// modules are defined as an array
// [ module function, map of requires ]
//
// map of requires is short require name -> numeric require
//
// anything defined in a previous bundle is accessed via the
// orig method which is the require for previous bundles

(function (modules, entry, mainEntry, parcelRequireName, globalName) {
  /* eslint-disable no-undef */
  var globalObject =
    typeof globalThis !== 'undefined'
      ? globalThis
      : typeof self !== 'undefined'
      ? self
      : typeof window !== 'undefined'
      ? window
      : typeof global !== 'undefined'
      ? global
      : {};
  /* eslint-enable no-undef */

  // Save the require from previous bundle to this closure if any
  var previousRequire =
    typeof globalObject[parcelRequireName] === 'function' &&
    globalObject[parcelRequireName];

  var cache = previousRequire.cache || {};
  // Do not use `require` to prevent Webpack from trying to bundle this call
  var nodeRequire =
    typeof module !== 'undefined' &&
    typeof module.require === 'function' &&
    module.require.bind(module);

  function newRequire(name, jumped) {
    if (!cache[name]) {
      if (!modules[name]) {
        // if we cannot find the module within our internal map or
        // cache jump to the current global require ie. the last bundle
        // that was added to the page.
        var currentRequire =
          typeof globalObject[parcelRequireName] === 'function' &&
          globalObject[parcelRequireName];
        if (!jumped && currentRequire) {
          return currentRequire(name, true);
        }

        // If there are other bundles on this page the require from the
        // previous one is saved to 'previousRequire'. Repeat this as
        // many times as there are bundles until the module is found or
        // we exhaust the require chain.
        if (previousRequire) {
          return previousRequire(name, true);
        }

        // Try the node require function if it exists.
        if (nodeRequire && typeof name === 'string') {
          return nodeRequire(name);
        }

        var err = new Error("Cannot find module '" + name + "'");
        err.code = 'MODULE_NOT_FOUND';
        throw err;
      }

      localRequire.resolve = resolve;
      localRequire.cache = {};

      var module = (cache[name] = new newRequire.Module(name));

      modules[name][0].call(
        module.exports,
        localRequire,
        module,
        module.exports,
        this
      );
    }

    return cache[name].exports;

    function localRequire(x) {
      var res = localRequire.resolve(x);
      return res === false ? {} : newRequire(res);
    }

    function resolve(x) {
      var id = modules[name][1][x];
      return id != null ? id : x;
    }
  }

  function Module(moduleName) {
    this.id = moduleName;
    this.bundle = newRequire;
    this.exports = {};
  }

  newRequire.isParcelRequire = true;
  newRequire.Module = Module;
  newRequire.modules = modules;
  newRequire.cache = cache;
  newRequire.parent = previousRequire;
  newRequire.register = function (id, exports) {
    modules[id] = [
      function (require, module) {
        module.exports = exports;
      },
      {},
    ];
  };

  Object.defineProperty(newRequire, 'root', {
    get: function () {
      return globalObject[parcelRequireName];
    },
  });

  globalObject[parcelRequireName] = newRequire;

  for (var i = 0; i < entry.length; i++) {
    newRequire(entry[i]);
  }

  if (mainEntry) {
    // Expose entry point to Node, AMD or browser globals
    // Based on https://github.com/ForbesLindesay/umd/blob/master/template.js
    var mainExports = newRequire(mainEntry);

    // CommonJS
    if (typeof exports === 'object' && typeof module !== 'undefined') {
      module.exports = mainExports;

      // RequireJS
    } else if (typeof define === 'function' && define.amd) {
      define(function () {
        return mainExports;
      });

      // <script>
    } else if (globalName) {
      this[globalName] = mainExports;
    }
  }
})({"kzDha":[function(require,module,exports) {
var global = arguments[3];
var HMR_HOST = null;
var HMR_PORT = 63555;
var HMR_SECURE = false;
var HMR_ENV_HASH = "3268c47d5908540d";
module.bundle.HMR_BUNDLE_ID = "e25729ca5a5a1dad";
"use strict";
/* global HMR_HOST, HMR_PORT, HMR_ENV_HASH, HMR_SECURE, chrome, browser, __parcel__import__, __parcel__importScripts__, ServiceWorkerGlobalScope */ /*::
import type {
  HMRAsset,
  HMRMessage,
} from '@parcel/reporter-dev-server/src/HMRServer.js';
interface ParcelRequire {
  (string): mixed;
  cache: {|[string]: ParcelModule|};
  hotData: {|[string]: mixed|};
  Module: any;
  parent: ?ParcelRequire;
  isParcelRequire: true;
  modules: {|[string]: [Function, {|[string]: string|}]|};
  HMR_BUNDLE_ID: string;
  root: ParcelRequire;
}
interface ParcelModule {
  hot: {|
    data: mixed,
    accept(cb: (Function) => void): void,
    dispose(cb: (mixed) => void): void,
    // accept(deps: Array<string> | string, cb: (Function) => void): void,
    // decline(): void,
    _acceptCallbacks: Array<(Function) => void>,
    _disposeCallbacks: Array<(mixed) => void>,
  |};
}
interface ExtensionContext {
  runtime: {|
    reload(): void,
    getURL(url: string): string;
    getManifest(): {manifest_version: number, ...};
  |};
}
declare var module: {bundle: ParcelRequire, ...};
declare var HMR_HOST: string;
declare var HMR_PORT: string;
declare var HMR_ENV_HASH: string;
declare var HMR_SECURE: boolean;
declare var chrome: ExtensionContext;
declare var browser: ExtensionContext;
declare var __parcel__import__: (string) => Promise<void>;
declare var __parcel__importScripts__: (string) => Promise<void>;
declare var globalThis: typeof self;
declare var ServiceWorkerGlobalScope: Object;
*/ var OVERLAY_ID = "__parcel__error__overlay__";
var OldModule = module.bundle.Module;
function Module(moduleName) {
    OldModule.call(this, moduleName);
    this.hot = {
        data: module.bundle.hotData[moduleName],
        _acceptCallbacks: [],
        _disposeCallbacks: [],
        accept: function(fn) {
            this._acceptCallbacks.push(fn || function() {});
        },
        dispose: function(fn) {
            this._disposeCallbacks.push(fn);
        }
    };
    module.bundle.hotData[moduleName] = undefined;
}
module.bundle.Module = Module;
module.bundle.hotData = {};
var checkedAssets /*: {|[string]: boolean|} */ , assetsToDispose /*: Array<[ParcelRequire, string]> */ , assetsToAccept /*: Array<[ParcelRequire, string]> */ ;
function getHostname() {
    return HMR_HOST || (location.protocol.indexOf("http") === 0 ? location.hostname : "localhost");
}
function getPort() {
    return HMR_PORT || location.port;
}
// eslint-disable-next-line no-redeclare
var parent = module.bundle.parent;
if ((!parent || !parent.isParcelRequire) && typeof WebSocket !== "undefined") {
    var hostname = getHostname();
    var port = getPort();
    var protocol = HMR_SECURE || location.protocol == "https:" && !/localhost|127.0.0.1|0.0.0.0/.test(hostname) ? "wss" : "ws";
    var ws;
    try {
        ws = new WebSocket(protocol + "://" + hostname + (port ? ":" + port : "") + "/");
    } catch (err) {
        if (err.message) console.error(err.message);
        ws = {};
    }
    // Web extension context
    var extCtx = typeof browser === "undefined" ? typeof chrome === "undefined" ? null : chrome : browser;
    // Safari doesn't support sourceURL in error stacks.
    // eval may also be disabled via CSP, so do a quick check.
    var supportsSourceURL = false;
    try {
        (0, eval)('throw new Error("test"); //# sourceURL=test.js');
    } catch (err) {
        supportsSourceURL = err.stack.includes("test.js");
    }
    // $FlowFixMe
    ws.onmessage = async function(event /*: {data: string, ...} */ ) {
        checkedAssets = {} /*: {|[string]: boolean|} */ ;
        assetsToAccept = [];
        assetsToDispose = [];
        var data /*: HMRMessage */  = JSON.parse(event.data);
        if (data.type === "update") {
            // Remove error overlay if there is one
            if (typeof document !== "undefined") removeErrorOverlay();
            let assets = data.assets.filter((asset)=>asset.envHash === HMR_ENV_HASH);
            // Handle HMR Update
            let handled = assets.every((asset)=>{
                return asset.type === "css" || asset.type === "js" && hmrAcceptCheck(module.bundle.root, asset.id, asset.depsByBundle);
            });
            if (handled) {
                console.clear();
                // Dispatch custom event so other runtimes (e.g React Refresh) are aware.
                if (typeof window !== "undefined" && typeof CustomEvent !== "undefined") window.dispatchEvent(new CustomEvent("parcelhmraccept"));
                await hmrApplyUpdates(assets);
                // Dispose all old assets.
                let processedAssets = {} /*: {|[string]: boolean|} */ ;
                for(let i = 0; i < assetsToDispose.length; i++){
                    let id = assetsToDispose[i][1];
                    if (!processedAssets[id]) {
                        hmrDispose(assetsToDispose[i][0], id);
                        processedAssets[id] = true;
                    }
                }
                // Run accept callbacks. This will also re-execute other disposed assets in topological order.
                processedAssets = {};
                for(let i = 0; i < assetsToAccept.length; i++){
                    let id = assetsToAccept[i][1];
                    if (!processedAssets[id]) {
                        hmrAccept(assetsToAccept[i][0], id);
                        processedAssets[id] = true;
                    }
                }
            } else fullReload();
        }
        if (data.type === "error") {
            // Log parcel errors to console
            for (let ansiDiagnostic of data.diagnostics.ansi){
                let stack = ansiDiagnostic.codeframe ? ansiDiagnostic.codeframe : ansiDiagnostic.stack;
                console.error("\uD83D\uDEA8 [parcel]: " + ansiDiagnostic.message + "\n" + stack + "\n\n" + ansiDiagnostic.hints.join("\n"));
            }
            if (typeof document !== "undefined") {
                // Render the fancy html overlay
                removeErrorOverlay();
                var overlay = createErrorOverlay(data.diagnostics.html);
                // $FlowFixMe
                document.body.appendChild(overlay);
            }
        }
    };
    ws.onerror = function(e) {
        if (e.message) console.error(e.message);
    };
    ws.onclose = function() {
        console.warn("[parcel] \uD83D\uDEA8 Connection to the HMR server was lost");
    };
}
function removeErrorOverlay() {
    var overlay = document.getElementById(OVERLAY_ID);
    if (overlay) {
        overlay.remove();
        console.log("[parcel] \u2728 Error resolved");
    }
}
function createErrorOverlay(diagnostics) {
    var overlay = document.createElement("div");
    overlay.id = OVERLAY_ID;
    let errorHTML = '<div style="background: black; opacity: 0.85; font-size: 16px; color: white; position: fixed; height: 100%; width: 100%; top: 0px; left: 0px; padding: 30px; font-family: Menlo, Consolas, monospace; z-index: 9999;">';
    for (let diagnostic of diagnostics){
        let stack = diagnostic.frames.length ? diagnostic.frames.reduce((p, frame)=>{
            return `${p}
<a href="/__parcel_launch_editor?file=${encodeURIComponent(frame.location)}" style="text-decoration: underline; color: #888" onclick="fetch(this.href); return false">${frame.location}</a>
${frame.code}`;
        }, "") : diagnostic.stack;
        errorHTML += `
      <div>
        <div style="font-size: 18px; font-weight: bold; margin-top: 20px;">
          \u{1F6A8} ${diagnostic.message}
        </div>
        <pre>${stack}</pre>
        <div>
          ${diagnostic.hints.map((hint)=>"<div>\uD83D\uDCA1 " + hint + "</div>").join("")}
        </div>
        ${diagnostic.documentation ? `<div>\u{1F4DD} <a style="color: violet" href="${diagnostic.documentation}" target="_blank">Learn more</a></div>` : ""}
      </div>
    `;
    }
    errorHTML += "</div>";
    overlay.innerHTML = errorHTML;
    return overlay;
}
function fullReload() {
    if ("reload" in location) location.reload();
    else if (extCtx && extCtx.runtime && extCtx.runtime.reload) extCtx.runtime.reload();
}
function getParents(bundle, id) /*: Array<[ParcelRequire, string]> */ {
    var modules = bundle.modules;
    if (!modules) return [];
    var parents = [];
    var k, d, dep;
    for(k in modules)for(d in modules[k][1]){
        dep = modules[k][1][d];
        if (dep === id || Array.isArray(dep) && dep[dep.length - 1] === id) parents.push([
            bundle,
            k
        ]);
    }
    if (bundle.parent) parents = parents.concat(getParents(bundle.parent, id));
    return parents;
}
function updateLink(link) {
    var href = link.getAttribute("href");
    if (!href) return;
    var newLink = link.cloneNode();
    newLink.onload = function() {
        if (link.parentNode !== null) // $FlowFixMe
        link.parentNode.removeChild(link);
    };
    newLink.setAttribute("href", // $FlowFixMe
    href.split("?")[0] + "?" + Date.now());
    // $FlowFixMe
    link.parentNode.insertBefore(newLink, link.nextSibling);
}
var cssTimeout = null;
function reloadCSS() {
    if (cssTimeout) return;
    cssTimeout = setTimeout(function() {
        var links = document.querySelectorAll('link[rel="stylesheet"]');
        for(var i = 0; i < links.length; i++){
            // $FlowFixMe[incompatible-type]
            var href /*: string */  = links[i].getAttribute("href");
            var hostname = getHostname();
            var servedFromHMRServer = hostname === "localhost" ? new RegExp("^(https?:\\/\\/(0.0.0.0|127.0.0.1)|localhost):" + getPort()).test(href) : href.indexOf(hostname + ":" + getPort());
            var absolute = /^https?:\/\//i.test(href) && href.indexOf(location.origin) !== 0 && !servedFromHMRServer;
            if (!absolute) updateLink(links[i]);
        }
        cssTimeout = null;
    }, 50);
}
function hmrDownload(asset) {
    if (asset.type === "js") {
        if (typeof document !== "undefined") {
            let script = document.createElement("script");
            script.src = asset.url + "?t=" + Date.now();
            if (asset.outputFormat === "esmodule") script.type = "module";
            return new Promise((resolve, reject)=>{
                var _document$head;
                script.onload = ()=>resolve(script);
                script.onerror = reject;
                (_document$head = document.head) === null || _document$head === void 0 || _document$head.appendChild(script);
            });
        } else if (typeof importScripts === "function") {
            // Worker scripts
            if (asset.outputFormat === "esmodule") return import(asset.url + "?t=" + Date.now());
            else return new Promise((resolve, reject)=>{
                try {
                    importScripts(asset.url + "?t=" + Date.now());
                    resolve();
                } catch (err) {
                    reject(err);
                }
            });
        }
    }
}
async function hmrApplyUpdates(assets) {
    global.parcelHotUpdate = Object.create(null);
    let scriptsToRemove;
    try {
        // If sourceURL comments aren't supported in eval, we need to load
        // the update from the dev server over HTTP so that stack traces
        // are correct in errors/logs. This is much slower than eval, so
        // we only do it if needed (currently just Safari).
        // https://bugs.webkit.org/show_bug.cgi?id=137297
        // This path is also taken if a CSP disallows eval.
        if (!supportsSourceURL) {
            let promises = assets.map((asset)=>{
                var _hmrDownload;
                return (_hmrDownload = hmrDownload(asset)) === null || _hmrDownload === void 0 ? void 0 : _hmrDownload.catch((err)=>{
                    // Web extension fix
                    if (extCtx && extCtx.runtime && extCtx.runtime.getManifest().manifest_version == 3 && typeof ServiceWorkerGlobalScope != "undefined" && global instanceof ServiceWorkerGlobalScope) {
                        extCtx.runtime.reload();
                        return;
                    }
                    throw err;
                });
            });
            scriptsToRemove = await Promise.all(promises);
        }
        assets.forEach(function(asset) {
            hmrApply(module.bundle.root, asset);
        });
    } finally{
        delete global.parcelHotUpdate;
        if (scriptsToRemove) scriptsToRemove.forEach((script)=>{
            if (script) {
                var _document$head2;
                (_document$head2 = document.head) === null || _document$head2 === void 0 || _document$head2.removeChild(script);
            }
        });
    }
}
function hmrApply(bundle /*: ParcelRequire */ , asset /*:  HMRAsset */ ) {
    var modules = bundle.modules;
    if (!modules) return;
    if (asset.type === "css") reloadCSS();
    else if (asset.type === "js") {
        let deps = asset.depsByBundle[bundle.HMR_BUNDLE_ID];
        if (deps) {
            if (modules[asset.id]) {
                // Remove dependencies that are removed and will become orphaned.
                // This is necessary so that if the asset is added back again, the cache is gone, and we prevent a full page reload.
                let oldDeps = modules[asset.id][1];
                for(let dep in oldDeps)if (!deps[dep] || deps[dep] !== oldDeps[dep]) {
                    let id = oldDeps[dep];
                    let parents = getParents(module.bundle.root, id);
                    if (parents.length === 1) hmrDelete(module.bundle.root, id);
                }
            }
            if (supportsSourceURL) // Global eval. We would use `new Function` here but browser
            // support for source maps is better with eval.
            (0, eval)(asset.output);
            // $FlowFixMe
            let fn = global.parcelHotUpdate[asset.id];
            modules[asset.id] = [
                fn,
                deps
            ];
        } else if (bundle.parent) hmrApply(bundle.parent, asset);
    }
}
function hmrDelete(bundle, id) {
    let modules = bundle.modules;
    if (!modules) return;
    if (modules[id]) {
        // Collect dependencies that will become orphaned when this module is deleted.
        let deps = modules[id][1];
        let orphans = [];
        for(let dep in deps){
            let parents = getParents(module.bundle.root, deps[dep]);
            if (parents.length === 1) orphans.push(deps[dep]);
        }
        // Delete the module. This must be done before deleting dependencies in case of circular dependencies.
        delete modules[id];
        delete bundle.cache[id];
        // Now delete the orphans.
        orphans.forEach((id)=>{
            hmrDelete(module.bundle.root, id);
        });
    } else if (bundle.parent) hmrDelete(bundle.parent, id);
}
function hmrAcceptCheck(bundle /*: ParcelRequire */ , id /*: string */ , depsByBundle /*: ?{ [string]: { [string]: string } }*/ ) {
    if (hmrAcceptCheckOne(bundle, id, depsByBundle)) return true;
    // Traverse parents breadth first. All possible ancestries must accept the HMR update, or we'll reload.
    let parents = getParents(module.bundle.root, id);
    let accepted = false;
    while(parents.length > 0){
        let v = parents.shift();
        let a = hmrAcceptCheckOne(v[0], v[1], null);
        if (a) // If this parent accepts, stop traversing upward, but still consider siblings.
        accepted = true;
        else {
            // Otherwise, queue the parents in the next level upward.
            let p = getParents(module.bundle.root, v[1]);
            if (p.length === 0) {
                // If there are no parents, then we've reached an entry without accepting. Reload.
                accepted = false;
                break;
            }
            parents.push(...p);
        }
    }
    return accepted;
}
function hmrAcceptCheckOne(bundle /*: ParcelRequire */ , id /*: string */ , depsByBundle /*: ?{ [string]: { [string]: string } }*/ ) {
    var modules = bundle.modules;
    if (!modules) return;
    if (depsByBundle && !depsByBundle[bundle.HMR_BUNDLE_ID]) {
        // If we reached the root bundle without finding where the asset should go,
        // there's nothing to do. Mark as "accepted" so we don't reload the page.
        if (!bundle.parent) return true;
        return hmrAcceptCheck(bundle.parent, id, depsByBundle);
    }
    if (checkedAssets[id]) return true;
    checkedAssets[id] = true;
    var cached = bundle.cache[id];
    assetsToDispose.push([
        bundle,
        id
    ]);
    if (!cached || cached.hot && cached.hot._acceptCallbacks.length) {
        assetsToAccept.push([
            bundle,
            id
        ]);
        return true;
    }
}
function hmrDispose(bundle /*: ParcelRequire */ , id /*: string */ ) {
    var cached = bundle.cache[id];
    bundle.hotData[id] = {};
    if (cached && cached.hot) cached.hot.data = bundle.hotData[id];
    if (cached && cached.hot && cached.hot._disposeCallbacks.length) cached.hot._disposeCallbacks.forEach(function(cb) {
        cb(bundle.hotData[id]);
    });
    delete bundle.cache[id];
}
function hmrAccept(bundle /*: ParcelRequire */ , id /*: string */ ) {
    // Execute the module.
    bundle(id);
    // Run the accept callbacks in the new version of the module.
    var cached = bundle.cache[id];
    if (cached && cached.hot && cached.hot._acceptCallbacks.length) cached.hot._acceptCallbacks.forEach(function(cb) {
        var assetsToAlsoAccept = cb(function() {
            return getParents(module.bundle.root, id);
        });
        if (assetsToAlsoAccept && assetsToAccept.length) {
            assetsToAlsoAccept.forEach(function(a) {
                hmrDispose(a[0], a[1]);
            });
            // $FlowFixMe[method-unbinding]
            assetsToAccept.push.apply(assetsToAccept, assetsToAlsoAccept);
        }
    });
}

},{}],"3jnqg":[function(require,module,exports) {
var _components = require("./components");
var _sections = require("./sections");

},{"./components":"8ujPh","./sections":"cGVsS"}],"8ujPh":[function(require,module,exports) {
var _carouselSlider = require("./carousel-slider/carousel-slider");
var _instagramSlider = require("./instagram-slider/instagram-slider");

},{"./carousel-slider/carousel-slider":"8SLFt","./instagram-slider/instagram-slider":"1jlpx"}],"8SLFt":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "CarouselSlider", ()=>CarouselSlider);
var _swiper = require("swiper");
var _swiperDefault = parcelHelpers.interopDefault(_swiper);
var _modules = require("swiper/modules");
var _motion = require("motion");
class CarouselSlider extends HTMLElement {
    constructor(){
        super();
    }
    connectedCallback() {
        this.setupSwiper();
    }
    disconnectedCallback() {
    //implementation
    }
    setupSwiper() {
        // Get configuration options from attributes or set default values
        const direction = this.getAttribute("direction") || "horizontal";
        const loop = this.hasAttribute("loop");
        const pagination = this.hasAttribute("pagination");
        const navigation = this.hasAttribute("navigation");
        const scrollbar = this.hasAttribute("scrollbar");
        const slidesPerView = this.getAttribute("slides-per-view") === "auto" ? "auto" : parseFloat(this.getAttribute("slides-per-view")) || 1;
        const spaceBetween = parseFloat(this.getAttribute("space-between")) || 16;
        const centeredSlides = this.hasAttribute("centered-sldies");
        console.log("spaceBetween", spaceBetween);
        // Responsive breakpoints (if provided)
        const breakpoints = this.getAttribute("breakpoints") || null;
        const parsedBreakpoints = breakpoints ? JSON.parse(breakpoints) : null;
        // Initialize Swiper with the provided configuration
        this.initializeSwiper({
            direction,
            loop,
            pagination,
            navigation,
            scrollbar,
            slidesPerView,
            spaceBetween,
            centeredSlides,
            breakpoints: parsedBreakpoints
        });
        this.handleReveal();
    }
    initializeSwiper(options) {
        // Merge default options with provided options
        const swiperOptions = {
            direction: "horizontal",
            loop: false,
            pagination: false,
            navigation: false,
            scrollbar: false,
            slidesPerView: 1,
            spaceBetween: 16,
            breakpoints: null,
            centeredSlides: false,
            modules: [],
            ...options
        };
        swiperOptions.modules = swiperOptions.modules || [];
        if (swiperOptions.navigation) {
            swiperOptions.navigation = {
                nextEl: ".swiper-button-next",
                prevEl: ".swiper-button-prev"
            };
            swiperOptions.modules.push((0, _modules.Navigation));
        }
        if (swiperOptions.pagination) {
            swiperOptions.pagination = {
                el: ".swiper-pagination",
                type: this.getAttribute("pagination"),
                ...swiperOptions.pagination
            };
            swiperOptions.modules.push((0, _modules.Pagination));
        }
        this.swiper = new (0, _swiperDefault.default)(this, swiperOptions);
    }
    handleReveal() {
        const revealOnScroll = this.hasAttribute("reveal-on-scroll");
        if (!revealOnScroll) return;
        (0, _motion.inView)(this, ()=>{
            (0, _motion.animate)(this, {
                opacity: 1
            });
            (0, _motion.animate)(this.querySelector(".swiper-wrapper").children, {
                opacity: [
                    0,
                    1
                ],
                transform: [
                    "translateY(30px)",
                    "translateY(0)"
                ]
            }, {
                duration: 0.25,
                delay: (0, _motion.stagger)(0.1, {
                    easing: "ease-out"
                }),
                easing: "ease"
            });
        });
    }
}
window.customElements.define("carousel-slider", CarouselSlider);

},{"@parcel/transformer-js/src/esmodule-helpers.js":"90RNB","motion":"ibAjH","swiper":"76a2Y","swiper/modules":"9duxt"}],"90RNB":[function(require,module,exports) {
exports.interopDefault = function(a) {
    return a && a.__esModule ? a : {
        default: a
    };
};
exports.defineInteropFlag = function(a) {
    Object.defineProperty(a, "__esModule", {
        value: true
    });
};
exports.exportAll = function(source, dest) {
    Object.keys(source).forEach(function(key) {
        if (key === "default" || key === "__esModule" || Object.prototype.hasOwnProperty.call(dest, key)) return;
        Object.defineProperty(dest, key, {
            enumerable: true,
            get: function() {
                return source[key];
            }
        });
    });
    return dest;
};
exports.export = function(dest, destName, get) {
    Object.defineProperty(dest, destName, {
        enumerable: true,
        get: get
    });
};

},{}],"ibAjH":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "animate", ()=>(0, _animateEsJs.animate));
var _dom = require("@motionone/dom");
parcelHelpers.exportAll(_dom, exports);
var _types = require("@motionone/types");
parcelHelpers.exportAll(_types, exports);
var _animateEsJs = require("./animate.es.js");

},{"@motionone/dom":"9aLuo","@motionone/types":false,"./animate.es.js":"if7Cf","@parcel/transformer-js/src/esmodule-helpers.js":"90RNB"}],"9aLuo":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "animate", ()=>(0, _indexEsJs.animate));
parcelHelpers.export(exports, "createAnimate", ()=>(0, _createAnimateEsJs.createAnimate));
parcelHelpers.export(exports, "animateStyle", ()=>(0, _animateStyleEsJs.animateStyle));
parcelHelpers.export(exports, "timeline", ()=>(0, _indexEsJs1.timeline));
parcelHelpers.export(exports, "stagger", ()=>(0, _staggerEsJs.stagger));
parcelHelpers.export(exports, "spring", ()=>(0, _indexEsJs2.spring));
parcelHelpers.export(exports, "glide", ()=>(0, _indexEsJs3.glide));
parcelHelpers.export(exports, "style", ()=>(0, _styleEsJs.style));
parcelHelpers.export(exports, "inView", ()=>(0, _inViewEsJs.inView));
parcelHelpers.export(exports, "resize", ()=>(0, _indexEsJs4.resize));
parcelHelpers.export(exports, "scroll", ()=>(0, _indexEsJs5.scroll));
parcelHelpers.export(exports, "ScrollOffset", ()=>(0, _presetsEsJs.ScrollOffset));
parcelHelpers.export(exports, "withControls", ()=>(0, _controlsEsJs.withControls));
parcelHelpers.export(exports, "getAnimationData", ()=>(0, _dataEsJs.getAnimationData));
parcelHelpers.export(exports, "getStyleName", ()=>(0, _getStyleNameEsJs.getStyleName));
parcelHelpers.export(exports, "createMotionState", ()=>(0, _indexEsJs6.createMotionState));
parcelHelpers.export(exports, "mountedStates", ()=>(0, _indexEsJs6.mountedStates));
parcelHelpers.export(exports, "createStyles", ()=>(0, _styleObjectEsJs.createStyles));
parcelHelpers.export(exports, "createStyleString", ()=>(0, _styleStringEsJs.createStyleString));
var _indexEsJs = require("./animate/index.es.js");
var _createAnimateEsJs = require("./animate/create-animate.es.js");
var _animateStyleEsJs = require("./animate/animate-style.es.js");
var _indexEsJs1 = require("./timeline/index.es.js");
var _staggerEsJs = require("./utils/stagger.es.js");
var _indexEsJs2 = require("./easing/spring/index.es.js");
var _indexEsJs3 = require("./easing/glide/index.es.js");
var _styleEsJs = require("./animate/style.es.js");
var _inViewEsJs = require("./gestures/in-view.es.js");
var _indexEsJs4 = require("./gestures/resize/index.es.js");
var _indexEsJs5 = require("./gestures/scroll/index.es.js");
var _presetsEsJs = require("./gestures/scroll/offsets/presets.es.js");
var _controlsEsJs = require("./animate/utils/controls.es.js");
var _dataEsJs = require("./animate/data.es.js");
var _getStyleNameEsJs = require("./animate/utils/get-style-name.es.js");
var _indexEsJs6 = require("./state/index.es.js");
var _styleObjectEsJs = require("./animate/utils/style-object.es.js");
var _styleStringEsJs = require("./animate/utils/style-string.es.js");

},{"./animate/index.es.js":"l2KG2","./animate/create-animate.es.js":false,"./animate/animate-style.es.js":false,"./timeline/index.es.js":false,"./utils/stagger.es.js":"4OfEJ","./easing/spring/index.es.js":false,"./easing/glide/index.es.js":false,"./animate/style.es.js":false,"./gestures/in-view.es.js":"96ksJ","./gestures/resize/index.es.js":false,"./gestures/scroll/index.es.js":"9uIs6","./gestures/scroll/offsets/presets.es.js":false,"./animate/utils/controls.es.js":"kXqZE","./animate/data.es.js":false,"./animate/utils/get-style-name.es.js":false,"./state/index.es.js":false,"./animate/utils/style-object.es.js":false,"./animate/utils/style-string.es.js":false,"@parcel/transformer-js/src/esmodule-helpers.js":"90RNB"}],"l2KG2":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "animate", ()=>animate);
var _animation = require("@motionone/animation");
var _createAnimateEsJs = require("./create-animate.es.js");
const animate = (0, _createAnimateEsJs.createAnimate)((0, _animation.Animation));

},{"@motionone/animation":"jm2tn","./create-animate.es.js":"em2gk","@parcel/transformer-js/src/esmodule-helpers.js":"90RNB"}],"jm2tn":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Animation", ()=>(0, _animationEsJs.Animation));
parcelHelpers.export(exports, "getEasingFunction", ()=>(0, _easingEsJs.getEasingFunction));
var _animationEsJs = require("./Animation.es.js");
var _easingEsJs = require("./utils/easing.es.js");

},{"./Animation.es.js":"53R6l","./utils/easing.es.js":"dEvKJ","@parcel/transformer-js/src/esmodule-helpers.js":"90RNB"}],"53R6l":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Animation", ()=>Animation);
var _utils = require("@motionone/utils");
var _easingEsJs = require("./utils/easing.es.js");
class Animation {
    constructor(output, keyframes = [
        0,
        1
    ], { easing, duration: initialDuration = (0, _utils.defaults).duration, delay = (0, _utils.defaults).delay, endDelay = (0, _utils.defaults).endDelay, repeat = (0, _utils.defaults).repeat, offset, direction = "normal" } = {}){
        this.startTime = null;
        this.rate = 1;
        this.t = 0;
        this.cancelTimestamp = null;
        this.easing = (0, _utils.noopReturn);
        this.duration = 0;
        this.totalDuration = 0;
        this.repeat = 0;
        this.playState = "idle";
        this.finished = new Promise((resolve, reject)=>{
            this.resolve = resolve;
            this.reject = reject;
        });
        easing = easing || (0, _utils.defaults).easing;
        if ((0, _utils.isEasingGenerator)(easing)) {
            const custom = easing.createAnimation(keyframes);
            easing = custom.easing;
            keyframes = custom.keyframes || keyframes;
            initialDuration = custom.duration || initialDuration;
        }
        this.repeat = repeat;
        this.easing = (0, _utils.isEasingList)(easing) ? (0, _utils.noopReturn) : (0, _easingEsJs.getEasingFunction)(easing);
        this.updateDuration(initialDuration);
        const interpolate$1 = (0, _utils.interpolate)(keyframes, offset, (0, _utils.isEasingList)(easing) ? easing.map((0, _easingEsJs.getEasingFunction)) : (0, _utils.noopReturn));
        this.tick = (timestamp)=>{
            var _a;
            // TODO: Temporary fix for OptionsResolver typing
            delay;
            let t = 0;
            if (this.pauseTime !== undefined) t = this.pauseTime;
            else t = (timestamp - this.startTime) * this.rate;
            this.t = t;
            // Convert to seconds
            t /= 1000;
            // Rebase on delay
            t = Math.max(t - delay, 0);
            /**
             * If this animation has finished, set the current time
             * to the total duration.
             */ if (this.playState === "finished" && this.pauseTime === undefined) t = this.totalDuration;
            /**
             * Get the current progress (0-1) of the animation. If t is >
             * than duration we'll get values like 2.5 (midway through the
             * third iteration)
             */ const progress = t / this.duration;
            // TODO progress += iterationStart
            /**
             * Get the current iteration (0 indexed). For instance the floor of
             * 2.5 is 2.
             */ let currentIteration = Math.floor(progress);
            /**
             * Get the current progress of the iteration by taking the remainder
             * so 2.5 is 0.5 through iteration 2
             */ let iterationProgress = progress % 1.0;
            if (!iterationProgress && progress >= 1) iterationProgress = 1;
            /**
             * If iteration progress is 1 we count that as the end
             * of the previous iteration.
             */ iterationProgress === 1 && currentIteration--;
            /**
             * Reverse progress if we're not running in "normal" direction
             */ const iterationIsOdd = currentIteration % 2;
            if (direction === "reverse" || direction === "alternate" && iterationIsOdd || direction === "alternate-reverse" && !iterationIsOdd) iterationProgress = 1 - iterationProgress;
            const p = t >= this.totalDuration ? 1 : Math.min(iterationProgress, 1);
            const latest = interpolate$1(this.easing(p));
            output(latest);
            const isAnimationFinished = this.pauseTime === undefined && (this.playState === "finished" || t >= this.totalDuration + endDelay);
            if (isAnimationFinished) {
                this.playState = "finished";
                (_a = this.resolve) === null || _a === void 0 || _a.call(this, latest);
            } else if (this.playState !== "idle") this.frameRequestId = requestAnimationFrame(this.tick);
        };
        this.play();
    }
    play() {
        const now = performance.now();
        this.playState = "running";
        if (this.pauseTime !== undefined) this.startTime = now - this.pauseTime;
        else if (!this.startTime) this.startTime = now;
        this.cancelTimestamp = this.startTime;
        this.pauseTime = undefined;
        this.frameRequestId = requestAnimationFrame(this.tick);
    }
    pause() {
        this.playState = "paused";
        this.pauseTime = this.t;
    }
    finish() {
        this.playState = "finished";
        this.tick(0);
    }
    stop() {
        var _a;
        this.playState = "idle";
        if (this.frameRequestId !== undefined) cancelAnimationFrame(this.frameRequestId);
        (_a = this.reject) === null || _a === void 0 || _a.call(this, false);
    }
    cancel() {
        this.stop();
        this.tick(this.cancelTimestamp);
    }
    reverse() {
        this.rate *= -1;
    }
    commitStyles() {}
    updateDuration(duration) {
        this.duration = duration;
        this.totalDuration = duration * (this.repeat + 1);
    }
    get currentTime() {
        return this.t;
    }
    set currentTime(t) {
        if (this.pauseTime !== undefined || this.rate === 0) this.pauseTime = t;
        else this.startTime = performance.now() - t / this.rate;
    }
    get playbackRate() {
        return this.rate;
    }
    set playbackRate(rate) {
        this.rate = rate;
    }
}

},{"@motionone/utils":"h9mXa","./utils/easing.es.js":"dEvKJ","@parcel/transformer-js/src/esmodule-helpers.js":"90RNB"}],"h9mXa":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "addUniqueItem", ()=>(0, _arrayEsJs.addUniqueItem));
parcelHelpers.export(exports, "removeItem", ()=>(0, _arrayEsJs.removeItem));
parcelHelpers.export(exports, "clamp", ()=>(0, _clampEsJs.clamp));
parcelHelpers.export(exports, "defaults", ()=>(0, _defaultsEsJs.defaults));
parcelHelpers.export(exports, "getEasingForSegment", ()=>(0, _easingEsJs.getEasingForSegment));
parcelHelpers.export(exports, "interpolate", ()=>(0, _interpolateEsJs.interpolate));
parcelHelpers.export(exports, "isCubicBezier", ()=>(0, _isCubicBezierEsJs.isCubicBezier));
parcelHelpers.export(exports, "isEasingGenerator", ()=>(0, _isEasingGeneratorEsJs.isEasingGenerator));
parcelHelpers.export(exports, "isEasingList", ()=>(0, _isEasingListEsJs.isEasingList));
parcelHelpers.export(exports, "isFunction", ()=>(0, _isFunctionEsJs.isFunction));
parcelHelpers.export(exports, "isNumber", ()=>(0, _isNumberEsJs.isNumber));
parcelHelpers.export(exports, "isString", ()=>(0, _isStringEsJs.isString));
parcelHelpers.export(exports, "mix", ()=>(0, _mixEsJs.mix));
parcelHelpers.export(exports, "noop", ()=>(0, _noopEsJs.noop));
parcelHelpers.export(exports, "noopReturn", ()=>(0, _noopEsJs.noopReturn));
parcelHelpers.export(exports, "defaultOffset", ()=>(0, _offsetEsJs.defaultOffset));
parcelHelpers.export(exports, "fillOffset", ()=>(0, _offsetEsJs.fillOffset));
parcelHelpers.export(exports, "progress", ()=>(0, _progressEsJs.progress));
parcelHelpers.export(exports, "time", ()=>(0, _timeEsJs.time));
parcelHelpers.export(exports, "velocityPerSecond", ()=>(0, _velocityEsJs.velocityPerSecond));
parcelHelpers.export(exports, "wrap", ()=>(0, _wrapEsJs.wrap));
var _arrayEsJs = require("./array.es.js");
var _clampEsJs = require("./clamp.es.js");
var _defaultsEsJs = require("./defaults.es.js");
var _easingEsJs = require("./easing.es.js");
var _interpolateEsJs = require("./interpolate.es.js");
var _isCubicBezierEsJs = require("./is-cubic-bezier.es.js");
var _isEasingGeneratorEsJs = require("./is-easing-generator.es.js");
var _isEasingListEsJs = require("./is-easing-list.es.js");
var _isFunctionEsJs = require("./is-function.es.js");
var _isNumberEsJs = require("./is-number.es.js");
var _isStringEsJs = require("./is-string.es.js");
var _mixEsJs = require("./mix.es.js");
var _noopEsJs = require("./noop.es.js");
var _offsetEsJs = require("./offset.es.js");
var _progressEsJs = require("./progress.es.js");
var _timeEsJs = require("./time.es.js");
var _velocityEsJs = require("./velocity.es.js");
var _wrapEsJs = require("./wrap.es.js");

},{"./array.es.js":"8VnTB","./clamp.es.js":"f2tBE","./defaults.es.js":"7xQlo","./easing.es.js":false,"./interpolate.es.js":"hFhm1","./is-cubic-bezier.es.js":"g53sc","./is-easing-generator.es.js":"gB2SU","./is-easing-list.es.js":"8as80","./is-function.es.js":"9hG6e","./is-number.es.js":"1Zr0T","./is-string.es.js":"fqynO","./mix.es.js":false,"./noop.es.js":"kjS2K","./offset.es.js":"cONgv","./progress.es.js":"6QHq2","./time.es.js":"85pZk","./velocity.es.js":"hSU8e","./wrap.es.js":false,"@parcel/transformer-js/src/esmodule-helpers.js":"90RNB"}],"8VnTB":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "addUniqueItem", ()=>addUniqueItem);
parcelHelpers.export(exports, "removeItem", ()=>removeItem);
function addUniqueItem(array, item) {
    array.indexOf(item) === -1 && array.push(item);
}
function removeItem(arr, item) {
    const index = arr.indexOf(item);
    index > -1 && arr.splice(index, 1);
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"90RNB"}],"f2tBE":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "clamp", ()=>clamp);
const clamp = (min, max, v)=>Math.min(Math.max(v, min), max);

},{"@parcel/transformer-js/src/esmodule-helpers.js":"90RNB"}],"7xQlo":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "defaults", ()=>defaults);
const defaults = {
    duration: 0.3,
    delay: 0,
    endDelay: 0,
    repeat: 0,
    easing: "ease"
};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"90RNB"}],"7V3YG":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getEasingForSegment", ()=>getEasingForSegment);
var _isEasingListEsJs = require("./is-easing-list.es.js");
var _wrapEsJs = require("./wrap.es.js");
function getEasingForSegment(easing, i) {
    return (0, _isEasingListEsJs.isEasingList)(easing) ? easing[(0, _wrapEsJs.wrap)(0, easing.length, i)] : easing;
}

},{"./is-easing-list.es.js":"8as80","./wrap.es.js":"aLhtu","@parcel/transformer-js/src/esmodule-helpers.js":"90RNB"}],"8as80":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "isEasingList", ()=>isEasingList);
var _isNumberEsJs = require("./is-number.es.js");
const isEasingList = (easing)=>Array.isArray(easing) && !(0, _isNumberEsJs.isNumber)(easing[0]);

},{"./is-number.es.js":"1Zr0T","@parcel/transformer-js/src/esmodule-helpers.js":"90RNB"}],"1Zr0T":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "isNumber", ()=>isNumber);
const isNumber = (value)=>typeof value === "number";

},{"@parcel/transformer-js/src/esmodule-helpers.js":"90RNB"}],"aLhtu":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "wrap", ()=>wrap);
const wrap = (min, max, v)=>{
    const rangeSize = max - min;
    return ((v - min) % rangeSize + rangeSize) % rangeSize + min;
};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"90RNB"}],"hFhm1":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "interpolate", ()=>interpolate);
var _mixEsJs = require("./mix.es.js");
var _noopEsJs = require("./noop.es.js");
var _offsetEsJs = require("./offset.es.js");
var _progressEsJs = require("./progress.es.js");
var _easingEsJs = require("./easing.es.js");
var _clampEsJs = require("./clamp.es.js");
function interpolate(output, input = (0, _offsetEsJs.defaultOffset)(output.length), easing = (0, _noopEsJs.noopReturn)) {
    const length = output.length;
    /**
     * If the input length is lower than the output we
     * fill the input to match. This currently assumes the input
     * is an animation progress value so is a good candidate for
     * moving outside the function.
     */ const remainder = length - input.length;
    remainder > 0 && (0, _offsetEsJs.fillOffset)(input, remainder);
    return (t)=>{
        let i = 0;
        for(; i < length - 2; i++){
            if (t < input[i + 1]) break;
        }
        let progressInRange = (0, _clampEsJs.clamp)(0, 1, (0, _progressEsJs.progress)(input[i], input[i + 1], t));
        const segmentEasing = (0, _easingEsJs.getEasingForSegment)(easing, i);
        progressInRange = segmentEasing(progressInRange);
        return (0, _mixEsJs.mix)(output[i], output[i + 1], progressInRange);
    };
}

},{"./mix.es.js":"bSd6M","./noop.es.js":"kjS2K","./offset.es.js":"cONgv","./progress.es.js":"6QHq2","./easing.es.js":"7V3YG","./clamp.es.js":"f2tBE","@parcel/transformer-js/src/esmodule-helpers.js":"90RNB"}],"bSd6M":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "mix", ()=>mix);
const mix = (min, max, progress)=>-progress * min + progress * max + min;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"90RNB"}],"kjS2K":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "noop", ()=>noop);
parcelHelpers.export(exports, "noopReturn", ()=>noopReturn);
const noop = ()=>{};
const noopReturn = (v)=>v;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"90RNB"}],"cONgv":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "defaultOffset", ()=>defaultOffset);
parcelHelpers.export(exports, "fillOffset", ()=>fillOffset);
var _mixEsJs = require("./mix.es.js");
var _progressEsJs = require("./progress.es.js");
function fillOffset(offset, remaining) {
    const min = offset[offset.length - 1];
    for(let i = 1; i <= remaining; i++){
        const offsetProgress = (0, _progressEsJs.progress)(0, remaining, i);
        offset.push((0, _mixEsJs.mix)(min, 1, offsetProgress));
    }
}
function defaultOffset(length) {
    const offset = [
        0
    ];
    fillOffset(offset, length - 1);
    return offset;
}

},{"./mix.es.js":"bSd6M","./progress.es.js":"6QHq2","@parcel/transformer-js/src/esmodule-helpers.js":"90RNB"}],"6QHq2":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "progress", ()=>progress);
const progress = (min, max, value)=>max - min === 0 ? 1 : (value - min) / (max - min);

},{"@parcel/transformer-js/src/esmodule-helpers.js":"90RNB"}],"g53sc":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "isCubicBezier", ()=>isCubicBezier);
var _isNumberEsJs = require("./is-number.es.js");
const isCubicBezier = (easing)=>Array.isArray(easing) && (0, _isNumberEsJs.isNumber)(easing[0]);

},{"./is-number.es.js":"1Zr0T","@parcel/transformer-js/src/esmodule-helpers.js":"90RNB"}],"gB2SU":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "isEasingGenerator", ()=>isEasingGenerator);
const isEasingGenerator = (easing)=>typeof easing === "object" && Boolean(easing.createAnimation);

},{"@parcel/transformer-js/src/esmodule-helpers.js":"90RNB"}],"9hG6e":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "isFunction", ()=>isFunction);
const isFunction = (value)=>typeof value === "function";

},{"@parcel/transformer-js/src/esmodule-helpers.js":"90RNB"}],"fqynO":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "isString", ()=>isString);
const isString = (value)=>typeof value === "string";

},{"@parcel/transformer-js/src/esmodule-helpers.js":"90RNB"}],"85pZk":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "time", ()=>time);
const time = {
    ms: (seconds)=>seconds * 1000,
    s: (milliseconds)=>milliseconds / 1000
};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"90RNB"}],"hSU8e":[function(require,module,exports) {
/*
  Convert velocity into velocity per second

  @param [number]: Unit per frame
  @param [number]: Frame duration in ms
*/ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "velocityPerSecond", ()=>velocityPerSecond);
function velocityPerSecond(velocity, frameDuration) {
    return frameDuration ? velocity * (1000 / frameDuration) : 0;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"90RNB"}],"dEvKJ":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getEasingFunction", ()=>getEasingFunction);
var _easing = require("@motionone/easing");
var _utils = require("@motionone/utils");
const namedEasings = {
    ease: (0, _easing.cubicBezier)(0.25, 0.1, 0.25, 1.0),
    "ease-in": (0, _easing.cubicBezier)(0.42, 0.0, 1.0, 1.0),
    "ease-in-out": (0, _easing.cubicBezier)(0.42, 0.0, 0.58, 1.0),
    "ease-out": (0, _easing.cubicBezier)(0.0, 0.0, 0.58, 1.0)
};
const functionArgsRegex = /\((.*?)\)/;
function getEasingFunction(definition) {
    // If already an easing function, return
    if ((0, _utils.isFunction)(definition)) return definition;
    // If an easing curve definition, return bezier function
    if ((0, _utils.isCubicBezier)(definition)) return (0, _easing.cubicBezier)(...definition);
    // If we have a predefined easing function, return
    if (namedEasings[definition]) return namedEasings[definition];
    // If this is a steps function, attempt to create easing curve
    if (definition.startsWith("steps")) {
        const args = functionArgsRegex.exec(definition);
        if (args) {
            const argsArray = args[1].split(",");
            return (0, _easing.steps)(parseFloat(argsArray[0]), argsArray[1].trim());
        }
    }
    return 0, _utils.noopReturn;
}

},{"@motionone/easing":"jJxVJ","@motionone/utils":"h9mXa","@parcel/transformer-js/src/esmodule-helpers.js":"90RNB"}],"jJxVJ":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "cubicBezier", ()=>(0, _cubicBezierEsJs.cubicBezier));
parcelHelpers.export(exports, "steps", ()=>(0, _stepsEsJs.steps));
var _cubicBezierEsJs = require("./cubic-bezier.es.js");
var _stepsEsJs = require("./steps.es.js");

},{"./cubic-bezier.es.js":"6h3dV","./steps.es.js":"c1oI2","@parcel/transformer-js/src/esmodule-helpers.js":"90RNB"}],"6h3dV":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "cubicBezier", ()=>cubicBezier);
var _utils = require("@motionone/utils");
/*
  Bezier function generator

  This has been modified from Gaëtan Renaudeau's BezierEasing
  https://github.com/gre/bezier-easing/blob/master/src/index.js
  https://github.com/gre/bezier-easing/blob/master/LICENSE
  
  I've removed the newtonRaphsonIterate algo because in benchmarking it
  wasn't noticiably faster than binarySubdivision, indeed removing it
  usually improved times, depending on the curve.

  I also removed the lookup table, as for the added bundle size and loop we're
  only cutting ~4 or so subdivision iterations. I bumped the max iterations up
  to 12 to compensate and this still tended to be faster for no perceivable
  loss in accuracy.

  Usage
    const easeOut = cubicBezier(.17,.67,.83,.67);
    const x = easeOut(0.5); // returns 0.627...
*/ // Returns x(t) given t, x1, and x2, or y(t) given t, y1, and y2.
const calcBezier = (t, a1, a2)=>(((1.0 - 3.0 * a2 + 3.0 * a1) * t + (3.0 * a2 - 6.0 * a1)) * t + 3.0 * a1) * t;
const subdivisionPrecision = 0.0000001;
const subdivisionMaxIterations = 12;
function binarySubdivide(x, lowerBound, upperBound, mX1, mX2) {
    let currentX;
    let currentT;
    let i = 0;
    do {
        currentT = lowerBound + (upperBound - lowerBound) / 2.0;
        currentX = calcBezier(currentT, mX1, mX2) - x;
        if (currentX > 0.0) upperBound = currentT;
        else lowerBound = currentT;
    }while (Math.abs(currentX) > subdivisionPrecision && ++i < subdivisionMaxIterations);
    return currentT;
}
function cubicBezier(mX1, mY1, mX2, mY2) {
    // If this is a linear gradient, return linear easing
    if (mX1 === mY1 && mX2 === mY2) return 0, _utils.noopReturn;
    const getTForX = (aX)=>binarySubdivide(aX, 0, 1, mX1, mX2);
    // If animation is at start/end, return t without easing
    return (t)=>t === 0 || t === 1 ? t : calcBezier(getTForX(t), mY1, mY2);
}

},{"@motionone/utils":"h9mXa","@parcel/transformer-js/src/esmodule-helpers.js":"90RNB"}],"c1oI2":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "steps", ()=>steps);
var _utils = require("@motionone/utils");
const steps = (steps, direction = "end")=>(progress)=>{
        progress = direction === "end" ? Math.min(progress, 0.999) : Math.max(progress, 0.001);
        const expanded = progress * steps;
        const rounded = direction === "end" ? Math.floor(expanded) : Math.ceil(expanded);
        return (0, _utils.clamp)(0, 1, rounded / steps);
    };

},{"@motionone/utils":"h9mXa","@parcel/transformer-js/src/esmodule-helpers.js":"90RNB"}],"em2gk":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "createAnimate", ()=>createAnimate);
var _heyListen = require("hey-listen");
var _animateStyleEsJs = require("./animate-style.es.js");
var _optionsEsJs = require("./utils/options.es.js");
var _resolveElementsEsJs = require("../utils/resolve-elements.es.js");
var _controlsEsJs = require("./utils/controls.es.js");
var _staggerEsJs = require("../utils/stagger.es.js");
function createAnimate(AnimatePolyfill) {
    return function animate(elements, keyframes, options = {}) {
        elements = (0, _resolveElementsEsJs.resolveElements)(elements);
        const numElements = elements.length;
        (0, _heyListen.invariant)(Boolean(numElements), "No valid element provided.");
        (0, _heyListen.invariant)(Boolean(keyframes), "No keyframes defined.");
        /**
         * Create and start new animations
         */ const animationFactories = [];
        for(let i = 0; i < numElements; i++){
            const element = elements[i];
            for(const key in keyframes){
                const valueOptions = (0, _optionsEsJs.getOptions)(options, key);
                valueOptions.delay = (0, _staggerEsJs.resolveOption)(valueOptions.delay, i, numElements);
                const animation = (0, _animateStyleEsJs.animateStyle)(element, key, keyframes[key], valueOptions, AnimatePolyfill);
                animationFactories.push(animation);
            }
        }
        return (0, _controlsEsJs.withControls)(animationFactories, options, /**
         * TODO:
         * If easing is set to spring or glide, duration will be dynamically
         * generated. Ideally we would dynamically generate this from
         * animation.effect.getComputedTiming().duration but this isn't
         * supported in iOS13 or our number polyfill. Perhaps it's possible
         * to Proxy animations returned from animateStyle that has duration
         * as a getter.
         */ options.duration);
    };
}

},{"hey-listen":"3MUym","./animate-style.es.js":"7L3Ft","./utils/options.es.js":"2CBzj","../utils/resolve-elements.es.js":"h3E9G","./utils/controls.es.js":"kXqZE","../utils/stagger.es.js":"4OfEJ","@parcel/transformer-js/src/esmodule-helpers.js":"90RNB"}],"3MUym":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "invariant", ()=>invariant);
parcelHelpers.export(exports, "warning", ()=>warning);
var warning = function() {};
var invariant = function() {};
warning = function(check, message) {
    if (!check && typeof console !== "undefined") console.warn(message);
};
invariant = function(check, message) {
    if (!check) throw new Error(message);
};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"90RNB"}],"7L3Ft":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "animateStyle", ()=>animateStyle);
var _dataEsJs = require("./data.es.js");
var _cssVarEsJs = require("./utils/css-var.es.js");
var _utils = require("@motionone/utils");
var _transformsEsJs = require("./utils/transforms.es.js");
var _easingEsJs = require("./utils/easing.es.js");
var _featureDetectionEsJs = require("./utils/feature-detection.es.js");
var _keyframesEsJs = require("./utils/keyframes.es.js");
var _styleEsJs = require("./style.es.js");
var _getStyleNameEsJs = require("./utils/get-style-name.es.js");
var _stopAnimationEsJs = require("./utils/stop-animation.es.js");
var _getUnitEsJs = require("./utils/get-unit.es.js");
function getDevToolsRecord() {
    return window.__MOTION_DEV_TOOLS_RECORD;
}
function animateStyle(element, key, keyframesDefinition, options = {}, AnimationPolyfill) {
    const record = getDevToolsRecord();
    const isRecording = options.record !== false && record;
    let animation;
    let { duration = (0, _utils.defaults).duration, delay = (0, _utils.defaults).delay, endDelay = (0, _utils.defaults).endDelay, repeat = (0, _utils.defaults).repeat, easing = (0, _utils.defaults).easing, persist = false, direction, offset, allowWebkitAcceleration = false } = options;
    const data = (0, _dataEsJs.getAnimationData)(element);
    const valueIsTransform = (0, _transformsEsJs.isTransform)(key);
    let canAnimateNatively = (0, _featureDetectionEsJs.supports).waapi();
    /**
     * If this is an individual transform, we need to map its
     * key to a CSS variable and update the element's transform style
     */ valueIsTransform && (0, _transformsEsJs.addTransformToElement)(element, key);
    const name = (0, _getStyleNameEsJs.getStyleName)(key);
    const motionValue = (0, _dataEsJs.getMotionValue)(data.values, name);
    /**
     * Get definition of value, this will be used to convert numerical
     * keyframes into the default value type.
     */ const definition = (0, _transformsEsJs.transformDefinitions).get(name);
    /**
     * Stop the current animation, if any. Because this will trigger
     * commitStyles (DOM writes) and we might later trigger DOM reads,
     * this is fired now and we return a factory function to create
     * the actual animation that can get called in batch,
     */ (0, _stopAnimationEsJs.stopAnimation)(motionValue.animation, !((0, _utils.isEasingGenerator)(easing) && motionValue.generator) && options.record !== false);
    /**
     * Batchable factory function containing all DOM reads.
     */ return ()=>{
        const readInitialValue = ()=>{
            var _a, _b;
            return (_b = (_a = (0, _styleEsJs.style).get(element, name)) !== null && _a !== void 0 ? _a : definition === null || definition === void 0 ? void 0 : definition.initialValue) !== null && _b !== void 0 ? _b : 0;
        };
        /**
         * Replace null values with the previous keyframe value, or read
         * it from the DOM if it's the first keyframe.
         */ let keyframes = (0, _keyframesEsJs.hydrateKeyframes)((0, _keyframesEsJs.keyframesList)(keyframesDefinition), readInitialValue);
        /**
         * Detect unit type of keyframes.
         */ const toUnit = (0, _getUnitEsJs.getUnitConverter)(keyframes, definition);
        if ((0, _utils.isEasingGenerator)(easing)) {
            const custom = easing.createAnimation(keyframes, key !== "opacity", readInitialValue, name, motionValue);
            easing = custom.easing;
            keyframes = custom.keyframes || keyframes;
            duration = custom.duration || duration;
        }
        /**
         * If this is a CSS variable we need to register it with the browser
         * before it can be animated natively. We also set it with setProperty
         * rather than directly onto the element.style object.
         */ if ((0, _cssVarEsJs.isCssVar)(name)) {
            if ((0, _featureDetectionEsJs.supports).cssRegisterProperty()) (0, _cssVarEsJs.registerCssVariable)(name);
            else canAnimateNatively = false;
        }
        /**
         * If we've been passed a custom easing function, and this browser
         * does **not** support linear() easing, and the value is a transform
         * (and thus a pure number) we can still support the custom easing
         * by falling back to the animation polyfill.
         */ if (valueIsTransform && !(0, _featureDetectionEsJs.supports).linearEasing() && ((0, _utils.isFunction)(easing) || (0, _utils.isEasingList)(easing) && easing.some((0, _utils.isFunction)))) canAnimateNatively = false;
        /**
         * If we can animate this value with WAAPI, do so.
         */ if (canAnimateNatively) {
            /**
             * Convert numbers to default value types. Currently this only supports
             * transforms but it could also support other value types.
             */ if (definition) keyframes = keyframes.map((value)=>(0, _utils.isNumber)(value) ? definition.toDefaultUnit(value) : value);
            /**
             * If this browser doesn't support partial/implicit keyframes we need to
             * explicitly provide one.
             */ if (keyframes.length === 1 && (!(0, _featureDetectionEsJs.supports).partialKeyframes() || isRecording)) keyframes.unshift(readInitialValue());
            const animationOptions = {
                delay: (0, _utils.time).ms(delay),
                duration: (0, _utils.time).ms(duration),
                endDelay: (0, _utils.time).ms(endDelay),
                easing: !(0, _utils.isEasingList)(easing) ? (0, _easingEsJs.convertEasing)(easing, duration) : undefined,
                direction,
                iterations: repeat + 1,
                fill: "both"
            };
            animation = element.animate({
                [name]: keyframes,
                offset,
                easing: (0, _utils.isEasingList)(easing) ? easing.map((thisEasing)=>(0, _easingEsJs.convertEasing)(thisEasing, duration)) : undefined
            }, animationOptions);
            /**
             * Polyfill finished Promise in browsers that don't support it
             */ if (!animation.finished) animation.finished = new Promise((resolve, reject)=>{
                animation.onfinish = resolve;
                animation.oncancel = reject;
            });
            const target = keyframes[keyframes.length - 1];
            animation.finished.then(()=>{
                if (persist) return;
                // Apply styles to target
                (0, _styleEsJs.style).set(element, name, target);
                // Ensure fill modes don't persist
                animation.cancel();
            }).catch((0, _utils.noop));
            /**
             * This forces Webkit to run animations on the main thread by exploiting
             * this condition:
             * https://trac.webkit.org/browser/webkit/trunk/Source/WebCore/platform/graphics/ca/GraphicsLayerCA.cpp?rev=281238#L1099
             *
             * This fixes Webkit's timing bugs, like accelerated animations falling
             * out of sync with main thread animations and massive delays in starting
             * accelerated animations in WKWebView.
             */ if (!allowWebkitAcceleration) animation.playbackRate = 1.000001;
        /**
             * If we can't animate the value natively then we can fallback to the numbers-only
             * polyfill for transforms.
             */ } else if (AnimationPolyfill && valueIsTransform) {
            /**
             * If any keyframe is a string (because we measured it from the DOM), we need to convert
             * it into a number before passing to the Animation polyfill.
             */ keyframes = keyframes.map((value)=>typeof value === "string" ? parseFloat(value) : value);
            /**
             * If we only have a single keyframe, we need to create an initial keyframe by reading
             * the current value from the DOM.
             */ if (keyframes.length === 1) keyframes.unshift(parseFloat(readInitialValue()));
            animation = new AnimationPolyfill((latest)=>{
                (0, _styleEsJs.style).set(element, name, toUnit ? toUnit(latest) : latest);
            }, keyframes, Object.assign(Object.assign({}, options), {
                duration,
                easing
            }));
        } else {
            const target = keyframes[keyframes.length - 1];
            (0, _styleEsJs.style).set(element, name, definition && (0, _utils.isNumber)(target) ? definition.toDefaultUnit(target) : target);
        }
        if (isRecording) record(element, key, keyframes, {
            duration,
            delay: delay,
            easing,
            repeat,
            offset
        }, "motion-one");
        motionValue.setAnimation(animation);
        return animation;
    };
}

},{"./data.es.js":"hFBG9","./utils/css-var.es.js":"2eFjV","@motionone/utils":"h9mXa","./utils/transforms.es.js":"jdwYq","./utils/easing.es.js":"bN9UB","./utils/feature-detection.es.js":"h4OTE","./utils/keyframes.es.js":"9BIDR","./style.es.js":"cHmC6","./utils/get-style-name.es.js":"eXoUu","./utils/stop-animation.es.js":"7Uk3y","./utils/get-unit.es.js":"4W4UO","@parcel/transformer-js/src/esmodule-helpers.js":"90RNB"}],"hFBG9":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getAnimationData", ()=>getAnimationData);
parcelHelpers.export(exports, "getMotionValue", ()=>getMotionValue);
var _types = require("@motionone/types");
const data = new WeakMap();
function getAnimationData(element) {
    if (!data.has(element)) data.set(element, {
        transforms: [],
        values: new Map()
    });
    return data.get(element);
}
function getMotionValue(motionValues, name) {
    if (!motionValues.has(name)) motionValues.set(name, new (0, _types.MotionValue)());
    return motionValues.get(name);
}

},{"@motionone/types":"GwRvE","@parcel/transformer-js/src/esmodule-helpers.js":"90RNB"}],"GwRvE":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "MotionValue", ()=>(0, _motionValueEsJs.MotionValue));
var _motionValueEsJs = require("./MotionValue.es.js");

},{"./MotionValue.es.js":"ee2bp","@parcel/transformer-js/src/esmodule-helpers.js":"90RNB"}],"ee2bp":[function(require,module,exports) {
/**
 * The MotionValue tracks the state of a single animatable
 * value. Currently, updatedAt and current are unused. The
 * long term idea is to use this to minimise the number
 * of DOM reads, and to abstract the DOM interactions here.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "MotionValue", ()=>MotionValue);
class MotionValue {
    setAnimation(animation) {
        this.animation = animation;
        animation === null || animation === void 0 || animation.finished.then(()=>this.clearAnimation()).catch(()=>{});
    }
    clearAnimation() {
        this.animation = this.generator = undefined;
    }
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"90RNB"}],"2eFjV":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "isCssVar", ()=>isCssVar);
parcelHelpers.export(exports, "registerCssVariable", ()=>registerCssVariable);
parcelHelpers.export(exports, "registeredProperties", ()=>registeredProperties);
var _transformsEsJs = require("./transforms.es.js");
const isCssVar = (name)=>name.startsWith("--");
const registeredProperties = new Set();
function registerCssVariable(name) {
    if (registeredProperties.has(name)) return;
    registeredProperties.add(name);
    try {
        const { syntax, initialValue } = (0, _transformsEsJs.transformDefinitions).has(name) ? (0, _transformsEsJs.transformDefinitions).get(name) : {};
        CSS.registerProperty({
            name,
            inherits: false,
            syntax,
            initialValue
        });
    } catch (e) {}
}

},{"./transforms.es.js":"jdwYq","@parcel/transformer-js/src/esmodule-helpers.js":"90RNB"}],"jdwYq":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "addTransformToElement", ()=>addTransformToElement);
parcelHelpers.export(exports, "asTransformCssVar", ()=>asTransformCssVar);
parcelHelpers.export(exports, "axes", ()=>axes);
parcelHelpers.export(exports, "buildTransformTemplate", ()=>buildTransformTemplate);
parcelHelpers.export(exports, "compareTransformOrder", ()=>compareTransformOrder);
parcelHelpers.export(exports, "isTransform", ()=>isTransform);
parcelHelpers.export(exports, "transformAlias", ()=>transformAlias);
parcelHelpers.export(exports, "transformDefinitions", ()=>transformDefinitions);
var _utils = require("@motionone/utils");
var _dataEsJs = require("../data.es.js");
/**
 * A list of all transformable axes. We'll use this list to generated a version
 * of each axes for each transform.
 */ const axes = [
    "",
    "X",
    "Y",
    "Z"
];
/**
 * An ordered array of each transformable value. By default, transform values
 * will be sorted to this order.
 */ const order = [
    "translate",
    "scale",
    "rotate",
    "skew"
];
const transformAlias = {
    x: "translateX",
    y: "translateY",
    z: "translateZ"
};
const rotation = {
    syntax: "<angle>",
    initialValue: "0deg",
    toDefaultUnit: (v)=>v + "deg"
};
const baseTransformProperties = {
    translate: {
        syntax: "<length-percentage>",
        initialValue: "0px",
        toDefaultUnit: (v)=>v + "px"
    },
    rotate: rotation,
    scale: {
        syntax: "<number>",
        initialValue: 1,
        toDefaultUnit: (0, _utils.noopReturn)
    },
    skew: rotation
};
const transformDefinitions = new Map();
const asTransformCssVar = (name)=>`--motion-${name}`;
/**
 * Generate a list of every possible transform key
 */ const transforms = [
    "x",
    "y",
    "z"
];
order.forEach((name)=>{
    axes.forEach((axis)=>{
        transforms.push(name + axis);
        transformDefinitions.set(asTransformCssVar(name + axis), baseTransformProperties[name]);
    });
});
/**
 * A function to use with Array.sort to sort transform keys by their default order.
 */ const compareTransformOrder = (a, b)=>transforms.indexOf(a) - transforms.indexOf(b);
/**
 * Provide a quick way to check if a string is the name of a transform
 */ const transformLookup = new Set(transforms);
const isTransform = (name)=>transformLookup.has(name);
const addTransformToElement = (element, name)=>{
    // Map x to translateX etc
    if (transformAlias[name]) name = transformAlias[name];
    const { transforms } = (0, _dataEsJs.getAnimationData)(element);
    (0, _utils.addUniqueItem)(transforms, name);
    /**
     * TODO: An optimisation here could be to cache the transform in element data
     * and only update if this has changed.
     */ element.style.transform = buildTransformTemplate(transforms);
};
const buildTransformTemplate = (transforms)=>transforms.sort(compareTransformOrder).reduce(transformListToString, "").trim();
const transformListToString = (template, name)=>`${template} ${name}(var(${asTransformCssVar(name)}))`;

},{"@motionone/utils":"h9mXa","../data.es.js":"hFBG9","@parcel/transformer-js/src/esmodule-helpers.js":"90RNB"}],"bN9UB":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "convertEasing", ()=>convertEasing);
parcelHelpers.export(exports, "cubicBezierAsString", ()=>cubicBezierAsString);
parcelHelpers.export(exports, "generateLinearEasingPoints", ()=>generateLinearEasingPoints);
var _utils = require("@motionone/utils");
var _featureDetectionEsJs = require("./feature-detection.es.js");
// Create a linear easing point for every x second
const resolution = 0.015;
const generateLinearEasingPoints = (easing, duration)=>{
    let points = "";
    const numPoints = Math.round(duration / resolution);
    for(let i = 0; i < numPoints; i++)points += easing((0, _utils.progress)(0, numPoints - 1, i)) + ", ";
    return points.substring(0, points.length - 2);
};
const convertEasing = (easing, duration)=>{
    if ((0, _utils.isFunction)(easing)) return (0, _featureDetectionEsJs.supports).linearEasing() ? `linear(${generateLinearEasingPoints(easing, duration)})` : (0, _utils.defaults).easing;
    else return (0, _utils.isCubicBezier)(easing) ? cubicBezierAsString(easing) : easing;
};
const cubicBezierAsString = ([a, b, c, d])=>`cubic-bezier(${a}, ${b}, ${c}, ${d})`;

},{"@motionone/utils":"h9mXa","./feature-detection.es.js":"h4OTE","@parcel/transformer-js/src/esmodule-helpers.js":"90RNB"}],"h4OTE":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "supports", ()=>supports);
const testAnimation = (keyframes, options)=>document.createElement("div").animate(keyframes, options);
const featureTests = {
    cssRegisterProperty: ()=>typeof CSS !== "undefined" && Object.hasOwnProperty.call(CSS, "registerProperty"),
    waapi: ()=>Object.hasOwnProperty.call(Element.prototype, "animate"),
    partialKeyframes: ()=>{
        try {
            testAnimation({
                opacity: [
                    1
                ]
            });
        } catch (e) {
            return false;
        }
        return true;
    },
    finished: ()=>Boolean(testAnimation({
            opacity: [
                0,
                1
            ]
        }, {
            duration: 0.001
        }).finished),
    linearEasing: ()=>{
        try {
            testAnimation({
                opacity: 0
            }, {
                easing: "linear(0, 1)"
            });
        } catch (e) {
            return false;
        }
        return true;
    }
};
const results = {};
const supports = {};
for(const key in featureTests)supports[key] = ()=>{
    if (results[key] === undefined) results[key] = featureTests[key]();
    return results[key];
};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"90RNB"}],"9BIDR":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "hydrateKeyframes", ()=>hydrateKeyframes);
parcelHelpers.export(exports, "keyframesList", ()=>keyframesList);
function hydrateKeyframes(keyframes, readInitialValue) {
    for(let i = 0; i < keyframes.length; i++)if (keyframes[i] === null) keyframes[i] = i ? keyframes[i - 1] : readInitialValue();
    return keyframes;
}
const keyframesList = (keyframes)=>Array.isArray(keyframes) ? keyframes : [
        keyframes
    ];

},{"@parcel/transformer-js/src/esmodule-helpers.js":"90RNB"}],"cHmC6":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "style", ()=>style);
var _cssVarEsJs = require("./utils/css-var.es.js");
var _getStyleNameEsJs = require("./utils/get-style-name.es.js");
var _transformsEsJs = require("./utils/transforms.es.js");
const style = {
    get: (element, name)=>{
        name = (0, _getStyleNameEsJs.getStyleName)(name);
        let value = (0, _cssVarEsJs.isCssVar)(name) ? element.style.getPropertyValue(name) : getComputedStyle(element)[name];
        if (!value && value !== 0) {
            const definition = (0, _transformsEsJs.transformDefinitions).get(name);
            if (definition) value = definition.initialValue;
        }
        return value;
    },
    set: (element, name, value)=>{
        name = (0, _getStyleNameEsJs.getStyleName)(name);
        if ((0, _cssVarEsJs.isCssVar)(name)) element.style.setProperty(name, value);
        else element.style[name] = value;
    }
};

},{"./utils/css-var.es.js":"2eFjV","./utils/get-style-name.es.js":"eXoUu","./utils/transforms.es.js":"jdwYq","@parcel/transformer-js/src/esmodule-helpers.js":"90RNB"}],"eXoUu":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getStyleName", ()=>getStyleName);
var _transformsEsJs = require("./transforms.es.js");
function getStyleName(key) {
    if ((0, _transformsEsJs.transformAlias)[key]) key = (0, _transformsEsJs.transformAlias)[key];
    return (0, _transformsEsJs.isTransform)(key) ? (0, _transformsEsJs.asTransformCssVar)(key) : key;
}

},{"./transforms.es.js":"jdwYq","@parcel/transformer-js/src/esmodule-helpers.js":"90RNB"}],"7Uk3y":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "stopAnimation", ()=>stopAnimation);
function stopAnimation(animation, needsCommit = true) {
    if (!animation || animation.playState === "finished") return;
    // Suppress error thrown by WAAPI
    try {
        if (animation.stop) animation.stop();
        else {
            needsCommit && animation.commitStyles();
            animation.cancel();
        }
    } catch (e) {}
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"90RNB"}],"4W4UO":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getUnitConverter", ()=>getUnitConverter);
var _utils = require("@motionone/utils");
function getUnitConverter(keyframes, definition) {
    var _a;
    let toUnit = (definition === null || definition === void 0 ? void 0 : definition.toDefaultUnit) || (0, _utils.noopReturn);
    const finalKeyframe = keyframes[keyframes.length - 1];
    if ((0, _utils.isString)(finalKeyframe)) {
        const unit = ((_a = finalKeyframe.match(/(-?[\d.]+)([a-z%]*)/)) === null || _a === void 0 ? void 0 : _a[2]) || "";
        if (unit) toUnit = (value)=>value + unit;
    }
    return toUnit;
}

},{"@motionone/utils":"h9mXa","@parcel/transformer-js/src/esmodule-helpers.js":"90RNB"}],"2CBzj":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getOptions", ()=>getOptions);
const getOptions = (options, key)=>/**
 * TODO: Make test for this
 * Always return a new object otherwise delay is overwritten by results of stagger
 * and this results in no stagger
 */ options[key] ? Object.assign(Object.assign({}, options), options[key]) : Object.assign({}, options);

},{"@parcel/transformer-js/src/esmodule-helpers.js":"90RNB"}],"h3E9G":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "resolveElements", ()=>resolveElements);
function resolveElements(elements, selectorCache) {
    var _a;
    if (typeof elements === "string") {
        if (selectorCache) {
            (_a = selectorCache[elements]) !== null && _a !== void 0 ? _a : selectorCache[elements] = document.querySelectorAll(elements);
            elements = selectorCache[elements];
        } else elements = document.querySelectorAll(elements);
    } else if (elements instanceof Element) elements = [
        elements
    ];
    /**
     * Return an empty array
     */ return Array.from(elements || []);
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"90RNB"}],"kXqZE":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "controls", ()=>controls);
parcelHelpers.export(exports, "withControls", ()=>withControls);
var _utils = require("@motionone/utils");
var _stopAnimationEsJs = require("./stop-animation.es.js");
const createAnimation = (factory)=>factory();
const withControls = (animationFactory, options, duration = (0, _utils.defaults).duration)=>{
    return new Proxy({
        animations: animationFactory.map(createAnimation).filter(Boolean),
        duration,
        options
    }, controls);
};
/**
 * TODO:
 * Currently this returns the first animation, ideally it would return
 * the first active animation.
 */ const getActiveAnimation = (state)=>state.animations[0];
const controls = {
    get: (target, key)=>{
        const activeAnimation = getActiveAnimation(target);
        switch(key){
            case "duration":
                return target.duration;
            case "currentTime":
                return (0, _utils.time).s((activeAnimation === null || activeAnimation === void 0 ? void 0 : activeAnimation[key]) || 0);
            case "playbackRate":
            case "playState":
                return activeAnimation === null || activeAnimation === void 0 ? void 0 : activeAnimation[key];
            case "finished":
                if (!target.finished) target.finished = Promise.all(target.animations.map(selectFinished)).catch((0, _utils.noop));
                return target.finished;
            case "stop":
                return ()=>{
                    target.animations.forEach((animation)=>(0, _stopAnimationEsJs.stopAnimation)(animation));
                };
            case "forEachNative":
                /**
                 * This is for internal use only, fire a callback for each
                 * underlying animation.
                 */ return (callback)=>{
                    target.animations.forEach((animation)=>callback(animation, target));
                };
            default:
                return typeof (activeAnimation === null || activeAnimation === void 0 ? void 0 : activeAnimation[key]) === "undefined" ? undefined : ()=>target.animations.forEach((animation)=>animation[key]());
        }
    },
    set: (target, key, value)=>{
        switch(key){
            case "currentTime":
                value = (0, _utils.time).ms(value);
            // Fall-through
            case "playbackRate":
                for(let i = 0; i < target.animations.length; i++)target.animations[i][key] = value;
                return true;
        }
        return false;
    }
};
const selectFinished = (animation)=>animation.finished;

},{"@motionone/utils":"h9mXa","./stop-animation.es.js":"7Uk3y","@parcel/transformer-js/src/esmodule-helpers.js":"90RNB"}],"4OfEJ":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getFromIndex", ()=>getFromIndex);
parcelHelpers.export(exports, "resolveOption", ()=>resolveOption);
parcelHelpers.export(exports, "stagger", ()=>stagger);
var _utils = require("@motionone/utils");
var _animation = require("@motionone/animation");
function stagger(duration = 0.1, { start = 0, from = 0, easing } = {}) {
    return (i, total)=>{
        const fromIndex = (0, _utils.isNumber)(from) ? from : getFromIndex(from, total);
        const distance = Math.abs(fromIndex - i);
        let delay = duration * distance;
        if (easing) {
            const maxDelay = total * duration;
            const easingFunction = (0, _animation.getEasingFunction)(easing);
            delay = easingFunction(delay / maxDelay) * maxDelay;
        }
        return start + delay;
    };
}
function getFromIndex(from, total) {
    if (from === "first") return 0;
    else {
        const lastIndex = total - 1;
        return from === "last" ? lastIndex : lastIndex / 2;
    }
}
function resolveOption(option, i, total) {
    return (0, _utils.isFunction)(option) ? option(i, total) : option;
}

},{"@motionone/utils":"h9mXa","@motionone/animation":"jm2tn","@parcel/transformer-js/src/esmodule-helpers.js":"90RNB"}],"96ksJ":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "inView", ()=>inView);
var _resolveElementsEsJs = require("../utils/resolve-elements.es.js");
var _utils = require("@motionone/utils");
const thresholds = {
    any: 0,
    all: 1
};
function inView(elementOrSelector, onStart, { root, margin: rootMargin, amount = "any" } = {}) {
    /**
     * If this browser doesn't support IntersectionObserver, return a dummy stop function.
     * Default triggering of onStart is tricky - it could be used for starting/stopping
     * videos, lazy loading content etc. We could provide an option to enable a fallback, or
     * provide a fallback callback option.
     */ if (typeof IntersectionObserver === "undefined") return ()=>{};
    const elements = (0, _resolveElementsEsJs.resolveElements)(elementOrSelector);
    const activeIntersections = new WeakMap();
    const onIntersectionChange = (entries)=>{
        entries.forEach((entry)=>{
            const onEnd = activeIntersections.get(entry.target);
            /**
             * If there's no change to the intersection, we don't need to
             * do anything here.
             */ if (entry.isIntersecting === Boolean(onEnd)) return;
            if (entry.isIntersecting) {
                const newOnEnd = onStart(entry);
                if ((0, _utils.isFunction)(newOnEnd)) activeIntersections.set(entry.target, newOnEnd);
                else observer.unobserve(entry.target);
            } else if (onEnd) {
                onEnd(entry);
                activeIntersections.delete(entry.target);
            }
        });
    };
    const observer = new IntersectionObserver(onIntersectionChange, {
        root,
        rootMargin,
        threshold: typeof amount === "number" ? amount : thresholds[amount]
    });
    elements.forEach((element)=>observer.observe(element));
    return ()=>observer.disconnect();
}

},{"../utils/resolve-elements.es.js":"h3E9G","@motionone/utils":"h9mXa","@parcel/transformer-js/src/esmodule-helpers.js":"90RNB"}],"4BXtZ":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "resize", ()=>resize);
var _handleElementEsJs = require("./handle-element.es.js");
var _handleWindowEsJs = require("./handle-window.es.js");
var _utils = require("@motionone/utils");
function resize(a, b) {
    return (0, _utils.isFunction)(a) ? (0, _handleWindowEsJs.resizeWindow)(a) : (0, _handleElementEsJs.resizeElement)(a, b);
}

},{"./handle-element.es.js":"aTwgL","./handle-window.es.js":"jqFSu","@motionone/utils":"h9mXa","@parcel/transformer-js/src/esmodule-helpers.js":"90RNB"}],"aTwgL":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "resizeElement", ()=>resizeElement);
var _resolveElementsEsJs = require("../../utils/resolve-elements.es.js");
const resizeHandlers = new WeakMap();
let observer;
function getElementSize(target, borderBoxSize) {
    if (borderBoxSize) {
        const { inlineSize, blockSize } = borderBoxSize[0];
        return {
            width: inlineSize,
            height: blockSize
        };
    } else if (target instanceof SVGElement && "getBBox" in target) return target.getBBox();
    else return {
        width: target.offsetWidth,
        height: target.offsetHeight
    };
}
function notifyTarget({ target, contentRect, borderBoxSize }) {
    var _a;
    (_a = resizeHandlers.get(target)) === null || _a === void 0 || _a.forEach((handler)=>{
        handler({
            target,
            contentSize: contentRect,
            get size () {
                return getElementSize(target, borderBoxSize);
            }
        });
    });
}
function notifyAll(entries) {
    entries.forEach(notifyTarget);
}
function createResizeObserver() {
    if (typeof ResizeObserver === "undefined") return;
    observer = new ResizeObserver(notifyAll);
}
function resizeElement(target, handler) {
    if (!observer) createResizeObserver();
    const elements = (0, _resolveElementsEsJs.resolveElements)(target);
    elements.forEach((element)=>{
        let elementHandlers = resizeHandlers.get(element);
        if (!elementHandlers) {
            elementHandlers = new Set();
            resizeHandlers.set(element, elementHandlers);
        }
        elementHandlers.add(handler);
        observer === null || observer === void 0 || observer.observe(element);
    });
    return ()=>{
        elements.forEach((element)=>{
            const elementHandlers = resizeHandlers.get(element);
            elementHandlers === null || elementHandlers === void 0 || elementHandlers.delete(handler);
            if (!(elementHandlers === null || elementHandlers === void 0 ? void 0 : elementHandlers.size)) observer === null || observer === void 0 || observer.unobserve(element);
        });
    };
}

},{"../../utils/resolve-elements.es.js":"h3E9G","@parcel/transformer-js/src/esmodule-helpers.js":"90RNB"}],"jqFSu":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "resizeWindow", ()=>resizeWindow);
const windowCallbacks = new Set();
let windowResizeHandler;
function createWindowResizeHandler() {
    windowResizeHandler = ()=>{
        const size = {
            width: window.innerWidth,
            height: window.innerHeight
        };
        const info = {
            target: window,
            size,
            contentSize: size
        };
        windowCallbacks.forEach((callback)=>callback(info));
    };
    window.addEventListener("resize", windowResizeHandler);
}
function resizeWindow(callback) {
    windowCallbacks.add(callback);
    if (!windowResizeHandler) createWindowResizeHandler();
    return ()=>{
        windowCallbacks.delete(callback);
        if (!windowCallbacks.size && windowResizeHandler) windowResizeHandler = undefined;
    };
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"90RNB"}],"9uIs6":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "scroll", ()=>scroll);
var _tslib = require("tslib");
var _indexEsJs = require("../resize/index.es.js");
var _infoEsJs = require("./info.es.js");
var _onScrollHandlerEsJs = require("./on-scroll-handler.es.js");
const scrollListeners = new WeakMap();
const resizeListeners = new WeakMap();
const onScrollHandlers = new WeakMap();
const getEventTarget = (element)=>element === document.documentElement ? window : element;
function scroll(onScroll, _a = {}) {
    var { container = document.documentElement } = _a, options = (0, _tslib.__rest)(_a, [
        "container"
    ]);
    let containerHandlers = onScrollHandlers.get(container);
    /**
     * Get the onScroll handlers for this container.
     * If one isn't found, create a new one.
     */ if (!containerHandlers) {
        containerHandlers = new Set();
        onScrollHandlers.set(container, containerHandlers);
    }
    /**
     * Create a new onScroll handler for the provided callback.
     */ const info = (0, _infoEsJs.createScrollInfo)();
    const containerHandler = (0, _onScrollHandlerEsJs.createOnScrollHandler)(container, onScroll, info, options);
    containerHandlers.add(containerHandler);
    /**
     * Check if there's a scroll event listener for this container.
     * If not, create one.
     */ if (!scrollListeners.has(container)) {
        const listener = ()=>{
            const time = performance.now();
            for (const handler of containerHandlers)handler.measure();
            for (const handler of containerHandlers)handler.update(time);
            for (const handler of containerHandlers)handler.notify();
        };
        scrollListeners.set(container, listener);
        const target = getEventTarget(container);
        window.addEventListener("resize", listener, {
            passive: true
        });
        if (container !== document.documentElement) resizeListeners.set(container, (0, _indexEsJs.resize)(container, listener));
        target.addEventListener("scroll", listener, {
            passive: true
        });
    }
    const listener = scrollListeners.get(container);
    const onLoadProcesss = requestAnimationFrame(listener);
    return ()=>{
        var _a;
        if (typeof onScroll !== "function") onScroll.stop();
        cancelAnimationFrame(onLoadProcesss);
        /**
         * Check if we even have any handlers for this container.
         */ const containerHandlers = onScrollHandlers.get(container);
        if (!containerHandlers) return;
        containerHandlers.delete(containerHandler);
        if (containerHandlers.size) return;
        /**
         * If no more handlers, remove the scroll listener too.
         */ const listener = scrollListeners.get(container);
        scrollListeners.delete(container);
        if (listener) {
            getEventTarget(container).removeEventListener("scroll", listener);
            (_a = resizeListeners.get(container)) === null || _a === void 0 || _a();
            window.removeEventListener("resize", listener);
        }
    };
}

},{"tslib":"b4YBG","../resize/index.es.js":"4BXtZ","./info.es.js":"cGYrT","./on-scroll-handler.es.js":"glOGz","@parcel/transformer-js/src/esmodule-helpers.js":"90RNB"}],"b4YBG":[function(require,module,exports) {
/******************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */ /* global Reflect, Promise, SuppressedError, Symbol */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "__extends", ()=>__extends);
parcelHelpers.export(exports, "__assign", ()=>__assign);
parcelHelpers.export(exports, "__rest", ()=>__rest);
parcelHelpers.export(exports, "__decorate", ()=>__decorate);
parcelHelpers.export(exports, "__param", ()=>__param);
parcelHelpers.export(exports, "__esDecorate", ()=>__esDecorate);
parcelHelpers.export(exports, "__runInitializers", ()=>__runInitializers);
parcelHelpers.export(exports, "__propKey", ()=>__propKey);
parcelHelpers.export(exports, "__setFunctionName", ()=>__setFunctionName);
parcelHelpers.export(exports, "__metadata", ()=>__metadata);
parcelHelpers.export(exports, "__awaiter", ()=>__awaiter);
parcelHelpers.export(exports, "__generator", ()=>__generator);
parcelHelpers.export(exports, "__createBinding", ()=>__createBinding);
parcelHelpers.export(exports, "__exportStar", ()=>__exportStar);
parcelHelpers.export(exports, "__values", ()=>__values);
parcelHelpers.export(exports, "__read", ()=>__read);
/** @deprecated */ parcelHelpers.export(exports, "__spread", ()=>__spread);
/** @deprecated */ parcelHelpers.export(exports, "__spreadArrays", ()=>__spreadArrays);
parcelHelpers.export(exports, "__spreadArray", ()=>__spreadArray);
parcelHelpers.export(exports, "__await", ()=>__await);
parcelHelpers.export(exports, "__asyncGenerator", ()=>__asyncGenerator);
parcelHelpers.export(exports, "__asyncDelegator", ()=>__asyncDelegator);
parcelHelpers.export(exports, "__asyncValues", ()=>__asyncValues);
parcelHelpers.export(exports, "__makeTemplateObject", ()=>__makeTemplateObject);
parcelHelpers.export(exports, "__importStar", ()=>__importStar);
parcelHelpers.export(exports, "__importDefault", ()=>__importDefault);
parcelHelpers.export(exports, "__classPrivateFieldGet", ()=>__classPrivateFieldGet);
parcelHelpers.export(exports, "__classPrivateFieldSet", ()=>__classPrivateFieldSet);
parcelHelpers.export(exports, "__classPrivateFieldIn", ()=>__classPrivateFieldIn);
parcelHelpers.export(exports, "__addDisposableResource", ()=>__addDisposableResource);
parcelHelpers.export(exports, "__disposeResources", ()=>__disposeResources);
var extendStatics = function(d, b) {
    extendStatics = Object.setPrototypeOf || ({
        __proto__: []
    }) instanceof Array && function(d, b) {
        d.__proto__ = b;
    } || function(d, b) {
        for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
    };
    return extendStatics(d, b);
};
function __extends(d, b) {
    if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
    extendStatics(d, b);
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}
var __assign = function() {
    __assign = Object.assign || function __assign(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
function __rest(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
}
function __decorate(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
}
function __param(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
}
function __esDecorate(ctor, descriptorIn, decorators, contextIn, initializers, extraInitializers) {
    function accept(f) {
        if (f !== void 0 && typeof f !== "function") throw new TypeError("Function expected");
        return f;
    }
    var kind = contextIn.kind, key = kind === "getter" ? "get" : kind === "setter" ? "set" : "value";
    var target = !descriptorIn && ctor ? contextIn["static"] ? ctor : ctor.prototype : null;
    var descriptor = descriptorIn || (target ? Object.getOwnPropertyDescriptor(target, contextIn.name) : {});
    var _, done = false;
    for(var i = decorators.length - 1; i >= 0; i--){
        var context = {};
        for(var p in contextIn)context[p] = p === "access" ? {} : contextIn[p];
        for(var p in contextIn.access)context.access[p] = contextIn.access[p];
        context.addInitializer = function(f) {
            if (done) throw new TypeError("Cannot add initializers after decoration has completed");
            extraInitializers.push(accept(f || null));
        };
        var result = (0, decorators[i])(kind === "accessor" ? {
            get: descriptor.get,
            set: descriptor.set
        } : descriptor[key], context);
        if (kind === "accessor") {
            if (result === void 0) continue;
            if (result === null || typeof result !== "object") throw new TypeError("Object expected");
            if (_ = accept(result.get)) descriptor.get = _;
            if (_ = accept(result.set)) descriptor.set = _;
            if (_ = accept(result.init)) initializers.unshift(_);
        } else if (_ = accept(result)) {
            if (kind === "field") initializers.unshift(_);
            else descriptor[key] = _;
        }
    }
    if (target) Object.defineProperty(target, contextIn.name, descriptor);
    done = true;
}
function __runInitializers(thisArg, initializers, value) {
    var useValue = arguments.length > 2;
    for(var i = 0; i < initializers.length; i++)value = useValue ? initializers[i].call(thisArg, value) : initializers[i].call(thisArg);
    return useValue ? value : void 0;
}
function __propKey(x) {
    return typeof x === "symbol" ? x : "".concat(x);
}
function __setFunctionName(f, name, prefix) {
    if (typeof name === "symbol") name = name.description ? "[".concat(name.description, "]") : "";
    return Object.defineProperty(f, "name", {
        configurable: true,
        value: prefix ? "".concat(prefix, " ", name) : name
    });
}
function __metadata(metadataKey, metadataValue) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(metadataKey, metadataValue);
}
function __awaiter(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}
function __generator(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(g && (g = 0, op[0] && (_ = 0)), _)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
}
var __createBinding = Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
};
function __exportStar(m, o) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(o, p)) __createBinding(o, m, p);
}
function __values(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function() {
            if (o && i >= o.length) o = void 0;
            return {
                value: o && o[i++],
                done: !o
            };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
}
function __read(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while((n === void 0 || n-- > 0) && !(r = i.next()).done)ar.push(r.value);
    } catch (error) {
        e = {
            error: error
        };
    } finally{
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        } finally{
            if (e) throw e.error;
        }
    }
    return ar;
}
function __spread() {
    for(var ar = [], i = 0; i < arguments.length; i++)ar = ar.concat(__read(arguments[i]));
    return ar;
}
function __spreadArrays() {
    for(var s = 0, i = 0, il = arguments.length; i < il; i++)s += arguments[i].length;
    for(var r = Array(s), k = 0, i = 0; i < il; i++)for(var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)r[k] = a[j];
    return r;
}
function __spreadArray(to, from, pack) {
    if (pack || arguments.length === 2) {
        for(var i = 0, l = from.length, ar; i < l; i++)if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
}
function __await(v) {
    return this instanceof __await ? (this.v = v, this) : new __await(v);
}
function __asyncGenerator(thisArg, _arguments, generator) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var g = generator.apply(thisArg, _arguments || []), i, q = [];
    return i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i;
    function verb(n) {
        if (g[n]) i[n] = function(v) {
            return new Promise(function(a, b) {
                q.push([
                    n,
                    v,
                    a,
                    b
                ]) > 1 || resume(n, v);
            });
        };
    }
    function resume(n, v) {
        try {
            step(g[n](v));
        } catch (e) {
            settle(q[0][3], e);
        }
    }
    function step(r) {
        r.value instanceof __await ? Promise.resolve(r.value.v).then(fulfill, reject) : settle(q[0][2], r);
    }
    function fulfill(value) {
        resume("next", value);
    }
    function reject(value) {
        resume("throw", value);
    }
    function settle(f, v) {
        if (f(v), q.shift(), q.length) resume(q[0][0], q[0][1]);
    }
}
function __asyncDelegator(o) {
    var i, p;
    return i = {}, verb("next"), verb("throw", function(e) {
        throw e;
    }), verb("return"), i[Symbol.iterator] = function() {
        return this;
    }, i;
    function verb(n, f) {
        i[n] = o[n] ? function(v) {
            return (p = !p) ? {
                value: __await(o[n](v)),
                done: false
            } : f ? f(v) : v;
        } : f;
    }
}
function __asyncValues(o) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var m = o[Symbol.asyncIterator], i;
    return m ? m.call(o) : (o = typeof __values === "function" ? __values(o) : o[Symbol.iterator](), i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i);
    function verb(n) {
        i[n] = o[n] && function(v) {
            return new Promise(function(resolve, reject) {
                v = o[n](v), settle(resolve, reject, v.done, v.value);
            });
        };
    }
    function settle(resolve, reject, d, v) {
        Promise.resolve(v).then(function(v) {
            resolve({
                value: v,
                done: d
            });
        }, reject);
    }
}
function __makeTemplateObject(cooked, raw) {
    if (Object.defineProperty) Object.defineProperty(cooked, "raw", {
        value: raw
    });
    else cooked.raw = raw;
    return cooked;
}
var __setModuleDefault = Object.create ? function(o, v) {
    Object.defineProperty(o, "default", {
        enumerable: true,
        value: v
    });
} : function(o, v) {
    o["default"] = v;
};
function __importStar(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    }
    __setModuleDefault(result, mod);
    return result;
}
function __importDefault(mod) {
    return mod && mod.__esModule ? mod : {
        default: mod
    };
}
function __classPrivateFieldGet(receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
}
function __classPrivateFieldSet(receiver, state, value, kind, f) {
    if (kind === "m") throw new TypeError("Private method is not writable");
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a setter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
    return kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value), value;
}
function __classPrivateFieldIn(state, receiver) {
    if (receiver === null || typeof receiver !== "object" && typeof receiver !== "function") throw new TypeError("Cannot use 'in' operator on non-object");
    return typeof state === "function" ? receiver === state : state.has(receiver);
}
function __addDisposableResource(env, value, async) {
    if (value !== null && value !== void 0) {
        if (typeof value !== "object" && typeof value !== "function") throw new TypeError("Object expected.");
        var dispose;
        if (async) {
            if (!Symbol.asyncDispose) throw new TypeError("Symbol.asyncDispose is not defined.");
            dispose = value[Symbol.asyncDispose];
        }
        if (dispose === void 0) {
            if (!Symbol.dispose) throw new TypeError("Symbol.dispose is not defined.");
            dispose = value[Symbol.dispose];
        }
        if (typeof dispose !== "function") throw new TypeError("Object not disposable.");
        env.stack.push({
            value: value,
            dispose: dispose,
            async: async
        });
    } else if (async) env.stack.push({
        async: true
    });
    return value;
}
var _SuppressedError = typeof SuppressedError === "function" ? SuppressedError : function(error, suppressed, message) {
    var e = new Error(message);
    return e.name = "SuppressedError", e.error = error, e.suppressed = suppressed, e;
};
function __disposeResources(env) {
    function fail(e) {
        env.error = env.hasError ? new _SuppressedError(e, env.error, "An error was suppressed during disposal.") : e;
        env.hasError = true;
    }
    function next() {
        while(env.stack.length){
            var rec = env.stack.pop();
            try {
                var result = rec.dispose && rec.dispose.call(rec.value);
                if (rec.async) return Promise.resolve(result).then(next, function(e) {
                    fail(e);
                    return next();
                });
            } catch (e) {
                fail(e);
            }
        }
        if (env.hasError) throw env.error;
    }
    return next();
}
exports.default = {
    __extends: __extends,
    __assign: __assign,
    __rest: __rest,
    __decorate: __decorate,
    __param: __param,
    __metadata: __metadata,
    __awaiter: __awaiter,
    __generator: __generator,
    __createBinding: __createBinding,
    __exportStar: __exportStar,
    __values: __values,
    __read: __read,
    __spread: __spread,
    __spreadArrays: __spreadArrays,
    __spreadArray: __spreadArray,
    __await: __await,
    __asyncGenerator: __asyncGenerator,
    __asyncDelegator: __asyncDelegator,
    __asyncValues: __asyncValues,
    __makeTemplateObject: __makeTemplateObject,
    __importStar: __importStar,
    __importDefault: __importDefault,
    __classPrivateFieldGet: __classPrivateFieldGet,
    __classPrivateFieldSet: __classPrivateFieldSet,
    __classPrivateFieldIn: __classPrivateFieldIn,
    __addDisposableResource: __addDisposableResource,
    __disposeResources: __disposeResources
};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"90RNB"}],"cGYrT":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "createScrollInfo", ()=>createScrollInfo);
parcelHelpers.export(exports, "updateScrollInfo", ()=>updateScrollInfo);
var _utils = require("@motionone/utils");
/**
 * A time in milliseconds, beyond which we consider the scroll velocity to be 0.
 */ const maxElapsed = 50;
const createAxisInfo = ()=>({
        current: 0,
        offset: [],
        progress: 0,
        scrollLength: 0,
        targetOffset: 0,
        targetLength: 0,
        containerLength: 0,
        velocity: 0
    });
const createScrollInfo = ()=>({
        time: 0,
        x: createAxisInfo(),
        y: createAxisInfo()
    });
const keys = {
    x: {
        length: "Width",
        position: "Left"
    },
    y: {
        length: "Height",
        position: "Top"
    }
};
function updateAxisInfo(element, axisName, info, time) {
    const axis = info[axisName];
    const { length, position } = keys[axisName];
    const prev = axis.current;
    const prevTime = info.time;
    axis.current = element["scroll" + position];
    axis.scrollLength = element["scroll" + length] - element["client" + length];
    axis.offset.length = 0;
    axis.offset[0] = 0;
    axis.offset[1] = axis.scrollLength;
    axis.progress = (0, _utils.progress)(0, axis.scrollLength, axis.current);
    const elapsed = time - prevTime;
    axis.velocity = elapsed > maxElapsed ? 0 : (0, _utils.velocityPerSecond)(axis.current - prev, elapsed);
}
function updateScrollInfo(element, info, time) {
    updateAxisInfo(element, "x", info, time);
    updateAxisInfo(element, "y", info, time);
    info.time = time;
}

},{"@motionone/utils":"h9mXa","@parcel/transformer-js/src/esmodule-helpers.js":"90RNB"}],"glOGz":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "createOnScrollHandler", ()=>createOnScrollHandler);
var _utils = require("@motionone/utils");
var _infoEsJs = require("./info.es.js");
var _indexEsJs = require("./offsets/index.es.js");
function measure(container, target = container, info) {
    /**
     * Find inset of target within scrollable container
     */ info.x.targetOffset = 0;
    info.y.targetOffset = 0;
    if (target !== container) {
        let node = target;
        while(node && node != container){
            info.x.targetOffset += node.offsetLeft;
            info.y.targetOffset += node.offsetTop;
            node = node.offsetParent;
        }
    }
    info.x.targetLength = target === container ? target.scrollWidth : target.clientWidth;
    info.y.targetLength = target === container ? target.scrollHeight : target.clientHeight;
    info.x.containerLength = container.clientWidth;
    info.y.containerLength = container.clientHeight;
}
function createOnScrollHandler(element, onScroll, info, options = {}) {
    const axis = options.axis || "y";
    return {
        measure: ()=>measure(element, options.target, info),
        update: (time)=>{
            (0, _infoEsJs.updateScrollInfo)(element, info, time);
            if (options.offset || options.target) (0, _indexEsJs.resolveOffsets)(element, info, options);
        },
        notify: (0, _utils.isFunction)(onScroll) ? ()=>onScroll(info) : scrubAnimation(onScroll, info[axis])
    };
}
function scrubAnimation(controls, axisInfo) {
    controls.pause();
    controls.forEachNative((animation, { easing })=>{
        var _a, _b;
        if (animation.updateDuration) {
            if (!easing) animation.easing = (0, _utils.noopReturn);
            animation.updateDuration(1);
        } else {
            const timingOptions = {
                duration: 1000
            };
            if (!easing) timingOptions.easing = "linear";
            (_b = (_a = animation.effect) === null || _a === void 0 ? void 0 : _a.updateTiming) === null || _b === void 0 || _b.call(_a, timingOptions);
        }
    });
    return ()=>{
        controls.currentTime = axisInfo.progress;
    };
}

},{"@motionone/utils":"h9mXa","./info.es.js":"cGYrT","./offsets/index.es.js":"l6oBw","@parcel/transformer-js/src/esmodule-helpers.js":"90RNB"}],"l6oBw":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "resolveOffsets", ()=>resolveOffsets);
var _utils = require("@motionone/utils");
var _insetEsJs = require("./inset.es.js");
var _presetsEsJs = require("./presets.es.js");
var _offsetEsJs = require("./offset.es.js");
const point = {
    x: 0,
    y: 0
};
function resolveOffsets(container, info, options) {
    let { offset: offsetDefinition = (0, _presetsEsJs.ScrollOffset).All } = options;
    const { target = container, axis = "y" } = options;
    const lengthLabel = axis === "y" ? "height" : "width";
    const inset = target !== container ? (0, _insetEsJs.calcInset)(target, container) : point;
    /**
     * Measure the target and container. If they're the same thing then we
     * use the container's scrollWidth/Height as the target, from there
     * all other calculations can remain the same.
     */ const targetSize = target === container ? {
        width: container.scrollWidth,
        height: container.scrollHeight
    } : {
        width: target.clientWidth,
        height: target.clientHeight
    };
    const containerSize = {
        width: container.clientWidth,
        height: container.clientHeight
    };
    /**
     * Reset the length of the resolved offset array rather than creating a new one.
     * TODO: More reusable data structures for targetSize/containerSize would also be good.
     */ info[axis].offset.length = 0;
    /**
     * Populate the offset array by resolving the user's offset definition into
     * a list of pixel scroll offets.
     */ let hasChanged = !info[axis].interpolate;
    const numOffsets = offsetDefinition.length;
    for(let i = 0; i < numOffsets; i++){
        const offset = (0, _offsetEsJs.resolveOffset)(offsetDefinition[i], containerSize[lengthLabel], targetSize[lengthLabel], inset[axis]);
        if (!hasChanged && offset !== info[axis].interpolatorOffsets[i]) hasChanged = true;
        info[axis].offset[i] = offset;
    }
    /**
     * If the pixel scroll offsets have changed, create a new interpolator function
     * to map scroll value into a progress.
     */ if (hasChanged) {
        info[axis].interpolate = (0, _utils.interpolate)((0, _utils.defaultOffset)(numOffsets), info[axis].offset);
        info[axis].interpolatorOffsets = [
            ...info[axis].offset
        ];
    }
    info[axis].progress = info[axis].interpolate(info[axis].current);
}

},{"@motionone/utils":"h9mXa","./inset.es.js":"cJlCM","./presets.es.js":"8fO9E","./offset.es.js":"bjUfx","@parcel/transformer-js/src/esmodule-helpers.js":"90RNB"}],"cJlCM":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "calcInset", ()=>calcInset);
function calcInset(element, container) {
    let inset = {
        x: 0,
        y: 0
    };
    let current = element;
    while(current && current !== container){
        if (current instanceof HTMLElement) {
            inset.x += current.offsetLeft;
            inset.y += current.offsetTop;
            current = current.offsetParent;
        } else if (current instanceof SVGGraphicsElement && "getBBox" in current) {
            const { top, left } = current.getBBox();
            inset.x += left;
            inset.y += top;
            /**
             * Assign the next parent element as the <svg /> tag.
             */ while(current && current.tagName !== "svg")current = current.parentNode;
        }
    }
    return inset;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"90RNB"}],"8fO9E":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ScrollOffset", ()=>ScrollOffset);
const ScrollOffset = {
    Enter: [
        [
            0,
            1
        ],
        [
            1,
            1
        ]
    ],
    Exit: [
        [
            0,
            0
        ],
        [
            1,
            0
        ]
    ],
    Any: [
        [
            1,
            0
        ],
        [
            0,
            1
        ]
    ],
    All: [
        [
            0,
            0
        ],
        [
            1,
            1
        ]
    ]
};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"90RNB"}],"bjUfx":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "resolveOffset", ()=>resolveOffset);
var _utils = require("@motionone/utils");
var _edgeEsJs = require("./edge.es.js");
const defaultOffset = [
    0,
    0
];
function resolveOffset(offset, containerLength, targetLength, targetInset) {
    let offsetDefinition = Array.isArray(offset) ? offset : defaultOffset;
    let targetPoint = 0;
    let containerPoint = 0;
    if ((0, _utils.isNumber)(offset)) /**
         * If we're provided offset: [0, 0.5, 1] then each number x should become
         * [x, x], so we default to the behaviour of mapping 0 => 0 of both target
         * and container etc.
         */ offsetDefinition = [
        offset,
        offset
    ];
    else if ((0, _utils.isString)(offset)) {
        offset = offset.trim();
        if (offset.includes(" ")) offsetDefinition = offset.split(" ");
        else /**
             * If we're provided a definition like "100px" then we want to apply
             * that only to the top of the target point, leaving the container at 0.
             * Whereas a named offset like "end" should be applied to both.
             */ offsetDefinition = [
            offset,
            (0, _edgeEsJs.namedEdges)[offset] ? offset : `0`
        ];
    }
    targetPoint = (0, _edgeEsJs.resolveEdge)(offsetDefinition[0], targetLength, targetInset);
    containerPoint = (0, _edgeEsJs.resolveEdge)(offsetDefinition[1], containerLength);
    return targetPoint - containerPoint;
}

},{"@motionone/utils":"h9mXa","./edge.es.js":"kvt33","@parcel/transformer-js/src/esmodule-helpers.js":"90RNB"}],"kvt33":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "namedEdges", ()=>namedEdges);
parcelHelpers.export(exports, "resolveEdge", ()=>resolveEdge);
var _utils = require("@motionone/utils");
const namedEdges = {
    start: 0,
    center: 0.5,
    end: 1
};
function resolveEdge(edge, length, inset = 0) {
    let delta = 0;
    /**
     * If we have this edge defined as a preset, replace the definition
     * with the numerical value.
     */ if (namedEdges[edge] !== undefined) edge = namedEdges[edge];
    /**
     * Handle unit values
     */ if ((0, _utils.isString)(edge)) {
        const asNumber = parseFloat(edge);
        if (edge.endsWith("px")) delta = asNumber;
        else if (edge.endsWith("%")) edge = asNumber / 100;
        else if (edge.endsWith("vw")) delta = asNumber / 100 * document.documentElement.clientWidth;
        else if (edge.endsWith("vh")) delta = asNumber / 100 * document.documentElement.clientHeight;
        else edge = asNumber;
    }
    /**
     * If the edge is defined as a number, handle as a progress value.
     */ if ((0, _utils.isNumber)(edge)) delta = length * edge;
    return inset + delta;
}

},{"@motionone/utils":"h9mXa","@parcel/transformer-js/src/esmodule-helpers.js":"90RNB"}],"if7Cf":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "animate", ()=>animate);
parcelHelpers.export(exports, "animateProgress", ()=>animateProgress);
var _dom = require("@motionone/dom");
var _utils = require("@motionone/utils");
var _animation = require("@motionone/animation");
function animateProgress(target, options = {}) {
    return (0, _dom.withControls)([
        ()=>{
            const animation = new (0, _animation.Animation)(target, [
                0,
                1
            ], options);
            animation.finished.catch(()=>{});
            return animation;
        }
    ], options, options.duration);
}
function animate(target, keyframesOrOptions, options) {
    const factory = (0, _utils.isFunction)(target) ? animateProgress : (0, _dom.animate);
    return factory(target, keyframesOrOptions, options);
}

},{"@motionone/dom":"9aLuo","@motionone/utils":"h9mXa","@motionone/animation":"jm2tn","@parcel/transformer-js/src/esmodule-helpers.js":"90RNB"}],"76a2Y":[function(require,module,exports) {
/**
 * Swiper 11.0.5
 * Most modern mobile touch slider and framework with hardware accelerated transitions
 * https://swiperjs.com
 *
 * Copyright 2014-2023 Vladimir Kharlampidi
 *
 * Released under the MIT License
 *
 * Released on: November 22, 2023
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Swiper", ()=>(0, _swiperCoreMjs.S));
parcelHelpers.export(exports, "default", ()=>(0, _swiperCoreMjs.S));
var _swiperCoreMjs = require("./shared/swiper-core.mjs");

},{"./shared/swiper-core.mjs":"4xJkF","@parcel/transformer-js/src/esmodule-helpers.js":"90RNB"}],"4xJkF":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "S", ()=>Swiper);
parcelHelpers.export(exports, "d", ()=>defaults);
var _ssrWindowEsmMjs = require("./ssr-window.esm.mjs");
var _utilsMjs = require("./utils.mjs");
let support;
function calcSupport() {
    const window1 = (0, _ssrWindowEsmMjs.a)();
    const document1 = (0, _ssrWindowEsmMjs.g)();
    return {
        smoothScroll: document1.documentElement && document1.documentElement.style && "scrollBehavior" in document1.documentElement.style,
        touch: !!("ontouchstart" in window1 || window1.DocumentTouch && document1 instanceof window1.DocumentTouch)
    };
}
function getSupport() {
    if (!support) support = calcSupport();
    return support;
}
let deviceCached;
function calcDevice(_temp) {
    let { userAgent } = _temp === void 0 ? {} : _temp;
    const support = getSupport();
    const window1 = (0, _ssrWindowEsmMjs.a)();
    const platform = window1.navigator.platform;
    const ua = userAgent || window1.navigator.userAgent;
    const device = {
        ios: false,
        android: false
    };
    const screenWidth = window1.screen.width;
    const screenHeight = window1.screen.height;
    const android = ua.match(/(Android);?[\s\/]+([\d.]+)?/); // eslint-disable-line
    let ipad = ua.match(/(iPad).*OS\s([\d_]+)/);
    const ipod = ua.match(/(iPod)(.*OS\s([\d_]+))?/);
    const iphone = !ipad && ua.match(/(iPhone\sOS|iOS)\s([\d_]+)/);
    const windows = platform === "Win32";
    let macos = platform === "MacIntel";
    // iPadOs 13 fix
    const iPadScreens = [
        "1024x1366",
        "1366x1024",
        "834x1194",
        "1194x834",
        "834x1112",
        "1112x834",
        "768x1024",
        "1024x768",
        "820x1180",
        "1180x820",
        "810x1080",
        "1080x810"
    ];
    if (!ipad && macos && support.touch && iPadScreens.indexOf(`${screenWidth}x${screenHeight}`) >= 0) {
        ipad = ua.match(/(Version)\/([\d.]+)/);
        if (!ipad) ipad = [
            0,
            1,
            "13_0_0"
        ];
        macos = false;
    }
    // Android
    if (android && !windows) {
        device.os = "android";
        device.android = true;
    }
    if (ipad || iphone || ipod) {
        device.os = "ios";
        device.ios = true;
    }
    // Export object
    return device;
}
function getDevice(overrides) {
    if (overrides === void 0) overrides = {};
    if (!deviceCached) deviceCached = calcDevice(overrides);
    return deviceCached;
}
let browser;
function calcBrowser() {
    const window1 = (0, _ssrWindowEsmMjs.a)();
    let needPerspectiveFix = false;
    function isSafari() {
        const ua = window1.navigator.userAgent.toLowerCase();
        return ua.indexOf("safari") >= 0 && ua.indexOf("chrome") < 0 && ua.indexOf("android") < 0;
    }
    if (isSafari()) {
        const ua = String(window1.navigator.userAgent);
        if (ua.includes("Version/")) {
            const [major, minor] = ua.split("Version/")[1].split(" ")[0].split(".").map((num)=>Number(num));
            needPerspectiveFix = major < 16 || major === 16 && minor < 2;
        }
    }
    return {
        isSafari: needPerspectiveFix || isSafari(),
        needPerspectiveFix,
        isWebView: /(iPhone|iPod|iPad).*AppleWebKit(?!.*Safari)/i.test(window1.navigator.userAgent)
    };
}
function getBrowser() {
    if (!browser) browser = calcBrowser();
    return browser;
}
function Resize(_ref) {
    let { swiper, on, emit } = _ref;
    const window1 = (0, _ssrWindowEsmMjs.a)();
    let observer = null;
    let animationFrame = null;
    const resizeHandler = ()=>{
        if (!swiper || swiper.destroyed || !swiper.initialized) return;
        emit("beforeResize");
        emit("resize");
    };
    const createObserver = ()=>{
        if (!swiper || swiper.destroyed || !swiper.initialized) return;
        observer = new ResizeObserver((entries)=>{
            animationFrame = window1.requestAnimationFrame(()=>{
                const { width, height } = swiper;
                let newWidth = width;
                let newHeight = height;
                entries.forEach((_ref2)=>{
                    let { contentBoxSize, contentRect, target } = _ref2;
                    if (target && target !== swiper.el) return;
                    newWidth = contentRect ? contentRect.width : (contentBoxSize[0] || contentBoxSize).inlineSize;
                    newHeight = contentRect ? contentRect.height : (contentBoxSize[0] || contentBoxSize).blockSize;
                });
                if (newWidth !== width || newHeight !== height) resizeHandler();
            });
        });
        observer.observe(swiper.el);
    };
    const removeObserver = ()=>{
        if (animationFrame) window1.cancelAnimationFrame(animationFrame);
        if (observer && observer.unobserve && swiper.el) {
            observer.unobserve(swiper.el);
            observer = null;
        }
    };
    const orientationChangeHandler = ()=>{
        if (!swiper || swiper.destroyed || !swiper.initialized) return;
        emit("orientationchange");
    };
    on("init", ()=>{
        if (swiper.params.resizeObserver && typeof window1.ResizeObserver !== "undefined") {
            createObserver();
            return;
        }
        window1.addEventListener("resize", resizeHandler);
        window1.addEventListener("orientationchange", orientationChangeHandler);
    });
    on("destroy", ()=>{
        removeObserver();
        window1.removeEventListener("resize", resizeHandler);
        window1.removeEventListener("orientationchange", orientationChangeHandler);
    });
}
function Observer(_ref) {
    let { swiper, extendParams, on, emit } = _ref;
    const observers = [];
    const window1 = (0, _ssrWindowEsmMjs.a)();
    const attach = function(target, options) {
        if (options === void 0) options = {};
        const ObserverFunc = window1.MutationObserver || window1.WebkitMutationObserver;
        const observer = new ObserverFunc((mutations)=>{
            // The observerUpdate event should only be triggered
            // once despite the number of mutations.  Additional
            // triggers are redundant and are very costly
            if (swiper.__preventObserver__) return;
            if (mutations.length === 1) {
                emit("observerUpdate", mutations[0]);
                return;
            }
            const observerUpdate = function observerUpdate() {
                emit("observerUpdate", mutations[0]);
            };
            if (window1.requestAnimationFrame) window1.requestAnimationFrame(observerUpdate);
            else window1.setTimeout(observerUpdate, 0);
        });
        observer.observe(target, {
            attributes: typeof options.attributes === "undefined" ? true : options.attributes,
            childList: typeof options.childList === "undefined" ? true : options.childList,
            characterData: typeof options.characterData === "undefined" ? true : options.characterData
        });
        observers.push(observer);
    };
    const init = ()=>{
        if (!swiper.params.observer) return;
        if (swiper.params.observeParents) {
            const containerParents = (0, _utilsMjs.a)(swiper.hostEl);
            for(let i = 0; i < containerParents.length; i += 1)attach(containerParents[i]);
        }
        // Observe container
        attach(swiper.hostEl, {
            childList: swiper.params.observeSlideChildren
        });
        // Observe wrapper
        attach(swiper.wrapperEl, {
            attributes: false
        });
    };
    const destroy = ()=>{
        observers.forEach((observer)=>{
            observer.disconnect();
        });
        observers.splice(0, observers.length);
    };
    extendParams({
        observer: false,
        observeParents: false,
        observeSlideChildren: false
    });
    on("init", init);
    on("destroy", destroy);
}
/* eslint-disable no-underscore-dangle */ var eventsEmitter = {
    on (events, handler, priority) {
        const self = this;
        if (!self.eventsListeners || self.destroyed) return self;
        if (typeof handler !== "function") return self;
        const method = priority ? "unshift" : "push";
        events.split(" ").forEach((event)=>{
            if (!self.eventsListeners[event]) self.eventsListeners[event] = [];
            self.eventsListeners[event][method](handler);
        });
        return self;
    },
    once (events, handler, priority) {
        const self = this;
        if (!self.eventsListeners || self.destroyed) return self;
        if (typeof handler !== "function") return self;
        function onceHandler() {
            self.off(events, onceHandler);
            if (onceHandler.__emitterProxy) delete onceHandler.__emitterProxy;
            for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
            handler.apply(self, args);
        }
        onceHandler.__emitterProxy = handler;
        return self.on(events, onceHandler, priority);
    },
    onAny (handler, priority) {
        const self = this;
        if (!self.eventsListeners || self.destroyed) return self;
        if (typeof handler !== "function") return self;
        const method = priority ? "unshift" : "push";
        if (self.eventsAnyListeners.indexOf(handler) < 0) self.eventsAnyListeners[method](handler);
        return self;
    },
    offAny (handler) {
        const self = this;
        if (!self.eventsListeners || self.destroyed) return self;
        if (!self.eventsAnyListeners) return self;
        const index = self.eventsAnyListeners.indexOf(handler);
        if (index >= 0) self.eventsAnyListeners.splice(index, 1);
        return self;
    },
    off (events, handler) {
        const self = this;
        if (!self.eventsListeners || self.destroyed) return self;
        if (!self.eventsListeners) return self;
        events.split(" ").forEach((event)=>{
            if (typeof handler === "undefined") self.eventsListeners[event] = [];
            else if (self.eventsListeners[event]) self.eventsListeners[event].forEach((eventHandler, index)=>{
                if (eventHandler === handler || eventHandler.__emitterProxy && eventHandler.__emitterProxy === handler) self.eventsListeners[event].splice(index, 1);
            });
        });
        return self;
    },
    emit () {
        const self = this;
        if (!self.eventsListeners || self.destroyed) return self;
        if (!self.eventsListeners) return self;
        let events;
        let data;
        let context;
        for(var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++)args[_key2] = arguments[_key2];
        if (typeof args[0] === "string" || Array.isArray(args[0])) {
            events = args[0];
            data = args.slice(1, args.length);
            context = self;
        } else {
            events = args[0].events;
            data = args[0].data;
            context = args[0].context || self;
        }
        data.unshift(context);
        const eventsArray = Array.isArray(events) ? events : events.split(" ");
        eventsArray.forEach((event)=>{
            if (self.eventsAnyListeners && self.eventsAnyListeners.length) self.eventsAnyListeners.forEach((eventHandler)=>{
                eventHandler.apply(context, [
                    event,
                    ...data
                ]);
            });
            if (self.eventsListeners && self.eventsListeners[event]) self.eventsListeners[event].forEach((eventHandler)=>{
                eventHandler.apply(context, data);
            });
        });
        return self;
    }
};
function updateSize() {
    const swiper = this;
    let width;
    let height;
    const el = swiper.el;
    if (typeof swiper.params.width !== "undefined" && swiper.params.width !== null) width = swiper.params.width;
    else width = el.clientWidth;
    if (typeof swiper.params.height !== "undefined" && swiper.params.height !== null) height = swiper.params.height;
    else height = el.clientHeight;
    if (width === 0 && swiper.isHorizontal() || height === 0 && swiper.isVertical()) return;
    // Subtract paddings
    width = width - parseInt((0, _utilsMjs.m)(el, "padding-left") || 0, 10) - parseInt((0, _utilsMjs.m)(el, "padding-right") || 0, 10);
    height = height - parseInt((0, _utilsMjs.m)(el, "padding-top") || 0, 10) - parseInt((0, _utilsMjs.m)(el, "padding-bottom") || 0, 10);
    if (Number.isNaN(width)) width = 0;
    if (Number.isNaN(height)) height = 0;
    Object.assign(swiper, {
        width,
        height,
        size: swiper.isHorizontal() ? width : height
    });
}
function updateSlides() {
    const swiper = this;
    function getDirectionPropertyValue(node, label) {
        return parseFloat(node.getPropertyValue(swiper.getDirectionLabel(label)) || 0);
    }
    const params = swiper.params;
    const { wrapperEl, slidesEl, size: swiperSize, rtlTranslate: rtl, wrongRTL } = swiper;
    const isVirtual = swiper.virtual && params.virtual.enabled;
    const previousSlidesLength = isVirtual ? swiper.virtual.slides.length : swiper.slides.length;
    const slides = (0, _utilsMjs.e)(slidesEl, `.${swiper.params.slideClass}, swiper-slide`);
    const slidesLength = isVirtual ? swiper.virtual.slides.length : slides.length;
    let snapGrid = [];
    const slidesGrid = [];
    const slidesSizesGrid = [];
    let offsetBefore = params.slidesOffsetBefore;
    if (typeof offsetBefore === "function") offsetBefore = params.slidesOffsetBefore.call(swiper);
    let offsetAfter = params.slidesOffsetAfter;
    if (typeof offsetAfter === "function") offsetAfter = params.slidesOffsetAfter.call(swiper);
    const previousSnapGridLength = swiper.snapGrid.length;
    const previousSlidesGridLength = swiper.slidesGrid.length;
    let spaceBetween = params.spaceBetween;
    let slidePosition = -offsetBefore;
    let prevSlideSize = 0;
    let index = 0;
    if (typeof swiperSize === "undefined") return;
    if (typeof spaceBetween === "string" && spaceBetween.indexOf("%") >= 0) spaceBetween = parseFloat(spaceBetween.replace("%", "")) / 100 * swiperSize;
    else if (typeof spaceBetween === "string") spaceBetween = parseFloat(spaceBetween);
    swiper.virtualSize = -spaceBetween;
    // reset margins
    slides.forEach((slideEl)=>{
        if (rtl) slideEl.style.marginLeft = "";
        else slideEl.style.marginRight = "";
        slideEl.style.marginBottom = "";
        slideEl.style.marginTop = "";
    });
    // reset cssMode offsets
    if (params.centeredSlides && params.cssMode) {
        (0, _utilsMjs.s)(wrapperEl, "--swiper-centered-offset-before", "");
        (0, _utilsMjs.s)(wrapperEl, "--swiper-centered-offset-after", "");
    }
    const gridEnabled = params.grid && params.grid.rows > 1 && swiper.grid;
    if (gridEnabled) swiper.grid.initSlides(slides);
    else if (swiper.grid) swiper.grid.unsetSlides();
    // Calc slides
    let slideSize;
    const shouldResetSlideSize = params.slidesPerView === "auto" && params.breakpoints && Object.keys(params.breakpoints).filter((key)=>{
        return typeof params.breakpoints[key].slidesPerView !== "undefined";
    }).length > 0;
    for(let i = 0; i < slidesLength; i += 1){
        slideSize = 0;
        let slide;
        if (slides[i]) slide = slides[i];
        if (gridEnabled) swiper.grid.updateSlide(i, slide, slides);
        if (slides[i] && (0, _utilsMjs.m)(slide, "display") === "none") continue; // eslint-disable-line
        if (params.slidesPerView === "auto") {
            if (shouldResetSlideSize) slides[i].style[swiper.getDirectionLabel("width")] = ``;
            const slideStyles = getComputedStyle(slide);
            const currentTransform = slide.style.transform;
            const currentWebKitTransform = slide.style.webkitTransform;
            if (currentTransform) slide.style.transform = "none";
            if (currentWebKitTransform) slide.style.webkitTransform = "none";
            if (params.roundLengths) slideSize = swiper.isHorizontal() ? (0, _utilsMjs.f)(slide, "width", true) : (0, _utilsMjs.f)(slide, "height", true);
            else {
                // eslint-disable-next-line
                const width = getDirectionPropertyValue(slideStyles, "width");
                const paddingLeft = getDirectionPropertyValue(slideStyles, "padding-left");
                const paddingRight = getDirectionPropertyValue(slideStyles, "padding-right");
                const marginLeft = getDirectionPropertyValue(slideStyles, "margin-left");
                const marginRight = getDirectionPropertyValue(slideStyles, "margin-right");
                const boxSizing = slideStyles.getPropertyValue("box-sizing");
                if (boxSizing && boxSizing === "border-box") slideSize = width + marginLeft + marginRight;
                else {
                    const { clientWidth, offsetWidth } = slide;
                    slideSize = width + paddingLeft + paddingRight + marginLeft + marginRight + (offsetWidth - clientWidth);
                }
            }
            if (currentTransform) slide.style.transform = currentTransform;
            if (currentWebKitTransform) slide.style.webkitTransform = currentWebKitTransform;
            if (params.roundLengths) slideSize = Math.floor(slideSize);
        } else {
            slideSize = (swiperSize - (params.slidesPerView - 1) * spaceBetween) / params.slidesPerView;
            if (params.roundLengths) slideSize = Math.floor(slideSize);
            if (slides[i]) slides[i].style[swiper.getDirectionLabel("width")] = `${slideSize}px`;
        }
        if (slides[i]) slides[i].swiperSlideSize = slideSize;
        slidesSizesGrid.push(slideSize);
        if (params.centeredSlides) {
            slidePosition = slidePosition + slideSize / 2 + prevSlideSize / 2 + spaceBetween;
            if (prevSlideSize === 0 && i !== 0) slidePosition = slidePosition - swiperSize / 2 - spaceBetween;
            if (i === 0) slidePosition = slidePosition - swiperSize / 2 - spaceBetween;
            if (Math.abs(slidePosition) < 0.001) slidePosition = 0;
            if (params.roundLengths) slidePosition = Math.floor(slidePosition);
            if (index % params.slidesPerGroup === 0) snapGrid.push(slidePosition);
            slidesGrid.push(slidePosition);
        } else {
            if (params.roundLengths) slidePosition = Math.floor(slidePosition);
            if ((index - Math.min(swiper.params.slidesPerGroupSkip, index)) % swiper.params.slidesPerGroup === 0) snapGrid.push(slidePosition);
            slidesGrid.push(slidePosition);
            slidePosition = slidePosition + slideSize + spaceBetween;
        }
        swiper.virtualSize += slideSize + spaceBetween;
        prevSlideSize = slideSize;
        index += 1;
    }
    swiper.virtualSize = Math.max(swiper.virtualSize, swiperSize) + offsetAfter;
    if (rtl && wrongRTL && (params.effect === "slide" || params.effect === "coverflow")) wrapperEl.style.width = `${swiper.virtualSize + spaceBetween}px`;
    if (params.setWrapperSize) wrapperEl.style[swiper.getDirectionLabel("width")] = `${swiper.virtualSize + spaceBetween}px`;
    if (gridEnabled) swiper.grid.updateWrapperSize(slideSize, snapGrid);
    // Remove last grid elements depending on width
    if (!params.centeredSlides) {
        const newSlidesGrid = [];
        for(let i = 0; i < snapGrid.length; i += 1){
            let slidesGridItem = snapGrid[i];
            if (params.roundLengths) slidesGridItem = Math.floor(slidesGridItem);
            if (snapGrid[i] <= swiper.virtualSize - swiperSize) newSlidesGrid.push(slidesGridItem);
        }
        snapGrid = newSlidesGrid;
        if (Math.floor(swiper.virtualSize - swiperSize) - Math.floor(snapGrid[snapGrid.length - 1]) > 1) snapGrid.push(swiper.virtualSize - swiperSize);
    }
    if (isVirtual && params.loop) {
        const size = slidesSizesGrid[0] + spaceBetween;
        if (params.slidesPerGroup > 1) {
            const groups = Math.ceil((swiper.virtual.slidesBefore + swiper.virtual.slidesAfter) / params.slidesPerGroup);
            const groupSize = size * params.slidesPerGroup;
            for(let i = 0; i < groups; i += 1)snapGrid.push(snapGrid[snapGrid.length - 1] + groupSize);
        }
        for(let i = 0; i < swiper.virtual.slidesBefore + swiper.virtual.slidesAfter; i += 1){
            if (params.slidesPerGroup === 1) snapGrid.push(snapGrid[snapGrid.length - 1] + size);
            slidesGrid.push(slidesGrid[slidesGrid.length - 1] + size);
            swiper.virtualSize += size;
        }
    }
    if (snapGrid.length === 0) snapGrid = [
        0
    ];
    if (spaceBetween !== 0) {
        const key = swiper.isHorizontal() && rtl ? "marginLeft" : swiper.getDirectionLabel("marginRight");
        slides.filter((_, slideIndex)=>{
            if (!params.cssMode || params.loop) return true;
            if (slideIndex === slides.length - 1) return false;
            return true;
        }).forEach((slideEl)=>{
            slideEl.style[key] = `${spaceBetween}px`;
        });
    }
    if (params.centeredSlides && params.centeredSlidesBounds) {
        let allSlidesSize = 0;
        slidesSizesGrid.forEach((slideSizeValue)=>{
            allSlidesSize += slideSizeValue + (spaceBetween || 0);
        });
        allSlidesSize -= spaceBetween;
        const maxSnap = allSlidesSize - swiperSize;
        snapGrid = snapGrid.map((snap)=>{
            if (snap <= 0) return -offsetBefore;
            if (snap > maxSnap) return maxSnap + offsetAfter;
            return snap;
        });
    }
    if (params.centerInsufficientSlides) {
        let allSlidesSize = 0;
        slidesSizesGrid.forEach((slideSizeValue)=>{
            allSlidesSize += slideSizeValue + (spaceBetween || 0);
        });
        allSlidesSize -= spaceBetween;
        if (allSlidesSize < swiperSize) {
            const allSlidesOffset = (swiperSize - allSlidesSize) / 2;
            snapGrid.forEach((snap, snapIndex)=>{
                snapGrid[snapIndex] = snap - allSlidesOffset;
            });
            slidesGrid.forEach((snap, snapIndex)=>{
                slidesGrid[snapIndex] = snap + allSlidesOffset;
            });
        }
    }
    Object.assign(swiper, {
        slides,
        snapGrid,
        slidesGrid,
        slidesSizesGrid
    });
    if (params.centeredSlides && params.cssMode && !params.centeredSlidesBounds) {
        (0, _utilsMjs.s)(wrapperEl, "--swiper-centered-offset-before", `${-snapGrid[0]}px`);
        (0, _utilsMjs.s)(wrapperEl, "--swiper-centered-offset-after", `${swiper.size / 2 - slidesSizesGrid[slidesSizesGrid.length - 1] / 2}px`);
        const addToSnapGrid = -swiper.snapGrid[0];
        const addToSlidesGrid = -swiper.slidesGrid[0];
        swiper.snapGrid = swiper.snapGrid.map((v)=>v + addToSnapGrid);
        swiper.slidesGrid = swiper.slidesGrid.map((v)=>v + addToSlidesGrid);
    }
    if (slidesLength !== previousSlidesLength) swiper.emit("slidesLengthChange");
    if (snapGrid.length !== previousSnapGridLength) {
        if (swiper.params.watchOverflow) swiper.checkOverflow();
        swiper.emit("snapGridLengthChange");
    }
    if (slidesGrid.length !== previousSlidesGridLength) swiper.emit("slidesGridLengthChange");
    if (params.watchSlidesProgress) swiper.updateSlidesOffset();
    swiper.emit("slidesUpdated");
    if (!isVirtual && !params.cssMode && (params.effect === "slide" || params.effect === "fade")) {
        const backFaceHiddenClass = `${params.containerModifierClass}backface-hidden`;
        const hasClassBackfaceClassAdded = swiper.el.classList.contains(backFaceHiddenClass);
        if (slidesLength <= params.maxBackfaceHiddenSlides) {
            if (!hasClassBackfaceClassAdded) swiper.el.classList.add(backFaceHiddenClass);
        } else if (hasClassBackfaceClassAdded) swiper.el.classList.remove(backFaceHiddenClass);
    }
}
function updateAutoHeight(speed) {
    const swiper = this;
    const activeSlides = [];
    const isVirtual = swiper.virtual && swiper.params.virtual.enabled;
    let newHeight = 0;
    let i;
    if (typeof speed === "number") swiper.setTransition(speed);
    else if (speed === true) swiper.setTransition(swiper.params.speed);
    const getSlideByIndex = (index)=>{
        if (isVirtual) return swiper.slides[swiper.getSlideIndexByData(index)];
        return swiper.slides[index];
    };
    // Find slides currently in view
    if (swiper.params.slidesPerView !== "auto" && swiper.params.slidesPerView > 1) {
        if (swiper.params.centeredSlides) (swiper.visibleSlides || []).forEach((slide)=>{
            activeSlides.push(slide);
        });
        else for(i = 0; i < Math.ceil(swiper.params.slidesPerView); i += 1){
            const index = swiper.activeIndex + i;
            if (index > swiper.slides.length && !isVirtual) break;
            activeSlides.push(getSlideByIndex(index));
        }
    } else activeSlides.push(getSlideByIndex(swiper.activeIndex));
    // Find new height from highest slide in view
    for(i = 0; i < activeSlides.length; i += 1)if (typeof activeSlides[i] !== "undefined") {
        const height = activeSlides[i].offsetHeight;
        newHeight = height > newHeight ? height : newHeight;
    }
    // Update Height
    if (newHeight || newHeight === 0) swiper.wrapperEl.style.height = `${newHeight}px`;
}
function updateSlidesOffset() {
    const swiper = this;
    const slides = swiper.slides;
    // eslint-disable-next-line
    const minusOffset = swiper.isElement ? swiper.isHorizontal() ? swiper.wrapperEl.offsetLeft : swiper.wrapperEl.offsetTop : 0;
    for(let i = 0; i < slides.length; i += 1)slides[i].swiperSlideOffset = (swiper.isHorizontal() ? slides[i].offsetLeft : slides[i].offsetTop) - minusOffset - swiper.cssOverflowAdjustment();
}
function updateSlidesProgress(translate) {
    if (translate === void 0) translate = this && this.translate || 0;
    const swiper = this;
    const params = swiper.params;
    const { slides, rtlTranslate: rtl, snapGrid } = swiper;
    if (slides.length === 0) return;
    if (typeof slides[0].swiperSlideOffset === "undefined") swiper.updateSlidesOffset();
    let offsetCenter = -translate;
    if (rtl) offsetCenter = translate;
    // Visible Slides
    slides.forEach((slideEl)=>{
        slideEl.classList.remove(params.slideVisibleClass, params.slideFullyVisibleClass);
    });
    swiper.visibleSlidesIndexes = [];
    swiper.visibleSlides = [];
    let spaceBetween = params.spaceBetween;
    if (typeof spaceBetween === "string" && spaceBetween.indexOf("%") >= 0) spaceBetween = parseFloat(spaceBetween.replace("%", "")) / 100 * swiper.size;
    else if (typeof spaceBetween === "string") spaceBetween = parseFloat(spaceBetween);
    for(let i = 0; i < slides.length; i += 1){
        const slide = slides[i];
        let slideOffset = slide.swiperSlideOffset;
        if (params.cssMode && params.centeredSlides) slideOffset -= slides[0].swiperSlideOffset;
        const slideProgress = (offsetCenter + (params.centeredSlides ? swiper.minTranslate() : 0) - slideOffset) / (slide.swiperSlideSize + spaceBetween);
        const originalSlideProgress = (offsetCenter - snapGrid[0] + (params.centeredSlides ? swiper.minTranslate() : 0) - slideOffset) / (slide.swiperSlideSize + spaceBetween);
        const slideBefore = -(offsetCenter - slideOffset);
        const slideAfter = slideBefore + swiper.slidesSizesGrid[i];
        const isFullyVisible = slideBefore >= 0 && slideBefore <= swiper.size - swiper.slidesSizesGrid[i];
        const isVisible = slideBefore >= 0 && slideBefore < swiper.size - 1 || slideAfter > 1 && slideAfter <= swiper.size || slideBefore <= 0 && slideAfter >= swiper.size;
        if (isVisible) {
            swiper.visibleSlides.push(slide);
            swiper.visibleSlidesIndexes.push(i);
            slides[i].classList.add(params.slideVisibleClass);
        }
        if (isFullyVisible) slides[i].classList.add(params.slideFullyVisibleClass);
        slide.progress = rtl ? -slideProgress : slideProgress;
        slide.originalProgress = rtl ? -originalSlideProgress : originalSlideProgress;
    }
}
function updateProgress(translate) {
    const swiper = this;
    if (typeof translate === "undefined") {
        const multiplier = swiper.rtlTranslate ? -1 : 1;
        // eslint-disable-next-line
        translate = swiper && swiper.translate && swiper.translate * multiplier || 0;
    }
    const params = swiper.params;
    const translatesDiff = swiper.maxTranslate() - swiper.minTranslate();
    let { progress, isBeginning, isEnd, progressLoop } = swiper;
    const wasBeginning = isBeginning;
    const wasEnd = isEnd;
    if (translatesDiff === 0) {
        progress = 0;
        isBeginning = true;
        isEnd = true;
    } else {
        progress = (translate - swiper.minTranslate()) / translatesDiff;
        const isBeginningRounded = Math.abs(translate - swiper.minTranslate()) < 1;
        const isEndRounded = Math.abs(translate - swiper.maxTranslate()) < 1;
        isBeginning = isBeginningRounded || progress <= 0;
        isEnd = isEndRounded || progress >= 1;
        if (isBeginningRounded) progress = 0;
        if (isEndRounded) progress = 1;
    }
    if (params.loop) {
        const firstSlideIndex = swiper.getSlideIndexByData(0);
        const lastSlideIndex = swiper.getSlideIndexByData(swiper.slides.length - 1);
        const firstSlideTranslate = swiper.slidesGrid[firstSlideIndex];
        const lastSlideTranslate = swiper.slidesGrid[lastSlideIndex];
        const translateMax = swiper.slidesGrid[swiper.slidesGrid.length - 1];
        const translateAbs = Math.abs(translate);
        if (translateAbs >= firstSlideTranslate) progressLoop = (translateAbs - firstSlideTranslate) / translateMax;
        else progressLoop = (translateAbs + translateMax - lastSlideTranslate) / translateMax;
        if (progressLoop > 1) progressLoop -= 1;
    }
    Object.assign(swiper, {
        progress,
        progressLoop,
        isBeginning,
        isEnd
    });
    if (params.watchSlidesProgress || params.centeredSlides && params.autoHeight) swiper.updateSlidesProgress(translate);
    if (isBeginning && !wasBeginning) swiper.emit("reachBeginning toEdge");
    if (isEnd && !wasEnd) swiper.emit("reachEnd toEdge");
    if (wasBeginning && !isBeginning || wasEnd && !isEnd) swiper.emit("fromEdge");
    swiper.emit("progress", progress);
}
function updateSlidesClasses() {
    const swiper = this;
    const { slides, params, slidesEl, activeIndex } = swiper;
    const isVirtual = swiper.virtual && params.virtual.enabled;
    const gridEnabled = swiper.grid && params.grid && params.grid.rows > 1;
    const getFilteredSlide = (selector)=>{
        return (0, _utilsMjs.e)(slidesEl, `.${params.slideClass}${selector}, swiper-slide${selector}`)[0];
    };
    slides.forEach((slideEl)=>{
        slideEl.classList.remove(params.slideActiveClass, params.slideNextClass, params.slidePrevClass);
    });
    let activeSlide;
    let prevSlide;
    let nextSlide;
    if (isVirtual) {
        if (params.loop) {
            let slideIndex = activeIndex - swiper.virtual.slidesBefore;
            if (slideIndex < 0) slideIndex = swiper.virtual.slides.length + slideIndex;
            if (slideIndex >= swiper.virtual.slides.length) slideIndex -= swiper.virtual.slides.length;
            activeSlide = getFilteredSlide(`[data-swiper-slide-index="${slideIndex}"]`);
        } else activeSlide = getFilteredSlide(`[data-swiper-slide-index="${activeIndex}"]`);
    } else if (gridEnabled) {
        activeSlide = slides.filter((slideEl)=>slideEl.column === activeIndex)[0];
        nextSlide = slides.filter((slideEl)=>slideEl.column === activeIndex + 1)[0];
        prevSlide = slides.filter((slideEl)=>slideEl.column === activeIndex - 1)[0];
    } else activeSlide = slides[activeIndex];
    if (activeSlide) {
        // Active classes
        activeSlide.classList.add(params.slideActiveClass);
        if (gridEnabled) {
            if (nextSlide) nextSlide.classList.add(params.slideNextClass);
            if (prevSlide) prevSlide.classList.add(params.slidePrevClass);
        } else {
            // Next Slide
            nextSlide = (0, _utilsMjs.o)(activeSlide, `.${params.slideClass}, swiper-slide`)[0];
            if (params.loop && !nextSlide) nextSlide = slides[0];
            if (nextSlide) nextSlide.classList.add(params.slideNextClass);
            // Prev Slide
            prevSlide = (0, _utilsMjs.p)(activeSlide, `.${params.slideClass}, swiper-slide`)[0];
            params.loop;
            if (prevSlide) prevSlide.classList.add(params.slidePrevClass);
        }
    }
    swiper.emitSlidesClasses();
}
const processLazyPreloader = (swiper, imageEl)=>{
    if (!swiper || swiper.destroyed || !swiper.params) return;
    const slideSelector = ()=>swiper.isElement ? `swiper-slide` : `.${swiper.params.slideClass}`;
    const slideEl = imageEl.closest(slideSelector());
    if (slideEl) {
        let lazyEl = slideEl.querySelector(`.${swiper.params.lazyPreloaderClass}`);
        if (!lazyEl && swiper.isElement) {
            if (slideEl.shadowRoot) lazyEl = slideEl.shadowRoot.querySelector(`.${swiper.params.lazyPreloaderClass}`);
            else // init later
            requestAnimationFrame(()=>{
                if (slideEl.shadowRoot) {
                    lazyEl = slideEl.shadowRoot.querySelector(`.${swiper.params.lazyPreloaderClass}`);
                    if (lazyEl) lazyEl.remove();
                }
            });
        }
        if (lazyEl) lazyEl.remove();
    }
};
const unlazy = (swiper, index)=>{
    if (!swiper.slides[index]) return;
    const imageEl = swiper.slides[index].querySelector('[loading="lazy"]');
    if (imageEl) imageEl.removeAttribute("loading");
};
const preload = (swiper)=>{
    if (!swiper || swiper.destroyed || !swiper.params) return;
    let amount = swiper.params.lazyPreloadPrevNext;
    const len = swiper.slides.length;
    if (!len || !amount || amount < 0) return;
    amount = Math.min(amount, len);
    const slidesPerView = swiper.params.slidesPerView === "auto" ? swiper.slidesPerViewDynamic() : Math.ceil(swiper.params.slidesPerView);
    const activeIndex = swiper.activeIndex;
    if (swiper.params.grid && swiper.params.grid.rows > 1) {
        const activeColumn = activeIndex;
        const preloadColumns = [
            activeColumn - amount
        ];
        preloadColumns.push(...Array.from({
            length: amount
        }).map((_, i)=>{
            return activeColumn + slidesPerView + i;
        }));
        swiper.slides.forEach((slideEl, i)=>{
            if (preloadColumns.includes(slideEl.column)) unlazy(swiper, i);
        });
        return;
    }
    const slideIndexLastInView = activeIndex + slidesPerView - 1;
    if (swiper.params.rewind || swiper.params.loop) for(let i = activeIndex - amount; i <= slideIndexLastInView + amount; i += 1){
        const realIndex = (i % len + len) % len;
        if (realIndex < activeIndex || realIndex > slideIndexLastInView) unlazy(swiper, realIndex);
    }
    else {
        for(let i = Math.max(activeIndex - amount, 0); i <= Math.min(slideIndexLastInView + amount, len - 1); i += 1)if (i !== activeIndex && (i > slideIndexLastInView || i < activeIndex)) unlazy(swiper, i);
    }
};
function getActiveIndexByTranslate(swiper) {
    const { slidesGrid, params } = swiper;
    const translate = swiper.rtlTranslate ? swiper.translate : -swiper.translate;
    let activeIndex;
    for(let i = 0; i < slidesGrid.length; i += 1){
        if (typeof slidesGrid[i + 1] !== "undefined") {
            if (translate >= slidesGrid[i] && translate < slidesGrid[i + 1] - (slidesGrid[i + 1] - slidesGrid[i]) / 2) activeIndex = i;
            else if (translate >= slidesGrid[i] && translate < slidesGrid[i + 1]) activeIndex = i + 1;
        } else if (translate >= slidesGrid[i]) activeIndex = i;
    }
    // Normalize slideIndex
    if (params.normalizeSlideIndex) {
        if (activeIndex < 0 || typeof activeIndex === "undefined") activeIndex = 0;
    }
    return activeIndex;
}
function updateActiveIndex(newActiveIndex) {
    const swiper = this;
    const translate = swiper.rtlTranslate ? swiper.translate : -swiper.translate;
    const { snapGrid, params, activeIndex: previousIndex, realIndex: previousRealIndex, snapIndex: previousSnapIndex } = swiper;
    let activeIndex = newActiveIndex;
    let snapIndex;
    const getVirtualRealIndex = (aIndex)=>{
        let realIndex = aIndex - swiper.virtual.slidesBefore;
        if (realIndex < 0) realIndex = swiper.virtual.slides.length + realIndex;
        if (realIndex >= swiper.virtual.slides.length) realIndex -= swiper.virtual.slides.length;
        return realIndex;
    };
    if (typeof activeIndex === "undefined") activeIndex = getActiveIndexByTranslate(swiper);
    if (snapGrid.indexOf(translate) >= 0) snapIndex = snapGrid.indexOf(translate);
    else {
        const skip = Math.min(params.slidesPerGroupSkip, activeIndex);
        snapIndex = skip + Math.floor((activeIndex - skip) / params.slidesPerGroup);
    }
    if (snapIndex >= snapGrid.length) snapIndex = snapGrid.length - 1;
    if (activeIndex === previousIndex && !swiper.params.loop) {
        if (snapIndex !== previousSnapIndex) {
            swiper.snapIndex = snapIndex;
            swiper.emit("snapIndexChange");
        }
        return;
    }
    if (activeIndex === previousIndex && swiper.params.loop && swiper.virtual && swiper.params.virtual.enabled) {
        swiper.realIndex = getVirtualRealIndex(activeIndex);
        return;
    }
    const gridEnabled = swiper.grid && params.grid && params.grid.rows > 1;
    // Get real index
    let realIndex;
    if (swiper.virtual && params.virtual.enabled && params.loop) realIndex = getVirtualRealIndex(activeIndex);
    else if (gridEnabled) {
        const firstSlideInColumn = swiper.slides.filter((slideEl)=>slideEl.column === activeIndex)[0];
        let activeSlideIndex = parseInt(firstSlideInColumn.getAttribute("data-swiper-slide-index"), 10);
        if (Number.isNaN(activeSlideIndex)) activeSlideIndex = Math.max(swiper.slides.indexOf(firstSlideInColumn), 0);
        realIndex = Math.floor(activeSlideIndex / params.grid.rows);
    } else if (swiper.slides[activeIndex]) {
        const slideIndex = swiper.slides[activeIndex].getAttribute("data-swiper-slide-index");
        if (slideIndex) realIndex = parseInt(slideIndex, 10);
        else realIndex = activeIndex;
    } else realIndex = activeIndex;
    Object.assign(swiper, {
        previousSnapIndex,
        snapIndex,
        previousRealIndex,
        realIndex,
        previousIndex,
        activeIndex
    });
    if (swiper.initialized) preload(swiper);
    swiper.emit("activeIndexChange");
    swiper.emit("snapIndexChange");
    if (swiper.initialized || swiper.params.runCallbacksOnInit) {
        if (previousRealIndex !== realIndex) swiper.emit("realIndexChange");
        swiper.emit("slideChange");
    }
}
function updateClickedSlide(el, path) {
    const swiper = this;
    const params = swiper.params;
    let slide = el.closest(`.${params.slideClass}, swiper-slide`);
    if (!slide && swiper.isElement && path && path.length > 1 && path.includes(el)) [
        ...path.slice(path.indexOf(el) + 1, path.length)
    ].forEach((pathEl)=>{
        if (!slide && pathEl.matches && pathEl.matches(`.${params.slideClass}, swiper-slide`)) slide = pathEl;
    });
    let slideFound = false;
    let slideIndex;
    if (slide) {
        for(let i = 0; i < swiper.slides.length; i += 1)if (swiper.slides[i] === slide) {
            slideFound = true;
            slideIndex = i;
            break;
        }
    }
    if (slide && slideFound) {
        swiper.clickedSlide = slide;
        if (swiper.virtual && swiper.params.virtual.enabled) swiper.clickedIndex = parseInt(slide.getAttribute("data-swiper-slide-index"), 10);
        else swiper.clickedIndex = slideIndex;
    } else {
        swiper.clickedSlide = undefined;
        swiper.clickedIndex = undefined;
        return;
    }
    if (params.slideToClickedSlide && swiper.clickedIndex !== undefined && swiper.clickedIndex !== swiper.activeIndex) swiper.slideToClickedSlide();
}
var update = {
    updateSize,
    updateSlides,
    updateAutoHeight,
    updateSlidesOffset,
    updateSlidesProgress,
    updateProgress,
    updateSlidesClasses,
    updateActiveIndex,
    updateClickedSlide
};
function getSwiperTranslate(axis) {
    if (axis === void 0) axis = this.isHorizontal() ? "x" : "y";
    const swiper = this;
    const { params, rtlTranslate: rtl, translate, wrapperEl } = swiper;
    if (params.virtualTranslate) return rtl ? -translate : translate;
    if (params.cssMode) return translate;
    let currentTranslate = (0, _utilsMjs.i)(wrapperEl, axis);
    currentTranslate += swiper.cssOverflowAdjustment();
    if (rtl) currentTranslate = -currentTranslate;
    return currentTranslate || 0;
}
function setTranslate(translate, byController) {
    const swiper = this;
    const { rtlTranslate: rtl, params, wrapperEl, progress } = swiper;
    let x = 0;
    let y = 0;
    const z = 0;
    if (swiper.isHorizontal()) x = rtl ? -translate : translate;
    else y = translate;
    if (params.roundLengths) {
        x = Math.floor(x);
        y = Math.floor(y);
    }
    swiper.previousTranslate = swiper.translate;
    swiper.translate = swiper.isHorizontal() ? x : y;
    if (params.cssMode) wrapperEl[swiper.isHorizontal() ? "scrollLeft" : "scrollTop"] = swiper.isHorizontal() ? -x : -y;
    else if (!params.virtualTranslate) {
        if (swiper.isHorizontal()) x -= swiper.cssOverflowAdjustment();
        else y -= swiper.cssOverflowAdjustment();
        wrapperEl.style.transform = `translate3d(${x}px, ${y}px, ${z}px)`;
    }
    // Check if we need to update progress
    let newProgress;
    const translatesDiff = swiper.maxTranslate() - swiper.minTranslate();
    if (translatesDiff === 0) newProgress = 0;
    else newProgress = (translate - swiper.minTranslate()) / translatesDiff;
    if (newProgress !== progress) swiper.updateProgress(translate);
    swiper.emit("setTranslate", swiper.translate, byController);
}
function minTranslate() {
    return -this.snapGrid[0];
}
function maxTranslate() {
    return -this.snapGrid[this.snapGrid.length - 1];
}
function translateTo(translate, speed, runCallbacks, translateBounds, internal) {
    if (translate === void 0) translate = 0;
    if (speed === void 0) speed = this.params.speed;
    if (runCallbacks === void 0) runCallbacks = true;
    if (translateBounds === void 0) translateBounds = true;
    const swiper = this;
    const { params, wrapperEl } = swiper;
    if (swiper.animating && params.preventInteractionOnTransition) return false;
    const minTranslate = swiper.minTranslate();
    const maxTranslate = swiper.maxTranslate();
    let newTranslate;
    if (translateBounds && translate > minTranslate) newTranslate = minTranslate;
    else if (translateBounds && translate < maxTranslate) newTranslate = maxTranslate;
    else newTranslate = translate;
    // Update progress
    swiper.updateProgress(newTranslate);
    if (params.cssMode) {
        const isH = swiper.isHorizontal();
        if (speed === 0) wrapperEl[isH ? "scrollLeft" : "scrollTop"] = -newTranslate;
        else {
            if (!swiper.support.smoothScroll) {
                (0, _utilsMjs.q)({
                    swiper,
                    targetPosition: -newTranslate,
                    side: isH ? "left" : "top"
                });
                return true;
            }
            wrapperEl.scrollTo({
                [isH ? "left" : "top"]: -newTranslate,
                behavior: "smooth"
            });
        }
        return true;
    }
    if (speed === 0) {
        swiper.setTransition(0);
        swiper.setTranslate(newTranslate);
        if (runCallbacks) {
            swiper.emit("beforeTransitionStart", speed, internal);
            swiper.emit("transitionEnd");
        }
    } else {
        swiper.setTransition(speed);
        swiper.setTranslate(newTranslate);
        if (runCallbacks) {
            swiper.emit("beforeTransitionStart", speed, internal);
            swiper.emit("transitionStart");
        }
        if (!swiper.animating) {
            swiper.animating = true;
            if (!swiper.onTranslateToWrapperTransitionEnd) swiper.onTranslateToWrapperTransitionEnd = function transitionEnd(e) {
                if (!swiper || swiper.destroyed) return;
                if (e.target !== this) return;
                swiper.wrapperEl.removeEventListener("transitionend", swiper.onTranslateToWrapperTransitionEnd);
                swiper.onTranslateToWrapperTransitionEnd = null;
                delete swiper.onTranslateToWrapperTransitionEnd;
                if (runCallbacks) swiper.emit("transitionEnd");
            };
            swiper.wrapperEl.addEventListener("transitionend", swiper.onTranslateToWrapperTransitionEnd);
        }
    }
    return true;
}
var translate = {
    getTranslate: getSwiperTranslate,
    setTranslate,
    minTranslate,
    maxTranslate,
    translateTo
};
function setTransition(duration, byController) {
    const swiper = this;
    if (!swiper.params.cssMode) {
        swiper.wrapperEl.style.transitionDuration = `${duration}ms`;
        swiper.wrapperEl.style.transitionDelay = duration === 0 ? `0ms` : "";
    }
    swiper.emit("setTransition", duration, byController);
}
function transitionEmit(_ref) {
    let { swiper, runCallbacks, direction, step } = _ref;
    const { activeIndex, previousIndex } = swiper;
    let dir = direction;
    if (!dir) {
        if (activeIndex > previousIndex) dir = "next";
        else if (activeIndex < previousIndex) dir = "prev";
        else dir = "reset";
    }
    swiper.emit(`transition${step}`);
    if (runCallbacks && activeIndex !== previousIndex) {
        if (dir === "reset") {
            swiper.emit(`slideResetTransition${step}`);
            return;
        }
        swiper.emit(`slideChangeTransition${step}`);
        if (dir === "next") swiper.emit(`slideNextTransition${step}`);
        else swiper.emit(`slidePrevTransition${step}`);
    }
}
function transitionStart(runCallbacks, direction) {
    if (runCallbacks === void 0) runCallbacks = true;
    const swiper = this;
    const { params } = swiper;
    if (params.cssMode) return;
    if (params.autoHeight) swiper.updateAutoHeight();
    transitionEmit({
        swiper,
        runCallbacks,
        direction,
        step: "Start"
    });
}
function transitionEnd(runCallbacks, direction) {
    if (runCallbacks === void 0) runCallbacks = true;
    const swiper = this;
    const { params } = swiper;
    swiper.animating = false;
    if (params.cssMode) return;
    swiper.setTransition(0);
    transitionEmit({
        swiper,
        runCallbacks,
        direction,
        step: "End"
    });
}
var transition = {
    setTransition,
    transitionStart,
    transitionEnd
};
function slideTo(index, speed, runCallbacks, internal, initial) {
    if (index === void 0) index = 0;
    if (speed === void 0) speed = this.params.speed;
    if (runCallbacks === void 0) runCallbacks = true;
    if (typeof index === "string") index = parseInt(index, 10);
    const swiper = this;
    let slideIndex = index;
    if (slideIndex < 0) slideIndex = 0;
    const { params, snapGrid, slidesGrid, previousIndex, activeIndex, rtlTranslate: rtl, wrapperEl, enabled } = swiper;
    if (swiper.animating && params.preventInteractionOnTransition || !enabled && !internal && !initial) return false;
    const skip = Math.min(swiper.params.slidesPerGroupSkip, slideIndex);
    let snapIndex = skip + Math.floor((slideIndex - skip) / swiper.params.slidesPerGroup);
    if (snapIndex >= snapGrid.length) snapIndex = snapGrid.length - 1;
    const translate = -snapGrid[snapIndex];
    // Normalize slideIndex
    if (params.normalizeSlideIndex) for(let i = 0; i < slidesGrid.length; i += 1){
        const normalizedTranslate = -Math.floor(translate * 100);
        const normalizedGrid = Math.floor(slidesGrid[i] * 100);
        const normalizedGridNext = Math.floor(slidesGrid[i + 1] * 100);
        if (typeof slidesGrid[i + 1] !== "undefined") {
            if (normalizedTranslate >= normalizedGrid && normalizedTranslate < normalizedGridNext - (normalizedGridNext - normalizedGrid) / 2) slideIndex = i;
            else if (normalizedTranslate >= normalizedGrid && normalizedTranslate < normalizedGridNext) slideIndex = i + 1;
        } else if (normalizedTranslate >= normalizedGrid) slideIndex = i;
    }
    // Directions locks
    if (swiper.initialized && slideIndex !== activeIndex) {
        if (!swiper.allowSlideNext && (rtl ? translate > swiper.translate && translate > swiper.minTranslate() : translate < swiper.translate && translate < swiper.minTranslate())) return false;
        if (!swiper.allowSlidePrev && translate > swiper.translate && translate > swiper.maxTranslate()) {
            if ((activeIndex || 0) !== slideIndex) return false;
        }
    }
    if (slideIndex !== (previousIndex || 0) && runCallbacks) swiper.emit("beforeSlideChangeStart");
    // Update progress
    swiper.updateProgress(translate);
    let direction;
    if (slideIndex > activeIndex) direction = "next";
    else if (slideIndex < activeIndex) direction = "prev";
    else direction = "reset";
    // Update Index
    if (rtl && -translate === swiper.translate || !rtl && translate === swiper.translate) {
        swiper.updateActiveIndex(slideIndex);
        // Update Height
        if (params.autoHeight) swiper.updateAutoHeight();
        swiper.updateSlidesClasses();
        if (params.effect !== "slide") swiper.setTranslate(translate);
        if (direction !== "reset") {
            swiper.transitionStart(runCallbacks, direction);
            swiper.transitionEnd(runCallbacks, direction);
        }
        return false;
    }
    if (params.cssMode) {
        const isH = swiper.isHorizontal();
        const t = rtl ? translate : -translate;
        if (speed === 0) {
            const isVirtual = swiper.virtual && swiper.params.virtual.enabled;
            if (isVirtual) {
                swiper.wrapperEl.style.scrollSnapType = "none";
                swiper._immediateVirtual = true;
            }
            if (isVirtual && !swiper._cssModeVirtualInitialSet && swiper.params.initialSlide > 0) {
                swiper._cssModeVirtualInitialSet = true;
                requestAnimationFrame(()=>{
                    wrapperEl[isH ? "scrollLeft" : "scrollTop"] = t;
                });
            } else wrapperEl[isH ? "scrollLeft" : "scrollTop"] = t;
            if (isVirtual) requestAnimationFrame(()=>{
                swiper.wrapperEl.style.scrollSnapType = "";
                swiper._immediateVirtual = false;
            });
        } else {
            if (!swiper.support.smoothScroll) {
                (0, _utilsMjs.q)({
                    swiper,
                    targetPosition: t,
                    side: isH ? "left" : "top"
                });
                return true;
            }
            wrapperEl.scrollTo({
                [isH ? "left" : "top"]: t,
                behavior: "smooth"
            });
        }
        return true;
    }
    swiper.setTransition(speed);
    swiper.setTranslate(translate);
    swiper.updateActiveIndex(slideIndex);
    swiper.updateSlidesClasses();
    swiper.emit("beforeTransitionStart", speed, internal);
    swiper.transitionStart(runCallbacks, direction);
    if (speed === 0) swiper.transitionEnd(runCallbacks, direction);
    else if (!swiper.animating) {
        swiper.animating = true;
        if (!swiper.onSlideToWrapperTransitionEnd) swiper.onSlideToWrapperTransitionEnd = function transitionEnd(e) {
            if (!swiper || swiper.destroyed) return;
            if (e.target !== this) return;
            swiper.wrapperEl.removeEventListener("transitionend", swiper.onSlideToWrapperTransitionEnd);
            swiper.onSlideToWrapperTransitionEnd = null;
            delete swiper.onSlideToWrapperTransitionEnd;
            swiper.transitionEnd(runCallbacks, direction);
        };
        swiper.wrapperEl.addEventListener("transitionend", swiper.onSlideToWrapperTransitionEnd);
    }
    return true;
}
function slideToLoop(index, speed, runCallbacks, internal) {
    if (index === void 0) index = 0;
    if (speed === void 0) speed = this.params.speed;
    if (runCallbacks === void 0) runCallbacks = true;
    if (typeof index === "string") {
        const indexAsNumber = parseInt(index, 10);
        index = indexAsNumber;
    }
    const swiper = this;
    const gridEnabled = swiper.grid && swiper.params.grid && swiper.params.grid.rows > 1;
    let newIndex = index;
    if (swiper.params.loop) {
        if (swiper.virtual && swiper.params.virtual.enabled) // eslint-disable-next-line
        newIndex = newIndex + swiper.virtual.slidesBefore;
        else {
            let targetSlideIndex;
            if (gridEnabled) {
                const slideIndex = newIndex * swiper.params.grid.rows;
                targetSlideIndex = swiper.slides.filter((slideEl)=>slideEl.getAttribute("data-swiper-slide-index") * 1 === slideIndex)[0].column;
            } else targetSlideIndex = swiper.getSlideIndexByData(newIndex);
            const cols = gridEnabled ? Math.ceil(swiper.slides.length / swiper.params.grid.rows) : swiper.slides.length;
            const { centeredSlides } = swiper.params;
            let slidesPerView = swiper.params.slidesPerView;
            if (slidesPerView === "auto") slidesPerView = swiper.slidesPerViewDynamic();
            else {
                slidesPerView = Math.ceil(parseFloat(swiper.params.slidesPerView, 10));
                if (centeredSlides && slidesPerView % 2 === 0) slidesPerView = slidesPerView + 1;
            }
            let needLoopFix = cols - targetSlideIndex < slidesPerView;
            if (centeredSlides) needLoopFix = needLoopFix || targetSlideIndex < Math.ceil(slidesPerView / 2);
            if (needLoopFix) {
                const direction = centeredSlides ? targetSlideIndex < swiper.activeIndex ? "prev" : "next" : targetSlideIndex - swiper.activeIndex - 1 < swiper.params.slidesPerView ? "next" : "prev";
                swiper.loopFix({
                    direction,
                    slideTo: true,
                    activeSlideIndex: direction === "next" ? targetSlideIndex + 1 : targetSlideIndex - cols + 1,
                    slideRealIndex: direction === "next" ? swiper.realIndex : undefined
                });
            }
            if (gridEnabled) {
                const slideIndex = newIndex * swiper.params.grid.rows;
                newIndex = swiper.slides.filter((slideEl)=>slideEl.getAttribute("data-swiper-slide-index") * 1 === slideIndex)[0].column;
            } else newIndex = swiper.getSlideIndexByData(newIndex);
        }
    }
    requestAnimationFrame(()=>{
        swiper.slideTo(newIndex, speed, runCallbacks, internal);
    });
    return swiper;
}
/* eslint no-unused-vars: "off" */ function slideNext(speed, runCallbacks, internal) {
    if (speed === void 0) speed = this.params.speed;
    if (runCallbacks === void 0) runCallbacks = true;
    const swiper = this;
    const { enabled, params, animating } = swiper;
    if (!enabled) return swiper;
    let perGroup = params.slidesPerGroup;
    if (params.slidesPerView === "auto" && params.slidesPerGroup === 1 && params.slidesPerGroupAuto) perGroup = Math.max(swiper.slidesPerViewDynamic("current", true), 1);
    const increment = swiper.activeIndex < params.slidesPerGroupSkip ? 1 : perGroup;
    const isVirtual = swiper.virtual && params.virtual.enabled;
    if (params.loop) {
        if (animating && !isVirtual && params.loopPreventsSliding) return false;
        swiper.loopFix({
            direction: "next"
        });
        // eslint-disable-next-line
        swiper._clientLeft = swiper.wrapperEl.clientLeft;
        if (swiper.activeIndex === swiper.slides.length - 1 && params.cssMode) {
            requestAnimationFrame(()=>{
                swiper.slideTo(swiper.activeIndex + increment, speed, runCallbacks, internal);
            });
            return true;
        }
    }
    if (params.rewind && swiper.isEnd) return swiper.slideTo(0, speed, runCallbacks, internal);
    return swiper.slideTo(swiper.activeIndex + increment, speed, runCallbacks, internal);
}
/* eslint no-unused-vars: "off" */ function slidePrev(speed, runCallbacks, internal) {
    if (speed === void 0) speed = this.params.speed;
    if (runCallbacks === void 0) runCallbacks = true;
    const swiper = this;
    const { params, snapGrid, slidesGrid, rtlTranslate, enabled, animating } = swiper;
    if (!enabled) return swiper;
    const isVirtual = swiper.virtual && params.virtual.enabled;
    if (params.loop) {
        if (animating && !isVirtual && params.loopPreventsSliding) return false;
        swiper.loopFix({
            direction: "prev"
        });
        // eslint-disable-next-line
        swiper._clientLeft = swiper.wrapperEl.clientLeft;
    }
    const translate = rtlTranslate ? swiper.translate : -swiper.translate;
    function normalize(val) {
        if (val < 0) return -Math.floor(Math.abs(val));
        return Math.floor(val);
    }
    const normalizedTranslate = normalize(translate);
    const normalizedSnapGrid = snapGrid.map((val)=>normalize(val));
    let prevSnap = snapGrid[normalizedSnapGrid.indexOf(normalizedTranslate) - 1];
    if (typeof prevSnap === "undefined" && params.cssMode) {
        let prevSnapIndex;
        snapGrid.forEach((snap, snapIndex)=>{
            if (normalizedTranslate >= snap) // prevSnap = snap;
            prevSnapIndex = snapIndex;
        });
        if (typeof prevSnapIndex !== "undefined") prevSnap = snapGrid[prevSnapIndex > 0 ? prevSnapIndex - 1 : prevSnapIndex];
    }
    let prevIndex = 0;
    if (typeof prevSnap !== "undefined") {
        prevIndex = slidesGrid.indexOf(prevSnap);
        if (prevIndex < 0) prevIndex = swiper.activeIndex - 1;
        if (params.slidesPerView === "auto" && params.slidesPerGroup === 1 && params.slidesPerGroupAuto) {
            prevIndex = prevIndex - swiper.slidesPerViewDynamic("previous", true) + 1;
            prevIndex = Math.max(prevIndex, 0);
        }
    }
    if (params.rewind && swiper.isBeginning) {
        const lastIndex = swiper.params.virtual && swiper.params.virtual.enabled && swiper.virtual ? swiper.virtual.slides.length - 1 : swiper.slides.length - 1;
        return swiper.slideTo(lastIndex, speed, runCallbacks, internal);
    } else if (params.loop && swiper.activeIndex === 0 && params.cssMode) {
        requestAnimationFrame(()=>{
            swiper.slideTo(prevIndex, speed, runCallbacks, internal);
        });
        return true;
    }
    return swiper.slideTo(prevIndex, speed, runCallbacks, internal);
}
/* eslint no-unused-vars: "off" */ function slideReset(speed, runCallbacks, internal) {
    if (speed === void 0) speed = this.params.speed;
    if (runCallbacks === void 0) runCallbacks = true;
    const swiper = this;
    return swiper.slideTo(swiper.activeIndex, speed, runCallbacks, internal);
}
/* eslint no-unused-vars: "off" */ function slideToClosest(speed, runCallbacks, internal, threshold) {
    if (speed === void 0) speed = this.params.speed;
    if (runCallbacks === void 0) runCallbacks = true;
    if (threshold === void 0) threshold = 0.5;
    const swiper = this;
    let index = swiper.activeIndex;
    const skip = Math.min(swiper.params.slidesPerGroupSkip, index);
    const snapIndex = skip + Math.floor((index - skip) / swiper.params.slidesPerGroup);
    const translate = swiper.rtlTranslate ? swiper.translate : -swiper.translate;
    if (translate >= swiper.snapGrid[snapIndex]) {
        // The current translate is on or after the current snap index, so the choice
        // is between the current index and the one after it.
        const currentSnap = swiper.snapGrid[snapIndex];
        const nextSnap = swiper.snapGrid[snapIndex + 1];
        if (translate - currentSnap > (nextSnap - currentSnap) * threshold) index += swiper.params.slidesPerGroup;
    } else {
        // The current translate is before the current snap index, so the choice
        // is between the current index and the one before it.
        const prevSnap = swiper.snapGrid[snapIndex - 1];
        const currentSnap = swiper.snapGrid[snapIndex];
        if (translate - prevSnap <= (currentSnap - prevSnap) * threshold) index -= swiper.params.slidesPerGroup;
    }
    index = Math.max(index, 0);
    index = Math.min(index, swiper.slidesGrid.length - 1);
    return swiper.slideTo(index, speed, runCallbacks, internal);
}
function slideToClickedSlide() {
    const swiper = this;
    const { params, slidesEl } = swiper;
    const slidesPerView = params.slidesPerView === "auto" ? swiper.slidesPerViewDynamic() : params.slidesPerView;
    let slideToIndex = swiper.clickedIndex;
    let realIndex;
    const slideSelector = swiper.isElement ? `swiper-slide` : `.${params.slideClass}`;
    if (params.loop) {
        if (swiper.animating) return;
        realIndex = parseInt(swiper.clickedSlide.getAttribute("data-swiper-slide-index"), 10);
        if (params.centeredSlides) {
            if (slideToIndex < swiper.loopedSlides - slidesPerView / 2 || slideToIndex > swiper.slides.length - swiper.loopedSlides + slidesPerView / 2) {
                swiper.loopFix();
                slideToIndex = swiper.getSlideIndex((0, _utilsMjs.e)(slidesEl, `${slideSelector}[data-swiper-slide-index="${realIndex}"]`)[0]);
                (0, _utilsMjs.n)(()=>{
                    swiper.slideTo(slideToIndex);
                });
            } else swiper.slideTo(slideToIndex);
        } else if (slideToIndex > swiper.slides.length - slidesPerView) {
            swiper.loopFix();
            slideToIndex = swiper.getSlideIndex((0, _utilsMjs.e)(slidesEl, `${slideSelector}[data-swiper-slide-index="${realIndex}"]`)[0]);
            (0, _utilsMjs.n)(()=>{
                swiper.slideTo(slideToIndex);
            });
        } else swiper.slideTo(slideToIndex);
    } else swiper.slideTo(slideToIndex);
}
var slide = {
    slideTo,
    slideToLoop,
    slideNext,
    slidePrev,
    slideReset,
    slideToClosest,
    slideToClickedSlide
};
function loopCreate(slideRealIndex) {
    const swiper = this;
    const { params, slidesEl } = swiper;
    if (!params.loop || swiper.virtual && swiper.params.virtual.enabled) return;
    const initSlides = ()=>{
        const slides = (0, _utilsMjs.e)(slidesEl, `.${params.slideClass}, swiper-slide`);
        slides.forEach((el, index)=>{
            el.setAttribute("data-swiper-slide-index", index);
        });
    };
    const gridEnabled = swiper.grid && params.grid && params.grid.rows > 1;
    const slidesPerGroup = params.slidesPerGroup * (gridEnabled ? params.grid.rows : 1);
    const shouldFillGroup = swiper.slides.length % slidesPerGroup !== 0;
    const shouldFillGrid = gridEnabled && swiper.slides.length % params.grid.rows !== 0;
    const addBlankSlides = (amountOfSlides)=>{
        for(let i = 0; i < amountOfSlides; i += 1){
            const slideEl = swiper.isElement ? (0, _utilsMjs.c)("swiper-slide", [
                params.slideBlankClass
            ]) : (0, _utilsMjs.c)("div", [
                params.slideClass,
                params.slideBlankClass
            ]);
            swiper.slidesEl.append(slideEl);
        }
    };
    if (shouldFillGroup) {
        if (params.loopAddBlankSlides) {
            const slidesToAdd = slidesPerGroup - swiper.slides.length % slidesPerGroup;
            addBlankSlides(slidesToAdd);
            swiper.recalcSlides();
            swiper.updateSlides();
        } else (0, _utilsMjs.r)("Swiper Loop Warning: The number of slides is not even to slidesPerGroup, loop mode may not function properly. You need to add more slides (or make duplicates, or empty slides)");
        initSlides();
    } else if (shouldFillGrid) {
        if (params.loopAddBlankSlides) {
            const slidesToAdd = params.grid.rows - swiper.slides.length % params.grid.rows;
            addBlankSlides(slidesToAdd);
            swiper.recalcSlides();
            swiper.updateSlides();
        } else (0, _utilsMjs.r)("Swiper Loop Warning: The number of slides is not even to grid.rows, loop mode may not function properly. You need to add more slides (or make duplicates, or empty slides)");
        initSlides();
    } else initSlides();
    swiper.loopFix({
        slideRealIndex,
        direction: params.centeredSlides ? undefined : "next"
    });
}
function loopFix(_temp) {
    let { slideRealIndex, slideTo = true, direction, setTranslate, activeSlideIndex, byController, byMousewheel } = _temp === void 0 ? {} : _temp;
    const swiper = this;
    if (!swiper.params.loop) return;
    swiper.emit("beforeLoopFix");
    const { slides, allowSlidePrev, allowSlideNext, slidesEl, params } = swiper;
    const { centeredSlides } = params;
    swiper.allowSlidePrev = true;
    swiper.allowSlideNext = true;
    if (swiper.virtual && params.virtual.enabled) {
        if (slideTo) {
            if (!params.centeredSlides && swiper.snapIndex === 0) swiper.slideTo(swiper.virtual.slides.length, 0, false, true);
            else if (params.centeredSlides && swiper.snapIndex < params.slidesPerView) swiper.slideTo(swiper.virtual.slides.length + swiper.snapIndex, 0, false, true);
            else if (swiper.snapIndex === swiper.snapGrid.length - 1) swiper.slideTo(swiper.virtual.slidesBefore, 0, false, true);
        }
        swiper.allowSlidePrev = allowSlidePrev;
        swiper.allowSlideNext = allowSlideNext;
        swiper.emit("loopFix");
        return;
    }
    let slidesPerView = params.slidesPerView;
    if (slidesPerView === "auto") slidesPerView = swiper.slidesPerViewDynamic();
    else {
        slidesPerView = Math.ceil(parseFloat(params.slidesPerView, 10));
        if (centeredSlides && slidesPerView % 2 === 0) slidesPerView = slidesPerView + 1;
    }
    const slidesPerGroup = params.slidesPerGroupAuto ? slidesPerView : params.slidesPerGroup;
    let loopedSlides = slidesPerGroup;
    if (loopedSlides % slidesPerGroup !== 0) loopedSlides += slidesPerGroup - loopedSlides % slidesPerGroup;
    loopedSlides += params.loopAdditionalSlides;
    swiper.loopedSlides = loopedSlides;
    const gridEnabled = swiper.grid && params.grid && params.grid.rows > 1;
    if (slides.length < slidesPerView + loopedSlides) (0, _utilsMjs.r)("Swiper Loop Warning: The number of slides is not enough for loop mode, it will be disabled and not function properly. You need to add more slides (or make duplicates) or lower the values of slidesPerView and slidesPerGroup parameters");
    else if (gridEnabled && params.grid.fill === "row") (0, _utilsMjs.r)("Swiper Loop Warning: Loop mode is not compatible with grid.fill = `row`");
    const prependSlidesIndexes = [];
    const appendSlidesIndexes = [];
    let activeIndex = swiper.activeIndex;
    if (typeof activeSlideIndex === "undefined") activeSlideIndex = swiper.getSlideIndex(slides.filter((el)=>el.classList.contains(params.slideActiveClass))[0]);
    else activeIndex = activeSlideIndex;
    const isNext = direction === "next" || !direction;
    const isPrev = direction === "prev" || !direction;
    let slidesPrepended = 0;
    let slidesAppended = 0;
    const cols = gridEnabled ? Math.ceil(slides.length / params.grid.rows) : slides.length;
    const activeColIndex = gridEnabled ? slides[activeSlideIndex].column : activeSlideIndex;
    const activeColIndexWithShift = activeColIndex + (centeredSlides && typeof setTranslate === "undefined" ? -slidesPerView / 2 + 0.5 : 0);
    // prepend last slides before start
    if (activeColIndexWithShift < loopedSlides) {
        slidesPrepended = Math.max(loopedSlides - activeColIndexWithShift, slidesPerGroup);
        for(let i = 0; i < loopedSlides - activeColIndexWithShift; i += 1){
            const index = i - Math.floor(i / cols) * cols;
            if (gridEnabled) {
                const colIndexToPrepend = cols - index - 1;
                for(let i = slides.length - 1; i >= 0; i -= 1)if (slides[i].column === colIndexToPrepend) prependSlidesIndexes.push(i);
            // slides.forEach((slide, slideIndex) => {
            //   if (slide.column === colIndexToPrepend) prependSlidesIndexes.push(slideIndex);
            // });
            } else prependSlidesIndexes.push(cols - index - 1);
        }
    } else if (activeColIndexWithShift + slidesPerView > cols - loopedSlides) {
        slidesAppended = Math.max(activeColIndexWithShift - (cols - loopedSlides * 2), slidesPerGroup);
        for(let i = 0; i < slidesAppended; i += 1){
            const index = i - Math.floor(i / cols) * cols;
            if (gridEnabled) slides.forEach((slide, slideIndex)=>{
                if (slide.column === index) appendSlidesIndexes.push(slideIndex);
            });
            else appendSlidesIndexes.push(index);
        }
    }
    swiper.__preventObserver__ = true;
    requestAnimationFrame(()=>{
        swiper.__preventObserver__ = false;
    });
    if (isPrev) prependSlidesIndexes.forEach((index)=>{
        slides[index].swiperLoopMoveDOM = true;
        slidesEl.prepend(slides[index]);
        slides[index].swiperLoopMoveDOM = false;
    });
    if (isNext) appendSlidesIndexes.forEach((index)=>{
        slides[index].swiperLoopMoveDOM = true;
        slidesEl.append(slides[index]);
        slides[index].swiperLoopMoveDOM = false;
    });
    swiper.recalcSlides();
    if (params.slidesPerView === "auto") swiper.updateSlides();
    else if (gridEnabled && (prependSlidesIndexes.length > 0 && isPrev || appendSlidesIndexes.length > 0 && isNext)) swiper.slides.forEach((slide, slideIndex)=>{
        swiper.grid.updateSlide(slideIndex, slide, swiper.slides);
    });
    if (params.watchSlidesProgress) swiper.updateSlidesOffset();
    if (slideTo) {
        if (prependSlidesIndexes.length > 0 && isPrev) {
            if (typeof slideRealIndex === "undefined") {
                const currentSlideTranslate = swiper.slidesGrid[activeIndex];
                const newSlideTranslate = swiper.slidesGrid[activeIndex + slidesPrepended];
                const diff = newSlideTranslate - currentSlideTranslate;
                if (byMousewheel) swiper.setTranslate(swiper.translate - diff);
                else {
                    swiper.slideTo(activeIndex + slidesPrepended, 0, false, true);
                    if (setTranslate) {
                        swiper.touchEventsData.startTranslate = swiper.touchEventsData.startTranslate - diff;
                        swiper.touchEventsData.currentTranslate = swiper.touchEventsData.currentTranslate - diff;
                    }
                }
            } else if (setTranslate) {
                const shift = gridEnabled ? prependSlidesIndexes.length / params.grid.rows : prependSlidesIndexes.length;
                swiper.slideTo(swiper.activeIndex + shift, 0, false, true);
                swiper.touchEventsData.currentTranslate = swiper.translate;
            }
        } else if (appendSlidesIndexes.length > 0 && isNext) {
            if (typeof slideRealIndex === "undefined") {
                const currentSlideTranslate = swiper.slidesGrid[activeIndex];
                const newSlideTranslate = swiper.slidesGrid[activeIndex - slidesAppended];
                const diff = newSlideTranslate - currentSlideTranslate;
                if (byMousewheel) swiper.setTranslate(swiper.translate - diff);
                else {
                    swiper.slideTo(activeIndex - slidesAppended, 0, false, true);
                    if (setTranslate) {
                        swiper.touchEventsData.startTranslate = swiper.touchEventsData.startTranslate - diff;
                        swiper.touchEventsData.currentTranslate = swiper.touchEventsData.currentTranslate - diff;
                    }
                }
            } else {
                const shift = gridEnabled ? appendSlidesIndexes.length / params.grid.rows : appendSlidesIndexes.length;
                swiper.slideTo(swiper.activeIndex - shift, 0, false, true);
            }
        }
    }
    swiper.allowSlidePrev = allowSlidePrev;
    swiper.allowSlideNext = allowSlideNext;
    if (swiper.controller && swiper.controller.control && !byController) {
        const loopParams = {
            slideRealIndex,
            direction,
            setTranslate,
            activeSlideIndex,
            byController: true
        };
        if (Array.isArray(swiper.controller.control)) swiper.controller.control.forEach((c)=>{
            if (!c.destroyed && c.params.loop) c.loopFix({
                ...loopParams,
                slideTo: c.params.slidesPerView === params.slidesPerView ? slideTo : false
            });
        });
        else if (swiper.controller.control instanceof swiper.constructor && swiper.controller.control.params.loop) swiper.controller.control.loopFix({
            ...loopParams,
            slideTo: swiper.controller.control.params.slidesPerView === params.slidesPerView ? slideTo : false
        });
    }
    swiper.emit("loopFix");
}
function loopDestroy() {
    const swiper = this;
    const { params, slidesEl } = swiper;
    if (!params.loop || swiper.virtual && swiper.params.virtual.enabled) return;
    swiper.recalcSlides();
    const newSlidesOrder = [];
    swiper.slides.forEach((slideEl)=>{
        const index = typeof slideEl.swiperSlideIndex === "undefined" ? slideEl.getAttribute("data-swiper-slide-index") * 1 : slideEl.swiperSlideIndex;
        newSlidesOrder[index] = slideEl;
    });
    swiper.slides.forEach((slideEl)=>{
        slideEl.removeAttribute("data-swiper-slide-index");
    });
    newSlidesOrder.forEach((slideEl)=>{
        slidesEl.append(slideEl);
    });
    swiper.recalcSlides();
    swiper.slideTo(swiper.realIndex, 0);
}
var loop = {
    loopCreate,
    loopFix,
    loopDestroy
};
function setGrabCursor(moving) {
    const swiper = this;
    if (!swiper.params.simulateTouch || swiper.params.watchOverflow && swiper.isLocked || swiper.params.cssMode) return;
    const el = swiper.params.touchEventsTarget === "container" ? swiper.el : swiper.wrapperEl;
    if (swiper.isElement) swiper.__preventObserver__ = true;
    el.style.cursor = "move";
    el.style.cursor = moving ? "grabbing" : "grab";
    if (swiper.isElement) requestAnimationFrame(()=>{
        swiper.__preventObserver__ = false;
    });
}
function unsetGrabCursor() {
    const swiper = this;
    if (swiper.params.watchOverflow && swiper.isLocked || swiper.params.cssMode) return;
    if (swiper.isElement) swiper.__preventObserver__ = true;
    swiper[swiper.params.touchEventsTarget === "container" ? "el" : "wrapperEl"].style.cursor = "";
    if (swiper.isElement) requestAnimationFrame(()=>{
        swiper.__preventObserver__ = false;
    });
}
var grabCursor = {
    setGrabCursor,
    unsetGrabCursor
};
// Modified from https://stackoverflow.com/questions/54520554/custom-element-getrootnode-closest-function-crossing-multiple-parent-shadowd
function closestElement(selector, base) {
    if (base === void 0) base = this;
    function __closestFrom(el) {
        if (!el || el === (0, _ssrWindowEsmMjs.g)() || el === (0, _ssrWindowEsmMjs.a)()) return null;
        if (el.assignedSlot) el = el.assignedSlot;
        const found = el.closest(selector);
        if (!found && !el.getRootNode) return null;
        return found || __closestFrom(el.getRootNode().host);
    }
    return __closestFrom(base);
}
function preventEdgeSwipe(swiper, event, startX) {
    const window1 = (0, _ssrWindowEsmMjs.a)();
    const { params } = swiper;
    const edgeSwipeDetection = params.edgeSwipeDetection;
    const edgeSwipeThreshold = params.edgeSwipeThreshold;
    if (edgeSwipeDetection && (startX <= edgeSwipeThreshold || startX >= window1.innerWidth - edgeSwipeThreshold)) {
        if (edgeSwipeDetection === "prevent") {
            event.preventDefault();
            return true;
        }
        return false;
    }
    return true;
}
function onTouchStart(event) {
    const swiper = this;
    const document1 = (0, _ssrWindowEsmMjs.g)();
    let e = event;
    if (e.originalEvent) e = e.originalEvent;
    const data = swiper.touchEventsData;
    if (e.type === "pointerdown") {
        if (data.pointerId !== null && data.pointerId !== e.pointerId) return;
        data.pointerId = e.pointerId;
    } else if (e.type === "touchstart" && e.targetTouches.length === 1) data.touchId = e.targetTouches[0].identifier;
    if (e.type === "touchstart") {
        // don't proceed touch event
        preventEdgeSwipe(swiper, e, e.targetTouches[0].pageX);
        return;
    }
    const { params, touches, enabled } = swiper;
    if (!enabled) return;
    if (!params.simulateTouch && e.pointerType === "mouse") return;
    if (swiper.animating && params.preventInteractionOnTransition) return;
    if (!swiper.animating && params.cssMode && params.loop) swiper.loopFix();
    let targetEl = e.target;
    if (params.touchEventsTarget === "wrapper") {
        if (!swiper.wrapperEl.contains(targetEl)) return;
    }
    if ("which" in e && e.which === 3) return;
    if ("button" in e && e.button > 0) return;
    if (data.isTouched && data.isMoved) return;
    // change target el for shadow root component
    const swipingClassHasValue = !!params.noSwipingClass && params.noSwipingClass !== "";
    // eslint-disable-next-line
    const eventPath = e.composedPath ? e.composedPath() : e.path;
    if (swipingClassHasValue && e.target && e.target.shadowRoot && eventPath) targetEl = eventPath[0];
    const noSwipingSelector = params.noSwipingSelector ? params.noSwipingSelector : `.${params.noSwipingClass}`;
    const isTargetShadow = !!(e.target && e.target.shadowRoot);
    // use closestElement for shadow root element to get the actual closest for nested shadow root element
    if (params.noSwiping && (isTargetShadow ? closestElement(noSwipingSelector, targetEl) : targetEl.closest(noSwipingSelector))) {
        swiper.allowClick = true;
        return;
    }
    if (params.swipeHandler) {
        if (!targetEl.closest(params.swipeHandler)) return;
    }
    touches.currentX = e.pageX;
    touches.currentY = e.pageY;
    const startX = touches.currentX;
    const startY = touches.currentY;
    // Do NOT start if iOS edge swipe is detected. Otherwise iOS app cannot swipe-to-go-back anymore
    if (!preventEdgeSwipe(swiper, e, startX)) return;
    Object.assign(data, {
        isTouched: true,
        isMoved: false,
        allowTouchCallbacks: true,
        isScrolling: undefined,
        startMoving: undefined
    });
    touches.startX = startX;
    touches.startY = startY;
    data.touchStartTime = (0, _utilsMjs.d)();
    swiper.allowClick = true;
    swiper.updateSize();
    swiper.swipeDirection = undefined;
    if (params.threshold > 0) data.allowThresholdMove = false;
    let preventDefault = true;
    if (targetEl.matches(data.focusableElements)) {
        preventDefault = false;
        if (targetEl.nodeName === "SELECT") data.isTouched = false;
    }
    if (document1.activeElement && document1.activeElement.matches(data.focusableElements) && document1.activeElement !== targetEl) document1.activeElement.blur();
    const shouldPreventDefault = preventDefault && swiper.allowTouchMove && params.touchStartPreventDefault;
    if ((params.touchStartForcePreventDefault || shouldPreventDefault) && !targetEl.isContentEditable) e.preventDefault();
    if (params.freeMode && params.freeMode.enabled && swiper.freeMode && swiper.animating && !params.cssMode) swiper.freeMode.onTouchStart();
    swiper.emit("touchStart", e);
}
function onTouchMove(event) {
    const document1 = (0, _ssrWindowEsmMjs.g)();
    const swiper = this;
    const data = swiper.touchEventsData;
    const { params, touches, rtlTranslate: rtl, enabled } = swiper;
    if (!enabled) return;
    if (!params.simulateTouch && event.pointerType === "mouse") return;
    let e = event;
    if (e.originalEvent) e = e.originalEvent;
    if (e.type === "pointermove") {
        if (data.touchId !== null) return; // return from pointer if we use touch
        const id = e.pointerId;
        if (id !== data.pointerId) return;
    }
    let targetTouch;
    if (e.type === "touchmove") {
        targetTouch = [
            ...e.changedTouches
        ].filter((t)=>t.identifier === data.touchId)[0];
        if (!targetTouch || targetTouch.identifier !== data.touchId) return;
    } else targetTouch = e;
    if (!data.isTouched) {
        if (data.startMoving && data.isScrolling) swiper.emit("touchMoveOpposite", e);
        return;
    }
    const pageX = targetTouch.pageX;
    const pageY = targetTouch.pageY;
    if (e.preventedByNestedSwiper) {
        touches.startX = pageX;
        touches.startY = pageY;
        return;
    }
    if (!swiper.allowTouchMove) {
        if (!e.target.matches(data.focusableElements)) swiper.allowClick = false;
        if (data.isTouched) {
            Object.assign(touches, {
                startX: pageX,
                startY: pageY,
                currentX: pageX,
                currentY: pageY
            });
            data.touchStartTime = (0, _utilsMjs.d)();
        }
        return;
    }
    if (params.touchReleaseOnEdges && !params.loop) {
        if (swiper.isVertical()) // Vertical
        {
            if (pageY < touches.startY && swiper.translate <= swiper.maxTranslate() || pageY > touches.startY && swiper.translate >= swiper.minTranslate()) {
                data.isTouched = false;
                data.isMoved = false;
                return;
            }
        } else if (pageX < touches.startX && swiper.translate <= swiper.maxTranslate() || pageX > touches.startX && swiper.translate >= swiper.minTranslate()) return;
    }
    if (document1.activeElement) {
        if (e.target === document1.activeElement && e.target.matches(data.focusableElements)) {
            data.isMoved = true;
            swiper.allowClick = false;
            return;
        }
    }
    if (data.allowTouchCallbacks) swiper.emit("touchMove", e);
    touches.previousX = touches.currentX;
    touches.previousY = touches.currentY;
    touches.currentX = pageX;
    touches.currentY = pageY;
    const diffX = touches.currentX - touches.startX;
    const diffY = touches.currentY - touches.startY;
    if (swiper.params.threshold && Math.sqrt(diffX ** 2 + diffY ** 2) < swiper.params.threshold) return;
    if (typeof data.isScrolling === "undefined") {
        let touchAngle;
        if (swiper.isHorizontal() && touches.currentY === touches.startY || swiper.isVertical() && touches.currentX === touches.startX) data.isScrolling = false;
        else // eslint-disable-next-line
        if (diffX * diffX + diffY * diffY >= 25) {
            touchAngle = Math.atan2(Math.abs(diffY), Math.abs(diffX)) * 180 / Math.PI;
            data.isScrolling = swiper.isHorizontal() ? touchAngle > params.touchAngle : 90 - touchAngle > params.touchAngle;
        }
    }
    if (data.isScrolling) swiper.emit("touchMoveOpposite", e);
    if (typeof data.startMoving === "undefined") {
        if (touches.currentX !== touches.startX || touches.currentY !== touches.startY) data.startMoving = true;
    }
    if (data.isScrolling) {
        data.isTouched = false;
        return;
    }
    if (!data.startMoving) return;
    swiper.allowClick = false;
    if (!params.cssMode && e.cancelable) e.preventDefault();
    if (params.touchMoveStopPropagation && !params.nested) e.stopPropagation();
    let diff = swiper.isHorizontal() ? diffX : diffY;
    let touchesDiff = swiper.isHorizontal() ? touches.currentX - touches.previousX : touches.currentY - touches.previousY;
    if (params.oneWayMovement) {
        diff = Math.abs(diff) * (rtl ? 1 : -1);
        touchesDiff = Math.abs(touchesDiff) * (rtl ? 1 : -1);
    }
    touches.diff = diff;
    diff *= params.touchRatio;
    if (rtl) {
        diff = -diff;
        touchesDiff = -touchesDiff;
    }
    const prevTouchesDirection = swiper.touchesDirection;
    swiper.swipeDirection = diff > 0 ? "prev" : "next";
    swiper.touchesDirection = touchesDiff > 0 ? "prev" : "next";
    const isLoop = swiper.params.loop && !params.cssMode;
    const allowLoopFix = swiper.touchesDirection === "next" && swiper.allowSlideNext || swiper.touchesDirection === "prev" && swiper.allowSlidePrev;
    if (!data.isMoved) {
        if (isLoop && allowLoopFix) swiper.loopFix({
            direction: swiper.swipeDirection
        });
        data.startTranslate = swiper.getTranslate();
        swiper.setTransition(0);
        if (swiper.animating) {
            const evt = new window.CustomEvent("transitionend", {
                bubbles: true,
                cancelable: true
            });
            swiper.wrapperEl.dispatchEvent(evt);
        }
        data.allowMomentumBounce = false;
        // Grab Cursor
        if (params.grabCursor && (swiper.allowSlideNext === true || swiper.allowSlidePrev === true)) swiper.setGrabCursor(true);
        swiper.emit("sliderFirstMove", e);
    }
    let loopFixed;
    new Date().getTime();
    if (data.isMoved && data.allowThresholdMove && prevTouchesDirection !== swiper.touchesDirection && isLoop && allowLoopFix && Math.abs(diff) >= 1) {
        Object.assign(touches, {
            startX: pageX,
            startY: pageY,
            currentX: pageX,
            currentY: pageY,
            startTranslate: data.currentTranslate
        });
        data.loopSwapReset = true;
        data.startTranslate = data.currentTranslate;
        return;
    }
    swiper.emit("sliderMove", e);
    data.isMoved = true;
    data.currentTranslate = diff + data.startTranslate;
    let disableParentSwiper = true;
    let resistanceRatio = params.resistanceRatio;
    if (params.touchReleaseOnEdges) resistanceRatio = 0;
    if (diff > 0) {
        if (isLoop && allowLoopFix && !loopFixed && data.allowThresholdMove && data.currentTranslate > (params.centeredSlides ? swiper.minTranslate() - swiper.slidesSizesGrid[swiper.activeIndex + 1] : swiper.minTranslate())) swiper.loopFix({
            direction: "prev",
            setTranslate: true,
            activeSlideIndex: 0
        });
        if (data.currentTranslate > swiper.minTranslate()) {
            disableParentSwiper = false;
            if (params.resistance) data.currentTranslate = swiper.minTranslate() - 1 + (-swiper.minTranslate() + data.startTranslate + diff) ** resistanceRatio;
        }
    } else if (diff < 0) {
        if (isLoop && allowLoopFix && !loopFixed && data.allowThresholdMove && data.currentTranslate < (params.centeredSlides ? swiper.maxTranslate() + swiper.slidesSizesGrid[swiper.slidesSizesGrid.length - 1] : swiper.maxTranslate())) swiper.loopFix({
            direction: "next",
            setTranslate: true,
            activeSlideIndex: swiper.slides.length - (params.slidesPerView === "auto" ? swiper.slidesPerViewDynamic() : Math.ceil(parseFloat(params.slidesPerView, 10)))
        });
        if (data.currentTranslate < swiper.maxTranslate()) {
            disableParentSwiper = false;
            if (params.resistance) data.currentTranslate = swiper.maxTranslate() + 1 - (swiper.maxTranslate() - data.startTranslate - diff) ** resistanceRatio;
        }
    }
    if (disableParentSwiper) e.preventedByNestedSwiper = true;
    // Directions locks
    if (!swiper.allowSlideNext && swiper.swipeDirection === "next" && data.currentTranslate < data.startTranslate) data.currentTranslate = data.startTranslate;
    if (!swiper.allowSlidePrev && swiper.swipeDirection === "prev" && data.currentTranslate > data.startTranslate) data.currentTranslate = data.startTranslate;
    if (!swiper.allowSlidePrev && !swiper.allowSlideNext) data.currentTranslate = data.startTranslate;
    // Threshold
    if (params.threshold > 0) {
        if (Math.abs(diff) > params.threshold || data.allowThresholdMove) {
            if (!data.allowThresholdMove) {
                data.allowThresholdMove = true;
                touches.startX = touches.currentX;
                touches.startY = touches.currentY;
                data.currentTranslate = data.startTranslate;
                touches.diff = swiper.isHorizontal() ? touches.currentX - touches.startX : touches.currentY - touches.startY;
                return;
            }
        } else {
            data.currentTranslate = data.startTranslate;
            return;
        }
    }
    if (!params.followFinger || params.cssMode) return;
    // Update active index in free mode
    if (params.freeMode && params.freeMode.enabled && swiper.freeMode || params.watchSlidesProgress) {
        swiper.updateActiveIndex();
        swiper.updateSlidesClasses();
    }
    if (params.freeMode && params.freeMode.enabled && swiper.freeMode) swiper.freeMode.onTouchMove();
    // Update progress
    swiper.updateProgress(data.currentTranslate);
    // Update translate
    swiper.setTranslate(data.currentTranslate);
}
function onTouchEnd(event) {
    const swiper = this;
    const data = swiper.touchEventsData;
    let e = event;
    if (e.originalEvent) e = e.originalEvent;
    let targetTouch;
    const isTouchEvent = e.type === "touchend" || e.type === "touchcancel";
    if (!isTouchEvent) {
        if (data.touchId !== null) return; // return from pointer if we use touch
        if (e.pointerId !== data.pointerId) return;
        targetTouch = e;
    } else {
        targetTouch = [
            ...e.changedTouches
        ].filter((t)=>t.identifier === data.touchId)[0];
        if (!targetTouch || targetTouch.identifier !== data.touchId) return;
    }
    if ([
        "pointercancel",
        "pointerout",
        "pointerleave",
        "contextmenu"
    ].includes(e.type)) {
        const proceed = [
            "pointercancel",
            "contextmenu"
        ].includes(e.type) && (swiper.browser.isSafari || swiper.browser.isWebView);
        if (!proceed) return;
    }
    data.pointerId = null;
    data.touchId = null;
    const { params, touches, rtlTranslate: rtl, slidesGrid, enabled } = swiper;
    if (!enabled) return;
    if (!params.simulateTouch && e.pointerType === "mouse") return;
    if (data.allowTouchCallbacks) swiper.emit("touchEnd", e);
    data.allowTouchCallbacks = false;
    if (!data.isTouched) {
        if (data.isMoved && params.grabCursor) swiper.setGrabCursor(false);
        data.isMoved = false;
        data.startMoving = false;
        return;
    }
    // Return Grab Cursor
    if (params.grabCursor && data.isMoved && data.isTouched && (swiper.allowSlideNext === true || swiper.allowSlidePrev === true)) swiper.setGrabCursor(false);
    // Time diff
    const touchEndTime = (0, _utilsMjs.d)();
    const timeDiff = touchEndTime - data.touchStartTime;
    // Tap, doubleTap, Click
    if (swiper.allowClick) {
        const pathTree = e.path || e.composedPath && e.composedPath();
        swiper.updateClickedSlide(pathTree && pathTree[0] || e.target, pathTree);
        swiper.emit("tap click", e);
        if (timeDiff < 300 && touchEndTime - data.lastClickTime < 300) swiper.emit("doubleTap doubleClick", e);
    }
    data.lastClickTime = (0, _utilsMjs.d)();
    (0, _utilsMjs.n)(()=>{
        if (!swiper.destroyed) swiper.allowClick = true;
    });
    if (!data.isTouched || !data.isMoved || !swiper.swipeDirection || touches.diff === 0 && !data.loopSwapReset || data.currentTranslate === data.startTranslate && !data.loopSwapReset) {
        data.isTouched = false;
        data.isMoved = false;
        data.startMoving = false;
        return;
    }
    data.isTouched = false;
    data.isMoved = false;
    data.startMoving = false;
    let currentPos;
    if (params.followFinger) currentPos = rtl ? swiper.translate : -swiper.translate;
    else currentPos = -data.currentTranslate;
    if (params.cssMode) return;
    if (params.freeMode && params.freeMode.enabled) {
        swiper.freeMode.onTouchEnd({
            currentPos
        });
        return;
    }
    // Find current slide
    const swipeToLast = currentPos >= -swiper.maxTranslate() && !swiper.params.loop;
    let stopIndex = 0;
    let groupSize = swiper.slidesSizesGrid[0];
    for(let i = 0; i < slidesGrid.length; i += i < params.slidesPerGroupSkip ? 1 : params.slidesPerGroup){
        const increment = i < params.slidesPerGroupSkip - 1 ? 1 : params.slidesPerGroup;
        if (typeof slidesGrid[i + increment] !== "undefined") {
            if (swipeToLast || currentPos >= slidesGrid[i] && currentPos < slidesGrid[i + increment]) {
                stopIndex = i;
                groupSize = slidesGrid[i + increment] - slidesGrid[i];
            }
        } else if (swipeToLast || currentPos >= slidesGrid[i]) {
            stopIndex = i;
            groupSize = slidesGrid[slidesGrid.length - 1] - slidesGrid[slidesGrid.length - 2];
        }
    }
    let rewindFirstIndex = null;
    let rewindLastIndex = null;
    if (params.rewind) {
        if (swiper.isBeginning) rewindLastIndex = params.virtual && params.virtual.enabled && swiper.virtual ? swiper.virtual.slides.length - 1 : swiper.slides.length - 1;
        else if (swiper.isEnd) rewindFirstIndex = 0;
    }
    // Find current slide size
    const ratio = (currentPos - slidesGrid[stopIndex]) / groupSize;
    const increment = stopIndex < params.slidesPerGroupSkip - 1 ? 1 : params.slidesPerGroup;
    if (timeDiff > params.longSwipesMs) {
        // Long touches
        if (!params.longSwipes) {
            swiper.slideTo(swiper.activeIndex);
            return;
        }
        if (swiper.swipeDirection === "next") {
            if (ratio >= params.longSwipesRatio) swiper.slideTo(params.rewind && swiper.isEnd ? rewindFirstIndex : stopIndex + increment);
            else swiper.slideTo(stopIndex);
        }
        if (swiper.swipeDirection === "prev") {
            if (ratio > 1 - params.longSwipesRatio) swiper.slideTo(stopIndex + increment);
            else if (rewindLastIndex !== null && ratio < 0 && Math.abs(ratio) > params.longSwipesRatio) swiper.slideTo(rewindLastIndex);
            else swiper.slideTo(stopIndex);
        }
    } else {
        // Short swipes
        if (!params.shortSwipes) {
            swiper.slideTo(swiper.activeIndex);
            return;
        }
        const isNavButtonTarget = swiper.navigation && (e.target === swiper.navigation.nextEl || e.target === swiper.navigation.prevEl);
        if (!isNavButtonTarget) {
            if (swiper.swipeDirection === "next") swiper.slideTo(rewindFirstIndex !== null ? rewindFirstIndex : stopIndex + increment);
            if (swiper.swipeDirection === "prev") swiper.slideTo(rewindLastIndex !== null ? rewindLastIndex : stopIndex);
        } else if (e.target === swiper.navigation.nextEl) swiper.slideTo(stopIndex + increment);
        else swiper.slideTo(stopIndex);
    }
}
function onResize() {
    const swiper = this;
    const { params, el } = swiper;
    if (el && el.offsetWidth === 0) return;
    // Breakpoints
    if (params.breakpoints) swiper.setBreakpoint();
    // Save locks
    const { allowSlideNext, allowSlidePrev, snapGrid } = swiper;
    const isVirtual = swiper.virtual && swiper.params.virtual.enabled;
    // Disable locks on resize
    swiper.allowSlideNext = true;
    swiper.allowSlidePrev = true;
    swiper.updateSize();
    swiper.updateSlides();
    swiper.updateSlidesClasses();
    const isVirtualLoop = isVirtual && params.loop;
    if ((params.slidesPerView === "auto" || params.slidesPerView > 1) && swiper.isEnd && !swiper.isBeginning && !swiper.params.centeredSlides && !isVirtualLoop) swiper.slideTo(swiper.slides.length - 1, 0, false, true);
    else if (swiper.params.loop && !isVirtual) swiper.slideToLoop(swiper.realIndex, 0, false, true);
    else swiper.slideTo(swiper.activeIndex, 0, false, true);
    if (swiper.autoplay && swiper.autoplay.running && swiper.autoplay.paused) {
        clearTimeout(swiper.autoplay.resizeTimeout);
        swiper.autoplay.resizeTimeout = setTimeout(()=>{
            if (swiper.autoplay && swiper.autoplay.running && swiper.autoplay.paused) swiper.autoplay.resume();
        }, 500);
    }
    // Return locks after resize
    swiper.allowSlidePrev = allowSlidePrev;
    swiper.allowSlideNext = allowSlideNext;
    if (swiper.params.watchOverflow && snapGrid !== swiper.snapGrid) swiper.checkOverflow();
}
function onClick(e) {
    const swiper = this;
    if (!swiper.enabled) return;
    if (!swiper.allowClick) {
        if (swiper.params.preventClicks) e.preventDefault();
        if (swiper.params.preventClicksPropagation && swiper.animating) {
            e.stopPropagation();
            e.stopImmediatePropagation();
        }
    }
}
function onScroll() {
    const swiper = this;
    const { wrapperEl, rtlTranslate, enabled } = swiper;
    if (!enabled) return;
    swiper.previousTranslate = swiper.translate;
    if (swiper.isHorizontal()) swiper.translate = -wrapperEl.scrollLeft;
    else swiper.translate = -wrapperEl.scrollTop;
    // eslint-disable-next-line
    if (swiper.translate === 0) swiper.translate = 0;
    swiper.updateActiveIndex();
    swiper.updateSlidesClasses();
    let newProgress;
    const translatesDiff = swiper.maxTranslate() - swiper.minTranslate();
    if (translatesDiff === 0) newProgress = 0;
    else newProgress = (swiper.translate - swiper.minTranslate()) / translatesDiff;
    if (newProgress !== swiper.progress) swiper.updateProgress(rtlTranslate ? -swiper.translate : swiper.translate);
    swiper.emit("setTranslate", swiper.translate, false);
}
function onLoad(e) {
    const swiper = this;
    processLazyPreloader(swiper, e.target);
    if (swiper.params.cssMode || swiper.params.slidesPerView !== "auto" && !swiper.params.autoHeight) return;
    swiper.update();
}
function onDocumentTouchStart() {
    const swiper = this;
    if (swiper.documentTouchHandlerProceeded) return;
    swiper.documentTouchHandlerProceeded = true;
    if (swiper.params.touchReleaseOnEdges) swiper.el.style.touchAction = "auto";
}
const events = (swiper, method)=>{
    const document1 = (0, _ssrWindowEsmMjs.g)();
    const { params, el, wrapperEl, device } = swiper;
    const capture = !!params.nested;
    const domMethod = method === "on" ? "addEventListener" : "removeEventListener";
    const swiperMethod = method;
    // Touch Events
    document1[domMethod]("touchstart", swiper.onDocumentTouchStart, {
        passive: false,
        capture
    });
    el[domMethod]("touchstart", swiper.onTouchStart, {
        passive: false
    });
    el[domMethod]("pointerdown", swiper.onTouchStart, {
        passive: false
    });
    document1[domMethod]("touchmove", swiper.onTouchMove, {
        passive: false,
        capture
    });
    document1[domMethod]("pointermove", swiper.onTouchMove, {
        passive: false,
        capture
    });
    document1[domMethod]("touchend", swiper.onTouchEnd, {
        passive: true
    });
    document1[domMethod]("pointerup", swiper.onTouchEnd, {
        passive: true
    });
    document1[domMethod]("pointercancel", swiper.onTouchEnd, {
        passive: true
    });
    document1[domMethod]("touchcancel", swiper.onTouchEnd, {
        passive: true
    });
    document1[domMethod]("pointerout", swiper.onTouchEnd, {
        passive: true
    });
    document1[domMethod]("pointerleave", swiper.onTouchEnd, {
        passive: true
    });
    document1[domMethod]("contextmenu", swiper.onTouchEnd, {
        passive: true
    });
    // Prevent Links Clicks
    if (params.preventClicks || params.preventClicksPropagation) el[domMethod]("click", swiper.onClick, true);
    if (params.cssMode) wrapperEl[domMethod]("scroll", swiper.onScroll);
    // Resize handler
    if (params.updateOnWindowResize) swiper[swiperMethod](device.ios || device.android ? "resize orientationchange observerUpdate" : "resize observerUpdate", onResize, true);
    else swiper[swiperMethod]("observerUpdate", onResize, true);
    // Images loader
    el[domMethod]("load", swiper.onLoad, {
        capture: true
    });
};
function attachEvents() {
    const swiper = this;
    const { params } = swiper;
    swiper.onTouchStart = onTouchStart.bind(swiper);
    swiper.onTouchMove = onTouchMove.bind(swiper);
    swiper.onTouchEnd = onTouchEnd.bind(swiper);
    swiper.onDocumentTouchStart = onDocumentTouchStart.bind(swiper);
    if (params.cssMode) swiper.onScroll = onScroll.bind(swiper);
    swiper.onClick = onClick.bind(swiper);
    swiper.onLoad = onLoad.bind(swiper);
    events(swiper, "on");
}
function detachEvents() {
    const swiper = this;
    events(swiper, "off");
}
var events$1 = {
    attachEvents,
    detachEvents
};
const isGridEnabled = (swiper, params)=>{
    return swiper.grid && params.grid && params.grid.rows > 1;
};
function setBreakpoint() {
    const swiper = this;
    const { realIndex, initialized, params, el } = swiper;
    const breakpoints = params.breakpoints;
    if (!breakpoints || breakpoints && Object.keys(breakpoints).length === 0) return;
    // Get breakpoint for window width and update parameters
    const breakpoint = swiper.getBreakpoint(breakpoints, swiper.params.breakpointsBase, swiper.el);
    if (!breakpoint || swiper.currentBreakpoint === breakpoint) return;
    const breakpointOnlyParams = breakpoint in breakpoints ? breakpoints[breakpoint] : undefined;
    const breakpointParams = breakpointOnlyParams || swiper.originalParams;
    const wasMultiRow = isGridEnabled(swiper, params);
    const isMultiRow = isGridEnabled(swiper, breakpointParams);
    const wasEnabled = params.enabled;
    if (wasMultiRow && !isMultiRow) {
        el.classList.remove(`${params.containerModifierClass}grid`, `${params.containerModifierClass}grid-column`);
        swiper.emitContainerClasses();
    } else if (!wasMultiRow && isMultiRow) {
        el.classList.add(`${params.containerModifierClass}grid`);
        if (breakpointParams.grid.fill && breakpointParams.grid.fill === "column" || !breakpointParams.grid.fill && params.grid.fill === "column") el.classList.add(`${params.containerModifierClass}grid-column`);
        swiper.emitContainerClasses();
    }
    // Toggle navigation, pagination, scrollbar
    [
        "navigation",
        "pagination",
        "scrollbar"
    ].forEach((prop)=>{
        if (typeof breakpointParams[prop] === "undefined") return;
        const wasModuleEnabled = params[prop] && params[prop].enabled;
        const isModuleEnabled = breakpointParams[prop] && breakpointParams[prop].enabled;
        if (wasModuleEnabled && !isModuleEnabled) swiper[prop].disable();
        if (!wasModuleEnabled && isModuleEnabled) swiper[prop].enable();
    });
    const directionChanged = breakpointParams.direction && breakpointParams.direction !== params.direction;
    const needsReLoop = params.loop && (breakpointParams.slidesPerView !== params.slidesPerView || directionChanged);
    const wasLoop = params.loop;
    if (directionChanged && initialized) swiper.changeDirection();
    (0, _utilsMjs.t)(swiper.params, breakpointParams);
    const isEnabled = swiper.params.enabled;
    const hasLoop = swiper.params.loop;
    Object.assign(swiper, {
        allowTouchMove: swiper.params.allowTouchMove,
        allowSlideNext: swiper.params.allowSlideNext,
        allowSlidePrev: swiper.params.allowSlidePrev
    });
    if (wasEnabled && !isEnabled) swiper.disable();
    else if (!wasEnabled && isEnabled) swiper.enable();
    swiper.currentBreakpoint = breakpoint;
    swiper.emit("_beforeBreakpoint", breakpointParams);
    if (initialized) {
        if (needsReLoop) {
            swiper.loopDestroy();
            swiper.loopCreate(realIndex);
            swiper.updateSlides();
        } else if (!wasLoop && hasLoop) {
            swiper.loopCreate(realIndex);
            swiper.updateSlides();
        } else if (wasLoop && !hasLoop) swiper.loopDestroy();
    }
    swiper.emit("breakpoint", breakpointParams);
}
function getBreakpoint(breakpoints, base, containerEl) {
    if (base === void 0) base = "window";
    if (!breakpoints || base === "container" && !containerEl) return undefined;
    let breakpoint = false;
    const window1 = (0, _ssrWindowEsmMjs.a)();
    const currentHeight = base === "window" ? window1.innerHeight : containerEl.clientHeight;
    const points = Object.keys(breakpoints).map((point)=>{
        if (typeof point === "string" && point.indexOf("@") === 0) {
            const minRatio = parseFloat(point.substr(1));
            const value = currentHeight * minRatio;
            return {
                value,
                point
            };
        }
        return {
            value: point,
            point
        };
    });
    points.sort((a, b)=>parseInt(a.value, 10) - parseInt(b.value, 10));
    for(let i = 0; i < points.length; i += 1){
        const { point, value } = points[i];
        if (base === "window") {
            if (window1.matchMedia(`(min-width: ${value}px)`).matches) breakpoint = point;
        } else if (value <= containerEl.clientWidth) breakpoint = point;
    }
    return breakpoint || "max";
}
var breakpoints = {
    setBreakpoint,
    getBreakpoint
};
function prepareClasses(entries, prefix) {
    const resultClasses = [];
    entries.forEach((item)=>{
        if (typeof item === "object") Object.keys(item).forEach((classNames)=>{
            if (item[classNames]) resultClasses.push(prefix + classNames);
        });
        else if (typeof item === "string") resultClasses.push(prefix + item);
    });
    return resultClasses;
}
function addClasses() {
    const swiper = this;
    const { classNames, params, rtl, el, device } = swiper;
    // prettier-ignore
    const suffixes = prepareClasses([
        "initialized",
        params.direction,
        {
            "free-mode": swiper.params.freeMode && params.freeMode.enabled
        },
        {
            "autoheight": params.autoHeight
        },
        {
            "rtl": rtl
        },
        {
            "grid": params.grid && params.grid.rows > 1
        },
        {
            "grid-column": params.grid && params.grid.rows > 1 && params.grid.fill === "column"
        },
        {
            "android": device.android
        },
        {
            "ios": device.ios
        },
        {
            "css-mode": params.cssMode
        },
        {
            "centered": params.cssMode && params.centeredSlides
        },
        {
            "watch-progress": params.watchSlidesProgress
        }
    ], params.containerModifierClass);
    classNames.push(...suffixes);
    el.classList.add(...classNames);
    swiper.emitContainerClasses();
}
function removeClasses() {
    const swiper = this;
    const { el, classNames } = swiper;
    el.classList.remove(...classNames);
    swiper.emitContainerClasses();
}
var classes = {
    addClasses,
    removeClasses
};
function checkOverflow() {
    const swiper = this;
    const { isLocked: wasLocked, params } = swiper;
    const { slidesOffsetBefore } = params;
    if (slidesOffsetBefore) {
        const lastSlideIndex = swiper.slides.length - 1;
        const lastSlideRightEdge = swiper.slidesGrid[lastSlideIndex] + swiper.slidesSizesGrid[lastSlideIndex] + slidesOffsetBefore * 2;
        swiper.isLocked = swiper.size > lastSlideRightEdge;
    } else swiper.isLocked = swiper.snapGrid.length === 1;
    if (params.allowSlideNext === true) swiper.allowSlideNext = !swiper.isLocked;
    if (params.allowSlidePrev === true) swiper.allowSlidePrev = !swiper.isLocked;
    if (wasLocked && wasLocked !== swiper.isLocked) swiper.isEnd = false;
    if (wasLocked !== swiper.isLocked) swiper.emit(swiper.isLocked ? "lock" : "unlock");
}
var checkOverflow$1 = {
    checkOverflow
};
var defaults = {
    init: true,
    direction: "horizontal",
    oneWayMovement: false,
    touchEventsTarget: "wrapper",
    initialSlide: 0,
    speed: 300,
    cssMode: false,
    updateOnWindowResize: true,
    resizeObserver: true,
    nested: false,
    createElements: false,
    eventsPrefix: "swiper",
    enabled: true,
    focusableElements: "input, select, option, textarea, button, video, label",
    // Overrides
    width: null,
    height: null,
    //
    preventInteractionOnTransition: false,
    // ssr
    userAgent: null,
    url: null,
    // To support iOS's swipe-to-go-back gesture (when being used in-app).
    edgeSwipeDetection: false,
    edgeSwipeThreshold: 20,
    // Autoheight
    autoHeight: false,
    // Set wrapper width
    setWrapperSize: false,
    // Virtual Translate
    virtualTranslate: false,
    // Effects
    effect: "slide",
    // 'slide' or 'fade' or 'cube' or 'coverflow' or 'flip'
    // Breakpoints
    breakpoints: undefined,
    breakpointsBase: "window",
    // Slides grid
    spaceBetween: 0,
    slidesPerView: 1,
    slidesPerGroup: 1,
    slidesPerGroupSkip: 0,
    slidesPerGroupAuto: false,
    centeredSlides: false,
    centeredSlidesBounds: false,
    slidesOffsetBefore: 0,
    // in px
    slidesOffsetAfter: 0,
    // in px
    normalizeSlideIndex: true,
    centerInsufficientSlides: false,
    // Disable swiper and hide navigation when container not overflow
    watchOverflow: true,
    // Round length
    roundLengths: false,
    // Touches
    touchRatio: 1,
    touchAngle: 45,
    simulateTouch: true,
    shortSwipes: true,
    longSwipes: true,
    longSwipesRatio: 0.5,
    longSwipesMs: 300,
    followFinger: true,
    allowTouchMove: true,
    threshold: 5,
    touchMoveStopPropagation: false,
    touchStartPreventDefault: true,
    touchStartForcePreventDefault: false,
    touchReleaseOnEdges: false,
    // Unique Navigation Elements
    uniqueNavElements: true,
    // Resistance
    resistance: true,
    resistanceRatio: 0.85,
    // Progress
    watchSlidesProgress: false,
    // Cursor
    grabCursor: false,
    // Clicks
    preventClicks: true,
    preventClicksPropagation: true,
    slideToClickedSlide: false,
    // loop
    loop: false,
    loopAddBlankSlides: true,
    loopAdditionalSlides: 0,
    loopPreventsSliding: true,
    // rewind
    rewind: false,
    // Swiping/no swiping
    allowSlidePrev: true,
    allowSlideNext: true,
    swipeHandler: null,
    // '.swipe-handler',
    noSwiping: true,
    noSwipingClass: "swiper-no-swiping",
    noSwipingSelector: null,
    // Passive Listeners
    passiveListeners: true,
    maxBackfaceHiddenSlides: 10,
    // NS
    containerModifierClass: "swiper-",
    // NEW
    slideClass: "swiper-slide",
    slideBlankClass: "swiper-slide-blank",
    slideActiveClass: "swiper-slide-active",
    slideVisibleClass: "swiper-slide-visible",
    slideFullyVisibleClass: "swiper-slide-fully-visible",
    slideNextClass: "swiper-slide-next",
    slidePrevClass: "swiper-slide-prev",
    wrapperClass: "swiper-wrapper",
    lazyPreloaderClass: "swiper-lazy-preloader",
    lazyPreloadPrevNext: 0,
    // Callbacks
    runCallbacksOnInit: true,
    // Internals
    _emitClasses: false
};
function moduleExtendParams(params, allModulesParams) {
    return function extendParams(obj) {
        if (obj === void 0) obj = {};
        const moduleParamName = Object.keys(obj)[0];
        const moduleParams = obj[moduleParamName];
        if (typeof moduleParams !== "object" || moduleParams === null) {
            (0, _utilsMjs.t)(allModulesParams, obj);
            return;
        }
        if (params[moduleParamName] === true) params[moduleParamName] = {
            enabled: true
        };
        if (moduleParamName === "navigation" && params[moduleParamName] && params[moduleParamName].enabled && !params[moduleParamName].prevEl && !params[moduleParamName].nextEl) params[moduleParamName].auto = true;
        if ([
            "pagination",
            "scrollbar"
        ].indexOf(moduleParamName) >= 0 && params[moduleParamName] && params[moduleParamName].enabled && !params[moduleParamName].el) params[moduleParamName].auto = true;
        if (!(moduleParamName in params && "enabled" in moduleParams)) {
            (0, _utilsMjs.t)(allModulesParams, obj);
            return;
        }
        if (typeof params[moduleParamName] === "object" && !("enabled" in params[moduleParamName])) params[moduleParamName].enabled = true;
        if (!params[moduleParamName]) params[moduleParamName] = {
            enabled: false
        };
        (0, _utilsMjs.t)(allModulesParams, obj);
    };
}
/* eslint no-param-reassign: "off" */ const prototypes = {
    eventsEmitter,
    update,
    translate,
    transition,
    slide,
    loop,
    grabCursor,
    events: events$1,
    breakpoints,
    checkOverflow: checkOverflow$1,
    classes
};
const extendedDefaults = {};
class Swiper {
    constructor(){
        let el;
        let params;
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        if (args.length === 1 && args[0].constructor && Object.prototype.toString.call(args[0]).slice(8, -1) === "Object") params = args[0];
        else [el, params] = args;
        if (!params) params = {};
        params = (0, _utilsMjs.t)({}, params);
        if (el && !params.el) params.el = el;
        const document1 = (0, _ssrWindowEsmMjs.g)();
        if (params.el && typeof params.el === "string" && document1.querySelectorAll(params.el).length > 1) {
            const swipers = [];
            document1.querySelectorAll(params.el).forEach((containerEl)=>{
                const newParams = (0, _utilsMjs.t)({}, params, {
                    el: containerEl
                });
                swipers.push(new Swiper(newParams));
            });
            // eslint-disable-next-line no-constructor-return
            return swipers;
        }
        // Swiper Instance
        const swiper = this;
        swiper.__swiper__ = true;
        swiper.support = getSupport();
        swiper.device = getDevice({
            userAgent: params.userAgent
        });
        swiper.browser = getBrowser();
        swiper.eventsListeners = {};
        swiper.eventsAnyListeners = [];
        swiper.modules = [
            ...swiper.__modules__
        ];
        if (params.modules && Array.isArray(params.modules)) swiper.modules.push(...params.modules);
        const allModulesParams = {};
        swiper.modules.forEach((mod)=>{
            mod({
                params,
                swiper,
                extendParams: moduleExtendParams(params, allModulesParams),
                on: swiper.on.bind(swiper),
                once: swiper.once.bind(swiper),
                off: swiper.off.bind(swiper),
                emit: swiper.emit.bind(swiper)
            });
        });
        // Extend defaults with modules params
        const swiperParams = (0, _utilsMjs.t)({}, defaults, allModulesParams);
        // Extend defaults with passed params
        swiper.params = (0, _utilsMjs.t)({}, swiperParams, extendedDefaults, params);
        swiper.originalParams = (0, _utilsMjs.t)({}, swiper.params);
        swiper.passedParams = (0, _utilsMjs.t)({}, params);
        // add event listeners
        if (swiper.params && swiper.params.on) Object.keys(swiper.params.on).forEach((eventName)=>{
            swiper.on(eventName, swiper.params.on[eventName]);
        });
        if (swiper.params && swiper.params.onAny) swiper.onAny(swiper.params.onAny);
        // Extend Swiper
        Object.assign(swiper, {
            enabled: swiper.params.enabled,
            el,
            // Classes
            classNames: [],
            // Slides
            slides: [],
            slidesGrid: [],
            snapGrid: [],
            slidesSizesGrid: [],
            // isDirection
            isHorizontal () {
                return swiper.params.direction === "horizontal";
            },
            isVertical () {
                return swiper.params.direction === "vertical";
            },
            // Indexes
            activeIndex: 0,
            realIndex: 0,
            //
            isBeginning: true,
            isEnd: false,
            // Props
            translate: 0,
            previousTranslate: 0,
            progress: 0,
            velocity: 0,
            animating: false,
            cssOverflowAdjustment () {
                // Returns 0 unless `translate` is > 2**23
                // Should be subtracted from css values to prevent overflow
                return Math.trunc(this.translate / 2 ** 23) * 2 ** 23;
            },
            // Locks
            allowSlideNext: swiper.params.allowSlideNext,
            allowSlidePrev: swiper.params.allowSlidePrev,
            // Touch Events
            touchEventsData: {
                isTouched: undefined,
                isMoved: undefined,
                allowTouchCallbacks: undefined,
                touchStartTime: undefined,
                isScrolling: undefined,
                currentTranslate: undefined,
                startTranslate: undefined,
                allowThresholdMove: undefined,
                // Form elements to match
                focusableElements: swiper.params.focusableElements,
                // Last click time
                lastClickTime: 0,
                clickTimeout: undefined,
                // Velocities
                velocities: [],
                allowMomentumBounce: undefined,
                startMoving: undefined,
                pointerId: null,
                touchId: null
            },
            // Clicks
            allowClick: true,
            // Touches
            allowTouchMove: swiper.params.allowTouchMove,
            touches: {
                startX: 0,
                startY: 0,
                currentX: 0,
                currentY: 0,
                diff: 0
            },
            // Images
            imagesToLoad: [],
            imagesLoaded: 0
        });
        swiper.emit("_swiper");
        // Init
        if (swiper.params.init) swiper.init();
        // Return app instance
        // eslint-disable-next-line no-constructor-return
        return swiper;
    }
    getDirectionLabel(property) {
        if (this.isHorizontal()) return property;
        // prettier-ignore
        return ({
            "width": "height",
            "margin-top": "margin-left",
            "margin-bottom ": "margin-right",
            "margin-left": "margin-top",
            "margin-right": "margin-bottom",
            "padding-left": "padding-top",
            "padding-right": "padding-bottom",
            "marginRight": "marginBottom"
        })[property];
    }
    getSlideIndex(slideEl) {
        const { slidesEl, params } = this;
        const slides = (0, _utilsMjs.e)(slidesEl, `.${params.slideClass}, swiper-slide`);
        const firstSlideIndex = (0, _utilsMjs.g)(slides[0]);
        return (0, _utilsMjs.g)(slideEl) - firstSlideIndex;
    }
    getSlideIndexByData(index) {
        return this.getSlideIndex(this.slides.filter((slideEl)=>slideEl.getAttribute("data-swiper-slide-index") * 1 === index)[0]);
    }
    recalcSlides() {
        const swiper = this;
        const { slidesEl, params } = swiper;
        swiper.slides = (0, _utilsMjs.e)(slidesEl, `.${params.slideClass}, swiper-slide`);
    }
    enable() {
        const swiper = this;
        if (swiper.enabled) return;
        swiper.enabled = true;
        if (swiper.params.grabCursor) swiper.setGrabCursor();
        swiper.emit("enable");
    }
    disable() {
        const swiper = this;
        if (!swiper.enabled) return;
        swiper.enabled = false;
        if (swiper.params.grabCursor) swiper.unsetGrabCursor();
        swiper.emit("disable");
    }
    setProgress(progress, speed) {
        const swiper = this;
        progress = Math.min(Math.max(progress, 0), 1);
        const min = swiper.minTranslate();
        const max = swiper.maxTranslate();
        const current = (max - min) * progress + min;
        swiper.translateTo(current, typeof speed === "undefined" ? 0 : speed);
        swiper.updateActiveIndex();
        swiper.updateSlidesClasses();
    }
    emitContainerClasses() {
        const swiper = this;
        if (!swiper.params._emitClasses || !swiper.el) return;
        const cls = swiper.el.className.split(" ").filter((className)=>{
            return className.indexOf("swiper") === 0 || className.indexOf(swiper.params.containerModifierClass) === 0;
        });
        swiper.emit("_containerClasses", cls.join(" "));
    }
    getSlideClasses(slideEl) {
        const swiper = this;
        if (swiper.destroyed) return "";
        return slideEl.className.split(" ").filter((className)=>{
            return className.indexOf("swiper-slide") === 0 || className.indexOf(swiper.params.slideClass) === 0;
        }).join(" ");
    }
    emitSlidesClasses() {
        const swiper = this;
        if (!swiper.params._emitClasses || !swiper.el) return;
        const updates = [];
        swiper.slides.forEach((slideEl)=>{
            const classNames = swiper.getSlideClasses(slideEl);
            updates.push({
                slideEl,
                classNames
            });
            swiper.emit("_slideClass", slideEl, classNames);
        });
        swiper.emit("_slideClasses", updates);
    }
    slidesPerViewDynamic(view, exact) {
        if (view === void 0) view = "current";
        if (exact === void 0) exact = false;
        const swiper = this;
        const { params, slides, slidesGrid, slidesSizesGrid, size: swiperSize, activeIndex } = swiper;
        let spv = 1;
        if (typeof params.slidesPerView === "number") return params.slidesPerView;
        if (params.centeredSlides) {
            let slideSize = slides[activeIndex] ? slides[activeIndex].swiperSlideSize : 0;
            let breakLoop;
            for(let i = activeIndex + 1; i < slides.length; i += 1)if (slides[i] && !breakLoop) {
                slideSize += slides[i].swiperSlideSize;
                spv += 1;
                if (slideSize > swiperSize) breakLoop = true;
            }
            for(let i = activeIndex - 1; i >= 0; i -= 1)if (slides[i] && !breakLoop) {
                slideSize += slides[i].swiperSlideSize;
                spv += 1;
                if (slideSize > swiperSize) breakLoop = true;
            }
        } else {
            // eslint-disable-next-line
            if (view === "current") for(let i = activeIndex + 1; i < slides.length; i += 1){
                const slideInView = exact ? slidesGrid[i] + slidesSizesGrid[i] - slidesGrid[activeIndex] < swiperSize : slidesGrid[i] - slidesGrid[activeIndex] < swiperSize;
                if (slideInView) spv += 1;
            }
            else // previous
            for(let i = activeIndex - 1; i >= 0; i -= 1){
                const slideInView = slidesGrid[activeIndex] - slidesGrid[i] < swiperSize;
                if (slideInView) spv += 1;
            }
        }
        return spv;
    }
    update() {
        const swiper = this;
        if (!swiper || swiper.destroyed) return;
        const { snapGrid, params } = swiper;
        // Breakpoints
        if (params.breakpoints) swiper.setBreakpoint();
        [
            ...swiper.el.querySelectorAll('[loading="lazy"]')
        ].forEach((imageEl)=>{
            if (imageEl.complete) processLazyPreloader(swiper, imageEl);
        });
        swiper.updateSize();
        swiper.updateSlides();
        swiper.updateProgress();
        swiper.updateSlidesClasses();
        function setTranslate() {
            const translateValue = swiper.rtlTranslate ? swiper.translate * -1 : swiper.translate;
            const newTranslate = Math.min(Math.max(translateValue, swiper.maxTranslate()), swiper.minTranslate());
            swiper.setTranslate(newTranslate);
            swiper.updateActiveIndex();
            swiper.updateSlidesClasses();
        }
        let translated;
        if (params.freeMode && params.freeMode.enabled && !params.cssMode) {
            setTranslate();
            if (params.autoHeight) swiper.updateAutoHeight();
        } else {
            if ((params.slidesPerView === "auto" || params.slidesPerView > 1) && swiper.isEnd && !params.centeredSlides) {
                const slides = swiper.virtual && params.virtual.enabled ? swiper.virtual.slides : swiper.slides;
                translated = swiper.slideTo(slides.length - 1, 0, false, true);
            } else translated = swiper.slideTo(swiper.activeIndex, 0, false, true);
            if (!translated) setTranslate();
        }
        if (params.watchOverflow && snapGrid !== swiper.snapGrid) swiper.checkOverflow();
        swiper.emit("update");
    }
    changeDirection(newDirection, needUpdate) {
        if (needUpdate === void 0) needUpdate = true;
        const swiper = this;
        const currentDirection = swiper.params.direction;
        if (!newDirection) // eslint-disable-next-line
        newDirection = currentDirection === "horizontal" ? "vertical" : "horizontal";
        if (newDirection === currentDirection || newDirection !== "horizontal" && newDirection !== "vertical") return swiper;
        swiper.el.classList.remove(`${swiper.params.containerModifierClass}${currentDirection}`);
        swiper.el.classList.add(`${swiper.params.containerModifierClass}${newDirection}`);
        swiper.emitContainerClasses();
        swiper.params.direction = newDirection;
        swiper.slides.forEach((slideEl)=>{
            if (newDirection === "vertical") slideEl.style.width = "";
            else slideEl.style.height = "";
        });
        swiper.emit("changeDirection");
        if (needUpdate) swiper.update();
        return swiper;
    }
    changeLanguageDirection(direction) {
        const swiper = this;
        if (swiper.rtl && direction === "rtl" || !swiper.rtl && direction === "ltr") return;
        swiper.rtl = direction === "rtl";
        swiper.rtlTranslate = swiper.params.direction === "horizontal" && swiper.rtl;
        if (swiper.rtl) {
            swiper.el.classList.add(`${swiper.params.containerModifierClass}rtl`);
            swiper.el.dir = "rtl";
        } else {
            swiper.el.classList.remove(`${swiper.params.containerModifierClass}rtl`);
            swiper.el.dir = "ltr";
        }
        swiper.update();
    }
    mount(element) {
        const swiper = this;
        if (swiper.mounted) return true;
        // Find el
        let el = element || swiper.params.el;
        if (typeof el === "string") el = document.querySelector(el);
        if (!el) return false;
        el.swiper = swiper;
        if (el.parentNode && el.parentNode.host && el.parentNode.host.nodeName === "SWIPER-CONTAINER") swiper.isElement = true;
        const getWrapperSelector = ()=>{
            return `.${(swiper.params.wrapperClass || "").trim().split(" ").join(".")}`;
        };
        const getWrapper = ()=>{
            if (el && el.shadowRoot && el.shadowRoot.querySelector) {
                const res = el.shadowRoot.querySelector(getWrapperSelector());
                // Children needs to return slot items
                return res;
            }
            return (0, _utilsMjs.e)(el, getWrapperSelector())[0];
        };
        // Find Wrapper
        let wrapperEl = getWrapper();
        if (!wrapperEl && swiper.params.createElements) {
            wrapperEl = (0, _utilsMjs.c)("div", swiper.params.wrapperClass);
            el.append(wrapperEl);
            (0, _utilsMjs.e)(el, `.${swiper.params.slideClass}`).forEach((slideEl)=>{
                wrapperEl.append(slideEl);
            });
        }
        Object.assign(swiper, {
            el,
            wrapperEl,
            slidesEl: swiper.isElement && !el.parentNode.host.slideSlots ? el.parentNode.host : wrapperEl,
            hostEl: swiper.isElement ? el.parentNode.host : el,
            mounted: true,
            // RTL
            rtl: el.dir.toLowerCase() === "rtl" || (0, _utilsMjs.m)(el, "direction") === "rtl",
            rtlTranslate: swiper.params.direction === "horizontal" && (el.dir.toLowerCase() === "rtl" || (0, _utilsMjs.m)(el, "direction") === "rtl"),
            wrongRTL: (0, _utilsMjs.m)(wrapperEl, "display") === "-webkit-box"
        });
        return true;
    }
    init(el) {
        const swiper = this;
        if (swiper.initialized) return swiper;
        const mounted = swiper.mount(el);
        if (mounted === false) return swiper;
        swiper.emit("beforeInit");
        // Set breakpoint
        if (swiper.params.breakpoints) swiper.setBreakpoint();
        // Add Classes
        swiper.addClasses();
        // Update size
        swiper.updateSize();
        // Update slides
        swiper.updateSlides();
        if (swiper.params.watchOverflow) swiper.checkOverflow();
        // Set Grab Cursor
        if (swiper.params.grabCursor && swiper.enabled) swiper.setGrabCursor();
        // Slide To Initial Slide
        if (swiper.params.loop && swiper.virtual && swiper.params.virtual.enabled) swiper.slideTo(swiper.params.initialSlide + swiper.virtual.slidesBefore, 0, swiper.params.runCallbacksOnInit, false, true);
        else swiper.slideTo(swiper.params.initialSlide, 0, swiper.params.runCallbacksOnInit, false, true);
        // Create loop
        if (swiper.params.loop) swiper.loopCreate();
        // Attach events
        swiper.attachEvents();
        const lazyElements = [
            ...swiper.el.querySelectorAll('[loading="lazy"]')
        ];
        if (swiper.isElement) lazyElements.push(...swiper.hostEl.querySelectorAll('[loading="lazy"]'));
        lazyElements.forEach((imageEl)=>{
            if (imageEl.complete) processLazyPreloader(swiper, imageEl);
            else imageEl.addEventListener("load", (e)=>{
                processLazyPreloader(swiper, e.target);
            });
        });
        preload(swiper);
        // Init Flag
        swiper.initialized = true;
        preload(swiper);
        // Emit
        swiper.emit("init");
        swiper.emit("afterInit");
        return swiper;
    }
    destroy(deleteInstance, cleanStyles) {
        if (deleteInstance === void 0) deleteInstance = true;
        if (cleanStyles === void 0) cleanStyles = true;
        const swiper = this;
        const { params, el, wrapperEl, slides } = swiper;
        if (typeof swiper.params === "undefined" || swiper.destroyed) return null;
        swiper.emit("beforeDestroy");
        // Init Flag
        swiper.initialized = false;
        // Detach events
        swiper.detachEvents();
        // Destroy loop
        if (params.loop) swiper.loopDestroy();
        // Cleanup styles
        if (cleanStyles) {
            swiper.removeClasses();
            el.removeAttribute("style");
            wrapperEl.removeAttribute("style");
            if (slides && slides.length) slides.forEach((slideEl)=>{
                slideEl.classList.remove(params.slideVisibleClass, params.slideFullyVisibleClass, params.slideActiveClass, params.slideNextClass, params.slidePrevClass);
                slideEl.removeAttribute("style");
                slideEl.removeAttribute("data-swiper-slide-index");
            });
        }
        swiper.emit("destroy");
        // Detach emitter events
        Object.keys(swiper.eventsListeners).forEach((eventName)=>{
            swiper.off(eventName);
        });
        if (deleteInstance !== false) {
            swiper.el.swiper = null;
            (0, _utilsMjs.u)(swiper);
        }
        swiper.destroyed = true;
        return null;
    }
    static extendDefaults(newDefaults) {
        (0, _utilsMjs.t)(extendedDefaults, newDefaults);
    }
    static get extendedDefaults() {
        return extendedDefaults;
    }
    static get defaults() {
        return defaults;
    }
    static installModule(mod) {
        if (!Swiper.prototype.__modules__) Swiper.prototype.__modules__ = [];
        const modules = Swiper.prototype.__modules__;
        if (typeof mod === "function" && modules.indexOf(mod) < 0) modules.push(mod);
    }
    static use(module) {
        if (Array.isArray(module)) {
            module.forEach((m)=>Swiper.installModule(m));
            return Swiper;
        }
        Swiper.installModule(module);
        return Swiper;
    }
}
Object.keys(prototypes).forEach((prototypeGroup)=>{
    Object.keys(prototypes[prototypeGroup]).forEach((protoMethod)=>{
        Swiper.prototype[protoMethod] = prototypes[prototypeGroup][protoMethod];
    });
});
Swiper.use([
    Resize,
    Observer
]);

},{"./ssr-window.esm.mjs":"ehIRJ","./utils.mjs":"agmBj","@parcel/transformer-js/src/esmodule-helpers.js":"90RNB"}],"ehIRJ":[function(require,module,exports) {
/**
 * SSR Window 4.0.2
 * Better handling for window object in SSR environment
 * https://github.com/nolimits4web/ssr-window
 *
 * Copyright 2021, Vladimir Kharlampidi
 *
 * Licensed under MIT
 *
 * Released on: December 13, 2021
 */ /* eslint-disable no-param-reassign */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "a", ()=>getWindow);
parcelHelpers.export(exports, "g", ()=>getDocument);
function isObject(obj) {
    return obj !== null && typeof obj === "object" && "constructor" in obj && obj.constructor === Object;
}
function extend(target, src) {
    if (target === void 0) target = {};
    if (src === void 0) src = {};
    Object.keys(src).forEach((key)=>{
        if (typeof target[key] === "undefined") target[key] = src[key];
        else if (isObject(src[key]) && isObject(target[key]) && Object.keys(src[key]).length > 0) extend(target[key], src[key]);
    });
}
const ssrDocument = {
    body: {},
    addEventListener () {},
    removeEventListener () {},
    activeElement: {
        blur () {},
        nodeName: ""
    },
    querySelector () {
        return null;
    },
    querySelectorAll () {
        return [];
    },
    getElementById () {
        return null;
    },
    createEvent () {
        return {
            initEvent () {}
        };
    },
    createElement () {
        return {
            children: [],
            childNodes: [],
            style: {},
            setAttribute () {},
            getElementsByTagName () {
                return [];
            }
        };
    },
    createElementNS () {
        return {};
    },
    importNode () {
        return null;
    },
    location: {
        hash: "",
        host: "",
        hostname: "",
        href: "",
        origin: "",
        pathname: "",
        protocol: "",
        search: ""
    }
};
function getDocument() {
    const doc = typeof document !== "undefined" ? document : {};
    extend(doc, ssrDocument);
    return doc;
}
const ssrWindow = {
    document: ssrDocument,
    navigator: {
        userAgent: ""
    },
    location: {
        hash: "",
        host: "",
        hostname: "",
        href: "",
        origin: "",
        pathname: "",
        protocol: "",
        search: ""
    },
    history: {
        replaceState () {},
        pushState () {},
        go () {},
        back () {}
    },
    CustomEvent: function CustomEvent() {
        return this;
    },
    addEventListener () {},
    removeEventListener () {},
    getComputedStyle () {
        return {
            getPropertyValue () {
                return "";
            }
        };
    },
    Image () {},
    Date () {},
    screen: {},
    setTimeout () {},
    clearTimeout () {},
    matchMedia () {
        return {};
    },
    requestAnimationFrame (callback) {
        if (typeof setTimeout === "undefined") {
            callback();
            return null;
        }
        return setTimeout(callback, 0);
    },
    cancelAnimationFrame (id) {
        if (typeof setTimeout === "undefined") return;
        clearTimeout(id);
    }
};
function getWindow() {
    const win = typeof window !== "undefined" ? window : {};
    extend(win, ssrWindow);
    return win;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"90RNB"}],"agmBj":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "a", ()=>elementParents);
parcelHelpers.export(exports, "b", ()=>elementOffset);
parcelHelpers.export(exports, "c", ()=>createElement);
parcelHelpers.export(exports, "d", ()=>now);
parcelHelpers.export(exports, "e", ()=>elementChildren);
parcelHelpers.export(exports, "f", ()=>elementOuterSize);
parcelHelpers.export(exports, "g", ()=>elementIndex);
parcelHelpers.export(exports, "h", ()=>classesToTokens);
parcelHelpers.export(exports, "i", ()=>getTranslate);
parcelHelpers.export(exports, "j", ()=>elementTransitionEnd);
parcelHelpers.export(exports, "k", ()=>isObject);
parcelHelpers.export(exports, "l", ()=>getSlideTransformEl);
parcelHelpers.export(exports, "m", ()=>elementStyle);
parcelHelpers.export(exports, "n", ()=>nextTick);
parcelHelpers.export(exports, "o", ()=>elementNextAll);
parcelHelpers.export(exports, "p", ()=>elementPrevAll);
parcelHelpers.export(exports, "q", ()=>animateCSSModeScroll);
parcelHelpers.export(exports, "r", ()=>showWarning);
parcelHelpers.export(exports, "s", ()=>setCSSProperty);
parcelHelpers.export(exports, "t", ()=>extend);
parcelHelpers.export(exports, "u", ()=>deleteProps);
var _ssrWindowEsmMjs = require("./ssr-window.esm.mjs");
function classesToTokens(classes) {
    if (classes === void 0) classes = "";
    return classes.trim().split(" ").filter((c)=>!!c.trim());
}
function deleteProps(obj) {
    const object = obj;
    Object.keys(object).forEach((key)=>{
        try {
            object[key] = null;
        } catch (e) {
        // no getter for object
        }
        try {
            delete object[key];
        } catch (e) {
        // something got wrong
        }
    });
}
function nextTick(callback, delay) {
    if (delay === void 0) delay = 0;
    return setTimeout(callback, delay);
}
function now() {
    return Date.now();
}
function getComputedStyle(el) {
    const window1 = (0, _ssrWindowEsmMjs.a)();
    let style;
    if (window1.getComputedStyle) style = window1.getComputedStyle(el, null);
    if (!style && el.currentStyle) style = el.currentStyle;
    if (!style) style = el.style;
    return style;
}
function getTranslate(el, axis) {
    if (axis === void 0) axis = "x";
    const window1 = (0, _ssrWindowEsmMjs.a)();
    let matrix;
    let curTransform;
    let transformMatrix;
    const curStyle = getComputedStyle(el);
    if (window1.WebKitCSSMatrix) {
        curTransform = curStyle.transform || curStyle.webkitTransform;
        if (curTransform.split(",").length > 6) curTransform = curTransform.split(", ").map((a)=>a.replace(",", ".")).join(", ");
        // Some old versions of Webkit choke when 'none' is passed; pass
        // empty string instead in this case
        transformMatrix = new window1.WebKitCSSMatrix(curTransform === "none" ? "" : curTransform);
    } else {
        transformMatrix = curStyle.MozTransform || curStyle.OTransform || curStyle.MsTransform || curStyle.msTransform || curStyle.transform || curStyle.getPropertyValue("transform").replace("translate(", "matrix(1, 0, 0, 1,");
        matrix = transformMatrix.toString().split(",");
    }
    if (axis === "x") {
        // Latest Chrome and webkits Fix
        if (window1.WebKitCSSMatrix) curTransform = transformMatrix.m41;
        else if (matrix.length === 16) curTransform = parseFloat(matrix[12]);
        else curTransform = parseFloat(matrix[4]);
    }
    if (axis === "y") {
        // Latest Chrome and webkits Fix
        if (window1.WebKitCSSMatrix) curTransform = transformMatrix.m42;
        else if (matrix.length === 16) curTransform = parseFloat(matrix[13]);
        else curTransform = parseFloat(matrix[5]);
    }
    return curTransform || 0;
}
function isObject(o) {
    return typeof o === "object" && o !== null && o.constructor && Object.prototype.toString.call(o).slice(8, -1) === "Object";
}
function isNode(node) {
    // eslint-disable-next-line
    if (typeof window !== "undefined" && typeof window.HTMLElement !== "undefined") return node instanceof HTMLElement;
    return node && (node.nodeType === 1 || node.nodeType === 11);
}
function extend() {
    const to = Object(arguments.length <= 0 ? undefined : arguments[0]);
    const noExtend = [
        "__proto__",
        "constructor",
        "prototype"
    ];
    for(let i = 1; i < arguments.length; i += 1){
        const nextSource = i < 0 || arguments.length <= i ? undefined : arguments[i];
        if (nextSource !== undefined && nextSource !== null && !isNode(nextSource)) {
            const keysArray = Object.keys(Object(nextSource)).filter((key)=>noExtend.indexOf(key) < 0);
            for(let nextIndex = 0, len = keysArray.length; nextIndex < len; nextIndex += 1){
                const nextKey = keysArray[nextIndex];
                const desc = Object.getOwnPropertyDescriptor(nextSource, nextKey);
                if (desc !== undefined && desc.enumerable) {
                    if (isObject(to[nextKey]) && isObject(nextSource[nextKey])) {
                        if (nextSource[nextKey].__swiper__) to[nextKey] = nextSource[nextKey];
                        else extend(to[nextKey], nextSource[nextKey]);
                    } else if (!isObject(to[nextKey]) && isObject(nextSource[nextKey])) {
                        to[nextKey] = {};
                        if (nextSource[nextKey].__swiper__) to[nextKey] = nextSource[nextKey];
                        else extend(to[nextKey], nextSource[nextKey]);
                    } else to[nextKey] = nextSource[nextKey];
                }
            }
        }
    }
    return to;
}
function setCSSProperty(el, varName, varValue) {
    el.style.setProperty(varName, varValue);
}
function animateCSSModeScroll(_ref) {
    let { swiper, targetPosition, side } = _ref;
    const window1 = (0, _ssrWindowEsmMjs.a)();
    const startPosition = -swiper.translate;
    let startTime = null;
    let time;
    const duration = swiper.params.speed;
    swiper.wrapperEl.style.scrollSnapType = "none";
    window1.cancelAnimationFrame(swiper.cssModeFrameID);
    const dir = targetPosition > startPosition ? "next" : "prev";
    const isOutOfBound = (current, target)=>{
        return dir === "next" && current >= target || dir === "prev" && current <= target;
    };
    const animate = ()=>{
        time = new Date().getTime();
        if (startTime === null) startTime = time;
        const progress = Math.max(Math.min((time - startTime) / duration, 1), 0);
        const easeProgress = 0.5 - Math.cos(progress * Math.PI) / 2;
        let currentPosition = startPosition + easeProgress * (targetPosition - startPosition);
        if (isOutOfBound(currentPosition, targetPosition)) currentPosition = targetPosition;
        swiper.wrapperEl.scrollTo({
            [side]: currentPosition
        });
        if (isOutOfBound(currentPosition, targetPosition)) {
            swiper.wrapperEl.style.overflow = "hidden";
            swiper.wrapperEl.style.scrollSnapType = "";
            setTimeout(()=>{
                swiper.wrapperEl.style.overflow = "";
                swiper.wrapperEl.scrollTo({
                    [side]: currentPosition
                });
            });
            window1.cancelAnimationFrame(swiper.cssModeFrameID);
            return;
        }
        swiper.cssModeFrameID = window1.requestAnimationFrame(animate);
    };
    animate();
}
function getSlideTransformEl(slideEl) {
    return slideEl.querySelector(".swiper-slide-transform") || slideEl.shadowRoot && slideEl.shadowRoot.querySelector(".swiper-slide-transform") || slideEl;
}
function elementChildren(element, selector) {
    if (selector === void 0) selector = "";
    return [
        ...element.children
    ].filter((el)=>el.matches(selector));
}
function showWarning(text) {
    try {
        console.warn(text);
        return;
    } catch (err) {
    // err
    }
}
function createElement(tag, classes) {
    if (classes === void 0) classes = [];
    const el = document.createElement(tag);
    el.classList.add(...Array.isArray(classes) ? classes : classesToTokens(classes));
    return el;
}
function elementOffset(el) {
    const window1 = (0, _ssrWindowEsmMjs.a)();
    const document1 = (0, _ssrWindowEsmMjs.g)();
    const box = el.getBoundingClientRect();
    const body = document1.body;
    const clientTop = el.clientTop || body.clientTop || 0;
    const clientLeft = el.clientLeft || body.clientLeft || 0;
    const scrollTop = el === window1 ? window1.scrollY : el.scrollTop;
    const scrollLeft = el === window1 ? window1.scrollX : el.scrollLeft;
    return {
        top: box.top + scrollTop - clientTop,
        left: box.left + scrollLeft - clientLeft
    };
}
function elementPrevAll(el, selector) {
    const prevEls = [];
    while(el.previousElementSibling){
        const prev = el.previousElementSibling; // eslint-disable-line
        if (selector) {
            if (prev.matches(selector)) prevEls.push(prev);
        } else prevEls.push(prev);
        el = prev;
    }
    return prevEls;
}
function elementNextAll(el, selector) {
    const nextEls = [];
    while(el.nextElementSibling){
        const next = el.nextElementSibling; // eslint-disable-line
        if (selector) {
            if (next.matches(selector)) nextEls.push(next);
        } else nextEls.push(next);
        el = next;
    }
    return nextEls;
}
function elementStyle(el, prop) {
    const window1 = (0, _ssrWindowEsmMjs.a)();
    return window1.getComputedStyle(el, null).getPropertyValue(prop);
}
function elementIndex(el) {
    let child = el;
    let i;
    if (child) {
        i = 0;
        // eslint-disable-next-line
        while((child = child.previousSibling) !== null)if (child.nodeType === 1) i += 1;
        return i;
    }
    return undefined;
}
function elementParents(el, selector) {
    const parents = []; // eslint-disable-line
    let parent = el.parentElement; // eslint-disable-line
    while(parent){
        if (selector) {
            if (parent.matches(selector)) parents.push(parent);
        } else parents.push(parent);
        parent = parent.parentElement;
    }
    return parents;
}
function elementTransitionEnd(el, callback) {
    function fireCallBack(e) {
        if (e.target !== el) return;
        callback.call(el, e);
        el.removeEventListener("transitionend", fireCallBack);
    }
    if (callback) el.addEventListener("transitionend", fireCallBack);
}
function elementOuterSize(el, size, includeMargins) {
    const window1 = (0, _ssrWindowEsmMjs.a)();
    if (includeMargins) return el[size === "width" ? "offsetWidth" : "offsetHeight"] + parseFloat(window1.getComputedStyle(el, null).getPropertyValue(size === "width" ? "margin-right" : "margin-top")) + parseFloat(window1.getComputedStyle(el, null).getPropertyValue(size === "width" ? "margin-left" : "margin-bottom"));
    return el.offsetWidth;
}

},{"./ssr-window.esm.mjs":"ehIRJ","@parcel/transformer-js/src/esmodule-helpers.js":"90RNB"}],"9duxt":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Virtual", ()=>(0, _virtualMjsDefault.default));
parcelHelpers.export(exports, "Keyboard", ()=>(0, _keyboardMjsDefault.default));
parcelHelpers.export(exports, "Mousewheel", ()=>(0, _mousewheelMjsDefault.default));
parcelHelpers.export(exports, "Navigation", ()=>(0, _navigationMjsDefault.default));
parcelHelpers.export(exports, "Pagination", ()=>(0, _paginationMjsDefault.default));
parcelHelpers.export(exports, "Scrollbar", ()=>(0, _scrollbarMjsDefault.default));
parcelHelpers.export(exports, "Parallax", ()=>(0, _parallaxMjsDefault.default));
parcelHelpers.export(exports, "Zoom", ()=>(0, _zoomMjsDefault.default));
parcelHelpers.export(exports, "Controller", ()=>(0, _controllerMjsDefault.default));
parcelHelpers.export(exports, "A11y", ()=>(0, _a11YMjsDefault.default));
parcelHelpers.export(exports, "History", ()=>(0, _historyMjsDefault.default));
parcelHelpers.export(exports, "HashNavigation", ()=>(0, _hashNavigationMjsDefault.default));
parcelHelpers.export(exports, "Autoplay", ()=>(0, _autoplayMjsDefault.default));
parcelHelpers.export(exports, "Thumbs", ()=>(0, _thumbsMjsDefault.default));
parcelHelpers.export(exports, "FreeMode", ()=>(0, _freeModeMjsDefault.default));
parcelHelpers.export(exports, "Grid", ()=>(0, _gridMjsDefault.default));
parcelHelpers.export(exports, "Manipulation", ()=>(0, _manipulationMjsDefault.default));
parcelHelpers.export(exports, "EffectFade", ()=>(0, _effectFadeMjsDefault.default));
parcelHelpers.export(exports, "EffectCube", ()=>(0, _effectCubeMjsDefault.default));
parcelHelpers.export(exports, "EffectFlip", ()=>(0, _effectFlipMjsDefault.default));
parcelHelpers.export(exports, "EffectCoverflow", ()=>(0, _effectCoverflowMjsDefault.default));
parcelHelpers.export(exports, "EffectCreative", ()=>(0, _effectCreativeMjsDefault.default));
parcelHelpers.export(exports, "EffectCards", ()=>(0, _effectCardsMjsDefault.default));
var _virtualMjs = require("./virtual.mjs");
var _virtualMjsDefault = parcelHelpers.interopDefault(_virtualMjs);
var _keyboardMjs = require("./keyboard.mjs");
var _keyboardMjsDefault = parcelHelpers.interopDefault(_keyboardMjs);
var _mousewheelMjs = require("./mousewheel.mjs");
var _mousewheelMjsDefault = parcelHelpers.interopDefault(_mousewheelMjs);
var _navigationMjs = require("./navigation.mjs");
var _navigationMjsDefault = parcelHelpers.interopDefault(_navigationMjs);
var _paginationMjs = require("./pagination.mjs");
var _paginationMjsDefault = parcelHelpers.interopDefault(_paginationMjs);
var _scrollbarMjs = require("./scrollbar.mjs");
var _scrollbarMjsDefault = parcelHelpers.interopDefault(_scrollbarMjs);
var _parallaxMjs = require("./parallax.mjs");
var _parallaxMjsDefault = parcelHelpers.interopDefault(_parallaxMjs);
var _zoomMjs = require("./zoom.mjs");
var _zoomMjsDefault = parcelHelpers.interopDefault(_zoomMjs);
var _controllerMjs = require("./controller.mjs");
var _controllerMjsDefault = parcelHelpers.interopDefault(_controllerMjs);
var _a11YMjs = require("./a11y.mjs");
var _a11YMjsDefault = parcelHelpers.interopDefault(_a11YMjs);
var _historyMjs = require("./history.mjs");
var _historyMjsDefault = parcelHelpers.interopDefault(_historyMjs);
var _hashNavigationMjs = require("./hash-navigation.mjs");
var _hashNavigationMjsDefault = parcelHelpers.interopDefault(_hashNavigationMjs);
var _autoplayMjs = require("./autoplay.mjs");
var _autoplayMjsDefault = parcelHelpers.interopDefault(_autoplayMjs);
var _thumbsMjs = require("./thumbs.mjs");
var _thumbsMjsDefault = parcelHelpers.interopDefault(_thumbsMjs);
var _freeModeMjs = require("./free-mode.mjs");
var _freeModeMjsDefault = parcelHelpers.interopDefault(_freeModeMjs);
var _gridMjs = require("./grid.mjs");
var _gridMjsDefault = parcelHelpers.interopDefault(_gridMjs);
var _manipulationMjs = require("./manipulation.mjs");
var _manipulationMjsDefault = parcelHelpers.interopDefault(_manipulationMjs);
var _effectFadeMjs = require("./effect-fade.mjs");
var _effectFadeMjsDefault = parcelHelpers.interopDefault(_effectFadeMjs);
var _effectCubeMjs = require("./effect-cube.mjs");
var _effectCubeMjsDefault = parcelHelpers.interopDefault(_effectCubeMjs);
var _effectFlipMjs = require("./effect-flip.mjs");
var _effectFlipMjsDefault = parcelHelpers.interopDefault(_effectFlipMjs);
var _effectCoverflowMjs = require("./effect-coverflow.mjs");
var _effectCoverflowMjsDefault = parcelHelpers.interopDefault(_effectCoverflowMjs);
var _effectCreativeMjs = require("./effect-creative.mjs");
var _effectCreativeMjsDefault = parcelHelpers.interopDefault(_effectCreativeMjs);
var _effectCardsMjs = require("./effect-cards.mjs");
var _effectCardsMjsDefault = parcelHelpers.interopDefault(_effectCardsMjs);

},{"./virtual.mjs":"8U59A","./keyboard.mjs":"dr754","./mousewheel.mjs":"7ozZO","./navigation.mjs":"j6snx","./pagination.mjs":"cM3gG","./scrollbar.mjs":"5ZA4Z","./parallax.mjs":"4xTpT","./zoom.mjs":"5sqWT","./controller.mjs":"jGerC","./a11y.mjs":"2VqlZ","./history.mjs":"kinZy","./hash-navigation.mjs":"5e3ak","./autoplay.mjs":"ahAVy","./thumbs.mjs":"32RsP","./free-mode.mjs":"hmLnH","./grid.mjs":"47ZXi","./manipulation.mjs":"eBqLo","./effect-fade.mjs":"igJ1Q","./effect-cube.mjs":"1fB7X","./effect-flip.mjs":"bGdX1","./effect-coverflow.mjs":"che9E","./effect-creative.mjs":"3Kr0j","./effect-cards.mjs":"lwNtT","@parcel/transformer-js/src/esmodule-helpers.js":"90RNB"}],"8U59A":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>Virtual);
var _ssrWindowEsmMjs = require("../shared/ssr-window.esm.mjs");
var _utilsMjs = require("../shared/utils.mjs");
function Virtual(_ref) {
    let { swiper, extendParams, on, emit } = _ref;
    extendParams({
        virtual: {
            enabled: false,
            slides: [],
            cache: true,
            renderSlide: null,
            renderExternal: null,
            renderExternalUpdate: true,
            addSlidesBefore: 0,
            addSlidesAfter: 0
        }
    });
    let cssModeTimeout;
    const document = (0, _ssrWindowEsmMjs.g)();
    swiper.virtual = {
        cache: {},
        from: undefined,
        to: undefined,
        slides: [],
        offset: 0,
        slidesGrid: []
    };
    const tempDOM = document.createElement("div");
    function renderSlide(slide, index) {
        const params = swiper.params.virtual;
        if (params.cache && swiper.virtual.cache[index]) return swiper.virtual.cache[index];
        // eslint-disable-next-line
        let slideEl;
        if (params.renderSlide) {
            slideEl = params.renderSlide.call(swiper, slide, index);
            if (typeof slideEl === "string") {
                tempDOM.innerHTML = slideEl;
                slideEl = tempDOM.children[0];
            }
        } else if (swiper.isElement) slideEl = (0, _utilsMjs.c)("swiper-slide");
        else slideEl = (0, _utilsMjs.c)("div", swiper.params.slideClass);
        slideEl.setAttribute("data-swiper-slide-index", index);
        if (!params.renderSlide) slideEl.innerHTML = slide;
        if (params.cache) swiper.virtual.cache[index] = slideEl;
        return slideEl;
    }
    function update(force) {
        const { slidesPerView, slidesPerGroup, centeredSlides, loop: isLoop } = swiper.params;
        const { addSlidesBefore, addSlidesAfter } = swiper.params.virtual;
        const { from: previousFrom, to: previousTo, slides, slidesGrid: previousSlidesGrid, offset: previousOffset } = swiper.virtual;
        if (!swiper.params.cssMode) swiper.updateActiveIndex();
        const activeIndex = swiper.activeIndex || 0;
        let offsetProp;
        if (swiper.rtlTranslate) offsetProp = "right";
        else offsetProp = swiper.isHorizontal() ? "left" : "top";
        let slidesAfter;
        let slidesBefore;
        if (centeredSlides) {
            slidesAfter = Math.floor(slidesPerView / 2) + slidesPerGroup + addSlidesAfter;
            slidesBefore = Math.floor(slidesPerView / 2) + slidesPerGroup + addSlidesBefore;
        } else {
            slidesAfter = slidesPerView + (slidesPerGroup - 1) + addSlidesAfter;
            slidesBefore = (isLoop ? slidesPerView : slidesPerGroup) + addSlidesBefore;
        }
        let from = activeIndex - slidesBefore;
        let to = activeIndex + slidesAfter;
        if (!isLoop) {
            from = Math.max(from, 0);
            to = Math.min(to, slides.length - 1);
        }
        let offset = (swiper.slidesGrid[from] || 0) - (swiper.slidesGrid[0] || 0);
        if (isLoop && activeIndex >= slidesBefore) {
            from -= slidesBefore;
            if (!centeredSlides) offset += swiper.slidesGrid[0];
        } else if (isLoop && activeIndex < slidesBefore) {
            from = -slidesBefore;
            if (centeredSlides) offset += swiper.slidesGrid[0];
        }
        Object.assign(swiper.virtual, {
            from,
            to,
            offset,
            slidesGrid: swiper.slidesGrid,
            slidesBefore,
            slidesAfter
        });
        function onRendered() {
            swiper.updateSlides();
            swiper.updateProgress();
            swiper.updateSlidesClasses();
            emit("virtualUpdate");
        }
        if (previousFrom === from && previousTo === to && !force) {
            if (swiper.slidesGrid !== previousSlidesGrid && offset !== previousOffset) swiper.slides.forEach((slideEl)=>{
                slideEl.style[offsetProp] = `${offset - Math.abs(swiper.cssOverflowAdjustment())}px`;
            });
            swiper.updateProgress();
            emit("virtualUpdate");
            return;
        }
        if (swiper.params.virtual.renderExternal) {
            swiper.params.virtual.renderExternal.call(swiper, {
                offset,
                from,
                to,
                slides: function getSlides() {
                    const slidesToRender = [];
                    for(let i = from; i <= to; i += 1)slidesToRender.push(slides[i]);
                    return slidesToRender;
                }()
            });
            if (swiper.params.virtual.renderExternalUpdate) onRendered();
            else emit("virtualUpdate");
            return;
        }
        const prependIndexes = [];
        const appendIndexes = [];
        const getSlideIndex = (index)=>{
            let slideIndex = index;
            if (index < 0) slideIndex = slides.length + index;
            else if (slideIndex >= slides.length) // eslint-disable-next-line
            slideIndex = slideIndex - slides.length;
            return slideIndex;
        };
        if (force) swiper.slides.filter((el)=>el.matches(`.${swiper.params.slideClass}, swiper-slide`)).forEach((slideEl)=>{
            slideEl.remove();
        });
        else {
            for(let i = previousFrom; i <= previousTo; i += 1)if (i < from || i > to) {
                const slideIndex = getSlideIndex(i);
                swiper.slides.filter((el)=>el.matches(`.${swiper.params.slideClass}[data-swiper-slide-index="${slideIndex}"], swiper-slide[data-swiper-slide-index="${slideIndex}"]`)).forEach((slideEl)=>{
                    slideEl.remove();
                });
            }
        }
        const loopFrom = isLoop ? -slides.length : 0;
        const loopTo = isLoop ? slides.length * 2 : slides.length;
        for(let i = loopFrom; i < loopTo; i += 1)if (i >= from && i <= to) {
            const slideIndex = getSlideIndex(i);
            if (typeof previousTo === "undefined" || force) appendIndexes.push(slideIndex);
            else {
                if (i > previousTo) appendIndexes.push(slideIndex);
                if (i < previousFrom) prependIndexes.push(slideIndex);
            }
        }
        appendIndexes.forEach((index)=>{
            swiper.slidesEl.append(renderSlide(slides[index], index));
        });
        if (isLoop) for(let i = prependIndexes.length - 1; i >= 0; i -= 1){
            const index = prependIndexes[i];
            swiper.slidesEl.prepend(renderSlide(slides[index], index));
        }
        else {
            prependIndexes.sort((a, b)=>b - a);
            prependIndexes.forEach((index)=>{
                swiper.slidesEl.prepend(renderSlide(slides[index], index));
            });
        }
        (0, _utilsMjs.e)(swiper.slidesEl, ".swiper-slide, swiper-slide").forEach((slideEl)=>{
            slideEl.style[offsetProp] = `${offset - Math.abs(swiper.cssOverflowAdjustment())}px`;
        });
        onRendered();
    }
    function appendSlide(slides) {
        if (typeof slides === "object" && "length" in slides) {
            for(let i = 0; i < slides.length; i += 1)if (slides[i]) swiper.virtual.slides.push(slides[i]);
        } else swiper.virtual.slides.push(slides);
        update(true);
    }
    function prependSlide(slides) {
        const activeIndex = swiper.activeIndex;
        let newActiveIndex = activeIndex + 1;
        let numberOfNewSlides = 1;
        if (Array.isArray(slides)) {
            for(let i = 0; i < slides.length; i += 1)if (slides[i]) swiper.virtual.slides.unshift(slides[i]);
            newActiveIndex = activeIndex + slides.length;
            numberOfNewSlides = slides.length;
        } else swiper.virtual.slides.unshift(slides);
        if (swiper.params.virtual.cache) {
            const cache = swiper.virtual.cache;
            const newCache = {};
            Object.keys(cache).forEach((cachedIndex)=>{
                const cachedEl = cache[cachedIndex];
                const cachedElIndex = cachedEl.getAttribute("data-swiper-slide-index");
                if (cachedElIndex) cachedEl.setAttribute("data-swiper-slide-index", parseInt(cachedElIndex, 10) + numberOfNewSlides);
                newCache[parseInt(cachedIndex, 10) + numberOfNewSlides] = cachedEl;
            });
            swiper.virtual.cache = newCache;
        }
        update(true);
        swiper.slideTo(newActiveIndex, 0);
    }
    function removeSlide(slidesIndexes) {
        if (typeof slidesIndexes === "undefined" || slidesIndexes === null) return;
        let activeIndex = swiper.activeIndex;
        if (Array.isArray(slidesIndexes)) for(let i = slidesIndexes.length - 1; i >= 0; i -= 1){
            if (swiper.params.virtual.cache) {
                delete swiper.virtual.cache[slidesIndexes[i]];
                // shift cache indexes
                Object.keys(swiper.virtual.cache).forEach((key)=>{
                    if (key > slidesIndexes) {
                        swiper.virtual.cache[key - 1] = swiper.virtual.cache[key];
                        swiper.virtual.cache[key - 1].setAttribute("data-swiper-slide-index", key - 1);
                        delete swiper.virtual.cache[key];
                    }
                });
            }
            swiper.virtual.slides.splice(slidesIndexes[i], 1);
            if (slidesIndexes[i] < activeIndex) activeIndex -= 1;
            activeIndex = Math.max(activeIndex, 0);
        }
        else {
            if (swiper.params.virtual.cache) {
                delete swiper.virtual.cache[slidesIndexes];
                // shift cache indexes
                Object.keys(swiper.virtual.cache).forEach((key)=>{
                    if (key > slidesIndexes) {
                        swiper.virtual.cache[key - 1] = swiper.virtual.cache[key];
                        swiper.virtual.cache[key - 1].setAttribute("data-swiper-slide-index", key - 1);
                        delete swiper.virtual.cache[key];
                    }
                });
            }
            swiper.virtual.slides.splice(slidesIndexes, 1);
            if (slidesIndexes < activeIndex) activeIndex -= 1;
            activeIndex = Math.max(activeIndex, 0);
        }
        update(true);
        swiper.slideTo(activeIndex, 0);
    }
    function removeAllSlides() {
        swiper.virtual.slides = [];
        if (swiper.params.virtual.cache) swiper.virtual.cache = {};
        update(true);
        swiper.slideTo(0, 0);
    }
    on("beforeInit", ()=>{
        if (!swiper.params.virtual.enabled) return;
        let domSlidesAssigned;
        if (typeof swiper.passedParams.virtual.slides === "undefined") {
            const slides = [
                ...swiper.slidesEl.children
            ].filter((el)=>el.matches(`.${swiper.params.slideClass}, swiper-slide`));
            if (slides && slides.length) {
                swiper.virtual.slides = [
                    ...slides
                ];
                domSlidesAssigned = true;
                slides.forEach((slideEl, slideIndex)=>{
                    slideEl.setAttribute("data-swiper-slide-index", slideIndex);
                    swiper.virtual.cache[slideIndex] = slideEl;
                    slideEl.remove();
                });
            }
        }
        if (!domSlidesAssigned) swiper.virtual.slides = swiper.params.virtual.slides;
        swiper.classNames.push(`${swiper.params.containerModifierClass}virtual`);
        swiper.params.watchSlidesProgress = true;
        swiper.originalParams.watchSlidesProgress = true;
        update();
    });
    on("setTranslate", ()=>{
        if (!swiper.params.virtual.enabled) return;
        if (swiper.params.cssMode && !swiper._immediateVirtual) {
            clearTimeout(cssModeTimeout);
            cssModeTimeout = setTimeout(()=>{
                update();
            }, 100);
        } else update();
    });
    on("init update resize", ()=>{
        if (!swiper.params.virtual.enabled) return;
        if (swiper.params.cssMode) (0, _utilsMjs.s)(swiper.wrapperEl, "--swiper-virtual-size", `${swiper.virtualSize}px`);
    });
    Object.assign(swiper.virtual, {
        appendSlide,
        prependSlide,
        removeSlide,
        removeAllSlides,
        update
    });
}

},{"../shared/ssr-window.esm.mjs":"ehIRJ","../shared/utils.mjs":"agmBj","@parcel/transformer-js/src/esmodule-helpers.js":"90RNB"}],"dr754":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>Keyboard);
var _ssrWindowEsmMjs = require("../shared/ssr-window.esm.mjs");
var _utilsMjs = require("../shared/utils.mjs");
/* eslint-disable consistent-return */ function Keyboard(_ref) {
    let { swiper, extendParams, on, emit } = _ref;
    const document = (0, _ssrWindowEsmMjs.g)();
    const window = (0, _ssrWindowEsmMjs.a)();
    swiper.keyboard = {
        enabled: false
    };
    extendParams({
        keyboard: {
            enabled: false,
            onlyInViewport: true,
            pageUpDown: true
        }
    });
    function handle(event) {
        if (!swiper.enabled) return;
        const { rtlTranslate: rtl } = swiper;
        let e = event;
        if (e.originalEvent) e = e.originalEvent; // jquery fix
        const kc = e.keyCode || e.charCode;
        const pageUpDown = swiper.params.keyboard.pageUpDown;
        const isPageUp = pageUpDown && kc === 33;
        const isPageDown = pageUpDown && kc === 34;
        const isArrowLeft = kc === 37;
        const isArrowRight = kc === 39;
        const isArrowUp = kc === 38;
        const isArrowDown = kc === 40;
        // Directions locks
        if (!swiper.allowSlideNext && (swiper.isHorizontal() && isArrowRight || swiper.isVertical() && isArrowDown || isPageDown)) return false;
        if (!swiper.allowSlidePrev && (swiper.isHorizontal() && isArrowLeft || swiper.isVertical() && isArrowUp || isPageUp)) return false;
        if (e.shiftKey || e.altKey || e.ctrlKey || e.metaKey) return undefined;
        if (document.activeElement && document.activeElement.nodeName && (document.activeElement.nodeName.toLowerCase() === "input" || document.activeElement.nodeName.toLowerCase() === "textarea")) return undefined;
        if (swiper.params.keyboard.onlyInViewport && (isPageUp || isPageDown || isArrowLeft || isArrowRight || isArrowUp || isArrowDown)) {
            let inView = false;
            // Check that swiper should be inside of visible area of window
            if ((0, _utilsMjs.a)(swiper.el, `.${swiper.params.slideClass}, swiper-slide`).length > 0 && (0, _utilsMjs.a)(swiper.el, `.${swiper.params.slideActiveClass}`).length === 0) return undefined;
            const el = swiper.el;
            const swiperWidth = el.clientWidth;
            const swiperHeight = el.clientHeight;
            const windowWidth = window.innerWidth;
            const windowHeight = window.innerHeight;
            const swiperOffset = (0, _utilsMjs.b)(el);
            if (rtl) swiperOffset.left -= el.scrollLeft;
            const swiperCoord = [
                [
                    swiperOffset.left,
                    swiperOffset.top
                ],
                [
                    swiperOffset.left + swiperWidth,
                    swiperOffset.top
                ],
                [
                    swiperOffset.left,
                    swiperOffset.top + swiperHeight
                ],
                [
                    swiperOffset.left + swiperWidth,
                    swiperOffset.top + swiperHeight
                ]
            ];
            for(let i = 0; i < swiperCoord.length; i += 1){
                const point = swiperCoord[i];
                if (point[0] >= 0 && point[0] <= windowWidth && point[1] >= 0 && point[1] <= windowHeight) {
                    if (point[0] === 0 && point[1] === 0) continue; // eslint-disable-line
                    inView = true;
                }
            }
            if (!inView) return undefined;
        }
        if (swiper.isHorizontal()) {
            if (isPageUp || isPageDown || isArrowLeft || isArrowRight) {
                if (e.preventDefault) e.preventDefault();
                else e.returnValue = false;
            }
            if ((isPageDown || isArrowRight) && !rtl || (isPageUp || isArrowLeft) && rtl) swiper.slideNext();
            if ((isPageUp || isArrowLeft) && !rtl || (isPageDown || isArrowRight) && rtl) swiper.slidePrev();
        } else {
            if (isPageUp || isPageDown || isArrowUp || isArrowDown) {
                if (e.preventDefault) e.preventDefault();
                else e.returnValue = false;
            }
            if (isPageDown || isArrowDown) swiper.slideNext();
            if (isPageUp || isArrowUp) swiper.slidePrev();
        }
        emit("keyPress", kc);
        return undefined;
    }
    function enable() {
        if (swiper.keyboard.enabled) return;
        document.addEventListener("keydown", handle);
        swiper.keyboard.enabled = true;
    }
    function disable() {
        if (!swiper.keyboard.enabled) return;
        document.removeEventListener("keydown", handle);
        swiper.keyboard.enabled = false;
    }
    on("init", ()=>{
        if (swiper.params.keyboard.enabled) enable();
    });
    on("destroy", ()=>{
        if (swiper.keyboard.enabled) disable();
    });
    Object.assign(swiper.keyboard, {
        enable,
        disable
    });
}

},{"../shared/ssr-window.esm.mjs":"ehIRJ","../shared/utils.mjs":"agmBj","@parcel/transformer-js/src/esmodule-helpers.js":"90RNB"}],"7ozZO":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>Mousewheel);
var _ssrWindowEsmMjs = require("../shared/ssr-window.esm.mjs");
var _utilsMjs = require("../shared/utils.mjs");
/* eslint-disable consistent-return */ function Mousewheel(_ref) {
    let { swiper, extendParams, on, emit } = _ref;
    const window = (0, _ssrWindowEsmMjs.a)();
    extendParams({
        mousewheel: {
            enabled: false,
            releaseOnEdges: false,
            invert: false,
            forceToAxis: false,
            sensitivity: 1,
            eventsTarget: "container",
            thresholdDelta: null,
            thresholdTime: null,
            noMousewheelClass: "swiper-no-mousewheel"
        }
    });
    swiper.mousewheel = {
        enabled: false
    };
    let timeout;
    let lastScrollTime = (0, _utilsMjs.d)();
    let lastEventBeforeSnap;
    const recentWheelEvents = [];
    function normalize(e) {
        // Reasonable defaults
        const PIXEL_STEP = 10;
        const LINE_HEIGHT = 40;
        const PAGE_HEIGHT = 800;
        let sX = 0;
        let sY = 0; // spinX, spinY
        let pX = 0;
        let pY = 0; // pixelX, pixelY
        // Legacy
        if ("detail" in e) sY = e.detail;
        if ("wheelDelta" in e) sY = -e.wheelDelta / 120;
        if ("wheelDeltaY" in e) sY = -e.wheelDeltaY / 120;
        if ("wheelDeltaX" in e) sX = -e.wheelDeltaX / 120;
        // side scrolling on FF with DOMMouseScroll
        if ("axis" in e && e.axis === e.HORIZONTAL_AXIS) {
            sX = sY;
            sY = 0;
        }
        pX = sX * PIXEL_STEP;
        pY = sY * PIXEL_STEP;
        if ("deltaY" in e) pY = e.deltaY;
        if ("deltaX" in e) pX = e.deltaX;
        if (e.shiftKey && !pX) {
            // if user scrolls with shift he wants horizontal scroll
            pX = pY;
            pY = 0;
        }
        if ((pX || pY) && e.deltaMode) {
            if (e.deltaMode === 1) {
                // delta in LINE units
                pX *= LINE_HEIGHT;
                pY *= LINE_HEIGHT;
            } else {
                // delta in PAGE units
                pX *= PAGE_HEIGHT;
                pY *= PAGE_HEIGHT;
            }
        }
        // Fall-back if spin cannot be determined
        if (pX && !sX) sX = pX < 1 ? -1 : 1;
        if (pY && !sY) sY = pY < 1 ? -1 : 1;
        return {
            spinX: sX,
            spinY: sY,
            pixelX: pX,
            pixelY: pY
        };
    }
    function handleMouseEnter() {
        if (!swiper.enabled) return;
        swiper.mouseEntered = true;
    }
    function handleMouseLeave() {
        if (!swiper.enabled) return;
        swiper.mouseEntered = false;
    }
    function animateSlider(newEvent) {
        if (swiper.params.mousewheel.thresholdDelta && newEvent.delta < swiper.params.mousewheel.thresholdDelta) // Prevent if delta of wheel scroll delta is below configured threshold
        return false;
        if (swiper.params.mousewheel.thresholdTime && (0, _utilsMjs.d)() - lastScrollTime < swiper.params.mousewheel.thresholdTime) // Prevent if time between scrolls is below configured threshold
        return false;
        // If the movement is NOT big enough and
        // if the last time the user scrolled was too close to the current one (avoid continuously triggering the slider):
        //   Don't go any further (avoid insignificant scroll movement).
        if (newEvent.delta >= 6 && (0, _utilsMjs.d)() - lastScrollTime < 60) // Return false as a default
        return true;
        // If user is scrolling towards the end:
        //   If the slider hasn't hit the latest slide or
        //   if the slider is a loop and
        //   if the slider isn't moving right now:
        //     Go to next slide and
        //     emit a scroll event.
        // Else (the user is scrolling towards the beginning) and
        // if the slider hasn't hit the first slide or
        // if the slider is a loop and
        // if the slider isn't moving right now:
        //   Go to prev slide and
        //   emit a scroll event.
        if (newEvent.direction < 0) {
            if ((!swiper.isEnd || swiper.params.loop) && !swiper.animating) {
                swiper.slideNext();
                emit("scroll", newEvent.raw);
            }
        } else if ((!swiper.isBeginning || swiper.params.loop) && !swiper.animating) {
            swiper.slidePrev();
            emit("scroll", newEvent.raw);
        }
        // If you got here is because an animation has been triggered so store the current time
        lastScrollTime = new window.Date().getTime();
        // Return false as a default
        return false;
    }
    function releaseScroll(newEvent) {
        const params = swiper.params.mousewheel;
        if (newEvent.direction < 0) {
            if (swiper.isEnd && !swiper.params.loop && params.releaseOnEdges) // Return true to animate scroll on edges
            return true;
        } else if (swiper.isBeginning && !swiper.params.loop && params.releaseOnEdges) // Return true to animate scroll on edges
        return true;
        return false;
    }
    function handle(event1) {
        let e = event1;
        let disableParentSwiper = true;
        if (!swiper.enabled) return;
        // Ignore event if the target or its parents have the swiper-no-mousewheel class
        if (event1.target.closest(`.${swiper.params.mousewheel.noMousewheelClass}`)) return;
        const params = swiper.params.mousewheel;
        if (swiper.params.cssMode) e.preventDefault();
        let targetEl = swiper.el;
        if (swiper.params.mousewheel.eventsTarget !== "container") targetEl = document.querySelector(swiper.params.mousewheel.eventsTarget);
        const targetElContainsTarget = targetEl && targetEl.contains(e.target);
        if (!swiper.mouseEntered && !targetElContainsTarget && !params.releaseOnEdges) return true;
        if (e.originalEvent) e = e.originalEvent; // jquery fix
        let delta = 0;
        const rtlFactor = swiper.rtlTranslate ? -1 : 1;
        const data = normalize(e);
        if (params.forceToAxis) {
            if (swiper.isHorizontal()) {
                if (Math.abs(data.pixelX) > Math.abs(data.pixelY)) delta = -data.pixelX * rtlFactor;
                else return true;
            } else if (Math.abs(data.pixelY) > Math.abs(data.pixelX)) delta = -data.pixelY;
            else return true;
        } else delta = Math.abs(data.pixelX) > Math.abs(data.pixelY) ? -data.pixelX * rtlFactor : -data.pixelY;
        if (delta === 0) return true;
        if (params.invert) delta = -delta;
        // Get the scroll positions
        let positions = swiper.getTranslate() + delta * params.sensitivity;
        if (positions >= swiper.minTranslate()) positions = swiper.minTranslate();
        if (positions <= swiper.maxTranslate()) positions = swiper.maxTranslate();
        // When loop is true:
        //     the disableParentSwiper will be true.
        // When loop is false:
        //     if the scroll positions is not on edge,
        //     then the disableParentSwiper will be true.
        //     if the scroll on edge positions,
        //     then the disableParentSwiper will be false.
        disableParentSwiper = swiper.params.loop ? true : !(positions === swiper.minTranslate() || positions === swiper.maxTranslate());
        if (disableParentSwiper && swiper.params.nested) e.stopPropagation();
        if (!swiper.params.freeMode || !swiper.params.freeMode.enabled) {
            // Register the new event in a variable which stores the relevant data
            const newEvent = {
                time: (0, _utilsMjs.d)(),
                delta: Math.abs(delta),
                direction: Math.sign(delta),
                raw: event1
            };
            // Keep the most recent events
            if (recentWheelEvents.length >= 2) recentWheelEvents.shift(); // only store the last N events
            const prevEvent = recentWheelEvents.length ? recentWheelEvents[recentWheelEvents.length - 1] : undefined;
            recentWheelEvents.push(newEvent);
            // If there is at least one previous recorded event:
            //   If direction has changed or
            //   if the scroll is quicker than the previous one:
            //     Animate the slider.
            // Else (this is the first time the wheel is moved):
            //     Animate the slider.
            if (prevEvent) {
                if (newEvent.direction !== prevEvent.direction || newEvent.delta > prevEvent.delta || newEvent.time > prevEvent.time + 150) animateSlider(newEvent);
            } else animateSlider(newEvent);
            // If it's time to release the scroll:
            //   Return now so you don't hit the preventDefault.
            if (releaseScroll(newEvent)) return true;
        } else {
            // Freemode or scrollContainer:
            // If we recently snapped after a momentum scroll, then ignore wheel events
            // to give time for the deceleration to finish. Stop ignoring after 500 msecs
            // or if it's a new scroll (larger delta or inverse sign as last event before
            // an end-of-momentum snap).
            const newEvent = {
                time: (0, _utilsMjs.d)(),
                delta: Math.abs(delta),
                direction: Math.sign(delta)
            };
            const ignoreWheelEvents = lastEventBeforeSnap && newEvent.time < lastEventBeforeSnap.time + 500 && newEvent.delta <= lastEventBeforeSnap.delta && newEvent.direction === lastEventBeforeSnap.direction;
            if (!ignoreWheelEvents) {
                lastEventBeforeSnap = undefined;
                let position = swiper.getTranslate() + delta * params.sensitivity;
                const wasBeginning = swiper.isBeginning;
                const wasEnd = swiper.isEnd;
                if (position >= swiper.minTranslate()) position = swiper.minTranslate();
                if (position <= swiper.maxTranslate()) position = swiper.maxTranslate();
                swiper.setTransition(0);
                swiper.setTranslate(position);
                swiper.updateProgress();
                swiper.updateActiveIndex();
                swiper.updateSlidesClasses();
                if (!wasBeginning && swiper.isBeginning || !wasEnd && swiper.isEnd) swiper.updateSlidesClasses();
                if (swiper.params.loop) swiper.loopFix({
                    direction: newEvent.direction < 0 ? "next" : "prev",
                    byMousewheel: true
                });
                if (swiper.params.freeMode.sticky) {
                    // When wheel scrolling starts with sticky (aka snap) enabled, then detect
                    // the end of a momentum scroll by storing recent (N=15?) wheel events.
                    // 1. do all N events have decreasing or same (absolute value) delta?
                    // 2. did all N events arrive in the last M (M=500?) msecs?
                    // 3. does the earliest event have an (absolute value) delta that's
                    //    at least P (P=1?) larger than the most recent event's delta?
                    // 4. does the latest event have a delta that's smaller than Q (Q=6?) pixels?
                    // If 1-4 are "yes" then we're near the end of a momentum scroll deceleration.
                    // Snap immediately and ignore remaining wheel events in this scroll.
                    // See comment above for "remaining wheel events in this scroll" determination.
                    // If 1-4 aren't satisfied, then wait to snap until 500ms after the last event.
                    clearTimeout(timeout);
                    timeout = undefined;
                    if (recentWheelEvents.length >= 15) recentWheelEvents.shift(); // only store the last N events
                    const prevEvent = recentWheelEvents.length ? recentWheelEvents[recentWheelEvents.length - 1] : undefined;
                    const firstEvent = recentWheelEvents[0];
                    recentWheelEvents.push(newEvent);
                    if (prevEvent && (newEvent.delta > prevEvent.delta || newEvent.direction !== prevEvent.direction)) // Increasing or reverse-sign delta means the user started scrolling again. Clear the wheel event log.
                    recentWheelEvents.splice(0);
                    else if (recentWheelEvents.length >= 15 && newEvent.time - firstEvent.time < 500 && firstEvent.delta - newEvent.delta >= 1 && newEvent.delta <= 6) {
                        // We're at the end of the deceleration of a momentum scroll, so there's no need
                        // to wait for more events. Snap ASAP on the next tick.
                        // Also, because there's some remaining momentum we'll bias the snap in the
                        // direction of the ongoing scroll because it's better UX for the scroll to snap
                        // in the same direction as the scroll instead of reversing to snap.  Therefore,
                        // if it's already scrolled more than 20% in the current direction, keep going.
                        const snapToThreshold = delta > 0 ? 0.8 : 0.2;
                        lastEventBeforeSnap = newEvent;
                        recentWheelEvents.splice(0);
                        timeout = (0, _utilsMjs.n)(()=>{
                            swiper.slideToClosest(swiper.params.speed, true, undefined, snapToThreshold);
                        }, 0); // no delay; move on next tick
                    }
                    if (!timeout) // if we get here, then we haven't detected the end of a momentum scroll, so
                    // we'll consider a scroll "complete" when there haven't been any wheel events
                    // for 500ms.
                    timeout = (0, _utilsMjs.n)(()=>{
                        const snapToThreshold = 0.5;
                        lastEventBeforeSnap = newEvent;
                        recentWheelEvents.splice(0);
                        swiper.slideToClosest(swiper.params.speed, true, undefined, snapToThreshold);
                    }, 500);
                }
                // Emit event
                if (!ignoreWheelEvents) emit("scroll", e);
                // Stop autoplay
                if (swiper.params.autoplay && swiper.params.autoplayDisableOnInteraction) swiper.autoplay.stop();
                // Return page scroll on edge positions
                if (params.releaseOnEdges && (position === swiper.minTranslate() || position === swiper.maxTranslate())) return true;
            }
        }
        if (e.preventDefault) e.preventDefault();
        else e.returnValue = false;
        return false;
    }
    function events(method) {
        let targetEl = swiper.el;
        if (swiper.params.mousewheel.eventsTarget !== "container") targetEl = document.querySelector(swiper.params.mousewheel.eventsTarget);
        targetEl[method]("mouseenter", handleMouseEnter);
        targetEl[method]("mouseleave", handleMouseLeave);
        targetEl[method]("wheel", handle);
    }
    function enable() {
        if (swiper.params.cssMode) {
            swiper.wrapperEl.removeEventListener("wheel", handle);
            return true;
        }
        if (swiper.mousewheel.enabled) return false;
        events("addEventListener");
        swiper.mousewheel.enabled = true;
        return true;
    }
    function disable() {
        if (swiper.params.cssMode) {
            swiper.wrapperEl.addEventListener(event, handle);
            return true;
        }
        if (!swiper.mousewheel.enabled) return false;
        events("removeEventListener");
        swiper.mousewheel.enabled = false;
        return true;
    }
    on("init", ()=>{
        if (!swiper.params.mousewheel.enabled && swiper.params.cssMode) disable();
        if (swiper.params.mousewheel.enabled) enable();
    });
    on("destroy", ()=>{
        if (swiper.params.cssMode) enable();
        if (swiper.mousewheel.enabled) disable();
    });
    Object.assign(swiper.mousewheel, {
        enable,
        disable
    });
}

},{"../shared/ssr-window.esm.mjs":"ehIRJ","../shared/utils.mjs":"agmBj","@parcel/transformer-js/src/esmodule-helpers.js":"90RNB"}],"j6snx":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>Navigation);
var _createElementIfNotDefinedMjs = require("../shared/create-element-if-not-defined.mjs");
function Navigation(_ref) {
    let { swiper, extendParams, on, emit } = _ref;
    extendParams({
        navigation: {
            nextEl: null,
            prevEl: null,
            hideOnClick: false,
            disabledClass: "swiper-button-disabled",
            hiddenClass: "swiper-button-hidden",
            lockClass: "swiper-button-lock",
            navigationDisabledClass: "swiper-navigation-disabled"
        }
    });
    swiper.navigation = {
        nextEl: null,
        prevEl: null
    };
    const makeElementsArray = (el)=>(Array.isArray(el) ? el : [
            el
        ]).filter((e)=>!!e);
    function getEl(el) {
        let res;
        if (el && typeof el === "string" && swiper.isElement) {
            res = swiper.el.querySelector(el);
            if (res) return res;
        }
        if (el) {
            if (typeof el === "string") res = [
                ...document.querySelectorAll(el)
            ];
            if (swiper.params.uniqueNavElements && typeof el === "string" && res.length > 1 && swiper.el.querySelectorAll(el).length === 1) res = swiper.el.querySelector(el);
        }
        if (el && !res) return el;
        // if (Array.isArray(res) && res.length === 1) res = res[0];
        return res;
    }
    function toggleEl(el, disabled) {
        const params = swiper.params.navigation;
        el = makeElementsArray(el);
        el.forEach((subEl)=>{
            if (subEl) {
                subEl.classList[disabled ? "add" : "remove"](...params.disabledClass.split(" "));
                if (subEl.tagName === "BUTTON") subEl.disabled = disabled;
                if (swiper.params.watchOverflow && swiper.enabled) subEl.classList[swiper.isLocked ? "add" : "remove"](params.lockClass);
            }
        });
    }
    function update() {
        // Update Navigation Buttons
        const { nextEl, prevEl } = swiper.navigation;
        if (swiper.params.loop) {
            toggleEl(prevEl, false);
            toggleEl(nextEl, false);
            return;
        }
        toggleEl(prevEl, swiper.isBeginning && !swiper.params.rewind);
        toggleEl(nextEl, swiper.isEnd && !swiper.params.rewind);
    }
    function onPrevClick(e) {
        e.preventDefault();
        if (swiper.isBeginning && !swiper.params.loop && !swiper.params.rewind) return;
        swiper.slidePrev();
        emit("navigationPrev");
    }
    function onNextClick(e) {
        e.preventDefault();
        if (swiper.isEnd && !swiper.params.loop && !swiper.params.rewind) return;
        swiper.slideNext();
        emit("navigationNext");
    }
    function init() {
        const params = swiper.params.navigation;
        swiper.params.navigation = (0, _createElementIfNotDefinedMjs.c)(swiper, swiper.originalParams.navigation, swiper.params.navigation, {
            nextEl: "swiper-button-next",
            prevEl: "swiper-button-prev"
        });
        if (!(params.nextEl || params.prevEl)) return;
        let nextEl = getEl(params.nextEl);
        let prevEl = getEl(params.prevEl);
        Object.assign(swiper.navigation, {
            nextEl,
            prevEl
        });
        nextEl = makeElementsArray(nextEl);
        prevEl = makeElementsArray(prevEl);
        const initButton = (el, dir)=>{
            if (el) el.addEventListener("click", dir === "next" ? onNextClick : onPrevClick);
            if (!swiper.enabled && el) el.classList.add(...params.lockClass.split(" "));
        };
        nextEl.forEach((el)=>initButton(el, "next"));
        prevEl.forEach((el)=>initButton(el, "prev"));
    }
    function destroy() {
        let { nextEl, prevEl } = swiper.navigation;
        nextEl = makeElementsArray(nextEl);
        prevEl = makeElementsArray(prevEl);
        const destroyButton = (el, dir)=>{
            el.removeEventListener("click", dir === "next" ? onNextClick : onPrevClick);
            el.classList.remove(...swiper.params.navigation.disabledClass.split(" "));
        };
        nextEl.forEach((el)=>destroyButton(el, "next"));
        prevEl.forEach((el)=>destroyButton(el, "prev"));
    }
    on("init", ()=>{
        if (swiper.params.navigation.enabled === false) // eslint-disable-next-line
        disable();
        else {
            init();
            update();
        }
    });
    on("toEdge fromEdge lock unlock", ()=>{
        update();
    });
    on("destroy", ()=>{
        destroy();
    });
    on("enable disable", ()=>{
        let { nextEl, prevEl } = swiper.navigation;
        nextEl = makeElementsArray(nextEl);
        prevEl = makeElementsArray(prevEl);
        if (swiper.enabled) {
            update();
            return;
        }
        [
            ...nextEl,
            ...prevEl
        ].filter((el)=>!!el).forEach((el)=>el.classList.add(swiper.params.navigation.lockClass));
    });
    on("click", (_s, e)=>{
        let { nextEl, prevEl } = swiper.navigation;
        nextEl = makeElementsArray(nextEl);
        prevEl = makeElementsArray(prevEl);
        const targetEl = e.target;
        if (swiper.params.navigation.hideOnClick && !prevEl.includes(targetEl) && !nextEl.includes(targetEl)) {
            if (swiper.pagination && swiper.params.pagination && swiper.params.pagination.clickable && (swiper.pagination.el === targetEl || swiper.pagination.el.contains(targetEl))) return;
            let isHidden;
            if (nextEl.length) isHidden = nextEl[0].classList.contains(swiper.params.navigation.hiddenClass);
            else if (prevEl.length) isHidden = prevEl[0].classList.contains(swiper.params.navigation.hiddenClass);
            if (isHidden === true) emit("navigationShow");
            else emit("navigationHide");
            [
                ...nextEl,
                ...prevEl
            ].filter((el)=>!!el).forEach((el)=>el.classList.toggle(swiper.params.navigation.hiddenClass));
        }
    });
    const enable = ()=>{
        swiper.el.classList.remove(...swiper.params.navigation.navigationDisabledClass.split(" "));
        init();
        update();
    };
    const disable = ()=>{
        swiper.el.classList.add(...swiper.params.navigation.navigationDisabledClass.split(" "));
        destroy();
    };
    Object.assign(swiper.navigation, {
        enable,
        disable,
        update,
        init,
        destroy
    });
}

},{"../shared/create-element-if-not-defined.mjs":"lYyyd","@parcel/transformer-js/src/esmodule-helpers.js":"90RNB"}],"lYyyd":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "c", ()=>createElementIfNotDefined);
var _utilsMjs = require("./utils.mjs");
function createElementIfNotDefined(swiper, originalParams, params, checkProps) {
    if (swiper.params.createElements) Object.keys(checkProps).forEach((key)=>{
        if (!params[key] && params.auto === true) {
            let element = (0, _utilsMjs.e)(swiper.el, `.${checkProps[key]}`)[0];
            if (!element) {
                element = (0, _utilsMjs.c)("div", checkProps[key]);
                element.className = checkProps[key];
                swiper.el.append(element);
            }
            params[key] = element;
            originalParams[key] = element;
        }
    });
    return params;
}

},{"./utils.mjs":"agmBj","@parcel/transformer-js/src/esmodule-helpers.js":"90RNB"}],"cM3gG":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>Pagination);
var _classesToSelectorMjs = require("../shared/classes-to-selector.mjs");
var _createElementIfNotDefinedMjs = require("../shared/create-element-if-not-defined.mjs");
var _utilsMjs = require("../shared/utils.mjs");
function Pagination(_ref) {
    let { swiper, extendParams, on, emit } = _ref;
    const pfx = "swiper-pagination";
    extendParams({
        pagination: {
            el: null,
            bulletElement: "span",
            clickable: false,
            hideOnClick: false,
            renderBullet: null,
            renderProgressbar: null,
            renderFraction: null,
            renderCustom: null,
            progressbarOpposite: false,
            type: "bullets",
            // 'bullets' or 'progressbar' or 'fraction' or 'custom'
            dynamicBullets: false,
            dynamicMainBullets: 1,
            formatFractionCurrent: (number)=>number,
            formatFractionTotal: (number)=>number,
            bulletClass: `${pfx}-bullet`,
            bulletActiveClass: `${pfx}-bullet-active`,
            modifierClass: `${pfx}-`,
            currentClass: `${pfx}-current`,
            totalClass: `${pfx}-total`,
            hiddenClass: `${pfx}-hidden`,
            progressbarFillClass: `${pfx}-progressbar-fill`,
            progressbarOppositeClass: `${pfx}-progressbar-opposite`,
            clickableClass: `${pfx}-clickable`,
            lockClass: `${pfx}-lock`,
            horizontalClass: `${pfx}-horizontal`,
            verticalClass: `${pfx}-vertical`,
            paginationDisabledClass: `${pfx}-disabled`
        }
    });
    swiper.pagination = {
        el: null,
        bullets: []
    };
    let bulletSize;
    let dynamicBulletIndex = 0;
    const makeElementsArray = (el)=>(Array.isArray(el) ? el : [
            el
        ]).filter((e)=>!!e);
    function isPaginationDisabled() {
        return !swiper.params.pagination.el || !swiper.pagination.el || Array.isArray(swiper.pagination.el) && swiper.pagination.el.length === 0;
    }
    function setSideBullets(bulletEl, position) {
        const { bulletActiveClass } = swiper.params.pagination;
        if (!bulletEl) return;
        bulletEl = bulletEl[`${position === "prev" ? "previous" : "next"}ElementSibling`];
        if (bulletEl) {
            bulletEl.classList.add(`${bulletActiveClass}-${position}`);
            bulletEl = bulletEl[`${position === "prev" ? "previous" : "next"}ElementSibling`];
            if (bulletEl) bulletEl.classList.add(`${bulletActiveClass}-${position}-${position}`);
        }
    }
    function onBulletClick(e) {
        const bulletEl = e.target.closest((0, _classesToSelectorMjs.c)(swiper.params.pagination.bulletClass));
        if (!bulletEl) return;
        e.preventDefault();
        const index = (0, _utilsMjs.g)(bulletEl) * swiper.params.slidesPerGroup;
        if (swiper.params.loop) {
            if (swiper.realIndex === index) return;
            swiper.slideToLoop(index);
        } else swiper.slideTo(index);
    }
    function update() {
        // Render || Update Pagination bullets/items
        const rtl = swiper.rtl;
        const params = swiper.params.pagination;
        if (isPaginationDisabled()) return;
        let el = swiper.pagination.el;
        el = makeElementsArray(el);
        // Current/Total
        let current;
        let previousIndex;
        const slidesLength = swiper.virtual && swiper.params.virtual.enabled ? swiper.virtual.slides.length : swiper.slides.length;
        const total = swiper.params.loop ? Math.ceil(slidesLength / swiper.params.slidesPerGroup) : swiper.snapGrid.length;
        if (swiper.params.loop) {
            previousIndex = swiper.previousRealIndex || 0;
            current = swiper.params.slidesPerGroup > 1 ? Math.floor(swiper.realIndex / swiper.params.slidesPerGroup) : swiper.realIndex;
        } else if (typeof swiper.snapIndex !== "undefined") {
            current = swiper.snapIndex;
            previousIndex = swiper.previousSnapIndex;
        } else {
            previousIndex = swiper.previousIndex || 0;
            current = swiper.activeIndex || 0;
        }
        // Types
        if (params.type === "bullets" && swiper.pagination.bullets && swiper.pagination.bullets.length > 0) {
            const bullets = swiper.pagination.bullets;
            let firstIndex;
            let lastIndex;
            let midIndex;
            if (params.dynamicBullets) {
                bulletSize = (0, _utilsMjs.f)(bullets[0], swiper.isHorizontal() ? "width" : "height", true);
                el.forEach((subEl)=>{
                    subEl.style[swiper.isHorizontal() ? "width" : "height"] = `${bulletSize * (params.dynamicMainBullets + 4)}px`;
                });
                if (params.dynamicMainBullets > 1 && previousIndex !== undefined) {
                    dynamicBulletIndex += current - (previousIndex || 0);
                    if (dynamicBulletIndex > params.dynamicMainBullets - 1) dynamicBulletIndex = params.dynamicMainBullets - 1;
                    else if (dynamicBulletIndex < 0) dynamicBulletIndex = 0;
                }
                firstIndex = Math.max(current - dynamicBulletIndex, 0);
                lastIndex = firstIndex + (Math.min(bullets.length, params.dynamicMainBullets) - 1);
                midIndex = (lastIndex + firstIndex) / 2;
            }
            bullets.forEach((bulletEl)=>{
                const classesToRemove = [
                    ...[
                        "",
                        "-next",
                        "-next-next",
                        "-prev",
                        "-prev-prev",
                        "-main"
                    ].map((suffix)=>`${params.bulletActiveClass}${suffix}`)
                ].map((s)=>typeof s === "string" && s.includes(" ") ? s.split(" ") : s).flat();
                bulletEl.classList.remove(...classesToRemove);
            });
            if (el.length > 1) bullets.forEach((bullet)=>{
                const bulletIndex = (0, _utilsMjs.g)(bullet);
                if (bulletIndex === current) bullet.classList.add(...params.bulletActiveClass.split(" "));
                else if (swiper.isElement) bullet.setAttribute("part", "bullet");
                if (params.dynamicBullets) {
                    if (bulletIndex >= firstIndex && bulletIndex <= lastIndex) bullet.classList.add(...`${params.bulletActiveClass}-main`.split(" "));
                    if (bulletIndex === firstIndex) setSideBullets(bullet, "prev");
                    if (bulletIndex === lastIndex) setSideBullets(bullet, "next");
                }
            });
            else {
                const bullet = bullets[current];
                if (bullet) bullet.classList.add(...params.bulletActiveClass.split(" "));
                if (swiper.isElement) bullets.forEach((bulletEl, bulletIndex)=>{
                    bulletEl.setAttribute("part", bulletIndex === current ? "bullet-active" : "bullet");
                });
                if (params.dynamicBullets) {
                    const firstDisplayedBullet = bullets[firstIndex];
                    const lastDisplayedBullet = bullets[lastIndex];
                    for(let i = firstIndex; i <= lastIndex; i += 1)if (bullets[i]) bullets[i].classList.add(...`${params.bulletActiveClass}-main`.split(" "));
                    setSideBullets(firstDisplayedBullet, "prev");
                    setSideBullets(lastDisplayedBullet, "next");
                }
            }
            if (params.dynamicBullets) {
                const dynamicBulletsLength = Math.min(bullets.length, params.dynamicMainBullets + 4);
                const bulletsOffset = (bulletSize * dynamicBulletsLength - bulletSize) / 2 - midIndex * bulletSize;
                const offsetProp = rtl ? "right" : "left";
                bullets.forEach((bullet)=>{
                    bullet.style[swiper.isHorizontal() ? offsetProp : "top"] = `${bulletsOffset}px`;
                });
            }
        }
        el.forEach((subEl, subElIndex)=>{
            if (params.type === "fraction") {
                subEl.querySelectorAll((0, _classesToSelectorMjs.c)(params.currentClass)).forEach((fractionEl)=>{
                    fractionEl.textContent = params.formatFractionCurrent(current + 1);
                });
                subEl.querySelectorAll((0, _classesToSelectorMjs.c)(params.totalClass)).forEach((totalEl)=>{
                    totalEl.textContent = params.formatFractionTotal(total);
                });
            }
            if (params.type === "progressbar") {
                let progressbarDirection;
                if (params.progressbarOpposite) progressbarDirection = swiper.isHorizontal() ? "vertical" : "horizontal";
                else progressbarDirection = swiper.isHorizontal() ? "horizontal" : "vertical";
                const scale = (current + 1) / total;
                let scaleX = 1;
                let scaleY = 1;
                if (progressbarDirection === "horizontal") scaleX = scale;
                else scaleY = scale;
                subEl.querySelectorAll((0, _classesToSelectorMjs.c)(params.progressbarFillClass)).forEach((progressEl)=>{
                    progressEl.style.transform = `translate3d(0,0,0) scaleX(${scaleX}) scaleY(${scaleY})`;
                    progressEl.style.transitionDuration = `${swiper.params.speed}ms`;
                });
            }
            if (params.type === "custom" && params.renderCustom) {
                subEl.innerHTML = params.renderCustom(swiper, current + 1, total);
                if (subElIndex === 0) emit("paginationRender", subEl);
            } else {
                if (subElIndex === 0) emit("paginationRender", subEl);
                emit("paginationUpdate", subEl);
            }
            if (swiper.params.watchOverflow && swiper.enabled) subEl.classList[swiper.isLocked ? "add" : "remove"](params.lockClass);
        });
    }
    function render() {
        // Render Container
        const params = swiper.params.pagination;
        if (isPaginationDisabled()) return;
        const slidesLength = swiper.virtual && swiper.params.virtual.enabled ? swiper.virtual.slides.length : swiper.grid && swiper.params.grid.rows > 1 ? swiper.slides.length / Math.ceil(swiper.params.grid.rows) : swiper.slides.length;
        let el = swiper.pagination.el;
        el = makeElementsArray(el);
        let paginationHTML = "";
        if (params.type === "bullets") {
            let numberOfBullets = swiper.params.loop ? Math.ceil(slidesLength / swiper.params.slidesPerGroup) : swiper.snapGrid.length;
            if (swiper.params.freeMode && swiper.params.freeMode.enabled && numberOfBullets > slidesLength) numberOfBullets = slidesLength;
            for(let i = 0; i < numberOfBullets; i += 1)if (params.renderBullet) paginationHTML += params.renderBullet.call(swiper, i, params.bulletClass);
            else // prettier-ignore
            paginationHTML += `<${params.bulletElement} ${swiper.isElement ? 'part="bullet"' : ""} class="${params.bulletClass}"></${params.bulletElement}>`;
        }
        if (params.type === "fraction") {
            if (params.renderFraction) paginationHTML = params.renderFraction.call(swiper, params.currentClass, params.totalClass);
            else paginationHTML = `<span class="${params.currentClass}"></span>` + " / " + `<span class="${params.totalClass}"></span>`;
        }
        if (params.type === "progressbar") {
            if (params.renderProgressbar) paginationHTML = params.renderProgressbar.call(swiper, params.progressbarFillClass);
            else paginationHTML = `<span class="${params.progressbarFillClass}"></span>`;
        }
        swiper.pagination.bullets = [];
        el.forEach((subEl)=>{
            if (params.type !== "custom") subEl.innerHTML = paginationHTML || "";
            if (params.type === "bullets") swiper.pagination.bullets.push(...subEl.querySelectorAll((0, _classesToSelectorMjs.c)(params.bulletClass)));
        });
        if (params.type !== "custom") emit("paginationRender", el[0]);
    }
    function init() {
        swiper.params.pagination = (0, _createElementIfNotDefinedMjs.c)(swiper, swiper.originalParams.pagination, swiper.params.pagination, {
            el: "swiper-pagination"
        });
        const params = swiper.params.pagination;
        if (!params.el) return;
        let el;
        if (typeof params.el === "string" && swiper.isElement) el = swiper.el.querySelector(params.el);
        if (!el && typeof params.el === "string") el = [
            ...document.querySelectorAll(params.el)
        ];
        if (!el) el = params.el;
        if (!el || el.length === 0) return;
        if (swiper.params.uniqueNavElements && typeof params.el === "string" && Array.isArray(el) && el.length > 1) {
            el = [
                ...swiper.el.querySelectorAll(params.el)
            ];
            // check if it belongs to another nested Swiper
            if (el.length > 1) el = el.filter((subEl)=>{
                if ((0, _utilsMjs.a)(subEl, ".swiper")[0] !== swiper.el) return false;
                return true;
            })[0];
        }
        if (Array.isArray(el) && el.length === 1) el = el[0];
        Object.assign(swiper.pagination, {
            el
        });
        el = makeElementsArray(el);
        el.forEach((subEl)=>{
            if (params.type === "bullets" && params.clickable) subEl.classList.add(...(params.clickableClass || "").split(" "));
            subEl.classList.add(params.modifierClass + params.type);
            subEl.classList.add(swiper.isHorizontal() ? params.horizontalClass : params.verticalClass);
            if (params.type === "bullets" && params.dynamicBullets) {
                subEl.classList.add(`${params.modifierClass}${params.type}-dynamic`);
                dynamicBulletIndex = 0;
                if (params.dynamicMainBullets < 1) params.dynamicMainBullets = 1;
            }
            if (params.type === "progressbar" && params.progressbarOpposite) subEl.classList.add(params.progressbarOppositeClass);
            if (params.clickable) subEl.addEventListener("click", onBulletClick);
            if (!swiper.enabled) subEl.classList.add(params.lockClass);
        });
    }
    function destroy() {
        const params = swiper.params.pagination;
        if (isPaginationDisabled()) return;
        let el = swiper.pagination.el;
        if (el) {
            el = makeElementsArray(el);
            el.forEach((subEl)=>{
                subEl.classList.remove(params.hiddenClass);
                subEl.classList.remove(params.modifierClass + params.type);
                subEl.classList.remove(swiper.isHorizontal() ? params.horizontalClass : params.verticalClass);
                if (params.clickable) {
                    subEl.classList.remove(...(params.clickableClass || "").split(" "));
                    subEl.removeEventListener("click", onBulletClick);
                }
            });
        }
        if (swiper.pagination.bullets) swiper.pagination.bullets.forEach((subEl)=>subEl.classList.remove(...params.bulletActiveClass.split(" ")));
    }
    on("changeDirection", ()=>{
        if (!swiper.pagination || !swiper.pagination.el) return;
        const params = swiper.params.pagination;
        let { el } = swiper.pagination;
        el = makeElementsArray(el);
        el.forEach((subEl)=>{
            subEl.classList.remove(params.horizontalClass, params.verticalClass);
            subEl.classList.add(swiper.isHorizontal() ? params.horizontalClass : params.verticalClass);
        });
    });
    on("init", ()=>{
        if (swiper.params.pagination.enabled === false) // eslint-disable-next-line
        disable();
        else {
            init();
            render();
            update();
        }
    });
    on("activeIndexChange", ()=>{
        if (typeof swiper.snapIndex === "undefined") update();
    });
    on("snapIndexChange", ()=>{
        update();
    });
    on("snapGridLengthChange", ()=>{
        render();
        update();
    });
    on("destroy", ()=>{
        destroy();
    });
    on("enable disable", ()=>{
        let { el } = swiper.pagination;
        if (el) {
            el = makeElementsArray(el);
            el.forEach((subEl)=>subEl.classList[swiper.enabled ? "remove" : "add"](swiper.params.pagination.lockClass));
        }
    });
    on("lock unlock", ()=>{
        update();
    });
    on("click", (_s, e)=>{
        const targetEl = e.target;
        const el = makeElementsArray(swiper.pagination.el);
        if (swiper.params.pagination.el && swiper.params.pagination.hideOnClick && el && el.length > 0 && !targetEl.classList.contains(swiper.params.pagination.bulletClass)) {
            if (swiper.navigation && (swiper.navigation.nextEl && targetEl === swiper.navigation.nextEl || swiper.navigation.prevEl && targetEl === swiper.navigation.prevEl)) return;
            const isHidden = el[0].classList.contains(swiper.params.pagination.hiddenClass);
            if (isHidden === true) emit("paginationShow");
            else emit("paginationHide");
            el.forEach((subEl)=>subEl.classList.toggle(swiper.params.pagination.hiddenClass));
        }
    });
    const enable = ()=>{
        swiper.el.classList.remove(swiper.params.pagination.paginationDisabledClass);
        let { el } = swiper.pagination;
        if (el) {
            el = makeElementsArray(el);
            el.forEach((subEl)=>subEl.classList.remove(swiper.params.pagination.paginationDisabledClass));
        }
        init();
        render();
        update();
    };
    const disable = ()=>{
        swiper.el.classList.add(swiper.params.pagination.paginationDisabledClass);
        let { el } = swiper.pagination;
        if (el) {
            el = makeElementsArray(el);
            el.forEach((subEl)=>subEl.classList.add(swiper.params.pagination.paginationDisabledClass));
        }
        destroy();
    };
    Object.assign(swiper.pagination, {
        enable,
        disable,
        render,
        update,
        init,
        destroy
    });
}

},{"../shared/classes-to-selector.mjs":"lC2D7","../shared/create-element-if-not-defined.mjs":"lYyyd","../shared/utils.mjs":"agmBj","@parcel/transformer-js/src/esmodule-helpers.js":"90RNB"}],"lC2D7":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "c", ()=>classesToSelector);
function classesToSelector(classes) {
    if (classes === void 0) classes = "";
    return `.${classes.trim().replace(/([\.:!+\/])/g, "\\$1") // eslint-disable-line
    .replace(/ /g, ".")}`;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"90RNB"}],"5ZA4Z":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>Scrollbar);
var _ssrWindowEsmMjs = require("../shared/ssr-window.esm.mjs");
var _utilsMjs = require("../shared/utils.mjs");
var _createElementIfNotDefinedMjs = require("../shared/create-element-if-not-defined.mjs");
var _classesToSelectorMjs = require("../shared/classes-to-selector.mjs");
function Scrollbar(_ref) {
    let { swiper, extendParams, on, emit } = _ref;
    const document = (0, _ssrWindowEsmMjs.g)();
    let isTouched = false;
    let timeout = null;
    let dragTimeout = null;
    let dragStartPos;
    let dragSize;
    let trackSize;
    let divider;
    extendParams({
        scrollbar: {
            el: null,
            dragSize: "auto",
            hide: false,
            draggable: false,
            snapOnRelease: true,
            lockClass: "swiper-scrollbar-lock",
            dragClass: "swiper-scrollbar-drag",
            scrollbarDisabledClass: "swiper-scrollbar-disabled",
            horizontalClass: `swiper-scrollbar-horizontal`,
            verticalClass: `swiper-scrollbar-vertical`
        }
    });
    swiper.scrollbar = {
        el: null,
        dragEl: null
    };
    function setTranslate() {
        if (!swiper.params.scrollbar.el || !swiper.scrollbar.el) return;
        const { scrollbar, rtlTranslate: rtl } = swiper;
        const { dragEl, el } = scrollbar;
        const params = swiper.params.scrollbar;
        const progress = swiper.params.loop ? swiper.progressLoop : swiper.progress;
        let newSize = dragSize;
        let newPos = (trackSize - dragSize) * progress;
        if (rtl) {
            newPos = -newPos;
            if (newPos > 0) {
                newSize = dragSize - newPos;
                newPos = 0;
            } else if (-newPos + dragSize > trackSize) newSize = trackSize + newPos;
        } else if (newPos < 0) {
            newSize = dragSize + newPos;
            newPos = 0;
        } else if (newPos + dragSize > trackSize) newSize = trackSize - newPos;
        if (swiper.isHorizontal()) {
            dragEl.style.transform = `translate3d(${newPos}px, 0, 0)`;
            dragEl.style.width = `${newSize}px`;
        } else {
            dragEl.style.transform = `translate3d(0px, ${newPos}px, 0)`;
            dragEl.style.height = `${newSize}px`;
        }
        if (params.hide) {
            clearTimeout(timeout);
            el.style.opacity = 1;
            timeout = setTimeout(()=>{
                el.style.opacity = 0;
                el.style.transitionDuration = "400ms";
            }, 1000);
        }
    }
    function setTransition(duration) {
        if (!swiper.params.scrollbar.el || !swiper.scrollbar.el) return;
        swiper.scrollbar.dragEl.style.transitionDuration = `${duration}ms`;
    }
    function updateSize() {
        if (!swiper.params.scrollbar.el || !swiper.scrollbar.el) return;
        const { scrollbar } = swiper;
        const { dragEl, el } = scrollbar;
        dragEl.style.width = "";
        dragEl.style.height = "";
        trackSize = swiper.isHorizontal() ? el.offsetWidth : el.offsetHeight;
        divider = swiper.size / (swiper.virtualSize + swiper.params.slidesOffsetBefore - (swiper.params.centeredSlides ? swiper.snapGrid[0] : 0));
        if (swiper.params.scrollbar.dragSize === "auto") dragSize = trackSize * divider;
        else dragSize = parseInt(swiper.params.scrollbar.dragSize, 10);
        if (swiper.isHorizontal()) dragEl.style.width = `${dragSize}px`;
        else dragEl.style.height = `${dragSize}px`;
        if (divider >= 1) el.style.display = "none";
        else el.style.display = "";
        if (swiper.params.scrollbar.hide) el.style.opacity = 0;
        if (swiper.params.watchOverflow && swiper.enabled) scrollbar.el.classList[swiper.isLocked ? "add" : "remove"](swiper.params.scrollbar.lockClass);
    }
    function getPointerPosition(e) {
        return swiper.isHorizontal() ? e.clientX : e.clientY;
    }
    function setDragPosition(e) {
        const { scrollbar, rtlTranslate: rtl } = swiper;
        const { el } = scrollbar;
        let positionRatio;
        positionRatio = (getPointerPosition(e) - (0, _utilsMjs.b)(el)[swiper.isHorizontal() ? "left" : "top"] - (dragStartPos !== null ? dragStartPos : dragSize / 2)) / (trackSize - dragSize);
        positionRatio = Math.max(Math.min(positionRatio, 1), 0);
        if (rtl) positionRatio = 1 - positionRatio;
        const position = swiper.minTranslate() + (swiper.maxTranslate() - swiper.minTranslate()) * positionRatio;
        swiper.updateProgress(position);
        swiper.setTranslate(position);
        swiper.updateActiveIndex();
        swiper.updateSlidesClasses();
    }
    function onDragStart(e) {
        const params = swiper.params.scrollbar;
        const { scrollbar, wrapperEl } = swiper;
        const { el, dragEl } = scrollbar;
        isTouched = true;
        dragStartPos = e.target === dragEl ? getPointerPosition(e) - e.target.getBoundingClientRect()[swiper.isHorizontal() ? "left" : "top"] : null;
        e.preventDefault();
        e.stopPropagation();
        wrapperEl.style.transitionDuration = "100ms";
        dragEl.style.transitionDuration = "100ms";
        setDragPosition(e);
        clearTimeout(dragTimeout);
        el.style.transitionDuration = "0ms";
        if (params.hide) el.style.opacity = 1;
        if (swiper.params.cssMode) swiper.wrapperEl.style["scroll-snap-type"] = "none";
        emit("scrollbarDragStart", e);
    }
    function onDragMove(e) {
        const { scrollbar, wrapperEl } = swiper;
        const { el, dragEl } = scrollbar;
        if (!isTouched) return;
        if (e.preventDefault) e.preventDefault();
        else e.returnValue = false;
        setDragPosition(e);
        wrapperEl.style.transitionDuration = "0ms";
        el.style.transitionDuration = "0ms";
        dragEl.style.transitionDuration = "0ms";
        emit("scrollbarDragMove", e);
    }
    function onDragEnd(e) {
        const params = swiper.params.scrollbar;
        const { scrollbar, wrapperEl } = swiper;
        const { el } = scrollbar;
        if (!isTouched) return;
        isTouched = false;
        if (swiper.params.cssMode) {
            swiper.wrapperEl.style["scroll-snap-type"] = "";
            wrapperEl.style.transitionDuration = "";
        }
        if (params.hide) {
            clearTimeout(dragTimeout);
            dragTimeout = (0, _utilsMjs.n)(()=>{
                el.style.opacity = 0;
                el.style.transitionDuration = "400ms";
            }, 1000);
        }
        emit("scrollbarDragEnd", e);
        if (params.snapOnRelease) swiper.slideToClosest();
    }
    function events(method) {
        const { scrollbar, params } = swiper;
        const el = scrollbar.el;
        if (!el) return;
        const target = el;
        const activeListener = params.passiveListeners ? {
            passive: false,
            capture: false
        } : false;
        const passiveListener = params.passiveListeners ? {
            passive: true,
            capture: false
        } : false;
        if (!target) return;
        const eventMethod = method === "on" ? "addEventListener" : "removeEventListener";
        target[eventMethod]("pointerdown", onDragStart, activeListener);
        document[eventMethod]("pointermove", onDragMove, activeListener);
        document[eventMethod]("pointerup", onDragEnd, passiveListener);
    }
    function enableDraggable() {
        if (!swiper.params.scrollbar.el || !swiper.scrollbar.el) return;
        events("on");
    }
    function disableDraggable() {
        if (!swiper.params.scrollbar.el || !swiper.scrollbar.el) return;
        events("off");
    }
    function init() {
        const { scrollbar, el: swiperEl } = swiper;
        swiper.params.scrollbar = (0, _createElementIfNotDefinedMjs.c)(swiper, swiper.originalParams.scrollbar, swiper.params.scrollbar, {
            el: "swiper-scrollbar"
        });
        const params = swiper.params.scrollbar;
        if (!params.el) return;
        let el;
        if (typeof params.el === "string" && swiper.isElement) el = swiper.el.querySelector(params.el);
        if (!el && typeof params.el === "string") {
            el = document.querySelectorAll(params.el);
            if (!el.length) return;
        } else if (!el) el = params.el;
        if (swiper.params.uniqueNavElements && typeof params.el === "string" && el.length > 1 && swiperEl.querySelectorAll(params.el).length === 1) el = swiperEl.querySelector(params.el);
        if (el.length > 0) el = el[0];
        el.classList.add(swiper.isHorizontal() ? params.horizontalClass : params.verticalClass);
        let dragEl;
        if (el) {
            dragEl = el.querySelector((0, _classesToSelectorMjs.c)(swiper.params.scrollbar.dragClass));
            if (!dragEl) {
                dragEl = (0, _utilsMjs.c)("div", swiper.params.scrollbar.dragClass);
                el.append(dragEl);
            }
        }
        Object.assign(scrollbar, {
            el,
            dragEl
        });
        if (params.draggable) enableDraggable();
        if (el) el.classList[swiper.enabled ? "remove" : "add"](...(0, _utilsMjs.h)(swiper.params.scrollbar.lockClass));
    }
    function destroy() {
        const params = swiper.params.scrollbar;
        const el = swiper.scrollbar.el;
        if (el) el.classList.remove(...(0, _utilsMjs.h)(swiper.isHorizontal() ? params.horizontalClass : params.verticalClass));
        disableDraggable();
    }
    on("init", ()=>{
        if (swiper.params.scrollbar.enabled === false) // eslint-disable-next-line
        disable();
        else {
            init();
            updateSize();
            setTranslate();
        }
    });
    on("update resize observerUpdate lock unlock", ()=>{
        updateSize();
    });
    on("setTranslate", ()=>{
        setTranslate();
    });
    on("setTransition", (_s, duration)=>{
        setTransition(duration);
    });
    on("enable disable", ()=>{
        const { el } = swiper.scrollbar;
        if (el) el.classList[swiper.enabled ? "remove" : "add"](...(0, _utilsMjs.h)(swiper.params.scrollbar.lockClass));
    });
    on("destroy", ()=>{
        destroy();
    });
    const enable = ()=>{
        swiper.el.classList.remove(...(0, _utilsMjs.h)(swiper.params.scrollbar.scrollbarDisabledClass));
        if (swiper.scrollbar.el) swiper.scrollbar.el.classList.remove(...(0, _utilsMjs.h)(swiper.params.scrollbar.scrollbarDisabledClass));
        init();
        updateSize();
        setTranslate();
    };
    const disable = ()=>{
        swiper.el.classList.add(...(0, _utilsMjs.h)(swiper.params.scrollbar.scrollbarDisabledClass));
        if (swiper.scrollbar.el) swiper.scrollbar.el.classList.add(...(0, _utilsMjs.h)(swiper.params.scrollbar.scrollbarDisabledClass));
        destroy();
    };
    Object.assign(swiper.scrollbar, {
        enable,
        disable,
        updateSize,
        setTranslate,
        init,
        destroy
    });
}

},{"../shared/ssr-window.esm.mjs":"ehIRJ","../shared/utils.mjs":"agmBj","../shared/create-element-if-not-defined.mjs":"lYyyd","../shared/classes-to-selector.mjs":"lC2D7","@parcel/transformer-js/src/esmodule-helpers.js":"90RNB"}],"4xTpT":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>Parallax);
var _utilsMjs = require("../shared/utils.mjs");
function Parallax(_ref) {
    let { swiper, extendParams, on } = _ref;
    extendParams({
        parallax: {
            enabled: false
        }
    });
    const elementsSelector = "[data-swiper-parallax], [data-swiper-parallax-x], [data-swiper-parallax-y], [data-swiper-parallax-opacity], [data-swiper-parallax-scale]";
    const setTransform = (el, progress)=>{
        const { rtl } = swiper;
        const rtlFactor = rtl ? -1 : 1;
        const p = el.getAttribute("data-swiper-parallax") || "0";
        let x = el.getAttribute("data-swiper-parallax-x");
        let y = el.getAttribute("data-swiper-parallax-y");
        const scale = el.getAttribute("data-swiper-parallax-scale");
        const opacity = el.getAttribute("data-swiper-parallax-opacity");
        const rotate = el.getAttribute("data-swiper-parallax-rotate");
        if (x || y) {
            x = x || "0";
            y = y || "0";
        } else if (swiper.isHorizontal()) {
            x = p;
            y = "0";
        } else {
            y = p;
            x = "0";
        }
        if (x.indexOf("%") >= 0) x = `${parseInt(x, 10) * progress * rtlFactor}%`;
        else x = `${x * progress * rtlFactor}px`;
        if (y.indexOf("%") >= 0) y = `${parseInt(y, 10) * progress}%`;
        else y = `${y * progress}px`;
        if (typeof opacity !== "undefined" && opacity !== null) {
            const currentOpacity = opacity - (opacity - 1) * (1 - Math.abs(progress));
            el.style.opacity = currentOpacity;
        }
        let transform = `translate3d(${x}, ${y}, 0px)`;
        if (typeof scale !== "undefined" && scale !== null) {
            const currentScale = scale - (scale - 1) * (1 - Math.abs(progress));
            transform += ` scale(${currentScale})`;
        }
        if (rotate && typeof rotate !== "undefined" && rotate !== null) {
            const currentRotate = rotate * progress * -1;
            transform += ` rotate(${currentRotate}deg)`;
        }
        el.style.transform = transform;
    };
    const setTranslate = ()=>{
        const { el, slides, progress, snapGrid, isElement } = swiper;
        const elements = (0, _utilsMjs.e)(el, elementsSelector);
        if (swiper.isElement) elements.push(...(0, _utilsMjs.e)(swiper.hostEl, elementsSelector));
        elements.forEach((subEl)=>{
            setTransform(subEl, progress);
        });
        slides.forEach((slideEl, slideIndex)=>{
            let slideProgress = slideEl.progress;
            if (swiper.params.slidesPerGroup > 1 && swiper.params.slidesPerView !== "auto") slideProgress += Math.ceil(slideIndex / 2) - progress * (snapGrid.length - 1);
            slideProgress = Math.min(Math.max(slideProgress, -1), 1);
            slideEl.querySelectorAll(`${elementsSelector}, [data-swiper-parallax-rotate]`).forEach((subEl)=>{
                setTransform(subEl, slideProgress);
            });
        });
    };
    const setTransition = function(duration) {
        if (duration === void 0) duration = swiper.params.speed;
        const { el, hostEl } = swiper;
        const elements = [
            ...el.querySelectorAll(elementsSelector)
        ];
        if (swiper.isElement) elements.push(...hostEl.querySelectorAll(elementsSelector));
        elements.forEach((parallaxEl)=>{
            let parallaxDuration = parseInt(parallaxEl.getAttribute("data-swiper-parallax-duration"), 10) || duration;
            if (duration === 0) parallaxDuration = 0;
            parallaxEl.style.transitionDuration = `${parallaxDuration}ms`;
        });
    };
    on("beforeInit", ()=>{
        if (!swiper.params.parallax.enabled) return;
        swiper.params.watchSlidesProgress = true;
        swiper.originalParams.watchSlidesProgress = true;
    });
    on("init", ()=>{
        if (!swiper.params.parallax.enabled) return;
        setTranslate();
    });
    on("setTranslate", ()=>{
        if (!swiper.params.parallax.enabled) return;
        setTranslate();
    });
    on("setTransition", (_swiper, duration)=>{
        if (!swiper.params.parallax.enabled) return;
        setTransition(duration);
    });
}

},{"../shared/utils.mjs":"agmBj","@parcel/transformer-js/src/esmodule-helpers.js":"90RNB"}],"5sqWT":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>Zoom);
var _ssrWindowEsmMjs = require("../shared/ssr-window.esm.mjs");
var _utilsMjs = require("../shared/utils.mjs");
function Zoom(_ref) {
    let { swiper, extendParams, on, emit } = _ref;
    const window = (0, _ssrWindowEsmMjs.a)();
    extendParams({
        zoom: {
            enabled: false,
            maxRatio: 3,
            minRatio: 1,
            toggle: true,
            containerClass: "swiper-zoom-container",
            zoomedSlideClass: "swiper-slide-zoomed"
        }
    });
    swiper.zoom = {
        enabled: false
    };
    let currentScale = 1;
    let isScaling = false;
    let fakeGestureTouched;
    let fakeGestureMoved;
    const evCache = [];
    const gesture = {
        originX: 0,
        originY: 0,
        slideEl: undefined,
        slideWidth: undefined,
        slideHeight: undefined,
        imageEl: undefined,
        imageWrapEl: undefined,
        maxRatio: 3
    };
    const image = {
        isTouched: undefined,
        isMoved: undefined,
        currentX: undefined,
        currentY: undefined,
        minX: undefined,
        minY: undefined,
        maxX: undefined,
        maxY: undefined,
        width: undefined,
        height: undefined,
        startX: undefined,
        startY: undefined,
        touchesStart: {},
        touchesCurrent: {}
    };
    const velocity = {
        x: undefined,
        y: undefined,
        prevPositionX: undefined,
        prevPositionY: undefined,
        prevTime: undefined
    };
    let scale = 1;
    Object.defineProperty(swiper.zoom, "scale", {
        get () {
            return scale;
        },
        set (value) {
            if (scale !== value) {
                const imageEl = gesture.imageEl;
                const slideEl = gesture.slideEl;
                emit("zoomChange", value, imageEl, slideEl);
            }
            scale = value;
        }
    });
    function getDistanceBetweenTouches() {
        if (evCache.length < 2) return 1;
        const x1 = evCache[0].pageX;
        const y1 = evCache[0].pageY;
        const x2 = evCache[1].pageX;
        const y2 = evCache[1].pageY;
        const distance = Math.sqrt((x2 - x1) ** 2 + (y2 - y1) ** 2);
        return distance;
    }
    function getScaleOrigin() {
        if (evCache.length < 2) return {
            x: null,
            y: null
        };
        const box = gesture.imageEl.getBoundingClientRect();
        return [
            (evCache[0].pageX + (evCache[1].pageX - evCache[0].pageX) / 2 - box.x - window.scrollX) / currentScale,
            (evCache[0].pageY + (evCache[1].pageY - evCache[0].pageY) / 2 - box.y - window.scrollY) / currentScale
        ];
    }
    function getSlideSelector() {
        return swiper.isElement ? `swiper-slide` : `.${swiper.params.slideClass}`;
    }
    function eventWithinSlide(e) {
        const slideSelector = getSlideSelector();
        if (e.target.matches(slideSelector)) return true;
        if (swiper.slides.filter((slideEl)=>slideEl.contains(e.target)).length > 0) return true;
        return false;
    }
    function eventWithinZoomContainer(e) {
        const selector = `.${swiper.params.zoom.containerClass}`;
        if (e.target.matches(selector)) return true;
        if ([
            ...swiper.hostEl.querySelectorAll(selector)
        ].filter((containerEl)=>containerEl.contains(e.target)).length > 0) return true;
        return false;
    }
    // Events
    function onGestureStart(e) {
        if (e.pointerType === "mouse") evCache.splice(0, evCache.length);
        if (!eventWithinSlide(e)) return;
        const params = swiper.params.zoom;
        fakeGestureTouched = false;
        fakeGestureMoved = false;
        evCache.push(e);
        if (evCache.length < 2) return;
        fakeGestureTouched = true;
        gesture.scaleStart = getDistanceBetweenTouches();
        if (!gesture.slideEl) {
            gesture.slideEl = e.target.closest(`.${swiper.params.slideClass}, swiper-slide`);
            if (!gesture.slideEl) gesture.slideEl = swiper.slides[swiper.activeIndex];
            let imageEl = gesture.slideEl.querySelector(`.${params.containerClass}`);
            if (imageEl) imageEl = imageEl.querySelectorAll("picture, img, svg, canvas, .swiper-zoom-target")[0];
            gesture.imageEl = imageEl;
            if (imageEl) gesture.imageWrapEl = (0, _utilsMjs.a)(gesture.imageEl, `.${params.containerClass}`)[0];
            else gesture.imageWrapEl = undefined;
            if (!gesture.imageWrapEl) {
                gesture.imageEl = undefined;
                return;
            }
            gesture.maxRatio = gesture.imageWrapEl.getAttribute("data-swiper-zoom") || params.maxRatio;
        }
        if (gesture.imageEl) {
            const [originX, originY] = getScaleOrigin();
            gesture.originX = originX;
            gesture.originY = originY;
            gesture.imageEl.style.transitionDuration = "0ms";
        }
        isScaling = true;
    }
    function onGestureChange(e) {
        if (!eventWithinSlide(e)) return;
        const params = swiper.params.zoom;
        const zoom = swiper.zoom;
        const pointerIndex = evCache.findIndex((cachedEv)=>cachedEv.pointerId === e.pointerId);
        if (pointerIndex >= 0) evCache[pointerIndex] = e;
        if (evCache.length < 2) return;
        fakeGestureMoved = true;
        gesture.scaleMove = getDistanceBetweenTouches();
        if (!gesture.imageEl) return;
        zoom.scale = gesture.scaleMove / gesture.scaleStart * currentScale;
        if (zoom.scale > gesture.maxRatio) zoom.scale = gesture.maxRatio - 1 + (zoom.scale - gesture.maxRatio + 1) ** 0.5;
        if (zoom.scale < params.minRatio) zoom.scale = params.minRatio + 1 - (params.minRatio - zoom.scale + 1) ** 0.5;
        gesture.imageEl.style.transform = `translate3d(0,0,0) scale(${zoom.scale})`;
    }
    function onGestureEnd(e) {
        if (!eventWithinSlide(e)) return;
        if (e.pointerType === "mouse" && e.type === "pointerout") return;
        const params = swiper.params.zoom;
        const zoom = swiper.zoom;
        const pointerIndex = evCache.findIndex((cachedEv)=>cachedEv.pointerId === e.pointerId);
        if (pointerIndex >= 0) evCache.splice(pointerIndex, 1);
        if (!fakeGestureTouched || !fakeGestureMoved) return;
        fakeGestureTouched = false;
        fakeGestureMoved = false;
        if (!gesture.imageEl) return;
        zoom.scale = Math.max(Math.min(zoom.scale, gesture.maxRatio), params.minRatio);
        gesture.imageEl.style.transitionDuration = `${swiper.params.speed}ms`;
        gesture.imageEl.style.transform = `translate3d(0,0,0) scale(${zoom.scale})`;
        currentScale = zoom.scale;
        isScaling = false;
        if (zoom.scale > 1 && gesture.slideEl) gesture.slideEl.classList.add(`${params.zoomedSlideClass}`);
        else if (zoom.scale <= 1 && gesture.slideEl) gesture.slideEl.classList.remove(`${params.zoomedSlideClass}`);
        if (zoom.scale === 1) {
            gesture.originX = 0;
            gesture.originY = 0;
            gesture.slideEl = undefined;
        }
    }
    function onTouchStart(e) {
        const device = swiper.device;
        if (!gesture.imageEl) return;
        if (image.isTouched) return;
        if (device.android && e.cancelable) e.preventDefault();
        image.isTouched = true;
        const event = evCache.length > 0 ? evCache[0] : e;
        image.touchesStart.x = event.pageX;
        image.touchesStart.y = event.pageY;
    }
    function onTouchMove(e) {
        if (!eventWithinSlide(e) || !eventWithinZoomContainer(e)) return;
        const zoom = swiper.zoom;
        if (!gesture.imageEl) return;
        if (!image.isTouched || !gesture.slideEl) return;
        if (!image.isMoved) {
            image.width = gesture.imageEl.offsetWidth;
            image.height = gesture.imageEl.offsetHeight;
            image.startX = (0, _utilsMjs.i)(gesture.imageWrapEl, "x") || 0;
            image.startY = (0, _utilsMjs.i)(gesture.imageWrapEl, "y") || 0;
            gesture.slideWidth = gesture.slideEl.offsetWidth;
            gesture.slideHeight = gesture.slideEl.offsetHeight;
            gesture.imageWrapEl.style.transitionDuration = "0ms";
        }
        // Define if we need image drag
        const scaledWidth = image.width * zoom.scale;
        const scaledHeight = image.height * zoom.scale;
        if (scaledWidth < gesture.slideWidth && scaledHeight < gesture.slideHeight) return;
        image.minX = Math.min(gesture.slideWidth / 2 - scaledWidth / 2, 0);
        image.maxX = -image.minX;
        image.minY = Math.min(gesture.slideHeight / 2 - scaledHeight / 2, 0);
        image.maxY = -image.minY;
        image.touchesCurrent.x = evCache.length > 0 ? evCache[0].pageX : e.pageX;
        image.touchesCurrent.y = evCache.length > 0 ? evCache[0].pageY : e.pageY;
        const touchesDiff = Math.max(Math.abs(image.touchesCurrent.x - image.touchesStart.x), Math.abs(image.touchesCurrent.y - image.touchesStart.y));
        if (touchesDiff > 5) swiper.allowClick = false;
        if (!image.isMoved && !isScaling) {
            if (swiper.isHorizontal() && (Math.floor(image.minX) === Math.floor(image.startX) && image.touchesCurrent.x < image.touchesStart.x || Math.floor(image.maxX) === Math.floor(image.startX) && image.touchesCurrent.x > image.touchesStart.x)) {
                image.isTouched = false;
                return;
            }
            if (!swiper.isHorizontal() && (Math.floor(image.minY) === Math.floor(image.startY) && image.touchesCurrent.y < image.touchesStart.y || Math.floor(image.maxY) === Math.floor(image.startY) && image.touchesCurrent.y > image.touchesStart.y)) {
                image.isTouched = false;
                return;
            }
        }
        if (e.cancelable) e.preventDefault();
        e.stopPropagation();
        image.isMoved = true;
        const scaleRatio = (zoom.scale - currentScale) / (gesture.maxRatio - swiper.params.zoom.minRatio);
        const { originX, originY } = gesture;
        image.currentX = image.touchesCurrent.x - image.touchesStart.x + image.startX + scaleRatio * (image.width - originX * 2);
        image.currentY = image.touchesCurrent.y - image.touchesStart.y + image.startY + scaleRatio * (image.height - originY * 2);
        if (image.currentX < image.minX) image.currentX = image.minX + 1 - (image.minX - image.currentX + 1) ** 0.8;
        if (image.currentX > image.maxX) image.currentX = image.maxX - 1 + (image.currentX - image.maxX + 1) ** 0.8;
        if (image.currentY < image.minY) image.currentY = image.minY + 1 - (image.minY - image.currentY + 1) ** 0.8;
        if (image.currentY > image.maxY) image.currentY = image.maxY - 1 + (image.currentY - image.maxY + 1) ** 0.8;
        // Velocity
        if (!velocity.prevPositionX) velocity.prevPositionX = image.touchesCurrent.x;
        if (!velocity.prevPositionY) velocity.prevPositionY = image.touchesCurrent.y;
        if (!velocity.prevTime) velocity.prevTime = Date.now();
        velocity.x = (image.touchesCurrent.x - velocity.prevPositionX) / (Date.now() - velocity.prevTime) / 2;
        velocity.y = (image.touchesCurrent.y - velocity.prevPositionY) / (Date.now() - velocity.prevTime) / 2;
        if (Math.abs(image.touchesCurrent.x - velocity.prevPositionX) < 2) velocity.x = 0;
        if (Math.abs(image.touchesCurrent.y - velocity.prevPositionY) < 2) velocity.y = 0;
        velocity.prevPositionX = image.touchesCurrent.x;
        velocity.prevPositionY = image.touchesCurrent.y;
        velocity.prevTime = Date.now();
        gesture.imageWrapEl.style.transform = `translate3d(${image.currentX}px, ${image.currentY}px,0)`;
    }
    function onTouchEnd() {
        const zoom = swiper.zoom;
        if (!gesture.imageEl) return;
        if (!image.isTouched || !image.isMoved) {
            image.isTouched = false;
            image.isMoved = false;
            return;
        }
        image.isTouched = false;
        image.isMoved = false;
        let momentumDurationX = 300;
        let momentumDurationY = 300;
        const momentumDistanceX = velocity.x * momentumDurationX;
        const newPositionX = image.currentX + momentumDistanceX;
        const momentumDistanceY = velocity.y * momentumDurationY;
        const newPositionY = image.currentY + momentumDistanceY;
        // Fix duration
        if (velocity.x !== 0) momentumDurationX = Math.abs((newPositionX - image.currentX) / velocity.x);
        if (velocity.y !== 0) momentumDurationY = Math.abs((newPositionY - image.currentY) / velocity.y);
        const momentumDuration = Math.max(momentumDurationX, momentumDurationY);
        image.currentX = newPositionX;
        image.currentY = newPositionY;
        // Define if we need image drag
        const scaledWidth = image.width * zoom.scale;
        const scaledHeight = image.height * zoom.scale;
        image.minX = Math.min(gesture.slideWidth / 2 - scaledWidth / 2, 0);
        image.maxX = -image.minX;
        image.minY = Math.min(gesture.slideHeight / 2 - scaledHeight / 2, 0);
        image.maxY = -image.minY;
        image.currentX = Math.max(Math.min(image.currentX, image.maxX), image.minX);
        image.currentY = Math.max(Math.min(image.currentY, image.maxY), image.minY);
        gesture.imageWrapEl.style.transitionDuration = `${momentumDuration}ms`;
        gesture.imageWrapEl.style.transform = `translate3d(${image.currentX}px, ${image.currentY}px,0)`;
    }
    function onTransitionEnd() {
        const zoom = swiper.zoom;
        if (gesture.slideEl && swiper.activeIndex !== swiper.slides.indexOf(gesture.slideEl)) {
            if (gesture.imageEl) gesture.imageEl.style.transform = "translate3d(0,0,0) scale(1)";
            if (gesture.imageWrapEl) gesture.imageWrapEl.style.transform = "translate3d(0,0,0)";
            gesture.slideEl.classList.remove(`${swiper.params.zoom.zoomedSlideClass}`);
            zoom.scale = 1;
            currentScale = 1;
            gesture.slideEl = undefined;
            gesture.imageEl = undefined;
            gesture.imageWrapEl = undefined;
            gesture.originX = 0;
            gesture.originY = 0;
        }
    }
    function zoomIn(e) {
        const zoom = swiper.zoom;
        const params = swiper.params.zoom;
        if (!gesture.slideEl) {
            if (e && e.target) gesture.slideEl = e.target.closest(`.${swiper.params.slideClass}, swiper-slide`);
            if (!gesture.slideEl) {
                if (swiper.params.virtual && swiper.params.virtual.enabled && swiper.virtual) gesture.slideEl = (0, _utilsMjs.e)(swiper.slidesEl, `.${swiper.params.slideActiveClass}`)[0];
                else gesture.slideEl = swiper.slides[swiper.activeIndex];
            }
            let imageEl = gesture.slideEl.querySelector(`.${params.containerClass}`);
            if (imageEl) imageEl = imageEl.querySelectorAll("picture, img, svg, canvas, .swiper-zoom-target")[0];
            gesture.imageEl = imageEl;
            if (imageEl) gesture.imageWrapEl = (0, _utilsMjs.a)(gesture.imageEl, `.${params.containerClass}`)[0];
            else gesture.imageWrapEl = undefined;
        }
        if (!gesture.imageEl || !gesture.imageWrapEl) return;
        if (swiper.params.cssMode) {
            swiper.wrapperEl.style.overflow = "hidden";
            swiper.wrapperEl.style.touchAction = "none";
        }
        gesture.slideEl.classList.add(`${params.zoomedSlideClass}`);
        let touchX;
        let touchY;
        let offsetX;
        let offsetY;
        let diffX;
        let diffY;
        let translateX;
        let translateY;
        let imageWidth;
        let imageHeight;
        let scaledWidth;
        let scaledHeight;
        let translateMinX;
        let translateMinY;
        let translateMaxX;
        let translateMaxY;
        let slideWidth;
        let slideHeight;
        if (typeof image.touchesStart.x === "undefined" && e) {
            touchX = e.pageX;
            touchY = e.pageY;
        } else {
            touchX = image.touchesStart.x;
            touchY = image.touchesStart.y;
        }
        const forceZoomRatio = typeof e === "number" ? e : null;
        if (currentScale === 1 && forceZoomRatio) {
            touchX = undefined;
            touchY = undefined;
        }
        zoom.scale = forceZoomRatio || gesture.imageWrapEl.getAttribute("data-swiper-zoom") || params.maxRatio;
        currentScale = forceZoomRatio || gesture.imageWrapEl.getAttribute("data-swiper-zoom") || params.maxRatio;
        if (e && !(currentScale === 1 && forceZoomRatio)) {
            slideWidth = gesture.slideEl.offsetWidth;
            slideHeight = gesture.slideEl.offsetHeight;
            offsetX = (0, _utilsMjs.b)(gesture.slideEl).left + window.scrollX;
            offsetY = (0, _utilsMjs.b)(gesture.slideEl).top + window.scrollY;
            diffX = offsetX + slideWidth / 2 - touchX;
            diffY = offsetY + slideHeight / 2 - touchY;
            imageWidth = gesture.imageEl.offsetWidth;
            imageHeight = gesture.imageEl.offsetHeight;
            scaledWidth = imageWidth * zoom.scale;
            scaledHeight = imageHeight * zoom.scale;
            translateMinX = Math.min(slideWidth / 2 - scaledWidth / 2, 0);
            translateMinY = Math.min(slideHeight / 2 - scaledHeight / 2, 0);
            translateMaxX = -translateMinX;
            translateMaxY = -translateMinY;
            translateX = diffX * zoom.scale;
            translateY = diffY * zoom.scale;
            if (translateX < translateMinX) translateX = translateMinX;
            if (translateX > translateMaxX) translateX = translateMaxX;
            if (translateY < translateMinY) translateY = translateMinY;
            if (translateY > translateMaxY) translateY = translateMaxY;
        } else {
            translateX = 0;
            translateY = 0;
        }
        if (forceZoomRatio && zoom.scale === 1) {
            gesture.originX = 0;
            gesture.originY = 0;
        }
        gesture.imageWrapEl.style.transitionDuration = "300ms";
        gesture.imageWrapEl.style.transform = `translate3d(${translateX}px, ${translateY}px,0)`;
        gesture.imageEl.style.transitionDuration = "300ms";
        gesture.imageEl.style.transform = `translate3d(0,0,0) scale(${zoom.scale})`;
    }
    function zoomOut() {
        const zoom = swiper.zoom;
        const params = swiper.params.zoom;
        if (!gesture.slideEl) {
            if (swiper.params.virtual && swiper.params.virtual.enabled && swiper.virtual) gesture.slideEl = (0, _utilsMjs.e)(swiper.slidesEl, `.${swiper.params.slideActiveClass}`)[0];
            else gesture.slideEl = swiper.slides[swiper.activeIndex];
            let imageEl = gesture.slideEl.querySelector(`.${params.containerClass}`);
            if (imageEl) imageEl = imageEl.querySelectorAll("picture, img, svg, canvas, .swiper-zoom-target")[0];
            gesture.imageEl = imageEl;
            if (imageEl) gesture.imageWrapEl = (0, _utilsMjs.a)(gesture.imageEl, `.${params.containerClass}`)[0];
            else gesture.imageWrapEl = undefined;
        }
        if (!gesture.imageEl || !gesture.imageWrapEl) return;
        if (swiper.params.cssMode) {
            swiper.wrapperEl.style.overflow = "";
            swiper.wrapperEl.style.touchAction = "";
        }
        zoom.scale = 1;
        currentScale = 1;
        gesture.imageWrapEl.style.transitionDuration = "300ms";
        gesture.imageWrapEl.style.transform = "translate3d(0,0,0)";
        gesture.imageEl.style.transitionDuration = "300ms";
        gesture.imageEl.style.transform = "translate3d(0,0,0) scale(1)";
        gesture.slideEl.classList.remove(`${params.zoomedSlideClass}`);
        gesture.slideEl = undefined;
        gesture.originX = 0;
        gesture.originY = 0;
    }
    // Toggle Zoom
    function zoomToggle(e) {
        const zoom = swiper.zoom;
        if (zoom.scale && zoom.scale !== 1) // Zoom Out
        zoomOut();
        else // Zoom In
        zoomIn(e);
    }
    function getListeners() {
        const passiveListener = swiper.params.passiveListeners ? {
            passive: true,
            capture: false
        } : false;
        const activeListenerWithCapture = swiper.params.passiveListeners ? {
            passive: false,
            capture: true
        } : true;
        return {
            passiveListener,
            activeListenerWithCapture
        };
    }
    // Attach/Detach Events
    function enable() {
        const zoom = swiper.zoom;
        if (zoom.enabled) return;
        zoom.enabled = true;
        const { passiveListener, activeListenerWithCapture } = getListeners();
        // Scale image
        swiper.wrapperEl.addEventListener("pointerdown", onGestureStart, passiveListener);
        swiper.wrapperEl.addEventListener("pointermove", onGestureChange, activeListenerWithCapture);
        [
            "pointerup",
            "pointercancel",
            "pointerout"
        ].forEach((eventName)=>{
            swiper.wrapperEl.addEventListener(eventName, onGestureEnd, passiveListener);
        });
        // Move image
        swiper.wrapperEl.addEventListener("pointermove", onTouchMove, activeListenerWithCapture);
    }
    function disable() {
        const zoom = swiper.zoom;
        if (!zoom.enabled) return;
        zoom.enabled = false;
        const { passiveListener, activeListenerWithCapture } = getListeners();
        // Scale image
        swiper.wrapperEl.removeEventListener("pointerdown", onGestureStart, passiveListener);
        swiper.wrapperEl.removeEventListener("pointermove", onGestureChange, activeListenerWithCapture);
        [
            "pointerup",
            "pointercancel",
            "pointerout"
        ].forEach((eventName)=>{
            swiper.wrapperEl.removeEventListener(eventName, onGestureEnd, passiveListener);
        });
        // Move image
        swiper.wrapperEl.removeEventListener("pointermove", onTouchMove, activeListenerWithCapture);
    }
    on("init", ()=>{
        if (swiper.params.zoom.enabled) enable();
    });
    on("destroy", ()=>{
        disable();
    });
    on("touchStart", (_s, e)=>{
        if (!swiper.zoom.enabled) return;
        onTouchStart(e);
    });
    on("touchEnd", (_s, e)=>{
        if (!swiper.zoom.enabled) return;
        onTouchEnd();
    });
    on("doubleTap", (_s, e)=>{
        if (!swiper.animating && swiper.params.zoom.enabled && swiper.zoom.enabled && swiper.params.zoom.toggle) zoomToggle(e);
    });
    on("transitionEnd", ()=>{
        if (swiper.zoom.enabled && swiper.params.zoom.enabled) onTransitionEnd();
    });
    on("slideChange", ()=>{
        if (swiper.zoom.enabled && swiper.params.zoom.enabled && swiper.params.cssMode) onTransitionEnd();
    });
    Object.assign(swiper.zoom, {
        enable,
        disable,
        in: zoomIn,
        out: zoomOut,
        toggle: zoomToggle
    });
}

},{"../shared/ssr-window.esm.mjs":"ehIRJ","../shared/utils.mjs":"agmBj","@parcel/transformer-js/src/esmodule-helpers.js":"90RNB"}],"jGerC":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>Controller);
var _utilsMjs = require("../shared/utils.mjs");
/* eslint no-bitwise: ["error", { "allow": [">>"] }] */ function Controller(_ref) {
    let { swiper, extendParams, on } = _ref;
    extendParams({
        controller: {
            control: undefined,
            inverse: false,
            by: "slide" // or 'container'
        }
    });
    swiper.controller = {
        control: undefined
    };
    function LinearSpline(x, y) {
        const binarySearch = function search() {
            let maxIndex;
            let minIndex;
            let guess;
            return (array, val)=>{
                minIndex = -1;
                maxIndex = array.length;
                while(maxIndex - minIndex > 1){
                    guess = maxIndex + minIndex >> 1;
                    if (array[guess] <= val) minIndex = guess;
                    else maxIndex = guess;
                }
                return maxIndex;
            };
        }();
        this.x = x;
        this.y = y;
        this.lastIndex = x.length - 1;
        // Given an x value (x2), return the expected y2 value:
        // (x1,y1) is the known point before given value,
        // (x3,y3) is the known point after given value.
        let i1;
        let i3;
        this.interpolate = function interpolate(x2) {
            if (!x2) return 0;
            // Get the indexes of x1 and x3 (the array indexes before and after given x2):
            i3 = binarySearch(this.x, x2);
            i1 = i3 - 1;
            // We have our indexes i1 & i3, so we can calculate already:
            // y2 := ((x2−x1) × (y3−y1)) ÷ (x3−x1) + y1
            return (x2 - this.x[i1]) * (this.y[i3] - this.y[i1]) / (this.x[i3] - this.x[i1]) + this.y[i1];
        };
        return this;
    }
    function getInterpolateFunction(c) {
        swiper.controller.spline = swiper.params.loop ? new LinearSpline(swiper.slidesGrid, c.slidesGrid) : new LinearSpline(swiper.snapGrid, c.snapGrid);
    }
    function setTranslate(_t, byController) {
        const controlled = swiper.controller.control;
        let multiplier;
        let controlledTranslate;
        const Swiper = swiper.constructor;
        function setControlledTranslate(c) {
            if (c.destroyed) return;
            // this will create an Interpolate function based on the snapGrids
            // x is the Grid of the scrolled scroller and y will be the controlled scroller
            // it makes sense to create this only once and recall it for the interpolation
            // the function does a lot of value caching for performance
            const translate = swiper.rtlTranslate ? -swiper.translate : swiper.translate;
            if (swiper.params.controller.by === "slide") {
                getInterpolateFunction(c);
                // i am not sure why the values have to be multiplicated this way, tried to invert the snapGrid
                // but it did not work out
                controlledTranslate = -swiper.controller.spline.interpolate(-translate);
            }
            if (!controlledTranslate || swiper.params.controller.by === "container") {
                multiplier = (c.maxTranslate() - c.minTranslate()) / (swiper.maxTranslate() - swiper.minTranslate());
                if (Number.isNaN(multiplier) || !Number.isFinite(multiplier)) multiplier = 1;
                controlledTranslate = (translate - swiper.minTranslate()) * multiplier + c.minTranslate();
            }
            if (swiper.params.controller.inverse) controlledTranslate = c.maxTranslate() - controlledTranslate;
            c.updateProgress(controlledTranslate);
            c.setTranslate(controlledTranslate, swiper);
            c.updateActiveIndex();
            c.updateSlidesClasses();
        }
        if (Array.isArray(controlled)) {
            for(let i = 0; i < controlled.length; i += 1)if (controlled[i] !== byController && controlled[i] instanceof Swiper) setControlledTranslate(controlled[i]);
        } else if (controlled instanceof Swiper && byController !== controlled) setControlledTranslate(controlled);
    }
    function setTransition(duration, byController) {
        const Swiper = swiper.constructor;
        const controlled = swiper.controller.control;
        let i;
        function setControlledTransition(c) {
            if (c.destroyed) return;
            c.setTransition(duration, swiper);
            if (duration !== 0) {
                c.transitionStart();
                if (c.params.autoHeight) (0, _utilsMjs.n)(()=>{
                    c.updateAutoHeight();
                });
                (0, _utilsMjs.j)(c.wrapperEl, ()=>{
                    if (!controlled) return;
                    c.transitionEnd();
                });
            }
        }
        if (Array.isArray(controlled)) {
            for(i = 0; i < controlled.length; i += 1)if (controlled[i] !== byController && controlled[i] instanceof Swiper) setControlledTransition(controlled[i]);
        } else if (controlled instanceof Swiper && byController !== controlled) setControlledTransition(controlled);
    }
    function removeSpline() {
        if (!swiper.controller.control) return;
        if (swiper.controller.spline) {
            swiper.controller.spline = undefined;
            delete swiper.controller.spline;
        }
    }
    on("beforeInit", ()=>{
        if (typeof window !== "undefined" && // eslint-disable-line
        (typeof swiper.params.controller.control === "string" || swiper.params.controller.control instanceof HTMLElement)) {
            const controlElement = document.querySelector(swiper.params.controller.control);
            if (controlElement && controlElement.swiper) swiper.controller.control = controlElement.swiper;
            else if (controlElement) {
                const onControllerSwiper = (e)=>{
                    swiper.controller.control = e.detail[0];
                    swiper.update();
                    controlElement.removeEventListener("init", onControllerSwiper);
                };
                controlElement.addEventListener("init", onControllerSwiper);
            }
            return;
        }
        swiper.controller.control = swiper.params.controller.control;
    });
    on("update", ()=>{
        removeSpline();
    });
    on("resize", ()=>{
        removeSpline();
    });
    on("observerUpdate", ()=>{
        removeSpline();
    });
    on("setTranslate", (_s, translate, byController)=>{
        if (!swiper.controller.control || swiper.controller.control.destroyed) return;
        swiper.controller.setTranslate(translate, byController);
    });
    on("setTransition", (_s, duration, byController)=>{
        if (!swiper.controller.control || swiper.controller.control.destroyed) return;
        swiper.controller.setTransition(duration, byController);
    });
    Object.assign(swiper.controller, {
        setTranslate,
        setTransition
    });
}

},{"../shared/utils.mjs":"agmBj","@parcel/transformer-js/src/esmodule-helpers.js":"90RNB"}],"2VqlZ":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>A11y);
var _classesToSelectorMjs = require("../shared/classes-to-selector.mjs");
var _utilsMjs = require("../shared/utils.mjs");
function A11y(_ref) {
    let { swiper, extendParams, on } = _ref;
    extendParams({
        a11y: {
            enabled: true,
            notificationClass: "swiper-notification",
            prevSlideMessage: "Previous slide",
            nextSlideMessage: "Next slide",
            firstSlideMessage: "This is the first slide",
            lastSlideMessage: "This is the last slide",
            paginationBulletMessage: "Go to slide {{index}}",
            slideLabelMessage: "{{index}} / {{slidesLength}}",
            containerMessage: null,
            containerRoleDescriptionMessage: null,
            itemRoleDescriptionMessage: null,
            slideRole: "group",
            id: null
        }
    });
    swiper.a11y = {
        clicked: false
    };
    let liveRegion = null;
    function notify(message) {
        const notification = liveRegion;
        if (notification.length === 0) return;
        notification.innerHTML = "";
        notification.innerHTML = message;
    }
    const makeElementsArray = (el)=>(Array.isArray(el) ? el : [
            el
        ]).filter((e)=>!!e);
    function getRandomNumber(size) {
        if (size === void 0) size = 16;
        const randomChar = ()=>Math.round(16 * Math.random()).toString(16);
        return "x".repeat(size).replace(/x/g, randomChar);
    }
    function makeElFocusable(el) {
        el = makeElementsArray(el);
        el.forEach((subEl)=>{
            subEl.setAttribute("tabIndex", "0");
        });
    }
    function makeElNotFocusable(el) {
        el = makeElementsArray(el);
        el.forEach((subEl)=>{
            subEl.setAttribute("tabIndex", "-1");
        });
    }
    function addElRole(el, role) {
        el = makeElementsArray(el);
        el.forEach((subEl)=>{
            subEl.setAttribute("role", role);
        });
    }
    function addElRoleDescription(el, description) {
        el = makeElementsArray(el);
        el.forEach((subEl)=>{
            subEl.setAttribute("aria-roledescription", description);
        });
    }
    function addElControls(el, controls) {
        el = makeElementsArray(el);
        el.forEach((subEl)=>{
            subEl.setAttribute("aria-controls", controls);
        });
    }
    function addElLabel(el, label) {
        el = makeElementsArray(el);
        el.forEach((subEl)=>{
            subEl.setAttribute("aria-label", label);
        });
    }
    function addElId(el, id) {
        el = makeElementsArray(el);
        el.forEach((subEl)=>{
            subEl.setAttribute("id", id);
        });
    }
    function addElLive(el, live) {
        el = makeElementsArray(el);
        el.forEach((subEl)=>{
            subEl.setAttribute("aria-live", live);
        });
    }
    function disableEl(el) {
        el = makeElementsArray(el);
        el.forEach((subEl)=>{
            subEl.setAttribute("aria-disabled", true);
        });
    }
    function enableEl(el) {
        el = makeElementsArray(el);
        el.forEach((subEl)=>{
            subEl.setAttribute("aria-disabled", false);
        });
    }
    function onEnterOrSpaceKey(e) {
        if (e.keyCode !== 13 && e.keyCode !== 32) return;
        const params = swiper.params.a11y;
        const targetEl = e.target;
        if (swiper.pagination && swiper.pagination.el && (targetEl === swiper.pagination.el || swiper.pagination.el.contains(e.target))) {
            if (!e.target.matches((0, _classesToSelectorMjs.c)(swiper.params.pagination.bulletClass))) return;
        }
        if (swiper.navigation && swiper.navigation.nextEl && targetEl === swiper.navigation.nextEl) {
            if (!(swiper.isEnd && !swiper.params.loop)) swiper.slideNext();
            if (swiper.isEnd) notify(params.lastSlideMessage);
            else notify(params.nextSlideMessage);
        }
        if (swiper.navigation && swiper.navigation.prevEl && targetEl === swiper.navigation.prevEl) {
            if (!(swiper.isBeginning && !swiper.params.loop)) swiper.slidePrev();
            if (swiper.isBeginning) notify(params.firstSlideMessage);
            else notify(params.prevSlideMessage);
        }
        if (swiper.pagination && targetEl.matches((0, _classesToSelectorMjs.c)(swiper.params.pagination.bulletClass))) targetEl.click();
    }
    function updateNavigation() {
        if (swiper.params.loop || swiper.params.rewind || !swiper.navigation) return;
        const { nextEl, prevEl } = swiper.navigation;
        if (prevEl) {
            if (swiper.isBeginning) {
                disableEl(prevEl);
                makeElNotFocusable(prevEl);
            } else {
                enableEl(prevEl);
                makeElFocusable(prevEl);
            }
        }
        if (nextEl) {
            if (swiper.isEnd) {
                disableEl(nextEl);
                makeElNotFocusable(nextEl);
            } else {
                enableEl(nextEl);
                makeElFocusable(nextEl);
            }
        }
    }
    function hasPagination() {
        return swiper.pagination && swiper.pagination.bullets && swiper.pagination.bullets.length;
    }
    function hasClickablePagination() {
        return hasPagination() && swiper.params.pagination.clickable;
    }
    function updatePagination() {
        const params = swiper.params.a11y;
        if (!hasPagination()) return;
        swiper.pagination.bullets.forEach((bulletEl)=>{
            if (swiper.params.pagination.clickable) {
                makeElFocusable(bulletEl);
                if (!swiper.params.pagination.renderBullet) {
                    addElRole(bulletEl, "button");
                    addElLabel(bulletEl, params.paginationBulletMessage.replace(/\{\{index\}\}/, (0, _utilsMjs.g)(bulletEl) + 1));
                }
            }
            if (bulletEl.matches((0, _classesToSelectorMjs.c)(swiper.params.pagination.bulletActiveClass))) bulletEl.setAttribute("aria-current", "true");
            else bulletEl.removeAttribute("aria-current");
        });
    }
    const initNavEl = (el, wrapperId, message)=>{
        makeElFocusable(el);
        if (el.tagName !== "BUTTON") {
            addElRole(el, "button");
            el.addEventListener("keydown", onEnterOrSpaceKey);
        }
        addElLabel(el, message);
        addElControls(el, wrapperId);
    };
    const handlePointerDown = ()=>{
        swiper.a11y.clicked = true;
    };
    const handlePointerUp = ()=>{
        requestAnimationFrame(()=>{
            requestAnimationFrame(()=>{
                if (!swiper.destroyed) swiper.a11y.clicked = false;
            });
        });
    };
    const handleFocus = (e)=>{
        if (swiper.a11y.clicked) return;
        const slideEl = e.target.closest(`.${swiper.params.slideClass}, swiper-slide`);
        if (!slideEl || !swiper.slides.includes(slideEl)) return;
        const isActive = swiper.slides.indexOf(slideEl) === swiper.activeIndex;
        const isVisible = swiper.params.watchSlidesProgress && swiper.visibleSlides && swiper.visibleSlides.includes(slideEl);
        if (isActive || isVisible) return;
        if (e.sourceCapabilities && e.sourceCapabilities.firesTouchEvents) return;
        if (swiper.isHorizontal()) swiper.el.scrollLeft = 0;
        else swiper.el.scrollTop = 0;
        swiper.slideTo(swiper.slides.indexOf(slideEl), 0);
    };
    const initSlides = ()=>{
        const params = swiper.params.a11y;
        if (params.itemRoleDescriptionMessage) addElRoleDescription(swiper.slides, params.itemRoleDescriptionMessage);
        if (params.slideRole) addElRole(swiper.slides, params.slideRole);
        const slidesLength = swiper.slides.length;
        if (params.slideLabelMessage) swiper.slides.forEach((slideEl, index)=>{
            const slideIndex = swiper.params.loop ? parseInt(slideEl.getAttribute("data-swiper-slide-index"), 10) : index;
            const ariaLabelMessage = params.slideLabelMessage.replace(/\{\{index\}\}/, slideIndex + 1).replace(/\{\{slidesLength\}\}/, slidesLength);
            addElLabel(slideEl, ariaLabelMessage);
        });
    };
    const init = ()=>{
        const params = swiper.params.a11y;
        swiper.el.append(liveRegion);
        // Container
        const containerEl = swiper.el;
        if (params.containerRoleDescriptionMessage) addElRoleDescription(containerEl, params.containerRoleDescriptionMessage);
        if (params.containerMessage) addElLabel(containerEl, params.containerMessage);
        // Wrapper
        const wrapperEl = swiper.wrapperEl;
        const wrapperId = params.id || wrapperEl.getAttribute("id") || `swiper-wrapper-${getRandomNumber(16)}`;
        const live = swiper.params.autoplay && swiper.params.autoplay.enabled ? "off" : "polite";
        addElId(wrapperEl, wrapperId);
        addElLive(wrapperEl, live);
        // Slide
        initSlides();
        // Navigation
        let { nextEl, prevEl } = swiper.navigation ? swiper.navigation : {};
        nextEl = makeElementsArray(nextEl);
        prevEl = makeElementsArray(prevEl);
        if (nextEl) nextEl.forEach((el)=>initNavEl(el, wrapperId, params.nextSlideMessage));
        if (prevEl) prevEl.forEach((el)=>initNavEl(el, wrapperId, params.prevSlideMessage));
        // Pagination
        if (hasClickablePagination()) {
            const paginationEl = makeElementsArray(swiper.pagination.el);
            paginationEl.forEach((el)=>{
                el.addEventListener("keydown", onEnterOrSpaceKey);
            });
        }
        // Tab focus
        swiper.el.addEventListener("focus", handleFocus, true);
        swiper.el.addEventListener("pointerdown", handlePointerDown, true);
        swiper.el.addEventListener("pointerup", handlePointerUp, true);
    };
    function destroy() {
        if (liveRegion) liveRegion.remove();
        let { nextEl, prevEl } = swiper.navigation ? swiper.navigation : {};
        nextEl = makeElementsArray(nextEl);
        prevEl = makeElementsArray(prevEl);
        if (nextEl) nextEl.forEach((el)=>el.removeEventListener("keydown", onEnterOrSpaceKey));
        if (prevEl) prevEl.forEach((el)=>el.removeEventListener("keydown", onEnterOrSpaceKey));
        // Pagination
        if (hasClickablePagination()) {
            const paginationEl = makeElementsArray(swiper.pagination.el);
            paginationEl.forEach((el)=>{
                el.removeEventListener("keydown", onEnterOrSpaceKey);
            });
        }
        // Tab focus
        swiper.el.removeEventListener("focus", handleFocus, true);
        swiper.el.removeEventListener("pointerdown", handlePointerDown, true);
        swiper.el.removeEventListener("pointerup", handlePointerUp, true);
    }
    on("beforeInit", ()=>{
        liveRegion = (0, _utilsMjs.c)("span", swiper.params.a11y.notificationClass);
        liveRegion.setAttribute("aria-live", "assertive");
        liveRegion.setAttribute("aria-atomic", "true");
    });
    on("afterInit", ()=>{
        if (!swiper.params.a11y.enabled) return;
        init();
    });
    on("slidesLengthChange snapGridLengthChange slidesGridLengthChange", ()=>{
        if (!swiper.params.a11y.enabled) return;
        initSlides();
    });
    on("fromEdge toEdge afterInit lock unlock", ()=>{
        if (!swiper.params.a11y.enabled) return;
        updateNavigation();
    });
    on("paginationUpdate", ()=>{
        if (!swiper.params.a11y.enabled) return;
        updatePagination();
    });
    on("destroy", ()=>{
        if (!swiper.params.a11y.enabled) return;
        destroy();
    });
}

},{"../shared/classes-to-selector.mjs":"lC2D7","../shared/utils.mjs":"agmBj","@parcel/transformer-js/src/esmodule-helpers.js":"90RNB"}],"kinZy":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>History);
var _ssrWindowEsmMjs = require("../shared/ssr-window.esm.mjs");
function History(_ref) {
    let { swiper, extendParams, on } = _ref;
    extendParams({
        history: {
            enabled: false,
            root: "",
            replaceState: false,
            key: "slides",
            keepQuery: false
        }
    });
    let initialized = false;
    let paths = {};
    const slugify = (text)=>{
        return text.toString().replace(/\s+/g, "-").replace(/[^\w-]+/g, "").replace(/--+/g, "-").replace(/^-+/, "").replace(/-+$/, "");
    };
    const getPathValues = (urlOverride)=>{
        const window = (0, _ssrWindowEsmMjs.a)();
        let location;
        if (urlOverride) location = new URL(urlOverride);
        else location = window.location;
        const pathArray = location.pathname.slice(1).split("/").filter((part)=>part !== "");
        const total = pathArray.length;
        const key = pathArray[total - 2];
        const value = pathArray[total - 1];
        return {
            key,
            value
        };
    };
    const setHistory = (key, index)=>{
        const window = (0, _ssrWindowEsmMjs.a)();
        if (!initialized || !swiper.params.history.enabled) return;
        let location;
        if (swiper.params.url) location = new URL(swiper.params.url);
        else location = window.location;
        const slide = swiper.slides[index];
        let value = slugify(slide.getAttribute("data-history"));
        if (swiper.params.history.root.length > 0) {
            let root = swiper.params.history.root;
            if (root[root.length - 1] === "/") root = root.slice(0, root.length - 1);
            value = `${root}/${key ? `${key}/` : ""}${value}`;
        } else if (!location.pathname.includes(key)) value = `${key ? `${key}/` : ""}${value}`;
        if (swiper.params.history.keepQuery) value += location.search;
        const currentState = window.history.state;
        if (currentState && currentState.value === value) return;
        if (swiper.params.history.replaceState) window.history.replaceState({
            value
        }, null, value);
        else window.history.pushState({
            value
        }, null, value);
    };
    const scrollToSlide = (speed, value, runCallbacks)=>{
        if (value) for(let i = 0, length = swiper.slides.length; i < length; i += 1){
            const slide = swiper.slides[i];
            const slideHistory = slugify(slide.getAttribute("data-history"));
            if (slideHistory === value) {
                const index = swiper.getSlideIndex(slide);
                swiper.slideTo(index, speed, runCallbacks);
            }
        }
        else swiper.slideTo(0, speed, runCallbacks);
    };
    const setHistoryPopState = ()=>{
        paths = getPathValues(swiper.params.url);
        scrollToSlide(swiper.params.speed, paths.value, false);
    };
    const init = ()=>{
        const window = (0, _ssrWindowEsmMjs.a)();
        if (!swiper.params.history) return;
        if (!window.history || !window.history.pushState) {
            swiper.params.history.enabled = false;
            swiper.params.hashNavigation.enabled = true;
            return;
        }
        initialized = true;
        paths = getPathValues(swiper.params.url);
        if (!paths.key && !paths.value) {
            if (!swiper.params.history.replaceState) window.addEventListener("popstate", setHistoryPopState);
            return;
        }
        scrollToSlide(0, paths.value, swiper.params.runCallbacksOnInit);
        if (!swiper.params.history.replaceState) window.addEventListener("popstate", setHistoryPopState);
    };
    const destroy = ()=>{
        const window = (0, _ssrWindowEsmMjs.a)();
        if (!swiper.params.history.replaceState) window.removeEventListener("popstate", setHistoryPopState);
    };
    on("init", ()=>{
        if (swiper.params.history.enabled) init();
    });
    on("destroy", ()=>{
        if (swiper.params.history.enabled) destroy();
    });
    on("transitionEnd _freeModeNoMomentumRelease", ()=>{
        if (initialized) setHistory(swiper.params.history.key, swiper.activeIndex);
    });
    on("slideChange", ()=>{
        if (initialized && swiper.params.cssMode) setHistory(swiper.params.history.key, swiper.activeIndex);
    });
}

},{"../shared/ssr-window.esm.mjs":"ehIRJ","@parcel/transformer-js/src/esmodule-helpers.js":"90RNB"}],"5e3ak":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>HashNavigation);
var _ssrWindowEsmMjs = require("../shared/ssr-window.esm.mjs");
var _utilsMjs = require("../shared/utils.mjs");
function HashNavigation(_ref) {
    let { swiper, extendParams, emit, on } = _ref;
    let initialized = false;
    const document = (0, _ssrWindowEsmMjs.g)();
    const window = (0, _ssrWindowEsmMjs.a)();
    extendParams({
        hashNavigation: {
            enabled: false,
            replaceState: false,
            watchState: false,
            getSlideIndex (_s, hash) {
                if (swiper.virtual && swiper.params.virtual.enabled) {
                    const slideWithHash = swiper.slides.filter((slideEl)=>slideEl.getAttribute("data-hash") === hash)[0];
                    if (!slideWithHash) return 0;
                    const index = parseInt(slideWithHash.getAttribute("data-swiper-slide-index"), 10);
                    return index;
                }
                return swiper.getSlideIndex((0, _utilsMjs.e)(swiper.slidesEl, `.${swiper.params.slideClass}[data-hash="${hash}"], swiper-slide[data-hash="${hash}"]`)[0]);
            }
        }
    });
    const onHashChange = ()=>{
        emit("hashChange");
        const newHash = document.location.hash.replace("#", "");
        const activeSlideEl = swiper.virtual && swiper.params.virtual.enabled ? swiper.slidesEl.querySelector(`[data-swiper-slide-index="${swiper.activeIndex}"]`) : swiper.slides[swiper.activeIndex];
        const activeSlideHash = activeSlideEl ? activeSlideEl.getAttribute("data-hash") : "";
        if (newHash !== activeSlideHash) {
            const newIndex = swiper.params.hashNavigation.getSlideIndex(swiper, newHash);
            if (typeof newIndex === "undefined" || Number.isNaN(newIndex)) return;
            swiper.slideTo(newIndex);
        }
    };
    const setHash = ()=>{
        if (!initialized || !swiper.params.hashNavigation.enabled) return;
        const activeSlideEl = swiper.virtual && swiper.params.virtual.enabled ? swiper.slidesEl.querySelector(`[data-swiper-slide-index="${swiper.activeIndex}"]`) : swiper.slides[swiper.activeIndex];
        const activeSlideHash = activeSlideEl ? activeSlideEl.getAttribute("data-hash") || activeSlideEl.getAttribute("data-history") : "";
        if (swiper.params.hashNavigation.replaceState && window.history && window.history.replaceState) {
            window.history.replaceState(null, null, `#${activeSlideHash}` || "");
            emit("hashSet");
        } else {
            document.location.hash = activeSlideHash || "";
            emit("hashSet");
        }
    };
    const init = ()=>{
        if (!swiper.params.hashNavigation.enabled || swiper.params.history && swiper.params.history.enabled) return;
        initialized = true;
        const hash = document.location.hash.replace("#", "");
        if (hash) {
            const speed = 0;
            const index = swiper.params.hashNavigation.getSlideIndex(swiper, hash);
            swiper.slideTo(index || 0, speed, swiper.params.runCallbacksOnInit, true);
        }
        if (swiper.params.hashNavigation.watchState) window.addEventListener("hashchange", onHashChange);
    };
    const destroy = ()=>{
        if (swiper.params.hashNavigation.watchState) window.removeEventListener("hashchange", onHashChange);
    };
    on("init", ()=>{
        if (swiper.params.hashNavigation.enabled) init();
    });
    on("destroy", ()=>{
        if (swiper.params.hashNavigation.enabled) destroy();
    });
    on("transitionEnd _freeModeNoMomentumRelease", ()=>{
        if (initialized) setHash();
    });
    on("slideChange", ()=>{
        if (initialized && swiper.params.cssMode) setHash();
    });
}

},{"../shared/ssr-window.esm.mjs":"ehIRJ","../shared/utils.mjs":"agmBj","@parcel/transformer-js/src/esmodule-helpers.js":"90RNB"}],"ahAVy":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>Autoplay);
var _ssrWindowEsmMjs = require("../shared/ssr-window.esm.mjs");
/* eslint no-underscore-dangle: "off" */ /* eslint no-use-before-define: "off" */ function Autoplay(_ref) {
    let { swiper, extendParams, on, emit, params } = _ref;
    swiper.autoplay = {
        running: false,
        paused: false,
        timeLeft: 0
    };
    extendParams({
        autoplay: {
            enabled: false,
            delay: 3000,
            waitForTransition: true,
            disableOnInteraction: false,
            stopOnLastSlide: false,
            reverseDirection: false,
            pauseOnMouseEnter: false
        }
    });
    let timeout;
    let raf;
    let autoplayDelayTotal = params && params.autoplay ? params.autoplay.delay : 3000;
    let autoplayDelayCurrent = params && params.autoplay ? params.autoplay.delay : 3000;
    let autoplayTimeLeft;
    let autoplayStartTime = new Date().getTime();
    let wasPaused;
    let isTouched;
    let pausedByTouch;
    let touchStartTimeout;
    let slideChanged;
    let pausedByInteraction;
    let pausedByPointerEnter;
    function onTransitionEnd(e) {
        if (!swiper || swiper.destroyed || !swiper.wrapperEl) return;
        if (e.target !== swiper.wrapperEl) return;
        swiper.wrapperEl.removeEventListener("transitionend", onTransitionEnd);
        if (pausedByPointerEnter) return;
        resume();
    }
    const calcTimeLeft = ()=>{
        if (swiper.destroyed || !swiper.autoplay.running) return;
        if (swiper.autoplay.paused) wasPaused = true;
        else if (wasPaused) {
            autoplayDelayCurrent = autoplayTimeLeft;
            wasPaused = false;
        }
        const timeLeft = swiper.autoplay.paused ? autoplayTimeLeft : autoplayStartTime + autoplayDelayCurrent - new Date().getTime();
        swiper.autoplay.timeLeft = timeLeft;
        emit("autoplayTimeLeft", timeLeft, timeLeft / autoplayDelayTotal);
        raf = requestAnimationFrame(()=>{
            calcTimeLeft();
        });
    };
    const getSlideDelay = ()=>{
        let activeSlideEl;
        if (swiper.virtual && swiper.params.virtual.enabled) activeSlideEl = swiper.slides.filter((slideEl)=>slideEl.classList.contains("swiper-slide-active"))[0];
        else activeSlideEl = swiper.slides[swiper.activeIndex];
        if (!activeSlideEl) return undefined;
        const currentSlideDelay = parseInt(activeSlideEl.getAttribute("data-swiper-autoplay"), 10);
        return currentSlideDelay;
    };
    const run = (delayForce)=>{
        if (swiper.destroyed || !swiper.autoplay.running) return;
        cancelAnimationFrame(raf);
        calcTimeLeft();
        let delay = typeof delayForce === "undefined" ? swiper.params.autoplay.delay : delayForce;
        autoplayDelayTotal = swiper.params.autoplay.delay;
        autoplayDelayCurrent = swiper.params.autoplay.delay;
        const currentSlideDelay = getSlideDelay();
        if (!Number.isNaN(currentSlideDelay) && currentSlideDelay > 0 && typeof delayForce === "undefined") {
            delay = currentSlideDelay;
            autoplayDelayTotal = currentSlideDelay;
            autoplayDelayCurrent = currentSlideDelay;
        }
        autoplayTimeLeft = delay;
        const speed = swiper.params.speed;
        const proceed = ()=>{
            if (!swiper || swiper.destroyed) return;
            if (swiper.params.autoplay.reverseDirection) {
                if (!swiper.isBeginning || swiper.params.loop || swiper.params.rewind) {
                    swiper.slidePrev(speed, true, true);
                    emit("autoplay");
                } else if (!swiper.params.autoplay.stopOnLastSlide) {
                    swiper.slideTo(swiper.slides.length - 1, speed, true, true);
                    emit("autoplay");
                }
            } else {
                if (!swiper.isEnd || swiper.params.loop || swiper.params.rewind) {
                    swiper.slideNext(speed, true, true);
                    emit("autoplay");
                } else if (!swiper.params.autoplay.stopOnLastSlide) {
                    swiper.slideTo(0, speed, true, true);
                    emit("autoplay");
                }
            }
            if (swiper.params.cssMode) {
                autoplayStartTime = new Date().getTime();
                requestAnimationFrame(()=>{
                    run();
                });
            }
        };
        if (delay > 0) {
            clearTimeout(timeout);
            timeout = setTimeout(()=>{
                proceed();
            }, delay);
        } else requestAnimationFrame(()=>{
            proceed();
        });
        // eslint-disable-next-line
        return delay;
    };
    const start = ()=>{
        autoplayStartTime = new Date().getTime();
        swiper.autoplay.running = true;
        run();
        emit("autoplayStart");
    };
    const stop = ()=>{
        swiper.autoplay.running = false;
        clearTimeout(timeout);
        cancelAnimationFrame(raf);
        emit("autoplayStop");
    };
    const pause = (internal, reset)=>{
        if (swiper.destroyed || !swiper.autoplay.running) return;
        clearTimeout(timeout);
        if (!internal) pausedByInteraction = true;
        const proceed = ()=>{
            emit("autoplayPause");
            if (swiper.params.autoplay.waitForTransition) swiper.wrapperEl.addEventListener("transitionend", onTransitionEnd);
            else resume();
        };
        swiper.autoplay.paused = true;
        if (reset) {
            if (slideChanged) autoplayTimeLeft = swiper.params.autoplay.delay;
            slideChanged = false;
            proceed();
            return;
        }
        const delay = autoplayTimeLeft || swiper.params.autoplay.delay;
        autoplayTimeLeft = delay - (new Date().getTime() - autoplayStartTime);
        if (swiper.isEnd && autoplayTimeLeft < 0 && !swiper.params.loop) return;
        if (autoplayTimeLeft < 0) autoplayTimeLeft = 0;
        proceed();
    };
    const resume = ()=>{
        if (swiper.isEnd && autoplayTimeLeft < 0 && !swiper.params.loop || swiper.destroyed || !swiper.autoplay.running) return;
        autoplayStartTime = new Date().getTime();
        if (pausedByInteraction) {
            pausedByInteraction = false;
            run(autoplayTimeLeft);
        } else run();
        swiper.autoplay.paused = false;
        emit("autoplayResume");
    };
    const onVisibilityChange = ()=>{
        if (swiper.destroyed || !swiper.autoplay.running) return;
        const document = (0, _ssrWindowEsmMjs.g)();
        if (document.visibilityState === "hidden") {
            pausedByInteraction = true;
            pause(true);
        }
        if (document.visibilityState === "visible") resume();
    };
    const onPointerEnter = (e)=>{
        if (e.pointerType !== "mouse") return;
        pausedByInteraction = true;
        pausedByPointerEnter = true;
        if (swiper.animating || swiper.autoplay.paused) return;
        pause(true);
    };
    const onPointerLeave = (e)=>{
        if (e.pointerType !== "mouse") return;
        pausedByPointerEnter = false;
        if (swiper.autoplay.paused) resume();
    };
    const attachMouseEvents = ()=>{
        if (swiper.params.autoplay.pauseOnMouseEnter) {
            swiper.el.addEventListener("pointerenter", onPointerEnter);
            swiper.el.addEventListener("pointerleave", onPointerLeave);
        }
    };
    const detachMouseEvents = ()=>{
        swiper.el.removeEventListener("pointerenter", onPointerEnter);
        swiper.el.removeEventListener("pointerleave", onPointerLeave);
    };
    const attachDocumentEvents = ()=>{
        const document = (0, _ssrWindowEsmMjs.g)();
        document.addEventListener("visibilitychange", onVisibilityChange);
    };
    const detachDocumentEvents = ()=>{
        const document = (0, _ssrWindowEsmMjs.g)();
        document.removeEventListener("visibilitychange", onVisibilityChange);
    };
    on("init", ()=>{
        if (swiper.params.autoplay.enabled) {
            attachMouseEvents();
            attachDocumentEvents();
            start();
        }
    });
    on("destroy", ()=>{
        detachMouseEvents();
        detachDocumentEvents();
        if (swiper.autoplay.running) stop();
    });
    on("_freeModeStaticRelease", ()=>{
        if (pausedByTouch || pausedByInteraction) resume();
    });
    on("_freeModeNoMomentumRelease", ()=>{
        if (!swiper.params.autoplay.disableOnInteraction) pause(true, true);
        else stop();
    });
    on("beforeTransitionStart", (_s, speed, internal)=>{
        if (swiper.destroyed || !swiper.autoplay.running) return;
        if (internal || !swiper.params.autoplay.disableOnInteraction) pause(true, true);
        else stop();
    });
    on("sliderFirstMove", ()=>{
        if (swiper.destroyed || !swiper.autoplay.running) return;
        if (swiper.params.autoplay.disableOnInteraction) {
            stop();
            return;
        }
        isTouched = true;
        pausedByTouch = false;
        pausedByInteraction = false;
        touchStartTimeout = setTimeout(()=>{
            pausedByInteraction = true;
            pausedByTouch = true;
            pause(true);
        }, 200);
    });
    on("touchEnd", ()=>{
        if (swiper.destroyed || !swiper.autoplay.running || !isTouched) return;
        clearTimeout(touchStartTimeout);
        clearTimeout(timeout);
        if (swiper.params.autoplay.disableOnInteraction) {
            pausedByTouch = false;
            isTouched = false;
            return;
        }
        if (pausedByTouch && swiper.params.cssMode) resume();
        pausedByTouch = false;
        isTouched = false;
    });
    on("slideChange", ()=>{
        if (swiper.destroyed || !swiper.autoplay.running) return;
        slideChanged = true;
    });
    Object.assign(swiper.autoplay, {
        start,
        stop,
        pause,
        resume
    });
}

},{"../shared/ssr-window.esm.mjs":"ehIRJ","@parcel/transformer-js/src/esmodule-helpers.js":"90RNB"}],"32RsP":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>Thumb);
var _ssrWindowEsmMjs = require("../shared/ssr-window.esm.mjs");
var _utilsMjs = require("../shared/utils.mjs");
function Thumb(_ref) {
    let { swiper, extendParams, on } = _ref;
    extendParams({
        thumbs: {
            swiper: null,
            multipleActiveThumbs: true,
            autoScrollOffset: 0,
            slideThumbActiveClass: "swiper-slide-thumb-active",
            thumbsContainerClass: "swiper-thumbs"
        }
    });
    let initialized = false;
    let swiperCreated = false;
    swiper.thumbs = {
        swiper: null
    };
    function onThumbClick() {
        const thumbsSwiper = swiper.thumbs.swiper;
        if (!thumbsSwiper || thumbsSwiper.destroyed) return;
        const clickedIndex = thumbsSwiper.clickedIndex;
        const clickedSlide = thumbsSwiper.clickedSlide;
        if (clickedSlide && clickedSlide.classList.contains(swiper.params.thumbs.slideThumbActiveClass)) return;
        if (typeof clickedIndex === "undefined" || clickedIndex === null) return;
        let slideToIndex;
        if (thumbsSwiper.params.loop) slideToIndex = parseInt(thumbsSwiper.clickedSlide.getAttribute("data-swiper-slide-index"), 10);
        else slideToIndex = clickedIndex;
        if (swiper.params.loop) swiper.slideToLoop(slideToIndex);
        else swiper.slideTo(slideToIndex);
    }
    function init() {
        const { thumbs: thumbsParams } = swiper.params;
        if (initialized) return false;
        initialized = true;
        const SwiperClass = swiper.constructor;
        if (thumbsParams.swiper instanceof SwiperClass) {
            swiper.thumbs.swiper = thumbsParams.swiper;
            Object.assign(swiper.thumbs.swiper.originalParams, {
                watchSlidesProgress: true,
                slideToClickedSlide: false
            });
            Object.assign(swiper.thumbs.swiper.params, {
                watchSlidesProgress: true,
                slideToClickedSlide: false
            });
            swiper.thumbs.swiper.update();
        } else if ((0, _utilsMjs.k)(thumbsParams.swiper)) {
            const thumbsSwiperParams = Object.assign({}, thumbsParams.swiper);
            Object.assign(thumbsSwiperParams, {
                watchSlidesProgress: true,
                slideToClickedSlide: false
            });
            swiper.thumbs.swiper = new SwiperClass(thumbsSwiperParams);
            swiperCreated = true;
        }
        swiper.thumbs.swiper.el.classList.add(swiper.params.thumbs.thumbsContainerClass);
        swiper.thumbs.swiper.on("tap", onThumbClick);
        return true;
    }
    function update(initial) {
        const thumbsSwiper = swiper.thumbs.swiper;
        if (!thumbsSwiper || thumbsSwiper.destroyed) return;
        const slidesPerView = thumbsSwiper.params.slidesPerView === "auto" ? thumbsSwiper.slidesPerViewDynamic() : thumbsSwiper.params.slidesPerView;
        // Activate thumbs
        let thumbsToActivate = 1;
        const thumbActiveClass = swiper.params.thumbs.slideThumbActiveClass;
        if (swiper.params.slidesPerView > 1 && !swiper.params.centeredSlides) thumbsToActivate = swiper.params.slidesPerView;
        if (!swiper.params.thumbs.multipleActiveThumbs) thumbsToActivate = 1;
        thumbsToActivate = Math.floor(thumbsToActivate);
        thumbsSwiper.slides.forEach((slideEl)=>slideEl.classList.remove(thumbActiveClass));
        if (thumbsSwiper.params.loop || thumbsSwiper.params.virtual && thumbsSwiper.params.virtual.enabled) for(let i = 0; i < thumbsToActivate; i += 1)(0, _utilsMjs.e)(thumbsSwiper.slidesEl, `[data-swiper-slide-index="${swiper.realIndex + i}"]`).forEach((slideEl)=>{
            slideEl.classList.add(thumbActiveClass);
        });
        else {
            for(let i = 0; i < thumbsToActivate; i += 1)if (thumbsSwiper.slides[swiper.realIndex + i]) thumbsSwiper.slides[swiper.realIndex + i].classList.add(thumbActiveClass);
        }
        const autoScrollOffset = swiper.params.thumbs.autoScrollOffset;
        const useOffset = autoScrollOffset && !thumbsSwiper.params.loop;
        if (swiper.realIndex !== thumbsSwiper.realIndex || useOffset) {
            const currentThumbsIndex = thumbsSwiper.activeIndex;
            let newThumbsIndex;
            let direction;
            if (thumbsSwiper.params.loop) {
                const newThumbsSlide = thumbsSwiper.slides.filter((slideEl)=>slideEl.getAttribute("data-swiper-slide-index") === `${swiper.realIndex}`)[0];
                newThumbsIndex = thumbsSwiper.slides.indexOf(newThumbsSlide);
                direction = swiper.activeIndex > swiper.previousIndex ? "next" : "prev";
            } else {
                newThumbsIndex = swiper.realIndex;
                direction = newThumbsIndex > swiper.previousIndex ? "next" : "prev";
            }
            if (useOffset) newThumbsIndex += direction === "next" ? autoScrollOffset : -1 * autoScrollOffset;
            if (thumbsSwiper.visibleSlidesIndexes && thumbsSwiper.visibleSlidesIndexes.indexOf(newThumbsIndex) < 0) {
                if (thumbsSwiper.params.centeredSlides) {
                    if (newThumbsIndex > currentThumbsIndex) newThumbsIndex = newThumbsIndex - Math.floor(slidesPerView / 2) + 1;
                    else newThumbsIndex = newThumbsIndex + Math.floor(slidesPerView / 2) - 1;
                } else newThumbsIndex > currentThumbsIndex && thumbsSwiper.params.slidesPerGroup;
                thumbsSwiper.slideTo(newThumbsIndex, initial ? 0 : undefined);
            }
        }
    }
    on("beforeInit", ()=>{
        const { thumbs } = swiper.params;
        if (!thumbs || !thumbs.swiper) return;
        if (typeof thumbs.swiper === "string" || thumbs.swiper instanceof HTMLElement) {
            const document = (0, _ssrWindowEsmMjs.g)();
            const getThumbsElementAndInit = ()=>{
                const thumbsElement = typeof thumbs.swiper === "string" ? document.querySelector(thumbs.swiper) : thumbs.swiper;
                if (thumbsElement && thumbsElement.swiper) {
                    thumbs.swiper = thumbsElement.swiper;
                    init();
                    update(true);
                } else if (thumbsElement) {
                    const onThumbsSwiper = (e)=>{
                        thumbs.swiper = e.detail[0];
                        thumbsElement.removeEventListener("init", onThumbsSwiper);
                        init();
                        update(true);
                        thumbs.swiper.update();
                        swiper.update();
                    };
                    thumbsElement.addEventListener("init", onThumbsSwiper);
                }
                return thumbsElement;
            };
            const watchForThumbsToAppear = ()=>{
                if (swiper.destroyed) return;
                const thumbsElement = getThumbsElementAndInit();
                if (!thumbsElement) requestAnimationFrame(watchForThumbsToAppear);
            };
            requestAnimationFrame(watchForThumbsToAppear);
        } else {
            init();
            update(true);
        }
    });
    on("slideChange update resize observerUpdate", ()=>{
        update();
    });
    on("setTransition", (_s, duration)=>{
        const thumbsSwiper = swiper.thumbs.swiper;
        if (!thumbsSwiper || thumbsSwiper.destroyed) return;
        thumbsSwiper.setTransition(duration);
    });
    on("beforeDestroy", ()=>{
        const thumbsSwiper = swiper.thumbs.swiper;
        if (!thumbsSwiper || thumbsSwiper.destroyed) return;
        if (swiperCreated) thumbsSwiper.destroy();
    });
    Object.assign(swiper.thumbs, {
        init,
        update
    });
}

},{"../shared/ssr-window.esm.mjs":"ehIRJ","../shared/utils.mjs":"agmBj","@parcel/transformer-js/src/esmodule-helpers.js":"90RNB"}],"hmLnH":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>freeMode);
var _utilsMjs = require("../shared/utils.mjs");
function freeMode(_ref) {
    let { swiper, extendParams, emit, once } = _ref;
    extendParams({
        freeMode: {
            enabled: false,
            momentum: true,
            momentumRatio: 1,
            momentumBounce: true,
            momentumBounceRatio: 1,
            momentumVelocityRatio: 1,
            sticky: false,
            minimumVelocity: 0.02
        }
    });
    function onTouchStart() {
        if (swiper.params.cssMode) return;
        const translate = swiper.getTranslate();
        swiper.setTranslate(translate);
        swiper.setTransition(0);
        swiper.touchEventsData.velocities.length = 0;
        swiper.freeMode.onTouchEnd({
            currentPos: swiper.rtl ? swiper.translate : -swiper.translate
        });
    }
    function onTouchMove() {
        if (swiper.params.cssMode) return;
        const { touchEventsData: data, touches } = swiper;
        // Velocity
        if (data.velocities.length === 0) data.velocities.push({
            position: touches[swiper.isHorizontal() ? "startX" : "startY"],
            time: data.touchStartTime
        });
        data.velocities.push({
            position: touches[swiper.isHorizontal() ? "currentX" : "currentY"],
            time: (0, _utilsMjs.d)()
        });
    }
    function onTouchEnd(_ref2) {
        let { currentPos } = _ref2;
        if (swiper.params.cssMode) return;
        const { params, wrapperEl, rtlTranslate: rtl, snapGrid, touchEventsData: data } = swiper;
        // Time diff
        const touchEndTime = (0, _utilsMjs.d)();
        const timeDiff = touchEndTime - data.touchStartTime;
        if (currentPos < -swiper.minTranslate()) {
            swiper.slideTo(swiper.activeIndex);
            return;
        }
        if (currentPos > -swiper.maxTranslate()) {
            if (swiper.slides.length < snapGrid.length) swiper.slideTo(snapGrid.length - 1);
            else swiper.slideTo(swiper.slides.length - 1);
            return;
        }
        if (params.freeMode.momentum) {
            if (data.velocities.length > 1) {
                const lastMoveEvent = data.velocities.pop();
                const velocityEvent = data.velocities.pop();
                const distance = lastMoveEvent.position - velocityEvent.position;
                const time = lastMoveEvent.time - velocityEvent.time;
                swiper.velocity = distance / time;
                swiper.velocity /= 2;
                if (Math.abs(swiper.velocity) < params.freeMode.minimumVelocity) swiper.velocity = 0;
                // this implies that the user stopped moving a finger then released.
                // There would be no events with distance zero, so the last event is stale.
                if (time > 150 || (0, _utilsMjs.d)() - lastMoveEvent.time > 300) swiper.velocity = 0;
            } else swiper.velocity = 0;
            swiper.velocity *= params.freeMode.momentumVelocityRatio;
            data.velocities.length = 0;
            let momentumDuration = 1000 * params.freeMode.momentumRatio;
            const momentumDistance = swiper.velocity * momentumDuration;
            let newPosition = swiper.translate + momentumDistance;
            if (rtl) newPosition = -newPosition;
            let doBounce = false;
            let afterBouncePosition;
            const bounceAmount = Math.abs(swiper.velocity) * 20 * params.freeMode.momentumBounceRatio;
            let needsLoopFix;
            if (newPosition < swiper.maxTranslate()) {
                if (params.freeMode.momentumBounce) {
                    if (newPosition + swiper.maxTranslate() < -bounceAmount) newPosition = swiper.maxTranslate() - bounceAmount;
                    afterBouncePosition = swiper.maxTranslate();
                    doBounce = true;
                    data.allowMomentumBounce = true;
                } else newPosition = swiper.maxTranslate();
                if (params.loop && params.centeredSlides) needsLoopFix = true;
            } else if (newPosition > swiper.minTranslate()) {
                if (params.freeMode.momentumBounce) {
                    if (newPosition - swiper.minTranslate() > bounceAmount) newPosition = swiper.minTranslate() + bounceAmount;
                    afterBouncePosition = swiper.minTranslate();
                    doBounce = true;
                    data.allowMomentumBounce = true;
                } else newPosition = swiper.minTranslate();
                if (params.loop && params.centeredSlides) needsLoopFix = true;
            } else if (params.freeMode.sticky) {
                let nextSlide;
                for(let j = 0; j < snapGrid.length; j += 1)if (snapGrid[j] > -newPosition) {
                    nextSlide = j;
                    break;
                }
                if (Math.abs(snapGrid[nextSlide] - newPosition) < Math.abs(snapGrid[nextSlide - 1] - newPosition) || swiper.swipeDirection === "next") newPosition = snapGrid[nextSlide];
                else newPosition = snapGrid[nextSlide - 1];
                newPosition = -newPosition;
            }
            if (needsLoopFix) once("transitionEnd", ()=>{
                swiper.loopFix();
            });
            // Fix duration
            if (swiper.velocity !== 0) {
                if (rtl) momentumDuration = Math.abs((-newPosition - swiper.translate) / swiper.velocity);
                else momentumDuration = Math.abs((newPosition - swiper.translate) / swiper.velocity);
                if (params.freeMode.sticky) {
                    // If freeMode.sticky is active and the user ends a swipe with a slow-velocity
                    // event, then durations can be 20+ seconds to slide one (or zero!) slides.
                    // It's easy to see this when simulating touch with mouse events. To fix this,
                    // limit single-slide swipes to the default slide duration. This also has the
                    // nice side effect of matching slide speed if the user stopped moving before
                    // lifting finger or mouse vs. moving slowly before lifting the finger/mouse.
                    // For faster swipes, also apply limits (albeit higher ones).
                    const moveDistance = Math.abs((rtl ? -newPosition : newPosition) - swiper.translate);
                    const currentSlideSize = swiper.slidesSizesGrid[swiper.activeIndex];
                    if (moveDistance < currentSlideSize) momentumDuration = params.speed;
                    else if (moveDistance < 2 * currentSlideSize) momentumDuration = params.speed * 1.5;
                    else momentumDuration = params.speed * 2.5;
                }
            } else if (params.freeMode.sticky) {
                swiper.slideToClosest();
                return;
            }
            if (params.freeMode.momentumBounce && doBounce) {
                swiper.updateProgress(afterBouncePosition);
                swiper.setTransition(momentumDuration);
                swiper.setTranslate(newPosition);
                swiper.transitionStart(true, swiper.swipeDirection);
                swiper.animating = true;
                (0, _utilsMjs.j)(wrapperEl, ()=>{
                    if (!swiper || swiper.destroyed || !data.allowMomentumBounce) return;
                    emit("momentumBounce");
                    swiper.setTransition(params.speed);
                    setTimeout(()=>{
                        swiper.setTranslate(afterBouncePosition);
                        (0, _utilsMjs.j)(wrapperEl, ()=>{
                            if (!swiper || swiper.destroyed) return;
                            swiper.transitionEnd();
                        });
                    }, 0);
                });
            } else if (swiper.velocity) {
                emit("_freeModeNoMomentumRelease");
                swiper.updateProgress(newPosition);
                swiper.setTransition(momentumDuration);
                swiper.setTranslate(newPosition);
                swiper.transitionStart(true, swiper.swipeDirection);
                if (!swiper.animating) {
                    swiper.animating = true;
                    (0, _utilsMjs.j)(wrapperEl, ()=>{
                        if (!swiper || swiper.destroyed) return;
                        swiper.transitionEnd();
                    });
                }
            } else swiper.updateProgress(newPosition);
            swiper.updateActiveIndex();
            swiper.updateSlidesClasses();
        } else if (params.freeMode.sticky) {
            swiper.slideToClosest();
            return;
        } else if (params.freeMode) emit("_freeModeNoMomentumRelease");
        if (!params.freeMode.momentum || timeDiff >= params.longSwipesMs) {
            emit("_freeModeStaticRelease");
            swiper.updateProgress();
            swiper.updateActiveIndex();
            swiper.updateSlidesClasses();
        }
    }
    Object.assign(swiper, {
        freeMode: {
            onTouchStart,
            onTouchMove,
            onTouchEnd
        }
    });
}

},{"../shared/utils.mjs":"agmBj","@parcel/transformer-js/src/esmodule-helpers.js":"90RNB"}],"47ZXi":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>Grid);
function Grid(_ref) {
    let { swiper, extendParams, on } = _ref;
    extendParams({
        grid: {
            rows: 1,
            fill: "column"
        }
    });
    let slidesNumberEvenToRows;
    let slidesPerRow;
    let numFullColumns;
    let wasMultiRow;
    const getSpaceBetween = ()=>{
        let spaceBetween = swiper.params.spaceBetween;
        if (typeof spaceBetween === "string" && spaceBetween.indexOf("%") >= 0) spaceBetween = parseFloat(spaceBetween.replace("%", "")) / 100 * swiper.size;
        else if (typeof spaceBetween === "string") spaceBetween = parseFloat(spaceBetween);
        return spaceBetween;
    };
    const initSlides = (slides)=>{
        const { slidesPerView } = swiper.params;
        const { rows, fill } = swiper.params.grid;
        const slidesLength = swiper.virtual && swiper.params.virtual.enabled ? swiper.virtual.slides.length : slides.length;
        numFullColumns = Math.floor(slidesLength / rows);
        if (Math.floor(slidesLength / rows) === slidesLength / rows) slidesNumberEvenToRows = slidesLength;
        else slidesNumberEvenToRows = Math.ceil(slidesLength / rows) * rows;
        if (slidesPerView !== "auto" && fill === "row") slidesNumberEvenToRows = Math.max(slidesNumberEvenToRows, slidesPerView * rows);
        slidesPerRow = slidesNumberEvenToRows / rows;
    };
    const unsetSlides = ()=>{
        if (swiper.slides) swiper.slides.forEach((slide)=>{
            if (slide.swiperSlideGridSet) {
                slide.style.height = "";
                slide.style[swiper.getDirectionLabel("margin-top")] = "";
            }
        });
    };
    const updateSlide = (i, slide, slides)=>{
        const { slidesPerGroup } = swiper.params;
        const spaceBetween = getSpaceBetween();
        const { rows, fill } = swiper.params.grid;
        const slidesLength = swiper.virtual && swiper.params.virtual.enabled ? swiper.virtual.slides.length : slides.length;
        // Set slides order
        let newSlideOrderIndex;
        let column;
        let row;
        if (fill === "row" && slidesPerGroup > 1) {
            const groupIndex = Math.floor(i / (slidesPerGroup * rows));
            const slideIndexInGroup = i - rows * slidesPerGroup * groupIndex;
            const columnsInGroup = groupIndex === 0 ? slidesPerGroup : Math.min(Math.ceil((slidesLength - groupIndex * rows * slidesPerGroup) / rows), slidesPerGroup);
            row = Math.floor(slideIndexInGroup / columnsInGroup);
            column = slideIndexInGroup - row * columnsInGroup + groupIndex * slidesPerGroup;
            newSlideOrderIndex = column + row * slidesNumberEvenToRows / rows;
            slide.style.order = newSlideOrderIndex;
        } else if (fill === "column") {
            column = Math.floor(i / rows);
            row = i - column * rows;
            if (column > numFullColumns || column === numFullColumns && row === rows - 1) {
                row += 1;
                if (row >= rows) {
                    row = 0;
                    column += 1;
                }
            }
        } else {
            row = Math.floor(i / slidesPerRow);
            column = i - row * slidesPerRow;
        }
        slide.row = row;
        slide.column = column;
        slide.style.height = `calc((100% - ${(rows - 1) * spaceBetween}px) / ${rows})`;
        slide.style[swiper.getDirectionLabel("margin-top")] = row !== 0 ? spaceBetween && `${spaceBetween}px` : "";
        slide.swiperSlideGridSet = true;
    };
    const updateWrapperSize = (slideSize, snapGrid)=>{
        const { centeredSlides, roundLengths } = swiper.params;
        const spaceBetween = getSpaceBetween();
        const { rows } = swiper.params.grid;
        swiper.virtualSize = (slideSize + spaceBetween) * slidesNumberEvenToRows;
        swiper.virtualSize = Math.ceil(swiper.virtualSize / rows) - spaceBetween;
        if (!swiper.params.cssMode) swiper.wrapperEl.style[swiper.getDirectionLabel("width")] = `${swiper.virtualSize + spaceBetween}px`;
        if (centeredSlides) {
            const newSlidesGrid = [];
            for(let i = 0; i < snapGrid.length; i += 1){
                let slidesGridItem = snapGrid[i];
                if (roundLengths) slidesGridItem = Math.floor(slidesGridItem);
                if (snapGrid[i] < swiper.virtualSize + snapGrid[0]) newSlidesGrid.push(slidesGridItem);
            }
            snapGrid.splice(0, snapGrid.length);
            snapGrid.push(...newSlidesGrid);
        }
    };
    const onInit = ()=>{
        wasMultiRow = swiper.params.grid && swiper.params.grid.rows > 1;
    };
    const onUpdate = ()=>{
        const { params, el } = swiper;
        const isMultiRow = params.grid && params.grid.rows > 1;
        if (wasMultiRow && !isMultiRow) {
            el.classList.remove(`${params.containerModifierClass}grid`, `${params.containerModifierClass}grid-column`);
            numFullColumns = 1;
            swiper.emitContainerClasses();
        } else if (!wasMultiRow && isMultiRow) {
            el.classList.add(`${params.containerModifierClass}grid`);
            if (params.grid.fill === "column") el.classList.add(`${params.containerModifierClass}grid-column`);
            swiper.emitContainerClasses();
        }
        wasMultiRow = isMultiRow;
    };
    on("init", onInit);
    on("update", onUpdate);
    swiper.grid = {
        initSlides,
        unsetSlides,
        updateSlide,
        updateWrapperSize
    };
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"90RNB"}],"eBqLo":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>Manipulation);
function appendSlide(slides) {
    const swiper = this;
    const { params, slidesEl } = swiper;
    if (params.loop) swiper.loopDestroy();
    const appendElement = (slideEl)=>{
        if (typeof slideEl === "string") {
            const tempDOM = document.createElement("div");
            tempDOM.innerHTML = slideEl;
            slidesEl.append(tempDOM.children[0]);
            tempDOM.innerHTML = "";
        } else slidesEl.append(slideEl);
    };
    if (typeof slides === "object" && "length" in slides) {
        for(let i = 0; i < slides.length; i += 1)if (slides[i]) appendElement(slides[i]);
    } else appendElement(slides);
    swiper.recalcSlides();
    if (params.loop) swiper.loopCreate();
    if (!params.observer || swiper.isElement) swiper.update();
}
function prependSlide(slides) {
    const swiper = this;
    const { params, activeIndex, slidesEl } = swiper;
    if (params.loop) swiper.loopDestroy();
    let newActiveIndex = activeIndex + 1;
    const prependElement = (slideEl)=>{
        if (typeof slideEl === "string") {
            const tempDOM = document.createElement("div");
            tempDOM.innerHTML = slideEl;
            slidesEl.prepend(tempDOM.children[0]);
            tempDOM.innerHTML = "";
        } else slidesEl.prepend(slideEl);
    };
    if (typeof slides === "object" && "length" in slides) {
        for(let i = 0; i < slides.length; i += 1)if (slides[i]) prependElement(slides[i]);
        newActiveIndex = activeIndex + slides.length;
    } else prependElement(slides);
    swiper.recalcSlides();
    if (params.loop) swiper.loopCreate();
    if (!params.observer || swiper.isElement) swiper.update();
    swiper.slideTo(newActiveIndex, 0, false);
}
function addSlide(index, slides) {
    const swiper = this;
    const { params, activeIndex, slidesEl } = swiper;
    let activeIndexBuffer = activeIndex;
    if (params.loop) {
        activeIndexBuffer -= swiper.loopedSlides;
        swiper.loopDestroy();
        swiper.recalcSlides();
    }
    const baseLength = swiper.slides.length;
    if (index <= 0) {
        swiper.prependSlide(slides);
        return;
    }
    if (index >= baseLength) {
        swiper.appendSlide(slides);
        return;
    }
    let newActiveIndex = activeIndexBuffer > index ? activeIndexBuffer + 1 : activeIndexBuffer;
    const slidesBuffer = [];
    for(let i = baseLength - 1; i >= index; i -= 1){
        const currentSlide = swiper.slides[i];
        currentSlide.remove();
        slidesBuffer.unshift(currentSlide);
    }
    if (typeof slides === "object" && "length" in slides) {
        for(let i = 0; i < slides.length; i += 1)if (slides[i]) slidesEl.append(slides[i]);
        newActiveIndex = activeIndexBuffer > index ? activeIndexBuffer + slides.length : activeIndexBuffer;
    } else slidesEl.append(slides);
    for(let i = 0; i < slidesBuffer.length; i += 1)slidesEl.append(slidesBuffer[i]);
    swiper.recalcSlides();
    if (params.loop) swiper.loopCreate();
    if (!params.observer || swiper.isElement) swiper.update();
    if (params.loop) swiper.slideTo(newActiveIndex + swiper.loopedSlides, 0, false);
    else swiper.slideTo(newActiveIndex, 0, false);
}
function removeSlide(slidesIndexes) {
    const swiper = this;
    const { params, activeIndex } = swiper;
    let activeIndexBuffer = activeIndex;
    if (params.loop) {
        activeIndexBuffer -= swiper.loopedSlides;
        swiper.loopDestroy();
    }
    let newActiveIndex = activeIndexBuffer;
    let indexToRemove;
    if (typeof slidesIndexes === "object" && "length" in slidesIndexes) {
        for(let i = 0; i < slidesIndexes.length; i += 1){
            indexToRemove = slidesIndexes[i];
            if (swiper.slides[indexToRemove]) swiper.slides[indexToRemove].remove();
            if (indexToRemove < newActiveIndex) newActiveIndex -= 1;
        }
        newActiveIndex = Math.max(newActiveIndex, 0);
    } else {
        indexToRemove = slidesIndexes;
        if (swiper.slides[indexToRemove]) swiper.slides[indexToRemove].remove();
        if (indexToRemove < newActiveIndex) newActiveIndex -= 1;
        newActiveIndex = Math.max(newActiveIndex, 0);
    }
    swiper.recalcSlides();
    if (params.loop) swiper.loopCreate();
    if (!params.observer || swiper.isElement) swiper.update();
    if (params.loop) swiper.slideTo(newActiveIndex + swiper.loopedSlides, 0, false);
    else swiper.slideTo(newActiveIndex, 0, false);
}
function removeAllSlides() {
    const swiper = this;
    const slidesIndexes = [];
    for(let i = 0; i < swiper.slides.length; i += 1)slidesIndexes.push(i);
    swiper.removeSlide(slidesIndexes);
}
function Manipulation(_ref) {
    let { swiper } = _ref;
    Object.assign(swiper, {
        appendSlide: appendSlide.bind(swiper),
        prependSlide: prependSlide.bind(swiper),
        addSlide: addSlide.bind(swiper),
        removeSlide: removeSlide.bind(swiper),
        removeAllSlides: removeAllSlides.bind(swiper)
    });
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"90RNB"}],"igJ1Q":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>EffectFade);
var _effectInitMjs = require("../shared/effect-init.mjs");
var _effectTargetMjs = require("../shared/effect-target.mjs");
var _effectVirtualTransitionEndMjs = require("../shared/effect-virtual-transition-end.mjs");
var _utilsMjs = require("../shared/utils.mjs");
function EffectFade(_ref) {
    let { swiper, extendParams, on } = _ref;
    extendParams({
        fadeEffect: {
            crossFade: false
        }
    });
    const setTranslate = ()=>{
        const { slides } = swiper;
        const params = swiper.params.fadeEffect;
        for(let i = 0; i < slides.length; i += 1){
            const slideEl = swiper.slides[i];
            const offset = slideEl.swiperSlideOffset;
            let tx = -offset;
            if (!swiper.params.virtualTranslate) tx -= swiper.translate;
            let ty = 0;
            if (!swiper.isHorizontal()) {
                ty = tx;
                tx = 0;
            }
            const slideOpacity = swiper.params.fadeEffect.crossFade ? Math.max(1 - Math.abs(slideEl.progress), 0) : 1 + Math.min(Math.max(slideEl.progress, -1), 0);
            const targetEl = (0, _effectTargetMjs.e)(params, slideEl);
            targetEl.style.opacity = slideOpacity;
            targetEl.style.transform = `translate3d(${tx}px, ${ty}px, 0px)`;
        }
    };
    const setTransition = (duration)=>{
        const transformElements = swiper.slides.map((slideEl)=>(0, _utilsMjs.l)(slideEl));
        transformElements.forEach((el)=>{
            el.style.transitionDuration = `${duration}ms`;
        });
        (0, _effectVirtualTransitionEndMjs.e)({
            swiper,
            duration,
            transformElements,
            allSlides: true
        });
    };
    (0, _effectInitMjs.e)({
        effect: "fade",
        swiper,
        on,
        setTranslate,
        setTransition,
        overwriteParams: ()=>({
                slidesPerView: 1,
                slidesPerGroup: 1,
                watchSlidesProgress: true,
                spaceBetween: 0,
                virtualTranslate: !swiper.params.cssMode
            })
    });
}

},{"../shared/effect-init.mjs":"jVIay","../shared/effect-target.mjs":"fEvlB","../shared/effect-virtual-transition-end.mjs":"gvbuW","../shared/utils.mjs":"agmBj","@parcel/transformer-js/src/esmodule-helpers.js":"90RNB"}],"jVIay":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "e", ()=>effectInit);
function effectInit(params) {
    const { effect, swiper, on, setTranslate, setTransition, overwriteParams, perspective, recreateShadows, getEffectParams } = params;
    on("beforeInit", ()=>{
        if (swiper.params.effect !== effect) return;
        swiper.classNames.push(`${swiper.params.containerModifierClass}${effect}`);
        if (perspective && perspective()) swiper.classNames.push(`${swiper.params.containerModifierClass}3d`);
        const overwriteParamsResult = overwriteParams ? overwriteParams() : {};
        Object.assign(swiper.params, overwriteParamsResult);
        Object.assign(swiper.originalParams, overwriteParamsResult);
    });
    on("setTranslate", ()=>{
        if (swiper.params.effect !== effect) return;
        setTranslate();
    });
    on("setTransition", (_s, duration)=>{
        if (swiper.params.effect !== effect) return;
        setTransition(duration);
    });
    on("transitionEnd", ()=>{
        if (swiper.params.effect !== effect) return;
        if (recreateShadows) {
            if (!getEffectParams || !getEffectParams().slideShadows) return;
            // remove shadows
            swiper.slides.forEach((slideEl)=>{
                slideEl.querySelectorAll(".swiper-slide-shadow-top, .swiper-slide-shadow-right, .swiper-slide-shadow-bottom, .swiper-slide-shadow-left").forEach((shadowEl)=>shadowEl.remove());
            });
            // create new one
            recreateShadows();
        }
    });
    let requireUpdateOnVirtual;
    on("virtualUpdate", ()=>{
        if (swiper.params.effect !== effect) return;
        if (!swiper.slides.length) requireUpdateOnVirtual = true;
        requestAnimationFrame(()=>{
            if (requireUpdateOnVirtual && swiper.slides && swiper.slides.length) {
                setTranslate();
                requireUpdateOnVirtual = false;
            }
        });
    });
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"90RNB"}],"fEvlB":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "e", ()=>effectTarget);
var _utilsMjs = require("./utils.mjs");
function effectTarget(effectParams, slideEl) {
    const transformEl = (0, _utilsMjs.l)(slideEl);
    if (transformEl !== slideEl) {
        transformEl.style.backfaceVisibility = "hidden";
        transformEl.style["-webkit-backface-visibility"] = "hidden";
    }
    return transformEl;
}

},{"./utils.mjs":"agmBj","@parcel/transformer-js/src/esmodule-helpers.js":"90RNB"}],"gvbuW":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "e", ()=>effectVirtualTransitionEnd);
var _utilsMjs = require("./utils.mjs");
function effectVirtualTransitionEnd(_ref) {
    let { swiper, duration, transformElements, allSlides } = _ref;
    const { activeIndex } = swiper;
    const getSlide = (el)=>{
        if (!el.parentElement) {
            // assume shadow root
            const slide = swiper.slides.filter((slideEl)=>slideEl.shadowRoot && slideEl.shadowRoot === el.parentNode)[0];
            return slide;
        }
        return el.parentElement;
    };
    if (swiper.params.virtualTranslate && duration !== 0) {
        let eventTriggered = false;
        let transitionEndTarget;
        if (allSlides) transitionEndTarget = transformElements;
        else transitionEndTarget = transformElements.filter((transformEl)=>{
            const el = transformEl.classList.contains("swiper-slide-transform") ? getSlide(transformEl) : transformEl;
            return swiper.getSlideIndex(el) === activeIndex;
        });
        transitionEndTarget.forEach((el)=>{
            (0, _utilsMjs.j)(el, ()=>{
                if (eventTriggered) return;
                if (!swiper || swiper.destroyed) return;
                eventTriggered = true;
                swiper.animating = false;
                const evt = new window.CustomEvent("transitionend", {
                    bubbles: true,
                    cancelable: true
                });
                swiper.wrapperEl.dispatchEvent(evt);
            });
        });
    }
}

},{"./utils.mjs":"agmBj","@parcel/transformer-js/src/esmodule-helpers.js":"90RNB"}],"1fB7X":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>EffectCube);
var _effectInitMjs = require("../shared/effect-init.mjs");
var _utilsMjs = require("../shared/utils.mjs");
function EffectCube(_ref) {
    let { swiper, extendParams, on } = _ref;
    extendParams({
        cubeEffect: {
            slideShadows: true,
            shadow: true,
            shadowOffset: 20,
            shadowScale: 0.94
        }
    });
    const createSlideShadows = (slideEl, progress, isHorizontal)=>{
        let shadowBefore = isHorizontal ? slideEl.querySelector(".swiper-slide-shadow-left") : slideEl.querySelector(".swiper-slide-shadow-top");
        let shadowAfter = isHorizontal ? slideEl.querySelector(".swiper-slide-shadow-right") : slideEl.querySelector(".swiper-slide-shadow-bottom");
        if (!shadowBefore) {
            shadowBefore = (0, _utilsMjs.c)("div", `swiper-slide-shadow-cube swiper-slide-shadow-${isHorizontal ? "left" : "top"}`.split(" "));
            slideEl.append(shadowBefore);
        }
        if (!shadowAfter) {
            shadowAfter = (0, _utilsMjs.c)("div", `swiper-slide-shadow-cube swiper-slide-shadow-${isHorizontal ? "right" : "bottom"}`.split(" "));
            slideEl.append(shadowAfter);
        }
        if (shadowBefore) shadowBefore.style.opacity = Math.max(-progress, 0);
        if (shadowAfter) shadowAfter.style.opacity = Math.max(progress, 0);
    };
    const recreateShadows = ()=>{
        // create new ones
        const isHorizontal = swiper.isHorizontal();
        swiper.slides.forEach((slideEl)=>{
            const progress = Math.max(Math.min(slideEl.progress, 1), -1);
            createSlideShadows(slideEl, progress, isHorizontal);
        });
    };
    const setTranslate = ()=>{
        const { el, wrapperEl, slides, width: swiperWidth, height: swiperHeight, rtlTranslate: rtl, size: swiperSize, browser } = swiper;
        const params = swiper.params.cubeEffect;
        const isHorizontal = swiper.isHorizontal();
        const isVirtual = swiper.virtual && swiper.params.virtual.enabled;
        let wrapperRotate = 0;
        let cubeShadowEl;
        if (params.shadow) {
            if (isHorizontal) {
                cubeShadowEl = swiper.wrapperEl.querySelector(".swiper-cube-shadow");
                if (!cubeShadowEl) {
                    cubeShadowEl = (0, _utilsMjs.c)("div", "swiper-cube-shadow");
                    swiper.wrapperEl.append(cubeShadowEl);
                }
                cubeShadowEl.style.height = `${swiperWidth}px`;
            } else {
                cubeShadowEl = el.querySelector(".swiper-cube-shadow");
                if (!cubeShadowEl) {
                    cubeShadowEl = (0, _utilsMjs.c)("div", "swiper-cube-shadow");
                    el.append(cubeShadowEl);
                }
            }
        }
        for(let i = 0; i < slides.length; i += 1){
            const slideEl = slides[i];
            let slideIndex = i;
            if (isVirtual) slideIndex = parseInt(slideEl.getAttribute("data-swiper-slide-index"), 10);
            let slideAngle = slideIndex * 90;
            let round = Math.floor(slideAngle / 360);
            if (rtl) {
                slideAngle = -slideAngle;
                round = Math.floor(-slideAngle / 360);
            }
            const progress = Math.max(Math.min(slideEl.progress, 1), -1);
            let tx = 0;
            let ty = 0;
            let tz = 0;
            if (slideIndex % 4 === 0) {
                tx = -round * 4 * swiperSize;
                tz = 0;
            } else if ((slideIndex - 1) % 4 === 0) {
                tx = 0;
                tz = -round * 4 * swiperSize;
            } else if ((slideIndex - 2) % 4 === 0) {
                tx = swiperSize + round * 4 * swiperSize;
                tz = swiperSize;
            } else if ((slideIndex - 3) % 4 === 0) {
                tx = -swiperSize;
                tz = 3 * swiperSize + swiperSize * 4 * round;
            }
            if (rtl) tx = -tx;
            if (!isHorizontal) {
                ty = tx;
                tx = 0;
            }
            const transform = `rotateX(${isHorizontal ? 0 : -slideAngle}deg) rotateY(${isHorizontal ? slideAngle : 0}deg) translate3d(${tx}px, ${ty}px, ${tz}px)`;
            if (progress <= 1 && progress > -1) {
                wrapperRotate = slideIndex * 90 + progress * 90;
                if (rtl) wrapperRotate = -slideIndex * 90 - progress * 90;
                if (swiper.browser && swiper.browser.isSafari && Math.abs(wrapperRotate) / 90 % 2 === 1) wrapperRotate += 0.001;
            }
            slideEl.style.transform = transform;
            if (params.slideShadows) createSlideShadows(slideEl, progress, isHorizontal);
        }
        wrapperEl.style.transformOrigin = `50% 50% -${swiperSize / 2}px`;
        wrapperEl.style["-webkit-transform-origin"] = `50% 50% -${swiperSize / 2}px`;
        if (params.shadow) {
            if (isHorizontal) cubeShadowEl.style.transform = `translate3d(0px, ${swiperWidth / 2 + params.shadowOffset}px, ${-swiperWidth / 2}px) rotateX(89.99deg) rotateZ(0deg) scale(${params.shadowScale})`;
            else {
                const shadowAngle = Math.abs(wrapperRotate) - Math.floor(Math.abs(wrapperRotate) / 90) * 90;
                const multiplier = 1.5 - (Math.sin(shadowAngle * 2 * Math.PI / 360) / 2 + Math.cos(shadowAngle * 2 * Math.PI / 360) / 2);
                const scale1 = params.shadowScale;
                const scale2 = params.shadowScale / multiplier;
                const offset = params.shadowOffset;
                cubeShadowEl.style.transform = `scale3d(${scale1}, 1, ${scale2}) translate3d(0px, ${swiperHeight / 2 + offset}px, ${-swiperHeight / 2 / scale2}px) rotateX(-89.99deg)`;
            }
        }
        const zFactor = (browser.isSafari || browser.isWebView) && browser.needPerspectiveFix ? -swiperSize / 2 : 0;
        wrapperEl.style.transform = `translate3d(0px,0,${zFactor}px) rotateX(${swiper.isHorizontal() ? 0 : wrapperRotate}deg) rotateY(${swiper.isHorizontal() ? -wrapperRotate : 0}deg)`;
        wrapperEl.style.setProperty("--swiper-cube-translate-z", `${zFactor}px`);
    };
    const setTransition = (duration)=>{
        const { el, slides } = swiper;
        slides.forEach((slideEl)=>{
            slideEl.style.transitionDuration = `${duration}ms`;
            slideEl.querySelectorAll(".swiper-slide-shadow-top, .swiper-slide-shadow-right, .swiper-slide-shadow-bottom, .swiper-slide-shadow-left").forEach((subEl)=>{
                subEl.style.transitionDuration = `${duration}ms`;
            });
        });
        if (swiper.params.cubeEffect.shadow && !swiper.isHorizontal()) {
            const shadowEl = el.querySelector(".swiper-cube-shadow");
            if (shadowEl) shadowEl.style.transitionDuration = `${duration}ms`;
        }
    };
    (0, _effectInitMjs.e)({
        effect: "cube",
        swiper,
        on,
        setTranslate,
        setTransition,
        recreateShadows,
        getEffectParams: ()=>swiper.params.cubeEffect,
        perspective: ()=>true,
        overwriteParams: ()=>({
                slidesPerView: 1,
                slidesPerGroup: 1,
                watchSlidesProgress: true,
                resistanceRatio: 0,
                spaceBetween: 0,
                centeredSlides: false,
                virtualTranslate: true
            })
    });
}

},{"../shared/effect-init.mjs":"jVIay","../shared/utils.mjs":"agmBj","@parcel/transformer-js/src/esmodule-helpers.js":"90RNB"}],"bGdX1":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>EffectFlip);
var _createShadowMjs = require("../shared/create-shadow.mjs");
var _effectInitMjs = require("../shared/effect-init.mjs");
var _effectTargetMjs = require("../shared/effect-target.mjs");
var _effectVirtualTransitionEndMjs = require("../shared/effect-virtual-transition-end.mjs");
var _utilsMjs = require("../shared/utils.mjs");
function EffectFlip(_ref) {
    let { swiper, extendParams, on } = _ref;
    extendParams({
        flipEffect: {
            slideShadows: true,
            limitRotation: true
        }
    });
    const createSlideShadows = (slideEl, progress)=>{
        let shadowBefore = swiper.isHorizontal() ? slideEl.querySelector(".swiper-slide-shadow-left") : slideEl.querySelector(".swiper-slide-shadow-top");
        let shadowAfter = swiper.isHorizontal() ? slideEl.querySelector(".swiper-slide-shadow-right") : slideEl.querySelector(".swiper-slide-shadow-bottom");
        if (!shadowBefore) shadowBefore = (0, _createShadowMjs.c)("flip", slideEl, swiper.isHorizontal() ? "left" : "top");
        if (!shadowAfter) shadowAfter = (0, _createShadowMjs.c)("flip", slideEl, swiper.isHorizontal() ? "right" : "bottom");
        if (shadowBefore) shadowBefore.style.opacity = Math.max(-progress, 0);
        if (shadowAfter) shadowAfter.style.opacity = Math.max(progress, 0);
    };
    const recreateShadows = ()=>{
        // Set shadows
        swiper.params.flipEffect;
        swiper.slides.forEach((slideEl)=>{
            let progress = slideEl.progress;
            if (swiper.params.flipEffect.limitRotation) progress = Math.max(Math.min(slideEl.progress, 1), -1);
            createSlideShadows(slideEl, progress);
        });
    };
    const setTranslate = ()=>{
        const { slides, rtlTranslate: rtl } = swiper;
        const params = swiper.params.flipEffect;
        for(let i = 0; i < slides.length; i += 1){
            const slideEl = slides[i];
            let progress = slideEl.progress;
            if (swiper.params.flipEffect.limitRotation) progress = Math.max(Math.min(slideEl.progress, 1), -1);
            const offset = slideEl.swiperSlideOffset;
            const rotate = -180 * progress;
            let rotateY = rotate;
            let rotateX = 0;
            let tx = swiper.params.cssMode ? -offset - swiper.translate : -offset;
            let ty = 0;
            if (!swiper.isHorizontal()) {
                ty = tx;
                tx = 0;
                rotateX = -rotateY;
                rotateY = 0;
            } else if (rtl) rotateY = -rotateY;
            if (swiper.browser && swiper.browser.isSafari) {
                if (Math.abs(rotateY) / 90 % 2 === 1) rotateY += 0.001;
                if (Math.abs(rotateX) / 90 % 2 === 1) rotateX += 0.001;
            }
            slideEl.style.zIndex = -Math.abs(Math.round(progress)) + slides.length;
            if (params.slideShadows) createSlideShadows(slideEl, progress);
            const transform = `translate3d(${tx}px, ${ty}px, 0px) rotateX(${rotateX}deg) rotateY(${rotateY}deg)`;
            const targetEl = (0, _effectTargetMjs.e)(params, slideEl);
            targetEl.style.transform = transform;
        }
    };
    const setTransition = (duration)=>{
        const transformElements = swiper.slides.map((slideEl)=>(0, _utilsMjs.l)(slideEl));
        transformElements.forEach((el)=>{
            el.style.transitionDuration = `${duration}ms`;
            el.querySelectorAll(".swiper-slide-shadow-top, .swiper-slide-shadow-right, .swiper-slide-shadow-bottom, .swiper-slide-shadow-left").forEach((shadowEl)=>{
                shadowEl.style.transitionDuration = `${duration}ms`;
            });
        });
        (0, _effectVirtualTransitionEndMjs.e)({
            swiper,
            duration,
            transformElements
        });
    };
    (0, _effectInitMjs.e)({
        effect: "flip",
        swiper,
        on,
        setTranslate,
        setTransition,
        recreateShadows,
        getEffectParams: ()=>swiper.params.flipEffect,
        perspective: ()=>true,
        overwriteParams: ()=>({
                slidesPerView: 1,
                slidesPerGroup: 1,
                watchSlidesProgress: true,
                spaceBetween: 0,
                virtualTranslate: !swiper.params.cssMode
            })
    });
}

},{"../shared/create-shadow.mjs":"hpFm6","../shared/effect-init.mjs":"jVIay","../shared/effect-target.mjs":"fEvlB","../shared/effect-virtual-transition-end.mjs":"gvbuW","../shared/utils.mjs":"agmBj","@parcel/transformer-js/src/esmodule-helpers.js":"90RNB"}],"hpFm6":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "c", ()=>createShadow);
var _utilsMjs = require("./utils.mjs");
function createShadow(suffix, slideEl, side) {
    const shadowClass = `swiper-slide-shadow${side ? `-${side}` : ""}${suffix ? ` swiper-slide-shadow-${suffix}` : ""}`;
    const shadowContainer = (0, _utilsMjs.l)(slideEl);
    let shadowEl = shadowContainer.querySelector(`.${shadowClass.split(" ").join(".")}`);
    if (!shadowEl) {
        shadowEl = (0, _utilsMjs.c)("div", shadowClass.split(" "));
        shadowContainer.append(shadowEl);
    }
    return shadowEl;
}

},{"./utils.mjs":"agmBj","@parcel/transformer-js/src/esmodule-helpers.js":"90RNB"}],"che9E":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>EffectCoverflow);
var _createShadowMjs = require("../shared/create-shadow.mjs");
var _effectInitMjs = require("../shared/effect-init.mjs");
var _effectTargetMjs = require("../shared/effect-target.mjs");
var _utilsMjs = require("../shared/utils.mjs");
function EffectCoverflow(_ref) {
    let { swiper, extendParams, on } = _ref;
    extendParams({
        coverflowEffect: {
            rotate: 50,
            stretch: 0,
            depth: 100,
            scale: 1,
            modifier: 1,
            slideShadows: true
        }
    });
    const setTranslate = ()=>{
        const { width: swiperWidth, height: swiperHeight, slides, slidesSizesGrid } = swiper;
        const params = swiper.params.coverflowEffect;
        const isHorizontal = swiper.isHorizontal();
        const transform = swiper.translate;
        const center = isHorizontal ? -transform + swiperWidth / 2 : -transform + swiperHeight / 2;
        const rotate = isHorizontal ? params.rotate : -params.rotate;
        const translate = params.depth;
        // Each slide offset from center
        for(let i = 0, length = slides.length; i < length; i += 1){
            const slideEl = slides[i];
            const slideSize = slidesSizesGrid[i];
            const slideOffset = slideEl.swiperSlideOffset;
            const centerOffset = (center - slideOffset - slideSize / 2) / slideSize;
            const offsetMultiplier = typeof params.modifier === "function" ? params.modifier(centerOffset) : centerOffset * params.modifier;
            let rotateY = isHorizontal ? rotate * offsetMultiplier : 0;
            let rotateX = isHorizontal ? 0 : rotate * offsetMultiplier;
            // var rotateZ = 0
            let translateZ = -translate * Math.abs(offsetMultiplier);
            let stretch = params.stretch;
            // Allow percentage to make a relative stretch for responsive sliders
            if (typeof stretch === "string" && stretch.indexOf("%") !== -1) stretch = parseFloat(params.stretch) / 100 * slideSize;
            let translateY = isHorizontal ? 0 : stretch * offsetMultiplier;
            let translateX = isHorizontal ? stretch * offsetMultiplier : 0;
            let scale = 1 - (1 - params.scale) * Math.abs(offsetMultiplier);
            // Fix for ultra small values
            if (Math.abs(translateX) < 0.001) translateX = 0;
            if (Math.abs(translateY) < 0.001) translateY = 0;
            if (Math.abs(translateZ) < 0.001) translateZ = 0;
            if (Math.abs(rotateY) < 0.001) rotateY = 0;
            if (Math.abs(rotateX) < 0.001) rotateX = 0;
            if (Math.abs(scale) < 0.001) scale = 0;
            if (swiper.browser && swiper.browser.isSafari) {
                if (Math.abs(rotateY) / 90 % 2 === 1) rotateY += 0.001;
                if (Math.abs(rotateX) / 90 % 2 === 1) rotateX += 0.001;
            }
            const slideTransform = `translate3d(${translateX}px,${translateY}px,${translateZ}px)  rotateX(${rotateX}deg) rotateY(${rotateY}deg) scale(${scale})`;
            const targetEl = (0, _effectTargetMjs.e)(params, slideEl);
            targetEl.style.transform = slideTransform;
            slideEl.style.zIndex = -Math.abs(Math.round(offsetMultiplier)) + 1;
            if (params.slideShadows) {
                // Set shadows
                let shadowBeforeEl = isHorizontal ? slideEl.querySelector(".swiper-slide-shadow-left") : slideEl.querySelector(".swiper-slide-shadow-top");
                let shadowAfterEl = isHorizontal ? slideEl.querySelector(".swiper-slide-shadow-right") : slideEl.querySelector(".swiper-slide-shadow-bottom");
                if (!shadowBeforeEl) shadowBeforeEl = (0, _createShadowMjs.c)("coverflow", slideEl, isHorizontal ? "left" : "top");
                if (!shadowAfterEl) shadowAfterEl = (0, _createShadowMjs.c)("coverflow", slideEl, isHorizontal ? "right" : "bottom");
                if (shadowBeforeEl) shadowBeforeEl.style.opacity = offsetMultiplier > 0 ? offsetMultiplier : 0;
                if (shadowAfterEl) shadowAfterEl.style.opacity = -offsetMultiplier > 0 ? -offsetMultiplier : 0;
            }
        }
    };
    const setTransition = (duration)=>{
        const transformElements = swiper.slides.map((slideEl)=>(0, _utilsMjs.l)(slideEl));
        transformElements.forEach((el)=>{
            el.style.transitionDuration = `${duration}ms`;
            el.querySelectorAll(".swiper-slide-shadow-top, .swiper-slide-shadow-right, .swiper-slide-shadow-bottom, .swiper-slide-shadow-left").forEach((shadowEl)=>{
                shadowEl.style.transitionDuration = `${duration}ms`;
            });
        });
    };
    (0, _effectInitMjs.e)({
        effect: "coverflow",
        swiper,
        on,
        setTranslate,
        setTransition,
        perspective: ()=>true,
        overwriteParams: ()=>({
                watchSlidesProgress: true
            })
    });
}

},{"../shared/create-shadow.mjs":"hpFm6","../shared/effect-init.mjs":"jVIay","../shared/effect-target.mjs":"fEvlB","../shared/utils.mjs":"agmBj","@parcel/transformer-js/src/esmodule-helpers.js":"90RNB"}],"3Kr0j":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>EffectCreative);
var _createShadowMjs = require("../shared/create-shadow.mjs");
var _effectInitMjs = require("../shared/effect-init.mjs");
var _effectTargetMjs = require("../shared/effect-target.mjs");
var _effectVirtualTransitionEndMjs = require("../shared/effect-virtual-transition-end.mjs");
var _utilsMjs = require("../shared/utils.mjs");
function EffectCreative(_ref) {
    let { swiper, extendParams, on } = _ref;
    extendParams({
        creativeEffect: {
            limitProgress: 1,
            shadowPerProgress: false,
            progressMultiplier: 1,
            perspective: true,
            prev: {
                translate: [
                    0,
                    0,
                    0
                ],
                rotate: [
                    0,
                    0,
                    0
                ],
                opacity: 1,
                scale: 1
            },
            next: {
                translate: [
                    0,
                    0,
                    0
                ],
                rotate: [
                    0,
                    0,
                    0
                ],
                opacity: 1,
                scale: 1
            }
        }
    });
    const getTranslateValue = (value)=>{
        if (typeof value === "string") return value;
        return `${value}px`;
    };
    const setTranslate = ()=>{
        const { slides, wrapperEl, slidesSizesGrid } = swiper;
        const params = swiper.params.creativeEffect;
        const { progressMultiplier: multiplier } = params;
        const isCenteredSlides = swiper.params.centeredSlides;
        if (isCenteredSlides) {
            const margin = slidesSizesGrid[0] / 2 - swiper.params.slidesOffsetBefore || 0;
            wrapperEl.style.transform = `translateX(calc(50% - ${margin}px))`;
        }
        for(let i = 0; i < slides.length; i += 1){
            const slideEl = slides[i];
            const slideProgress = slideEl.progress;
            const progress = Math.min(Math.max(slideEl.progress, -params.limitProgress), params.limitProgress);
            let originalProgress = progress;
            if (!isCenteredSlides) originalProgress = Math.min(Math.max(slideEl.originalProgress, -params.limitProgress), params.limitProgress);
            const offset = slideEl.swiperSlideOffset;
            const t = [
                swiper.params.cssMode ? -offset - swiper.translate : -offset,
                0,
                0
            ];
            const r = [
                0,
                0,
                0
            ];
            let custom = false;
            if (!swiper.isHorizontal()) {
                t[1] = t[0];
                t[0] = 0;
            }
            let data = {
                translate: [
                    0,
                    0,
                    0
                ],
                rotate: [
                    0,
                    0,
                    0
                ],
                scale: 1,
                opacity: 1
            };
            if (progress < 0) {
                data = params.next;
                custom = true;
            } else if (progress > 0) {
                data = params.prev;
                custom = true;
            }
            // set translate
            t.forEach((value, index)=>{
                t[index] = `calc(${value}px + (${getTranslateValue(data.translate[index])} * ${Math.abs(progress * multiplier)}))`;
            });
            // set rotates
            r.forEach((value, index)=>{
                let val = data.rotate[index] * Math.abs(progress * multiplier);
                if (swiper.browser && swiper.browser.isSafari && Math.abs(val) / 90 % 2 === 1) val += 0.001;
                r[index] = val;
            });
            slideEl.style.zIndex = -Math.abs(Math.round(slideProgress)) + slides.length;
            const translateString = t.join(", ");
            const rotateString = `rotateX(${r[0]}deg) rotateY(${r[1]}deg) rotateZ(${r[2]}deg)`;
            const scaleString = originalProgress < 0 ? `scale(${1 + (1 - data.scale) * originalProgress * multiplier})` : `scale(${1 - (1 - data.scale) * originalProgress * multiplier})`;
            const opacityString = originalProgress < 0 ? 1 + (1 - data.opacity) * originalProgress * multiplier : 1 - (1 - data.opacity) * originalProgress * multiplier;
            const transform = `translate3d(${translateString}) ${rotateString} ${scaleString}`;
            // Set shadows
            if (custom && data.shadow || !custom) {
                let shadowEl = slideEl.querySelector(".swiper-slide-shadow");
                if (!shadowEl && data.shadow) shadowEl = (0, _createShadowMjs.c)("creative", slideEl);
                if (shadowEl) {
                    const shadowOpacity = params.shadowPerProgress ? progress * (1 / params.limitProgress) : progress;
                    shadowEl.style.opacity = Math.min(Math.max(Math.abs(shadowOpacity), 0), 1);
                }
            }
            const targetEl = (0, _effectTargetMjs.e)(params, slideEl);
            targetEl.style.transform = transform;
            targetEl.style.opacity = opacityString;
            if (data.origin) targetEl.style.transformOrigin = data.origin;
        }
    };
    const setTransition = (duration)=>{
        const transformElements = swiper.slides.map((slideEl)=>(0, _utilsMjs.l)(slideEl));
        transformElements.forEach((el)=>{
            el.style.transitionDuration = `${duration}ms`;
            el.querySelectorAll(".swiper-slide-shadow").forEach((shadowEl)=>{
                shadowEl.style.transitionDuration = `${duration}ms`;
            });
        });
        (0, _effectVirtualTransitionEndMjs.e)({
            swiper,
            duration,
            transformElements,
            allSlides: true
        });
    };
    (0, _effectInitMjs.e)({
        effect: "creative",
        swiper,
        on,
        setTranslate,
        setTransition,
        perspective: ()=>swiper.params.creativeEffect.perspective,
        overwriteParams: ()=>({
                watchSlidesProgress: true,
                virtualTranslate: !swiper.params.cssMode
            })
    });
}

},{"../shared/create-shadow.mjs":"hpFm6","../shared/effect-init.mjs":"jVIay","../shared/effect-target.mjs":"fEvlB","../shared/effect-virtual-transition-end.mjs":"gvbuW","../shared/utils.mjs":"agmBj","@parcel/transformer-js/src/esmodule-helpers.js":"90RNB"}],"lwNtT":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>EffectCards);
var _createShadowMjs = require("../shared/create-shadow.mjs");
var _effectInitMjs = require("../shared/effect-init.mjs");
var _effectTargetMjs = require("../shared/effect-target.mjs");
var _effectVirtualTransitionEndMjs = require("../shared/effect-virtual-transition-end.mjs");
var _utilsMjs = require("../shared/utils.mjs");
function EffectCards(_ref) {
    let { swiper, extendParams, on } = _ref;
    extendParams({
        cardsEffect: {
            slideShadows: true,
            rotate: true,
            perSlideRotate: 2,
            perSlideOffset: 8
        }
    });
    const setTranslate = ()=>{
        const { slides, activeIndex, rtlTranslate: rtl } = swiper;
        const params = swiper.params.cardsEffect;
        const { startTranslate, isTouched } = swiper.touchEventsData;
        const currentTranslate = rtl ? -swiper.translate : swiper.translate;
        for(let i = 0; i < slides.length; i += 1){
            const slideEl = slides[i];
            const slideProgress = slideEl.progress;
            const progress = Math.min(Math.max(slideProgress, -4), 4);
            let offset = slideEl.swiperSlideOffset;
            if (swiper.params.centeredSlides && !swiper.params.cssMode) swiper.wrapperEl.style.transform = `translateX(${swiper.minTranslate()}px)`;
            if (swiper.params.centeredSlides && swiper.params.cssMode) offset -= slides[0].swiperSlideOffset;
            let tX = swiper.params.cssMode ? -offset - swiper.translate : -offset;
            let tY = 0;
            const tZ = -100 * Math.abs(progress);
            let scale = 1;
            let rotate = -params.perSlideRotate * progress;
            let tXAdd = params.perSlideOffset - Math.abs(progress) * 0.75;
            const slideIndex = swiper.virtual && swiper.params.virtual.enabled ? swiper.virtual.from + i : i;
            const isSwipeToNext = (slideIndex === activeIndex || slideIndex === activeIndex - 1) && progress > 0 && progress < 1 && (isTouched || swiper.params.cssMode) && currentTranslate < startTranslate;
            const isSwipeToPrev = (slideIndex === activeIndex || slideIndex === activeIndex + 1) && progress < 0 && progress > -1 && (isTouched || swiper.params.cssMode) && currentTranslate > startTranslate;
            if (isSwipeToNext || isSwipeToPrev) {
                const subProgress = (1 - Math.abs((Math.abs(progress) - 0.5) / 0.5)) ** 0.5;
                rotate += -28 * progress * subProgress;
                scale += -0.5 * subProgress;
                tXAdd += 96 * subProgress;
                tY = `${-25 * subProgress * Math.abs(progress)}%`;
            }
            if (progress < 0) // next
            tX = `calc(${tX}px ${rtl ? "-" : "+"} (${tXAdd * Math.abs(progress)}%))`;
            else if (progress > 0) // prev
            tX = `calc(${tX}px ${rtl ? "-" : "+"} (-${tXAdd * Math.abs(progress)}%))`;
            else tX = `${tX}px`;
            if (!swiper.isHorizontal()) {
                const prevY = tY;
                tY = tX;
                tX = prevY;
            }
            const scaleString = progress < 0 ? `${1 + (1 - scale) * progress}` : `${1 - (1 - scale) * progress}`;
            /* eslint-disable */ const transform = `
        translate3d(${tX}, ${tY}, ${tZ}px)
        rotateZ(${params.rotate ? rtl ? -rotate : rotate : 0}deg)
        scale(${scaleString})
      `;
            /* eslint-enable */ if (params.slideShadows) {
                // Set shadows
                let shadowEl = slideEl.querySelector(".swiper-slide-shadow");
                if (!shadowEl) shadowEl = (0, _createShadowMjs.c)("cards", slideEl);
                if (shadowEl) shadowEl.style.opacity = Math.min(Math.max((Math.abs(progress) - 0.5) / 0.5, 0), 1);
            }
            slideEl.style.zIndex = -Math.abs(Math.round(slideProgress)) + slides.length;
            const targetEl = (0, _effectTargetMjs.e)(params, slideEl);
            targetEl.style.transform = transform;
        }
    };
    const setTransition = (duration)=>{
        const transformElements = swiper.slides.map((slideEl)=>(0, _utilsMjs.l)(slideEl));
        transformElements.forEach((el)=>{
            el.style.transitionDuration = `${duration}ms`;
            el.querySelectorAll(".swiper-slide-shadow").forEach((shadowEl)=>{
                shadowEl.style.transitionDuration = `${duration}ms`;
            });
        });
        (0, _effectVirtualTransitionEndMjs.e)({
            swiper,
            duration,
            transformElements
        });
    };
    (0, _effectInitMjs.e)({
        effect: "cards",
        swiper,
        on,
        setTranslate,
        setTransition,
        perspective: ()=>true,
        overwriteParams: ()=>({
                watchSlidesProgress: true,
                virtualTranslate: !swiper.params.cssMode
            })
    });
}

},{"../shared/create-shadow.mjs":"hpFm6","../shared/effect-init.mjs":"jVIay","../shared/effect-target.mjs":"fEvlB","../shared/effect-virtual-transition-end.mjs":"gvbuW","../shared/utils.mjs":"agmBj","@parcel/transformer-js/src/esmodule-helpers.js":"90RNB"}],"1jlpx":[function(require,module,exports) {
var _carouselSlider = require("../carousel-slider/carousel-slider");
class InstagramSlider extends (0, _carouselSlider.CarouselSlider) {
    constructor(){
        super();
        //implementation
        this.API_ENDPOINT = this.getAttribute("data-api-endpoint");
        this.LOADED = false;
    }
    connectedCallback() {
        this.renderContents();
        // check if this.LOADED is false
        if (!this.LOADED) {
            console.log("loaded = false, returning");
            return;
        }
        super.connectedCallback();
    }
    async fetchData() {
        try {
            const response = await fetch(this.API_ENDPOINT);
            if (!response.ok) throw new Error(`HTTP error! status: ${response.status}`);
            const data = await response.json();
            console.log("Instagram data:", data);
            return data;
        } catch (error) {
            console.error("Error fetching Instagram data:", error);
        }
    }
    async renderContents() {
        const instagramData = await this.fetchData();
        if (instagramData) {
            this.LOADED = true;
            console.log("this.LOADED", this.LOADED);
            instagramData.forEach((post, i)=>{
                const modalOpener = document.createElement("modal-opener");
                // const modalDialog = document.createElement("modal-dialog");
                const mediaType = post.mediaType;
                modalOpener.classList.add("swiper-slide", "instagram-feed__slide");
                if (i === 0) modalOpener.classList.add("instagram-feed__slide--first");
                switch(mediaType){
                    case "VIDEO":
                        modalOpener.innerHTML = `
                <video alt="${post.caption}" poster="${post.thumbnailUrl}">
                  <source src="${post.mediaUrl}" />
                </video>
              `;
                        break;
                    case "IMAGE":
                        modalOpener.innerHTML = `
                <img src="${post.mediaUrl}" alt="${post.caption}">
              `;
                        break;
                    case "CAROUSEL_ALBUM":
                        modalOpener.innerHTML = `
                <img src="${post.mediaUrl}" alt="${post.caption}">
              `;
                        break;
                    default:
                }
                this.querySelector(".swiper-wrapper").appendChild(modalOpener);
            });
            this.setupSwiper();
        }
    }
}
window.customElements.define("instagram-slider", InstagramSlider);

},{"../carousel-slider/carousel-slider":"8SLFt"}],"cGVsS":[function(require,module,exports) {
var _pinnedHeros = require("./pinned-heros");

},{"./pinned-heros":"6OJub"}],"6OJub":[function(require,module,exports) {
var _pinnedHeros = require("./pinned-heros");

},{"./pinned-heros":"xleOi"}],"xleOi":[function(require,module,exports) {
var _motion = require("motion");
var _lottiePlayer = require("@lottiefiles/lottie-player");
class PinnedHeros extends HTMLElement {
    constructor(){
        super();
        this.cards = this.querySelectorAll(".pinned-heros__section");
        this.numCards = this.cards.length;
        this.cards.forEach((card, index0)=>{
            const index = index0 + 1;
            const reverseIndex = this.numCards - index0;
            const reverseIndex0 = this.numCards - index;
            console.log("index0", index0);
            console.log("index", index);
            console.log("reverseIndex", reverseIndex);
            console.log("reverseIndex0", reverseIndex0);
            card.style.paddingTop = index * parseFloat(getComputedStyle(this).getPropertyValue("--card-top-offset")) + "rem";
            // card.style.paddingTop = `calc(${index} * 2rem`;
            // card.style.paddingTop = index * 2 + "px";
            // console.log("padding-top", card.style.paddingTop);
            // Scroll-Linked Animation
            (0, _motion.scroll)((0, _motion.animate)(card, {
                // Earlier cards shrink more than later cards
                scale: [
                    1,
                    1 - 0.1 * reverseIndex0
                ]
            }), {
                // Each card should only shrink when it’s at the top.
                // We can’t use exit on the els for this (as they are sticky)
                // but can track $cardsWrapper instead.
                target: this,
                offset: [
                    `${index0 / this.numCards * 100}%`,
                    `${index / this.numCards * 100}%`
                ]
            });
        });
    }
    connectedCallback() {
    //implementation
    }
    disconnectedCallback() {
    //implementation
    }
    attributeChangedCallback(name, oldVal, newVal) {
    //implementation
    }
    adoptedCallback() {
    //implementation
    }
}
window.customElements.define("pinned-heros", PinnedHeros);

},{"motion":"ibAjH","@lottiefiles/lottie-player":"4MrCA"}],"4MrCA":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "LottiePlayer", ()=>LottiePlayer);
parcelHelpers.export(exports, "PlayMode", ()=>PlayMode);
parcelHelpers.export(exports, "PlayerEvents", ()=>PlayerEvents);
parcelHelpers.export(exports, "PlayerState", ()=>PlayerState);
parcelHelpers.export(exports, "parseSrc", ()=>parseSrc);
var global = arguments[3];
function _asyncIterator(t1) {
    var e1, r1, i1, s1 = 2;
    for("undefined" != typeof Symbol && (r1 = Symbol.asyncIterator, i1 = Symbol.iterator); s1--;){
        if (r1 && null != (e1 = t1[r1])) return e1.call(t1);
        if (i1 && null != (e1 = t1[i1])) return new AsyncFromSyncIterator(e1.call(t1));
        r1 = "@@asyncIterator", i1 = "@@iterator";
    }
    throw new TypeError("Object is not async iterable");
}
function AsyncFromSyncIterator(t1) {
    function e1(t1) {
        if (Object(t1) !== t1) return Promise.reject(new TypeError(t1 + " is not an object."));
        var e1 = t1.done;
        return Promise.resolve(t1.value).then(function(t1) {
            return {
                value: t1,
                done: e1
            };
        });
    }
    return AsyncFromSyncIterator = function(t1) {
        this.s = t1, this.n = t1.next;
    }, AsyncFromSyncIterator.prototype = {
        s: null,
        n: null,
        next: function() {
            return e1(this.n.apply(this.s, arguments));
        },
        return: function(t1) {
            var r1 = this.s.return;
            return void 0 === r1 ? Promise.resolve({
                value: t1,
                done: !0
            }) : e1(r1.apply(this.s, arguments));
        },
        throw: function(t1) {
            var r1 = this.s.return;
            return void 0 === r1 ? Promise.reject(t1) : e1(r1.apply(this.s, arguments));
        }
    }, new AsyncFromSyncIterator(t1);
}
var REACT_ELEMENT_TYPE;
function _jsx(t1, e1, r1, i1) {
    REACT_ELEMENT_TYPE || (REACT_ELEMENT_TYPE = "function" == typeof Symbol && Symbol.for && Symbol.for("react.element") || 60103);
    var s1 = t1 && t1.defaultProps, a1 = arguments.length - 3;
    if (e1 || 0 === a1 || (e1 = {
        children: void 0
    }), 1 === a1) e1.children = i1;
    else if (a1 > 1) {
        for(var n1 = new Array(a1), o1 = 0; o1 < a1; o1++)n1[o1] = arguments[o1 + 3];
        e1.children = n1;
    }
    if (e1 && s1) for(var h1 in s1)void 0 === e1[h1] && (e1[h1] = s1[h1]);
    else e1 || (e1 = s1 || {});
    return {
        $$typeof: REACT_ELEMENT_TYPE,
        type: t1,
        key: void 0 === r1 ? null : "" + r1,
        ref: null,
        props: e1,
        _owner: null
    };
}
function ownKeys(t1, e1) {
    var r1 = Object.keys(t1);
    if (Object.getOwnPropertySymbols) {
        var i1 = Object.getOwnPropertySymbols(t1);
        e1 && (i1 = i1.filter(function(e1) {
            return Object.getOwnPropertyDescriptor(t1, e1).enumerable;
        })), r1.push.apply(r1, i1);
    }
    return r1;
}
function _objectSpread2(t1) {
    for(var e1 = 1; e1 < arguments.length; e1++){
        var r1 = null != arguments[e1] ? arguments[e1] : {};
        e1 % 2 ? ownKeys(Object(r1), !0).forEach(function(e1) {
            _defineProperty(t1, e1, r1[e1]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(t1, Object.getOwnPropertyDescriptors(r1)) : ownKeys(Object(r1)).forEach(function(e1) {
            Object.defineProperty(t1, e1, Object.getOwnPropertyDescriptor(r1, e1));
        });
    }
    return t1;
}
function _typeof(t1) {
    return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(t1) {
        return typeof t1;
    } : function(t1) {
        return t1 && "function" == typeof Symbol && t1.constructor === Symbol && t1 !== Symbol.prototype ? "symbol" : typeof t1;
    }, _typeof(t1);
}
function _wrapRegExp() {
    _wrapRegExp = function(t1, e1) {
        return new r1(t1, void 0, e1);
    };
    var t1 = RegExp.prototype, e1 = new WeakMap;
    function r1(t1, i1, s1) {
        var a1 = new RegExp(t1, i1);
        return e1.set(a1, s1 || e1.get(t1)), _setPrototypeOf(a1, r1.prototype);
    }
    function i1(t1, r1) {
        var i1 = e1.get(r1);
        return Object.keys(i1).reduce(function(e1, r1) {
            return e1[r1] = t1[i1[r1]], e1;
        }, Object.create(null));
    }
    return _inherits(r1, RegExp), r1.prototype.exec = function(e1) {
        var r1 = t1.exec.call(this, e1);
        return r1 && (r1.groups = i1(r1, this)), r1;
    }, r1.prototype[Symbol.replace] = function(r1, s1) {
        if ("string" == typeof s1) {
            var a1 = e1.get(this);
            return t1[Symbol.replace].call(this, r1, s1.replace(/\$<([^>]+)>/g, function(t1, e1) {
                return "$" + a1[e1];
            }));
        }
        if ("function" == typeof s1) {
            var n1 = this;
            return t1[Symbol.replace].call(this, r1, function() {
                var t1 = arguments;
                return "object" != typeof t1[t1.length - 1] && (t1 = [].slice.call(t1)).push(i1(t1, n1)), s1.apply(this, t1);
            });
        }
        return t1[Symbol.replace].call(this, r1, s1);
    }, _wrapRegExp.apply(this, arguments);
}
function _AwaitValue(t1) {
    this.wrapped = t1;
}
function _AsyncGenerator(t1) {
    var e1, r1;
    function i1(e1, r1) {
        try {
            var a1 = t1[e1](r1), n1 = a1.value, o1 = n1 instanceof _AwaitValue;
            Promise.resolve(o1 ? n1.wrapped : n1).then(function(t1) {
                o1 ? i1("return" === e1 ? "return" : "next", t1) : s1(a1.done ? "return" : "normal", t1);
            }, function(t1) {
                i1("throw", t1);
            });
        } catch (t1) {
            s1("throw", t1);
        }
    }
    function s1(t1, s1) {
        switch(t1){
            case "return":
                e1.resolve({
                    value: s1,
                    done: !0
                });
                break;
            case "throw":
                e1.reject(s1);
                break;
            default:
                e1.resolve({
                    value: s1,
                    done: !1
                });
        }
        (e1 = e1.next) ? i1(e1.key, e1.arg) : r1 = null;
    }
    this._invoke = function(t1, s1) {
        return new Promise(function(a1, n1) {
            var o1 = {
                key: t1,
                arg: s1,
                resolve: a1,
                reject: n1,
                next: null
            };
            r1 ? r1 = r1.next = o1 : (e1 = r1 = o1, i1(t1, s1));
        });
    }, "function" != typeof t1.return && (this.return = void 0);
}
function _wrapAsyncGenerator(t1) {
    return function() {
        return new _AsyncGenerator(t1.apply(this, arguments));
    };
}
function _awaitAsyncGenerator(t1) {
    return new _AwaitValue(t1);
}
function _asyncGeneratorDelegate(t1, e1) {
    var r1 = {}, i1 = !1;
    function s1(r1, s1) {
        return i1 = !0, s1 = new Promise(function(e1) {
            e1(t1[r1](s1));
        }), {
            done: !1,
            value: e1(s1)
        };
    }
    return r1["undefined" != typeof Symbol && Symbol.iterator || "@@iterator"] = function() {
        return this;
    }, r1.next = function(t1) {
        return i1 ? (i1 = !1, t1) : s1("next", t1);
    }, "function" == typeof t1.throw && (r1.throw = function(t1) {
        if (i1) throw i1 = !1, t1;
        return s1("throw", t1);
    }), "function" == typeof t1.return && (r1.return = function(t1) {
        return i1 ? (i1 = !1, t1) : s1("return", t1);
    }), r1;
}
function asyncGeneratorStep(t1, e1, r1, i1, s1, a1, n1) {
    try {
        var o1 = t1[a1](n1), h1 = o1.value;
    } catch (t1) {
        return void r1(t1);
    }
    o1.done ? e1(h1) : Promise.resolve(h1).then(i1, s1);
}
function _asyncToGenerator(t1) {
    return function() {
        var e1 = this, r1 = arguments;
        return new Promise(function(i1, s1) {
            var a1 = t1.apply(e1, r1);
            function n1(t1) {
                asyncGeneratorStep(a1, i1, s1, n1, o1, "next", t1);
            }
            function o1(t1) {
                asyncGeneratorStep(a1, i1, s1, n1, o1, "throw", t1);
            }
            n1(void 0);
        });
    };
}
function _classCallCheck(t1, e1) {
    if (!(t1 instanceof e1)) throw new TypeError("Cannot call a class as a function");
}
function _defineProperties(t1, e1) {
    for(var r1 = 0; r1 < e1.length; r1++){
        var i1 = e1[r1];
        i1.enumerable = i1.enumerable || !1, i1.configurable = !0, "value" in i1 && (i1.writable = !0), Object.defineProperty(t1, i1.key, i1);
    }
}
function _createClass(t1, e1, r1) {
    return e1 && _defineProperties(t1.prototype, e1), r1 && _defineProperties(t1, r1), Object.defineProperty(t1, "prototype", {
        writable: !1
    }), t1;
}
function _defineEnumerableProperties(t1, e1) {
    for(var r1 in e1)(a1 = e1[r1]).configurable = a1.enumerable = !0, "value" in a1 && (a1.writable = !0), Object.defineProperty(t1, r1, a1);
    if (Object.getOwnPropertySymbols) for(var i1 = Object.getOwnPropertySymbols(e1), s1 = 0; s1 < i1.length; s1++){
        var a1, n1 = i1[s1];
        (a1 = e1[n1]).configurable = a1.enumerable = !0, "value" in a1 && (a1.writable = !0), Object.defineProperty(t1, n1, a1);
    }
    return t1;
}
function _defaults(t1, e1) {
    for(var r1 = Object.getOwnPropertyNames(e1), i1 = 0; i1 < r1.length; i1++){
        var s1 = r1[i1], a1 = Object.getOwnPropertyDescriptor(e1, s1);
        a1 && a1.configurable && void 0 === t1[s1] && Object.defineProperty(t1, s1, a1);
    }
    return t1;
}
function _defineProperty(t1, e1, r1) {
    return e1 in t1 ? Object.defineProperty(t1, e1, {
        value: r1,
        enumerable: !0,
        configurable: !0,
        writable: !0
    }) : t1[e1] = r1, t1;
}
function _extends() {
    return _extends = Object.assign || function(t1) {
        for(var e1 = 1; e1 < arguments.length; e1++){
            var r1 = arguments[e1];
            for(var i1 in r1)Object.prototype.hasOwnProperty.call(r1, i1) && (t1[i1] = r1[i1]);
        }
        return t1;
    }, _extends.apply(this, arguments);
}
function _objectSpread(t1) {
    for(var e1 = 1; e1 < arguments.length; e1++){
        var r1 = null != arguments[e1] ? Object(arguments[e1]) : {}, i1 = Object.keys(r1);
        "function" == typeof Object.getOwnPropertySymbols && i1.push.apply(i1, Object.getOwnPropertySymbols(r1).filter(function(t1) {
            return Object.getOwnPropertyDescriptor(r1, t1).enumerable;
        })), i1.forEach(function(e1) {
            _defineProperty(t1, e1, r1[e1]);
        });
    }
    return t1;
}
function _inherits(t1, e1) {
    if ("function" != typeof e1 && null !== e1) throw new TypeError("Super expression must either be null or a function");
    t1.prototype = Object.create(e1 && e1.prototype, {
        constructor: {
            value: t1,
            writable: !0,
            configurable: !0
        }
    }), Object.defineProperty(t1, "prototype", {
        writable: !1
    }), e1 && _setPrototypeOf(t1, e1);
}
function _inheritsLoose(t1, e1) {
    t1.prototype = Object.create(e1.prototype), t1.prototype.constructor = t1, _setPrototypeOf(t1, e1);
}
function _getPrototypeOf(t1) {
    return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function(t1) {
        return t1.__proto__ || Object.getPrototypeOf(t1);
    }, _getPrototypeOf(t1);
}
function _setPrototypeOf(t1, e1) {
    return _setPrototypeOf = Object.setPrototypeOf || function(t1, e1) {
        return t1.__proto__ = e1, t1;
    }, _setPrototypeOf(t1, e1);
}
function _isNativeReflectConstruct() {
    if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
    if (Reflect.construct.sham) return !1;
    if ("function" == typeof Proxy) return !0;
    try {
        return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {})), !0;
    } catch (t1) {
        return !1;
    }
}
function _construct(t1, e1, r1) {
    return _construct = _isNativeReflectConstruct() ? Reflect.construct : function(t1, e1, r1) {
        var i1 = [
            null
        ];
        i1.push.apply(i1, e1);
        var s1 = new (Function.bind.apply(t1, i1));
        return r1 && _setPrototypeOf(s1, r1.prototype), s1;
    }, _construct.apply(null, arguments);
}
function _isNativeFunction(t1) {
    return -1 !== Function.toString.call(t1).indexOf("[native code]");
}
function _wrapNativeSuper(t1) {
    var e1 = "function" == typeof Map ? new Map : void 0;
    return _wrapNativeSuper = function(t1) {
        if (null === t1 || !_isNativeFunction(t1)) return t1;
        if ("function" != typeof t1) throw new TypeError("Super expression must either be null or a function");
        if (void 0 !== e1) {
            if (e1.has(t1)) return e1.get(t1);
            e1.set(t1, r1);
        }
        function r1() {
            return _construct(t1, arguments, _getPrototypeOf(this).constructor);
        }
        return r1.prototype = Object.create(t1.prototype, {
            constructor: {
                value: r1,
                enumerable: !1,
                writable: !0,
                configurable: !0
            }
        }), _setPrototypeOf(r1, t1);
    }, _wrapNativeSuper(t1);
}
function _instanceof(t1, e1) {
    return null != e1 && "undefined" != typeof Symbol && e1[Symbol.hasInstance] ? !!e1[Symbol.hasInstance](t1) : t1 instanceof e1;
}
function _interopRequireDefault(t1) {
    return t1 && t1.__esModule ? t1 : {
        default: t1
    };
}
function _getRequireWildcardCache(t1) {
    if ("function" != typeof WeakMap) return null;
    var e1 = new WeakMap, r1 = new WeakMap;
    return (_getRequireWildcardCache = function(t1) {
        return t1 ? r1 : e1;
    })(t1);
}
function _interopRequireWildcard(t1, e1) {
    if (!e1 && t1 && t1.__esModule) return t1;
    if (null === t1 || "object" != typeof t1 && "function" != typeof t1) return {
        default: t1
    };
    var r1 = _getRequireWildcardCache(e1);
    if (r1 && r1.has(t1)) return r1.get(t1);
    var i1 = {}, s1 = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var a1 in t1)if ("default" !== a1 && Object.prototype.hasOwnProperty.call(t1, a1)) {
        var n1 = s1 ? Object.getOwnPropertyDescriptor(t1, a1) : null;
        n1 && (n1.get || n1.set) ? Object.defineProperty(i1, a1, n1) : i1[a1] = t1[a1];
    }
    return i1.default = t1, r1 && r1.set(t1, i1), i1;
}
function _newArrowCheck(t1, e1) {
    if (t1 !== e1) throw new TypeError("Cannot instantiate an arrow function");
}
function _objectDestructuringEmpty(t1) {
    if (null == t1) throw new TypeError("Cannot destructure undefined");
}
function _objectWithoutPropertiesLoose(t1, e1) {
    if (null == t1) return {};
    var r1, i1, s1 = {}, a1 = Object.keys(t1);
    for(i1 = 0; i1 < a1.length; i1++)r1 = a1[i1], e1.indexOf(r1) >= 0 || (s1[r1] = t1[r1]);
    return s1;
}
function _objectWithoutProperties(t1, e1) {
    if (null == t1) return {};
    var r1, i1, s1 = _objectWithoutPropertiesLoose(t1, e1);
    if (Object.getOwnPropertySymbols) {
        var a1 = Object.getOwnPropertySymbols(t1);
        for(i1 = 0; i1 < a1.length; i1++)r1 = a1[i1], e1.indexOf(r1) >= 0 || Object.prototype.propertyIsEnumerable.call(t1, r1) && (s1[r1] = t1[r1]);
    }
    return s1;
}
function _assertThisInitialized(t1) {
    if (void 0 === t1) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return t1;
}
function _possibleConstructorReturn(t1, e1) {
    if (e1 && ("object" == typeof e1 || "function" == typeof e1)) return e1;
    if (void 0 !== e1) throw new TypeError("Derived constructors may only return object or undefined");
    return _assertThisInitialized(t1);
}
function _createSuper(t1) {
    var e1 = _isNativeReflectConstruct();
    return function() {
        var r1, i1 = _getPrototypeOf(t1);
        if (e1) {
            var s1 = _getPrototypeOf(this).constructor;
            r1 = Reflect.construct(i1, arguments, s1);
        } else r1 = i1.apply(this, arguments);
        return _possibleConstructorReturn(this, r1);
    };
}
function _superPropBase(t1, e1) {
    for(; !Object.prototype.hasOwnProperty.call(t1, e1) && null !== (t1 = _getPrototypeOf(t1)););
    return t1;
}
function _get() {
    return _get = "undefined" != typeof Reflect && Reflect.get ? Reflect.get : function(t1, e1, r1) {
        var i1 = _superPropBase(t1, e1);
        if (i1) {
            var s1 = Object.getOwnPropertyDescriptor(i1, e1);
            return s1.get ? s1.get.call(arguments.length < 3 ? t1 : r1) : s1.value;
        }
    }, _get.apply(this, arguments);
}
function set(t1, e1, r1, i1) {
    return set = "undefined" != typeof Reflect && Reflect.set ? Reflect.set : function(t1, e1, r1, i1) {
        var s1, a1 = _superPropBase(t1, e1);
        if (a1) {
            if ((s1 = Object.getOwnPropertyDescriptor(a1, e1)).set) return s1.set.call(i1, r1), !0;
            if (!s1.writable) return !1;
        }
        if (s1 = Object.getOwnPropertyDescriptor(i1, e1)) {
            if (!s1.writable) return !1;
            s1.value = r1, Object.defineProperty(i1, e1, s1);
        } else _defineProperty(i1, e1, r1);
        return !0;
    }, set(t1, e1, r1, i1);
}
function _set(t1, e1, r1, i1, s1) {
    if (!set(t1, e1, r1, i1 || t1) && s1) throw new Error("failed to set property");
    return r1;
}
function _taggedTemplateLiteral(t1, e1) {
    return e1 || (e1 = t1.slice(0)), Object.freeze(Object.defineProperties(t1, {
        raw: {
            value: Object.freeze(e1)
        }
    }));
}
function _taggedTemplateLiteralLoose(t1, e1) {
    return e1 || (e1 = t1.slice(0)), t1.raw = e1, t1;
}
function _readOnlyError(t1) {
    throw new TypeError('"' + t1 + '" is read-only');
}
function _writeOnlyError(t1) {
    throw new TypeError('"' + t1 + '" is write-only');
}
function _classNameTDZError(t1) {
    throw new Error('Class "' + t1 + '" cannot be referenced in computed property keys.');
}
function _temporalUndefined() {}
function _tdz(t1) {
    throw new ReferenceError(t1 + " is not defined - temporal dead zone");
}
function _temporalRef(t1, e1) {
    return t1 === _temporalUndefined ? _tdz(e1) : t1;
}
function _slicedToArray(t1, e1) {
    return _arrayWithHoles(t1) || _iterableToArrayLimit(t1, e1) || _unsupportedIterableToArray(t1, e1) || _nonIterableRest();
}
function _slicedToArrayLoose(t1, e1) {
    return _arrayWithHoles(t1) || _iterableToArrayLimitLoose(t1, e1) || _unsupportedIterableToArray(t1, e1) || _nonIterableRest();
}
function _toArray(t1) {
    return _arrayWithHoles(t1) || _iterableToArray(t1) || _unsupportedIterableToArray(t1) || _nonIterableRest();
}
function _toConsumableArray(t1) {
    return _arrayWithoutHoles(t1) || _iterableToArray(t1) || _unsupportedIterableToArray(t1) || _nonIterableSpread();
}
function _arrayWithoutHoles(t1) {
    if (Array.isArray(t1)) return _arrayLikeToArray(t1);
}
function _arrayWithHoles(t1) {
    if (Array.isArray(t1)) return t1;
}
function _maybeArrayLike(t1, e1, r1) {
    if (e1 && !Array.isArray(e1) && "number" == typeof e1.length) {
        var i1 = e1.length;
        return _arrayLikeToArray(e1, void 0 !== r1 && r1 < i1 ? r1 : i1);
    }
    return t1(e1, r1);
}
function _iterableToArray(t1) {
    if ("undefined" != typeof Symbol && null != t1[Symbol.iterator] || null != t1["@@iterator"]) return Array.from(t1);
}
function _iterableToArrayLimit(t1, e1) {
    var r1 = null == t1 ? null : "undefined" != typeof Symbol && t1[Symbol.iterator] || t1["@@iterator"];
    if (null != r1) {
        var i1, s1, a1 = [], n1 = !0, o1 = !1;
        try {
            for(r1 = r1.call(t1); !(n1 = (i1 = r1.next()).done) && (a1.push(i1.value), !e1 || a1.length !== e1); n1 = !0);
        } catch (t1) {
            o1 = !0, s1 = t1;
        } finally{
            try {
                n1 || null == r1.return || r1.return();
            } finally{
                if (o1) throw s1;
            }
        }
        return a1;
    }
}
function _iterableToArrayLimitLoose(t1, e1) {
    var r1 = t1 && ("undefined" != typeof Symbol && t1[Symbol.iterator] || t1["@@iterator"]);
    if (null != r1) {
        var i1 = [];
        for(r1 = r1.call(t1), _step; !(_step = r1.next()).done && (i1.push(_step.value), !e1 || i1.length !== e1););
        return i1;
    }
}
function _unsupportedIterableToArray(t1, e1) {
    if (t1) {
        if ("string" == typeof t1) return _arrayLikeToArray(t1, e1);
        var r1 = Object.prototype.toString.call(t1).slice(8, -1);
        return "Object" === r1 && t1.constructor && (r1 = t1.constructor.name), "Map" === r1 || "Set" === r1 ? Array.from(t1) : "Arguments" === r1 || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(r1) ? _arrayLikeToArray(t1, e1) : void 0;
    }
}
function _arrayLikeToArray(t1, e1) {
    (null == e1 || e1 > t1.length) && (e1 = t1.length);
    for(var r1 = 0, i1 = new Array(e1); r1 < e1; r1++)i1[r1] = t1[r1];
    return i1;
}
function _nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _createForOfIteratorHelper(t1, e1) {
    var r1 = "undefined" != typeof Symbol && t1[Symbol.iterator] || t1["@@iterator"];
    if (!r1) {
        if (Array.isArray(t1) || (r1 = _unsupportedIterableToArray(t1)) || e1 && t1 && "number" == typeof t1.length) {
            r1 && (t1 = r1);
            var i1 = 0, s1 = function() {};
            return {
                s: s1,
                n: function() {
                    return i1 >= t1.length ? {
                        done: !0
                    } : {
                        done: !1,
                        value: t1[i1++]
                    };
                },
                e: function(t1) {
                    throw t1;
                },
                f: s1
            };
        }
        throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
    }
    var a1, n1 = !0, o1 = !1;
    return {
        s: function() {
            r1 = r1.call(t1);
        },
        n: function() {
            var t1 = r1.next();
            return n1 = t1.done, t1;
        },
        e: function(t1) {
            o1 = !0, a1 = t1;
        },
        f: function() {
            try {
                n1 || null == r1.return || r1.return();
            } finally{
                if (o1) throw a1;
            }
        }
    };
}
function _createForOfIteratorHelperLoose(t1, e1) {
    var r1 = "undefined" != typeof Symbol && t1[Symbol.iterator] || t1["@@iterator"];
    if (r1) return (r1 = r1.call(t1)).next.bind(r1);
    if (Array.isArray(t1) || (r1 = _unsupportedIterableToArray(t1)) || e1 && t1 && "number" == typeof t1.length) {
        r1 && (t1 = r1);
        var i1 = 0;
        return function() {
            return i1 >= t1.length ? {
                done: !0
            } : {
                done: !1,
                value: t1[i1++]
            };
        };
    }
    throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _skipFirstGeneratorNext(t1) {
    return function() {
        var e1 = t1.apply(this, arguments);
        return e1.next(), e1;
    };
}
function _toPrimitive(t1, e1) {
    if ("object" != typeof t1 || null === t1) return t1;
    var r1 = t1[Symbol.toPrimitive];
    if (void 0 !== r1) {
        var i1 = r1.call(t1, e1 || "default");
        if ("object" != typeof i1) return i1;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === e1 ? String : Number)(t1);
}
function _toPropertyKey(t1) {
    var e1 = _toPrimitive(t1, "string");
    return "symbol" == typeof e1 ? e1 : String(e1);
}
function _initializerWarningHelper(t1, e1) {
    throw new Error("Decorating class property failed. Please ensure that proposal-class-properties is enabled and runs after the decorators transform.");
}
function _initializerDefineProperty(t1, e1, r1, i1) {
    r1 && Object.defineProperty(t1, e1, {
        enumerable: r1.enumerable,
        configurable: r1.configurable,
        writable: r1.writable,
        value: r1.initializer ? r1.initializer.call(i1) : void 0
    });
}
function _applyDecoratedDescriptor(t1, e1, r1, i1, s1) {
    var a1 = {};
    return Object.keys(i1).forEach(function(t1) {
        a1[t1] = i1[t1];
    }), a1.enumerable = !!a1.enumerable, a1.configurable = !!a1.configurable, ("value" in a1 || a1.initializer) && (a1.writable = !0), a1 = r1.slice().reverse().reduce(function(r1, i1) {
        return i1(t1, e1, r1) || r1;
    }, a1), s1 && void 0 !== a1.initializer && (a1.value = a1.initializer ? a1.initializer.call(s1) : void 0, a1.initializer = void 0), void 0 === a1.initializer && (Object.defineProperty(t1, e1, a1), a1 = null), a1;
}
_AsyncGenerator.prototype["function" == typeof Symbol && Symbol.asyncIterator || "@@asyncIterator"] = function() {
    return this;
}, _AsyncGenerator.prototype.next = function(t1) {
    return this._invoke("next", t1);
}, _AsyncGenerator.prototype.throw = function(t1) {
    return this._invoke("throw", t1);
}, _AsyncGenerator.prototype.return = function(t1) {
    return this._invoke("return", t1);
};
var id = 0;
function _classPrivateFieldLooseKey(t1) {
    return "__private_" + id++ + "_" + t1;
}
function _classPrivateFieldLooseBase(t1, e1) {
    if (!Object.prototype.hasOwnProperty.call(t1, e1)) throw new TypeError("attempted to use private field on non-instance");
    return t1;
}
function _classPrivateFieldGet(t1, e1) {
    return _classApplyDescriptorGet(t1, _classExtractFieldDescriptor(t1, e1, "get"));
}
function _classPrivateFieldSet(t1, e1, r1) {
    return _classApplyDescriptorSet(t1, _classExtractFieldDescriptor(t1, e1, "set"), r1), r1;
}
function _classPrivateFieldDestructureSet(t1, e1) {
    return _classApplyDescriptorDestructureSet(t1, _classExtractFieldDescriptor(t1, e1, "set"));
}
function _classExtractFieldDescriptor(t1, e1, r1) {
    if (!e1.has(t1)) throw new TypeError("attempted to " + r1 + " private field on non-instance");
    return e1.get(t1);
}
function _classStaticPrivateFieldSpecGet(t1, e1, r1) {
    return _classCheckPrivateStaticAccess(t1, e1), _classCheckPrivateStaticFieldDescriptor(r1, "get"), _classApplyDescriptorGet(t1, r1);
}
function _classStaticPrivateFieldSpecSet(t1, e1, r1, i1) {
    return _classCheckPrivateStaticAccess(t1, e1), _classCheckPrivateStaticFieldDescriptor(r1, "set"), _classApplyDescriptorSet(t1, r1, i1), i1;
}
function _classStaticPrivateMethodGet(t1, e1, r1) {
    return _classCheckPrivateStaticAccess(t1, e1), r1;
}
function _classStaticPrivateMethodSet() {
    throw new TypeError("attempted to set read only static private field");
}
function _classApplyDescriptorGet(t1, e1) {
    return e1.get ? e1.get.call(t1) : e1.value;
}
function _classApplyDescriptorSet(t1, e1, r1) {
    if (e1.set) e1.set.call(t1, r1);
    else {
        if (!e1.writable) throw new TypeError("attempted to set read only private field");
        e1.value = r1;
    }
}
function _classApplyDescriptorDestructureSet(t1, e1) {
    if (e1.set) return "__destrObj" in e1 || (e1.__destrObj = {
        set value (r){
            e1.set.call(t1, r);
        }
    }), e1.__destrObj;
    if (!e1.writable) throw new TypeError("attempted to set read only private field");
    return e1;
}
function _classStaticPrivateFieldDestructureSet(t1, e1, r1) {
    return _classCheckPrivateStaticAccess(t1, e1), _classCheckPrivateStaticFieldDescriptor(r1, "set"), _classApplyDescriptorDestructureSet(t1, r1);
}
function _classCheckPrivateStaticAccess(t1, e1) {
    if (t1 !== e1) throw new TypeError("Private static access of wrong provenance");
}
function _classCheckPrivateStaticFieldDescriptor(t1, e1) {
    if (void 0 === t1) throw new TypeError("attempted to " + e1 + " private static field before its declaration");
}
function _decorate(t1, e1, r1, i1) {
    var s1 = _getDecoratorsApi();
    if (i1) for(var a1 = 0; a1 < i1.length; a1++)s1 = i1[a1](s1);
    var n1 = e1(function(t1) {
        s1.initializeInstanceElements(t1, o1.elements);
    }, r1), o1 = s1.decorateClass(_coalesceClassElements(n1.d.map(_createElementDescriptor)), t1);
    return s1.initializeClassElements(n1.F, o1.elements), s1.runClassFinishers(n1.F, o1.finishers);
}
function _getDecoratorsApi() {
    _getDecoratorsApi = function() {
        return t1;
    };
    var t1 = {
        elementsDefinitionOrder: [
            [
                "method"
            ],
            [
                "field"
            ]
        ],
        initializeInstanceElements: function(t1, e1) {
            [
                "method",
                "field"
            ].forEach(function(r1) {
                e1.forEach(function(e1) {
                    e1.kind === r1 && "own" === e1.placement && this.defineClassElement(t1, e1);
                }, this);
            }, this);
        },
        initializeClassElements: function(t1, e1) {
            var r1 = t1.prototype;
            [
                "method",
                "field"
            ].forEach(function(i1) {
                e1.forEach(function(e1) {
                    var s1 = e1.placement;
                    if (e1.kind === i1 && ("static" === s1 || "prototype" === s1)) {
                        var a1 = "static" === s1 ? t1 : r1;
                        this.defineClassElement(a1, e1);
                    }
                }, this);
            }, this);
        },
        defineClassElement: function(t1, e1) {
            var r1 = e1.descriptor;
            if ("field" === e1.kind) {
                var i1 = e1.initializer;
                r1 = {
                    enumerable: r1.enumerable,
                    writable: r1.writable,
                    configurable: r1.configurable,
                    value: void 0 === i1 ? void 0 : i1.call(t1)
                };
            }
            Object.defineProperty(t1, e1.key, r1);
        },
        decorateClass: function(t1, e1) {
            var r1 = [], i1 = [], s1 = {
                static: [],
                prototype: [],
                own: []
            };
            if (t1.forEach(function(t1) {
                this.addElementPlacement(t1, s1);
            }, this), t1.forEach(function(t1) {
                if (!_hasDecorators(t1)) return r1.push(t1);
                var e1 = this.decorateElement(t1, s1);
                r1.push(e1.element), r1.push.apply(r1, e1.extras), i1.push.apply(i1, e1.finishers);
            }, this), !e1) return {
                elements: r1,
                finishers: i1
            };
            var a1 = this.decorateConstructor(r1, e1);
            return i1.push.apply(i1, a1.finishers), a1.finishers = i1, a1;
        },
        addElementPlacement: function(t1, e1, r1) {
            var i1 = e1[t1.placement];
            if (!r1 && -1 !== i1.indexOf(t1.key)) throw new TypeError("Duplicated element (" + t1.key + ")");
            i1.push(t1.key);
        },
        decorateElement: function(t1, e1) {
            for(var r1 = [], i1 = [], s1 = t1.decorators, a1 = s1.length - 1; a1 >= 0; a1--){
                var n1 = e1[t1.placement];
                n1.splice(n1.indexOf(t1.key), 1);
                var o1 = this.fromElementDescriptor(t1), h1 = this.toElementFinisherExtras((0, s1[a1])(o1) || o1);
                t1 = h1.element, this.addElementPlacement(t1, e1), h1.finisher && i1.push(h1.finisher);
                var l1 = h1.extras;
                if (l1) {
                    for(var p1 = 0; p1 < l1.length; p1++)this.addElementPlacement(l1[p1], e1);
                    r1.push.apply(r1, l1);
                }
            }
            return {
                element: t1,
                finishers: i1,
                extras: r1
            };
        },
        decorateConstructor: function(t1, e1) {
            for(var r1 = [], i1 = e1.length - 1; i1 >= 0; i1--){
                var s1 = this.fromClassDescriptor(t1), a1 = this.toClassDescriptor((0, e1[i1])(s1) || s1);
                if (void 0 !== a1.finisher && r1.push(a1.finisher), void 0 !== a1.elements) {
                    t1 = a1.elements;
                    for(var n1 = 0; n1 < t1.length - 1; n1++)for(var o1 = n1 + 1; o1 < t1.length; o1++)if (t1[n1].key === t1[o1].key && t1[n1].placement === t1[o1].placement) throw new TypeError("Duplicated element (" + t1[n1].key + ")");
                }
            }
            return {
                elements: t1,
                finishers: r1
            };
        },
        fromElementDescriptor: function(t1) {
            var e1 = {
                kind: t1.kind,
                key: t1.key,
                placement: t1.placement,
                descriptor: t1.descriptor
            };
            return Object.defineProperty(e1, Symbol.toStringTag, {
                value: "Descriptor",
                configurable: !0
            }), "field" === t1.kind && (e1.initializer = t1.initializer), e1;
        },
        toElementDescriptors: function(t1) {
            if (void 0 !== t1) return _toArray(t1).map(function(t1) {
                var e1 = this.toElementDescriptor(t1);
                return this.disallowProperty(t1, "finisher", "An element descriptor"), this.disallowProperty(t1, "extras", "An element descriptor"), e1;
            }, this);
        },
        toElementDescriptor: function(t1) {
            var e1 = String(t1.kind);
            if ("method" !== e1 && "field" !== e1) throw new TypeError('An element descriptor\'s .kind property must be either "method" or "field", but a decorator created an element descriptor with .kind "' + e1 + '"');
            var r1 = _toPropertyKey(t1.key), i1 = String(t1.placement);
            if ("static" !== i1 && "prototype" !== i1 && "own" !== i1) throw new TypeError('An element descriptor\'s .placement property must be one of "static", "prototype" or "own", but a decorator created an element descriptor with .placement "' + i1 + '"');
            var s1 = t1.descriptor;
            this.disallowProperty(t1, "elements", "An element descriptor");
            var a1 = {
                kind: e1,
                key: r1,
                placement: i1,
                descriptor: Object.assign({}, s1)
            };
            return "field" !== e1 ? this.disallowProperty(t1, "initializer", "A method descriptor") : (this.disallowProperty(s1, "get", "The property descriptor of a field descriptor"), this.disallowProperty(s1, "set", "The property descriptor of a field descriptor"), this.disallowProperty(s1, "value", "The property descriptor of a field descriptor"), a1.initializer = t1.initializer), a1;
        },
        toElementFinisherExtras: function(t1) {
            return {
                element: this.toElementDescriptor(t1),
                finisher: _optionalCallableProperty(t1, "finisher"),
                extras: this.toElementDescriptors(t1.extras)
            };
        },
        fromClassDescriptor: function(t1) {
            var e1 = {
                kind: "class",
                elements: t1.map(this.fromElementDescriptor, this)
            };
            return Object.defineProperty(e1, Symbol.toStringTag, {
                value: "Descriptor",
                configurable: !0
            }), e1;
        },
        toClassDescriptor: function(t1) {
            var e1 = String(t1.kind);
            if ("class" !== e1) throw new TypeError('A class descriptor\'s .kind property must be "class", but a decorator created a class descriptor with .kind "' + e1 + '"');
            this.disallowProperty(t1, "key", "A class descriptor"), this.disallowProperty(t1, "placement", "A class descriptor"), this.disallowProperty(t1, "descriptor", "A class descriptor"), this.disallowProperty(t1, "initializer", "A class descriptor"), this.disallowProperty(t1, "extras", "A class descriptor");
            var r1 = _optionalCallableProperty(t1, "finisher");
            return {
                elements: this.toElementDescriptors(t1.elements),
                finisher: r1
            };
        },
        runClassFinishers: function(t1, e1) {
            for(var r1 = 0; r1 < e1.length; r1++){
                var i1 = (0, e1[r1])(t1);
                if (void 0 !== i1) {
                    if ("function" != typeof i1) throw new TypeError("Finishers must return a constructor.");
                    t1 = i1;
                }
            }
            return t1;
        },
        disallowProperty: function(t1, e1, r1) {
            if (void 0 !== t1[e1]) throw new TypeError(r1 + " can't have a ." + e1 + " property.");
        }
    };
    return t1;
}
function _createElementDescriptor(t1) {
    var e1, r1 = _toPropertyKey(t1.key);
    "method" === t1.kind ? e1 = {
        value: t1.value,
        writable: !0,
        configurable: !0,
        enumerable: !1
    } : "get" === t1.kind ? e1 = {
        get: t1.value,
        configurable: !0,
        enumerable: !1
    } : "set" === t1.kind ? e1 = {
        set: t1.value,
        configurable: !0,
        enumerable: !1
    } : "field" === t1.kind && (e1 = {
        configurable: !0,
        writable: !0,
        enumerable: !0
    });
    var i1 = {
        kind: "field" === t1.kind ? "field" : "method",
        key: r1,
        placement: t1.static ? "static" : "field" === t1.kind ? "own" : "prototype",
        descriptor: e1
    };
    return t1.decorators && (i1.decorators = t1.decorators), "field" === t1.kind && (i1.initializer = t1.value), i1;
}
function _coalesceGetterSetter(t1, e1) {
    void 0 !== t1.descriptor.get ? e1.descriptor.get = t1.descriptor.get : e1.descriptor.set = t1.descriptor.set;
}
function _coalesceClassElements(t1) {
    for(var e1 = [], r1 = function(t1) {
        return "method" === t1.kind && t1.key === a1.key && t1.placement === a1.placement;
    }, i1 = 0; i1 < t1.length; i1++){
        var s1, a1 = t1[i1];
        if ("method" === a1.kind && (s1 = e1.find(r1))) {
            if (_isDataDescriptor(a1.descriptor) || _isDataDescriptor(s1.descriptor)) {
                if (_hasDecorators(a1) || _hasDecorators(s1)) throw new ReferenceError("Duplicated methods (" + a1.key + ") can't be decorated.");
                s1.descriptor = a1.descriptor;
            } else {
                if (_hasDecorators(a1)) {
                    if (_hasDecorators(s1)) throw new ReferenceError("Decorators can't be placed on different accessors with for the same property (" + a1.key + ").");
                    s1.decorators = a1.decorators;
                }
                _coalesceGetterSetter(a1, s1);
            }
        } else e1.push(a1);
    }
    return e1;
}
function _hasDecorators(t1) {
    return t1.decorators && t1.decorators.length;
}
function _isDataDescriptor(t1) {
    return void 0 !== t1 && !(void 0 === t1.value && void 0 === t1.writable);
}
function _optionalCallableProperty(t1, e1) {
    var r1 = t1[e1];
    if (void 0 !== r1 && "function" != typeof r1) throw new TypeError("Expected '" + e1 + "' to be a function");
    return r1;
}
function _classPrivateMethodGet(t1, e1, r1) {
    if (!e1.has(t1)) throw new TypeError("attempted to get private field on non-instance");
    return r1;
}
function _checkPrivateRedeclaration(t1, e1) {
    if (e1.has(t1)) throw new TypeError("Cannot initialize the same private elements twice on an object");
}
function _classPrivateFieldInitSpec(t1, e1, r1) {
    _checkPrivateRedeclaration(t1, e1), e1.set(t1, r1);
}
function _classPrivateMethodInitSpec(t1, e1) {
    _checkPrivateRedeclaration(t1, e1), e1.add(t1);
}
function _classPrivateMethodSet() {
    throw new TypeError("attempted to reassign private method");
}
/*! *****************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */ var _extendStatics = function(t1, e1) {
    return _extendStatics = Object.setPrototypeOf || ({
        __proto__: []
    }) instanceof Array && function(t1, e1) {
        t1.__proto__ = e1;
    } || function(t1, e1) {
        for(var r1 in e1)Object.prototype.hasOwnProperty.call(e1, r1) && (t1[r1] = e1[r1]);
    }, _extendStatics(t1, e1);
};
function __extends(t1, e1) {
    if ("function" != typeof e1 && null !== e1) throw new TypeError("Class extends value " + String(e1) + " is not a constructor or null");
    function r1() {
        this.constructor = t1;
    }
    _extendStatics(t1, e1), t1.prototype = null === e1 ? Object.create(e1) : (r1.prototype = e1.prototype, new r1);
}
var _assign = function() {
    return _assign = Object.assign || function(t1) {
        for(var e1, r1 = 1, i1 = arguments.length; r1 < i1; r1++)for(var s1 in e1 = arguments[r1])Object.prototype.hasOwnProperty.call(e1, s1) && (t1[s1] = e1[s1]);
        return t1;
    }, _assign.apply(this, arguments);
};
function __rest(t1, e1) {
    var r1 = {};
    for(var i1 in t1)Object.prototype.hasOwnProperty.call(t1, i1) && e1.indexOf(i1) < 0 && (r1[i1] = t1[i1]);
    if (null != t1 && "function" == typeof Object.getOwnPropertySymbols) {
        var s1 = 0;
        for(i1 = Object.getOwnPropertySymbols(t1); s1 < i1.length; s1++)e1.indexOf(i1[s1]) < 0 && Object.prototype.propertyIsEnumerable.call(t1, i1[s1]) && (r1[i1[s1]] = t1[i1[s1]]);
    }
    return r1;
}
function __decorate(t1, e1, r1, i1) {
    var s1, a1 = arguments.length, n1 = a1 < 3 ? e1 : null === i1 ? i1 = Object.getOwnPropertyDescriptor(e1, r1) : i1;
    if ("object" == typeof Reflect && "function" == typeof Reflect.decorate) n1 = Reflect.decorate(t1, e1, r1, i1);
    else for(var o1 = t1.length - 1; o1 >= 0; o1--)(s1 = t1[o1]) && (n1 = (a1 < 3 ? s1(n1) : a1 > 3 ? s1(e1, r1, n1) : s1(e1, r1)) || n1);
    return a1 > 3 && n1 && Object.defineProperty(e1, r1, n1), n1;
}
function __param(t1, e1) {
    return function(r1, i1) {
        e1(r1, i1, t1);
    };
}
function __metadata(t1, e1) {
    if ("object" == typeof Reflect && "function" == typeof Reflect.metadata) return Reflect.metadata(t1, e1);
}
function __awaiter(t1, e1, r1, i1) {
    return new (r1 || (r1 = Promise))(function(s1, a1) {
        function n1(t1) {
            try {
                h1(i1.next(t1));
            } catch (t1) {
                a1(t1);
            }
        }
        function o1(t1) {
            try {
                h1(i1.throw(t1));
            } catch (t1) {
                a1(t1);
            }
        }
        function h1(t1) {
            var e1;
            t1.done ? s1(t1.value) : (e1 = t1.value, e1 instanceof r1 ? e1 : new r1(function(t1) {
                t1(e1);
            })).then(n1, o1);
        }
        h1((i1 = i1.apply(t1, e1 || [])).next());
    });
}
function __generator(t1, e1) {
    var r1, i1, s1, a1, n1 = {
        label: 0,
        sent: function() {
            if (1 & s1[0]) throw s1[1];
            return s1[1];
        },
        trys: [],
        ops: []
    };
    return a1 = {
        next: o1(0),
        throw: o1(1),
        return: o1(2)
    }, "function" == typeof Symbol && (a1[Symbol.iterator] = function() {
        return this;
    }), a1;
    function o1(a1) {
        return function(o1) {
            return function(a1) {
                if (r1) throw new TypeError("Generator is already executing.");
                for(; n1;)try {
                    if (r1 = 1, i1 && (s1 = 2 & a1[0] ? i1.return : a1[0] ? i1.throw || ((s1 = i1.return) && s1.call(i1), 0) : i1.next) && !(s1 = s1.call(i1, a1[1])).done) return s1;
                    switch(i1 = 0, s1 && (a1 = [
                        2 & a1[0],
                        s1.value
                    ]), a1[0]){
                        case 0:
                        case 1:
                            s1 = a1;
                            break;
                        case 4:
                            return n1.label++, {
                                value: a1[1],
                                done: !1
                            };
                        case 5:
                            n1.label++, i1 = a1[1], a1 = [
                                0
                            ];
                            continue;
                        case 7:
                            a1 = n1.ops.pop(), n1.trys.pop();
                            continue;
                        default:
                            if (!(s1 = n1.trys, (s1 = s1.length > 0 && s1[s1.length - 1]) || 6 !== a1[0] && 2 !== a1[0])) {
                                n1 = 0;
                                continue;
                            }
                            if (3 === a1[0] && (!s1 || a1[1] > s1[0] && a1[1] < s1[3])) {
                                n1.label = a1[1];
                                break;
                            }
                            if (6 === a1[0] && n1.label < s1[1]) {
                                n1.label = s1[1], s1 = a1;
                                break;
                            }
                            if (s1 && n1.label < s1[2]) {
                                n1.label = s1[2], n1.ops.push(a1);
                                break;
                            }
                            s1[2] && n1.ops.pop(), n1.trys.pop();
                            continue;
                    }
                    a1 = e1.call(t1, n1);
                } catch (t1) {
                    a1 = [
                        6,
                        t1
                    ], i1 = 0;
                } finally{
                    r1 = s1 = 0;
                }
                if (5 & a1[0]) throw a1[1];
                return {
                    value: a1[0] ? a1[1] : void 0,
                    done: !0
                };
            }([
                a1,
                o1
            ]);
        };
    }
}
var __createBinding = Object.create ? function(t1, e1, r1, i1) {
    void 0 === i1 && (i1 = r1), Object.defineProperty(t1, i1, {
        enumerable: !0,
        get: function() {
            return e1[r1];
        }
    });
} : function(t1, e1, r1, i1) {
    void 0 === i1 && (i1 = r1), t1[i1] = e1[r1];
};
function __exportStar(t1, e1) {
    for(var r1 in t1)"default" === r1 || Object.prototype.hasOwnProperty.call(e1, r1) || __createBinding(e1, t1, r1);
}
function __values(t1) {
    var e1 = "function" == typeof Symbol && Symbol.iterator, r1 = e1 && t1[e1], i1 = 0;
    if (r1) return r1.call(t1);
    if (t1 && "number" == typeof t1.length) return {
        next: function() {
            return t1 && i1 >= t1.length && (t1 = void 0), {
                value: t1 && t1[i1++],
                done: !t1
            };
        }
    };
    throw new TypeError(e1 ? "Object is not iterable." : "Symbol.iterator is not defined.");
}
function __read(t1, e1) {
    var r1 = "function" == typeof Symbol && t1[Symbol.iterator];
    if (!r1) return t1;
    var i1, s1, a1 = r1.call(t1), n1 = [];
    try {
        for(; (void 0 === e1 || e1-- > 0) && !(i1 = a1.next()).done;)n1.push(i1.value);
    } catch (t1) {
        s1 = {
            error: t1
        };
    } finally{
        try {
            i1 && !i1.done && (r1 = a1.return) && r1.call(a1);
        } finally{
            if (s1) throw s1.error;
        }
    }
    return n1;
}
function __spread() {
    for(var t1 = [], e1 = 0; e1 < arguments.length; e1++)t1 = t1.concat(__read(arguments[e1]));
    return t1;
}
function __spreadArrays() {
    for(var t1 = 0, e1 = 0, r1 = arguments.length; e1 < r1; e1++)t1 += arguments[e1].length;
    var i1 = Array(t1), s1 = 0;
    for(e1 = 0; e1 < r1; e1++)for(var a1 = arguments[e1], n1 = 0, o1 = a1.length; n1 < o1; n1++, s1++)i1[s1] = a1[n1];
    return i1;
}
function __spreadArray(t1, e1, r1) {
    if (r1 || 2 === arguments.length) for(var i1, s1 = 0, a1 = e1.length; s1 < a1; s1++)!i1 && s1 in e1 || (i1 || (i1 = Array.prototype.slice.call(e1, 0, s1)), i1[s1] = e1[s1]);
    return t1.concat(i1 || Array.prototype.slice.call(e1));
}
function __await(t1) {
    return this instanceof __await ? (this.v = t1, this) : new __await(t1);
}
function __asyncGenerator(t1, e1, r1) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var i1, s1 = r1.apply(t1, e1 || []), a1 = [];
    return i1 = {}, n1("next"), n1("throw"), n1("return"), i1[Symbol.asyncIterator] = function() {
        return this;
    }, i1;
    function n1(t1) {
        s1[t1] && (i1[t1] = function(e1) {
            return new Promise(function(r1, i1) {
                a1.push([
                    t1,
                    e1,
                    r1,
                    i1
                ]) > 1 || o1(t1, e1);
            });
        });
    }
    function o1(t1, e1) {
        try {
            !function(t1) {
                t1.value instanceof __await ? Promise.resolve(t1.value.v).then(h1, l1) : p1(a1[0][2], t1);
            }(s1[t1](e1));
        } catch (t1) {
            p1(a1[0][3], t1);
        }
    }
    function h1(t1) {
        o1("next", t1);
    }
    function l1(t1) {
        o1("throw", t1);
    }
    function p1(t1, e1) {
        t1(e1), a1.shift(), a1.length && o1(a1[0][0], a1[0][1]);
    }
}
function __asyncDelegator(t1) {
    var e1, r1;
    return e1 = {}, i1("next"), i1("throw", function(t1) {
        throw t1;
    }), i1("return"), e1[Symbol.iterator] = function() {
        return this;
    }, e1;
    function i1(i1, s1) {
        e1[i1] = t1[i1] ? function(e1) {
            return (r1 = !r1) ? {
                value: __await(t1[i1](e1)),
                done: "return" === i1
            } : s1 ? s1(e1) : e1;
        } : s1;
    }
}
function __asyncValues(t1) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var e1, r1 = t1[Symbol.asyncIterator];
    return r1 ? r1.call(t1) : (t1 = "function" == typeof __values ? __values(t1) : t1[Symbol.iterator](), e1 = {}, i1("next"), i1("throw"), i1("return"), e1[Symbol.asyncIterator] = function() {
        return this;
    }, e1);
    function i1(r1) {
        e1[r1] = t1[r1] && function(e1) {
            return new Promise(function(i1, s1) {
                (function(t1, e1, r1, i1) {
                    Promise.resolve(i1).then(function(e1) {
                        t1({
                            value: e1,
                            done: r1
                        });
                    }, e1);
                })(i1, s1, (e1 = t1[r1](e1)).done, e1.value);
            });
        };
    }
}
function __makeTemplateObject(t1, e1) {
    return Object.defineProperty ? Object.defineProperty(t1, "raw", {
        value: e1
    }) : t1.raw = e1, t1;
}
var __setModuleDefault = Object.create ? function(t1, e1) {
    Object.defineProperty(t1, "default", {
        enumerable: !0,
        value: e1
    });
} : function(t1, e1) {
    t1.default = e1;
};
function __importStar(t1) {
    if (t1 && t1.__esModule) return t1;
    var e1 = {};
    if (null != t1) for(var r1 in t1)"default" !== r1 && Object.prototype.hasOwnProperty.call(t1, r1) && __createBinding(e1, t1, r1);
    return __setModuleDefault(e1, t1), e1;
}
function __importDefault(t1) {
    return t1 && t1.__esModule ? t1 : {
        default: t1
    };
}
function __classPrivateFieldGet(t1, e1, r1, i1) {
    if ("a" === r1 && !i1) throw new TypeError("Private accessor was defined without a getter");
    if ("function" == typeof e1 ? t1 !== e1 || !i1 : !e1.has(t1)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return "m" === r1 ? i1 : "a" === r1 ? i1.call(t1) : i1 ? i1.value : e1.get(t1);
}
function __classPrivateFieldSet(t1, e1, r1, i1, s1) {
    if ("m" === i1) throw new TypeError("Private method is not writable");
    if ("a" === i1 && !s1) throw new TypeError("Private accessor was defined without a setter");
    if ("function" == typeof e1 ? t1 !== e1 || !s1 : !e1.has(t1)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
    return "a" === i1 ? s1.call(t1, r1) : s1 ? s1.value = r1 : e1.set(t1, r1), r1;
/**
 * @license
 * Copyright 2019 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */ }
var t$3 = window.ShadowRoot && (void 0 === window.ShadyCSS || window.ShadyCSS.nativeShadow) && "adoptedStyleSheets" in Document.prototype && "replace" in CSSStyleSheet.prototype, e$8 = Symbol(), n$5 = new Map;
class s$3 {
    constructor(t1, e1){
        if (this._$cssResult$ = !0, e1 !== e$8) throw Error("CSSResult is not constructable. Use `unsafeCSS` or `css` instead.");
        this.cssText = t1;
    }
    get styleSheet() {
        var t1 = n$5.get(this.cssText);
        return t$3 && void 0 === t1 && (n$5.set(this.cssText, t1 = new CSSStyleSheet), t1.replaceSync(this.cssText)), t1;
    }
    toString() {
        return this.cssText;
    }
}
var o$5 = (t1)=>new s$3("string" == typeof t1 ? t1 : t1 + "", e$8), r$3 = function(t1) {
    for(var e1 = arguments.length, r1 = new Array(e1 > 1 ? e1 - 1 : 0), i1 = 1; i1 < e1; i1++)r1[i1 - 1] = arguments[i1];
    var s1 = 1 === t1.length ? t1[0] : r1.reduce((e1, r1, i1)=>e1 + ((t1)=>{
            if (!0 === t1._$cssResult$) return t1.cssText;
            if ("number" == typeof t1) return t1;
            throw Error("Value passed to 'css' function must be a 'css' function result: " + t1 + ". Use 'unsafeCSS' to pass non-literal values, but take care to ensure page security.");
        })(r1) + t1[i1 + 1], t1[0]);
    return new s$3(s1, e$8);
}, i$3 = (t1, e1)=>{
    t$3 ? t1.adoptedStyleSheets = e1.map((t1)=>t1 instanceof CSSStyleSheet ? t1 : t1.styleSheet) : e1.forEach((e1)=>{
        var r1 = document.createElement("style"), i1 = window.litNonce;
        void 0 !== i1 && r1.setAttribute("nonce", i1), r1.textContent = e1.cssText, t1.appendChild(r1);
    });
}, S$1 = t$3 ? (t1)=>t1 : (t1)=>t1 instanceof CSSStyleSheet ? ((t1)=>{
        var e1 = "";
        for (var r1 of t1.cssRules)e1 += r1.cssText;
        return o$5(e1);
    })(t1) : t1, s$2, e$7 = window.trustedTypes, r$2 = e$7 ? e$7.emptyScript : "", h$2 = window.reactiveElementPolyfillSupport, o$4 = {
    toAttribute (t1, e1) {
        switch(e1){
            case Boolean:
                t1 = t1 ? r$2 : null;
                break;
            case Object:
            case Array:
                t1 = null == t1 ? t1 : JSON.stringify(t1);
        }
        return t1;
    },
    fromAttribute (t1, e1) {
        var r1 = t1;
        switch(e1){
            case Boolean:
                r1 = null !== t1;
                break;
            case Number:
                r1 = null === t1 ? null : Number(t1);
                break;
            case Object:
            case Array:
                try {
                    r1 = JSON.parse(t1);
                } catch (t1) {
                    r1 = null;
                }
        }
        return r1;
    }
}, n$4 = (t1, e1)=>e1 !== t1 && (e1 == e1 || t1 == t1), l$3 = {
    attribute: !0,
    type: String,
    converter: o$4,
    reflect: !1,
    hasChanged: n$4
}, t$2;
class a$1 extends HTMLElement {
    constructor(){
        super(), this._$Et = new Map, this.isUpdatePending = !1, this.hasUpdated = !1, this._$Ei = null, this.o();
    }
    static addInitializer(t1) {
        var e1;
        null !== (e1 = this.l) && void 0 !== e1 || (this.l = []), this.l.push(t1);
    }
    static get observedAttributes() {
        this.finalize();
        var t1 = [];
        return this.elementProperties.forEach((e1, r1)=>{
            var i1 = this._$Eh(r1, e1);
            void 0 !== i1 && (this._$Eu.set(i1, r1), t1.push(i1));
        }), t1;
    }
    static createProperty(t1) {
        var e1 = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : l$3;
        if (e1.state && (e1.attribute = !1), this.finalize(), this.elementProperties.set(t1, e1), !e1.noAccessor && !this.prototype.hasOwnProperty(t1)) {
            var r1 = "symbol" == typeof t1 ? Symbol() : "__" + t1, i1 = this.getPropertyDescriptor(t1, r1, e1);
            void 0 !== i1 && Object.defineProperty(this.prototype, t1, i1);
        }
    }
    static getPropertyDescriptor(t1, e1, r1) {
        return {
            get () {
                return this[e1];
            },
            set (i1) {
                var s1 = this[t1];
                this[e1] = i1, this.requestUpdate(t1, s1, r1);
            },
            configurable: !0,
            enumerable: !0
        };
    }
    static getPropertyOptions(t1) {
        return this.elementProperties.get(t1) || l$3;
    }
    static finalize() {
        if (this.hasOwnProperty("finalized")) return !1;
        this.finalized = !0;
        var t1 = Object.getPrototypeOf(this);
        if (t1.finalize(), this.elementProperties = new Map(t1.elementProperties), this._$Eu = new Map, this.hasOwnProperty("properties")) {
            var e1 = this.properties, r1 = [
                ...Object.getOwnPropertyNames(e1),
                ...Object.getOwnPropertySymbols(e1)
            ];
            for (var i1 of r1)this.createProperty(i1, e1[i1]);
        }
        return this.elementStyles = this.finalizeStyles(this.styles), !0;
    }
    static finalizeStyles(t1) {
        var e1 = [];
        if (Array.isArray(t1)) {
            var r1 = new Set(t1.flat(1 / 0).reverse());
            for (var i1 of r1)e1.unshift(S$1(i1));
        } else void 0 !== t1 && e1.push(S$1(t1));
        return e1;
    }
    static _$Eh(t1, e1) {
        var r1 = e1.attribute;
        return !1 === r1 ? void 0 : "string" == typeof r1 ? r1 : "string" == typeof t1 ? t1.toLowerCase() : void 0;
    }
    o() {
        var t1;
        this._$Ep = new Promise((t1)=>this.enableUpdating = t1), this._$AL = new Map, this._$Em(), this.requestUpdate(), null === (t1 = this.constructor.l) || void 0 === t1 || t1.forEach((t1)=>t1(this));
    }
    addController(t1) {
        var e1, r1;
        (null !== (e1 = this._$Eg) && void 0 !== e1 ? e1 : this._$Eg = []).push(t1), void 0 !== this.renderRoot && this.isConnected && (null === (r1 = t1.hostConnected) || void 0 === r1 || r1.call(t1));
    }
    removeController(t1) {
        var e1;
        null === (e1 = this._$Eg) || void 0 === e1 || e1.splice(this._$Eg.indexOf(t1) >>> 0, 1);
    }
    _$Em() {
        this.constructor.elementProperties.forEach((t1, e1)=>{
            this.hasOwnProperty(e1) && (this._$Et.set(e1, this[e1]), delete this[e1]);
        });
    }
    createRenderRoot() {
        var t1, e1 = null !== (t1 = this.shadowRoot) && void 0 !== t1 ? t1 : this.attachShadow(this.constructor.shadowRootOptions);
        return i$3(e1, this.constructor.elementStyles), e1;
    }
    connectedCallback() {
        var t1;
        void 0 === this.renderRoot && (this.renderRoot = this.createRenderRoot()), this.enableUpdating(!0), null === (t1 = this._$Eg) || void 0 === t1 || t1.forEach((t1)=>{
            var e1;
            return null === (e1 = t1.hostConnected) || void 0 === e1 ? void 0 : e1.call(t1);
        });
    }
    enableUpdating(t1) {}
    disconnectedCallback() {
        var t1;
        null === (t1 = this._$Eg) || void 0 === t1 || t1.forEach((t1)=>{
            var e1;
            return null === (e1 = t1.hostDisconnected) || void 0 === e1 ? void 0 : e1.call(t1);
        });
    }
    attributeChangedCallback(t1, e1, r1) {
        this._$AK(t1, r1);
    }
    _$ES(t1, e1) {
        var r1, i1, s1 = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : l$3, a1 = this.constructor._$Eh(t1, s1);
        if (void 0 !== a1 && !0 === s1.reflect) {
            var n1 = (null !== (i1 = null === (r1 = s1.converter) || void 0 === r1 ? void 0 : r1.toAttribute) && void 0 !== i1 ? i1 : o$4.toAttribute)(e1, s1.type);
            this._$Ei = t1, null == n1 ? this.removeAttribute(a1) : this.setAttribute(a1, n1), this._$Ei = null;
        }
    }
    _$AK(t1, e1) {
        var r1, i1, s1, a1 = this.constructor, n1 = a1._$Eu.get(t1);
        if (void 0 !== n1 && this._$Ei !== n1) {
            var o1 = a1.getPropertyOptions(n1), h1 = o1.converter, l1 = null !== (s1 = null !== (i1 = null === (r1 = h1) || void 0 === r1 ? void 0 : r1.fromAttribute) && void 0 !== i1 ? i1 : "function" == typeof h1 ? h1 : null) && void 0 !== s1 ? s1 : o$4.fromAttribute;
            this._$Ei = n1, this[n1] = l1(e1, o1.type), this._$Ei = null;
        }
    }
    requestUpdate(t1, e1, r1) {
        var i1 = !0;
        void 0 !== t1 && (((r1 = r1 || this.constructor.getPropertyOptions(t1)).hasChanged || n$4)(this[t1], e1) ? (this._$AL.has(t1) || this._$AL.set(t1, e1), !0 === r1.reflect && this._$Ei !== t1 && (void 0 === this._$E_ && (this._$E_ = new Map), this._$E_.set(t1, r1))) : i1 = !1), !this.isUpdatePending && i1 && (this._$Ep = this._$EC());
    }
    _$EC() {
        var t1 = this;
        return _asyncToGenerator(function*() {
            t1.isUpdatePending = !0;
            try {
                yield t1._$Ep;
            } catch (e1) {
                Promise.reject(e1);
            }
            var e1 = t1.scheduleUpdate();
            return null != e1 && (yield e1), !t1.isUpdatePending;
        })();
    }
    scheduleUpdate() {
        return this.performUpdate();
    }
    performUpdate() {
        var t1;
        if (this.isUpdatePending) {
            this.hasUpdated, this._$Et && (this._$Et.forEach((t1, e1)=>this[e1] = t1), this._$Et = void 0);
            var e1 = !1, r1 = this._$AL;
            try {
                (e1 = this.shouldUpdate(r1)) ? (this.willUpdate(r1), null === (t1 = this._$Eg) || void 0 === t1 || t1.forEach((t1)=>{
                    var e1;
                    return null === (e1 = t1.hostUpdate) || void 0 === e1 ? void 0 : e1.call(t1);
                }), this.update(r1)) : this._$EU();
            } catch (t1) {
                throw e1 = !1, this._$EU(), t1;
            }
            e1 && this._$AE(r1);
        }
    }
    willUpdate(t1) {}
    _$AE(t1) {
        var e1;
        null === (e1 = this._$Eg) || void 0 === e1 || e1.forEach((t1)=>{
            var e1;
            return null === (e1 = t1.hostUpdated) || void 0 === e1 ? void 0 : e1.call(t1);
        }), this.hasUpdated || (this.hasUpdated = !0, this.firstUpdated(t1)), this.updated(t1);
    }
    _$EU() {
        this._$AL = new Map, this.isUpdatePending = !1;
    }
    get updateComplete() {
        return this.getUpdateComplete();
    }
    getUpdateComplete() {
        return this._$Ep;
    }
    shouldUpdate(t1) {
        return !0;
    }
    update(t1) {
        void 0 !== this._$E_ && (this._$E_.forEach((t1, e1)=>this._$ES(e1, this[e1], t1)), this._$E_ = void 0), this._$EU();
    }
    updated(t1) {}
    firstUpdated(t1) {}
}
a$1.finalized = !0, a$1.elementProperties = new Map, a$1.elementStyles = [], a$1.shadowRootOptions = {
    mode: "open"
}, null == h$2 || h$2({
    ReactiveElement: a$1
}), (null !== (s$2 = globalThis.reactiveElementVersions) && void 0 !== s$2 ? s$2 : globalThis.reactiveElementVersions = []).push("1.2.1");
var i$2 = globalThis.trustedTypes, s$1 = i$2 ? i$2.createPolicy("lit-html", {
    createHTML: (t1)=>t1
}) : void 0, e$6 = "lit$".concat((Math.random() + "").slice(9), "$"), o$3 = "?" + e$6, n$3 = "<".concat(o$3, ">"), l$2 = document, h$1 = function() {
    var t1 = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : "";
    return l$2.createComment(t1);
}, r$1 = (t1)=>null === t1 || "object" != typeof t1 && "function" != typeof t1, d = Array.isArray, u = (t1)=>{
    var e1;
    return d(t1) || "function" == typeof (null === (e1 = t1) || void 0 === e1 ? void 0 : e1[Symbol.iterator]);
}, c = /<(?:(!--|\/[^a-zA-Z])|(\/?[a-zA-Z][^>\s]*)|(\/?$))/g, v = /-->/g, a = />/g, f = />|[ 	\n\r](?:([^\s"'>=/]+)([ 	\n\r]*=[ 	\n\r]*(?:[^ 	\n\r"'`<>=]|("|')|))|$)/g, _ = /'/g, m = /"/g, g = /^(?:script|style|textarea)$/i, p = (t1)=>function(e1) {
        for(var r1 = arguments.length, i1 = new Array(r1 > 1 ? r1 - 1 : 0), s1 = 1; s1 < r1; s1++)i1[s1 - 1] = arguments[s1];
        return {
            _$litType$: t1,
            strings: e1,
            values: i1
        };
    }, $ = p(1), y = p(2), b = Symbol.for("lit-noChange"), w = Symbol.for("lit-nothing"), T = new WeakMap, x = (t1, e1, r1)=>{
    var i1, s1, a1 = null !== (i1 = null == r1 ? void 0 : r1.renderBefore) && void 0 !== i1 ? i1 : e1, n1 = a1._$litPart$;
    if (void 0 === n1) {
        var o1 = null !== (s1 = null == r1 ? void 0 : r1.renderBefore) && void 0 !== s1 ? s1 : null;
        a1._$litPart$ = n1 = new N(e1.insertBefore(h$1(), o1), o1, void 0, null != r1 ? r1 : {});
    }
    return n1._$AI(t1), n1;
}, A = l$2.createTreeWalker(l$2, 129, null, !1), C = (t1, e1)=>{
    for(var r1, i1 = t1.length - 1, s1 = [], n1 = 2 === e1 ? "<svg>" : "", o1 = c, h1 = 0; h1 < i1; h1++){
        for(var l1 = t1[h1], p1 = void 0, d1 = void 0, u1 = -1, y1 = 0; y1 < l1.length && (o1.lastIndex = y1, null !== (d1 = o1.exec(l1)));)y1 = o1.lastIndex, o1 === c ? "!--" === d1[1] ? o1 = v : void 0 !== d1[1] ? o1 = a : void 0 !== d1[2] ? (g.test(d1[2]) && (r1 = RegExp("</" + d1[2], "g")), o1 = f) : void 0 !== d1[3] && (o1 = f) : o1 === f ? ">" === d1[0] ? (o1 = null != r1 ? r1 : c, u1 = -1) : void 0 === d1[1] ? u1 = -2 : (u1 = o1.lastIndex - d1[2].length, p1 = d1[1], o1 = void 0 === d1[3] ? f : '"' === d1[3] ? m : _) : o1 === m || o1 === _ ? o1 = f : o1 === v || o1 === a ? o1 = c : (o1 = f, r1 = void 0);
        var b1 = o1 === f && t1[h1 + 1].startsWith("/>") ? " " : "";
        n1 += o1 === c ? l1 + n$3 : u1 >= 0 ? (s1.push(p1), l1.slice(0, u1) + "$lit$" + l1.slice(u1) + e$6 + b1) : l1 + e$6 + (-2 === u1 ? (s1.push(void 0), h1) : b1);
    }
    var P1 = n1 + (t1[i1] || "<?>") + (2 === e1 ? "</svg>" : "");
    if (!Array.isArray(t1) || !t1.hasOwnProperty("raw")) throw Error("invalid template strings array");
    return [
        void 0 !== s$1 ? s$1.createHTML(P1) : P1,
        s1
    ];
};
class E {
    constructor(t1, e1){
        var r1, { strings: i1, _$litType$: s1 } = t1;
        this.parts = [];
        var a1 = 0, n1 = 0, o1 = i1.length - 1, h1 = this.parts, [l1, p1] = C(i1, s1);
        if (this.el = E.createElement(l1, e1), A.currentNode = this.el.content, 2 === s1) {
            var c1 = this.el.content, f1 = c1.firstChild;
            f1.remove(), c1.append(...f1.childNodes);
        }
        for(; null !== (r1 = A.nextNode()) && h1.length < o1;){
            if (1 === r1.nodeType) {
                if (r1.hasAttributes()) {
                    var d1 = [];
                    for (var u1 of r1.getAttributeNames())if (u1.endsWith("$lit$") || u1.startsWith(e$6)) {
                        var m1 = p1[n1++];
                        if (d1.push(u1), void 0 !== m1) {
                            var y1 = r1.getAttribute(m1.toLowerCase() + "$lit$").split(e$6), v1 = /([.?@])?(.*)/.exec(m1);
                            h1.push({
                                type: 1,
                                index: a1,
                                name: v1[2],
                                strings: y1,
                                ctor: "." === v1[1] ? M : "?" === v1[1] ? H : "@" === v1[1] ? I : S
                            });
                        } else h1.push({
                            type: 6,
                            index: a1
                        });
                    }
                    for (var b1 of d1)r1.removeAttribute(b1);
                }
                if (g.test(r1.tagName)) {
                    var _1 = r1.textContent.split(e$6), P1 = _1.length - 1;
                    if (P1 > 0) {
                        r1.textContent = i$2 ? i$2.emptyScript : "";
                        for(var x1 = 0; x1 < P1; x1++)r1.append(_1[x1], h$1()), A.nextNode(), h1.push({
                            type: 2,
                            index: ++a1
                        });
                        r1.append(_1[P1], h$1());
                    }
                }
            } else if (8 === r1.nodeType) {
                if (r1.data === o$3) h1.push({
                    type: 2,
                    index: a1
                });
                else for(var w1 = -1; -1 !== (w1 = r1.data.indexOf(e$6, w1 + 1));)h1.push({
                    type: 7,
                    index: a1
                }), w1 += e$6.length - 1;
            }
            a1++;
        }
    }
    static createElement(t1, e1) {
        var r1 = l$2.createElement("template");
        return r1.innerHTML = t1, r1;
    }
}
function P(t1, e1) {
    var r1, i1, s1, a1, n1 = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : t1, o1 = arguments.length > 3 ? arguments[3] : void 0;
    if (e1 === b) return e1;
    var h1 = void 0 !== o1 ? null === (r1 = n1._$Cl) || void 0 === r1 ? void 0 : r1[o1] : n1._$Cu, l1 = r$1(e1) ? void 0 : e1._$litDirective$;
    return (null == h1 ? void 0 : h1.constructor) !== l1 && (null === (i1 = null == h1 ? void 0 : h1._$AO) || void 0 === i1 || i1.call(h1, !1), void 0 === l1 ? h1 = void 0 : (h1 = new l1(t1))._$AT(t1, n1, o1), void 0 !== o1 ? (null !== (s1 = (a1 = n1)._$Cl) && void 0 !== s1 ? s1 : a1._$Cl = [])[o1] = h1 : n1._$Cu = h1), void 0 !== h1 && (e1 = P(t1, h1._$AS(t1, e1.values), h1, o1)), e1;
}
class V {
    constructor(t1, e1){
        this.v = [], this._$AN = void 0, this._$AD = t1, this._$AM = e1;
    }
    get parentNode() {
        return this._$AM.parentNode;
    }
    get _$AU() {
        return this._$AM._$AU;
    }
    p(t1) {
        var e1, { el: { content: r1 }, parts: i1 } = this._$AD, s1 = (null !== (e1 = null == t1 ? void 0 : t1.creationScope) && void 0 !== e1 ? e1 : l$2).importNode(r1, !0);
        A.currentNode = s1;
        for(var a1 = A.nextNode(), n1 = 0, o1 = 0, h1 = i1[0]; void 0 !== h1;){
            if (n1 === h1.index) {
                var l1 = void 0;
                2 === h1.type ? l1 = new N(a1, a1.nextSibling, this, t1) : 1 === h1.type ? l1 = new h1.ctor(a1, h1.name, h1.strings, this, t1) : 6 === h1.type && (l1 = new L(a1, this, t1)), this.v.push(l1), h1 = i1[++o1];
            }
            n1 !== (null == h1 ? void 0 : h1.index) && (a1 = A.nextNode(), n1++);
        }
        return s1;
    }
    m(t1) {
        var e1 = 0;
        for (var r1 of this.v)void 0 !== r1 && (void 0 !== r1.strings ? (r1._$AI(t1, r1, e1), e1 += r1.strings.length - 2) : r1._$AI(t1[e1])), e1++;
    }
}
class N {
    constructor(t1, e1, r1, i1){
        var s1;
        this.type = 2, this._$AH = w, this._$AN = void 0, this._$AA = t1, this._$AB = e1, this._$AM = r1, this.options = i1, this._$Cg = null === (s1 = null == i1 ? void 0 : i1.isConnected) || void 0 === s1 || s1;
    }
    get _$AU() {
        var t1, e1;
        return null !== (e1 = null === (t1 = this._$AM) || void 0 === t1 ? void 0 : t1._$AU) && void 0 !== e1 ? e1 : this._$Cg;
    }
    get parentNode() {
        var t1 = this._$AA.parentNode, e1 = this._$AM;
        return void 0 !== e1 && 11 === t1.nodeType && (t1 = e1.parentNode), t1;
    }
    get startNode() {
        return this._$AA;
    }
    get endNode() {
        return this._$AB;
    }
    _$AI(t1) {
        t1 = P(this, t1, arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : this), r$1(t1) ? t1 === w || null == t1 || "" === t1 ? (this._$AH !== w && this._$AR(), this._$AH = w) : t1 !== this._$AH && t1 !== b && this.$(t1) : void 0 !== t1._$litType$ ? this.T(t1) : void 0 !== t1.nodeType ? this.S(t1) : u(t1) ? this.A(t1) : this.$(t1);
    }
    M(t1) {
        var e1 = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : this._$AB;
        return this._$AA.parentNode.insertBefore(t1, e1);
    }
    S(t1) {
        this._$AH !== t1 && (this._$AR(), this._$AH = this.M(t1));
    }
    $(t1) {
        this._$AH !== w && r$1(this._$AH) ? this._$AA.nextSibling.data = t1 : this.S(l$2.createTextNode(t1)), this._$AH = t1;
    }
    T(t1) {
        var e1, { values: r1, _$litType$: i1 } = t1, s1 = "number" == typeof i1 ? this._$AC(t1) : (void 0 === i1.el && (i1.el = E.createElement(i1.h, this.options)), i1);
        if ((null === (e1 = this._$AH) || void 0 === e1 ? void 0 : e1._$AD) === s1) this._$AH.m(r1);
        else {
            var a1 = new V(s1, this), n1 = a1.p(this.options);
            a1.m(r1), this.S(n1), this._$AH = a1;
        }
    }
    _$AC(t1) {
        var e1 = T.get(t1.strings);
        return void 0 === e1 && T.set(t1.strings, e1 = new E(t1)), e1;
    }
    A(t1) {
        d(this._$AH) || (this._$AH = [], this._$AR());
        var e1, r1 = this._$AH, i1 = 0;
        for (var s1 of t1)i1 === r1.length ? r1.push(e1 = new N(this.M(h$1()), this.M(h$1()), this, this.options)) : e1 = r1[i1], e1._$AI(s1), i1++;
        i1 < r1.length && (this._$AR(e1 && e1._$AB.nextSibling, i1), r1.length = i1);
    }
    _$AR() {
        var t1, e1 = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : this._$AA.nextSibling, r1 = arguments.length > 1 ? arguments[1] : void 0;
        for(null === (t1 = this._$AP) || void 0 === t1 || t1.call(this, !1, !0, r1); e1 && e1 !== this._$AB;){
            var i1 = e1.nextSibling;
            e1.remove(), e1 = i1;
        }
    }
    setConnected(t1) {
        var e1;
        void 0 === this._$AM && (this._$Cg = t1, null === (e1 = this._$AP) || void 0 === e1 || e1.call(this, t1));
    }
}
class S {
    constructor(t1, e1, r1, i1, s1){
        this.type = 1, this._$AH = w, this._$AN = void 0, this.element = t1, this.name = e1, this._$AM = i1, this.options = s1, r1.length > 2 || "" !== r1[0] || "" !== r1[1] ? (this._$AH = Array(r1.length - 1).fill(new String), this.strings = r1) : this._$AH = w;
    }
    get tagName() {
        return this.element.tagName;
    }
    get _$AU() {
        return this._$AM._$AU;
    }
    _$AI(t1) {
        var e1 = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : this, r1 = arguments.length > 2 ? arguments[2] : void 0, i1 = arguments.length > 3 ? arguments[3] : void 0, s1 = this.strings, a1 = !1;
        if (void 0 === s1) t1 = P(this, t1, e1, 0), (a1 = !r$1(t1) || t1 !== this._$AH && t1 !== b) && (this._$AH = t1);
        else {
            var n1, o1, h1 = t1;
            for(t1 = s1[0], n1 = 0; n1 < s1.length - 1; n1++)(o1 = P(this, h1[r1 + n1], e1, n1)) === b && (o1 = this._$AH[n1]), a1 || (a1 = !r$1(o1) || o1 !== this._$AH[n1]), o1 === w ? t1 = w : t1 !== w && (t1 += (null != o1 ? o1 : "") + s1[n1 + 1]), this._$AH[n1] = o1;
        }
        a1 && !i1 && this.k(t1);
    }
    k(t1) {
        t1 === w ? this.element.removeAttribute(this.name) : this.element.setAttribute(this.name, null != t1 ? t1 : "");
    }
}
class M extends S {
    constructor(){
        super(...arguments), this.type = 3;
    }
    k(t1) {
        this.element[this.name] = t1 === w ? void 0 : t1;
    }
}
var k = i$2 ? i$2.emptyScript : "";
class H extends S {
    constructor(){
        super(...arguments), this.type = 4;
    }
    k(t1) {
        t1 && t1 !== w ? this.element.setAttribute(this.name, k) : this.element.removeAttribute(this.name);
    }
}
class I extends S {
    constructor(t1, e1, r1, i1, s1){
        super(t1, e1, r1, i1, s1), this.type = 5;
    }
    _$AI(t1) {
        var e1;
        if ((t1 = null !== (e1 = P(this, t1, arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : this, 0)) && void 0 !== e1 ? e1 : w) !== b) {
            var r1 = this._$AH, i1 = t1 === w && r1 !== w || t1.capture !== r1.capture || t1.once !== r1.once || t1.passive !== r1.passive, s1 = t1 !== w && (r1 === w || i1);
            i1 && this.element.removeEventListener(this.name, this, r1), s1 && this.element.addEventListener(this.name, this, t1), this._$AH = t1;
        }
    }
    handleEvent(t1) {
        var e1, r1;
        "function" == typeof this._$AH ? this._$AH.call(null !== (r1 = null === (e1 = this.options) || void 0 === e1 ? void 0 : e1.host) && void 0 !== r1 ? r1 : this.element, t1) : this._$AH.handleEvent(t1);
    }
}
class L {
    constructor(t1, e1, r1){
        this.element = t1, this.type = 6, this._$AN = void 0, this._$AM = e1, this.options = r1;
    }
    get _$AU() {
        return this._$AM._$AU;
    }
    _$AI(t1) {
        P(this, t1);
    }
}
var R = {
    P: "$lit$",
    V: e$6,
    L: o$3,
    I: 1,
    N: C,
    R: V,
    D: u,
    j: P,
    H: N,
    O: S,
    F: H,
    B: I,
    W: M,
    Z: L
}, z = window.litHtmlPolyfillSupport, l$1, o$2;
null == z || z(E, N), (null !== (t$2 = globalThis.litHtmlVersions) && void 0 !== t$2 ? t$2 : globalThis.litHtmlVersions = []).push("2.1.2");
var r = a$1;
class s extends a$1 {
    constructor(){
        super(...arguments), this.renderOptions = {
            host: this
        }, this._$Dt = void 0;
    }
    createRenderRoot() {
        var t1, e1, r1 = super.createRenderRoot();
        return null !== (t1 = (e1 = this.renderOptions).renderBefore) && void 0 !== t1 || (e1.renderBefore = r1.firstChild), r1;
    }
    update(t1) {
        var e1 = this.render();
        this.hasUpdated || (this.renderOptions.isConnected = this.isConnected), super.update(t1), this._$Dt = x(e1, this.renderRoot, this.renderOptions);
    }
    connectedCallback() {
        var t1;
        super.connectedCallback(), null === (t1 = this._$Dt) || void 0 === t1 || t1.setConnected(!0);
    }
    disconnectedCallback() {
        var t1;
        super.disconnectedCallback(), null === (t1 = this._$Dt) || void 0 === t1 || t1.setConnected(!1);
    }
    render() {
        return b;
    }
}
s.finalized = !0, s._$litElement$ = !0, null === (l$1 = globalThis.litElementHydrateSupport) || void 0 === l$1 || l$1.call(globalThis, {
    LitElement: s
});
var n$2 = globalThis.litElementPolyfillSupport;
null == n$2 || n$2({
    LitElement: s
});
var h = {
    _$AK: (t1, e1, r1)=>{
        t1._$AK(e1, r1);
    },
    _$AL: (t1)=>t1._$AL
};
(null !== (o$2 = globalThis.litElementVersions) && void 0 !== o$2 ? o$2 : globalThis.litElementVersions = []).push("3.1.2");
/**
 * @license
 * Copyright 2017 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */ var n$1 = (t1)=>(e1)=>"function" == typeof e1 ? ((t1, e1)=>(window.customElements.define(t1, e1), e1))(t1, e1) : ((t1, e1)=>{
            var { kind: r1, elements: i1 } = e1;
            return {
                kind: r1,
                elements: i1,
                finisher (e1) {
                    window.customElements.define(t1, e1);
                }
            };
        })(t1, e1), i$1 = (t1, e1)=>"method" === e1.kind && e1.descriptor && !("value" in e1.descriptor) ? _objectSpread2(_objectSpread2({}, e1), {}, {
        finisher (r1) {
            r1.createProperty(e1.key, t1);
        }
    }) : {
        kind: "field",
        key: Symbol(),
        placement: "own",
        descriptor: {},
        originalKey: e1.key,
        initializer () {
            "function" == typeof e1.initializer && (this[e1.key] = e1.initializer.call(this));
        },
        finisher (r1) {
            r1.createProperty(e1.key, t1);
        }
    };
function e$5(t1) {
    return (e1, r1)=>void 0 !== r1 ? ((t1, e1, r1)=>{
            e1.constructor.createProperty(r1, t1);
        })(t1, e1, r1) : i$1(t1, e1);
}
/**
 * @license
 * Copyright 2017 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */ function t$1(t1) {
    return e$5(_objectSpread2(_objectSpread2({}, t1), {}, {
        state: !0
    }));
}
/**
 * @license
 * Copyright 2017 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */ var e$4 = (t1, e1, r1)=>{
    Object.defineProperty(e1, r1, t1);
}, t = (t1, e1)=>({
        kind: "method",
        placement: "prototype",
        key: e1.key,
        descriptor: t1
    }), o$1 = (t1)=>{
    var { finisher: e1, descriptor: r1 } = t1;
    return (t1, i1)=>{
        var s1;
        if (void 0 === i1) {
            var a1 = null !== (s1 = t1.originalKey) && void 0 !== s1 ? s1 : t1.key, n1 = null != r1 ? {
                kind: "method",
                placement: "prototype",
                key: a1,
                descriptor: r1(t1.key)
            } : _objectSpread2(_objectSpread2({}, t1), {}, {
                key: a1
            });
            return null != e1 && (n1.finisher = function(t1) {
                e1(t1, a1);
            }), n1;
        }
        var o1 = t1.constructor;
        void 0 !== r1 && Object.defineProperty(t1, i1, r1(i1)), null == e1 || e1(o1, i1);
    };
}, n;
/**
 * @license
 * Copyright 2017 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */ function e$3(t1) {
    return o$1({
        finisher: (e1, r1)=>{
            Object.assign(e1.prototype[r1], t1);
        }
    });
}
/**
 * @license
 * Copyright 2017 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */ function i(t1, e1) {
    return o$1({
        descriptor: (r1)=>{
            var i1 = {
                get () {
                    var e1, r1;
                    return null !== (r1 = null === (e1 = this.renderRoot) || void 0 === e1 ? void 0 : e1.querySelector(t1)) && void 0 !== r1 ? r1 : null;
                },
                enumerable: !0,
                configurable: !0
            };
            if (e1) {
                var s1 = "symbol" == typeof r1 ? Symbol() : "__" + r1;
                i1.get = function() {
                    var e1, r1;
                    return void 0 === this[s1] && (this[s1] = null !== (r1 = null === (e1 = this.renderRoot) || void 0 === e1 ? void 0 : e1.querySelector(t1)) && void 0 !== r1 ? r1 : null), this[s1];
                };
            }
            return i1;
        }
    });
}
/**
 * @license
 * Copyright 2017 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */ function e$2(t1) {
    return o$1({
        descriptor: (e1)=>({
                get () {
                    var e1, r1;
                    return null !== (r1 = null === (e1 = this.renderRoot) || void 0 === e1 ? void 0 : e1.querySelectorAll(t1)) && void 0 !== r1 ? r1 : [];
                },
                enumerable: !0,
                configurable: !0
            })
    });
}
/**
 * @license
 * Copyright 2017 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */ function e$1(t1) {
    return o$1({
        descriptor: (e1)=>({
                get () {
                    var e1 = this;
                    return _asyncToGenerator(function*() {
                        var r1;
                        return yield e1.updateComplete, null === (r1 = e1.renderRoot) || void 0 === r1 ? void 0 : r1.querySelector(t1);
                    })();
                },
                enumerable: !0,
                configurable: !0
            })
    });
}
/**
 * @license
 * Copyright 2021 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */ var e = null != (null === (n = window.HTMLSlotElement) || void 0 === n ? void 0 : n.prototype.assignedElements) ? (t1, e1)=>t1.assignedElements(e1) : (t1, e1)=>t1.assignedNodes(e1).filter((t1)=>t1.nodeType === Node.ELEMENT_NODE);
function l(t1) {
    var { slot: r1, selector: i1 } = null != t1 ? t1 : {};
    return o$1({
        descriptor: (s1)=>({
                get () {
                    var s1, a1 = "slot" + (r1 ? "[name=".concat(r1, "]") : ":not([name])"), n1 = null === (s1 = this.renderRoot) || void 0 === s1 ? void 0 : s1.querySelector(a1), o1 = null != n1 ? e(n1, t1) : [];
                    return i1 ? o1.filter((t1)=>t1.matches(i1)) : o1;
                },
                enumerable: !0,
                configurable: !0
            })
    });
}
/**
 * @license
 * Copyright 2017 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */ function o(t1, e1, r1) {
    var i1, s1 = t1;
    return "object" == typeof t1 ? (s1 = t1.slot, i1 = t1) : i1 = {
        flatten: e1
    }, r1 ? l({
        slot: s1,
        flatten: e1,
        selector: r1
    }) : o$1({
        descriptor: (t1)=>({
                get () {
                    var t1, e1, r1 = "slot" + (s1 ? "[name=".concat(s1, "]") : ":not([name])"), a1 = null === (t1 = this.renderRoot) || void 0 === t1 ? void 0 : t1.querySelector(r1);
                    return null !== (e1 = null == a1 ? void 0 : a1.assignedNodes(i1)) && void 0 !== e1 ? e1 : [];
                },
                enumerable: !0,
                configurable: !0
            })
    });
}
var commonjsGlobal = "undefined" != typeof globalThis ? globalThis : "undefined" != typeof window ? window : "undefined" != typeof global ? global : "undefined" != typeof self ? self : {};
function getDefaultExportFromCjs(t1) {
    return t1 && t1.__esModule && Object.prototype.hasOwnProperty.call(t1, "default") ? t1.default : t1;
}
function getDefaultExportFromNamespaceIfPresent(t1) {
    return t1 && Object.prototype.hasOwnProperty.call(t1, "default") ? t1.default : t1;
}
function getDefaultExportFromNamespaceIfNotNamed(t1) {
    return t1 && Object.prototype.hasOwnProperty.call(t1, "default") && 1 === Object.keys(t1).length ? t1.default : t1;
}
function getAugmentedNamespace(t1) {
    if (t1.__esModule) return t1;
    var e1 = Object.defineProperty({}, "__esModule", {
        value: !0
    });
    return Object.keys(t1).forEach(function(r1) {
        var i1 = Object.getOwnPropertyDescriptor(t1, r1);
        Object.defineProperty(e1, r1, i1.get ? i1 : {
            enumerable: !0,
            get: function() {
                return t1[r1];
            }
        });
    }), e1;
}
function commonjsRequire(t1) {
    throw new Error('Could not dynamically require "' + t1 + '". Please configure the dynamicRequireTargets or/and ignoreDynamicRequires option of @rollup/plugin-commonjs appropriately for this require call to work.');
}
var lottie$1 = {
    exports: {}
};
(function(module, exports) {
    var factory;
    "undefined" != typeof navigator && (factory = function() {
        var svgNS = "http://www.w3.org/2000/svg", locationHref = "", _useWebWorker = !1, initialDefaultFrame = -999999, setWebWorker = function(t1) {
            _useWebWorker = !!t1;
        }, getWebWorker = function() {
            return _useWebWorker;
        }, setLocationHref = function(t1) {
            locationHref = t1;
        }, getLocationHref = function() {
            return locationHref;
        };
        function createTag(t1) {
            return document.createElement(t1);
        }
        function extendPrototype(t1, e1) {
            var r1, i1, s1 = t1.length;
            for(r1 = 0; r1 < s1; r1 += 1)for(var a1 in i1 = t1[r1].prototype)Object.prototype.hasOwnProperty.call(i1, a1) && (e1.prototype[a1] = i1[a1]);
        }
        function getDescriptor(t1, e1) {
            return Object.getOwnPropertyDescriptor(t1, e1);
        }
        function createProxyFunction(t1) {
            function e1() {}
            return e1.prototype = t1, e1;
        }
        var audioControllerFactory = function() {
            function t1(t1) {
                this.audios = [], this.audioFactory = t1, this._volume = 1, this._isMuted = !1;
            }
            return t1.prototype = {
                addAudio: function(t1) {
                    this.audios.push(t1);
                },
                pause: function() {
                    var t1, e1 = this.audios.length;
                    for(t1 = 0; t1 < e1; t1 += 1)this.audios[t1].pause();
                },
                resume: function() {
                    var t1, e1 = this.audios.length;
                    for(t1 = 0; t1 < e1; t1 += 1)this.audios[t1].resume();
                },
                setRate: function(t1) {
                    var e1, r1 = this.audios.length;
                    for(e1 = 0; e1 < r1; e1 += 1)this.audios[e1].setRate(t1);
                },
                createAudio: function(t1) {
                    return this.audioFactory ? this.audioFactory(t1) : window.Howl ? new window.Howl({
                        src: [
                            t1
                        ]
                    }) : {
                        isPlaying: !1,
                        play: function() {
                            this.isPlaying = !0;
                        },
                        seek: function() {
                            this.isPlaying = !1;
                        },
                        playing: function() {},
                        rate: function() {},
                        setVolume: function() {}
                    };
                },
                setAudioFactory: function(t1) {
                    this.audioFactory = t1;
                },
                setVolume: function(t1) {
                    this._volume = t1, this._updateVolume();
                },
                mute: function() {
                    this._isMuted = !0, this._updateVolume();
                },
                unmute: function() {
                    this._isMuted = !1, this._updateVolume();
                },
                getVolume: function() {
                    return this._volume;
                },
                _updateVolume: function() {
                    var t1, e1 = this.audios.length;
                    for(t1 = 0; t1 < e1; t1 += 1)this.audios[t1].volume(this._volume * (this._isMuted ? 0 : 1));
                }
            }, function() {
                return new t1;
            };
        }(), createTypedArray = function() {
            function t1(t1, e1) {
                var r1, i1 = 0, s1 = [];
                switch(t1){
                    case "int16":
                    case "uint8c":
                        r1 = 1;
                        break;
                    default:
                        r1 = 1.1;
                }
                for(i1 = 0; i1 < e1; i1 += 1)s1.push(r1);
                return s1;
            }
            return "function" == typeof Uint8ClampedArray && "function" == typeof Float32Array ? function(e1, r1) {
                return "float32" === e1 ? new Float32Array(r1) : "int16" === e1 ? new Int16Array(r1) : "uint8c" === e1 ? new Uint8ClampedArray(r1) : t1(e1, r1);
            } : t1;
        }();
        function createSizedArray(t1) {
            return Array.apply(null, {
                length: t1
            });
        }
        function _typeof$6(t1) {
            return _typeof$6 = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(t1) {
                return typeof t1;
            } : function(t1) {
                return t1 && "function" == typeof Symbol && t1.constructor === Symbol && t1 !== Symbol.prototype ? "symbol" : typeof t1;
            }, _typeof$6(t1);
        }
        var subframeEnabled = !0, expressionsPlugin = null, expressionsInterfaces = null, idPrefix$1 = "", isSafari = /^((?!chrome|android).)*safari/i.test(navigator.userAgent), _shouldRoundValues = !1, bmPow = Math.pow, bmSqrt = Math.sqrt, bmFloor = Math.floor, bmMax = Math.max, bmMin = Math.min, BMMath = {};
        function ProjectInterface$1() {
            return {};
        }
        !function() {
            var t1, e1 = [
                "abs",
                "acos",
                "acosh",
                "asin",
                "asinh",
                "atan",
                "atanh",
                "atan2",
                "ceil",
                "cbrt",
                "expm1",
                "clz32",
                "cos",
                "cosh",
                "exp",
                "floor",
                "fround",
                "hypot",
                "imul",
                "log",
                "log1p",
                "log2",
                "log10",
                "max",
                "min",
                "pow",
                "random",
                "round",
                "sign",
                "sin",
                "sinh",
                "sqrt",
                "tan",
                "tanh",
                "trunc",
                "E",
                "LN10",
                "LN2",
                "LOG10E",
                "LOG2E",
                "PI",
                "SQRT1_2",
                "SQRT2"
            ], r1 = e1.length;
            for(t1 = 0; t1 < r1; t1 += 1)BMMath[e1[t1]] = Math[e1[t1]];
        }(), BMMath.random = Math.random, BMMath.abs = function(t1) {
            if ("object" === _typeof$6(t1) && t1.length) {
                var e1, r1 = createSizedArray(t1.length), i1 = t1.length;
                for(e1 = 0; e1 < i1; e1 += 1)r1[e1] = Math.abs(t1[e1]);
                return r1;
            }
            return Math.abs(t1);
        };
        var defaultCurveSegments = 150, degToRads = Math.PI / 180, roundCorner = .5519;
        function roundValues(t1) {
            _shouldRoundValues = !!t1;
        }
        function bmRnd(t1) {
            return _shouldRoundValues ? Math.round(t1) : t1;
        }
        function styleDiv(t1) {
            t1.style.position = "absolute", t1.style.top = 0, t1.style.left = 0, t1.style.display = "block", t1.style.transformOrigin = "0 0", t1.style.webkitTransformOrigin = "0 0", t1.style.backfaceVisibility = "visible", t1.style.webkitBackfaceVisibility = "visible", t1.style.transformStyle = "preserve-3d", t1.style.webkitTransformStyle = "preserve-3d", t1.style.mozTransformStyle = "preserve-3d";
        }
        function BMEnterFrameEvent(t1, e1, r1, i1) {
            this.type = t1, this.currentTime = e1, this.totalTime = r1, this.direction = i1 < 0 ? -1 : 1;
        }
        function BMCompleteEvent(t1, e1) {
            this.type = t1, this.direction = e1 < 0 ? -1 : 1;
        }
        function BMCompleteLoopEvent(t1, e1, r1, i1) {
            this.type = t1, this.currentLoop = r1, this.totalLoops = e1, this.direction = i1 < 0 ? -1 : 1;
        }
        function BMSegmentStartEvent(t1, e1, r1) {
            this.type = t1, this.firstFrame = e1, this.totalFrames = r1;
        }
        function BMDestroyEvent(t1, e1) {
            this.type = t1, this.target = e1;
        }
        function BMRenderFrameErrorEvent(t1, e1) {
            this.type = "renderFrameError", this.nativeError = t1, this.currentTime = e1;
        }
        function BMConfigErrorEvent(t1) {
            this.type = "configError", this.nativeError = t1;
        }
        function BMAnimationConfigErrorEvent(t1, e1) {
            this.type = t1, this.nativeError = e1;
        }
        var createElementID = (_count = 0, function() {
            return idPrefix$1 + "__lottie_element_" + (_count += 1);
        }), _count;
        function HSVtoRGB(t1, e1, r1) {
            var i1, s1, a1, n1, o1, h1, l1, p1;
            switch(h1 = r1 * (1 - e1), l1 = r1 * (1 - (o1 = 6 * t1 - (n1 = Math.floor(6 * t1))) * e1), p1 = r1 * (1 - (1 - o1) * e1), n1 % 6){
                case 0:
                    i1 = r1, s1 = p1, a1 = h1;
                    break;
                case 1:
                    i1 = l1, s1 = r1, a1 = h1;
                    break;
                case 2:
                    i1 = h1, s1 = r1, a1 = p1;
                    break;
                case 3:
                    i1 = h1, s1 = l1, a1 = r1;
                    break;
                case 4:
                    i1 = p1, s1 = h1, a1 = r1;
                    break;
                case 5:
                    i1 = r1, s1 = h1, a1 = l1;
            }
            return [
                i1,
                s1,
                a1
            ];
        }
        function RGBtoHSV(t1, e1, r1) {
            var i1, s1 = Math.max(t1, e1, r1), a1 = Math.min(t1, e1, r1), n1 = s1 - a1, o1 = 0 === s1 ? 0 : n1 / s1, h1 = s1 / 255;
            switch(s1){
                case a1:
                    i1 = 0;
                    break;
                case t1:
                    i1 = e1 - r1 + n1 * (e1 < r1 ? 6 : 0), i1 /= 6 * n1;
                    break;
                case e1:
                    i1 = r1 - t1 + 2 * n1, i1 /= 6 * n1;
                    break;
                case r1:
                    i1 = t1 - e1 + 4 * n1, i1 /= 6 * n1;
            }
            return [
                i1,
                o1,
                h1
            ];
        }
        function addSaturationToRGB(t1, e1) {
            var r1 = RGBtoHSV(255 * t1[0], 255 * t1[1], 255 * t1[2]);
            return r1[1] += e1, r1[1] > 1 ? r1[1] = 1 : r1[1] <= 0 && (r1[1] = 0), HSVtoRGB(r1[0], r1[1], r1[2]);
        }
        function addBrightnessToRGB(t1, e1) {
            var r1 = RGBtoHSV(255 * t1[0], 255 * t1[1], 255 * t1[2]);
            return r1[2] += e1, r1[2] > 1 ? r1[2] = 1 : r1[2] < 0 && (r1[2] = 0), HSVtoRGB(r1[0], r1[1], r1[2]);
        }
        function addHueToRGB(t1, e1) {
            var r1 = RGBtoHSV(255 * t1[0], 255 * t1[1], 255 * t1[2]);
            return r1[0] += e1 / 360, r1[0] > 1 ? r1[0] -= 1 : r1[0] < 0 && (r1[0] += 1), HSVtoRGB(r1[0], r1[1], r1[2]);
        }
        var rgbToHex = function() {
            var t1, e1, r1 = [];
            for(t1 = 0; t1 < 256; t1 += 1)e1 = t1.toString(16), r1[t1] = 1 === e1.length ? "0" + e1 : e1;
            return function(t1, e1, i1) {
                return t1 < 0 && (t1 = 0), e1 < 0 && (e1 = 0), i1 < 0 && (i1 = 0), "#" + r1[t1] + r1[e1] + r1[i1];
            };
        }(), setSubframeEnabled = function(t1) {
            subframeEnabled = !!t1;
        }, getSubframeEnabled = function() {
            return subframeEnabled;
        }, setExpressionsPlugin = function(t1) {
            expressionsPlugin = t1;
        }, getExpressionsPlugin = function() {
            return expressionsPlugin;
        }, setExpressionInterfaces = function(t1) {
            expressionsInterfaces = t1;
        }, getExpressionInterfaces = function() {
            return expressionsInterfaces;
        }, setDefaultCurveSegments = function(t1) {
            defaultCurveSegments = t1;
        }, getDefaultCurveSegments = function() {
            return defaultCurveSegments;
        }, setIdPrefix = function(t1) {
            idPrefix$1 = t1;
        }, getIdPrefix = function() {
            return idPrefix$1;
        };
        function createNS(t1) {
            return document.createElementNS(svgNS, t1);
        }
        function _typeof$5(t1) {
            return _typeof$5 = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(t1) {
                return typeof t1;
            } : function(t1) {
                return t1 && "function" == typeof Symbol && t1.constructor === Symbol && t1 !== Symbol.prototype ? "symbol" : typeof t1;
            }, _typeof$5(t1);
        }
        var dataManager = function() {
            var t1, e1, r1 = 1, i1 = [], s1 = {
                onmessage: function() {},
                postMessage: function(e1) {
                    t1({
                        data: e1
                    });
                }
            }, _workerSelf1 = {
                postMessage: function(t1) {
                    s1.onmessage({
                        data: t1
                    });
                }
            };
            function a1() {
                e1 || (e1 = function(e1) {
                    if (window.Worker && window.Blob && getWebWorker()) {
                        var r1 = new Blob([
                            "var _workerSelf = self; self.onmessage = ",
                            e1.toString()
                        ], {
                            type: "text/javascript"
                        }), i1 = URL.createObjectURL(r1);
                        return new Worker(i1);
                    }
                    return t1 = e1, s1;
                }(function(t1) {
                    if (_workerSelf1.dataManager || (_workerSelf1.dataManager = function() {
                        function t1(s1, a1) {
                            var n1, o1, h1, l1, p1, f1, d1 = s1.length;
                            for(o1 = 0; o1 < d1; o1 += 1)if ("ks" in (n1 = s1[o1]) && !n1.completed) {
                                if (n1.completed = !0, n1.hasMask) {
                                    var u1 = n1.masksProperties;
                                    for(l1 = u1.length, h1 = 0; h1 < l1; h1 += 1)if (u1[h1].pt.k.i) i1(u1[h1].pt.k);
                                    else for(f1 = u1[h1].pt.k.length, p1 = 0; p1 < f1; p1 += 1)u1[h1].pt.k[p1].s && i1(u1[h1].pt.k[p1].s[0]), u1[h1].pt.k[p1].e && i1(u1[h1].pt.k[p1].e[0]);
                                }
                                0 === n1.ty ? (n1.layers = e1(n1.refId, a1), t1(n1.layers, a1)) : 4 === n1.ty ? r1(n1.shapes) : 5 === n1.ty && c1(n1);
                            }
                        }
                        function e1(t1, e1) {
                            var r1 = function(t1, e1) {
                                for(var r1 = 0, i1 = e1.length; r1 < i1;){
                                    if (e1[r1].id === t1) return e1[r1];
                                    r1 += 1;
                                }
                                return null;
                            }(t1, e1);
                            return r1 ? r1.layers.__used ? JSON.parse(JSON.stringify(r1.layers)) : (r1.layers.__used = !0, r1.layers) : null;
                        }
                        function r1(t1) {
                            var e1, s1, a1;
                            for(e1 = t1.length - 1; e1 >= 0; e1 -= 1)if ("sh" === t1[e1].ty) {
                                if (t1[e1].ks.k.i) i1(t1[e1].ks.k);
                                else for(a1 = t1[e1].ks.k.length, s1 = 0; s1 < a1; s1 += 1)t1[e1].ks.k[s1].s && i1(t1[e1].ks.k[s1].s[0]), t1[e1].ks.k[s1].e && i1(t1[e1].ks.k[s1].e[0]);
                            } else "gr" === t1[e1].ty && r1(t1[e1].it);
                        }
                        function i1(t1) {
                            var e1, r1 = t1.i.length;
                            for(e1 = 0; e1 < r1; e1 += 1)t1.i[e1][0] += t1.v[e1][0], t1.i[e1][1] += t1.v[e1][1], t1.o[e1][0] += t1.v[e1][0], t1.o[e1][1] += t1.v[e1][1];
                        }
                        function s1(t1, e1) {
                            var r1 = e1 ? e1.split(".") : [
                                100,
                                100,
                                100
                            ];
                            return t1[0] > r1[0] || !(r1[0] > t1[0]) && (t1[1] > r1[1] || !(r1[1] > t1[1]) && (t1[2] > r1[2] || !(r1[2] > t1[2]) && null));
                        }
                        var a1, n1 = function() {
                            var t1 = [
                                4,
                                4,
                                14
                            ];
                            function e1(t1) {
                                var e1, r1, i1, s1 = t1.length;
                                for(e1 = 0; e1 < s1; e1 += 1)5 === t1[e1].ty && (i1 = void 0, i1 = (r1 = t1[e1]).t.d, r1.t.d = {
                                    k: [
                                        {
                                            s: i1,
                                            t: 0
                                        }
                                    ]
                                });
                            }
                            return function(r1) {
                                if (s1(t1, r1.v) && (e1(r1.layers), r1.assets)) {
                                    var i1, a1 = r1.assets.length;
                                    for(i1 = 0; i1 < a1; i1 += 1)r1.assets[i1].layers && e1(r1.assets[i1].layers);
                                }
                            };
                        }(), o1 = (a1 = [
                            4,
                            7,
                            99
                        ], function(t1) {
                            if (t1.chars && !s1(a1, t1.v)) {
                                var e1, i1 = t1.chars.length;
                                for(e1 = 0; e1 < i1; e1 += 1){
                                    var n1 = t1.chars[e1];
                                    n1.data && n1.data.shapes && (r1(n1.data.shapes), n1.data.ip = 0, n1.data.op = 99999, n1.data.st = 0, n1.data.sr = 1, n1.data.ks = {
                                        p: {
                                            k: [
                                                0,
                                                0
                                            ],
                                            a: 0
                                        },
                                        s: {
                                            k: [
                                                100,
                                                100
                                            ],
                                            a: 0
                                        },
                                        a: {
                                            k: [
                                                0,
                                                0
                                            ],
                                            a: 0
                                        },
                                        r: {
                                            k: 0,
                                            a: 0
                                        },
                                        o: {
                                            k: 100,
                                            a: 0
                                        }
                                    }, t1.chars[e1].t || (n1.data.shapes.push({
                                        ty: "no"
                                    }), n1.data.shapes[0].it.push({
                                        p: {
                                            k: [
                                                0,
                                                0
                                            ],
                                            a: 0
                                        },
                                        s: {
                                            k: [
                                                100,
                                                100
                                            ],
                                            a: 0
                                        },
                                        a: {
                                            k: [
                                                0,
                                                0
                                            ],
                                            a: 0
                                        },
                                        r: {
                                            k: 0,
                                            a: 0
                                        },
                                        o: {
                                            k: 100,
                                            a: 0
                                        },
                                        sk: {
                                            k: 0,
                                            a: 0
                                        },
                                        sa: {
                                            k: 0,
                                            a: 0
                                        },
                                        ty: "tr"
                                    })));
                                }
                            }
                        }), h1 = function() {
                            var t1 = [
                                5,
                                7,
                                15
                            ];
                            function e1(t1) {
                                var e1, r1, i1 = t1.length;
                                for(e1 = 0; e1 < i1; e1 += 1)5 === t1[e1].ty && (r1 = void 0, "number" == typeof (r1 = t1[e1].t.p).a && (r1.a = {
                                    a: 0,
                                    k: r1.a
                                }), "number" == typeof r1.p && (r1.p = {
                                    a: 0,
                                    k: r1.p
                                }), "number" == typeof r1.r && (r1.r = {
                                    a: 0,
                                    k: r1.r
                                }));
                            }
                            return function(r1) {
                                if (s1(t1, r1.v) && (e1(r1.layers), r1.assets)) {
                                    var i1, a1 = r1.assets.length;
                                    for(i1 = 0; i1 < a1; i1 += 1)r1.assets[i1].layers && e1(r1.assets[i1].layers);
                                }
                            };
                        }(), l1 = function() {
                            var t1 = [
                                4,
                                1,
                                9
                            ];
                            function e1(t1) {
                                var r1, i1, s1, a1 = t1.length;
                                for(r1 = 0; r1 < a1; r1 += 1)if ("gr" === t1[r1].ty) e1(t1[r1].it);
                                else if ("fl" === t1[r1].ty || "st" === t1[r1].ty) {
                                    if (t1[r1].c.k && t1[r1].c.k[0].i) for(s1 = t1[r1].c.k.length, i1 = 0; i1 < s1; i1 += 1)t1[r1].c.k[i1].s && (t1[r1].c.k[i1].s[0] /= 255, t1[r1].c.k[i1].s[1] /= 255, t1[r1].c.k[i1].s[2] /= 255, t1[r1].c.k[i1].s[3] /= 255), t1[r1].c.k[i1].e && (t1[r1].c.k[i1].e[0] /= 255, t1[r1].c.k[i1].e[1] /= 255, t1[r1].c.k[i1].e[2] /= 255, t1[r1].c.k[i1].e[3] /= 255);
                                    else t1[r1].c.k[0] /= 255, t1[r1].c.k[1] /= 255, t1[r1].c.k[2] /= 255, t1[r1].c.k[3] /= 255;
                                }
                            }
                            function r1(t1) {
                                var r1, i1 = t1.length;
                                for(r1 = 0; r1 < i1; r1 += 1)4 === t1[r1].ty && e1(t1[r1].shapes);
                            }
                            return function(e1) {
                                if (s1(t1, e1.v) && (r1(e1.layers), e1.assets)) {
                                    var i1, a1 = e1.assets.length;
                                    for(i1 = 0; i1 < a1; i1 += 1)e1.assets[i1].layers && r1(e1.assets[i1].layers);
                                }
                            };
                        }(), p1 = function() {
                            var t1 = [
                                4,
                                4,
                                18
                            ];
                            function e1(t1) {
                                var r1, i1, s1;
                                for(r1 = t1.length - 1; r1 >= 0; r1 -= 1)if ("sh" === t1[r1].ty) {
                                    if (t1[r1].ks.k.i) t1[r1].ks.k.c = t1[r1].closed;
                                    else for(s1 = t1[r1].ks.k.length, i1 = 0; i1 < s1; i1 += 1)t1[r1].ks.k[i1].s && (t1[r1].ks.k[i1].s[0].c = t1[r1].closed), t1[r1].ks.k[i1].e && (t1[r1].ks.k[i1].e[0].c = t1[r1].closed);
                                } else "gr" === t1[r1].ty && e1(t1[r1].it);
                            }
                            function r1(t1) {
                                var r1, i1, s1, a1, n1, o1, h1 = t1.length;
                                for(i1 = 0; i1 < h1; i1 += 1){
                                    if ((r1 = t1[i1]).hasMask) {
                                        var l1 = r1.masksProperties;
                                        for(a1 = l1.length, s1 = 0; s1 < a1; s1 += 1)if (l1[s1].pt.k.i) l1[s1].pt.k.c = l1[s1].cl;
                                        else for(o1 = l1[s1].pt.k.length, n1 = 0; n1 < o1; n1 += 1)l1[s1].pt.k[n1].s && (l1[s1].pt.k[n1].s[0].c = l1[s1].cl), l1[s1].pt.k[n1].e && (l1[s1].pt.k[n1].e[0].c = l1[s1].cl);
                                    }
                                    4 === r1.ty && e1(r1.shapes);
                                }
                            }
                            return function(e1) {
                                if (s1(t1, e1.v) && (r1(e1.layers), e1.assets)) {
                                    var i1, a1 = e1.assets.length;
                                    for(i1 = 0; i1 < a1; i1 += 1)e1.assets[i1].layers && r1(e1.assets[i1].layers);
                                }
                            };
                        }();
                        function c1(t1) {
                            0 === t1.t.a.length && t1.t.p;
                        }
                        var f1 = {
                            completeData: function(r1) {
                                r1.__complete || (l1(r1), n1(r1), o1(r1), h1(r1), p1(r1), t1(r1.layers, r1.assets), function(r1, i1) {
                                    if (r1) {
                                        var s1 = 0, a1 = r1.length;
                                        for(s1 = 0; s1 < a1; s1 += 1)1 === r1[s1].t && (r1[s1].data.layers = e1(r1[s1].data.refId, i1), t1(r1[s1].data.layers, i1));
                                    }
                                }(r1.chars, r1.assets), r1.__complete = !0);
                            }
                        };
                        return f1.checkColors = l1, f1.checkChars = o1, f1.checkPathProperties = h1, f1.checkShapes = p1, f1.completeLayers = t1, f1;
                    }()), _workerSelf1.assetLoader || (_workerSelf1.assetLoader = function() {
                        function t1(t1) {
                            var e1 = t1.getResponseHeader("content-type");
                            return e1 && "json" === t1.responseType && -1 !== e1.indexOf("json") || t1.response && "object" === _typeof$5(t1.response) ? t1.response : t1.response && "string" == typeof t1.response ? JSON.parse(t1.response) : t1.responseText ? JSON.parse(t1.responseText) : null;
                        }
                        return {
                            load: function(e1, r1, i1, s1) {
                                var a1, n1 = new XMLHttpRequest;
                                try {
                                    n1.responseType = "json";
                                } catch (t1) {}
                                n1.onreadystatechange = function() {
                                    if (4 === n1.readyState) {
                                        if (200 === n1.status) a1 = t1(n1), i1(a1);
                                        else try {
                                            a1 = t1(n1), i1(a1);
                                        } catch (t1) {
                                            s1 && s1(t1);
                                        }
                                    }
                                };
                                try {
                                    n1.open([
                                        "G",
                                        "E",
                                        "T"
                                    ].join(""), e1, !0);
                                } catch (t1) {
                                    n1.open([
                                        "G",
                                        "E",
                                        "T"
                                    ].join(""), r1 + "/" + e1, !0);
                                }
                                n1.send();
                            }
                        };
                    }()), "loadAnimation" === t1.data.type) _workerSelf1.assetLoader.load(t1.data.path, t1.data.fullPath, function(e1) {
                        _workerSelf1.dataManager.completeData(e1), _workerSelf1.postMessage({
                            id: t1.data.id,
                            payload: e1,
                            status: "success"
                        });
                    }, function() {
                        _workerSelf1.postMessage({
                            id: t1.data.id,
                            status: "error"
                        });
                    });
                    else if ("complete" === t1.data.type) {
                        var e1 = t1.data.animation;
                        _workerSelf1.dataManager.completeData(e1), _workerSelf1.postMessage({
                            id: t1.data.id,
                            payload: e1,
                            status: "success"
                        });
                    } else "loadData" === t1.data.type && _workerSelf1.assetLoader.load(t1.data.path, t1.data.fullPath, function(e1) {
                        _workerSelf1.postMessage({
                            id: t1.data.id,
                            payload: e1,
                            status: "success"
                        });
                    }, function() {
                        _workerSelf1.postMessage({
                            id: t1.data.id,
                            status: "error"
                        });
                    });
                }), e1.onmessage = function(t1) {
                    var e1 = t1.data, r1 = e1.id, s1 = i1[r1];
                    i1[r1] = null, "success" === e1.status ? s1.onComplete(e1.payload) : s1.onError && s1.onError();
                });
            }
            function n1(t1, e1) {
                var s1 = "processId_" + (r1 += 1);
                return i1[s1] = {
                    onComplete: t1,
                    onError: e1
                }, s1;
            }
            return {
                loadAnimation: function(t1, r1, i1) {
                    a1();
                    var s1 = n1(r1, i1);
                    e1.postMessage({
                        type: "loadAnimation",
                        path: t1,
                        fullPath: window.location.origin + window.location.pathname,
                        id: s1
                    });
                },
                loadData: function(t1, r1, i1) {
                    a1();
                    var s1 = n1(r1, i1);
                    e1.postMessage({
                        type: "loadData",
                        path: t1,
                        fullPath: window.location.origin + window.location.pathname,
                        id: s1
                    });
                },
                completeAnimation: function(t1, r1, i1) {
                    a1();
                    var s1 = n1(r1, i1);
                    e1.postMessage({
                        type: "complete",
                        animation: t1,
                        id: s1
                    });
                }
            };
        }(), ImagePreloader = function() {
            var t1 = function() {
                var t1 = createTag("canvas");
                t1.width = 1, t1.height = 1;
                var e1 = t1.getContext("2d");
                return e1.fillStyle = "rgba(0,0,0,0)", e1.fillRect(0, 0, 1, 1), t1;
            }();
            function e1() {
                this.loadedAssets += 1, this.loadedAssets === this.totalImages && this.loadedFootagesCount === this.totalFootages && this.imagesLoadedCb && this.imagesLoadedCb(null);
            }
            function r1() {
                this.loadedFootagesCount += 1, this.loadedAssets === this.totalImages && this.loadedFootagesCount === this.totalFootages && this.imagesLoadedCb && this.imagesLoadedCb(null);
            }
            function i1(t1, e1, r1) {
                var i1 = "";
                if (t1.e) i1 = t1.p;
                else if (e1) {
                    var s1 = t1.p;
                    -1 !== s1.indexOf("images/") && (s1 = s1.split("/")[1]), i1 = e1 + s1;
                } else i1 = r1, i1 += t1.u ? t1.u : "", i1 += t1.p;
                return i1;
            }
            function s1(t1) {
                var e1 = 0, r1 = setInterval((function() {
                    (t1.getBBox().width || e1 > 500) && (this._imageLoaded(), clearInterval(r1)), e1 += 1;
                }).bind(this), 50);
            }
            function a1(t1) {
                var e1 = {
                    assetData: t1
                }, r1 = i1(t1, this.assetsPath, this.path);
                return dataManager.loadData(r1, (function(t1) {
                    e1.img = t1, this._footageLoaded();
                }).bind(this), (function() {
                    e1.img = {}, this._footageLoaded();
                }).bind(this)), e1;
            }
            function n1() {
                this._imageLoaded = e1.bind(this), this._footageLoaded = r1.bind(this), this.testImageLoaded = s1.bind(this), this.createFootageData = a1.bind(this), this.assetsPath = "", this.path = "", this.totalImages = 0, this.totalFootages = 0, this.loadedAssets = 0, this.loadedFootagesCount = 0, this.imagesLoadedCb = null, this.images = [];
            }
            return n1.prototype = {
                loadAssets: function(t1, e1) {
                    var r1;
                    this.imagesLoadedCb = e1;
                    var i1 = t1.length;
                    for(r1 = 0; r1 < i1; r1 += 1)t1[r1].layers || (t1[r1].t && "seq" !== t1[r1].t ? 3 === t1[r1].t && (this.totalFootages += 1, this.images.push(this.createFootageData(t1[r1]))) : (this.totalImages += 1, this.images.push(this._createImageData(t1[r1]))));
                },
                setAssetsPath: function(t1) {
                    this.assetsPath = t1 || "";
                },
                setPath: function(t1) {
                    this.path = t1 || "";
                },
                loadedImages: function() {
                    return this.totalImages === this.loadedAssets;
                },
                loadedFootages: function() {
                    return this.totalFootages === this.loadedFootagesCount;
                },
                destroy: function() {
                    this.imagesLoadedCb = null, this.images.length = 0;
                },
                getAsset: function(t1) {
                    for(var e1 = 0, r1 = this.images.length; e1 < r1;){
                        if (this.images[e1].assetData === t1) return this.images[e1].img;
                        e1 += 1;
                    }
                    return null;
                },
                createImgData: function(e1) {
                    var r1 = i1(e1, this.assetsPath, this.path), s1 = createTag("img");
                    s1.crossOrigin = "anonymous", s1.addEventListener("load", this._imageLoaded, !1), s1.addEventListener("error", (function() {
                        a1.img = t1, this._imageLoaded();
                    }).bind(this), !1), s1.src = r1;
                    var a1 = {
                        img: s1,
                        assetData: e1
                    };
                    return a1;
                },
                createImageData: function(e1) {
                    var r1 = i1(e1, this.assetsPath, this.path), s1 = createNS("image");
                    isSafari ? this.testImageLoaded(s1) : s1.addEventListener("load", this._imageLoaded, !1), s1.addEventListener("error", (function() {
                        a1.img = t1, this._imageLoaded();
                    }).bind(this), !1), s1.setAttributeNS("http://www.w3.org/1999/xlink", "href", r1), this._elementHelper.append ? this._elementHelper.append(s1) : this._elementHelper.appendChild(s1);
                    var a1 = {
                        img: s1,
                        assetData: e1
                    };
                    return a1;
                },
                imageLoaded: e1,
                footageLoaded: r1,
                setCacheType: function(t1, e1) {
                    "svg" === t1 ? (this._elementHelper = e1, this._createImageData = this.createImageData.bind(this)) : this._createImageData = this.createImgData.bind(this);
                }
            }, n1;
        }();
        function BaseEvent() {}
        BaseEvent.prototype = {
            triggerEvent: function(t1, e1) {
                if (this._cbs[t1]) for(var r1 = this._cbs[t1], i1 = 0; i1 < r1.length; i1 += 1)r1[i1](e1);
            },
            addEventListener: function(t1, e1) {
                return this._cbs[t1] || (this._cbs[t1] = []), this._cbs[t1].push(e1), (function() {
                    this.removeEventListener(t1, e1);
                }).bind(this);
            },
            removeEventListener: function(t1, e1) {
                if (e1) {
                    if (this._cbs[t1]) {
                        for(var r1 = 0, i1 = this._cbs[t1].length; r1 < i1;)this._cbs[t1][r1] === e1 && (this._cbs[t1].splice(r1, 1), r1 -= 1, i1 -= 1), r1 += 1;
                        this._cbs[t1].length || (this._cbs[t1] = null);
                    }
                } else this._cbs[t1] = null;
            }
        };
        var markerParser = function() {
            function t1(t1) {
                for(var e1, r1 = t1.split("\r\n"), i1 = {}, s1 = 0, a1 = 0; a1 < r1.length; a1 += 1)2 === (e1 = r1[a1].split(":")).length && (i1[e1[0]] = e1[1].trim(), s1 += 1);
                if (0 === s1) throw new Error;
                return i1;
            }
            return function(e1) {
                for(var r1 = [], i1 = 0; i1 < e1.length; i1 += 1){
                    var s1 = e1[i1], a1 = {
                        time: s1.tm,
                        duration: s1.dr
                    };
                    try {
                        a1.payload = JSON.parse(e1[i1].cm);
                    } catch (r1) {
                        try {
                            a1.payload = t1(e1[i1].cm);
                        } catch (t1) {
                            a1.payload = {
                                name: e1[i1].cm
                            };
                        }
                    }
                    r1.push(a1);
                }
                return r1;
            };
        }(), ProjectInterface = function() {
            function t1(t1) {
                this.compositions.push(t1);
            }
            return function() {
                function e1(t1) {
                    for(var e1 = 0, r1 = this.compositions.length; e1 < r1;){
                        if (this.compositions[e1].data && this.compositions[e1].data.nm === t1) return this.compositions[e1].prepareFrame && this.compositions[e1].data.xt && this.compositions[e1].prepareFrame(this.currentFrame), this.compositions[e1].compInterface;
                        e1 += 1;
                    }
                    return null;
                }
                return e1.compositions = [], e1.currentFrame = 0, e1.registerComposition = t1, e1;
            };
        }(), renderers = {}, registerRenderer = function(t1, e1) {
            renderers[t1] = e1;
        };
        function getRenderer(t1) {
            return renderers[t1];
        }
        function _typeof$4(t1) {
            return _typeof$4 = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(t1) {
                return typeof t1;
            } : function(t1) {
                return t1 && "function" == typeof Symbol && t1.constructor === Symbol && t1 !== Symbol.prototype ? "symbol" : typeof t1;
            }, _typeof$4(t1);
        }
        var AnimationItem = function() {
            this._cbs = [], this.name = "", this.path = "", this.isLoaded = !1, this.currentFrame = 0, this.currentRawFrame = 0, this.firstFrame = 0, this.totalFrames = 0, this.frameRate = 0, this.frameMult = 0, this.playSpeed = 1, this.playDirection = 1, this.playCount = 0, this.animationData = {}, this.assets = [], this.isPaused = !0, this.autoplay = !1, this.loop = !0, this.renderer = null, this.animationID = createElementID(), this.assetsPath = "", this.timeCompleted = 0, this.segmentPos = 0, this.isSubframeEnabled = getSubframeEnabled(), this.segments = [], this._idle = !0, this._completedLoop = !1, this.projectInterface = ProjectInterface(), this.imagePreloader = new ImagePreloader, this.audioController = audioControllerFactory(), this.markers = [], this.configAnimation = this.configAnimation.bind(this), this.onSetupError = this.onSetupError.bind(this), this.onSegmentComplete = this.onSegmentComplete.bind(this), this.drawnFrameEvent = new BMEnterFrameEvent("drawnFrame", 0, 0, 0);
        };
        extendPrototype([
            BaseEvent
        ], AnimationItem), AnimationItem.prototype.setParams = function(t1) {
            (t1.wrapper || t1.container) && (this.wrapper = t1.wrapper || t1.container);
            var e1 = "svg";
            t1.animType ? e1 = t1.animType : t1.renderer && (e1 = t1.renderer);
            var r1 = getRenderer(e1);
            this.renderer = new r1(this, t1.rendererSettings), this.imagePreloader.setCacheType(e1, this.renderer.globalData.defs), this.renderer.setProjectInterface(this.projectInterface), this.animType = e1, "" === t1.loop || null === t1.loop || void 0 === t1.loop || !0 === t1.loop ? this.loop = !0 : !1 === t1.loop ? this.loop = !1 : this.loop = parseInt(t1.loop, 10), this.autoplay = !("autoplay" in t1) || t1.autoplay, this.name = t1.name ? t1.name : "", this.autoloadSegments = !Object.prototype.hasOwnProperty.call(t1, "autoloadSegments") || t1.autoloadSegments, this.assetsPath = t1.assetsPath, this.initialSegment = t1.initialSegment, t1.audioFactory && this.audioController.setAudioFactory(t1.audioFactory), t1.animationData ? this.setupAnimation(t1.animationData) : t1.path && (-1 !== t1.path.lastIndexOf("\\") ? this.path = t1.path.substr(0, t1.path.lastIndexOf("\\") + 1) : this.path = t1.path.substr(0, t1.path.lastIndexOf("/") + 1), this.fileName = t1.path.substr(t1.path.lastIndexOf("/") + 1), this.fileName = this.fileName.substr(0, this.fileName.lastIndexOf(".json")), dataManager.loadAnimation(t1.path, this.configAnimation, this.onSetupError));
        }, AnimationItem.prototype.onSetupError = function() {
            this.trigger("data_failed");
        }, AnimationItem.prototype.setupAnimation = function(t1) {
            dataManager.completeAnimation(t1, this.configAnimation);
        }, AnimationItem.prototype.setData = function(t1, e1) {
            e1 && "object" !== _typeof$4(e1) && (e1 = JSON.parse(e1));
            var r1 = {
                wrapper: t1,
                animationData: e1
            }, i1 = t1.attributes;
            r1.path = i1.getNamedItem("data-animation-path") ? i1.getNamedItem("data-animation-path").value : i1.getNamedItem("data-bm-path") ? i1.getNamedItem("data-bm-path").value : i1.getNamedItem("bm-path") ? i1.getNamedItem("bm-path").value : "", r1.animType = i1.getNamedItem("data-anim-type") ? i1.getNamedItem("data-anim-type").value : i1.getNamedItem("data-bm-type") ? i1.getNamedItem("data-bm-type").value : i1.getNamedItem("bm-type") ? i1.getNamedItem("bm-type").value : i1.getNamedItem("data-bm-renderer") ? i1.getNamedItem("data-bm-renderer").value : i1.getNamedItem("bm-renderer") ? i1.getNamedItem("bm-renderer").value : "canvas";
            var s1 = i1.getNamedItem("data-anim-loop") ? i1.getNamedItem("data-anim-loop").value : i1.getNamedItem("data-bm-loop") ? i1.getNamedItem("data-bm-loop").value : i1.getNamedItem("bm-loop") ? i1.getNamedItem("bm-loop").value : "";
            "false" === s1 ? r1.loop = !1 : "true" === s1 ? r1.loop = !0 : "" !== s1 && (r1.loop = parseInt(s1, 10));
            var a1 = i1.getNamedItem("data-anim-autoplay") ? i1.getNamedItem("data-anim-autoplay").value : i1.getNamedItem("data-bm-autoplay") ? i1.getNamedItem("data-bm-autoplay").value : !i1.getNamedItem("bm-autoplay") || i1.getNamedItem("bm-autoplay").value;
            r1.autoplay = "false" !== a1, r1.name = i1.getNamedItem("data-name") ? i1.getNamedItem("data-name").value : i1.getNamedItem("data-bm-name") ? i1.getNamedItem("data-bm-name").value : i1.getNamedItem("bm-name") ? i1.getNamedItem("bm-name").value : "", "false" === (i1.getNamedItem("data-anim-prerender") ? i1.getNamedItem("data-anim-prerender").value : i1.getNamedItem("data-bm-prerender") ? i1.getNamedItem("data-bm-prerender").value : i1.getNamedItem("bm-prerender") ? i1.getNamedItem("bm-prerender").value : "") && (r1.prerender = !1), this.setParams(r1);
        }, AnimationItem.prototype.includeLayers = function(t1) {
            t1.op > this.animationData.op && (this.animationData.op = t1.op, this.totalFrames = Math.floor(t1.op - this.animationData.ip));
            var e1, r1, i1 = this.animationData.layers, s1 = i1.length, a1 = t1.layers, n1 = a1.length;
            for(r1 = 0; r1 < n1; r1 += 1)for(e1 = 0; e1 < s1;){
                if (i1[e1].id === a1[r1].id) {
                    i1[e1] = a1[r1];
                    break;
                }
                e1 += 1;
            }
            if ((t1.chars || t1.fonts) && (this.renderer.globalData.fontManager.addChars(t1.chars), this.renderer.globalData.fontManager.addFonts(t1.fonts, this.renderer.globalData.defs)), t1.assets) for(s1 = t1.assets.length, e1 = 0; e1 < s1; e1 += 1)this.animationData.assets.push(t1.assets[e1]);
            this.animationData.__complete = !1, dataManager.completeAnimation(this.animationData, this.onSegmentComplete);
        }, AnimationItem.prototype.onSegmentComplete = function(t1) {
            this.animationData = t1;
            var e1 = getExpressionsPlugin();
            e1 && e1.initExpressions(this), this.loadNextSegment();
        }, AnimationItem.prototype.loadNextSegment = function() {
            var t1 = this.animationData.segments;
            if (!t1 || 0 === t1.length || !this.autoloadSegments) return this.trigger("data_ready"), void (this.timeCompleted = this.totalFrames);
            var e1 = t1.shift();
            this.timeCompleted = e1.time * this.frameRate;
            var r1 = this.path + this.fileName + "_" + this.segmentPos + ".json";
            this.segmentPos += 1, dataManager.loadData(r1, this.includeLayers.bind(this), (function() {
                this.trigger("data_failed");
            }).bind(this));
        }, AnimationItem.prototype.loadSegments = function() {
            this.animationData.segments || (this.timeCompleted = this.totalFrames), this.loadNextSegment();
        }, AnimationItem.prototype.imagesLoaded = function() {
            this.trigger("loaded_images"), this.checkLoaded();
        }, AnimationItem.prototype.preloadImages = function() {
            this.imagePreloader.setAssetsPath(this.assetsPath), this.imagePreloader.setPath(this.path), this.imagePreloader.loadAssets(this.animationData.assets, this.imagesLoaded.bind(this));
        }, AnimationItem.prototype.configAnimation = function(t1) {
            if (this.renderer) try {
                this.animationData = t1, this.initialSegment ? (this.totalFrames = Math.floor(this.initialSegment[1] - this.initialSegment[0]), this.firstFrame = Math.round(this.initialSegment[0])) : (this.totalFrames = Math.floor(this.animationData.op - this.animationData.ip), this.firstFrame = Math.round(this.animationData.ip)), this.renderer.configAnimation(t1), t1.assets || (t1.assets = []), this.assets = this.animationData.assets, this.frameRate = this.animationData.fr, this.frameMult = this.animationData.fr / 1e3, this.renderer.searchExtraCompositions(t1.assets), this.markers = markerParser(t1.markers || []), this.trigger("config_ready"), this.preloadImages(), this.loadSegments(), this.updaFrameModifier(), this.waitForFontsLoaded(), this.isPaused && this.audioController.pause();
            } catch (t1) {
                this.triggerConfigError(t1);
            }
        }, AnimationItem.prototype.waitForFontsLoaded = function() {
            this.renderer && (this.renderer.globalData.fontManager.isLoaded ? this.checkLoaded() : setTimeout(this.waitForFontsLoaded.bind(this), 20));
        }, AnimationItem.prototype.checkLoaded = function() {
            if (!this.isLoaded && this.renderer.globalData.fontManager.isLoaded && (this.imagePreloader.loadedImages() || "canvas" !== this.renderer.rendererType) && this.imagePreloader.loadedFootages()) {
                this.isLoaded = !0;
                var t1 = getExpressionsPlugin();
                t1 && t1.initExpressions(this), this.renderer.initItems(), setTimeout((function() {
                    this.trigger("DOMLoaded");
                }).bind(this), 0), this.gotoFrame(), this.autoplay && this.play();
            }
        }, AnimationItem.prototype.resize = function(t1, e1) {
            var r1 = "number" == typeof t1 ? t1 : void 0, i1 = "number" == typeof e1 ? e1 : void 0;
            this.renderer.updateContainerSize(r1, i1);
        }, AnimationItem.prototype.setSubframe = function(t1) {
            this.isSubframeEnabled = !!t1;
        }, AnimationItem.prototype.gotoFrame = function() {
            this.currentFrame = this.isSubframeEnabled ? this.currentRawFrame : ~~this.currentRawFrame, this.timeCompleted !== this.totalFrames && this.currentFrame > this.timeCompleted && (this.currentFrame = this.timeCompleted), this.trigger("enterFrame"), this.renderFrame(), this.trigger("drawnFrame");
        }, AnimationItem.prototype.renderFrame = function() {
            if (!1 !== this.isLoaded && this.renderer) try {
                this.renderer.renderFrame(this.currentFrame + this.firstFrame);
            } catch (t1) {
                this.triggerRenderFrameError(t1);
            }
        }, AnimationItem.prototype.play = function(t1) {
            t1 && this.name !== t1 || !0 === this.isPaused && (this.isPaused = !1, this.trigger("_pause"), this.audioController.resume(), this._idle && (this._idle = !1, this.trigger("_active")));
        }, AnimationItem.prototype.pause = function(t1) {
            t1 && this.name !== t1 || !1 === this.isPaused && (this.isPaused = !0, this.trigger("_play"), this._idle = !0, this.trigger("_idle"), this.audioController.pause());
        }, AnimationItem.prototype.togglePause = function(t1) {
            t1 && this.name !== t1 || (!0 === this.isPaused ? this.play() : this.pause());
        }, AnimationItem.prototype.stop = function(t1) {
            t1 && this.name !== t1 || (this.pause(), this.playCount = 0, this._completedLoop = !1, this.setCurrentRawFrameValue(0));
        }, AnimationItem.prototype.getMarkerData = function(t1) {
            for(var e1, r1 = 0; r1 < this.markers.length; r1 += 1)if ((e1 = this.markers[r1]).payload && e1.payload.name === t1) return e1;
            return null;
        }, AnimationItem.prototype.goToAndStop = function(t1, e1, r1) {
            if (!r1 || this.name === r1) {
                var i1 = Number(t1);
                if (isNaN(i1)) {
                    var s1 = this.getMarkerData(t1);
                    s1 && this.goToAndStop(s1.time, !0);
                } else e1 ? this.setCurrentRawFrameValue(t1) : this.setCurrentRawFrameValue(t1 * this.frameModifier);
                this.pause();
            }
        }, AnimationItem.prototype.goToAndPlay = function(t1, e1, r1) {
            if (!r1 || this.name === r1) {
                var i1 = Number(t1);
                if (isNaN(i1)) {
                    var s1 = this.getMarkerData(t1);
                    s1 && (s1.duration ? this.playSegments([
                        s1.time,
                        s1.time + s1.duration
                    ], !0) : this.goToAndStop(s1.time, !0));
                } else this.goToAndStop(i1, e1, r1);
                this.play();
            }
        }, AnimationItem.prototype.advanceTime = function(t1) {
            if (!0 !== this.isPaused && !1 !== this.isLoaded) {
                var e1 = this.currentRawFrame + t1 * this.frameModifier, r1 = !1;
                e1 >= this.totalFrames - 1 && this.frameModifier > 0 ? this.loop && this.playCount !== this.loop ? e1 >= this.totalFrames ? (this.playCount += 1, this.checkSegments(e1 % this.totalFrames) || (this.setCurrentRawFrameValue(e1 % this.totalFrames), this._completedLoop = !0, this.trigger("loopComplete"))) : this.setCurrentRawFrameValue(e1) : this.checkSegments(e1 > this.totalFrames ? e1 % this.totalFrames : 0) || (r1 = !0, e1 = this.totalFrames - 1) : e1 < 0 ? this.checkSegments(e1 % this.totalFrames) || (!this.loop || this.playCount-- <= 0 && !0 !== this.loop ? (r1 = !0, e1 = 0) : (this.setCurrentRawFrameValue(this.totalFrames + e1 % this.totalFrames), this._completedLoop ? this.trigger("loopComplete") : this._completedLoop = !0)) : this.setCurrentRawFrameValue(e1), r1 && (this.setCurrentRawFrameValue(e1), this.pause(), this.trigger("complete"));
            }
        }, AnimationItem.prototype.adjustSegment = function(t1, e1) {
            this.playCount = 0, t1[1] < t1[0] ? (this.frameModifier > 0 && (this.playSpeed < 0 ? this.setSpeed(-this.playSpeed) : this.setDirection(-1)), this.totalFrames = t1[0] - t1[1], this.timeCompleted = this.totalFrames, this.firstFrame = t1[1], this.setCurrentRawFrameValue(this.totalFrames - .001 - e1)) : t1[1] > t1[0] && (this.frameModifier < 0 && (this.playSpeed < 0 ? this.setSpeed(-this.playSpeed) : this.setDirection(1)), this.totalFrames = t1[1] - t1[0], this.timeCompleted = this.totalFrames, this.firstFrame = t1[0], this.setCurrentRawFrameValue(.001 + e1)), this.trigger("segmentStart");
        }, AnimationItem.prototype.setSegment = function(t1, e1) {
            var r1 = -1;
            this.isPaused && (this.currentRawFrame + this.firstFrame < t1 ? r1 = t1 : this.currentRawFrame + this.firstFrame > e1 && (r1 = e1 - t1)), this.firstFrame = t1, this.totalFrames = e1 - t1, this.timeCompleted = this.totalFrames, -1 !== r1 && this.goToAndStop(r1, !0);
        }, AnimationItem.prototype.playSegments = function(t1, e1) {
            if (e1 && (this.segments.length = 0), "object" === _typeof$4(t1[0])) {
                var r1, i1 = t1.length;
                for(r1 = 0; r1 < i1; r1 += 1)this.segments.push(t1[r1]);
            } else this.segments.push(t1);
            this.segments.length && e1 && this.adjustSegment(this.segments.shift(), 0), this.isPaused && this.play();
        }, AnimationItem.prototype.resetSegments = function(t1) {
            this.segments.length = 0, this.segments.push([
                this.animationData.ip,
                this.animationData.op
            ]), t1 && this.checkSegments(0);
        }, AnimationItem.prototype.checkSegments = function(t1) {
            return !!this.segments.length && (this.adjustSegment(this.segments.shift(), t1), !0);
        }, AnimationItem.prototype.destroy = function(t1) {
            t1 && this.name !== t1 || !this.renderer || (this.renderer.destroy(), this.imagePreloader.destroy(), this.trigger("destroy"), this._cbs = null, this.onEnterFrame = null, this.onLoopComplete = null, this.onComplete = null, this.onSegmentStart = null, this.onDestroy = null, this.renderer = null, this.renderer = null, this.imagePreloader = null, this.projectInterface = null);
        }, AnimationItem.prototype.setCurrentRawFrameValue = function(t1) {
            this.currentRawFrame = t1, this.gotoFrame();
        }, AnimationItem.prototype.setSpeed = function(t1) {
            this.playSpeed = t1, this.updaFrameModifier();
        }, AnimationItem.prototype.setDirection = function(t1) {
            this.playDirection = t1 < 0 ? -1 : 1, this.updaFrameModifier();
        }, AnimationItem.prototype.setVolume = function(t1, e1) {
            e1 && this.name !== e1 || this.audioController.setVolume(t1);
        }, AnimationItem.prototype.getVolume = function() {
            return this.audioController.getVolume();
        }, AnimationItem.prototype.mute = function(t1) {
            t1 && this.name !== t1 || this.audioController.mute();
        }, AnimationItem.prototype.unmute = function(t1) {
            t1 && this.name !== t1 || this.audioController.unmute();
        }, AnimationItem.prototype.updaFrameModifier = function() {
            this.frameModifier = this.frameMult * this.playSpeed * this.playDirection, this.audioController.setRate(this.playSpeed * this.playDirection);
        }, AnimationItem.prototype.getPath = function() {
            return this.path;
        }, AnimationItem.prototype.getAssetsPath = function(t1) {
            var e1 = "";
            if (t1.e) e1 = t1.p;
            else if (this.assetsPath) {
                var r1 = t1.p;
                -1 !== r1.indexOf("images/") && (r1 = r1.split("/")[1]), e1 = this.assetsPath + r1;
            } else e1 = this.path, e1 += t1.u ? t1.u : "", e1 += t1.p;
            return e1;
        }, AnimationItem.prototype.getAssetData = function(t1) {
            for(var e1 = 0, r1 = this.assets.length; e1 < r1;){
                if (t1 === this.assets[e1].id) return this.assets[e1];
                e1 += 1;
            }
            return null;
        }, AnimationItem.prototype.hide = function() {
            this.renderer.hide();
        }, AnimationItem.prototype.show = function() {
            this.renderer.show();
        }, AnimationItem.prototype.getDuration = function(t1) {
            return t1 ? this.totalFrames : this.totalFrames / this.frameRate;
        }, AnimationItem.prototype.updateDocumentData = function(t1, e1, r1) {
            try {
                this.renderer.getElementByPath(t1).updateDocumentData(e1, r1);
            } catch (t1) {}
        }, AnimationItem.prototype.trigger = function(t1) {
            if (this._cbs && this._cbs[t1]) switch(t1){
                case "enterFrame":
                    this.triggerEvent(t1, new BMEnterFrameEvent(t1, this.currentFrame, this.totalFrames, this.frameModifier));
                    break;
                case "drawnFrame":
                    this.drawnFrameEvent.currentTime = this.currentFrame, this.drawnFrameEvent.totalTime = this.totalFrames, this.drawnFrameEvent.direction = this.frameModifier, this.triggerEvent(t1, this.drawnFrameEvent);
                    break;
                case "loopComplete":
                    this.triggerEvent(t1, new BMCompleteLoopEvent(t1, this.loop, this.playCount, this.frameMult));
                    break;
                case "complete":
                    this.triggerEvent(t1, new BMCompleteEvent(t1, this.frameMult));
                    break;
                case "segmentStart":
                    this.triggerEvent(t1, new BMSegmentStartEvent(t1, this.firstFrame, this.totalFrames));
                    break;
                case "destroy":
                    this.triggerEvent(t1, new BMDestroyEvent(t1, this));
                    break;
                default:
                    this.triggerEvent(t1);
            }
            "enterFrame" === t1 && this.onEnterFrame && this.onEnterFrame.call(this, new BMEnterFrameEvent(t1, this.currentFrame, this.totalFrames, this.frameMult)), "loopComplete" === t1 && this.onLoopComplete && this.onLoopComplete.call(this, new BMCompleteLoopEvent(t1, this.loop, this.playCount, this.frameMult)), "complete" === t1 && this.onComplete && this.onComplete.call(this, new BMCompleteEvent(t1, this.frameMult)), "segmentStart" === t1 && this.onSegmentStart && this.onSegmentStart.call(this, new BMSegmentStartEvent(t1, this.firstFrame, this.totalFrames)), "destroy" === t1 && this.onDestroy && this.onDestroy.call(this, new BMDestroyEvent(t1, this));
        }, AnimationItem.prototype.triggerRenderFrameError = function(t1) {
            var e1 = new BMRenderFrameErrorEvent(t1, this.currentFrame);
            this.triggerEvent("error", e1), this.onError && this.onError.call(this, e1);
        }, AnimationItem.prototype.triggerConfigError = function(t1) {
            var e1 = new BMConfigErrorEvent(t1, this.currentFrame);
            this.triggerEvent("error", e1), this.onError && this.onError.call(this, e1);
        };
        var animationManager = function() {
            var t1 = {}, e1 = [], r1 = 0, i1 = 0, s1 = 0, a1 = !0, n1 = !1;
            function o1(t1) {
                for(var r1 = 0, s1 = t1.target; r1 < i1;)e1[r1].animation === s1 && (e1.splice(r1, 1), r1 -= 1, i1 -= 1, s1.isPaused || p1()), r1 += 1;
            }
            function h1(t1, r1) {
                if (!t1) return null;
                for(var s1 = 0; s1 < i1;){
                    if (e1[s1].elem === t1 && null !== e1[s1].elem) return e1[s1].animation;
                    s1 += 1;
                }
                var a1 = new AnimationItem;
                return c1(a1, t1), a1.setData(t1, r1), a1;
            }
            function l1() {
                s1 += 1, u1();
            }
            function p1() {
                s1 -= 1;
            }
            function c1(t1, r1) {
                t1.addEventListener("destroy", o1), t1.addEventListener("_active", l1), t1.addEventListener("_idle", p1), e1.push({
                    elem: r1,
                    animation: t1
                }), i1 += 1;
            }
            function f1(t1) {
                var o1, h1 = t1 - r1;
                for(o1 = 0; o1 < i1; o1 += 1)e1[o1].animation.advanceTime(h1);
                r1 = t1, s1 && !n1 ? window.requestAnimationFrame(f1) : a1 = !0;
            }
            function d1(t1) {
                r1 = t1, window.requestAnimationFrame(f1);
            }
            function u1() {
                !n1 && s1 && a1 && (window.requestAnimationFrame(d1), a1 = !1);
            }
            return t1.registerAnimation = h1, t1.loadAnimation = function(t1) {
                var e1 = new AnimationItem;
                return c1(e1, null), e1.setParams(t1), e1;
            }, t1.setSpeed = function(t1, r1) {
                var s1;
                for(s1 = 0; s1 < i1; s1 += 1)e1[s1].animation.setSpeed(t1, r1);
            }, t1.setDirection = function(t1, r1) {
                var s1;
                for(s1 = 0; s1 < i1; s1 += 1)e1[s1].animation.setDirection(t1, r1);
            }, t1.play = function(t1) {
                var r1;
                for(r1 = 0; r1 < i1; r1 += 1)e1[r1].animation.play(t1);
            }, t1.pause = function(t1) {
                var r1;
                for(r1 = 0; r1 < i1; r1 += 1)e1[r1].animation.pause(t1);
            }, t1.stop = function(t1) {
                var r1;
                for(r1 = 0; r1 < i1; r1 += 1)e1[r1].animation.stop(t1);
            }, t1.togglePause = function(t1) {
                var r1;
                for(r1 = 0; r1 < i1; r1 += 1)e1[r1].animation.togglePause(t1);
            }, t1.searchAnimations = function(t1, e1, r1) {
                var i1, s1 = [].concat([].slice.call(document.getElementsByClassName("lottie")), [].slice.call(document.getElementsByClassName("bodymovin"))), a1 = s1.length;
                for(i1 = 0; i1 < a1; i1 += 1)r1 && s1[i1].setAttribute("data-bm-type", r1), h1(s1[i1], t1);
                if (e1 && 0 === a1) {
                    r1 || (r1 = "svg");
                    var n1 = document.getElementsByTagName("body")[0];
                    n1.innerText = "";
                    var o1 = createTag("div");
                    o1.style.width = "100%", o1.style.height = "100%", o1.setAttribute("data-bm-type", r1), n1.appendChild(o1), h1(o1, t1);
                }
            }, t1.resize = function() {
                var t1;
                for(t1 = 0; t1 < i1; t1 += 1)e1[t1].animation.resize();
            }, t1.goToAndStop = function(t1, r1, s1) {
                var a1;
                for(a1 = 0; a1 < i1; a1 += 1)e1[a1].animation.goToAndStop(t1, r1, s1);
            }, t1.destroy = function(t1) {
                var r1;
                for(r1 = i1 - 1; r1 >= 0; r1 -= 1)e1[r1].animation.destroy(t1);
            }, t1.freeze = function() {
                n1 = !0;
            }, t1.unfreeze = function() {
                n1 = !1, u1();
            }, t1.setVolume = function(t1, r1) {
                var s1;
                for(s1 = 0; s1 < i1; s1 += 1)e1[s1].animation.setVolume(t1, r1);
            }, t1.mute = function(t1) {
                var r1;
                for(r1 = 0; r1 < i1; r1 += 1)e1[r1].animation.mute(t1);
            }, t1.unmute = function(t1) {
                var r1;
                for(r1 = 0; r1 < i1; r1 += 1)e1[r1].animation.unmute(t1);
            }, t1.getRegisteredAnimations = function() {
                var t1, r1 = e1.length, i1 = [];
                for(t1 = 0; t1 < r1; t1 += 1)i1.push(e1[t1].animation);
                return i1;
            }, t1;
        }(), BezierFactory = function() {
            var t1 = {
                getBezierEasing: function(t1, r1, i1, s1, a1) {
                    var n1 = a1 || ("bez_" + t1 + "_" + r1 + "_" + i1 + "_" + s1).replace(/\./g, "p");
                    if (e1[n1]) return e1[n1];
                    var o1 = new l1([
                        t1,
                        r1,
                        i1,
                        s1
                    ]);
                    return e1[n1] = o1, o1;
                }
            }, e1 = {}, r1 = .1, i1 = "function" == typeof Float32Array;
            function s1(t1, e1) {
                return 1 - 3 * e1 + 3 * t1;
            }
            function a1(t1, e1) {
                return 3 * e1 - 6 * t1;
            }
            function n1(t1) {
                return 3 * t1;
            }
            function o1(t1, e1, r1) {
                return ((s1(e1, r1) * t1 + a1(e1, r1)) * t1 + n1(e1)) * t1;
            }
            function h1(t1, e1, r1) {
                return 3 * s1(e1, r1) * t1 * t1 + 2 * a1(e1, r1) * t1 + n1(e1);
            }
            function l1(t1) {
                this._p = t1, this._mSampleValues = i1 ? new Float32Array(11) : new Array(11), this._precomputed = !1, this.get = this.get.bind(this);
            }
            return l1.prototype = {
                get: function(t1) {
                    var e1 = this._p[0], r1 = this._p[1], i1 = this._p[2], s1 = this._p[3];
                    return this._precomputed || this._precompute(), e1 === r1 && i1 === s1 ? t1 : 0 === t1 ? 0 : 1 === t1 ? 1 : o1(this._getTForX(t1), r1, s1);
                },
                _precompute: function() {
                    var t1 = this._p[0], e1 = this._p[1], r1 = this._p[2], i1 = this._p[3];
                    this._precomputed = !0, t1 === e1 && r1 === i1 || this._calcSampleValues();
                },
                _calcSampleValues: function() {
                    for(var t1 = this._p[0], e1 = this._p[2], i1 = 0; i1 < 11; ++i1)this._mSampleValues[i1] = o1(i1 * r1, t1, e1);
                },
                _getTForX: function(t1) {
                    for(var e1 = this._p[0], i1 = this._p[2], s1 = this._mSampleValues, a1 = 0, n1 = 1; 10 !== n1 && s1[n1] <= t1; ++n1)a1 += r1;
                    var l1 = a1 + (t1 - s1[--n1]) / (s1[n1 + 1] - s1[n1]) * r1, p1 = h1(l1, e1, i1);
                    return p1 >= .001 ? function(t1, e1, r1, i1) {
                        for(var s1 = 0; s1 < 4; ++s1){
                            var a1 = h1(e1, r1, i1);
                            if (0 === a1) return e1;
                            e1 -= (o1(e1, r1, i1) - t1) / a1;
                        }
                        return e1;
                    }(t1, l1, e1, i1) : 0 === p1 ? l1 : function(t1, e1, r1, i1, s1) {
                        var a1, n1, h1 = 0;
                        do (a1 = o1(n1 = e1 + (r1 - e1) / 2, i1, s1) - t1) > 0 ? r1 = n1 : e1 = n1;
                        while (Math.abs(a1) > 1e-7 && ++h1 < 10);
                        return n1;
                    }(t1, a1, a1 + r1, e1, i1);
                }
            }, t1;
        }(), pooling = {
            double: function(t1) {
                return t1.concat(createSizedArray(t1.length));
            }
        }, poolFactory = function(t1, e1, r1) {
            var i1 = 0, s1 = t1, a1 = createSizedArray(s1);
            return {
                newElement: function() {
                    return i1 ? a1[i1 -= 1] : e1();
                },
                release: function(t1) {
                    i1 === s1 && (a1 = pooling.double(a1), s1 *= 2), r1 && r1(t1), a1[i1] = t1, i1 += 1;
                }
            };
        }, bezierLengthPool = poolFactory(8, function() {
            return {
                addedLength: 0,
                percents: createTypedArray("float32", getDefaultCurveSegments()),
                lengths: createTypedArray("float32", getDefaultCurveSegments())
            };
        }), segmentsLengthPool = poolFactory(8, function() {
            return {
                lengths: [],
                totalLength: 0
            };
        }, function(t1) {
            var e1, r1 = t1.lengths.length;
            for(e1 = 0; e1 < r1; e1 += 1)bezierLengthPool.release(t1.lengths[e1]);
            t1.lengths.length = 0;
        });
        function bezFunction() {
            var t1 = Math;
            function e1(t1, e1, r1, i1, s1, a1) {
                var n1 = t1 * i1 + e1 * s1 + r1 * a1 - s1 * i1 - a1 * t1 - r1 * e1;
                return n1 > -0.001 && n1 < .001;
            }
            var r1 = function(t1, e1, r1, i1) {
                var s1, a1, n1, o1, h1, l1, p1 = getDefaultCurveSegments(), c1 = 0, f1 = [], d1 = [], u1 = bezierLengthPool.newElement();
                for(n1 = r1.length, s1 = 0; s1 < p1; s1 += 1){
                    for(h1 = s1 / (p1 - 1), l1 = 0, a1 = 0; a1 < n1; a1 += 1)o1 = bmPow(1 - h1, 3) * t1[a1] + 3 * bmPow(1 - h1, 2) * h1 * r1[a1] + 3 * (1 - h1) * bmPow(h1, 2) * i1[a1] + bmPow(h1, 3) * e1[a1], f1[a1] = o1, null !== d1[a1] && (l1 += bmPow(f1[a1] - d1[a1], 2)), d1[a1] = f1[a1];
                    l1 && (c1 += l1 = bmSqrt(l1)), u1.percents[s1] = h1, u1.lengths[s1] = c1;
                }
                return u1.addedLength = c1, u1;
            };
            function i1(t1) {
                this.segmentLength = 0, this.points = new Array(t1);
            }
            function s1(t1, e1) {
                this.partialLength = t1, this.point = e1;
            }
            var a1, n1 = (a1 = {}, function(t1, r1, n1, o1) {
                var h1 = (t1[0] + "_" + t1[1] + "_" + r1[0] + "_" + r1[1] + "_" + n1[0] + "_" + n1[1] + "_" + o1[0] + "_" + o1[1]).replace(/\./g, "p");
                if (!a1[h1]) {
                    var l1, p1, c1, f1, d1, u1, m1, y1 = getDefaultCurveSegments(), g1 = 0, v1 = null;
                    2 === t1.length && (t1[0] !== r1[0] || t1[1] !== r1[1]) && e1(t1[0], t1[1], r1[0], r1[1], t1[0] + n1[0], t1[1] + n1[1]) && e1(t1[0], t1[1], r1[0], r1[1], r1[0] + o1[0], r1[1] + o1[1]) && (y1 = 2);
                    var b1 = new i1(y1);
                    for(c1 = n1.length, l1 = 0; l1 < y1; l1 += 1){
                        for(m1 = createSizedArray(c1), d1 = l1 / (y1 - 1), u1 = 0, p1 = 0; p1 < c1; p1 += 1)f1 = bmPow(1 - d1, 3) * t1[p1] + 3 * bmPow(1 - d1, 2) * d1 * (t1[p1] + n1[p1]) + 3 * (1 - d1) * bmPow(d1, 2) * (r1[p1] + o1[p1]) + bmPow(d1, 3) * r1[p1], m1[p1] = f1, null !== v1 && (u1 += bmPow(m1[p1] - v1[p1], 2));
                        g1 += u1 = bmSqrt(u1), b1.points[l1] = new s1(u1, m1), v1 = m1;
                    }
                    b1.segmentLength = g1, a1[h1] = b1;
                }
                return a1[h1];
            });
            function o1(t1, e1) {
                var r1 = e1.percents, i1 = e1.lengths, s1 = r1.length, a1 = bmFloor((s1 - 1) * t1), n1 = t1 * e1.addedLength, o1 = 0;
                if (a1 === s1 - 1 || 0 === a1 || n1 === i1[a1]) return r1[a1];
                for(var h1 = i1[a1] > n1 ? -1 : 1, l1 = !0; l1;)if (i1[a1] <= n1 && i1[a1 + 1] > n1 ? (o1 = (n1 - i1[a1]) / (i1[a1 + 1] - i1[a1]), l1 = !1) : a1 += h1, a1 < 0 || a1 >= s1 - 1) {
                    if (a1 === s1 - 1) return r1[a1];
                    l1 = !1;
                }
                return r1[a1] + (r1[a1 + 1] - r1[a1]) * o1;
            }
            var h1 = createTypedArray("float32", 8);
            return {
                getSegmentsLength: function(t1) {
                    var e1, i1 = segmentsLengthPool.newElement(), s1 = t1.c, a1 = t1.v, n1 = t1.o, o1 = t1.i, h1 = t1._length, l1 = i1.lengths, p1 = 0;
                    for(e1 = 0; e1 < h1 - 1; e1 += 1)l1[e1] = r1(a1[e1], a1[e1 + 1], n1[e1], o1[e1 + 1]), p1 += l1[e1].addedLength;
                    return s1 && h1 && (l1[e1] = r1(a1[e1], a1[0], n1[e1], o1[0]), p1 += l1[e1].addedLength), i1.totalLength = p1, i1;
                },
                getNewSegment: function(e1, r1, i1, s1, a1, n1, l1) {
                    a1 < 0 ? a1 = 0 : a1 > 1 && (a1 = 1);
                    var p1, c1 = o1(a1, l1), f1 = o1(n1 = n1 > 1 ? 1 : n1, l1), d1 = e1.length, u1 = 1 - c1, m1 = 1 - f1, y1 = u1 * u1 * u1, g1 = c1 * u1 * u1 * 3, v1 = c1 * c1 * u1 * 3, b1 = c1 * c1 * c1, _1 = u1 * u1 * m1, P1 = c1 * u1 * m1 + u1 * c1 * m1 + u1 * u1 * f1, E1 = c1 * c1 * m1 + u1 * c1 * f1 + c1 * u1 * f1, S1 = c1 * c1 * f1, x1 = u1 * m1 * m1, A1 = c1 * m1 * m1 + u1 * f1 * m1 + u1 * m1 * f1, w1 = c1 * f1 * m1 + u1 * f1 * f1 + c1 * m1 * f1, C1 = c1 * f1 * f1, k1 = m1 * m1 * m1, T1 = f1 * m1 * m1 + m1 * f1 * m1 + m1 * m1 * f1, D1 = f1 * f1 * m1 + m1 * f1 * f1 + f1 * m1 * f1, M1 = f1 * f1 * f1;
                    for(p1 = 0; p1 < d1; p1 += 1)h1[4 * p1] = t1.round(1e3 * (y1 * e1[p1] + g1 * i1[p1] + v1 * s1[p1] + b1 * r1[p1])) / 1e3, h1[4 * p1 + 1] = t1.round(1e3 * (_1 * e1[p1] + P1 * i1[p1] + E1 * s1[p1] + S1 * r1[p1])) / 1e3, h1[4 * p1 + 2] = t1.round(1e3 * (x1 * e1[p1] + A1 * i1[p1] + w1 * s1[p1] + C1 * r1[p1])) / 1e3, h1[4 * p1 + 3] = t1.round(1e3 * (k1 * e1[p1] + T1 * i1[p1] + D1 * s1[p1] + M1 * r1[p1])) / 1e3;
                    return h1;
                },
                getPointInSegment: function(e1, r1, i1, s1, a1, n1) {
                    var h1 = o1(a1, n1), l1 = 1 - h1;
                    return [
                        t1.round(1e3 * (l1 * l1 * l1 * e1[0] + (h1 * l1 * l1 + l1 * h1 * l1 + l1 * l1 * h1) * i1[0] + (h1 * h1 * l1 + l1 * h1 * h1 + h1 * l1 * h1) * s1[0] + h1 * h1 * h1 * r1[0])) / 1e3,
                        t1.round(1e3 * (l1 * l1 * l1 * e1[1] + (h1 * l1 * l1 + l1 * h1 * l1 + l1 * l1 * h1) * i1[1] + (h1 * h1 * l1 + l1 * h1 * h1 + h1 * l1 * h1) * s1[1] + h1 * h1 * h1 * r1[1])) / 1e3
                    ];
                },
                buildBezierData: n1,
                pointOnLine2D: e1,
                pointOnLine3D: function(r1, i1, s1, a1, n1, o1, h1, l1, p1) {
                    if (0 === s1 && 0 === o1 && 0 === p1) return e1(r1, i1, a1, n1, h1, l1);
                    var c1, f1 = t1.sqrt(t1.pow(a1 - r1, 2) + t1.pow(n1 - i1, 2) + t1.pow(o1 - s1, 2)), d1 = t1.sqrt(t1.pow(h1 - r1, 2) + t1.pow(l1 - i1, 2) + t1.pow(p1 - s1, 2)), u1 = t1.sqrt(t1.pow(h1 - a1, 2) + t1.pow(l1 - n1, 2) + t1.pow(p1 - o1, 2));
                    return (c1 = f1 > d1 ? f1 > u1 ? f1 - d1 - u1 : u1 - d1 - f1 : u1 > d1 ? u1 - d1 - f1 : d1 - f1 - u1) > -0.0001 && c1 < 1e-4;
                }
            };
        }
        var bez = bezFunction(), PropertyFactory = function() {
            var t1 = initialDefaultFrame, e1 = Math.abs;
            function r1(t1, e1) {
                var r1, s1 = this.offsetTime;
                "multidimensional" === this.propType && (r1 = createTypedArray("float32", this.pv.length));
                for(var a1, n1, o1, h1, l1, p1, c1, f1, d1, u1 = e1.lastIndex, m1 = u1, y1 = this.keyframes.length - 1, g1 = !0; g1;){
                    if (a1 = this.keyframes[m1], n1 = this.keyframes[m1 + 1], m1 === y1 - 1 && t1 >= n1.t - s1) {
                        a1.h && (a1 = n1), u1 = 0;
                        break;
                    }
                    if (n1.t - s1 > t1) {
                        u1 = m1;
                        break;
                    }
                    m1 < y1 - 1 ? m1 += 1 : (u1 = 0, g1 = !1);
                }
                o1 = this.keyframesMetadata[m1] || {};
                var v1, b1, _1, P1, E1, S1, x1, A1, w1, C1, k1 = n1.t - s1, T1 = a1.t - s1;
                if (a1.to) {
                    o1.bezierData || (o1.bezierData = bez.buildBezierData(a1.s, n1.s || a1.e, a1.to, a1.ti));
                    var D1 = o1.bezierData;
                    if (t1 >= k1 || t1 < T1) {
                        var M1 = t1 >= k1 ? D1.points.length - 1 : 0;
                        for(l1 = D1.points[M1].point.length, h1 = 0; h1 < l1; h1 += 1)r1[h1] = D1.points[M1].point[h1];
                    } else {
                        o1.__fnct ? d1 = o1.__fnct : (d1 = BezierFactory.getBezierEasing(a1.o.x, a1.o.y, a1.i.x, a1.i.y, a1.n).get, o1.__fnct = d1), p1 = d1((t1 - T1) / (k1 - T1));
                        var F1, I1 = D1.segmentLength * p1, R1 = e1.lastFrame < t1 && e1._lastKeyframeIndex === m1 ? e1._lastAddedLength : 0;
                        for(f1 = e1.lastFrame < t1 && e1._lastKeyframeIndex === m1 ? e1._lastPoint : 0, g1 = !0, c1 = D1.points.length; g1;){
                            if (R1 += D1.points[f1].partialLength, 0 === I1 || 0 === p1 || f1 === D1.points.length - 1) {
                                for(l1 = D1.points[f1].point.length, h1 = 0; h1 < l1; h1 += 1)r1[h1] = D1.points[f1].point[h1];
                                break;
                            }
                            if (I1 >= R1 && I1 < R1 + D1.points[f1 + 1].partialLength) {
                                for(F1 = (I1 - R1) / D1.points[f1 + 1].partialLength, l1 = D1.points[f1].point.length, h1 = 0; h1 < l1; h1 += 1)r1[h1] = D1.points[f1].point[h1] + (D1.points[f1 + 1].point[h1] - D1.points[f1].point[h1]) * F1;
                                break;
                            }
                            f1 < c1 - 1 ? f1 += 1 : g1 = !1;
                        }
                        e1._lastPoint = f1, e1._lastAddedLength = R1 - D1.points[f1].partialLength, e1._lastKeyframeIndex = m1;
                    }
                } else {
                    var B1, V1, O1, L1, $1;
                    if (y1 = a1.s.length, v1 = n1.s || a1.e, this.sh && 1 !== a1.h) {
                        if (t1 >= k1) r1[0] = v1[0], r1[1] = v1[1], r1[2] = v1[2];
                        else if (t1 <= T1) r1[0] = a1.s[0], r1[1] = a1.s[1], r1[2] = a1.s[2];
                        else {
                            var z1 = i1(a1.s), G1 = i1(v1);
                            b1 = r1, _1 = function(t1, e1, r1) {
                                var i1, s1, a1, n1, o1, h1 = [], l1 = t1[0], p1 = t1[1], c1 = t1[2], f1 = t1[3], d1 = e1[0], u1 = e1[1], m1 = e1[2], y1 = e1[3];
                                return (s1 = l1 * d1 + p1 * u1 + c1 * m1 + f1 * y1) < 0 && (s1 = -s1, d1 = -d1, u1 = -u1, m1 = -m1, y1 = -y1), 1 - s1 > 1e-6 ? (i1 = Math.acos(s1), a1 = Math.sin(i1), n1 = Math.sin((1 - r1) * i1) / a1, o1 = Math.sin(r1 * i1) / a1) : (n1 = 1 - r1, o1 = r1), h1[0] = n1 * l1 + o1 * d1, h1[1] = n1 * p1 + o1 * u1, h1[2] = n1 * c1 + o1 * m1, h1[3] = n1 * f1 + o1 * y1, h1;
                            }(z1, G1, (t1 - T1) / (k1 - T1)), P1 = _1[0], E1 = _1[1], S1 = _1[2], x1 = _1[3], A1 = Math.atan2(2 * E1 * x1 - 2 * P1 * S1, 1 - 2 * E1 * E1 - 2 * S1 * S1), w1 = Math.asin(2 * P1 * E1 + 2 * S1 * x1), C1 = Math.atan2(2 * P1 * x1 - 2 * E1 * S1, 1 - 2 * P1 * P1 - 2 * S1 * S1), b1[0] = A1 / degToRads, b1[1] = w1 / degToRads, b1[2] = C1 / degToRads;
                        }
                    } else for(m1 = 0; m1 < y1; m1 += 1)1 !== a1.h && (t1 >= k1 ? p1 = 1 : t1 < T1 ? p1 = 0 : (a1.o.x.constructor === Array ? (o1.__fnct || (o1.__fnct = []), o1.__fnct[m1] ? d1 = o1.__fnct[m1] : (B1 = void 0 === a1.o.x[m1] ? a1.o.x[0] : a1.o.x[m1], V1 = void 0 === a1.o.y[m1] ? a1.o.y[0] : a1.o.y[m1], O1 = void 0 === a1.i.x[m1] ? a1.i.x[0] : a1.i.x[m1], L1 = void 0 === a1.i.y[m1] ? a1.i.y[0] : a1.i.y[m1], d1 = BezierFactory.getBezierEasing(B1, V1, O1, L1).get, o1.__fnct[m1] = d1)) : o1.__fnct ? d1 = o1.__fnct : (B1 = a1.o.x, V1 = a1.o.y, O1 = a1.i.x, L1 = a1.i.y, d1 = BezierFactory.getBezierEasing(B1, V1, O1, L1).get, a1.keyframeMetadata = d1), p1 = d1((t1 - T1) / (k1 - T1)))), v1 = n1.s || a1.e, $1 = 1 === a1.h ? a1.s[m1] : a1.s[m1] + (v1[m1] - a1.s[m1]) * p1, "multidimensional" === this.propType ? r1[m1] = $1 : r1 = $1;
                }
                return e1.lastIndex = u1, r1;
            }
            function i1(t1) {
                var e1 = t1[0] * degToRads, r1 = t1[1] * degToRads, i1 = t1[2] * degToRads, s1 = Math.cos(e1 / 2), a1 = Math.cos(r1 / 2), n1 = Math.cos(i1 / 2), o1 = Math.sin(e1 / 2), h1 = Math.sin(r1 / 2), l1 = Math.sin(i1 / 2);
                return [
                    o1 * h1 * n1 + s1 * a1 * l1,
                    o1 * a1 * n1 + s1 * h1 * l1,
                    s1 * h1 * n1 - o1 * a1 * l1,
                    s1 * a1 * n1 - o1 * h1 * l1
                ];
            }
            function s1() {
                var e1 = this.comp.renderedFrame - this.offsetTime, r1 = this.keyframes[0].t - this.offsetTime, i1 = this.keyframes[this.keyframes.length - 1].t - this.offsetTime;
                if (!(e1 === this._caching.lastFrame || this._caching.lastFrame !== t1 && (this._caching.lastFrame >= i1 && e1 >= i1 || this._caching.lastFrame < r1 && e1 < r1))) {
                    this._caching.lastFrame >= e1 && (this._caching._lastKeyframeIndex = -1, this._caching.lastIndex = 0);
                    var s1 = this.interpolateValue(e1, this._caching);
                    this.pv = s1;
                }
                return this._caching.lastFrame = e1, this.pv;
            }
            function a1(t1) {
                var r1;
                if ("unidimensional" === this.propType) r1 = t1 * this.mult, e1(this.v - r1) > 1e-5 && (this.v = r1, this._mdf = !0);
                else for(var i1 = 0, s1 = this.v.length; i1 < s1;)r1 = t1[i1] * this.mult, e1(this.v[i1] - r1) > 1e-5 && (this.v[i1] = r1, this._mdf = !0), i1 += 1;
            }
            function n1() {
                if (this.elem.globalData.frameId !== this.frameId && this.effectsSequence.length) {
                    if (this.lock) this.setVValue(this.pv);
                    else {
                        var t1;
                        this.lock = !0, this._mdf = this._isFirstFrame;
                        var e1 = this.effectsSequence.length, r1 = this.kf ? this.pv : this.data.k;
                        for(t1 = 0; t1 < e1; t1 += 1)r1 = this.effectsSequence[t1](r1);
                        this.setVValue(r1), this._isFirstFrame = !1, this.lock = !1, this.frameId = this.elem.globalData.frameId;
                    }
                }
            }
            function o1(t1) {
                this.effectsSequence.push(t1), this.container.addDynamicProperty(this);
            }
            function h1(t1, e1, r1, i1) {
                this.propType = "unidimensional", this.mult = r1 || 1, this.data = e1, this.v = r1 ? e1.k * r1 : e1.k, this.pv = e1.k, this._mdf = !1, this.elem = t1, this.container = i1, this.comp = t1.comp, this.k = !1, this.kf = !1, this.vel = 0, this.effectsSequence = [], this._isFirstFrame = !0, this.getValue = n1, this.setVValue = a1, this.addEffect = o1;
            }
            function l1(t1, e1, r1, i1) {
                var s1;
                this.propType = "multidimensional", this.mult = r1 || 1, this.data = e1, this._mdf = !1, this.elem = t1, this.container = i1, this.comp = t1.comp, this.k = !1, this.kf = !1, this.frameId = -1;
                var h1 = e1.k.length;
                for(this.v = createTypedArray("float32", h1), this.pv = createTypedArray("float32", h1), this.vel = createTypedArray("float32", h1), s1 = 0; s1 < h1; s1 += 1)this.v[s1] = e1.k[s1] * this.mult, this.pv[s1] = e1.k[s1];
                this._isFirstFrame = !0, this.effectsSequence = [], this.getValue = n1, this.setVValue = a1, this.addEffect = o1;
            }
            function p1(e1, i1, h1, l1) {
                this.propType = "unidimensional", this.keyframes = i1.k, this.keyframesMetadata = [], this.offsetTime = e1.data.st, this.frameId = -1, this._caching = {
                    lastFrame: t1,
                    lastIndex: 0,
                    value: 0,
                    _lastKeyframeIndex: -1
                }, this.k = !0, this.kf = !0, this.data = i1, this.mult = h1 || 1, this.elem = e1, this.container = l1, this.comp = e1.comp, this.v = t1, this.pv = t1, this._isFirstFrame = !0, this.getValue = n1, this.setVValue = a1, this.interpolateValue = r1, this.effectsSequence = [
                    s1.bind(this)
                ], this.addEffect = o1;
            }
            function c1(e1, i1, h1, l1) {
                var p1;
                this.propType = "multidimensional";
                var c1, f1, d1, u1, m1 = i1.k.length;
                for(p1 = 0; p1 < m1 - 1; p1 += 1)i1.k[p1].to && i1.k[p1].s && i1.k[p1 + 1] && i1.k[p1 + 1].s && (c1 = i1.k[p1].s, f1 = i1.k[p1 + 1].s, d1 = i1.k[p1].to, u1 = i1.k[p1].ti, (2 === c1.length && (c1[0] !== f1[0] || c1[1] !== f1[1]) && bez.pointOnLine2D(c1[0], c1[1], f1[0], f1[1], c1[0] + d1[0], c1[1] + d1[1]) && bez.pointOnLine2D(c1[0], c1[1], f1[0], f1[1], f1[0] + u1[0], f1[1] + u1[1]) || 3 === c1.length && (c1[0] !== f1[0] || c1[1] !== f1[1] || c1[2] !== f1[2]) && bez.pointOnLine3D(c1[0], c1[1], c1[2], f1[0], f1[1], f1[2], c1[0] + d1[0], c1[1] + d1[1], c1[2] + d1[2]) && bez.pointOnLine3D(c1[0], c1[1], c1[2], f1[0], f1[1], f1[2], f1[0] + u1[0], f1[1] + u1[1], f1[2] + u1[2])) && (i1.k[p1].to = null, i1.k[p1].ti = null), c1[0] === f1[0] && c1[1] === f1[1] && 0 === d1[0] && 0 === d1[1] && 0 === u1[0] && 0 === u1[1] && (2 === c1.length || c1[2] === f1[2] && 0 === d1[2] && 0 === u1[2]) && (i1.k[p1].to = null, i1.k[p1].ti = null));
                this.effectsSequence = [
                    s1.bind(this)
                ], this.data = i1, this.keyframes = i1.k, this.keyframesMetadata = [], this.offsetTime = e1.data.st, this.k = !0, this.kf = !0, this._isFirstFrame = !0, this.mult = h1 || 1, this.elem = e1, this.container = l1, this.comp = e1.comp, this.getValue = n1, this.setVValue = a1, this.interpolateValue = r1, this.frameId = -1;
                var y1 = i1.k[0].s.length;
                for(this.v = createTypedArray("float32", y1), this.pv = createTypedArray("float32", y1), p1 = 0; p1 < y1; p1 += 1)this.v[p1] = t1, this.pv[p1] = t1;
                this._caching = {
                    lastFrame: t1,
                    lastIndex: 0,
                    value: createTypedArray("float32", y1)
                }, this.addEffect = o1;
            }
            var f1 = {
                getProp: function(t1, e1, r1, i1, s1) {
                    var a1;
                    if (e1.k.length) {
                        if ("number" == typeof e1.k[0]) a1 = new l1(t1, e1, i1, s1);
                        else switch(r1){
                            case 0:
                                a1 = new p1(t1, e1, i1, s1);
                                break;
                            case 1:
                                a1 = new c1(t1, e1, i1, s1);
                        }
                    } else a1 = new h1(t1, e1, i1, s1);
                    return a1.effectsSequence.length && s1.addDynamicProperty(a1), a1;
                }
            };
            return f1;
        }();
        function DynamicPropertyContainer() {}
        DynamicPropertyContainer.prototype = {
            addDynamicProperty: function(t1) {
                -1 === this.dynamicProperties.indexOf(t1) && (this.dynamicProperties.push(t1), this.container.addDynamicProperty(this), this._isAnimated = !0);
            },
            iterateDynamicProperties: function() {
                var t1;
                this._mdf = !1;
                var e1 = this.dynamicProperties.length;
                for(t1 = 0; t1 < e1; t1 += 1)this.dynamicProperties[t1].getValue(), this.dynamicProperties[t1]._mdf && (this._mdf = !0);
            },
            initDynamicPropertyContainer: function(t1) {
                this.container = t1, this.dynamicProperties = [], this._mdf = !1, this._isAnimated = !1;
            }
        };
        var pointPool = poolFactory(8, function() {
            return createTypedArray("float32", 2);
        });
        function ShapePath() {
            this.c = !1, this._length = 0, this._maxLength = 8, this.v = createSizedArray(this._maxLength), this.o = createSizedArray(this._maxLength), this.i = createSizedArray(this._maxLength);
        }
        ShapePath.prototype.setPathData = function(t1, e1) {
            this.c = t1, this.setLength(e1);
            for(var r1 = 0; r1 < e1;)this.v[r1] = pointPool.newElement(), this.o[r1] = pointPool.newElement(), this.i[r1] = pointPool.newElement(), r1 += 1;
        }, ShapePath.prototype.setLength = function(t1) {
            for(; this._maxLength < t1;)this.doubleArrayLength();
            this._length = t1;
        }, ShapePath.prototype.doubleArrayLength = function() {
            this.v = this.v.concat(createSizedArray(this._maxLength)), this.i = this.i.concat(createSizedArray(this._maxLength)), this.o = this.o.concat(createSizedArray(this._maxLength)), this._maxLength *= 2;
        }, ShapePath.prototype.setXYAt = function(t1, e1, r1, i1, s1) {
            var a1;
            switch(this._length = Math.max(this._length, i1 + 1), this._length >= this._maxLength && this.doubleArrayLength(), r1){
                case "v":
                    a1 = this.v;
                    break;
                case "i":
                    a1 = this.i;
                    break;
                case "o":
                    a1 = this.o;
                    break;
                default:
                    a1 = [];
            }
            (!a1[i1] || a1[i1] && !s1) && (a1[i1] = pointPool.newElement()), a1[i1][0] = t1, a1[i1][1] = e1;
        }, ShapePath.prototype.setTripleAt = function(t1, e1, r1, i1, s1, a1, n1, o1) {
            this.setXYAt(t1, e1, "v", n1, o1), this.setXYAt(r1, i1, "o", n1, o1), this.setXYAt(s1, a1, "i", n1, o1);
        }, ShapePath.prototype.reverse = function() {
            var t1 = new ShapePath;
            t1.setPathData(this.c, this._length);
            var e1 = this.v, r1 = this.o, i1 = this.i, s1 = 0;
            this.c && (t1.setTripleAt(e1[0][0], e1[0][1], i1[0][0], i1[0][1], r1[0][0], r1[0][1], 0, !1), s1 = 1);
            var a1, n1 = this._length - 1, o1 = this._length;
            for(a1 = s1; a1 < o1; a1 += 1)t1.setTripleAt(e1[n1][0], e1[n1][1], i1[n1][0], i1[n1][1], r1[n1][0], r1[n1][1], a1, !1), n1 -= 1;
            return t1;
        }, ShapePath.prototype.length = function() {
            return this._length;
        };
        var shapePool = (factory = poolFactory(4, function() {
            return new ShapePath;
        }, function(t1) {
            var e1, r1 = t1._length;
            for(e1 = 0; e1 < r1; e1 += 1)pointPool.release(t1.v[e1]), pointPool.release(t1.i[e1]), pointPool.release(t1.o[e1]), t1.v[e1] = null, t1.i[e1] = null, t1.o[e1] = null;
            t1._length = 0, t1.c = !1;
        }), factory.clone = function(t1) {
            var e1, r1 = factory.newElement(), i1 = void 0 === t1._length ? t1.v.length : t1._length;
            for(r1.setLength(i1), r1.c = t1.c, e1 = 0; e1 < i1; e1 += 1)r1.setTripleAt(t1.v[e1][0], t1.v[e1][1], t1.o[e1][0], t1.o[e1][1], t1.i[e1][0], t1.i[e1][1], e1);
            return r1;
        }, factory), factory;
        function ShapeCollection() {
            this._length = 0, this._maxLength = 4, this.shapes = createSizedArray(this._maxLength);
        }
        ShapeCollection.prototype.addShape = function(t1) {
            this._length === this._maxLength && (this.shapes = this.shapes.concat(createSizedArray(this._maxLength)), this._maxLength *= 2), this.shapes[this._length] = t1, this._length += 1;
        }, ShapeCollection.prototype.releaseShapes = function() {
            var t1;
            for(t1 = 0; t1 < this._length; t1 += 1)shapePool.release(this.shapes[t1]);
            this._length = 0;
        };
        var shapeCollectionPool = (ob = {
            newShapeCollection: function() {
                return _length ? pool[_length -= 1] : new ShapeCollection;
            },
            release: function(t1) {
                var e1, r1 = t1._length;
                for(e1 = 0; e1 < r1; e1 += 1)shapePool.release(t1.shapes[e1]);
                t1._length = 0, _length === _maxLength && (pool = pooling.double(pool), _maxLength *= 2), pool[_length] = t1, _length += 1;
            }
        }, _length = 0, _maxLength = 4, pool = createSizedArray(_maxLength), ob), ob, _length, _maxLength, pool, ShapePropertyFactory = function() {
            var t1 = -999999;
            function e1(t1, e1, r1) {
                var i1, s1, a1, n1, o1, h1, l1, p1, c1, f1 = r1.lastIndex, d1 = this.keyframes;
                if (t1 < d1[0].t - this.offsetTime) i1 = d1[0].s[0], a1 = !0, f1 = 0;
                else if (t1 >= d1[d1.length - 1].t - this.offsetTime) i1 = d1[d1.length - 1].s ? d1[d1.length - 1].s[0] : d1[d1.length - 2].e[0], a1 = !0;
                else {
                    for(var u1, m1, y1, g1 = f1, v1 = d1.length - 1, b1 = !0; b1 && (u1 = d1[g1], !((m1 = d1[g1 + 1]).t - this.offsetTime > t1));)g1 < v1 - 1 ? g1 += 1 : b1 = !1;
                    if (y1 = this.keyframesMetadata[g1] || {}, f1 = g1, !(a1 = 1 === u1.h)) {
                        if (t1 >= m1.t - this.offsetTime) p1 = 1;
                        else if (t1 < u1.t - this.offsetTime) p1 = 0;
                        else {
                            var _1;
                            y1.__fnct ? _1 = y1.__fnct : (_1 = BezierFactory.getBezierEasing(u1.o.x, u1.o.y, u1.i.x, u1.i.y).get, y1.__fnct = _1), p1 = _1((t1 - (u1.t - this.offsetTime)) / (m1.t - this.offsetTime - (u1.t - this.offsetTime)));
                        }
                        s1 = m1.s ? m1.s[0] : u1.e[0];
                    }
                    i1 = u1.s[0];
                }
                for(h1 = e1._length, l1 = i1.i[0].length, r1.lastIndex = f1, n1 = 0; n1 < h1; n1 += 1)for(o1 = 0; o1 < l1; o1 += 1)c1 = a1 ? i1.i[n1][o1] : i1.i[n1][o1] + (s1.i[n1][o1] - i1.i[n1][o1]) * p1, e1.i[n1][o1] = c1, c1 = a1 ? i1.o[n1][o1] : i1.o[n1][o1] + (s1.o[n1][o1] - i1.o[n1][o1]) * p1, e1.o[n1][o1] = c1, c1 = a1 ? i1.v[n1][o1] : i1.v[n1][o1] + (s1.v[n1][o1] - i1.v[n1][o1]) * p1, e1.v[n1][o1] = c1;
            }
            function r1() {
                var e1 = this.comp.renderedFrame - this.offsetTime, r1 = this.keyframes[0].t - this.offsetTime, i1 = this.keyframes[this.keyframes.length - 1].t - this.offsetTime, s1 = this._caching.lastFrame;
                return s1 !== t1 && (s1 < r1 && e1 < r1 || s1 > i1 && e1 > i1) || (this._caching.lastIndex = s1 < e1 ? this._caching.lastIndex : 0, this.interpolateShape(e1, this.pv, this._caching)), this._caching.lastFrame = e1, this.pv;
            }
            function i1() {
                this.paths = this.localShapeCollection;
            }
            function s1(t1) {
                (function(t1, e1) {
                    if (t1._length !== e1._length || t1.c !== e1.c) return !1;
                    var r1, i1 = t1._length;
                    for(r1 = 0; r1 < i1; r1 += 1)if (t1.v[r1][0] !== e1.v[r1][0] || t1.v[r1][1] !== e1.v[r1][1] || t1.o[r1][0] !== e1.o[r1][0] || t1.o[r1][1] !== e1.o[r1][1] || t1.i[r1][0] !== e1.i[r1][0] || t1.i[r1][1] !== e1.i[r1][1]) return !1;
                    return !0;
                })(this.v, t1) || (this.v = shapePool.clone(t1), this.localShapeCollection.releaseShapes(), this.localShapeCollection.addShape(this.v), this._mdf = !0, this.paths = this.localShapeCollection);
            }
            function a1() {
                if (this.elem.globalData.frameId !== this.frameId) {
                    if (this.effectsSequence.length) {
                        if (this.lock) this.setVValue(this.pv);
                        else {
                            var t1, e1;
                            this.lock = !0, this._mdf = !1, t1 = this.kf ? this.pv : this.data.ks ? this.data.ks.k : this.data.pt.k;
                            var r1 = this.effectsSequence.length;
                            for(e1 = 0; e1 < r1; e1 += 1)t1 = this.effectsSequence[e1](t1);
                            this.setVValue(t1), this.lock = !1, this.frameId = this.elem.globalData.frameId;
                        }
                    } else this._mdf = !1;
                }
            }
            function n1(t1, e1, r1) {
                this.propType = "shape", this.comp = t1.comp, this.container = t1, this.elem = t1, this.data = e1, this.k = !1, this.kf = !1, this._mdf = !1;
                var s1 = 3 === r1 ? e1.pt.k : e1.ks.k;
                this.v = shapePool.clone(s1), this.pv = shapePool.clone(this.v), this.localShapeCollection = shapeCollectionPool.newShapeCollection(), this.paths = this.localShapeCollection, this.paths.addShape(this.v), this.reset = i1, this.effectsSequence = [];
            }
            function o1(t1) {
                this.effectsSequence.push(t1), this.container.addDynamicProperty(this);
            }
            function h1(e1, s1, a1) {
                this.propType = "shape", this.comp = e1.comp, this.elem = e1, this.container = e1, this.offsetTime = e1.data.st, this.keyframes = 3 === a1 ? s1.pt.k : s1.ks.k, this.keyframesMetadata = [], this.k = !0, this.kf = !0;
                var n1 = this.keyframes[0].s[0].i.length;
                this.v = shapePool.newElement(), this.v.setPathData(this.keyframes[0].s[0].c, n1), this.pv = shapePool.clone(this.v), this.localShapeCollection = shapeCollectionPool.newShapeCollection(), this.paths = this.localShapeCollection, this.paths.addShape(this.v), this.lastFrame = t1, this.reset = i1, this._caching = {
                    lastFrame: t1,
                    lastIndex: 0
                }, this.effectsSequence = [
                    r1.bind(this)
                ];
            }
            n1.prototype.interpolateShape = e1, n1.prototype.getValue = a1, n1.prototype.setVValue = s1, n1.prototype.addEffect = o1, h1.prototype.getValue = a1, h1.prototype.interpolateShape = e1, h1.prototype.setVValue = s1, h1.prototype.addEffect = o1;
            var l1 = function() {
                var t1 = roundCorner;
                function e1(t1, e1) {
                    this.v = shapePool.newElement(), this.v.setPathData(!0, 4), this.localShapeCollection = shapeCollectionPool.newShapeCollection(), this.paths = this.localShapeCollection, this.localShapeCollection.addShape(this.v), this.d = e1.d, this.elem = t1, this.comp = t1.comp, this.frameId = -1, this.initDynamicPropertyContainer(t1), this.p = PropertyFactory.getProp(t1, e1.p, 1, 0, this), this.s = PropertyFactory.getProp(t1, e1.s, 1, 0, this), this.dynamicProperties.length ? this.k = !0 : (this.k = !1, this.convertEllToPath());
                }
                return e1.prototype = {
                    reset: i1,
                    getValue: function() {
                        this.elem.globalData.frameId !== this.frameId && (this.frameId = this.elem.globalData.frameId, this.iterateDynamicProperties(), this._mdf && this.convertEllToPath());
                    },
                    convertEllToPath: function() {
                        var e1 = this.p.v[0], r1 = this.p.v[1], i1 = this.s.v[0] / 2, s1 = this.s.v[1] / 2, a1 = 3 !== this.d, n1 = this.v;
                        n1.v[0][0] = e1, n1.v[0][1] = r1 - s1, n1.v[1][0] = a1 ? e1 + i1 : e1 - i1, n1.v[1][1] = r1, n1.v[2][0] = e1, n1.v[2][1] = r1 + s1, n1.v[3][0] = a1 ? e1 - i1 : e1 + i1, n1.v[3][1] = r1, n1.i[0][0] = a1 ? e1 - i1 * t1 : e1 + i1 * t1, n1.i[0][1] = r1 - s1, n1.i[1][0] = a1 ? e1 + i1 : e1 - i1, n1.i[1][1] = r1 - s1 * t1, n1.i[2][0] = a1 ? e1 + i1 * t1 : e1 - i1 * t1, n1.i[2][1] = r1 + s1, n1.i[3][0] = a1 ? e1 - i1 : e1 + i1, n1.i[3][1] = r1 + s1 * t1, n1.o[0][0] = a1 ? e1 + i1 * t1 : e1 - i1 * t1, n1.o[0][1] = r1 - s1, n1.o[1][0] = a1 ? e1 + i1 : e1 - i1, n1.o[1][1] = r1 + s1 * t1, n1.o[2][0] = a1 ? e1 - i1 * t1 : e1 + i1 * t1, n1.o[2][1] = r1 + s1, n1.o[3][0] = a1 ? e1 - i1 : e1 + i1, n1.o[3][1] = r1 - s1 * t1;
                    }
                }, extendPrototype([
                    DynamicPropertyContainer
                ], e1), e1;
            }(), p1 = function() {
                function t1(t1, e1) {
                    this.v = shapePool.newElement(), this.v.setPathData(!0, 0), this.elem = t1, this.comp = t1.comp, this.data = e1, this.frameId = -1, this.d = e1.d, this.initDynamicPropertyContainer(t1), 1 === e1.sy ? (this.ir = PropertyFactory.getProp(t1, e1.ir, 0, 0, this), this.is = PropertyFactory.getProp(t1, e1.is, 0, .01, this), this.convertToPath = this.convertStarToPath) : this.convertToPath = this.convertPolygonToPath, this.pt = PropertyFactory.getProp(t1, e1.pt, 0, 0, this), this.p = PropertyFactory.getProp(t1, e1.p, 1, 0, this), this.r = PropertyFactory.getProp(t1, e1.r, 0, degToRads, this), this.or = PropertyFactory.getProp(t1, e1.or, 0, 0, this), this.os = PropertyFactory.getProp(t1, e1.os, 0, .01, this), this.localShapeCollection = shapeCollectionPool.newShapeCollection(), this.localShapeCollection.addShape(this.v), this.paths = this.localShapeCollection, this.dynamicProperties.length ? this.k = !0 : (this.k = !1, this.convertToPath());
                }
                return t1.prototype = {
                    reset: i1,
                    getValue: function() {
                        this.elem.globalData.frameId !== this.frameId && (this.frameId = this.elem.globalData.frameId, this.iterateDynamicProperties(), this._mdf && this.convertToPath());
                    },
                    convertStarToPath: function() {
                        var t1, e1, r1, i1, s1 = 2 * Math.floor(this.pt.v), a1 = 2 * Math.PI / s1, n1 = !0, o1 = this.or.v, h1 = this.ir.v, l1 = this.os.v, p1 = this.is.v, c1 = 2 * Math.PI * o1 / (2 * s1), f1 = 2 * Math.PI * h1 / (2 * s1), d1 = -Math.PI / 2;
                        d1 += this.r.v;
                        var u1 = 3 === this.data.d ? -1 : 1;
                        for(this.v._length = 0, t1 = 0; t1 < s1; t1 += 1){
                            r1 = n1 ? l1 : p1, i1 = n1 ? c1 : f1;
                            var m1 = (e1 = n1 ? o1 : h1) * Math.cos(d1), y1 = e1 * Math.sin(d1), g1 = 0 === m1 && 0 === y1 ? 0 : y1 / Math.sqrt(m1 * m1 + y1 * y1), v1 = 0 === m1 && 0 === y1 ? 0 : -m1 / Math.sqrt(m1 * m1 + y1 * y1);
                            m1 += +this.p.v[0], y1 += +this.p.v[1], this.v.setTripleAt(m1, y1, m1 - g1 * i1 * r1 * u1, y1 - v1 * i1 * r1 * u1, m1 + g1 * i1 * r1 * u1, y1 + v1 * i1 * r1 * u1, t1, !0), n1 = !n1, d1 += a1 * u1;
                        }
                    },
                    convertPolygonToPath: function() {
                        var t1, e1 = Math.floor(this.pt.v), r1 = 2 * Math.PI / e1, i1 = this.or.v, s1 = this.os.v, a1 = 2 * Math.PI * i1 / (4 * e1), n1 = .5 * -Math.PI, o1 = 3 === this.data.d ? -1 : 1;
                        for(n1 += this.r.v, this.v._length = 0, t1 = 0; t1 < e1; t1 += 1){
                            var h1 = i1 * Math.cos(n1), l1 = i1 * Math.sin(n1), p1 = 0 === h1 && 0 === l1 ? 0 : l1 / Math.sqrt(h1 * h1 + l1 * l1), c1 = 0 === h1 && 0 === l1 ? 0 : -h1 / Math.sqrt(h1 * h1 + l1 * l1);
                            h1 += +this.p.v[0], l1 += +this.p.v[1], this.v.setTripleAt(h1, l1, h1 - p1 * a1 * s1 * o1, l1 - c1 * a1 * s1 * o1, h1 + p1 * a1 * s1 * o1, l1 + c1 * a1 * s1 * o1, t1, !0), n1 += r1 * o1;
                        }
                        this.paths.length = 0, this.paths[0] = this.v;
                    }
                }, extendPrototype([
                    DynamicPropertyContainer
                ], t1), t1;
            }(), c1 = function() {
                function t1(t1, e1) {
                    this.v = shapePool.newElement(), this.v.c = !0, this.localShapeCollection = shapeCollectionPool.newShapeCollection(), this.localShapeCollection.addShape(this.v), this.paths = this.localShapeCollection, this.elem = t1, this.comp = t1.comp, this.frameId = -1, this.d = e1.d, this.initDynamicPropertyContainer(t1), this.p = PropertyFactory.getProp(t1, e1.p, 1, 0, this), this.s = PropertyFactory.getProp(t1, e1.s, 1, 0, this), this.r = PropertyFactory.getProp(t1, e1.r, 0, 0, this), this.dynamicProperties.length ? this.k = !0 : (this.k = !1, this.convertRectToPath());
                }
                return t1.prototype = {
                    convertRectToPath: function() {
                        var t1 = this.p.v[0], e1 = this.p.v[1], r1 = this.s.v[0] / 2, i1 = this.s.v[1] / 2, s1 = bmMin(r1, i1, this.r.v), a1 = s1 * (1 - roundCorner);
                        this.v._length = 0, 2 === this.d || 1 === this.d ? (this.v.setTripleAt(t1 + r1, e1 - i1 + s1, t1 + r1, e1 - i1 + s1, t1 + r1, e1 - i1 + a1, 0, !0), this.v.setTripleAt(t1 + r1, e1 + i1 - s1, t1 + r1, e1 + i1 - a1, t1 + r1, e1 + i1 - s1, 1, !0), 0 !== s1 ? (this.v.setTripleAt(t1 + r1 - s1, e1 + i1, t1 + r1 - s1, e1 + i1, t1 + r1 - a1, e1 + i1, 2, !0), this.v.setTripleAt(t1 - r1 + s1, e1 + i1, t1 - r1 + a1, e1 + i1, t1 - r1 + s1, e1 + i1, 3, !0), this.v.setTripleAt(t1 - r1, e1 + i1 - s1, t1 - r1, e1 + i1 - s1, t1 - r1, e1 + i1 - a1, 4, !0), this.v.setTripleAt(t1 - r1, e1 - i1 + s1, t1 - r1, e1 - i1 + a1, t1 - r1, e1 - i1 + s1, 5, !0), this.v.setTripleAt(t1 - r1 + s1, e1 - i1, t1 - r1 + s1, e1 - i1, t1 - r1 + a1, e1 - i1, 6, !0), this.v.setTripleAt(t1 + r1 - s1, e1 - i1, t1 + r1 - a1, e1 - i1, t1 + r1 - s1, e1 - i1, 7, !0)) : (this.v.setTripleAt(t1 - r1, e1 + i1, t1 - r1 + a1, e1 + i1, t1 - r1, e1 + i1, 2), this.v.setTripleAt(t1 - r1, e1 - i1, t1 - r1, e1 - i1 + a1, t1 - r1, e1 - i1, 3))) : (this.v.setTripleAt(t1 + r1, e1 - i1 + s1, t1 + r1, e1 - i1 + a1, t1 + r1, e1 - i1 + s1, 0, !0), 0 !== s1 ? (this.v.setTripleAt(t1 + r1 - s1, e1 - i1, t1 + r1 - s1, e1 - i1, t1 + r1 - a1, e1 - i1, 1, !0), this.v.setTripleAt(t1 - r1 + s1, e1 - i1, t1 - r1 + a1, e1 - i1, t1 - r1 + s1, e1 - i1, 2, !0), this.v.setTripleAt(t1 - r1, e1 - i1 + s1, t1 - r1, e1 - i1 + s1, t1 - r1, e1 - i1 + a1, 3, !0), this.v.setTripleAt(t1 - r1, e1 + i1 - s1, t1 - r1, e1 + i1 - a1, t1 - r1, e1 + i1 - s1, 4, !0), this.v.setTripleAt(t1 - r1 + s1, e1 + i1, t1 - r1 + s1, e1 + i1, t1 - r1 + a1, e1 + i1, 5, !0), this.v.setTripleAt(t1 + r1 - s1, e1 + i1, t1 + r1 - a1, e1 + i1, t1 + r1 - s1, e1 + i1, 6, !0), this.v.setTripleAt(t1 + r1, e1 + i1 - s1, t1 + r1, e1 + i1 - s1, t1 + r1, e1 + i1 - a1, 7, !0)) : (this.v.setTripleAt(t1 - r1, e1 - i1, t1 - r1 + a1, e1 - i1, t1 - r1, e1 - i1, 1, !0), this.v.setTripleAt(t1 - r1, e1 + i1, t1 - r1, e1 + i1 - a1, t1 - r1, e1 + i1, 2, !0), this.v.setTripleAt(t1 + r1, e1 + i1, t1 + r1 - a1, e1 + i1, t1 + r1, e1 + i1, 3, !0)));
                    },
                    getValue: function() {
                        this.elem.globalData.frameId !== this.frameId && (this.frameId = this.elem.globalData.frameId, this.iterateDynamicProperties(), this._mdf && this.convertRectToPath());
                    },
                    reset: i1
                }, extendPrototype([
                    DynamicPropertyContainer
                ], t1), t1;
            }(), f1 = {
                getShapeProp: function(t1, e1, r1) {
                    var i1;
                    return 3 === r1 || 4 === r1 ? i1 = (3 === r1 ? e1.pt : e1.ks).k.length ? new h1(t1, e1, r1) : new n1(t1, e1, r1) : 5 === r1 ? i1 = new c1(t1, e1) : 6 === r1 ? i1 = new l1(t1, e1) : 7 === r1 && (i1 = new p1(t1, e1)), i1.k && t1.addDynamicProperty(i1), i1;
                },
                getConstructorFunction: function() {
                    return n1;
                },
                getKeyframedConstructorFunction: function() {
                    return h1;
                }
            };
            return f1;
        }(), Matrix = function() {
            var t1 = Math.cos, e1 = Math.sin, r1 = Math.tan, i1 = Math.round;
            function s1() {
                return this.props[0] = 1, this.props[1] = 0, this.props[2] = 0, this.props[3] = 0, this.props[4] = 0, this.props[5] = 1, this.props[6] = 0, this.props[7] = 0, this.props[8] = 0, this.props[9] = 0, this.props[10] = 1, this.props[11] = 0, this.props[12] = 0, this.props[13] = 0, this.props[14] = 0, this.props[15] = 1, this;
            }
            function a1(r1) {
                if (0 === r1) return this;
                var i1 = t1(r1), s1 = e1(r1);
                return this._t(i1, -s1, 0, 0, s1, i1, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1);
            }
            function n1(r1) {
                if (0 === r1) return this;
                var i1 = t1(r1), s1 = e1(r1);
                return this._t(1, 0, 0, 0, 0, i1, -s1, 0, 0, s1, i1, 0, 0, 0, 0, 1);
            }
            function o1(r1) {
                if (0 === r1) return this;
                var i1 = t1(r1), s1 = e1(r1);
                return this._t(i1, 0, s1, 0, 0, 1, 0, 0, -s1, 0, i1, 0, 0, 0, 0, 1);
            }
            function h1(r1) {
                if (0 === r1) return this;
                var i1 = t1(r1), s1 = e1(r1);
                return this._t(i1, -s1, 0, 0, s1, i1, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1);
            }
            function l1(t1, e1) {
                return this._t(1, e1, t1, 1, 0, 0);
            }
            function p1(t1, e1) {
                return this.shear(r1(t1), r1(e1));
            }
            function c1(i1, s1) {
                var a1 = t1(s1), n1 = e1(s1);
                return this._t(a1, n1, 0, 0, -n1, a1, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1)._t(1, 0, 0, 0, r1(i1), 1, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1)._t(a1, -n1, 0, 0, n1, a1, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1);
            }
            function f1(t1, e1, r1) {
                return r1 || 0 === r1 || (r1 = 1), 1 === t1 && 1 === e1 && 1 === r1 ? this : this._t(t1, 0, 0, 0, 0, e1, 0, 0, 0, 0, r1, 0, 0, 0, 0, 1);
            }
            function d1(t1, e1, r1, i1, s1, a1, n1, o1, h1, l1, p1, c1, f1, d1, u1, m1) {
                return this.props[0] = t1, this.props[1] = e1, this.props[2] = r1, this.props[3] = i1, this.props[4] = s1, this.props[5] = a1, this.props[6] = n1, this.props[7] = o1, this.props[8] = h1, this.props[9] = l1, this.props[10] = p1, this.props[11] = c1, this.props[12] = f1, this.props[13] = d1, this.props[14] = u1, this.props[15] = m1, this;
            }
            function u1(t1, e1, r1) {
                return r1 = r1 || 0, 0 !== t1 || 0 !== e1 || 0 !== r1 ? this._t(1, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1, 0, t1, e1, r1, 1) : this;
            }
            function m1(t1, e1, r1, i1, s1, a1, n1, o1, h1, l1, p1, c1, f1, d1, u1, m1) {
                var y1 = this.props;
                if (1 === t1 && 0 === e1 && 0 === r1 && 0 === i1 && 0 === s1 && 1 === a1 && 0 === n1 && 0 === o1 && 0 === h1 && 0 === l1 && 1 === p1 && 0 === c1) return y1[12] = y1[12] * t1 + y1[15] * f1, y1[13] = y1[13] * a1 + y1[15] * d1, y1[14] = y1[14] * p1 + y1[15] * u1, y1[15] *= m1, this._identityCalculated = !1, this;
                var g1 = y1[0], v1 = y1[1], b1 = y1[2], _1 = y1[3], P1 = y1[4], E1 = y1[5], S1 = y1[6], x1 = y1[7], A1 = y1[8], w1 = y1[9], C1 = y1[10], k1 = y1[11], T1 = y1[12], D1 = y1[13], M1 = y1[14], F1 = y1[15];
                return y1[0] = g1 * t1 + v1 * s1 + b1 * h1 + _1 * f1, y1[1] = g1 * e1 + v1 * a1 + b1 * l1 + _1 * d1, y1[2] = g1 * r1 + v1 * n1 + b1 * p1 + _1 * u1, y1[3] = g1 * i1 + v1 * o1 + b1 * c1 + _1 * m1, y1[4] = P1 * t1 + E1 * s1 + S1 * h1 + x1 * f1, y1[5] = P1 * e1 + E1 * a1 + S1 * l1 + x1 * d1, y1[6] = P1 * r1 + E1 * n1 + S1 * p1 + x1 * u1, y1[7] = P1 * i1 + E1 * o1 + S1 * c1 + x1 * m1, y1[8] = A1 * t1 + w1 * s1 + C1 * h1 + k1 * f1, y1[9] = A1 * e1 + w1 * a1 + C1 * l1 + k1 * d1, y1[10] = A1 * r1 + w1 * n1 + C1 * p1 + k1 * u1, y1[11] = A1 * i1 + w1 * o1 + C1 * c1 + k1 * m1, y1[12] = T1 * t1 + D1 * s1 + M1 * h1 + F1 * f1, y1[13] = T1 * e1 + D1 * a1 + M1 * l1 + F1 * d1, y1[14] = T1 * r1 + D1 * n1 + M1 * p1 + F1 * u1, y1[15] = T1 * i1 + D1 * o1 + M1 * c1 + F1 * m1, this._identityCalculated = !1, this;
            }
            function y1() {
                return this._identityCalculated || (this._identity = !(1 !== this.props[0] || 0 !== this.props[1] || 0 !== this.props[2] || 0 !== this.props[3] || 0 !== this.props[4] || 1 !== this.props[5] || 0 !== this.props[6] || 0 !== this.props[7] || 0 !== this.props[8] || 0 !== this.props[9] || 1 !== this.props[10] || 0 !== this.props[11] || 0 !== this.props[12] || 0 !== this.props[13] || 0 !== this.props[14] || 1 !== this.props[15]), this._identityCalculated = !0), this._identity;
            }
            function g1(t1) {
                for(var e1 = 0; e1 < 16;){
                    if (t1.props[e1] !== this.props[e1]) return !1;
                    e1 += 1;
                }
                return !0;
            }
            function v1(t1) {
                var e1;
                for(e1 = 0; e1 < 16; e1 += 1)t1.props[e1] = this.props[e1];
                return t1;
            }
            function b1(t1) {
                var e1;
                for(e1 = 0; e1 < 16; e1 += 1)this.props[e1] = t1[e1];
            }
            function _1(t1, e1, r1) {
                return {
                    x: t1 * this.props[0] + e1 * this.props[4] + r1 * this.props[8] + this.props[12],
                    y: t1 * this.props[1] + e1 * this.props[5] + r1 * this.props[9] + this.props[13],
                    z: t1 * this.props[2] + e1 * this.props[6] + r1 * this.props[10] + this.props[14]
                };
            }
            function P1(t1, e1, r1) {
                return t1 * this.props[0] + e1 * this.props[4] + r1 * this.props[8] + this.props[12];
            }
            function E1(t1, e1, r1) {
                return t1 * this.props[1] + e1 * this.props[5] + r1 * this.props[9] + this.props[13];
            }
            function S1(t1, e1, r1) {
                return t1 * this.props[2] + e1 * this.props[6] + r1 * this.props[10] + this.props[14];
            }
            function x1() {
                var t1 = this.props[0] * this.props[5] - this.props[1] * this.props[4], e1 = this.props[5] / t1, r1 = -this.props[1] / t1, i1 = -this.props[4] / t1, s1 = this.props[0] / t1, a1 = (this.props[4] * this.props[13] - this.props[5] * this.props[12]) / t1, n1 = -(this.props[0] * this.props[13] - this.props[1] * this.props[12]) / t1, o1 = new Matrix;
                return o1.props[0] = e1, o1.props[1] = r1, o1.props[4] = i1, o1.props[5] = s1, o1.props[12] = a1, o1.props[13] = n1, o1;
            }
            function A1(t1) {
                return this.getInverseMatrix().applyToPointArray(t1[0], t1[1], t1[2] || 0);
            }
            function w1(t1) {
                var e1, r1 = t1.length, i1 = [];
                for(e1 = 0; e1 < r1; e1 += 1)i1[e1] = A1(t1[e1]);
                return i1;
            }
            function C1(t1, e1, r1) {
                var i1 = createTypedArray("float32", 6);
                if (this.isIdentity()) i1[0] = t1[0], i1[1] = t1[1], i1[2] = e1[0], i1[3] = e1[1], i1[4] = r1[0], i1[5] = r1[1];
                else {
                    var s1 = this.props[0], a1 = this.props[1], n1 = this.props[4], o1 = this.props[5], h1 = this.props[12], l1 = this.props[13];
                    i1[0] = t1[0] * s1 + t1[1] * n1 + h1, i1[1] = t1[0] * a1 + t1[1] * o1 + l1, i1[2] = e1[0] * s1 + e1[1] * n1 + h1, i1[3] = e1[0] * a1 + e1[1] * o1 + l1, i1[4] = r1[0] * s1 + r1[1] * n1 + h1, i1[5] = r1[0] * a1 + r1[1] * o1 + l1;
                }
                return i1;
            }
            function k1(t1, e1, r1) {
                return this.isIdentity() ? [
                    t1,
                    e1,
                    r1
                ] : [
                    t1 * this.props[0] + e1 * this.props[4] + r1 * this.props[8] + this.props[12],
                    t1 * this.props[1] + e1 * this.props[5] + r1 * this.props[9] + this.props[13],
                    t1 * this.props[2] + e1 * this.props[6] + r1 * this.props[10] + this.props[14]
                ];
            }
            function T1(t1, e1) {
                if (this.isIdentity()) return t1 + "," + e1;
                var r1 = this.props;
                return Math.round(100 * (t1 * r1[0] + e1 * r1[4] + r1[12])) / 100 + "," + Math.round(100 * (t1 * r1[1] + e1 * r1[5] + r1[13])) / 100;
            }
            function D1() {
                for(var t1 = 0, e1 = this.props, r1 = "matrix3d("; t1 < 16;)r1 += i1(1e4 * e1[t1]) / 1e4, r1 += 15 === t1 ? ")" : ",", t1 += 1;
                return r1;
            }
            function M1(t1) {
                return t1 < 1e-6 && t1 > 0 || t1 > -0.000001 && t1 < 0 ? i1(1e4 * t1) / 1e4 : t1;
            }
            function F1() {
                var t1 = this.props;
                return "matrix(" + M1(t1[0]) + "," + M1(t1[1]) + "," + M1(t1[4]) + "," + M1(t1[5]) + "," + M1(t1[12]) + "," + M1(t1[13]) + ")";
            }
            return function() {
                this.reset = s1, this.rotate = a1, this.rotateX = n1, this.rotateY = o1, this.rotateZ = h1, this.skew = p1, this.skewFromAxis = c1, this.shear = l1, this.scale = f1, this.setTransform = d1, this.translate = u1, this.transform = m1, this.applyToPoint = _1, this.applyToX = P1, this.applyToY = E1, this.applyToZ = S1, this.applyToPointArray = k1, this.applyToTriplePoints = C1, this.applyToPointStringified = T1, this.toCSS = D1, this.to2dCSS = F1, this.clone = v1, this.cloneFromProps = b1, this.equals = g1, this.inversePoints = w1, this.inversePoint = A1, this.getInverseMatrix = x1, this._t = this.transform, this.isIdentity = y1, this._identity = !0, this._identityCalculated = !1, this.props = createTypedArray("float32", 16), this.reset();
            };
        }();
        function _typeof$3(t1) {
            return _typeof$3 = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(t1) {
                return typeof t1;
            } : function(t1) {
                return t1 && "function" == typeof Symbol && t1.constructor === Symbol && t1 !== Symbol.prototype ? "symbol" : typeof t1;
            }, _typeof$3(t1);
        }
        var lottie = {}, standalone = "__[STANDALONE]__", animationData = "__[ANIMATIONDATA]__", renderer = "";
        function setLocation(t1) {
            setLocationHref(t1);
        }
        function searchAnimations() {
            !0 === standalone ? animationManager.searchAnimations(animationData, standalone, renderer) : animationManager.searchAnimations();
        }
        function setSubframeRendering(t1) {
            setSubframeEnabled(t1);
        }
        function setPrefix(t1) {
            setIdPrefix(t1);
        }
        function loadAnimation(t1) {
            return !0 === standalone && (t1.animationData = JSON.parse(animationData)), animationManager.loadAnimation(t1);
        }
        function setQuality(t1) {
            if ("string" == typeof t1) switch(t1){
                case "high":
                    setDefaultCurveSegments(200);
                    break;
                default:
                case "medium":
                    setDefaultCurveSegments(50);
                    break;
                case "low":
                    setDefaultCurveSegments(10);
            }
            else !isNaN(t1) && t1 > 1 && setDefaultCurveSegments(t1);
            getDefaultCurveSegments() >= 50 ? roundValues(!1) : roundValues(!0);
        }
        function inBrowser() {
            return "undefined" != typeof navigator;
        }
        function installPlugin(t1, e1) {
            "expressions" === t1 && setExpressionsPlugin(e1);
        }
        function getFactory(t1) {
            switch(t1){
                case "propertyFactory":
                    return PropertyFactory;
                case "shapePropertyFactory":
                    return ShapePropertyFactory;
                case "matrix":
                    return Matrix;
                default:
                    return null;
            }
        }
        function checkReady() {
            "complete" === document.readyState && (clearInterval(readyStateCheckInterval), searchAnimations());
        }
        function getQueryVariable(t1) {
            for(var e1 = queryString.split("&"), r1 = 0; r1 < e1.length; r1 += 1){
                var i1 = e1[r1].split("=");
                if (decodeURIComponent(i1[0]) == t1) return decodeURIComponent(i1[1]);
            }
            return null;
        }
        lottie.play = animationManager.play, lottie.pause = animationManager.pause, lottie.setLocationHref = setLocation, lottie.togglePause = animationManager.togglePause, lottie.setSpeed = animationManager.setSpeed, lottie.setDirection = animationManager.setDirection, lottie.stop = animationManager.stop, lottie.searchAnimations = searchAnimations, lottie.registerAnimation = animationManager.registerAnimation, lottie.loadAnimation = loadAnimation, lottie.setSubframeRendering = setSubframeRendering, lottie.resize = animationManager.resize, lottie.goToAndStop = animationManager.goToAndStop, lottie.destroy = animationManager.destroy, lottie.setQuality = setQuality, lottie.inBrowser = inBrowser, lottie.installPlugin = installPlugin, lottie.freeze = animationManager.freeze, lottie.unfreeze = animationManager.unfreeze, lottie.setVolume = animationManager.setVolume, lottie.mute = animationManager.mute, lottie.unmute = animationManager.unmute, lottie.getRegisteredAnimations = animationManager.getRegisteredAnimations, lottie.useWebWorker = setWebWorker, lottie.setIDPrefix = setPrefix, lottie.__getFactory = getFactory, lottie.version = "5.10.0";
        var queryString = "";
        if (standalone) {
            var scripts = document.getElementsByTagName("script"), index = scripts.length - 1, myScript = scripts[index] || {
                src: ""
            };
            queryString = myScript.src ? myScript.src.replace(/^[^\?]+\??/, "") : "", renderer = getQueryVariable("renderer");
        }
        var readyStateCheckInterval = setInterval(checkReady, 100);
        try {
            "object" !== _typeof$3(exports) && (window.bodymovin = lottie);
        } catch (t) {}
        var ShapeModifiers = function() {
            var t1 = {}, e1 = {};
            return t1.registerModifier = function(t1, r1) {
                e1[t1] || (e1[t1] = r1);
            }, t1.getModifier = function(t1, r1, i1) {
                return new e1[t1](r1, i1);
            }, t1;
        }();
        function ShapeModifier() {}
        function TrimModifier() {}
        function PuckerAndBloatModifier() {}
        ShapeModifier.prototype.initModifierProperties = function() {}, ShapeModifier.prototype.addShapeToModifier = function() {}, ShapeModifier.prototype.addShape = function(t1) {
            if (!this.closed) {
                t1.sh.container.addDynamicProperty(t1.sh);
                var e1 = {
                    shape: t1.sh,
                    data: t1,
                    localShapeCollection: shapeCollectionPool.newShapeCollection()
                };
                this.shapes.push(e1), this.addShapeToModifier(e1), this._isAnimated && t1.setAsAnimated();
            }
        }, ShapeModifier.prototype.init = function(t1, e1) {
            this.shapes = [], this.elem = t1, this.initDynamicPropertyContainer(t1), this.initModifierProperties(t1, e1), this.frameId = initialDefaultFrame, this.closed = !1, this.k = !1, this.dynamicProperties.length ? this.k = !0 : this.getValue(!0);
        }, ShapeModifier.prototype.processKeys = function() {
            this.elem.globalData.frameId !== this.frameId && (this.frameId = this.elem.globalData.frameId, this.iterateDynamicProperties());
        }, extendPrototype([
            DynamicPropertyContainer
        ], ShapeModifier), extendPrototype([
            ShapeModifier
        ], TrimModifier), TrimModifier.prototype.initModifierProperties = function(t1, e1) {
            this.s = PropertyFactory.getProp(t1, e1.s, 0, .01, this), this.e = PropertyFactory.getProp(t1, e1.e, 0, .01, this), this.o = PropertyFactory.getProp(t1, e1.o, 0, 0, this), this.sValue = 0, this.eValue = 0, this.getValue = this.processKeys, this.m = e1.m, this._isAnimated = !!this.s.effectsSequence.length || !!this.e.effectsSequence.length || !!this.o.effectsSequence.length;
        }, TrimModifier.prototype.addShapeToModifier = function(t1) {
            t1.pathsData = [];
        }, TrimModifier.prototype.calculateShapeEdges = function(t1, e1, r1, i1, s1) {
            var a1 = [];
            e1 <= 1 ? a1.push({
                s: t1,
                e: e1
            }) : t1 >= 1 ? a1.push({
                s: t1 - 1,
                e: e1 - 1
            }) : (a1.push({
                s: t1,
                e: 1
            }), a1.push({
                s: 0,
                e: e1 - 1
            }));
            var n1, o1, h1 = [], l1 = a1.length;
            for(n1 = 0; n1 < l1; n1 += 1){
                var p1, c1;
                (o1 = a1[n1]).e * s1 < i1 || o1.s * s1 > i1 + r1 || (p1 = o1.s * s1 <= i1 ? 0 : (o1.s * s1 - i1) / r1, c1 = o1.e * s1 >= i1 + r1 ? 1 : (o1.e * s1 - i1) / r1, h1.push([
                    p1,
                    c1
                ]));
            }
            return h1.length || h1.push([
                0,
                0
            ]), h1;
        }, TrimModifier.prototype.releasePathsData = function(t1) {
            var e1, r1 = t1.length;
            for(e1 = 0; e1 < r1; e1 += 1)segmentsLengthPool.release(t1[e1]);
            return t1.length = 0, t1;
        }, TrimModifier.prototype.processShapes = function(t1) {
            var e1, r1, i1, s1;
            if (this._mdf || t1) {
                var a1 = this.o.v % 360 / 360;
                if (a1 < 0 && (a1 += 1), (e1 = this.s.v > 1 ? 1 + a1 : this.s.v < 0 ? 0 + a1 : this.s.v + a1) > (r1 = this.e.v > 1 ? 1 + a1 : this.e.v < 0 ? 0 + a1 : this.e.v + a1)) {
                    var n1 = e1;
                    e1 = r1, r1 = n1;
                }
                e1 = 1e-4 * Math.round(1e4 * e1), r1 = 1e-4 * Math.round(1e4 * r1), this.sValue = e1, this.eValue = r1;
            } else e1 = this.sValue, r1 = this.eValue;
            var o1, h1, l1, p1, c1, f1 = this.shapes.length, d1 = 0;
            if (r1 === e1) for(s1 = 0; s1 < f1; s1 += 1)this.shapes[s1].localShapeCollection.releaseShapes(), this.shapes[s1].shape._mdf = !0, this.shapes[s1].shape.paths = this.shapes[s1].localShapeCollection, this._mdf && (this.shapes[s1].pathsData.length = 0);
            else if (1 === r1 && 0 === e1 || 0 === r1 && 1 === e1) {
                if (this._mdf) for(s1 = 0; s1 < f1; s1 += 1)this.shapes[s1].pathsData.length = 0, this.shapes[s1].shape._mdf = !0;
            } else {
                var u1, m1, y1 = [];
                for(s1 = 0; s1 < f1; s1 += 1)if ((u1 = this.shapes[s1]).shape._mdf || this._mdf || t1 || 2 === this.m) {
                    if (h1 = (i1 = u1.shape.paths)._length, c1 = 0, !u1.shape._mdf && u1.pathsData.length) c1 = u1.totalShapeLength;
                    else {
                        for(l1 = this.releasePathsData(u1.pathsData), o1 = 0; o1 < h1; o1 += 1)p1 = bez.getSegmentsLength(i1.shapes[o1]), l1.push(p1), c1 += p1.totalLength;
                        u1.totalShapeLength = c1, u1.pathsData = l1;
                    }
                    d1 += c1, u1.shape._mdf = !0;
                } else u1.shape.paths = u1.localShapeCollection;
                var g1, v1 = e1, b1 = r1, _1 = 0;
                for(s1 = f1 - 1; s1 >= 0; s1 -= 1)if ((u1 = this.shapes[s1]).shape._mdf) {
                    for((m1 = u1.localShapeCollection).releaseShapes(), 2 === this.m && f1 > 1 ? (g1 = this.calculateShapeEdges(e1, r1, u1.totalShapeLength, _1, d1), _1 += u1.totalShapeLength) : g1 = [
                        [
                            v1,
                            b1
                        ]
                    ], h1 = g1.length, o1 = 0; o1 < h1; o1 += 1){
                        v1 = g1[o1][0], b1 = g1[o1][1], y1.length = 0, b1 <= 1 ? y1.push({
                            s: u1.totalShapeLength * v1,
                            e: u1.totalShapeLength * b1
                        }) : v1 >= 1 ? y1.push({
                            s: u1.totalShapeLength * (v1 - 1),
                            e: u1.totalShapeLength * (b1 - 1)
                        }) : (y1.push({
                            s: u1.totalShapeLength * v1,
                            e: u1.totalShapeLength
                        }), y1.push({
                            s: 0,
                            e: u1.totalShapeLength * (b1 - 1)
                        }));
                        var P1 = this.addShapes(u1, y1[0]);
                        if (y1[0].s !== y1[0].e) {
                            if (y1.length > 1) {
                                if (u1.shape.paths.shapes[u1.shape.paths._length - 1].c) {
                                    var E1 = P1.pop();
                                    this.addPaths(P1, m1), P1 = this.addShapes(u1, y1[1], E1);
                                } else this.addPaths(P1, m1), P1 = this.addShapes(u1, y1[1]);
                            }
                            this.addPaths(P1, m1);
                        }
                    }
                    u1.shape.paths = m1;
                }
            }
        }, TrimModifier.prototype.addPaths = function(t1, e1) {
            var r1, i1 = t1.length;
            for(r1 = 0; r1 < i1; r1 += 1)e1.addShape(t1[r1]);
        }, TrimModifier.prototype.addSegment = function(t1, e1, r1, i1, s1, a1, n1) {
            s1.setXYAt(e1[0], e1[1], "o", a1), s1.setXYAt(r1[0], r1[1], "i", a1 + 1), n1 && s1.setXYAt(t1[0], t1[1], "v", a1), s1.setXYAt(i1[0], i1[1], "v", a1 + 1);
        }, TrimModifier.prototype.addSegmentFromArray = function(t1, e1, r1, i1) {
            e1.setXYAt(t1[1], t1[5], "o", r1), e1.setXYAt(t1[2], t1[6], "i", r1 + 1), i1 && e1.setXYAt(t1[0], t1[4], "v", r1), e1.setXYAt(t1[3], t1[7], "v", r1 + 1);
        }, TrimModifier.prototype.addShapes = function(t1, e1, r1) {
            var i1, s1, a1, n1, o1, h1, l1, p1, c1 = t1.pathsData, f1 = t1.shape.paths.shapes, d1 = t1.shape.paths._length, u1 = 0, m1 = [], y1 = !0;
            for(r1 ? (o1 = r1._length, p1 = r1._length) : (r1 = shapePool.newElement(), o1 = 0, p1 = 0), m1.push(r1), i1 = 0; i1 < d1; i1 += 1){
                for(h1 = c1[i1].lengths, r1.c = f1[i1].c, a1 = f1[i1].c ? h1.length : h1.length + 1, s1 = 1; s1 < a1; s1 += 1)if (u1 + (n1 = h1[s1 - 1]).addedLength < e1.s) u1 += n1.addedLength, r1.c = !1;
                else {
                    if (u1 > e1.e) {
                        r1.c = !1;
                        break;
                    }
                    e1.s <= u1 && e1.e >= u1 + n1.addedLength ? (this.addSegment(f1[i1].v[s1 - 1], f1[i1].o[s1 - 1], f1[i1].i[s1], f1[i1].v[s1], r1, o1, y1), y1 = !1) : (l1 = bez.getNewSegment(f1[i1].v[s1 - 1], f1[i1].v[s1], f1[i1].o[s1 - 1], f1[i1].i[s1], (e1.s - u1) / n1.addedLength, (e1.e - u1) / n1.addedLength, h1[s1 - 1]), this.addSegmentFromArray(l1, r1, o1, y1), y1 = !1, r1.c = !1), u1 += n1.addedLength, o1 += 1;
                }
                if (f1[i1].c && h1.length) {
                    if (n1 = h1[s1 - 1], u1 <= e1.e) {
                        var g1 = h1[s1 - 1].addedLength;
                        e1.s <= u1 && e1.e >= u1 + g1 ? (this.addSegment(f1[i1].v[s1 - 1], f1[i1].o[s1 - 1], f1[i1].i[0], f1[i1].v[0], r1, o1, y1), y1 = !1) : (l1 = bez.getNewSegment(f1[i1].v[s1 - 1], f1[i1].v[0], f1[i1].o[s1 - 1], f1[i1].i[0], (e1.s - u1) / g1, (e1.e - u1) / g1, h1[s1 - 1]), this.addSegmentFromArray(l1, r1, o1, y1), y1 = !1, r1.c = !1);
                    } else r1.c = !1;
                    u1 += n1.addedLength, o1 += 1;
                }
                if (r1._length && (r1.setXYAt(r1.v[p1][0], r1.v[p1][1], "i", p1), r1.setXYAt(r1.v[r1._length - 1][0], r1.v[r1._length - 1][1], "o", r1._length - 1)), u1 > e1.e) break;
                i1 < d1 - 1 && (r1 = shapePool.newElement(), y1 = !0, m1.push(r1), o1 = 0);
            }
            return m1;
        }, extendPrototype([
            ShapeModifier
        ], PuckerAndBloatModifier), PuckerAndBloatModifier.prototype.initModifierProperties = function(t1, e1) {
            this.getValue = this.processKeys, this.amount = PropertyFactory.getProp(t1, e1.a, 0, null, this), this._isAnimated = !!this.amount.effectsSequence.length;
        }, PuckerAndBloatModifier.prototype.processPath = function(t1, e1) {
            var r1 = e1 / 100, i1 = [
                0,
                0
            ], s1 = t1._length, a1 = 0;
            for(a1 = 0; a1 < s1; a1 += 1)i1[0] += t1.v[a1][0], i1[1] += t1.v[a1][1];
            i1[0] /= s1, i1[1] /= s1;
            var n1, o1, h1, l1, p1, c1, f1 = shapePool.newElement();
            for(f1.c = t1.c, a1 = 0; a1 < s1; a1 += 1)n1 = t1.v[a1][0] + (i1[0] - t1.v[a1][0]) * r1, o1 = t1.v[a1][1] + (i1[1] - t1.v[a1][1]) * r1, h1 = t1.o[a1][0] + (i1[0] - t1.o[a1][0]) * -r1, l1 = t1.o[a1][1] + (i1[1] - t1.o[a1][1]) * -r1, p1 = t1.i[a1][0] + (i1[0] - t1.i[a1][0]) * -r1, c1 = t1.i[a1][1] + (i1[1] - t1.i[a1][1]) * -r1, f1.setTripleAt(n1, o1, h1, l1, p1, c1, a1);
            return f1;
        }, PuckerAndBloatModifier.prototype.processShapes = function(t1) {
            var e1, r1, i1, s1, a1, n1, o1 = this.shapes.length, h1 = this.amount.v;
            if (0 !== h1) for(r1 = 0; r1 < o1; r1 += 1){
                if (n1 = (a1 = this.shapes[r1]).localShapeCollection, a1.shape._mdf || this._mdf || t1) for(n1.releaseShapes(), a1.shape._mdf = !0, e1 = a1.shape.paths.shapes, s1 = a1.shape.paths._length, i1 = 0; i1 < s1; i1 += 1)n1.addShape(this.processPath(e1[i1], h1));
                a1.shape.paths = a1.localShapeCollection;
            }
            this.dynamicProperties.length || (this._mdf = !1);
        };
        var TransformPropertyFactory = function() {
            var t1 = [
                0,
                0
            ];
            function e1(t1, e1, r1) {
                if (this.elem = t1, this.frameId = -1, this.propType = "transform", this.data = e1, this.v = new Matrix, this.pre = new Matrix, this.appliedTransformations = 0, this.initDynamicPropertyContainer(r1 || t1), e1.p && e1.p.s ? (this.px = PropertyFactory.getProp(t1, e1.p.x, 0, 0, this), this.py = PropertyFactory.getProp(t1, e1.p.y, 0, 0, this), e1.p.z && (this.pz = PropertyFactory.getProp(t1, e1.p.z, 0, 0, this))) : this.p = PropertyFactory.getProp(t1, e1.p || {
                    k: [
                        0,
                        0,
                        0
                    ]
                }, 1, 0, this), e1.rx) {
                    if (this.rx = PropertyFactory.getProp(t1, e1.rx, 0, degToRads, this), this.ry = PropertyFactory.getProp(t1, e1.ry, 0, degToRads, this), this.rz = PropertyFactory.getProp(t1, e1.rz, 0, degToRads, this), e1.or.k[0].ti) {
                        var i1, s1 = e1.or.k.length;
                        for(i1 = 0; i1 < s1; i1 += 1)e1.or.k[i1].to = null, e1.or.k[i1].ti = null;
                    }
                    this.or = PropertyFactory.getProp(t1, e1.or, 1, degToRads, this), this.or.sh = !0;
                } else this.r = PropertyFactory.getProp(t1, e1.r || {
                    k: 0
                }, 0, degToRads, this);
                e1.sk && (this.sk = PropertyFactory.getProp(t1, e1.sk, 0, degToRads, this), this.sa = PropertyFactory.getProp(t1, e1.sa, 0, degToRads, this)), this.a = PropertyFactory.getProp(t1, e1.a || {
                    k: [
                        0,
                        0,
                        0
                    ]
                }, 1, 0, this), this.s = PropertyFactory.getProp(t1, e1.s || {
                    k: [
                        100,
                        100,
                        100
                    ]
                }, 1, .01, this), e1.o ? this.o = PropertyFactory.getProp(t1, e1.o, 0, .01, t1) : this.o = {
                    _mdf: !1,
                    v: 1
                }, this._isDirty = !0, this.dynamicProperties.length || this.getValue(!0);
            }
            return e1.prototype = {
                applyToMatrix: function(t1) {
                    var e1 = this._mdf;
                    this.iterateDynamicProperties(), this._mdf = this._mdf || e1, this.a && t1.translate(-this.a.v[0], -this.a.v[1], this.a.v[2]), this.s && t1.scale(this.s.v[0], this.s.v[1], this.s.v[2]), this.sk && t1.skewFromAxis(-this.sk.v, this.sa.v), this.r ? t1.rotate(-this.r.v) : t1.rotateZ(-this.rz.v).rotateY(this.ry.v).rotateX(this.rx.v).rotateZ(-this.or.v[2]).rotateY(this.or.v[1]).rotateX(this.or.v[0]), this.data.p.s ? this.data.p.z ? t1.translate(this.px.v, this.py.v, -this.pz.v) : t1.translate(this.px.v, this.py.v, 0) : t1.translate(this.p.v[0], this.p.v[1], -this.p.v[2]);
                },
                getValue: function(e1) {
                    if (this.elem.globalData.frameId !== this.frameId) {
                        if (this._isDirty && (this.precalculateMatrix(), this._isDirty = !1), this.iterateDynamicProperties(), this._mdf || e1) {
                            var r1;
                            if (this.v.cloneFromProps(this.pre.props), this.appliedTransformations < 1 && this.v.translate(-this.a.v[0], -this.a.v[1], this.a.v[2]), this.appliedTransformations < 2 && this.v.scale(this.s.v[0], this.s.v[1], this.s.v[2]), this.sk && this.appliedTransformations < 3 && this.v.skewFromAxis(-this.sk.v, this.sa.v), this.r && this.appliedTransformations < 4 ? this.v.rotate(-this.r.v) : !this.r && this.appliedTransformations < 4 && this.v.rotateZ(-this.rz.v).rotateY(this.ry.v).rotateX(this.rx.v).rotateZ(-this.or.v[2]).rotateY(this.or.v[1]).rotateX(this.or.v[0]), this.autoOriented) {
                                var i1, s1;
                                if (r1 = this.elem.globalData.frameRate, this.p && this.p.keyframes && this.p.getValueAtTime) this.p._caching.lastFrame + this.p.offsetTime <= this.p.keyframes[0].t ? (i1 = this.p.getValueAtTime((this.p.keyframes[0].t + .01) / r1, 0), s1 = this.p.getValueAtTime(this.p.keyframes[0].t / r1, 0)) : this.p._caching.lastFrame + this.p.offsetTime >= this.p.keyframes[this.p.keyframes.length - 1].t ? (i1 = this.p.getValueAtTime(this.p.keyframes[this.p.keyframes.length - 1].t / r1, 0), s1 = this.p.getValueAtTime((this.p.keyframes[this.p.keyframes.length - 1].t - .05) / r1, 0)) : (i1 = this.p.pv, s1 = this.p.getValueAtTime((this.p._caching.lastFrame + this.p.offsetTime - .01) / r1, this.p.offsetTime));
                                else if (this.px && this.px.keyframes && this.py.keyframes && this.px.getValueAtTime && this.py.getValueAtTime) {
                                    i1 = [], s1 = [];
                                    var a1 = this.px, n1 = this.py;
                                    a1._caching.lastFrame + a1.offsetTime <= a1.keyframes[0].t ? (i1[0] = a1.getValueAtTime((a1.keyframes[0].t + .01) / r1, 0), i1[1] = n1.getValueAtTime((n1.keyframes[0].t + .01) / r1, 0), s1[0] = a1.getValueAtTime(a1.keyframes[0].t / r1, 0), s1[1] = n1.getValueAtTime(n1.keyframes[0].t / r1, 0)) : a1._caching.lastFrame + a1.offsetTime >= a1.keyframes[a1.keyframes.length - 1].t ? (i1[0] = a1.getValueAtTime(a1.keyframes[a1.keyframes.length - 1].t / r1, 0), i1[1] = n1.getValueAtTime(n1.keyframes[n1.keyframes.length - 1].t / r1, 0), s1[0] = a1.getValueAtTime((a1.keyframes[a1.keyframes.length - 1].t - .01) / r1, 0), s1[1] = n1.getValueAtTime((n1.keyframes[n1.keyframes.length - 1].t - .01) / r1, 0)) : (i1 = [
                                        a1.pv,
                                        n1.pv
                                    ], s1[0] = a1.getValueAtTime((a1._caching.lastFrame + a1.offsetTime - .01) / r1, a1.offsetTime), s1[1] = n1.getValueAtTime((n1._caching.lastFrame + n1.offsetTime - .01) / r1, n1.offsetTime));
                                } else i1 = s1 = t1;
                                this.v.rotate(-Math.atan2(i1[1] - s1[1], i1[0] - s1[0]));
                            }
                            this.data.p && this.data.p.s ? this.data.p.z ? this.v.translate(this.px.v, this.py.v, -this.pz.v) : this.v.translate(this.px.v, this.py.v, 0) : this.v.translate(this.p.v[0], this.p.v[1], -this.p.v[2]);
                        }
                        this.frameId = this.elem.globalData.frameId;
                    }
                },
                precalculateMatrix: function() {
                    if (!this.a.k && (this.pre.translate(-this.a.v[0], -this.a.v[1], this.a.v[2]), this.appliedTransformations = 1, !this.s.effectsSequence.length)) {
                        if (this.pre.scale(this.s.v[0], this.s.v[1], this.s.v[2]), this.appliedTransformations = 2, this.sk) {
                            if (this.sk.effectsSequence.length || this.sa.effectsSequence.length) return;
                            this.pre.skewFromAxis(-this.sk.v, this.sa.v), this.appliedTransformations = 3;
                        }
                        this.r ? this.r.effectsSequence.length || (this.pre.rotate(-this.r.v), this.appliedTransformations = 4) : this.rz.effectsSequence.length || this.ry.effectsSequence.length || this.rx.effectsSequence.length || this.or.effectsSequence.length || (this.pre.rotateZ(-this.rz.v).rotateY(this.ry.v).rotateX(this.rx.v).rotateZ(-this.or.v[2]).rotateY(this.or.v[1]).rotateX(this.or.v[0]), this.appliedTransformations = 4);
                    }
                },
                autoOrient: function() {}
            }, extendPrototype([
                DynamicPropertyContainer
            ], e1), e1.prototype.addDynamicProperty = function(t1) {
                this._addDynamicProperty(t1), this.elem.addDynamicProperty(t1), this._isDirty = !0;
            }, e1.prototype._addDynamicProperty = DynamicPropertyContainer.prototype.addDynamicProperty, {
                getTransformProperty: function(t1, r1, i1) {
                    return new e1(t1, r1, i1);
                }
            };
        }();
        function RepeaterModifier() {}
        function RoundCornersModifier() {}
        function floatEqual(t1, e1) {
            return 1e5 * Math.abs(t1 - e1) <= Math.min(Math.abs(t1), Math.abs(e1));
        }
        function floatZero(t1) {
            return Math.abs(t1) <= 1e-5;
        }
        function lerp(t1, e1, r1) {
            return t1 * (1 - r1) + e1 * r1;
        }
        function lerpPoint(t1, e1, r1) {
            return [
                lerp(t1[0], e1[0], r1),
                lerp(t1[1], e1[1], r1)
            ];
        }
        function quadRoots(t1, e1, r1) {
            if (0 === t1) return [];
            var i1 = e1 * e1 - 4 * t1 * r1;
            if (i1 < 0) return [];
            var s1 = -e1 / (2 * t1);
            if (0 === i1) return [
                s1
            ];
            var a1 = Math.sqrt(i1) / (2 * t1);
            return [
                s1 - a1,
                s1 + a1
            ];
        }
        function polynomialCoefficients(t1, e1, r1, i1) {
            return [
                3 * e1 - t1 - 3 * r1 + i1,
                3 * t1 - 6 * e1 + 3 * r1,
                -3 * t1 + 3 * e1,
                t1
            ];
        }
        function singlePoint(t1) {
            return new PolynomialBezier(t1, t1, t1, t1, !1);
        }
        function PolynomialBezier(t1, e1, r1, i1, s1) {
            s1 && pointEqual(t1, e1) && (e1 = lerpPoint(t1, i1, 1 / 3)), s1 && pointEqual(r1, i1) && (r1 = lerpPoint(t1, i1, 2 / 3));
            var a1 = polynomialCoefficients(t1[0], e1[0], r1[0], i1[0]), n1 = polynomialCoefficients(t1[1], e1[1], r1[1], i1[1]);
            this.a = [
                a1[0],
                n1[0]
            ], this.b = [
                a1[1],
                n1[1]
            ], this.c = [
                a1[2],
                n1[2]
            ], this.d = [
                a1[3],
                n1[3]
            ], this.points = [
                t1,
                e1,
                r1,
                i1
            ];
        }
        function extrema(t1, e1) {
            var r1 = t1.points[0][e1], i1 = t1.points[t1.points.length - 1][e1];
            if (r1 > i1) {
                var s1 = i1;
                i1 = r1, r1 = s1;
            }
            for(var a1 = quadRoots(3 * t1.a[e1], 2 * t1.b[e1], t1.c[e1]), n1 = 0; n1 < a1.length; n1 += 1)if (a1[n1] > 0 && a1[n1] < 1) {
                var o1 = t1.point(a1[n1])[e1];
                o1 < r1 ? r1 = o1 : o1 > i1 && (i1 = o1);
            }
            return {
                min: r1,
                max: i1
            };
        }
        function intersectData(t1, e1, r1) {
            var i1 = t1.boundingBox();
            return {
                cx: i1.cx,
                cy: i1.cy,
                width: i1.width,
                height: i1.height,
                bez: t1,
                t: (e1 + r1) / 2,
                t1: e1,
                t2: r1
            };
        }
        function splitData(t1) {
            var e1 = t1.bez.split(.5);
            return [
                intersectData(e1[0], t1.t1, t1.t),
                intersectData(e1[1], t1.t, t1.t2)
            ];
        }
        function boxIntersect(t1, e1) {
            return 2 * Math.abs(t1.cx - e1.cx) < t1.width + e1.width && 2 * Math.abs(t1.cy - e1.cy) < t1.height + e1.height;
        }
        function intersectsImpl(t1, e1, r1, i1, s1, a1) {
            if (boxIntersect(t1, e1)) {
                if (r1 >= a1 || t1.width <= i1 && t1.height <= i1 && e1.width <= i1 && e1.height <= i1) s1.push([
                    t1.t,
                    e1.t
                ]);
                else {
                    var n1 = splitData(t1), o1 = splitData(e1);
                    intersectsImpl(n1[0], o1[0], r1 + 1, i1, s1, a1), intersectsImpl(n1[0], o1[1], r1 + 1, i1, s1, a1), intersectsImpl(n1[1], o1[0], r1 + 1, i1, s1, a1), intersectsImpl(n1[1], o1[1], r1 + 1, i1, s1, a1);
                }
            }
        }
        function crossProduct(t1, e1) {
            return [
                t1[1] * e1[2] - t1[2] * e1[1],
                t1[2] * e1[0] - t1[0] * e1[2],
                t1[0] * e1[1] - t1[1] * e1[0]
            ];
        }
        function lineIntersection(t1, e1, r1, i1) {
            var s1 = [
                t1[0],
                t1[1],
                1
            ], a1 = [
                e1[0],
                e1[1],
                1
            ], n1 = [
                r1[0],
                r1[1],
                1
            ], o1 = [
                i1[0],
                i1[1],
                1
            ], h1 = crossProduct(crossProduct(s1, a1), crossProduct(n1, o1));
            return floatZero(h1[2]) ? null : [
                h1[0] / h1[2],
                h1[1] / h1[2]
            ];
        }
        function polarOffset(t1, e1, r1) {
            return [
                t1[0] + Math.cos(e1) * r1,
                t1[1] - Math.sin(e1) * r1
            ];
        }
        function pointDistance(t1, e1) {
            return Math.hypot(t1[0] - e1[0], t1[1] - e1[1]);
        }
        function pointEqual(t1, e1) {
            return floatEqual(t1[0], e1[0]) && floatEqual(t1[1], e1[1]);
        }
        function ZigZagModifier() {}
        function setPoint(t1, e1, r1, i1, s1, a1, n1) {
            var o1 = r1 - Math.PI / 2, h1 = r1 + Math.PI / 2, l1 = e1[0] + Math.cos(r1) * i1 * s1, p1 = e1[1] - Math.sin(r1) * i1 * s1;
            t1.setTripleAt(l1, p1, l1 + Math.cos(o1) * a1, p1 - Math.sin(o1) * a1, l1 + Math.cos(h1) * n1, p1 - Math.sin(h1) * n1, t1.length());
        }
        function getPerpendicularVector(t1, e1) {
            var r1 = [
                e1[0] - t1[0],
                e1[1] - t1[1]
            ], i1 = .5 * -Math.PI;
            return [
                Math.cos(i1) * r1[0] - Math.sin(i1) * r1[1],
                Math.sin(i1) * r1[0] + Math.cos(i1) * r1[1]
            ];
        }
        function getProjectingAngle(t1, e1) {
            var r1 = 0 === e1 ? t1.length() - 1 : e1 - 1, i1 = (e1 + 1) % t1.length(), s1 = getPerpendicularVector(t1.v[r1], t1.v[i1]);
            return Math.atan2(0, 1) - Math.atan2(s1[1], s1[0]);
        }
        function zigZagCorner(t1, e1, r1, i1, s1, a1, n1) {
            var o1 = getProjectingAngle(e1, r1), h1 = e1.v[r1 % e1._length], l1 = e1.v[0 === r1 ? e1._length - 1 : r1 - 1], p1 = e1.v[(r1 + 1) % e1._length], c1 = 2 === a1 ? Math.sqrt(Math.pow(h1[0] - l1[0], 2) + Math.pow(h1[1] - l1[1], 2)) : 0, f1 = 2 === a1 ? Math.sqrt(Math.pow(h1[0] - p1[0], 2) + Math.pow(h1[1] - p1[1], 2)) : 0;
            setPoint(t1, e1.v[r1 % e1._length], o1, n1, i1, f1 / (2 * (s1 + 1)), c1 / (2 * (s1 + 1)), a1);
        }
        function zigZagSegment(t1, e1, r1, i1, s1, a1) {
            for(var n1 = 0; n1 < i1; n1 += 1){
                var o1 = (n1 + 1) / (i1 + 1), h1 = 2 === s1 ? Math.sqrt(Math.pow(e1.points[3][0] - e1.points[0][0], 2) + Math.pow(e1.points[3][1] - e1.points[0][1], 2)) : 0, l1 = e1.normalAngle(o1);
                setPoint(t1, e1.point(o1), l1, a1, r1, h1 / (2 * (i1 + 1)), h1 / (2 * (i1 + 1)), s1), a1 = -a1;
            }
            return a1;
        }
        function linearOffset(t1, e1, r1) {
            var i1 = Math.atan2(e1[0] - t1[0], e1[1] - t1[1]);
            return [
                polarOffset(t1, i1, r1),
                polarOffset(e1, i1, r1)
            ];
        }
        function offsetSegment(t1, e1) {
            var r1, i1, s1, a1, n1, o1, h1;
            r1 = (h1 = linearOffset(t1.points[0], t1.points[1], e1))[0], i1 = h1[1], s1 = (h1 = linearOffset(t1.points[1], t1.points[2], e1))[0], a1 = h1[1], n1 = (h1 = linearOffset(t1.points[2], t1.points[3], e1))[0], o1 = h1[1];
            var l1 = lineIntersection(r1, i1, s1, a1);
            null === l1 && (l1 = i1);
            var p1 = lineIntersection(n1, o1, s1, a1);
            return null === p1 && (p1 = n1), new PolynomialBezier(r1, l1, p1, o1);
        }
        function joinLines(t1, e1, r1, i1, s1) {
            var a1 = e1.points[3], n1 = r1.points[0];
            if (3 === i1) return a1;
            if (pointEqual(a1, n1)) return a1;
            if (2 === i1) {
                var o1 = -e1.tangentAngle(1), h1 = -r1.tangentAngle(0) + Math.PI, l1 = lineIntersection(a1, polarOffset(a1, o1 + Math.PI / 2, 100), n1, polarOffset(n1, o1 + Math.PI / 2, 100)), p1 = l1 ? pointDistance(l1, a1) : pointDistance(a1, n1) / 2, c1 = polarOffset(a1, o1, 2 * p1 * roundCorner);
                return t1.setXYAt(c1[0], c1[1], "o", t1.length() - 1), c1 = polarOffset(n1, h1, 2 * p1 * roundCorner), t1.setTripleAt(n1[0], n1[1], n1[0], n1[1], c1[0], c1[1], t1.length()), n1;
            }
            var f1 = lineIntersection(pointEqual(a1, e1.points[2]) ? e1.points[0] : e1.points[2], a1, n1, pointEqual(n1, r1.points[1]) ? r1.points[3] : r1.points[1]);
            return f1 && pointDistance(f1, a1) < s1 ? (t1.setTripleAt(f1[0], f1[1], f1[0], f1[1], f1[0], f1[1], t1.length()), f1) : a1;
        }
        function getIntersection(t1, e1) {
            var r1 = t1.intersections(e1);
            return r1.length && floatEqual(r1[0][0], 1) && r1.shift(), r1.length ? r1[0] : null;
        }
        function pruneSegmentIntersection(t1, e1) {
            var r1 = t1.slice(), i1 = e1.slice(), s1 = getIntersection(t1[t1.length - 1], e1[0]);
            return s1 && (r1[t1.length - 1] = t1[t1.length - 1].split(s1[0])[0], i1[0] = e1[0].split(s1[1])[1]), t1.length > 1 && e1.length > 1 && (s1 = getIntersection(t1[0], e1[e1.length - 1])) ? [
                [
                    t1[0].split(s1[0])[0]
                ],
                [
                    e1[e1.length - 1].split(s1[1])[1]
                ]
            ] : [
                r1,
                i1
            ];
        }
        function pruneIntersections(t1) {
            for(var e1, r1 = 1; r1 < t1.length; r1 += 1)e1 = pruneSegmentIntersection(t1[r1 - 1], t1[r1]), t1[r1 - 1] = e1[0], t1[r1] = e1[1];
            return t1.length > 1 && (e1 = pruneSegmentIntersection(t1[t1.length - 1], t1[0]), t1[t1.length - 1] = e1[0], t1[0] = e1[1]), t1;
        }
        function offsetSegmentSplit(t1, e1) {
            var r1, i1, s1, a1, n1 = t1.inflectionPoints();
            if (0 === n1.length) return [
                offsetSegment(t1, e1)
            ];
            if (1 === n1.length || floatEqual(n1[1], 1)) return r1 = (s1 = t1.split(n1[0]))[0], i1 = s1[1], [
                offsetSegment(r1, e1),
                offsetSegment(i1, e1)
            ];
            r1 = (s1 = t1.split(n1[0]))[0];
            var o1 = (n1[1] - n1[0]) / (1 - n1[0]);
            return a1 = (s1 = s1[1].split(o1))[0], i1 = s1[1], [
                offsetSegment(r1, e1),
                offsetSegment(a1, e1),
                offsetSegment(i1, e1)
            ];
        }
        function OffsetPathModifier() {}
        function getFontProperties(t1) {
            for(var e1 = t1.fStyle ? t1.fStyle.split(" ") : [], r1 = "normal", i1 = "normal", s1 = e1.length, a1 = 0; a1 < s1; a1 += 1)switch(e1[a1].toLowerCase()){
                case "italic":
                    i1 = "italic";
                    break;
                case "bold":
                    r1 = "700";
                    break;
                case "black":
                    r1 = "900";
                    break;
                case "medium":
                    r1 = "500";
                    break;
                case "regular":
                case "normal":
                    r1 = "400";
                    break;
                case "light":
                case "thin":
                    r1 = "200";
            }
            return {
                style: i1,
                weight: t1.fWeight || r1
            };
        }
        extendPrototype([
            ShapeModifier
        ], RepeaterModifier), RepeaterModifier.prototype.initModifierProperties = function(t1, e1) {
            this.getValue = this.processKeys, this.c = PropertyFactory.getProp(t1, e1.c, 0, null, this), this.o = PropertyFactory.getProp(t1, e1.o, 0, null, this), this.tr = TransformPropertyFactory.getTransformProperty(t1, e1.tr, this), this.so = PropertyFactory.getProp(t1, e1.tr.so, 0, .01, this), this.eo = PropertyFactory.getProp(t1, e1.tr.eo, 0, .01, this), this.data = e1, this.dynamicProperties.length || this.getValue(!0), this._isAnimated = !!this.dynamicProperties.length, this.pMatrix = new Matrix, this.rMatrix = new Matrix, this.sMatrix = new Matrix, this.tMatrix = new Matrix, this.matrix = new Matrix;
        }, RepeaterModifier.prototype.applyTransforms = function(t1, e1, r1, i1, s1, a1) {
            var n1 = a1 ? -1 : 1, o1 = i1.s.v[0] + (1 - i1.s.v[0]) * (1 - s1), h1 = i1.s.v[1] + (1 - i1.s.v[1]) * (1 - s1);
            t1.translate(i1.p.v[0] * n1 * s1, i1.p.v[1] * n1 * s1, i1.p.v[2]), e1.translate(-i1.a.v[0], -i1.a.v[1], i1.a.v[2]), e1.rotate(-i1.r.v * n1 * s1), e1.translate(i1.a.v[0], i1.a.v[1], i1.a.v[2]), r1.translate(-i1.a.v[0], -i1.a.v[1], i1.a.v[2]), r1.scale(a1 ? 1 / o1 : o1, a1 ? 1 / h1 : h1), r1.translate(i1.a.v[0], i1.a.v[1], i1.a.v[2]);
        }, RepeaterModifier.prototype.init = function(t1, e1, r1, i1) {
            for(this.elem = t1, this.arr = e1, this.pos = r1, this.elemsData = i1, this._currentCopies = 0, this._elements = [], this._groups = [], this.frameId = -1, this.initDynamicPropertyContainer(t1), this.initModifierProperties(t1, e1[r1]); r1 > 0;)r1 -= 1, this._elements.unshift(e1[r1]);
            this.dynamicProperties.length ? this.k = !0 : this.getValue(!0);
        }, RepeaterModifier.prototype.resetElements = function(t1) {
            var e1, r1 = t1.length;
            for(e1 = 0; e1 < r1; e1 += 1)t1[e1]._processed = !1, "gr" === t1[e1].ty && this.resetElements(t1[e1].it);
        }, RepeaterModifier.prototype.cloneElements = function(t1) {
            var e1 = JSON.parse(JSON.stringify(t1));
            return this.resetElements(e1), e1;
        }, RepeaterModifier.prototype.changeGroupRender = function(t1, e1) {
            var r1, i1 = t1.length;
            for(r1 = 0; r1 < i1; r1 += 1)t1[r1]._render = e1, "gr" === t1[r1].ty && this.changeGroupRender(t1[r1].it, e1);
        }, RepeaterModifier.prototype.processShapes = function(t1) {
            var e1, r1, i1, s1, a1, n1 = !1;
            if (this._mdf || t1) {
                var o1, h1 = Math.ceil(this.c.v);
                if (this._groups.length < h1) {
                    for(; this._groups.length < h1;){
                        var l1 = {
                            it: this.cloneElements(this._elements),
                            ty: "gr"
                        };
                        l1.it.push({
                            a: {
                                a: 0,
                                ix: 1,
                                k: [
                                    0,
                                    0
                                ]
                            },
                            nm: "Transform",
                            o: {
                                a: 0,
                                ix: 7,
                                k: 100
                            },
                            p: {
                                a: 0,
                                ix: 2,
                                k: [
                                    0,
                                    0
                                ]
                            },
                            r: {
                                a: 1,
                                ix: 6,
                                k: [
                                    {
                                        s: 0,
                                        e: 0,
                                        t: 0
                                    },
                                    {
                                        s: 0,
                                        e: 0,
                                        t: 1
                                    }
                                ]
                            },
                            s: {
                                a: 0,
                                ix: 3,
                                k: [
                                    100,
                                    100
                                ]
                            },
                            sa: {
                                a: 0,
                                ix: 5,
                                k: 0
                            },
                            sk: {
                                a: 0,
                                ix: 4,
                                k: 0
                            },
                            ty: "tr"
                        }), this.arr.splice(0, 0, l1), this._groups.splice(0, 0, l1), this._currentCopies += 1;
                    }
                    this.elem.reloadShapes(), n1 = !0;
                }
                for(a1 = 0, i1 = 0; i1 <= this._groups.length - 1; i1 += 1){
                    if (o1 = a1 < h1, this._groups[i1]._render = o1, this.changeGroupRender(this._groups[i1].it, o1), !o1) {
                        var p1 = this.elemsData[i1].it, c1 = p1[p1.length - 1];
                        0 !== c1.transform.op.v ? (c1.transform.op._mdf = !0, c1.transform.op.v = 0) : c1.transform.op._mdf = !1;
                    }
                    a1 += 1;
                }
                this._currentCopies = h1;
                var f1 = this.o.v, d1 = f1 % 1, u1 = f1 > 0 ? Math.floor(f1) : Math.ceil(f1), m1 = this.pMatrix.props, y1 = this.rMatrix.props, g1 = this.sMatrix.props;
                this.pMatrix.reset(), this.rMatrix.reset(), this.sMatrix.reset(), this.tMatrix.reset(), this.matrix.reset();
                var v1, b1, _1 = 0;
                if (f1 > 0) {
                    for(; _1 < u1;)this.applyTransforms(this.pMatrix, this.rMatrix, this.sMatrix, this.tr, 1, !1), _1 += 1;
                    d1 && (this.applyTransforms(this.pMatrix, this.rMatrix, this.sMatrix, this.tr, d1, !1), _1 += d1);
                } else if (f1 < 0) {
                    for(; _1 > u1;)this.applyTransforms(this.pMatrix, this.rMatrix, this.sMatrix, this.tr, 1, !0), _1 -= 1;
                    d1 && (this.applyTransforms(this.pMatrix, this.rMatrix, this.sMatrix, this.tr, -d1, !0), _1 -= d1);
                }
                for(i1 = 1 === this.data.m ? 0 : this._currentCopies - 1, s1 = 1 === this.data.m ? 1 : -1, a1 = this._currentCopies; a1;){
                    if (b1 = (r1 = (e1 = this.elemsData[i1].it)[e1.length - 1].transform.mProps.v.props).length, e1[e1.length - 1].transform.mProps._mdf = !0, e1[e1.length - 1].transform.op._mdf = !0, e1[e1.length - 1].transform.op.v = 1 === this._currentCopies ? this.so.v : this.so.v + (this.eo.v - this.so.v) * (i1 / (this._currentCopies - 1)), 0 !== _1) {
                        for((0 !== i1 && 1 === s1 || i1 !== this._currentCopies - 1 && -1 === s1) && this.applyTransforms(this.pMatrix, this.rMatrix, this.sMatrix, this.tr, 1, !1), this.matrix.transform(y1[0], y1[1], y1[2], y1[3], y1[4], y1[5], y1[6], y1[7], y1[8], y1[9], y1[10], y1[11], y1[12], y1[13], y1[14], y1[15]), this.matrix.transform(g1[0], g1[1], g1[2], g1[3], g1[4], g1[5], g1[6], g1[7], g1[8], g1[9], g1[10], g1[11], g1[12], g1[13], g1[14], g1[15]), this.matrix.transform(m1[0], m1[1], m1[2], m1[3], m1[4], m1[5], m1[6], m1[7], m1[8], m1[9], m1[10], m1[11], m1[12], m1[13], m1[14], m1[15]), v1 = 0; v1 < b1; v1 += 1)r1[v1] = this.matrix.props[v1];
                        this.matrix.reset();
                    } else for(this.matrix.reset(), v1 = 0; v1 < b1; v1 += 1)r1[v1] = this.matrix.props[v1];
                    _1 += 1, a1 -= 1, i1 += s1;
                }
            } else for(a1 = this._currentCopies, i1 = 0, s1 = 1; a1;)r1 = (e1 = this.elemsData[i1].it)[e1.length - 1].transform.mProps.v.props, e1[e1.length - 1].transform.mProps._mdf = !1, e1[e1.length - 1].transform.op._mdf = !1, a1 -= 1, i1 += s1;
            return n1;
        }, RepeaterModifier.prototype.addShape = function() {}, extendPrototype([
            ShapeModifier
        ], RoundCornersModifier), RoundCornersModifier.prototype.initModifierProperties = function(t1, e1) {
            this.getValue = this.processKeys, this.rd = PropertyFactory.getProp(t1, e1.r, 0, null, this), this._isAnimated = !!this.rd.effectsSequence.length;
        }, RoundCornersModifier.prototype.processPath = function(t1, e1) {
            var r1, i1 = shapePool.newElement();
            i1.c = t1.c;
            var s1, a1, n1, o1, h1, l1, p1, c1, f1, d1, u1, m1, y1 = t1._length, g1 = 0;
            for(r1 = 0; r1 < y1; r1 += 1)s1 = t1.v[r1], n1 = t1.o[r1], a1 = t1.i[r1], s1[0] === n1[0] && s1[1] === n1[1] && s1[0] === a1[0] && s1[1] === a1[1] ? 0 !== r1 && r1 !== y1 - 1 || t1.c ? (o1 = 0 === r1 ? t1.v[y1 - 1] : t1.v[r1 - 1], l1 = (h1 = Math.sqrt(Math.pow(s1[0] - o1[0], 2) + Math.pow(s1[1] - o1[1], 2))) ? Math.min(h1 / 2, e1) / h1 : 0, p1 = u1 = s1[0] + (o1[0] - s1[0]) * l1, c1 = m1 = s1[1] - (s1[1] - o1[1]) * l1, f1 = p1 - (p1 - s1[0]) * roundCorner, d1 = c1 - (c1 - s1[1]) * roundCorner, i1.setTripleAt(p1, c1, f1, d1, u1, m1, g1), g1 += 1, o1 = r1 === y1 - 1 ? t1.v[0] : t1.v[r1 + 1], l1 = (h1 = Math.sqrt(Math.pow(s1[0] - o1[0], 2) + Math.pow(s1[1] - o1[1], 2))) ? Math.min(h1 / 2, e1) / h1 : 0, p1 = f1 = s1[0] + (o1[0] - s1[0]) * l1, c1 = d1 = s1[1] + (o1[1] - s1[1]) * l1, u1 = p1 - (p1 - s1[0]) * roundCorner, m1 = c1 - (c1 - s1[1]) * roundCorner, i1.setTripleAt(p1, c1, f1, d1, u1, m1, g1), g1 += 1) : (i1.setTripleAt(s1[0], s1[1], n1[0], n1[1], a1[0], a1[1], g1), g1 += 1) : (i1.setTripleAt(t1.v[r1][0], t1.v[r1][1], t1.o[r1][0], t1.o[r1][1], t1.i[r1][0], t1.i[r1][1], g1), g1 += 1);
            return i1;
        }, RoundCornersModifier.prototype.processShapes = function(t1) {
            var e1, r1, i1, s1, a1, n1, o1 = this.shapes.length, h1 = this.rd.v;
            if (0 !== h1) for(r1 = 0; r1 < o1; r1 += 1){
                if (n1 = (a1 = this.shapes[r1]).localShapeCollection, a1.shape._mdf || this._mdf || t1) for(n1.releaseShapes(), a1.shape._mdf = !0, e1 = a1.shape.paths.shapes, s1 = a1.shape.paths._length, i1 = 0; i1 < s1; i1 += 1)n1.addShape(this.processPath(e1[i1], h1));
                a1.shape.paths = a1.localShapeCollection;
            }
            this.dynamicProperties.length || (this._mdf = !1);
        }, PolynomialBezier.prototype.point = function(t1) {
            return [
                ((this.a[0] * t1 + this.b[0]) * t1 + this.c[0]) * t1 + this.d[0],
                ((this.a[1] * t1 + this.b[1]) * t1 + this.c[1]) * t1 + this.d[1]
            ];
        }, PolynomialBezier.prototype.derivative = function(t1) {
            return [
                (3 * t1 * this.a[0] + 2 * this.b[0]) * t1 + this.c[0],
                (3 * t1 * this.a[1] + 2 * this.b[1]) * t1 + this.c[1]
            ];
        }, PolynomialBezier.prototype.tangentAngle = function(t1) {
            var e1 = this.derivative(t1);
            return Math.atan2(e1[1], e1[0]);
        }, PolynomialBezier.prototype.normalAngle = function(t1) {
            var e1 = this.derivative(t1);
            return Math.atan2(e1[0], e1[1]);
        }, PolynomialBezier.prototype.inflectionPoints = function() {
            var t1 = this.a[1] * this.b[0] - this.a[0] * this.b[1];
            if (floatZero(t1)) return [];
            var e1 = -0.5 * (this.a[1] * this.c[0] - this.a[0] * this.c[1]) / t1, r1 = e1 * e1 - 1 / 3 * (this.b[1] * this.c[0] - this.b[0] * this.c[1]) / t1;
            if (r1 < 0) return [];
            var i1 = Math.sqrt(r1);
            return floatZero(i1) ? i1 > 0 && i1 < 1 ? [
                e1
            ] : [] : [
                e1 - i1,
                e1 + i1
            ].filter(function(t1) {
                return t1 > 0 && t1 < 1;
            });
        }, PolynomialBezier.prototype.split = function(t1) {
            if (t1 <= 0) return [
                singlePoint(this.points[0]),
                this
            ];
            if (t1 >= 1) return [
                this,
                singlePoint(this.points[this.points.length - 1])
            ];
            var e1 = lerpPoint(this.points[0], this.points[1], t1), r1 = lerpPoint(this.points[1], this.points[2], t1), i1 = lerpPoint(this.points[2], this.points[3], t1), s1 = lerpPoint(e1, r1, t1), a1 = lerpPoint(r1, i1, t1), n1 = lerpPoint(s1, a1, t1);
            return [
                new PolynomialBezier(this.points[0], e1, s1, n1, !0),
                new PolynomialBezier(n1, a1, i1, this.points[3], !0)
            ];
        }, PolynomialBezier.prototype.bounds = function() {
            return {
                x: extrema(this, 0),
                y: extrema(this, 1)
            };
        }, PolynomialBezier.prototype.boundingBox = function() {
            var t1 = this.bounds();
            return {
                left: t1.x.min,
                right: t1.x.max,
                top: t1.y.min,
                bottom: t1.y.max,
                width: t1.x.max - t1.x.min,
                height: t1.y.max - t1.y.min,
                cx: (t1.x.max + t1.x.min) / 2,
                cy: (t1.y.max + t1.y.min) / 2
            };
        }, PolynomialBezier.prototype.intersections = function(t1, e1, r1) {
            void 0 === e1 && (e1 = 2), void 0 === r1 && (r1 = 7);
            var i1 = [];
            return intersectsImpl(intersectData(this, 0, 1), intersectData(t1, 0, 1), 0, e1, i1, r1), i1;
        }, PolynomialBezier.shapeSegment = function(t1, e1) {
            var r1 = (e1 + 1) % t1.length();
            return new PolynomialBezier(t1.v[e1], t1.o[e1], t1.i[r1], t1.v[r1], !0);
        }, PolynomialBezier.shapeSegmentInverted = function(t1, e1) {
            var r1 = (e1 + 1) % t1.length();
            return new PolynomialBezier(t1.v[r1], t1.i[r1], t1.o[e1], t1.v[e1], !0);
        }, extendPrototype([
            ShapeModifier
        ], ZigZagModifier), ZigZagModifier.prototype.initModifierProperties = function(t1, e1) {
            this.getValue = this.processKeys, this.amplitude = PropertyFactory.getProp(t1, e1.s, 0, null, this), this.frequency = PropertyFactory.getProp(t1, e1.r, 0, null, this), this.pointsType = PropertyFactory.getProp(t1, e1.pt, 0, null, this), this._isAnimated = 0 !== this.amplitude.effectsSequence.length || 0 !== this.frequency.effectsSequence.length || 0 !== this.pointsType.effectsSequence.length;
        }, ZigZagModifier.prototype.processPath = function(t1, e1, r1, i1) {
            var s1 = t1._length, a1 = shapePool.newElement();
            if (a1.c = t1.c, t1.c || (s1 -= 1), 0 === s1) return a1;
            var n1 = -1, o1 = PolynomialBezier.shapeSegment(t1, 0);
            zigZagCorner(a1, t1, 0, e1, r1, i1, n1);
            for(var h1 = 0; h1 < s1; h1 += 1)n1 = zigZagSegment(a1, o1, e1, r1, i1, -n1), o1 = h1 !== s1 - 1 || t1.c ? PolynomialBezier.shapeSegment(t1, (h1 + 1) % s1) : null, zigZagCorner(a1, t1, h1 + 1, e1, r1, i1, n1);
            return a1;
        }, ZigZagModifier.prototype.processShapes = function(t1) {
            var e1, r1, i1, s1, a1, n1, o1 = this.shapes.length, h1 = this.amplitude.v, l1 = Math.max(0, Math.round(this.frequency.v)), p1 = this.pointsType.v;
            if (0 !== h1) for(r1 = 0; r1 < o1; r1 += 1){
                if (n1 = (a1 = this.shapes[r1]).localShapeCollection, a1.shape._mdf || this._mdf || t1) for(n1.releaseShapes(), a1.shape._mdf = !0, e1 = a1.shape.paths.shapes, s1 = a1.shape.paths._length, i1 = 0; i1 < s1; i1 += 1)n1.addShape(this.processPath(e1[i1], h1, l1, p1));
                a1.shape.paths = a1.localShapeCollection;
            }
            this.dynamicProperties.length || (this._mdf = !1);
        }, extendPrototype([
            ShapeModifier
        ], OffsetPathModifier), OffsetPathModifier.prototype.initModifierProperties = function(t1, e1) {
            this.getValue = this.processKeys, this.amount = PropertyFactory.getProp(t1, e1.a, 0, null, this), this.miterLimit = PropertyFactory.getProp(t1, e1.ml, 0, null, this), this.lineJoin = e1.lj, this._isAnimated = 0 !== this.amount.effectsSequence.length;
        }, OffsetPathModifier.prototype.processPath = function(t1, e1, r1, i1) {
            var s1 = shapePool.newElement();
            s1.c = t1.c;
            var a1, n1, o1, h1 = t1.length();
            t1.c || (h1 -= 1);
            var l1 = [];
            for(a1 = 0; a1 < h1; a1 += 1)o1 = PolynomialBezier.shapeSegment(t1, a1), l1.push(offsetSegmentSplit(o1, e1));
            if (!t1.c) for(a1 = h1 - 1; a1 >= 0; a1 -= 1)o1 = PolynomialBezier.shapeSegmentInverted(t1, a1), l1.push(offsetSegmentSplit(o1, e1));
            l1 = pruneIntersections(l1);
            var p1 = null, c1 = null;
            for(a1 = 0; a1 < l1.length; a1 += 1){
                var f1 = l1[a1];
                for(c1 && (p1 = joinLines(s1, c1, f1[0], r1, i1)), c1 = f1[f1.length - 1], n1 = 0; n1 < f1.length; n1 += 1)o1 = f1[n1], p1 && pointEqual(o1.points[0], p1) ? s1.setXYAt(o1.points[1][0], o1.points[1][1], "o", s1.length() - 1) : s1.setTripleAt(o1.points[0][0], o1.points[0][1], o1.points[1][0], o1.points[1][1], o1.points[0][0], o1.points[0][1], s1.length()), s1.setTripleAt(o1.points[3][0], o1.points[3][1], o1.points[3][0], o1.points[3][1], o1.points[2][0], o1.points[2][1], s1.length()), p1 = o1.points[3];
            }
            return l1.length && joinLines(s1, c1, l1[0][0], r1, i1), s1;
        }, OffsetPathModifier.prototype.processShapes = function(t1) {
            var e1, r1, i1, s1, a1, n1, o1 = this.shapes.length, h1 = this.amount.v, l1 = this.miterLimit.v, p1 = this.lineJoin;
            if (0 !== h1) for(r1 = 0; r1 < o1; r1 += 1){
                if (n1 = (a1 = this.shapes[r1]).localShapeCollection, a1.shape._mdf || this._mdf || t1) for(n1.releaseShapes(), a1.shape._mdf = !0, e1 = a1.shape.paths.shapes, s1 = a1.shape.paths._length, i1 = 0; i1 < s1; i1 += 1)n1.addShape(this.processPath(e1[i1], h1, p1, l1));
                a1.shape.paths = a1.localShapeCollection;
            }
            this.dynamicProperties.length || (this._mdf = !1);
        };
        var FontManager = function() {
            var t1 = {
                w: 0,
                size: 0,
                shapes: [],
                data: {
                    shapes: []
                }
            }, e1 = [];
            e1 = e1.concat([
                2304,
                2305,
                2306,
                2307,
                2362,
                2363,
                2364,
                2364,
                2366,
                2367,
                2368,
                2369,
                2370,
                2371,
                2372,
                2373,
                2374,
                2375,
                2376,
                2377,
                2378,
                2379,
                2380,
                2381,
                2382,
                2383,
                2387,
                2388,
                2389,
                2390,
                2391,
                2402,
                2403
            ]);
            var r1 = [
                "d83cdffb",
                "d83cdffc",
                "d83cdffd",
                "d83cdffe",
                "d83cdfff"
            ], i1 = [
                65039,
                8205
            ];
            function s1(t1, e1) {
                var r1 = createTag("span");
                r1.setAttribute("aria-hidden", !0), r1.style.fontFamily = e1;
                var i1 = createTag("span");
                i1.innerText = "giItT1WQy@!-/#", r1.style.position = "absolute", r1.style.left = "-10000px", r1.style.top = "-10000px", r1.style.fontSize = "300px", r1.style.fontVariant = "normal", r1.style.fontStyle = "normal", r1.style.fontWeight = "normal", r1.style.letterSpacing = "0", r1.appendChild(i1), document.body.appendChild(r1);
                var s1 = i1.offsetWidth;
                return i1.style.fontFamily = function(t1) {
                    var e1, r1 = t1.split(","), i1 = r1.length, s1 = [];
                    for(e1 = 0; e1 < i1; e1 += 1)"sans-serif" !== r1[e1] && "monospace" !== r1[e1] && s1.push(r1[e1]);
                    return s1.join(",");
                }(t1) + ", " + e1, {
                    node: i1,
                    w: s1,
                    parent: r1
                };
            }
            function a1(t1, e1) {
                var r1, i1 = document.body && e1 ? "svg" : "canvas", s1 = getFontProperties(t1);
                if ("svg" === i1) {
                    var a1 = createNS("text");
                    a1.style.fontSize = "100px", a1.setAttribute("font-family", t1.fFamily), a1.setAttribute("font-style", s1.style), a1.setAttribute("font-weight", s1.weight), a1.textContent = "1", t1.fClass ? (a1.style.fontFamily = "inherit", a1.setAttribute("class", t1.fClass)) : a1.style.fontFamily = t1.fFamily, e1.appendChild(a1), r1 = a1;
                } else {
                    var n1 = new OffscreenCanvas(500, 500).getContext("2d");
                    n1.font = s1.style + " " + s1.weight + " 100px " + t1.fFamily, r1 = n1;
                }
                return {
                    measureText: function(t1) {
                        return "svg" === i1 ? (r1.textContent = t1, r1.getComputedTextLength()) : r1.measureText(t1).width;
                    }
                };
            }
            var n1 = function() {
                this.fonts = [], this.chars = null, this.typekitLoaded = 0, this.isLoaded = !1, this._warned = !1, this.initTime = Date.now(), this.setIsLoadedBinded = this.setIsLoaded.bind(this), this.checkLoadedFontsBinded = this.checkLoadedFonts.bind(this);
            };
            n1.isModifier = function(t1, e1) {
                var i1 = t1.toString(16) + e1.toString(16);
                return -1 !== r1.indexOf(i1);
            }, n1.isZeroWidthJoiner = function(t1, e1) {
                return e1 ? t1 === i1[0] && e1 === i1[1] : t1 === i1[1];
            }, n1.isCombinedCharacter = function(t1) {
                return -1 !== e1.indexOf(t1);
            };
            var o1 = {
                addChars: function(t1) {
                    if (t1) {
                        var e1;
                        this.chars || (this.chars = []);
                        var r1, i1, s1 = t1.length, a1 = this.chars.length;
                        for(e1 = 0; e1 < s1; e1 += 1){
                            for(r1 = 0, i1 = !1; r1 < a1;)this.chars[r1].style === t1[e1].style && this.chars[r1].fFamily === t1[e1].fFamily && this.chars[r1].ch === t1[e1].ch && (i1 = !0), r1 += 1;
                            i1 || (this.chars.push(t1[e1]), a1 += 1);
                        }
                    }
                },
                addFonts: function(t1, e1) {
                    if (t1) {
                        if (this.chars) return this.isLoaded = !0, void (this.fonts = t1.list);
                        if (!document.body) return this.isLoaded = !0, t1.list.forEach(function(t1) {
                            t1.helper = a1(t1), t1.cache = {};
                        }), void (this.fonts = t1.list);
                        var r1, i1 = t1.list, n1 = i1.length, o1 = n1;
                        for(r1 = 0; r1 < n1; r1 += 1){
                            var h1, l1, p1 = !0;
                            if (i1[r1].loaded = !1, i1[r1].monoCase = s1(i1[r1].fFamily, "monospace"), i1[r1].sansCase = s1(i1[r1].fFamily, "sans-serif"), i1[r1].fPath) {
                                if ("p" === i1[r1].fOrigin || 3 === i1[r1].origin) {
                                    if ((h1 = document.querySelectorAll('style[f-forigin="p"][f-family="' + i1[r1].fFamily + '"], style[f-origin="3"][f-family="' + i1[r1].fFamily + '"]')).length > 0 && (p1 = !1), p1) {
                                        var c1 = createTag("style");
                                        c1.setAttribute("f-forigin", i1[r1].fOrigin), c1.setAttribute("f-origin", i1[r1].origin), c1.setAttribute("f-family", i1[r1].fFamily), c1.type = "text/css", c1.innerText = "@font-face {font-family: " + i1[r1].fFamily + "; font-style: normal; src: url('" + i1[r1].fPath + "');}", e1.appendChild(c1);
                                    }
                                } else if ("g" === i1[r1].fOrigin || 1 === i1[r1].origin) {
                                    for(h1 = document.querySelectorAll('link[f-forigin="g"], link[f-origin="1"]'), l1 = 0; l1 < h1.length; l1 += 1)-1 !== h1[l1].href.indexOf(i1[r1].fPath) && (p1 = !1);
                                    if (p1) {
                                        var f1 = createTag("link");
                                        f1.setAttribute("f-forigin", i1[r1].fOrigin), f1.setAttribute("f-origin", i1[r1].origin), f1.type = "text/css", f1.rel = "stylesheet", f1.href = i1[r1].fPath, document.body.appendChild(f1);
                                    }
                                } else if ("t" === i1[r1].fOrigin || 2 === i1[r1].origin) {
                                    for(h1 = document.querySelectorAll('script[f-forigin="t"], script[f-origin="2"]'), l1 = 0; l1 < h1.length; l1 += 1)i1[r1].fPath === h1[l1].src && (p1 = !1);
                                    if (p1) {
                                        var d1 = createTag("link");
                                        d1.setAttribute("f-forigin", i1[r1].fOrigin), d1.setAttribute("f-origin", i1[r1].origin), d1.setAttribute("rel", "stylesheet"), d1.setAttribute("href", i1[r1].fPath), e1.appendChild(d1);
                                    }
                                }
                            } else i1[r1].loaded = !0, o1 -= 1;
                            i1[r1].helper = a1(i1[r1], e1), i1[r1].cache = {}, this.fonts.push(i1[r1]);
                        }
                        0 === o1 ? this.isLoaded = !0 : setTimeout(this.checkLoadedFonts.bind(this), 100);
                    } else this.isLoaded = !0;
                },
                getCharData: function(e1, r1, i1) {
                    for(var s1 = 0, a1 = this.chars.length; s1 < a1;){
                        if (this.chars[s1].ch === e1 && this.chars[s1].style === r1 && this.chars[s1].fFamily === i1) return this.chars[s1];
                        s1 += 1;
                    }
                    return ("string" == typeof e1 && 13 !== e1.charCodeAt(0) || !e1) && console && console.warn && !this._warned && (this._warned = !0, console.warn("Missing character from exported characters list: ", e1, r1, i1)), t1;
                },
                getFontByName: function(t1) {
                    for(var e1 = 0, r1 = this.fonts.length; e1 < r1;){
                        if (this.fonts[e1].fName === t1) return this.fonts[e1];
                        e1 += 1;
                    }
                    return this.fonts[0];
                },
                measureText: function(t1, e1, r1) {
                    var i1 = this.getFontByName(e1), s1 = t1.charCodeAt(0);
                    if (!i1.cache[s1 + 1]) {
                        var a1 = i1.helper;
                        if (" " === t1) {
                            var n1 = a1.measureText("|" + t1 + "|"), o1 = a1.measureText("||");
                            i1.cache[s1 + 1] = (n1 - o1) / 100;
                        } else i1.cache[s1 + 1] = a1.measureText(t1) / 100;
                    }
                    return i1.cache[s1 + 1] * r1;
                },
                checkLoadedFonts: function() {
                    var t1, e1, r1, i1 = this.fonts.length, s1 = i1;
                    for(t1 = 0; t1 < i1; t1 += 1)this.fonts[t1].loaded ? s1 -= 1 : "n" === this.fonts[t1].fOrigin || 0 === this.fonts[t1].origin ? this.fonts[t1].loaded = !0 : (e1 = this.fonts[t1].monoCase.node, r1 = this.fonts[t1].monoCase.w, e1.offsetWidth !== r1 ? (s1 -= 1, this.fonts[t1].loaded = !0) : (e1 = this.fonts[t1].sansCase.node, r1 = this.fonts[t1].sansCase.w, e1.offsetWidth !== r1 && (s1 -= 1, this.fonts[t1].loaded = !0)), this.fonts[t1].loaded && (this.fonts[t1].sansCase.parent.parentNode.removeChild(this.fonts[t1].sansCase.parent), this.fonts[t1].monoCase.parent.parentNode.removeChild(this.fonts[t1].monoCase.parent)));
                    0 !== s1 && Date.now() - this.initTime < 5e3 ? setTimeout(this.checkLoadedFontsBinded, 20) : setTimeout(this.setIsLoadedBinded, 10);
                },
                setIsLoaded: function() {
                    this.isLoaded = !0;
                }
            };
            return n1.prototype = o1, n1;
        }();
        function RenderableElement() {}
        RenderableElement.prototype = {
            initRenderable: function() {
                this.isInRange = !1, this.hidden = !1, this.isTransparent = !1, this.renderableComponents = [];
            },
            addRenderableComponent: function(t1) {
                -1 === this.renderableComponents.indexOf(t1) && this.renderableComponents.push(t1);
            },
            removeRenderableComponent: function(t1) {
                -1 !== this.renderableComponents.indexOf(t1) && this.renderableComponents.splice(this.renderableComponents.indexOf(t1), 1);
            },
            prepareRenderableFrame: function(t1) {
                this.checkLayerLimits(t1);
            },
            checkTransparency: function() {
                this.finalTransform.mProp.o.v <= 0 ? !this.isTransparent && this.globalData.renderConfig.hideOnTransparent && (this.isTransparent = !0, this.hide()) : this.isTransparent && (this.isTransparent = !1, this.show());
            },
            checkLayerLimits: function(t1) {
                this.data.ip - this.data.st <= t1 && this.data.op - this.data.st > t1 ? !0 !== this.isInRange && (this.globalData._mdf = !0, this._mdf = !0, this.isInRange = !0, this.show()) : !1 !== this.isInRange && (this.globalData._mdf = !0, this.isInRange = !1, this.hide());
            },
            renderRenderable: function() {
                var t1, e1 = this.renderableComponents.length;
                for(t1 = 0; t1 < e1; t1 += 1)this.renderableComponents[t1].renderFrame(this._isFirstFrame);
            },
            sourceRectAtTime: function() {
                return {
                    top: 0,
                    left: 0,
                    width: 100,
                    height: 100
                };
            },
            getLayerSize: function() {
                return 5 === this.data.ty ? {
                    w: this.data.textData.width,
                    h: this.data.textData.height
                } : {
                    w: this.data.width,
                    h: this.data.height
                };
            }
        };
        var getBlendMode = (blendModeEnums = {
            0: "source-over",
            1: "multiply",
            2: "screen",
            3: "overlay",
            4: "darken",
            5: "lighten",
            6: "color-dodge",
            7: "color-burn",
            8: "hard-light",
            9: "soft-light",
            10: "difference",
            11: "exclusion",
            12: "hue",
            13: "saturation",
            14: "color",
            15: "luminosity"
        }, function(t1) {
            return blendModeEnums[t1] || "";
        }), blendModeEnums;
        function SliderEffect(t1, e1, r1) {
            this.p = PropertyFactory.getProp(e1, t1.v, 0, 0, r1);
        }
        function AngleEffect(t1, e1, r1) {
            this.p = PropertyFactory.getProp(e1, t1.v, 0, 0, r1);
        }
        function ColorEffect(t1, e1, r1) {
            this.p = PropertyFactory.getProp(e1, t1.v, 1, 0, r1);
        }
        function PointEffect(t1, e1, r1) {
            this.p = PropertyFactory.getProp(e1, t1.v, 1, 0, r1);
        }
        function LayerIndexEffect(t1, e1, r1) {
            this.p = PropertyFactory.getProp(e1, t1.v, 0, 0, r1);
        }
        function MaskIndexEffect(t1, e1, r1) {
            this.p = PropertyFactory.getProp(e1, t1.v, 0, 0, r1);
        }
        function CheckboxEffect(t1, e1, r1) {
            this.p = PropertyFactory.getProp(e1, t1.v, 0, 0, r1);
        }
        function NoValueEffect() {
            this.p = {};
        }
        function EffectsManager(t1, e1) {
            var r1, i1 = t1.ef || [];
            this.effectElements = [];
            var s1, a1 = i1.length;
            for(r1 = 0; r1 < a1; r1 += 1)s1 = new GroupEffect(i1[r1], e1), this.effectElements.push(s1);
        }
        function GroupEffect(t1, e1) {
            this.init(t1, e1);
        }
        function BaseElement() {}
        function FrameElement() {}
        function FootageElement(t1, e1, r1) {
            this.initFrame(), this.initRenderable(), this.assetData = e1.getAssetData(t1.refId), this.footageData = e1.imageLoader.getAsset(this.assetData), this.initBaseData(t1, e1, r1);
        }
        function AudioElement(t1, e1, r1) {
            this.initFrame(), this.initRenderable(), this.assetData = e1.getAssetData(t1.refId), this.initBaseData(t1, e1, r1), this._isPlaying = !1, this._canPlay = !1;
            var i1 = this.globalData.getAssetsPath(this.assetData);
            this.audio = this.globalData.audioController.createAudio(i1), this._currentTime = 0, this.globalData.audioController.addAudio(this), this._volumeMultiplier = 1, this._volume = 1, this._previousVolume = null, this.tm = t1.tm ? PropertyFactory.getProp(this, t1.tm, 0, e1.frameRate, this) : {
                _placeholder: !0
            }, this.lv = PropertyFactory.getProp(this, t1.au && t1.au.lv ? t1.au.lv : {
                k: [
                    100
                ]
            }, 1, .01, this);
        }
        function BaseRenderer() {}
        function TransformElement() {}
        function MaskElement(t1, e1, r1) {
            this.data = t1, this.element = e1, this.globalData = r1, this.storedData = [], this.masksProperties = this.data.masksProperties || [], this.maskElement = null;
            var i1, s1, a1 = this.globalData.defs, n1 = this.masksProperties ? this.masksProperties.length : 0;
            this.viewData = createSizedArray(n1), this.solidPath = "";
            var o1, h1, l1, p1, c1, f1, d1 = this.masksProperties, u1 = 0, m1 = [], y1 = createElementID(), g1 = "clipPath", v1 = "clip-path";
            for(i1 = 0; i1 < n1; i1 += 1)if (("a" !== d1[i1].mode && "n" !== d1[i1].mode || d1[i1].inv || 100 !== d1[i1].o.k || d1[i1].o.x) && (g1 = "mask", v1 = "mask"), "s" !== d1[i1].mode && "i" !== d1[i1].mode || 0 !== u1 ? l1 = null : ((l1 = createNS("rect")).setAttribute("fill", "#ffffff"), l1.setAttribute("width", this.element.comp.data.w || 0), l1.setAttribute("height", this.element.comp.data.h || 0), m1.push(l1)), s1 = createNS("path"), "n" === d1[i1].mode) this.viewData[i1] = {
                op: PropertyFactory.getProp(this.element, d1[i1].o, 0, .01, this.element),
                prop: ShapePropertyFactory.getShapeProp(this.element, d1[i1], 3),
                elem: s1,
                lastPath: ""
            }, a1.appendChild(s1);
            else {
                var b1;
                if (u1 += 1, s1.setAttribute("fill", "s" === d1[i1].mode ? "#000000" : "#ffffff"), s1.setAttribute("clip-rule", "nonzero"), 0 !== d1[i1].x.k ? (g1 = "mask", v1 = "mask", f1 = PropertyFactory.getProp(this.element, d1[i1].x, 0, null, this.element), b1 = createElementID(), (p1 = createNS("filter")).setAttribute("id", b1), (c1 = createNS("feMorphology")).setAttribute("operator", "erode"), c1.setAttribute("in", "SourceGraphic"), c1.setAttribute("radius", "0"), p1.appendChild(c1), a1.appendChild(p1), s1.setAttribute("stroke", "s" === d1[i1].mode ? "#000000" : "#ffffff")) : (c1 = null, f1 = null), this.storedData[i1] = {
                    elem: s1,
                    x: f1,
                    expan: c1,
                    lastPath: "",
                    lastOperator: "",
                    filterId: b1,
                    lastRadius: 0
                }, "i" === d1[i1].mode) {
                    h1 = m1.length;
                    var _1 = createNS("g");
                    for(o1 = 0; o1 < h1; o1 += 1)_1.appendChild(m1[o1]);
                    var P1 = createNS("mask");
                    P1.setAttribute("mask-type", "alpha"), P1.setAttribute("id", y1 + "_" + u1), P1.appendChild(s1), a1.appendChild(P1), _1.setAttribute("mask", "url(" + getLocationHref() + "#" + y1 + "_" + u1 + ")"), m1.length = 0, m1.push(_1);
                } else m1.push(s1);
                d1[i1].inv && !this.solidPath && (this.solidPath = this.createLayerSolidPath()), this.viewData[i1] = {
                    elem: s1,
                    lastPath: "",
                    op: PropertyFactory.getProp(this.element, d1[i1].o, 0, .01, this.element),
                    prop: ShapePropertyFactory.getShapeProp(this.element, d1[i1], 3),
                    invRect: l1
                }, this.viewData[i1].prop.k || this.drawPath(d1[i1], this.viewData[i1].prop.v, this.viewData[i1]);
            }
            for(this.maskElement = createNS(g1), n1 = m1.length, i1 = 0; i1 < n1; i1 += 1)this.maskElement.appendChild(m1[i1]);
            u1 > 0 && (this.maskElement.setAttribute("id", y1), this.element.maskedElement.setAttribute(v1, "url(" + getLocationHref() + "#" + y1 + ")"), a1.appendChild(this.maskElement)), this.viewData.length && this.element.addRenderableComponent(this);
        }
        extendPrototype([
            DynamicPropertyContainer
        ], GroupEffect), GroupEffect.prototype.getValue = GroupEffect.prototype.iterateDynamicProperties, GroupEffect.prototype.init = function(t1, e1) {
            var r1;
            this.data = t1, this.effectElements = [], this.initDynamicPropertyContainer(e1);
            var i1, s1 = this.data.ef.length, a1 = this.data.ef;
            for(r1 = 0; r1 < s1; r1 += 1){
                switch(i1 = null, a1[r1].ty){
                    case 0:
                        i1 = new SliderEffect(a1[r1], e1, this);
                        break;
                    case 1:
                        i1 = new AngleEffect(a1[r1], e1, this);
                        break;
                    case 2:
                        i1 = new ColorEffect(a1[r1], e1, this);
                        break;
                    case 3:
                        i1 = new PointEffect(a1[r1], e1, this);
                        break;
                    case 4:
                    case 7:
                        i1 = new CheckboxEffect(a1[r1], e1, this);
                        break;
                    case 10:
                        i1 = new LayerIndexEffect(a1[r1], e1, this);
                        break;
                    case 11:
                        i1 = new MaskIndexEffect(a1[r1], e1, this);
                        break;
                    case 5:
                        i1 = new EffectsManager(a1[r1], e1, this);
                        break;
                    default:
                        i1 = new NoValueEffect(a1[r1], e1, this);
                }
                i1 && this.effectElements.push(i1);
            }
        }, BaseElement.prototype = {
            checkMasks: function() {
                if (!this.data.hasMask) return !1;
                for(var t1 = 0, e1 = this.data.masksProperties.length; t1 < e1;){
                    if ("n" !== this.data.masksProperties[t1].mode && !1 !== this.data.masksProperties[t1].cl) return !0;
                    t1 += 1;
                }
                return !1;
            },
            initExpressions: function() {
                var t1 = getExpressionInterfaces();
                if (t1) {
                    var e1 = t1("layer"), r1 = t1("effects"), i1 = t1("shape"), s1 = t1("text"), a1 = t1("comp");
                    this.layerInterface = e1(this), this.data.hasMask && this.maskManager && this.layerInterface.registerMaskInterface(this.maskManager);
                    var n1 = r1.createEffectsInterface(this, this.layerInterface);
                    this.layerInterface.registerEffectsInterface(n1), 0 === this.data.ty || this.data.xt ? this.compInterface = a1(this) : 4 === this.data.ty ? (this.layerInterface.shapeInterface = i1(this.shapesData, this.itemsData, this.layerInterface), this.layerInterface.content = this.layerInterface.shapeInterface) : 5 === this.data.ty && (this.layerInterface.textInterface = s1(this), this.layerInterface.text = this.layerInterface.textInterface);
                }
            },
            setBlendMode: function() {
                var t1 = getBlendMode(this.data.bm);
                (this.baseElement || this.layerElement).style["mix-blend-mode"] = t1;
            },
            initBaseData: function(t1, e1, r1) {
                this.globalData = e1, this.comp = r1, this.data = t1, this.layerId = createElementID(), this.data.sr || (this.data.sr = 1), this.effectsManager = new EffectsManager(this.data, this, this.dynamicProperties);
            },
            getType: function() {
                return this.type;
            },
            sourceRectAtTime: function() {}
        }, FrameElement.prototype = {
            initFrame: function() {
                this._isFirstFrame = !1, this.dynamicProperties = [], this._mdf = !1;
            },
            prepareProperties: function(t1, e1) {
                var r1, i1 = this.dynamicProperties.length;
                for(r1 = 0; r1 < i1; r1 += 1)(e1 || this._isParent && "transform" === this.dynamicProperties[r1].propType) && (this.dynamicProperties[r1].getValue(), this.dynamicProperties[r1]._mdf && (this.globalData._mdf = !0, this._mdf = !0));
            },
            addDynamicProperty: function(t1) {
                -1 === this.dynamicProperties.indexOf(t1) && this.dynamicProperties.push(t1);
            }
        }, FootageElement.prototype.prepareFrame = function() {}, extendPrototype([
            RenderableElement,
            BaseElement,
            FrameElement
        ], FootageElement), FootageElement.prototype.getBaseElement = function() {
            return null;
        }, FootageElement.prototype.renderFrame = function() {}, FootageElement.prototype.destroy = function() {}, FootageElement.prototype.initExpressions = function() {
            var t1 = getExpressionInterfaces();
            if (t1) {
                var e1 = t1("footage");
                this.layerInterface = e1(this);
            }
        }, FootageElement.prototype.getFootageData = function() {
            return this.footageData;
        }, AudioElement.prototype.prepareFrame = function(t1) {
            if (this.prepareRenderableFrame(t1, !0), this.prepareProperties(t1, !0), this.tm._placeholder) this._currentTime = t1 / this.data.sr;
            else {
                var e1 = this.tm.v;
                this._currentTime = e1;
            }
            this._volume = this.lv.v[0];
            var r1 = this._volume * this._volumeMultiplier;
            this._previousVolume !== r1 && (this._previousVolume = r1, this.audio.volume(r1));
        }, extendPrototype([
            RenderableElement,
            BaseElement,
            FrameElement
        ], AudioElement), AudioElement.prototype.renderFrame = function() {
            this.isInRange && this._canPlay && (this._isPlaying ? (!this.audio.playing() || Math.abs(this._currentTime / this.globalData.frameRate - this.audio.seek()) > .1) && this.audio.seek(this._currentTime / this.globalData.frameRate) : (this.audio.play(), this.audio.seek(this._currentTime / this.globalData.frameRate), this._isPlaying = !0));
        }, AudioElement.prototype.show = function() {}, AudioElement.prototype.hide = function() {
            this.audio.pause(), this._isPlaying = !1;
        }, AudioElement.prototype.pause = function() {
            this.audio.pause(), this._isPlaying = !1, this._canPlay = !1;
        }, AudioElement.prototype.resume = function() {
            this._canPlay = !0;
        }, AudioElement.prototype.setRate = function(t1) {
            this.audio.rate(t1);
        }, AudioElement.prototype.volume = function(t1) {
            this._volumeMultiplier = t1, this._previousVolume = t1 * this._volume, this.audio.volume(this._previousVolume);
        }, AudioElement.prototype.getBaseElement = function() {
            return null;
        }, AudioElement.prototype.destroy = function() {}, AudioElement.prototype.sourceRectAtTime = function() {}, AudioElement.prototype.initExpressions = function() {}, BaseRenderer.prototype.checkLayers = function(t1) {
            var e1, r1, i1 = this.layers.length;
            for(this.completeLayers = !0, e1 = i1 - 1; e1 >= 0; e1 -= 1)this.elements[e1] || (r1 = this.layers[e1]).ip - r1.st <= t1 - this.layers[e1].st && r1.op - r1.st > t1 - this.layers[e1].st && this.buildItem(e1), this.completeLayers = !!this.elements[e1] && this.completeLayers;
            this.checkPendingElements();
        }, BaseRenderer.prototype.createItem = function(t1) {
            switch(t1.ty){
                case 2:
                    return this.createImage(t1);
                case 0:
                    return this.createComp(t1);
                case 1:
                    return this.createSolid(t1);
                case 3:
                default:
                    return this.createNull(t1);
                case 4:
                    return this.createShape(t1);
                case 5:
                    return this.createText(t1);
                case 6:
                    return this.createAudio(t1);
                case 13:
                    return this.createCamera(t1);
                case 15:
                    return this.createFootage(t1);
            }
        }, BaseRenderer.prototype.createCamera = function() {
            throw new Error("You're using a 3d camera. Try the html renderer.");
        }, BaseRenderer.prototype.createAudio = function(t1) {
            return new AudioElement(t1, this.globalData, this);
        }, BaseRenderer.prototype.createFootage = function(t1) {
            return new FootageElement(t1, this.globalData, this);
        }, BaseRenderer.prototype.buildAllItems = function() {
            var t1, e1 = this.layers.length;
            for(t1 = 0; t1 < e1; t1 += 1)this.buildItem(t1);
            this.checkPendingElements();
        }, BaseRenderer.prototype.includeLayers = function(t1) {
            var e1;
            this.completeLayers = !1;
            var r1, i1 = t1.length, s1 = this.layers.length;
            for(e1 = 0; e1 < i1; e1 += 1)for(r1 = 0; r1 < s1;){
                if (this.layers[r1].id === t1[e1].id) {
                    this.layers[r1] = t1[e1];
                    break;
                }
                r1 += 1;
            }
        }, BaseRenderer.prototype.setProjectInterface = function(t1) {
            this.globalData.projectInterface = t1;
        }, BaseRenderer.prototype.initItems = function() {
            this.globalData.progressiveLoad || this.buildAllItems();
        }, BaseRenderer.prototype.buildElementParenting = function(t1, e1, r1) {
            for(var i1 = this.elements, s1 = this.layers, a1 = 0, n1 = s1.length; a1 < n1;)s1[a1].ind == e1 && (i1[a1] && !0 !== i1[a1] ? (r1.push(i1[a1]), i1[a1].setAsParent(), void 0 !== s1[a1].parent ? this.buildElementParenting(t1, s1[a1].parent, r1) : t1.setHierarchy(r1)) : (this.buildItem(a1), this.addPendingElement(t1))), a1 += 1;
        }, BaseRenderer.prototype.addPendingElement = function(t1) {
            this.pendingElements.push(t1);
        }, BaseRenderer.prototype.searchExtraCompositions = function(t1) {
            var e1, r1 = t1.length;
            for(e1 = 0; e1 < r1; e1 += 1)if (t1[e1].xt) {
                var i1 = this.createComp(t1[e1]);
                i1.initExpressions(), this.globalData.projectInterface.registerComposition(i1);
            }
        }, BaseRenderer.prototype.getElementByPath = function(t1) {
            var e1, r1 = t1.shift();
            if ("number" == typeof r1) e1 = this.elements[r1];
            else {
                var i1, s1 = this.elements.length;
                for(i1 = 0; i1 < s1; i1 += 1)if (this.elements[i1].data.nm === r1) {
                    e1 = this.elements[i1];
                    break;
                }
            }
            return 0 === t1.length ? e1 : e1.getElementByPath(t1);
        }, BaseRenderer.prototype.setupGlobalData = function(t1, e1) {
            this.globalData.fontManager = new FontManager, this.globalData.fontManager.addChars(t1.chars), this.globalData.fontManager.addFonts(t1.fonts, e1), this.globalData.getAssetData = this.animationItem.getAssetData.bind(this.animationItem), this.globalData.getAssetsPath = this.animationItem.getAssetsPath.bind(this.animationItem), this.globalData.imageLoader = this.animationItem.imagePreloader, this.globalData.audioController = this.animationItem.audioController, this.globalData.frameId = 0, this.globalData.frameRate = t1.fr, this.globalData.nm = t1.nm, this.globalData.compSize = {
                w: t1.w,
                h: t1.h
            };
        }, TransformElement.prototype = {
            initTransform: function() {
                this.finalTransform = {
                    mProp: this.data.ks ? TransformPropertyFactory.getTransformProperty(this, this.data.ks, this) : {
                        o: 0
                    },
                    _matMdf: !1,
                    _opMdf: !1,
                    mat: new Matrix
                }, this.data.ao && (this.finalTransform.mProp.autoOriented = !0), this.data.ty;
            },
            renderTransform: function() {
                if (this.finalTransform._opMdf = this.finalTransform.mProp.o._mdf || this._isFirstFrame, this.finalTransform._matMdf = this.finalTransform.mProp._mdf || this._isFirstFrame, this.hierarchy) {
                    var t1, e1 = this.finalTransform.mat, r1 = 0, i1 = this.hierarchy.length;
                    if (!this.finalTransform._matMdf) for(; r1 < i1;){
                        if (this.hierarchy[r1].finalTransform.mProp._mdf) {
                            this.finalTransform._matMdf = !0;
                            break;
                        }
                        r1 += 1;
                    }
                    if (this.finalTransform._matMdf) for(t1 = this.finalTransform.mProp.v.props, e1.cloneFromProps(t1), r1 = 0; r1 < i1; r1 += 1)t1 = this.hierarchy[r1].finalTransform.mProp.v.props, e1.transform(t1[0], t1[1], t1[2], t1[3], t1[4], t1[5], t1[6], t1[7], t1[8], t1[9], t1[10], t1[11], t1[12], t1[13], t1[14], t1[15]);
                }
            },
            globalToLocal: function(t1) {
                var e1 = [];
                e1.push(this.finalTransform);
                for(var r1, i1 = !0, s1 = this.comp; i1;)s1.finalTransform ? (s1.data.hasMask && e1.splice(0, 0, s1.finalTransform), s1 = s1.comp) : i1 = !1;
                var a1, n1 = e1.length;
                for(r1 = 0; r1 < n1; r1 += 1)a1 = e1[r1].mat.applyToPointArray(0, 0, 0), t1 = [
                    t1[0] - a1[0],
                    t1[1] - a1[1],
                    0
                ];
                return t1;
            },
            mHelper: new Matrix
        }, MaskElement.prototype.getMaskProperty = function(t1) {
            return this.viewData[t1].prop;
        }, MaskElement.prototype.renderFrame = function(t1) {
            var e1, r1 = this.element.finalTransform.mat, i1 = this.masksProperties.length;
            for(e1 = 0; e1 < i1; e1 += 1)if ((this.viewData[e1].prop._mdf || t1) && this.drawPath(this.masksProperties[e1], this.viewData[e1].prop.v, this.viewData[e1]), (this.viewData[e1].op._mdf || t1) && this.viewData[e1].elem.setAttribute("fill-opacity", this.viewData[e1].op.v), "n" !== this.masksProperties[e1].mode && (this.viewData[e1].invRect && (this.element.finalTransform.mProp._mdf || t1) && this.viewData[e1].invRect.setAttribute("transform", r1.getInverseMatrix().to2dCSS()), this.storedData[e1].x && (this.storedData[e1].x._mdf || t1))) {
                var s1 = this.storedData[e1].expan;
                this.storedData[e1].x.v < 0 ? ("erode" !== this.storedData[e1].lastOperator && (this.storedData[e1].lastOperator = "erode", this.storedData[e1].elem.setAttribute("filter", "url(" + getLocationHref() + "#" + this.storedData[e1].filterId + ")")), s1.setAttribute("radius", -this.storedData[e1].x.v)) : ("dilate" !== this.storedData[e1].lastOperator && (this.storedData[e1].lastOperator = "dilate", this.storedData[e1].elem.setAttribute("filter", null)), this.storedData[e1].elem.setAttribute("stroke-width", 2 * this.storedData[e1].x.v));
            }
        }, MaskElement.prototype.getMaskelement = function() {
            return this.maskElement;
        }, MaskElement.prototype.createLayerSolidPath = function() {
            var t1 = "M0,0 ";
            return t1 += " h" + this.globalData.compSize.w, t1 += " v" + this.globalData.compSize.h, t1 += " h-" + this.globalData.compSize.w, t1 += " v-" + this.globalData.compSize.h + " ";
        }, MaskElement.prototype.drawPath = function(t1, e1, r1) {
            var i1, s1, a1 = " M" + e1.v[0][0] + "," + e1.v[0][1];
            for(s1 = e1._length, i1 = 1; i1 < s1; i1 += 1)a1 += " C" + e1.o[i1 - 1][0] + "," + e1.o[i1 - 1][1] + " " + e1.i[i1][0] + "," + e1.i[i1][1] + " " + e1.v[i1][0] + "," + e1.v[i1][1];
            if (e1.c && s1 > 1 && (a1 += " C" + e1.o[i1 - 1][0] + "," + e1.o[i1 - 1][1] + " " + e1.i[0][0] + "," + e1.i[0][1] + " " + e1.v[0][0] + "," + e1.v[0][1]), r1.lastPath !== a1) {
                var n1 = "";
                r1.elem && (e1.c && (n1 = t1.inv ? this.solidPath + a1 : a1), r1.elem.setAttribute("d", n1)), r1.lastPath = a1;
            }
        }, MaskElement.prototype.destroy = function() {
            this.element = null, this.globalData = null, this.maskElement = null, this.data = null, this.masksProperties = null;
        };
        var filtersFactory = function() {
            var t1 = {
                createFilter: function(t1, e1) {
                    var r1 = createNS("filter");
                    return r1.setAttribute("id", t1), !0 !== e1 && (r1.setAttribute("filterUnits", "objectBoundingBox"), r1.setAttribute("x", "0%"), r1.setAttribute("y", "0%"), r1.setAttribute("width", "100%"), r1.setAttribute("height", "100%")), r1;
                },
                createAlphaToLuminanceFilter: function() {
                    var t1 = createNS("feColorMatrix");
                    return t1.setAttribute("type", "matrix"), t1.setAttribute("color-interpolation-filters", "sRGB"), t1.setAttribute("values", "0 0 0 1 0  0 0 0 1 0  0 0 0 1 0  0 0 0 1 1"), t1;
                }
            };
            return t1;
        }(), featureSupport = function() {
            var t1 = {
                maskType: !0
            };
            return (/MSIE 10/i.test(navigator.userAgent) || /MSIE 9/i.test(navigator.userAgent) || /rv:11.0/i.test(navigator.userAgent) || /Edge\/\d./i.test(navigator.userAgent)) && (t1.maskType = !1), t1;
        }(), registeredEffects = {}, idPrefix = "filter_result_";
        function SVGEffects(t1) {
            var e1, r1, i1 = "SourceGraphic", s1 = t1.data.ef ? t1.data.ef.length : 0, a1 = createElementID(), n1 = filtersFactory.createFilter(a1, !0), o1 = 0;
            for(this.filters = [], e1 = 0; e1 < s1; e1 += 1){
                r1 = null;
                var h1 = t1.data.ef[e1].ty;
                registeredEffects[h1] && (r1 = new registeredEffects[h1].effect(n1, t1.effectsManager.effectElements[e1], t1, idPrefix + o1, i1), i1 = idPrefix + o1, registeredEffects[h1].countsAsEffect && (o1 += 1)), r1 && this.filters.push(r1);
            }
            o1 && (t1.globalData.defs.appendChild(n1), t1.layerElement.setAttribute("filter", "url(" + getLocationHref() + "#" + a1 + ")")), this.filters.length && t1.addRenderableComponent(this);
        }
        function registerEffect(t1, e1, r1) {
            registeredEffects[t1] = {
                effect: e1,
                countsAsEffect: r1
            };
        }
        function SVGBaseElement() {}
        function HierarchyElement() {}
        function RenderableDOMElement() {}
        function IImageElement(t1, e1, r1) {
            this.assetData = e1.getAssetData(t1.refId), this.initElement(t1, e1, r1), this.sourceRect = {
                top: 0,
                left: 0,
                width: this.assetData.w,
                height: this.assetData.h
            };
        }
        function ProcessedElement(t1, e1) {
            this.elem = t1, this.pos = e1;
        }
        function IShapeElement() {}
        SVGEffects.prototype.renderFrame = function(t1) {
            var e1, r1 = this.filters.length;
            for(e1 = 0; e1 < r1; e1 += 1)this.filters[e1].renderFrame(t1);
        }, SVGBaseElement.prototype = {
            initRendererElement: function() {
                this.layerElement = createNS("g");
            },
            createContainerElements: function() {
                this.matteElement = createNS("g"), this.transformedElement = this.layerElement, this.maskedElement = this.layerElement, this._sizeChanged = !1;
                var t1 = null;
                if (this.data.td) {
                    this.matteMasks = {};
                    var e1 = createNS("symbol");
                    e1.setAttribute("id", this.layerId);
                    var r1 = createNS("g");
                    r1.appendChild(this.layerElement), e1.appendChild(r1), t1 = r1, this.globalData.defs.appendChild(e1);
                } else this.data.tt ? (this.matteElement.appendChild(this.layerElement), t1 = this.matteElement, this.baseElement = this.matteElement) : this.baseElement = this.layerElement;
                if (this.data.ln && this.layerElement.setAttribute("id", this.data.ln), this.data.cl && this.layerElement.setAttribute("class", this.data.cl), 0 === this.data.ty && !this.data.hd) {
                    var i1 = createNS("clipPath"), s1 = createNS("path");
                    s1.setAttribute("d", "M0,0 L" + this.data.w + ",0 L" + this.data.w + "," + this.data.h + " L0," + this.data.h + "z");
                    var a1 = createElementID();
                    if (i1.setAttribute("id", a1), i1.appendChild(s1), this.globalData.defs.appendChild(i1), this.checkMasks()) {
                        var n1 = createNS("g");
                        n1.setAttribute("clip-path", "url(" + getLocationHref() + "#" + a1 + ")"), n1.appendChild(this.layerElement), this.transformedElement = n1, t1 ? t1.appendChild(this.transformedElement) : this.baseElement = this.transformedElement;
                    } else this.layerElement.setAttribute("clip-path", "url(" + getLocationHref() + "#" + a1 + ")");
                }
                0 !== this.data.bm && this.setBlendMode();
            },
            renderElement: function() {
                this.finalTransform._matMdf && this.transformedElement.setAttribute("transform", this.finalTransform.mat.to2dCSS()), this.finalTransform._opMdf && this.transformedElement.setAttribute("opacity", this.finalTransform.mProp.o.v);
            },
            destroyBaseElement: function() {
                this.layerElement = null, this.matteElement = null, this.maskManager.destroy();
            },
            getBaseElement: function() {
                return this.data.hd ? null : this.baseElement;
            },
            createRenderableComponents: function() {
                this.maskManager = new MaskElement(this.data, this, this.globalData), this.renderableEffectsManager = new SVGEffects(this);
            },
            getMatte: function(t1) {
                if (!this.matteMasks[t1]) {
                    var e1, r1, i1, s1, a1 = this.layerId + "_" + t1;
                    if (1 === t1 || 3 === t1) {
                        var n1 = createNS("mask");
                        n1.setAttribute("id", a1), n1.setAttribute("mask-type", 3 === t1 ? "luminance" : "alpha"), (i1 = createNS("use")).setAttributeNS("http://www.w3.org/1999/xlink", "href", "#" + this.layerId), n1.appendChild(i1), this.globalData.defs.appendChild(n1), featureSupport.maskType || 1 !== t1 || (n1.setAttribute("mask-type", "luminance"), e1 = createElementID(), r1 = filtersFactory.createFilter(e1), this.globalData.defs.appendChild(r1), r1.appendChild(filtersFactory.createAlphaToLuminanceFilter()), (s1 = createNS("g")).appendChild(i1), n1.appendChild(s1), s1.setAttribute("filter", "url(" + getLocationHref() + "#" + e1 + ")"));
                    } else if (2 === t1) {
                        var o1 = createNS("mask");
                        o1.setAttribute("id", a1), o1.setAttribute("mask-type", "alpha");
                        var h1 = createNS("g");
                        o1.appendChild(h1), e1 = createElementID(), r1 = filtersFactory.createFilter(e1);
                        var l1 = createNS("feComponentTransfer");
                        l1.setAttribute("in", "SourceGraphic"), r1.appendChild(l1);
                        var p1 = createNS("feFuncA");
                        p1.setAttribute("type", "table"), p1.setAttribute("tableValues", "1.0 0.0"), l1.appendChild(p1), this.globalData.defs.appendChild(r1);
                        var c1 = createNS("rect");
                        c1.setAttribute("width", this.comp.data.w), c1.setAttribute("height", this.comp.data.h), c1.setAttribute("x", "0"), c1.setAttribute("y", "0"), c1.setAttribute("fill", "#ffffff"), c1.setAttribute("opacity", "0"), h1.setAttribute("filter", "url(" + getLocationHref() + "#" + e1 + ")"), h1.appendChild(c1), (i1 = createNS("use")).setAttributeNS("http://www.w3.org/1999/xlink", "href", "#" + this.layerId), h1.appendChild(i1), featureSupport.maskType || (o1.setAttribute("mask-type", "luminance"), r1.appendChild(filtersFactory.createAlphaToLuminanceFilter()), s1 = createNS("g"), h1.appendChild(c1), s1.appendChild(this.layerElement), h1.appendChild(s1)), this.globalData.defs.appendChild(o1);
                    }
                    this.matteMasks[t1] = a1;
                }
                return this.matteMasks[t1];
            },
            setMatte: function(t1) {
                this.matteElement && this.matteElement.setAttribute("mask", "url(" + getLocationHref() + "#" + t1 + ")");
            }
        }, HierarchyElement.prototype = {
            initHierarchy: function() {
                this.hierarchy = [], this._isParent = !1, this.checkParenting();
            },
            setHierarchy: function(t1) {
                this.hierarchy = t1;
            },
            setAsParent: function() {
                this._isParent = !0;
            },
            checkParenting: function() {
                void 0 !== this.data.parent && this.comp.buildElementParenting(this, this.data.parent, []);
            }
        }, extendPrototype([
            RenderableElement,
            createProxyFunction({
                initElement: function(t1, e1, r1) {
                    this.initFrame(), this.initBaseData(t1, e1, r1), this.initTransform(t1, e1, r1), this.initHierarchy(), this.initRenderable(), this.initRendererElement(), this.createContainerElements(), this.createRenderableComponents(), this.createContent(), this.hide();
                },
                hide: function() {
                    this.hidden || this.isInRange && !this.isTransparent || ((this.baseElement || this.layerElement).style.display = "none", this.hidden = !0);
                },
                show: function() {
                    this.isInRange && !this.isTransparent && (this.data.hd || ((this.baseElement || this.layerElement).style.display = "block"), this.hidden = !1, this._isFirstFrame = !0);
                },
                renderFrame: function() {
                    this.data.hd || this.hidden || (this.renderTransform(), this.renderRenderable(), this.renderElement(), this.renderInnerContent(), this._isFirstFrame && (this._isFirstFrame = !1));
                },
                renderInnerContent: function() {},
                prepareFrame: function(t1) {
                    this._mdf = !1, this.prepareRenderableFrame(t1), this.prepareProperties(t1, this.isInRange), this.checkTransparency();
                },
                destroy: function() {
                    this.innerElem = null, this.destroyBaseElement();
                }
            })
        ], RenderableDOMElement), extendPrototype([
            BaseElement,
            TransformElement,
            SVGBaseElement,
            HierarchyElement,
            FrameElement,
            RenderableDOMElement
        ], IImageElement), IImageElement.prototype.createContent = function() {
            var t1 = this.globalData.getAssetsPath(this.assetData);
            this.innerElem = createNS("image"), this.innerElem.setAttribute("width", this.assetData.w + "px"), this.innerElem.setAttribute("height", this.assetData.h + "px"), this.innerElem.setAttribute("preserveAspectRatio", this.assetData.pr || this.globalData.renderConfig.imagePreserveAspectRatio), this.innerElem.setAttributeNS("http://www.w3.org/1999/xlink", "href", t1), this.layerElement.appendChild(this.innerElem);
        }, IImageElement.prototype.sourceRectAtTime = function() {
            return this.sourceRect;
        }, IShapeElement.prototype = {
            addShapeToModifiers: function(t1) {
                var e1, r1 = this.shapeModifiers.length;
                for(e1 = 0; e1 < r1; e1 += 1)this.shapeModifiers[e1].addShape(t1);
            },
            isShapeInAnimatedModifiers: function(t1) {
                for(var e1 = this.shapeModifiers.length; 0 < e1;)if (this.shapeModifiers[0].isAnimatedWithShape(t1)) return !0;
                return !1;
            },
            renderModifiers: function() {
                if (this.shapeModifiers.length) {
                    var t1, e1 = this.shapes.length;
                    for(t1 = 0; t1 < e1; t1 += 1)this.shapes[t1].sh.reset();
                    for(t1 = (e1 = this.shapeModifiers.length) - 1; t1 >= 0 && !this.shapeModifiers[t1].processShapes(this._isFirstFrame); t1 -= 1);
                }
            },
            searchProcessedElement: function(t1) {
                for(var e1 = this.processedElements, r1 = 0, i1 = e1.length; r1 < i1;){
                    if (e1[r1].elem === t1) return e1[r1].pos;
                    r1 += 1;
                }
                return 0;
            },
            addProcessedElement: function(t1, e1) {
                for(var r1 = this.processedElements, i1 = r1.length; i1;)if (r1[i1 -= 1].elem === t1) return void (r1[i1].pos = e1);
                r1.push(new ProcessedElement(t1, e1));
            },
            prepareFrame: function(t1) {
                this.prepareRenderableFrame(t1), this.prepareProperties(t1, this.isInRange);
            }
        };
        var lineCapEnum = {
            1: "butt",
            2: "round",
            3: "square"
        }, lineJoinEnum = {
            1: "miter",
            2: "round",
            3: "bevel"
        };
        function SVGShapeData(t1, e1, r1) {
            this.caches = [], this.styles = [], this.transformers = t1, this.lStr = "", this.sh = r1, this.lvl = e1, this._isAnimated = !!r1.k;
            for(var i1 = 0, s1 = t1.length; i1 < s1;){
                if (t1[i1].mProps.dynamicProperties.length) {
                    this._isAnimated = !0;
                    break;
                }
                i1 += 1;
            }
        }
        function SVGStyleData(t1, e1) {
            this.data = t1, this.type = t1.ty, this.d = "", this.lvl = e1, this._mdf = !1, this.closed = !0 === t1.hd, this.pElem = createNS("path"), this.msElem = null;
        }
        function DashProperty(t1, e1, r1, i1) {
            var s1;
            this.elem = t1, this.frameId = -1, this.dataProps = createSizedArray(e1.length), this.renderer = r1, this.k = !1, this.dashStr = "", this.dashArray = createTypedArray("float32", e1.length ? e1.length - 1 : 0), this.dashoffset = createTypedArray("float32", 1), this.initDynamicPropertyContainer(i1);
            var a1, n1 = e1.length || 0;
            for(s1 = 0; s1 < n1; s1 += 1)a1 = PropertyFactory.getProp(t1, e1[s1].v, 0, 0, this), this.k = a1.k || this.k, this.dataProps[s1] = {
                n: e1[s1].n,
                p: a1
            };
            this.k || this.getValue(!0), this._isAnimated = this.k;
        }
        function SVGStrokeStyleData(t1, e1, r1) {
            this.initDynamicPropertyContainer(t1), this.getValue = this.iterateDynamicProperties, this.o = PropertyFactory.getProp(t1, e1.o, 0, .01, this), this.w = PropertyFactory.getProp(t1, e1.w, 0, null, this), this.d = new DashProperty(t1, e1.d || {}, "svg", this), this.c = PropertyFactory.getProp(t1, e1.c, 1, 255, this), this.style = r1, this._isAnimated = !!this._isAnimated;
        }
        function SVGFillStyleData(t1, e1, r1) {
            this.initDynamicPropertyContainer(t1), this.getValue = this.iterateDynamicProperties, this.o = PropertyFactory.getProp(t1, e1.o, 0, .01, this), this.c = PropertyFactory.getProp(t1, e1.c, 1, 255, this), this.style = r1;
        }
        function SVGNoStyleData(t1, e1, r1) {
            this.initDynamicPropertyContainer(t1), this.getValue = this.iterateDynamicProperties, this.style = r1;
        }
        function GradientProperty(t1, e1, r1) {
            this.data = e1, this.c = createTypedArray("uint8c", 4 * e1.p);
            var i1 = e1.k.k[0].s ? e1.k.k[0].s.length - 4 * e1.p : e1.k.k.length - 4 * e1.p;
            this.o = createTypedArray("float32", i1), this._cmdf = !1, this._omdf = !1, this._collapsable = this.checkCollapsable(), this._hasOpacity = i1, this.initDynamicPropertyContainer(r1), this.prop = PropertyFactory.getProp(t1, e1.k, 1, null, this), this.k = this.prop.k, this.getValue(!0);
        }
        function SVGGradientFillStyleData(t1, e1, r1) {
            this.initDynamicPropertyContainer(t1), this.getValue = this.iterateDynamicProperties, this.initGradientData(t1, e1, r1);
        }
        function SVGGradientStrokeStyleData(t1, e1, r1) {
            this.initDynamicPropertyContainer(t1), this.getValue = this.iterateDynamicProperties, this.w = PropertyFactory.getProp(t1, e1.w, 0, null, this), this.d = new DashProperty(t1, e1.d || {}, "svg", this), this.initGradientData(t1, e1, r1), this._isAnimated = !!this._isAnimated;
        }
        function ShapeGroupData() {
            this.it = [], this.prevViewData = [], this.gr = createNS("g");
        }
        function SVGTransformData(t1, e1, r1) {
            this.transform = {
                mProps: t1,
                op: e1,
                container: r1
            }, this.elements = [], this._isAnimated = this.transform.mProps.dynamicProperties.length || this.transform.op.effectsSequence.length;
        }
        SVGShapeData.prototype.setAsAnimated = function() {
            this._isAnimated = !0;
        }, SVGStyleData.prototype.reset = function() {
            this.d = "", this._mdf = !1;
        }, DashProperty.prototype.getValue = function(t1) {
            if ((this.elem.globalData.frameId !== this.frameId || t1) && (this.frameId = this.elem.globalData.frameId, this.iterateDynamicProperties(), this._mdf = this._mdf || t1, this._mdf)) {
                var e1 = 0, r1 = this.dataProps.length;
                for("svg" === this.renderer && (this.dashStr = ""), e1 = 0; e1 < r1; e1 += 1)"o" !== this.dataProps[e1].n ? "svg" === this.renderer ? this.dashStr += " " + this.dataProps[e1].p.v : this.dashArray[e1] = this.dataProps[e1].p.v : this.dashoffset[0] = this.dataProps[e1].p.v;
            }
        }, extendPrototype([
            DynamicPropertyContainer
        ], DashProperty), extendPrototype([
            DynamicPropertyContainer
        ], SVGStrokeStyleData), extendPrototype([
            DynamicPropertyContainer
        ], SVGFillStyleData), extendPrototype([
            DynamicPropertyContainer
        ], SVGNoStyleData), GradientProperty.prototype.comparePoints = function(t1, e1) {
            for(var r1 = 0, i1 = this.o.length / 2; r1 < i1;){
                if (Math.abs(t1[4 * r1] - t1[4 * e1 + 2 * r1]) > .01) return !1;
                r1 += 1;
            }
            return !0;
        }, GradientProperty.prototype.checkCollapsable = function() {
            if (this.o.length / 2 != this.c.length / 4) return !1;
            if (this.data.k.k[0].s) for(var t1 = 0, e1 = this.data.k.k.length; t1 < e1;){
                if (!this.comparePoints(this.data.k.k[t1].s, this.data.p)) return !1;
                t1 += 1;
            }
            else if (!this.comparePoints(this.data.k.k, this.data.p)) return !1;
            return !0;
        }, GradientProperty.prototype.getValue = function(t1) {
            if (this.prop.getValue(), this._mdf = !1, this._cmdf = !1, this._omdf = !1, this.prop._mdf || t1) {
                var e1, r1, i1, s1 = 4 * this.data.p;
                for(e1 = 0; e1 < s1; e1 += 1)r1 = e1 % 4 == 0 ? 100 : 255, i1 = Math.round(this.prop.v[e1] * r1), this.c[e1] !== i1 && (this.c[e1] = i1, this._cmdf = !t1);
                if (this.o.length) for(s1 = this.prop.v.length, e1 = 4 * this.data.p; e1 < s1; e1 += 1)r1 = e1 % 2 == 0 ? 100 : 1, i1 = e1 % 2 == 0 ? Math.round(100 * this.prop.v[e1]) : this.prop.v[e1], this.o[e1 - 4 * this.data.p] !== i1 && (this.o[e1 - 4 * this.data.p] = i1, this._omdf = !t1);
                this._mdf = !t1;
            }
        }, extendPrototype([
            DynamicPropertyContainer
        ], GradientProperty), SVGGradientFillStyleData.prototype.initGradientData = function(t1, e1, r1) {
            this.o = PropertyFactory.getProp(t1, e1.o, 0, .01, this), this.s = PropertyFactory.getProp(t1, e1.s, 1, null, this), this.e = PropertyFactory.getProp(t1, e1.e, 1, null, this), this.h = PropertyFactory.getProp(t1, e1.h || {
                k: 0
            }, 0, .01, this), this.a = PropertyFactory.getProp(t1, e1.a || {
                k: 0
            }, 0, degToRads, this), this.g = new GradientProperty(t1, e1.g, this), this.style = r1, this.stops = [], this.setGradientData(r1.pElem, e1), this.setGradientOpacity(e1, r1), this._isAnimated = !!this._isAnimated;
        }, SVGGradientFillStyleData.prototype.setGradientData = function(t1, e1) {
            var r1 = createElementID(), i1 = createNS(1 === e1.t ? "linearGradient" : "radialGradient");
            i1.setAttribute("id", r1), i1.setAttribute("spreadMethod", "pad"), i1.setAttribute("gradientUnits", "userSpaceOnUse");
            var s1, a1, n1, o1 = [];
            for(n1 = 4 * e1.g.p, a1 = 0; a1 < n1; a1 += 4)s1 = createNS("stop"), i1.appendChild(s1), o1.push(s1);
            t1.setAttribute("gf" === e1.ty ? "fill" : "stroke", "url(" + getLocationHref() + "#" + r1 + ")"), this.gf = i1, this.cst = o1;
        }, SVGGradientFillStyleData.prototype.setGradientOpacity = function(t1, e1) {
            if (this.g._hasOpacity && !this.g._collapsable) {
                var r1, i1, s1, a1 = createNS("mask"), n1 = createNS("path");
                a1.appendChild(n1);
                var o1 = createElementID(), h1 = createElementID();
                a1.setAttribute("id", h1);
                var l1 = createNS(1 === t1.t ? "linearGradient" : "radialGradient");
                l1.setAttribute("id", o1), l1.setAttribute("spreadMethod", "pad"), l1.setAttribute("gradientUnits", "userSpaceOnUse"), s1 = t1.g.k.k[0].s ? t1.g.k.k[0].s.length : t1.g.k.k.length;
                var p1 = this.stops;
                for(i1 = 4 * t1.g.p; i1 < s1; i1 += 2)(r1 = createNS("stop")).setAttribute("stop-color", "rgb(255,255,255)"), l1.appendChild(r1), p1.push(r1);
                n1.setAttribute("gf" === t1.ty ? "fill" : "stroke", "url(" + getLocationHref() + "#" + o1 + ")"), "gs" === t1.ty && (n1.setAttribute("stroke-linecap", lineCapEnum[t1.lc || 2]), n1.setAttribute("stroke-linejoin", lineJoinEnum[t1.lj || 2]), 1 === t1.lj && n1.setAttribute("stroke-miterlimit", t1.ml)), this.of = l1, this.ms = a1, this.ost = p1, this.maskId = h1, e1.msElem = n1;
            }
        }, extendPrototype([
            DynamicPropertyContainer
        ], SVGGradientFillStyleData), extendPrototype([
            SVGGradientFillStyleData,
            DynamicPropertyContainer
        ], SVGGradientStrokeStyleData);
        var buildShapeString = function(t1, e1, r1, i1) {
            if (0 === e1) return "";
            var s1, a1 = t1.o, n1 = t1.i, o1 = t1.v, h1 = " M" + i1.applyToPointStringified(o1[0][0], o1[0][1]);
            for(s1 = 1; s1 < e1; s1 += 1)h1 += " C" + i1.applyToPointStringified(a1[s1 - 1][0], a1[s1 - 1][1]) + " " + i1.applyToPointStringified(n1[s1][0], n1[s1][1]) + " " + i1.applyToPointStringified(o1[s1][0], o1[s1][1]);
            return r1 && e1 && (h1 += " C" + i1.applyToPointStringified(a1[s1 - 1][0], a1[s1 - 1][1]) + " " + i1.applyToPointStringified(n1[0][0], n1[0][1]) + " " + i1.applyToPointStringified(o1[0][0], o1[0][1]), h1 += "z"), h1;
        }, SVGElementsRenderer = function() {
            var t1 = new Matrix, e1 = new Matrix;
            function r1(t1, e1, r1) {
                (r1 || e1.transform.op._mdf) && e1.transform.container.setAttribute("opacity", e1.transform.op.v), (r1 || e1.transform.mProps._mdf) && e1.transform.container.setAttribute("transform", e1.transform.mProps.v.to2dCSS());
            }
            function i1() {}
            function s1(r1, i1, s1) {
                var a1, n1, o1, h1, l1, p1, c1, f1, d1, u1, m1, y1 = i1.styles.length, g1 = i1.lvl;
                for(p1 = 0; p1 < y1; p1 += 1){
                    if (h1 = i1.sh._mdf || s1, i1.styles[p1].lvl < g1) {
                        for(f1 = e1.reset(), u1 = g1 - i1.styles[p1].lvl, m1 = i1.transformers.length - 1; !h1 && u1 > 0;)h1 = i1.transformers[m1].mProps._mdf || h1, u1 -= 1, m1 -= 1;
                        if (h1) for(u1 = g1 - i1.styles[p1].lvl, m1 = i1.transformers.length - 1; u1 > 0;)d1 = i1.transformers[m1].mProps.v.props, f1.transform(d1[0], d1[1], d1[2], d1[3], d1[4], d1[5], d1[6], d1[7], d1[8], d1[9], d1[10], d1[11], d1[12], d1[13], d1[14], d1[15]), u1 -= 1, m1 -= 1;
                    } else f1 = t1;
                    if (n1 = (c1 = i1.sh.paths)._length, h1) {
                        for(o1 = "", a1 = 0; a1 < n1; a1 += 1)(l1 = c1.shapes[a1]) && l1._length && (o1 += buildShapeString(l1, l1._length, l1.c, f1));
                        i1.caches[p1] = o1;
                    } else o1 = i1.caches[p1];
                    i1.styles[p1].d += !0 === r1.hd ? "" : o1, i1.styles[p1]._mdf = h1 || i1.styles[p1]._mdf;
                }
            }
            function a1(t1, e1, r1) {
                var i1 = e1.style;
                (e1.c._mdf || r1) && i1.pElem.setAttribute("fill", "rgb(" + bmFloor(e1.c.v[0]) + "," + bmFloor(e1.c.v[1]) + "," + bmFloor(e1.c.v[2]) + ")"), (e1.o._mdf || r1) && i1.pElem.setAttribute("fill-opacity", e1.o.v);
            }
            function n1(t1, e1, r1) {
                o1(t1, e1, r1), h1(0, e1, r1);
            }
            function o1(t1, e1, r1) {
                var i1, s1, a1, n1, o1, h1 = e1.gf, l1 = e1.g._hasOpacity, p1 = e1.s.v, c1 = e1.e.v;
                if (e1.o._mdf || r1) {
                    var f1 = "gf" === t1.ty ? "fill-opacity" : "stroke-opacity";
                    e1.style.pElem.setAttribute(f1, e1.o.v);
                }
                if (e1.s._mdf || r1) {
                    var d1 = 1 === t1.t ? "x1" : "cx", u1 = "x1" === d1 ? "y1" : "cy";
                    h1.setAttribute(d1, p1[0]), h1.setAttribute(u1, p1[1]), l1 && !e1.g._collapsable && (e1.of.setAttribute(d1, p1[0]), e1.of.setAttribute(u1, p1[1]));
                }
                if (e1.g._cmdf || r1) {
                    i1 = e1.cst;
                    var m1 = e1.g.c;
                    for(a1 = i1.length, s1 = 0; s1 < a1; s1 += 1)(n1 = i1[s1]).setAttribute("offset", m1[4 * s1] + "%"), n1.setAttribute("stop-color", "rgb(" + m1[4 * s1 + 1] + "," + m1[4 * s1 + 2] + "," + m1[4 * s1 + 3] + ")");
                }
                if (l1 && (e1.g._omdf || r1)) {
                    var y1 = e1.g.o;
                    for(a1 = (i1 = e1.g._collapsable ? e1.cst : e1.ost).length, s1 = 0; s1 < a1; s1 += 1)n1 = i1[s1], e1.g._collapsable || n1.setAttribute("offset", y1[2 * s1] + "%"), n1.setAttribute("stop-opacity", y1[2 * s1 + 1]);
                }
                if (1 === t1.t) (e1.e._mdf || r1) && (h1.setAttribute("x2", c1[0]), h1.setAttribute("y2", c1[1]), l1 && !e1.g._collapsable && (e1.of.setAttribute("x2", c1[0]), e1.of.setAttribute("y2", c1[1])));
                else if ((e1.s._mdf || e1.e._mdf || r1) && (o1 = Math.sqrt(Math.pow(p1[0] - c1[0], 2) + Math.pow(p1[1] - c1[1], 2)), h1.setAttribute("r", o1), l1 && !e1.g._collapsable && e1.of.setAttribute("r", o1)), e1.e._mdf || e1.h._mdf || e1.a._mdf || r1) {
                    o1 || (o1 = Math.sqrt(Math.pow(p1[0] - c1[0], 2) + Math.pow(p1[1] - c1[1], 2)));
                    var g1 = Math.atan2(c1[1] - p1[1], c1[0] - p1[0]), v1 = e1.h.v;
                    v1 >= 1 ? v1 = .99 : v1 <= -1 && (v1 = -0.99);
                    var b1 = o1 * v1, _1 = Math.cos(g1 + e1.a.v) * b1 + p1[0], P1 = Math.sin(g1 + e1.a.v) * b1 + p1[1];
                    h1.setAttribute("fx", _1), h1.setAttribute("fy", P1), l1 && !e1.g._collapsable && (e1.of.setAttribute("fx", _1), e1.of.setAttribute("fy", P1));
                }
            }
            function h1(t1, e1, r1) {
                var i1 = e1.style, s1 = e1.d;
                s1 && (s1._mdf || r1) && s1.dashStr && (i1.pElem.setAttribute("stroke-dasharray", s1.dashStr), i1.pElem.setAttribute("stroke-dashoffset", s1.dashoffset[0])), e1.c && (e1.c._mdf || r1) && i1.pElem.setAttribute("stroke", "rgb(" + bmFloor(e1.c.v[0]) + "," + bmFloor(e1.c.v[1]) + "," + bmFloor(e1.c.v[2]) + ")"), (e1.o._mdf || r1) && i1.pElem.setAttribute("stroke-opacity", e1.o.v), (e1.w._mdf || r1) && (i1.pElem.setAttribute("stroke-width", e1.w.v), i1.msElem && i1.msElem.setAttribute("stroke-width", e1.w.v));
            }
            return {
                createRenderFunction: function(t1) {
                    switch(t1.ty){
                        case "fl":
                            return a1;
                        case "gf":
                            return o1;
                        case "gs":
                            return n1;
                        case "st":
                            return h1;
                        case "sh":
                        case "el":
                        case "rc":
                        case "sr":
                            return s1;
                        case "tr":
                            return r1;
                        case "no":
                            return i1;
                        default:
                            return null;
                    }
                }
            };
        }();
        function SVGShapeElement(t1, e1, r1) {
            this.shapes = [], this.shapesData = t1.shapes, this.stylesList = [], this.shapeModifiers = [], this.itemsData = [], this.processedElements = [], this.animatedContents = [], this.initElement(t1, e1, r1), this.prevViewData = [];
        }
        function LetterProps(t1, e1, r1, i1, s1, a1) {
            this.o = t1, this.sw = e1, this.sc = r1, this.fc = i1, this.m = s1, this.p = a1, this._mdf = {
                o: !0,
                sw: !!e1,
                sc: !!r1,
                fc: !!i1,
                m: !0,
                p: !0
            };
        }
        function TextProperty(t1, e1) {
            this._frameId = initialDefaultFrame, this.pv = "", this.v = "", this.kf = !1, this._isFirstFrame = !0, this._mdf = !1, this.data = e1, this.elem = t1, this.comp = this.elem.comp, this.keysIndex = 0, this.canResize = !1, this.minimumFontSize = 1, this.effectsSequence = [], this.currentData = {
                ascent: 0,
                boxWidth: this.defaultBoxWidth,
                f: "",
                fStyle: "",
                fWeight: "",
                fc: "",
                j: "",
                justifyOffset: "",
                l: [],
                lh: 0,
                lineWidths: [],
                ls: "",
                of: "",
                s: "",
                sc: "",
                sw: 0,
                t: 0,
                tr: 0,
                sz: 0,
                ps: null,
                fillColorAnim: !1,
                strokeColorAnim: !1,
                strokeWidthAnim: !1,
                yOffset: 0,
                finalSize: 0,
                finalText: [],
                finalLineHeight: 0,
                __complete: !1
            }, this.copyData(this.currentData, this.data.d.k[0].s), this.searchProperty() || this.completeTextData(this.currentData);
        }
        extendPrototype([
            BaseElement,
            TransformElement,
            SVGBaseElement,
            IShapeElement,
            HierarchyElement,
            FrameElement,
            RenderableDOMElement
        ], SVGShapeElement), SVGShapeElement.prototype.initSecondaryElement = function() {}, SVGShapeElement.prototype.identityMatrix = new Matrix, SVGShapeElement.prototype.buildExpressionInterface = function() {}, SVGShapeElement.prototype.createContent = function() {
            this.searchShapes(this.shapesData, this.itemsData, this.prevViewData, this.layerElement, 0, [], !0), this.filterUniqueShapes();
        }, SVGShapeElement.prototype.filterUniqueShapes = function() {
            var t1, e1, r1, i1, s1 = this.shapes.length, a1 = this.stylesList.length, n1 = [], o1 = !1;
            for(r1 = 0; r1 < a1; r1 += 1){
                for(i1 = this.stylesList[r1], o1 = !1, n1.length = 0, t1 = 0; t1 < s1; t1 += 1)-1 !== (e1 = this.shapes[t1]).styles.indexOf(i1) && (n1.push(e1), o1 = e1._isAnimated || o1);
                n1.length > 1 && o1 && this.setShapesAsAnimated(n1);
            }
        }, SVGShapeElement.prototype.setShapesAsAnimated = function(t1) {
            var e1, r1 = t1.length;
            for(e1 = 0; e1 < r1; e1 += 1)t1[e1].setAsAnimated();
        }, SVGShapeElement.prototype.createStyleElement = function(t1, e1) {
            var r1, i1 = new SVGStyleData(t1, e1), s1 = i1.pElem;
            return "st" === t1.ty ? r1 = new SVGStrokeStyleData(this, t1, i1) : "fl" === t1.ty ? r1 = new SVGFillStyleData(this, t1, i1) : "gf" === t1.ty || "gs" === t1.ty ? (r1 = new ("gf" === t1.ty ? SVGGradientFillStyleData : SVGGradientStrokeStyleData)(this, t1, i1), this.globalData.defs.appendChild(r1.gf), r1.maskId && (this.globalData.defs.appendChild(r1.ms), this.globalData.defs.appendChild(r1.of), s1.setAttribute("mask", "url(" + getLocationHref() + "#" + r1.maskId + ")"))) : "no" === t1.ty && (r1 = new SVGNoStyleData(this, t1, i1)), "st" !== t1.ty && "gs" !== t1.ty || (s1.setAttribute("stroke-linecap", lineCapEnum[t1.lc || 2]), s1.setAttribute("stroke-linejoin", lineJoinEnum[t1.lj || 2]), s1.setAttribute("fill-opacity", "0"), 1 === t1.lj && s1.setAttribute("stroke-miterlimit", t1.ml)), 2 === t1.r && s1.setAttribute("fill-rule", "evenodd"), t1.ln && s1.setAttribute("id", t1.ln), t1.cl && s1.setAttribute("class", t1.cl), t1.bm && (s1.style["mix-blend-mode"] = getBlendMode(t1.bm)), this.stylesList.push(i1), this.addToAnimatedContents(t1, r1), r1;
        }, SVGShapeElement.prototype.createGroupElement = function(t1) {
            var e1 = new ShapeGroupData;
            return t1.ln && e1.gr.setAttribute("id", t1.ln), t1.cl && e1.gr.setAttribute("class", t1.cl), t1.bm && (e1.gr.style["mix-blend-mode"] = getBlendMode(t1.bm)), e1;
        }, SVGShapeElement.prototype.createTransformElement = function(t1, e1) {
            var r1 = TransformPropertyFactory.getTransformProperty(this, t1, this), i1 = new SVGTransformData(r1, r1.o, e1);
            return this.addToAnimatedContents(t1, i1), i1;
        }, SVGShapeElement.prototype.createShapeElement = function(t1, e1, r1) {
            var i1 = 4;
            "rc" === t1.ty ? i1 = 5 : "el" === t1.ty ? i1 = 6 : "sr" === t1.ty && (i1 = 7);
            var s1 = new SVGShapeData(e1, r1, ShapePropertyFactory.getShapeProp(this, t1, i1, this));
            return this.shapes.push(s1), this.addShapeToModifiers(s1), this.addToAnimatedContents(t1, s1), s1;
        }, SVGShapeElement.prototype.addToAnimatedContents = function(t1, e1) {
            for(var r1 = 0, i1 = this.animatedContents.length; r1 < i1;){
                if (this.animatedContents[r1].element === e1) return;
                r1 += 1;
            }
            this.animatedContents.push({
                fn: SVGElementsRenderer.createRenderFunction(t1),
                element: e1,
                data: t1
            });
        }, SVGShapeElement.prototype.setElementStyles = function(t1) {
            var e1, r1 = t1.styles, i1 = this.stylesList.length;
            for(e1 = 0; e1 < i1; e1 += 1)this.stylesList[e1].closed || r1.push(this.stylesList[e1]);
        }, SVGShapeElement.prototype.reloadShapes = function() {
            var t1;
            this._isFirstFrame = !0;
            var e1 = this.itemsData.length;
            for(t1 = 0; t1 < e1; t1 += 1)this.prevViewData[t1] = this.itemsData[t1];
            for(this.searchShapes(this.shapesData, this.itemsData, this.prevViewData, this.layerElement, 0, [], !0), this.filterUniqueShapes(), e1 = this.dynamicProperties.length, t1 = 0; t1 < e1; t1 += 1)this.dynamicProperties[t1].getValue();
            this.renderModifiers();
        }, SVGShapeElement.prototype.searchShapes = function(t1, e1, r1, i1, s1, a1, n1) {
            var o1, h1, l1, p1, c1, f1, d1 = [].concat(a1), u1 = t1.length - 1, m1 = [], y1 = [];
            for(o1 = u1; o1 >= 0; o1 -= 1){
                if ((f1 = this.searchProcessedElement(t1[o1])) ? e1[o1] = r1[f1 - 1] : t1[o1]._render = n1, "fl" === t1[o1].ty || "st" === t1[o1].ty || "gf" === t1[o1].ty || "gs" === t1[o1].ty || "no" === t1[o1].ty) f1 ? e1[o1].style.closed = !1 : e1[o1] = this.createStyleElement(t1[o1], s1), t1[o1]._render && e1[o1].style.pElem.parentNode !== i1 && i1.appendChild(e1[o1].style.pElem), m1.push(e1[o1].style);
                else if ("gr" === t1[o1].ty) {
                    if (f1) for(l1 = e1[o1].it.length, h1 = 0; h1 < l1; h1 += 1)e1[o1].prevViewData[h1] = e1[o1].it[h1];
                    else e1[o1] = this.createGroupElement(t1[o1]);
                    this.searchShapes(t1[o1].it, e1[o1].it, e1[o1].prevViewData, e1[o1].gr, s1 + 1, d1, n1), t1[o1]._render && e1[o1].gr.parentNode !== i1 && i1.appendChild(e1[o1].gr);
                } else "tr" === t1[o1].ty ? (f1 || (e1[o1] = this.createTransformElement(t1[o1], i1)), p1 = e1[o1].transform, d1.push(p1)) : "sh" === t1[o1].ty || "rc" === t1[o1].ty || "el" === t1[o1].ty || "sr" === t1[o1].ty ? (f1 || (e1[o1] = this.createShapeElement(t1[o1], d1, s1)), this.setElementStyles(e1[o1])) : "tm" === t1[o1].ty || "rd" === t1[o1].ty || "ms" === t1[o1].ty || "pb" === t1[o1].ty || "zz" === t1[o1].ty || "op" === t1[o1].ty ? (f1 ? (c1 = e1[o1]).closed = !1 : ((c1 = ShapeModifiers.getModifier(t1[o1].ty)).init(this, t1[o1]), e1[o1] = c1, this.shapeModifiers.push(c1)), y1.push(c1)) : "rp" === t1[o1].ty && (f1 ? (c1 = e1[o1]).closed = !0 : (c1 = ShapeModifiers.getModifier(t1[o1].ty), e1[o1] = c1, c1.init(this, t1, o1, e1), this.shapeModifiers.push(c1), n1 = !1), y1.push(c1));
                this.addProcessedElement(t1[o1], o1 + 1);
            }
            for(u1 = m1.length, o1 = 0; o1 < u1; o1 += 1)m1[o1].closed = !0;
            for(u1 = y1.length, o1 = 0; o1 < u1; o1 += 1)y1[o1].closed = !0;
        }, SVGShapeElement.prototype.renderInnerContent = function() {
            var t1;
            this.renderModifiers();
            var e1 = this.stylesList.length;
            for(t1 = 0; t1 < e1; t1 += 1)this.stylesList[t1].reset();
            for(this.renderShape(), t1 = 0; t1 < e1; t1 += 1)(this.stylesList[t1]._mdf || this._isFirstFrame) && (this.stylesList[t1].msElem && (this.stylesList[t1].msElem.setAttribute("d", this.stylesList[t1].d), this.stylesList[t1].d = "M0 0" + this.stylesList[t1].d), this.stylesList[t1].pElem.setAttribute("d", this.stylesList[t1].d || "M0 0"));
        }, SVGShapeElement.prototype.renderShape = function() {
            var t1, e1, r1 = this.animatedContents.length;
            for(t1 = 0; t1 < r1; t1 += 1)e1 = this.animatedContents[t1], (this._isFirstFrame || e1.element._isAnimated) && !0 !== e1.data && e1.fn(e1.data, e1.element, this._isFirstFrame);
        }, SVGShapeElement.prototype.destroy = function() {
            this.destroyBaseElement(), this.shapesData = null, this.itemsData = null;
        }, LetterProps.prototype.update = function(t1, e1, r1, i1, s1, a1) {
            this._mdf.o = !1, this._mdf.sw = !1, this._mdf.sc = !1, this._mdf.fc = !1, this._mdf.m = !1, this._mdf.p = !1;
            var n1 = !1;
            return this.o !== t1 && (this.o = t1, this._mdf.o = !0, n1 = !0), this.sw !== e1 && (this.sw = e1, this._mdf.sw = !0, n1 = !0), this.sc !== r1 && (this.sc = r1, this._mdf.sc = !0, n1 = !0), this.fc !== i1 && (this.fc = i1, this._mdf.fc = !0, n1 = !0), this.m !== s1 && (this.m = s1, this._mdf.m = !0, n1 = !0), !a1.length || this.p[0] === a1[0] && this.p[1] === a1[1] && this.p[4] === a1[4] && this.p[5] === a1[5] && this.p[12] === a1[12] && this.p[13] === a1[13] || (this.p = a1, this._mdf.p = !0, n1 = !0), n1;
        }, TextProperty.prototype.defaultBoxWidth = [
            0,
            0
        ], TextProperty.prototype.copyData = function(t1, e1) {
            for(var r1 in e1)Object.prototype.hasOwnProperty.call(e1, r1) && (t1[r1] = e1[r1]);
            return t1;
        }, TextProperty.prototype.setCurrentData = function(t1) {
            t1.__complete || this.completeTextData(t1), this.currentData = t1, this.currentData.boxWidth = this.currentData.boxWidth || this.defaultBoxWidth, this._mdf = !0;
        }, TextProperty.prototype.searchProperty = function() {
            return this.searchKeyframes();
        }, TextProperty.prototype.searchKeyframes = function() {
            return this.kf = this.data.d.k.length > 1, this.kf && this.addEffect(this.getKeyframeValue.bind(this)), this.kf;
        }, TextProperty.prototype.addEffect = function(t1) {
            this.effectsSequence.push(t1), this.elem.addDynamicProperty(this);
        }, TextProperty.prototype.getValue = function(t1) {
            if (this.elem.globalData.frameId !== this.frameId && this.effectsSequence.length || t1) {
                this.currentData.t = this.data.d.k[this.keysIndex].s.t;
                var e1 = this.currentData, r1 = this.keysIndex;
                if (this.lock) this.setCurrentData(this.currentData);
                else {
                    var i1;
                    this.lock = !0, this._mdf = !1;
                    var s1 = this.effectsSequence.length, a1 = t1 || this.data.d.k[this.keysIndex].s;
                    for(i1 = 0; i1 < s1; i1 += 1)a1 = r1 !== this.keysIndex ? this.effectsSequence[i1](a1, a1.t) : this.effectsSequence[i1](this.currentData, a1.t);
                    e1 !== a1 && this.setCurrentData(a1), this.v = this.currentData, this.pv = this.v, this.lock = !1, this.frameId = this.elem.globalData.frameId;
                }
            }
        }, TextProperty.prototype.getKeyframeValue = function() {
            for(var t1 = this.data.d.k, e1 = this.elem.comp.renderedFrame, r1 = 0, i1 = t1.length; r1 <= i1 - 1 && !(r1 === i1 - 1 || t1[r1 + 1].t > e1);)r1 += 1;
            return this.keysIndex !== r1 && (this.keysIndex = r1), this.data.d.k[this.keysIndex].s;
        }, TextProperty.prototype.buildFinalText = function(t1) {
            for(var e1, r1, i1 = [], s1 = 0, a1 = t1.length, n1 = !1; s1 < a1;)e1 = t1.charCodeAt(s1), FontManager.isCombinedCharacter(e1) ? i1[i1.length - 1] += t1.charAt(s1) : e1 >= 55296 && e1 <= 56319 ? (r1 = t1.charCodeAt(s1 + 1)) >= 56320 && r1 <= 57343 ? (n1 || FontManager.isModifier(e1, r1) ? (i1[i1.length - 1] += t1.substr(s1, 2), n1 = !1) : i1.push(t1.substr(s1, 2)), s1 += 1) : i1.push(t1.charAt(s1)) : e1 > 56319 ? (r1 = t1.charCodeAt(s1 + 1), FontManager.isZeroWidthJoiner(e1, r1) ? (n1 = !0, i1[i1.length - 1] += t1.substr(s1, 2), s1 += 1) : i1.push(t1.charAt(s1))) : FontManager.isZeroWidthJoiner(e1) ? (i1[i1.length - 1] += t1.charAt(s1), n1 = !0) : i1.push(t1.charAt(s1)), s1 += 1;
            return i1;
        }, TextProperty.prototype.completeTextData = function(t1) {
            t1.__complete = !0;
            var e1, r1, i1, s1, a1, n1, o1, h1 = this.elem.globalData.fontManager, l1 = this.data, p1 = [], c1 = 0, f1 = l1.m.g, d1 = 0, u1 = 0, m1 = 0, y1 = [], g1 = 0, v1 = 0, b1 = h1.getFontByName(t1.f), _1 = 0, P1 = getFontProperties(b1);
            t1.fWeight = P1.weight, t1.fStyle = P1.style, t1.finalSize = t1.s, t1.finalText = this.buildFinalText(t1.t), r1 = t1.finalText.length, t1.finalLineHeight = t1.lh;
            var E1, S1 = t1.tr / 1e3 * t1.finalSize;
            if (t1.sz) for(var x1, A1, w1 = !0, C1 = t1.sz[0], k1 = t1.sz[1]; w1;){
                x1 = 0, g1 = 0, r1 = (A1 = this.buildFinalText(t1.t)).length, S1 = t1.tr / 1e3 * t1.finalSize;
                var T1 = -1;
                for(e1 = 0; e1 < r1; e1 += 1)E1 = A1[e1].charCodeAt(0), i1 = !1, " " === A1[e1] ? T1 = e1 : 13 !== E1 && 3 !== E1 || (g1 = 0, i1 = !0, x1 += t1.finalLineHeight || 1.2 * t1.finalSize), h1.chars ? (o1 = h1.getCharData(A1[e1], b1.fStyle, b1.fFamily), _1 = i1 ? 0 : o1.w * t1.finalSize / 100) : _1 = h1.measureText(A1[e1], t1.f, t1.finalSize), g1 + _1 > C1 && " " !== A1[e1] ? (-1 === T1 ? r1 += 1 : e1 = T1, x1 += t1.finalLineHeight || 1.2 * t1.finalSize, A1.splice(e1, T1 === e1 ? 1 : 0, "\r"), T1 = -1, g1 = 0) : (g1 += _1, g1 += S1);
                x1 += b1.ascent * t1.finalSize / 100, this.canResize && t1.finalSize > this.minimumFontSize && k1 < x1 ? (t1.finalSize -= 1, t1.finalLineHeight = t1.finalSize * t1.lh / t1.s) : (t1.finalText = A1, r1 = t1.finalText.length, w1 = !1);
            }
            g1 = -S1, _1 = 0;
            var D1, M1 = 0;
            for(e1 = 0; e1 < r1; e1 += 1)if (i1 = !1, 13 === (E1 = (D1 = t1.finalText[e1]).charCodeAt(0)) || 3 === E1 ? (M1 = 0, y1.push(g1), v1 = g1 > v1 ? g1 : v1, g1 = -2 * S1, s1 = "", i1 = !0, m1 += 1) : s1 = D1, h1.chars ? (o1 = h1.getCharData(D1, b1.fStyle, h1.getFontByName(t1.f).fFamily), _1 = i1 ? 0 : o1.w * t1.finalSize / 100) : _1 = h1.measureText(s1, t1.f, t1.finalSize), " " === D1 ? M1 += _1 + S1 : (g1 += _1 + S1 + M1, M1 = 0), p1.push({
                l: _1,
                an: _1,
                add: d1,
                n: i1,
                anIndexes: [],
                val: s1,
                line: m1,
                animatorJustifyOffset: 0
            }), 2 == f1) {
                if (d1 += _1, "" === s1 || " " === s1 || e1 === r1 - 1) {
                    for("" !== s1 && " " !== s1 || (d1 -= _1); u1 <= e1;)p1[u1].an = d1, p1[u1].ind = c1, p1[u1].extra = _1, u1 += 1;
                    c1 += 1, d1 = 0;
                }
            } else if (3 == f1) {
                if (d1 += _1, "" === s1 || e1 === r1 - 1) {
                    for("" === s1 && (d1 -= _1); u1 <= e1;)p1[u1].an = d1, p1[u1].ind = c1, p1[u1].extra = _1, u1 += 1;
                    d1 = 0, c1 += 1;
                }
            } else p1[c1].ind = c1, p1[c1].extra = 0, c1 += 1;
            if (t1.l = p1, v1 = g1 > v1 ? g1 : v1, y1.push(g1), t1.sz) t1.boxWidth = t1.sz[0], t1.justifyOffset = 0;
            else switch(t1.boxWidth = v1, t1.j){
                case 1:
                    t1.justifyOffset = -t1.boxWidth;
                    break;
                case 2:
                    t1.justifyOffset = -t1.boxWidth / 2;
                    break;
                default:
                    t1.justifyOffset = 0;
            }
            t1.lineWidths = y1;
            var F1, I1, R1, B1, V1 = l1.a;
            n1 = V1.length;
            var O1 = [];
            for(a1 = 0; a1 < n1; a1 += 1){
                for((F1 = V1[a1]).a.sc && (t1.strokeColorAnim = !0), F1.a.sw && (t1.strokeWidthAnim = !0), (F1.a.fc || F1.a.fh || F1.a.fs || F1.a.fb) && (t1.fillColorAnim = !0), B1 = 0, R1 = F1.s.b, e1 = 0; e1 < r1; e1 += 1)(I1 = p1[e1]).anIndexes[a1] = B1, (1 == R1 && "" !== I1.val || 2 == R1 && "" !== I1.val && " " !== I1.val || 3 == R1 && (I1.n || " " == I1.val || e1 == r1 - 1) || 4 == R1 && (I1.n || e1 == r1 - 1)) && (1 === F1.s.rn && O1.push(B1), B1 += 1);
                l1.a[a1].s.totalChars = B1;
                var L1, $1 = -1;
                if (1 === F1.s.rn) for(e1 = 0; e1 < r1; e1 += 1)$1 != (I1 = p1[e1]).anIndexes[a1] && ($1 = I1.anIndexes[a1], L1 = O1.splice(Math.floor(Math.random() * O1.length), 1)[0]), I1.anIndexes[a1] = L1;
            }
            t1.yOffset = t1.finalLineHeight || 1.2 * t1.finalSize, t1.ls = t1.ls || 0, t1.ascent = b1.ascent * t1.finalSize / 100;
        }, TextProperty.prototype.updateDocumentData = function(t1, e1) {
            e1 = void 0 === e1 ? this.keysIndex : e1;
            var r1 = this.copyData({}, this.data.d.k[e1].s);
            r1 = this.copyData(r1, t1), this.data.d.k[e1].s = r1, this.recalculate(e1), this.elem.addDynamicProperty(this);
        }, TextProperty.prototype.recalculate = function(t1) {
            var e1 = this.data.d.k[t1].s;
            e1.__complete = !1, this.keysIndex = 0, this._isFirstFrame = !0, this.getValue(e1);
        }, TextProperty.prototype.canResizeFont = function(t1) {
            this.canResize = t1, this.recalculate(this.keysIndex), this.elem.addDynamicProperty(this);
        }, TextProperty.prototype.setMinimumFontSize = function(t1) {
            this.minimumFontSize = Math.floor(t1) || 1, this.recalculate(this.keysIndex), this.elem.addDynamicProperty(this);
        };
        var TextSelectorProp = function() {
            var t1 = Math.max, e1 = Math.min, r1 = Math.floor;
            function i1(t1, e1) {
                this._currentTextLength = -1, this.k = !1, this.data = e1, this.elem = t1, this.comp = t1.comp, this.finalS = 0, this.finalE = 0, this.initDynamicPropertyContainer(t1), this.s = PropertyFactory.getProp(t1, e1.s || {
                    k: 0
                }, 0, 0, this), this.e = "e" in e1 ? PropertyFactory.getProp(t1, e1.e, 0, 0, this) : {
                    v: 100
                }, this.o = PropertyFactory.getProp(t1, e1.o || {
                    k: 0
                }, 0, 0, this), this.xe = PropertyFactory.getProp(t1, e1.xe || {
                    k: 0
                }, 0, 0, this), this.ne = PropertyFactory.getProp(t1, e1.ne || {
                    k: 0
                }, 0, 0, this), this.sm = PropertyFactory.getProp(t1, e1.sm || {
                    k: 100
                }, 0, 0, this), this.a = PropertyFactory.getProp(t1, e1.a, 0, .01, this), this.dynamicProperties.length || this.getValue();
            }
            return i1.prototype = {
                getMult: function(i1) {
                    this._currentTextLength !== this.elem.textProperty.currentData.l.length && this.getValue();
                    var s1 = 0, a1 = 0, n1 = 1, o1 = 1;
                    this.ne.v > 0 ? s1 = this.ne.v / 100 : a1 = -this.ne.v / 100, this.xe.v > 0 ? n1 = 1 - this.xe.v / 100 : o1 = 1 + this.xe.v / 100;
                    var h1 = BezierFactory.getBezierEasing(s1, a1, n1, o1).get, l1 = 0, p1 = this.finalS, c1 = this.finalE, f1 = this.data.sh;
                    if (2 === f1) l1 = h1(l1 = c1 === p1 ? i1 >= c1 ? 1 : 0 : t1(0, e1(.5 / (c1 - p1) + (i1 - p1) / (c1 - p1), 1)));
                    else if (3 === f1) l1 = h1(l1 = c1 === p1 ? i1 >= c1 ? 0 : 1 : 1 - t1(0, e1(.5 / (c1 - p1) + (i1 - p1) / (c1 - p1), 1)));
                    else if (4 === f1) c1 === p1 ? l1 = 0 : (l1 = t1(0, e1(.5 / (c1 - p1) + (i1 - p1) / (c1 - p1), 1))) < .5 ? l1 *= 2 : l1 = 1 - 2 * (l1 - .5), l1 = h1(l1);
                    else if (5 === f1) {
                        if (c1 === p1) l1 = 0;
                        else {
                            var d1 = c1 - p1, u1 = -d1 / 2 + (i1 = e1(t1(0, i1 + .5 - p1), c1 - p1)), m1 = d1 / 2;
                            l1 = Math.sqrt(1 - u1 * u1 / (m1 * m1));
                        }
                        l1 = h1(l1);
                    } else 6 === f1 ? (c1 === p1 ? l1 = 0 : (i1 = e1(t1(0, i1 + .5 - p1), c1 - p1), l1 = (1 + Math.cos(Math.PI + 2 * Math.PI * i1 / (c1 - p1))) / 2), l1 = h1(l1)) : (i1 >= r1(p1) && (l1 = t1(0, e1(i1 - p1 < 0 ? e1(c1, 1) - (p1 - i1) : c1 - i1, 1))), l1 = h1(l1));
                    if (100 !== this.sm.v) {
                        var y1 = .01 * this.sm.v;
                        0 === y1 && (y1 = 1e-8);
                        var g1 = .5 - .5 * y1;
                        l1 < g1 ? l1 = 0 : (l1 = (l1 - g1) / y1) > 1 && (l1 = 1);
                    }
                    return l1 * this.a.v;
                },
                getValue: function(t1) {
                    this.iterateDynamicProperties(), this._mdf = t1 || this._mdf, this._currentTextLength = this.elem.textProperty.currentData.l.length || 0, t1 && 2 === this.data.r && (this.e.v = this._currentTextLength);
                    var e1 = 2 === this.data.r ? 1 : 100 / this.data.totalChars, r1 = this.o.v / e1, i1 = this.s.v / e1 + r1, s1 = this.e.v / e1 + r1;
                    if (i1 > s1) {
                        var a1 = i1;
                        i1 = s1, s1 = a1;
                    }
                    this.finalS = i1, this.finalE = s1;
                }
            }, extendPrototype([
                DynamicPropertyContainer
            ], i1), {
                getTextSelectorProp: function(t1, e1, r1) {
                    return new i1(t1, e1, r1);
                }
            };
        }();
        function TextAnimatorDataProperty(t1, e1, r1) {
            var i1 = {
                propType: !1
            }, s1 = PropertyFactory.getProp, a1 = e1.a;
            this.a = {
                r: a1.r ? s1(t1, a1.r, 0, degToRads, r1) : i1,
                rx: a1.rx ? s1(t1, a1.rx, 0, degToRads, r1) : i1,
                ry: a1.ry ? s1(t1, a1.ry, 0, degToRads, r1) : i1,
                sk: a1.sk ? s1(t1, a1.sk, 0, degToRads, r1) : i1,
                sa: a1.sa ? s1(t1, a1.sa, 0, degToRads, r1) : i1,
                s: a1.s ? s1(t1, a1.s, 1, .01, r1) : i1,
                a: a1.a ? s1(t1, a1.a, 1, 0, r1) : i1,
                o: a1.o ? s1(t1, a1.o, 0, .01, r1) : i1,
                p: a1.p ? s1(t1, a1.p, 1, 0, r1) : i1,
                sw: a1.sw ? s1(t1, a1.sw, 0, 0, r1) : i1,
                sc: a1.sc ? s1(t1, a1.sc, 1, 0, r1) : i1,
                fc: a1.fc ? s1(t1, a1.fc, 1, 0, r1) : i1,
                fh: a1.fh ? s1(t1, a1.fh, 0, 0, r1) : i1,
                fs: a1.fs ? s1(t1, a1.fs, 0, .01, r1) : i1,
                fb: a1.fb ? s1(t1, a1.fb, 0, .01, r1) : i1,
                t: a1.t ? s1(t1, a1.t, 0, 0, r1) : i1
            }, this.s = TextSelectorProp.getTextSelectorProp(t1, e1.s, r1), this.s.t = e1.s.t;
        }
        function TextAnimatorProperty(t1, e1, r1) {
            this._isFirstFrame = !0, this._hasMaskedPath = !1, this._frameId = -1, this._textData = t1, this._renderType = e1, this._elem = r1, this._animatorsData = createSizedArray(this._textData.a.length), this._pathData = {}, this._moreOptions = {
                alignment: {}
            }, this.renderedLetters = [], this.lettersChangedFlag = !1, this.initDynamicPropertyContainer(r1);
        }
        function ITextElement() {}
        TextAnimatorProperty.prototype.searchProperties = function() {
            var t1, e1, r1 = this._textData.a.length, i1 = PropertyFactory.getProp;
            for(t1 = 0; t1 < r1; t1 += 1)e1 = this._textData.a[t1], this._animatorsData[t1] = new TextAnimatorDataProperty(this._elem, e1, this);
            this._textData.p && "m" in this._textData.p ? (this._pathData = {
                a: i1(this._elem, this._textData.p.a, 0, 0, this),
                f: i1(this._elem, this._textData.p.f, 0, 0, this),
                l: i1(this._elem, this._textData.p.l, 0, 0, this),
                r: i1(this._elem, this._textData.p.r, 0, 0, this),
                p: i1(this._elem, this._textData.p.p, 0, 0, this),
                m: this._elem.maskManager.getMaskProperty(this._textData.p.m)
            }, this._hasMaskedPath = !0) : this._hasMaskedPath = !1, this._moreOptions.alignment = i1(this._elem, this._textData.m.a, 1, 0, this);
        }, TextAnimatorProperty.prototype.getMeasures = function(t1, e1) {
            if (this.lettersChangedFlag = e1, this._mdf || this._isFirstFrame || e1 || this._hasMaskedPath && this._pathData.m._mdf) {
                this._isFirstFrame = !1;
                var r1, i1, s1, a1, n1, o1, h1, l1, p1, c1, f1, d1, u1, m1, y1, g1, v1, b1, _1, P1 = this._moreOptions.alignment.v, E1 = this._animatorsData, S1 = this._textData, x1 = this.mHelper, A1 = this._renderType, w1 = this.renderedLetters.length, C1 = t1.l;
                if (this._hasMaskedPath) {
                    if (_1 = this._pathData.m, !this._pathData.n || this._pathData._mdf) {
                        var k1, T1 = _1.v;
                        for(this._pathData.r.v && (T1 = T1.reverse()), n1 = {
                            tLength: 0,
                            segments: []
                        }, a1 = T1._length - 1, g1 = 0, s1 = 0; s1 < a1; s1 += 1)k1 = bez.buildBezierData(T1.v[s1], T1.v[s1 + 1], [
                            T1.o[s1][0] - T1.v[s1][0],
                            T1.o[s1][1] - T1.v[s1][1]
                        ], [
                            T1.i[s1 + 1][0] - T1.v[s1 + 1][0],
                            T1.i[s1 + 1][1] - T1.v[s1 + 1][1]
                        ]), n1.tLength += k1.segmentLength, n1.segments.push(k1), g1 += k1.segmentLength;
                        s1 = a1, _1.v.c && (k1 = bez.buildBezierData(T1.v[s1], T1.v[0], [
                            T1.o[s1][0] - T1.v[s1][0],
                            T1.o[s1][1] - T1.v[s1][1]
                        ], [
                            T1.i[0][0] - T1.v[0][0],
                            T1.i[0][1] - T1.v[0][1]
                        ]), n1.tLength += k1.segmentLength, n1.segments.push(k1), g1 += k1.segmentLength), this._pathData.pi = n1;
                    }
                    if (n1 = this._pathData.pi, o1 = this._pathData.f.v, f1 = 0, c1 = 1, l1 = 0, p1 = !0, m1 = n1.segments, o1 < 0 && _1.v.c) for(n1.tLength < Math.abs(o1) && (o1 = -Math.abs(o1) % n1.tLength), c1 = (u1 = m1[f1 = m1.length - 1].points).length - 1; o1 < 0;)o1 += u1[c1].partialLength, (c1 -= 1) < 0 && (c1 = (u1 = m1[f1 -= 1].points).length - 1);
                    d1 = (u1 = m1[f1].points)[c1 - 1], y1 = (h1 = u1[c1]).partialLength;
                }
                a1 = C1.length, r1 = 0, i1 = 0;
                var D1, M1, F1, I1, R1, B1 = 1.2 * t1.finalSize * .714, V1 = !0;
                F1 = E1.length;
                var O1, L1, $1, z1, G1, N1, j1, H1, q1, W1, U1, Y1, X1 = -1, Z1 = o1, K1 = f1, J1 = c1, Q1 = -1, tt1 = "", et1 = this.defaultPropsArray;
                if (2 === t1.j || 1 === t1.j) {
                    var rt1 = 0, it1 = 0, st1 = 2 === t1.j ? -0.5 : -1, at1 = 0, nt1 = !0;
                    for(s1 = 0; s1 < a1; s1 += 1)if (C1[s1].n) {
                        for(rt1 && (rt1 += it1); at1 < s1;)C1[at1].animatorJustifyOffset = rt1, at1 += 1;
                        rt1 = 0, nt1 = !0;
                    } else {
                        for(M1 = 0; M1 < F1; M1 += 1)(D1 = E1[M1].a).t.propType && (nt1 && 2 === t1.j && (it1 += D1.t.v * st1), (R1 = E1[M1].s.getMult(C1[s1].anIndexes[M1], S1.a[M1].s.totalChars)).length ? rt1 += D1.t.v * R1[0] * st1 : rt1 += D1.t.v * R1 * st1);
                        nt1 = !1;
                    }
                    for(rt1 && (rt1 += it1); at1 < s1;)C1[at1].animatorJustifyOffset = rt1, at1 += 1;
                }
                for(s1 = 0; s1 < a1; s1 += 1){
                    if (x1.reset(), z1 = 1, C1[s1].n) r1 = 0, i1 += t1.yOffset, i1 += V1 ? 1 : 0, o1 = Z1, V1 = !1, this._hasMaskedPath && (c1 = J1, d1 = (u1 = m1[f1 = K1].points)[c1 - 1], y1 = (h1 = u1[c1]).partialLength, l1 = 0), tt1 = "", U1 = "", q1 = "", Y1 = "", et1 = this.defaultPropsArray;
                    else {
                        if (this._hasMaskedPath) {
                            if (Q1 !== C1[s1].line) {
                                switch(t1.j){
                                    case 1:
                                        o1 += g1 - t1.lineWidths[C1[s1].line];
                                        break;
                                    case 2:
                                        o1 += (g1 - t1.lineWidths[C1[s1].line]) / 2;
                                }
                                Q1 = C1[s1].line;
                            }
                            X1 !== C1[s1].ind && (C1[X1] && (o1 += C1[X1].extra), o1 += C1[s1].an / 2, X1 = C1[s1].ind), o1 += P1[0] * C1[s1].an * .005;
                            var ot1 = 0;
                            for(M1 = 0; M1 < F1; M1 += 1)(D1 = E1[M1].a).p.propType && ((R1 = E1[M1].s.getMult(C1[s1].anIndexes[M1], S1.a[M1].s.totalChars)).length ? ot1 += D1.p.v[0] * R1[0] : ot1 += D1.p.v[0] * R1), D1.a.propType && ((R1 = E1[M1].s.getMult(C1[s1].anIndexes[M1], S1.a[M1].s.totalChars)).length ? ot1 += D1.a.v[0] * R1[0] : ot1 += D1.a.v[0] * R1);
                            for(p1 = !0, this._pathData.a.v && (o1 = .5 * C1[0].an + (g1 - this._pathData.f.v - .5 * C1[0].an - .5 * C1[C1.length - 1].an) * X1 / (a1 - 1), o1 += this._pathData.f.v); p1;)l1 + y1 >= o1 + ot1 || !u1 ? (v1 = (o1 + ot1 - l1) / h1.partialLength, L1 = d1.point[0] + (h1.point[0] - d1.point[0]) * v1, $1 = d1.point[1] + (h1.point[1] - d1.point[1]) * v1, x1.translate(-P1[0] * C1[s1].an * .005, -P1[1] * B1 * .01), p1 = !1) : u1 && (l1 += h1.partialLength, (c1 += 1) >= u1.length && (c1 = 0, m1[f1 += 1] ? u1 = m1[f1].points : _1.v.c ? (c1 = 0, u1 = m1[f1 = 0].points) : (l1 -= h1.partialLength, u1 = null)), u1 && (d1 = h1, y1 = (h1 = u1[c1]).partialLength));
                            O1 = C1[s1].an / 2 - C1[s1].add, x1.translate(-O1, 0, 0);
                        } else O1 = C1[s1].an / 2 - C1[s1].add, x1.translate(-O1, 0, 0), x1.translate(-P1[0] * C1[s1].an * .005, -P1[1] * B1 * .01, 0);
                        for(M1 = 0; M1 < F1; M1 += 1)(D1 = E1[M1].a).t.propType && (R1 = E1[M1].s.getMult(C1[s1].anIndexes[M1], S1.a[M1].s.totalChars), 0 === r1 && 0 === t1.j || (this._hasMaskedPath ? R1.length ? o1 += D1.t.v * R1[0] : o1 += D1.t.v * R1 : R1.length ? r1 += D1.t.v * R1[0] : r1 += D1.t.v * R1));
                        for(t1.strokeWidthAnim && (N1 = t1.sw || 0), t1.strokeColorAnim && (G1 = t1.sc ? [
                            t1.sc[0],
                            t1.sc[1],
                            t1.sc[2]
                        ] : [
                            0,
                            0,
                            0
                        ]), t1.fillColorAnim && t1.fc && (j1 = [
                            t1.fc[0],
                            t1.fc[1],
                            t1.fc[2]
                        ]), M1 = 0; M1 < F1; M1 += 1)(D1 = E1[M1].a).a.propType && ((R1 = E1[M1].s.getMult(C1[s1].anIndexes[M1], S1.a[M1].s.totalChars)).length ? x1.translate(-D1.a.v[0] * R1[0], -D1.a.v[1] * R1[1], D1.a.v[2] * R1[2]) : x1.translate(-D1.a.v[0] * R1, -D1.a.v[1] * R1, D1.a.v[2] * R1));
                        for(M1 = 0; M1 < F1; M1 += 1)(D1 = E1[M1].a).s.propType && ((R1 = E1[M1].s.getMult(C1[s1].anIndexes[M1], S1.a[M1].s.totalChars)).length ? x1.scale(1 + (D1.s.v[0] - 1) * R1[0], 1 + (D1.s.v[1] - 1) * R1[1], 1) : x1.scale(1 + (D1.s.v[0] - 1) * R1, 1 + (D1.s.v[1] - 1) * R1, 1));
                        for(M1 = 0; M1 < F1; M1 += 1){
                            if (D1 = E1[M1].a, R1 = E1[M1].s.getMult(C1[s1].anIndexes[M1], S1.a[M1].s.totalChars), D1.sk.propType && (R1.length ? x1.skewFromAxis(-D1.sk.v * R1[0], D1.sa.v * R1[1]) : x1.skewFromAxis(-D1.sk.v * R1, D1.sa.v * R1)), D1.r.propType && (R1.length ? x1.rotateZ(-D1.r.v * R1[2]) : x1.rotateZ(-D1.r.v * R1)), D1.ry.propType && (R1.length ? x1.rotateY(D1.ry.v * R1[1]) : x1.rotateY(D1.ry.v * R1)), D1.rx.propType && (R1.length ? x1.rotateX(D1.rx.v * R1[0]) : x1.rotateX(D1.rx.v * R1)), D1.o.propType && (R1.length ? z1 += (D1.o.v * R1[0] - z1) * R1[0] : z1 += (D1.o.v * R1 - z1) * R1), t1.strokeWidthAnim && D1.sw.propType && (R1.length ? N1 += D1.sw.v * R1[0] : N1 += D1.sw.v * R1), t1.strokeColorAnim && D1.sc.propType) for(H1 = 0; H1 < 3; H1 += 1)R1.length ? G1[H1] += (D1.sc.v[H1] - G1[H1]) * R1[0] : G1[H1] += (D1.sc.v[H1] - G1[H1]) * R1;
                            if (t1.fillColorAnim && t1.fc) {
                                if (D1.fc.propType) for(H1 = 0; H1 < 3; H1 += 1)R1.length ? j1[H1] += (D1.fc.v[H1] - j1[H1]) * R1[0] : j1[H1] += (D1.fc.v[H1] - j1[H1]) * R1;
                                D1.fh.propType && (j1 = R1.length ? addHueToRGB(j1, D1.fh.v * R1[0]) : addHueToRGB(j1, D1.fh.v * R1)), D1.fs.propType && (j1 = R1.length ? addSaturationToRGB(j1, D1.fs.v * R1[0]) : addSaturationToRGB(j1, D1.fs.v * R1)), D1.fb.propType && (j1 = R1.length ? addBrightnessToRGB(j1, D1.fb.v * R1[0]) : addBrightnessToRGB(j1, D1.fb.v * R1));
                            }
                        }
                        for(M1 = 0; M1 < F1; M1 += 1)(D1 = E1[M1].a).p.propType && (R1 = E1[M1].s.getMult(C1[s1].anIndexes[M1], S1.a[M1].s.totalChars), this._hasMaskedPath ? R1.length ? x1.translate(0, D1.p.v[1] * R1[0], -D1.p.v[2] * R1[1]) : x1.translate(0, D1.p.v[1] * R1, -D1.p.v[2] * R1) : R1.length ? x1.translate(D1.p.v[0] * R1[0], D1.p.v[1] * R1[1], -D1.p.v[2] * R1[2]) : x1.translate(D1.p.v[0] * R1, D1.p.v[1] * R1, -D1.p.v[2] * R1));
                        if (t1.strokeWidthAnim && (q1 = N1 < 0 ? 0 : N1), t1.strokeColorAnim && (W1 = "rgb(" + Math.round(255 * G1[0]) + "," + Math.round(255 * G1[1]) + "," + Math.round(255 * G1[2]) + ")"), t1.fillColorAnim && t1.fc && (U1 = "rgb(" + Math.round(255 * j1[0]) + "," + Math.round(255 * j1[1]) + "," + Math.round(255 * j1[2]) + ")"), this._hasMaskedPath) {
                            if (x1.translate(0, -t1.ls), x1.translate(0, P1[1] * B1 * .01 + i1, 0), this._pathData.p.v) {
                                b1 = (h1.point[1] - d1.point[1]) / (h1.point[0] - d1.point[0]);
                                var ht1 = 180 * Math.atan(b1) / Math.PI;
                                h1.point[0] < d1.point[0] && (ht1 += 180), x1.rotate(-ht1 * Math.PI / 180);
                            }
                            x1.translate(L1, $1, 0), o1 -= P1[0] * C1[s1].an * .005, C1[s1 + 1] && X1 !== C1[s1 + 1].ind && (o1 += C1[s1].an / 2, o1 += .001 * t1.tr * t1.finalSize);
                        } else {
                            switch(x1.translate(r1, i1, 0), t1.ps && x1.translate(t1.ps[0], t1.ps[1] + t1.ascent, 0), t1.j){
                                case 1:
                                    x1.translate(C1[s1].animatorJustifyOffset + t1.justifyOffset + (t1.boxWidth - t1.lineWidths[C1[s1].line]), 0, 0);
                                    break;
                                case 2:
                                    x1.translate(C1[s1].animatorJustifyOffset + t1.justifyOffset + (t1.boxWidth - t1.lineWidths[C1[s1].line]) / 2, 0, 0);
                            }
                            x1.translate(0, -t1.ls), x1.translate(O1, 0, 0), x1.translate(P1[0] * C1[s1].an * .005, P1[1] * B1 * .01, 0), r1 += C1[s1].l + .001 * t1.tr * t1.finalSize;
                        }
                        "html" === A1 ? tt1 = x1.toCSS() : "svg" === A1 ? tt1 = x1.to2dCSS() : et1 = [
                            x1.props[0],
                            x1.props[1],
                            x1.props[2],
                            x1.props[3],
                            x1.props[4],
                            x1.props[5],
                            x1.props[6],
                            x1.props[7],
                            x1.props[8],
                            x1.props[9],
                            x1.props[10],
                            x1.props[11],
                            x1.props[12],
                            x1.props[13],
                            x1.props[14],
                            x1.props[15]
                        ], Y1 = z1;
                    }
                    w1 <= s1 ? (I1 = new LetterProps(Y1, q1, W1, U1, tt1, et1), this.renderedLetters.push(I1), w1 += 1, this.lettersChangedFlag = !0) : (I1 = this.renderedLetters[s1], this.lettersChangedFlag = I1.update(Y1, q1, W1, U1, tt1, et1) || this.lettersChangedFlag);
                }
            }
        }, TextAnimatorProperty.prototype.getValue = function() {
            this._elem.globalData.frameId !== this._frameId && (this._frameId = this._elem.globalData.frameId, this.iterateDynamicProperties());
        }, TextAnimatorProperty.prototype.mHelper = new Matrix, TextAnimatorProperty.prototype.defaultPropsArray = [], extendPrototype([
            DynamicPropertyContainer
        ], TextAnimatorProperty), ITextElement.prototype.initElement = function(t1, e1, r1) {
            this.lettersChangedFlag = !0, this.initFrame(), this.initBaseData(t1, e1, r1), this.textProperty = new TextProperty(this, t1.t, this.dynamicProperties), this.textAnimator = new TextAnimatorProperty(t1.t, this.renderType, this), this.initTransform(t1, e1, r1), this.initHierarchy(), this.initRenderable(), this.initRendererElement(), this.createContainerElements(), this.createRenderableComponents(), this.createContent(), this.hide(), this.textAnimator.searchProperties(this.dynamicProperties);
        }, ITextElement.prototype.prepareFrame = function(t1) {
            this._mdf = !1, this.prepareRenderableFrame(t1), this.prepareProperties(t1, this.isInRange), (this.textProperty._mdf || this.textProperty._isFirstFrame) && (this.buildNewText(), this.textProperty._isFirstFrame = !1, this.textProperty._mdf = !1);
        }, ITextElement.prototype.createPathShape = function(t1, e1) {
            var r1, i1, s1 = e1.length, a1 = "";
            for(r1 = 0; r1 < s1; r1 += 1)"sh" === e1[r1].ty && (i1 = e1[r1].ks.k, a1 += buildShapeString(i1, i1.i.length, !0, t1));
            return a1;
        }, ITextElement.prototype.updateDocumentData = function(t1, e1) {
            this.textProperty.updateDocumentData(t1, e1);
        }, ITextElement.prototype.canResizeFont = function(t1) {
            this.textProperty.canResizeFont(t1);
        }, ITextElement.prototype.setMinimumFontSize = function(t1) {
            this.textProperty.setMinimumFontSize(t1);
        }, ITextElement.prototype.applyTextPropertiesToMatrix = function(t1, e1, r1, i1, s1) {
            switch(t1.ps && e1.translate(t1.ps[0], t1.ps[1] + t1.ascent, 0), e1.translate(0, -t1.ls, 0), t1.j){
                case 1:
                    e1.translate(t1.justifyOffset + (t1.boxWidth - t1.lineWidths[r1]), 0, 0);
                    break;
                case 2:
                    e1.translate(t1.justifyOffset + (t1.boxWidth - t1.lineWidths[r1]) / 2, 0, 0);
            }
            e1.translate(i1, s1, 0);
        }, ITextElement.prototype.buildColor = function(t1) {
            return "rgb(" + Math.round(255 * t1[0]) + "," + Math.round(255 * t1[1]) + "," + Math.round(255 * t1[2]) + ")";
        }, ITextElement.prototype.emptyProp = new LetterProps, ITextElement.prototype.destroy = function() {};
        var emptyShapeData = {
            shapes: []
        };
        function SVGTextLottieElement(t1, e1, r1) {
            this.textSpans = [], this.renderType = "svg", this.initElement(t1, e1, r1);
        }
        function ISolidElement(t1, e1, r1) {
            this.initElement(t1, e1, r1);
        }
        function NullElement(t1, e1, r1) {
            this.initFrame(), this.initBaseData(t1, e1, r1), this.initFrame(), this.initTransform(t1, e1, r1), this.initHierarchy();
        }
        function SVGRendererBase() {}
        function ICompElement() {}
        function SVGCompElement(t1, e1, r1) {
            this.layers = t1.layers, this.supports3d = !0, this.completeLayers = !1, this.pendingElements = [], this.elements = this.layers ? createSizedArray(this.layers.length) : [], this.initElement(t1, e1, r1), this.tm = t1.tm ? PropertyFactory.getProp(this, t1.tm, 0, e1.frameRate, this) : {
                _placeholder: !0
            };
        }
        function SVGRenderer(t1, e1) {
            this.animationItem = t1, this.layers = null, this.renderedFrame = -1, this.svgElement = createNS("svg");
            var r1 = "";
            if (e1 && e1.title) {
                var i1 = createNS("title"), s1 = createElementID();
                i1.setAttribute("id", s1), i1.textContent = e1.title, this.svgElement.appendChild(i1), r1 += s1;
            }
            if (e1 && e1.description) {
                var a1 = createNS("desc"), n1 = createElementID();
                a1.setAttribute("id", n1), a1.textContent = e1.description, this.svgElement.appendChild(a1), r1 += " " + n1;
            }
            r1 && this.svgElement.setAttribute("aria-labelledby", r1);
            var o1 = createNS("defs");
            this.svgElement.appendChild(o1);
            var h1 = createNS("g");
            this.svgElement.appendChild(h1), this.layerElement = h1, this.renderConfig = {
                preserveAspectRatio: e1 && e1.preserveAspectRatio || "xMidYMid meet",
                imagePreserveAspectRatio: e1 && e1.imagePreserveAspectRatio || "xMidYMid slice",
                contentVisibility: e1 && e1.contentVisibility || "visible",
                progressiveLoad: e1 && e1.progressiveLoad || !1,
                hideOnTransparent: !(e1 && !1 === e1.hideOnTransparent),
                viewBoxOnly: e1 && e1.viewBoxOnly || !1,
                viewBoxSize: e1 && e1.viewBoxSize || !1,
                className: e1 && e1.className || "",
                id: e1 && e1.id || "",
                focusable: e1 && e1.focusable,
                filterSize: {
                    width: e1 && e1.filterSize && e1.filterSize.width || "100%",
                    height: e1 && e1.filterSize && e1.filterSize.height || "100%",
                    x: e1 && e1.filterSize && e1.filterSize.x || "0%",
                    y: e1 && e1.filterSize && e1.filterSize.y || "0%"
                },
                width: e1 && e1.width,
                height: e1 && e1.height,
                runExpressions: !e1 || void 0 === e1.runExpressions || e1.runExpressions
            }, this.globalData = {
                _mdf: !1,
                frameNum: -1,
                defs: o1,
                renderConfig: this.renderConfig
            }, this.elements = [], this.pendingElements = [], this.destroyed = !1, this.rendererType = "svg";
        }
        function CVContextData() {
            var t1;
            for(this.saved = [], this.cArrPos = 0, this.cTr = new Matrix, this.cO = 1, this.savedOp = createTypedArray("float32", 15), t1 = 0; t1 < 15; t1 += 1)this.saved[t1] = createTypedArray("float32", 16);
            this._length = 15;
        }
        function ShapeTransformManager() {
            this.sequences = {}, this.sequenceList = [], this.transform_key_count = 0;
        }
        function CVEffects() {}
        function CVMaskElement(t1, e1) {
            var r1;
            this.data = t1, this.element = e1, this.masksProperties = this.data.masksProperties || [], this.viewData = createSizedArray(this.masksProperties.length);
            var i1 = this.masksProperties.length, s1 = !1;
            for(r1 = 0; r1 < i1; r1 += 1)"n" !== this.masksProperties[r1].mode && (s1 = !0), this.viewData[r1] = ShapePropertyFactory.getShapeProp(this.element, this.masksProperties[r1], 3);
            this.hasMasks = s1, s1 && this.element.addRenderableComponent(this);
        }
        function CVBaseElement() {}
        function CVShapeData(t1, e1, r1, i1) {
            this.styledShapes = [], this.tr = [
                0,
                0,
                0,
                0,
                0,
                0
            ];
            var s1, a1 = 4;
            "rc" === e1.ty ? a1 = 5 : "el" === e1.ty ? a1 = 6 : "sr" === e1.ty && (a1 = 7), this.sh = ShapePropertyFactory.getShapeProp(t1, e1, a1, t1);
            var n1, o1 = r1.length;
            for(s1 = 0; s1 < o1; s1 += 1)r1[s1].closed || (n1 = {
                transforms: i1.addTransformSequence(r1[s1].transforms),
                trNodes: []
            }, this.styledShapes.push(n1), r1[s1].elements.push(n1));
        }
        function CVShapeElement(t1, e1, r1) {
            this.shapes = [], this.shapesData = t1.shapes, this.stylesList = [], this.itemsData = [], this.prevViewData = [], this.shapeModifiers = [], this.processedElements = [], this.transformsManager = new ShapeTransformManager, this.initElement(t1, e1, r1);
        }
        function CVTextElement(t1, e1, r1) {
            this.textSpans = [], this.yOffset = 0, this.fillColorAnim = !1, this.strokeColorAnim = !1, this.strokeWidthAnim = !1, this.stroke = !1, this.fill = !1, this.justifyOffset = 0, this.currentRender = null, this.renderType = "canvas", this.values = {
                fill: "rgba(0,0,0,0)",
                stroke: "rgba(0,0,0,0)",
                sWidth: 0,
                fValue: ""
            }, this.initElement(t1, e1, r1);
        }
        function CVImageElement(t1, e1, r1) {
            this.assetData = e1.getAssetData(t1.refId), this.img = e1.imageLoader.getAsset(this.assetData), this.initElement(t1, e1, r1);
        }
        function CVSolidElement(t1, e1, r1) {
            this.initElement(t1, e1, r1);
        }
        function CanvasRendererBase(t1, e1) {
            this.animationItem = t1, this.renderConfig = {
                clearCanvas: !e1 || void 0 === e1.clearCanvas || e1.clearCanvas,
                context: e1 && e1.context || null,
                progressiveLoad: e1 && e1.progressiveLoad || !1,
                preserveAspectRatio: e1 && e1.preserveAspectRatio || "xMidYMid meet",
                imagePreserveAspectRatio: e1 && e1.imagePreserveAspectRatio || "xMidYMid slice",
                contentVisibility: e1 && e1.contentVisibility || "visible",
                className: e1 && e1.className || "",
                id: e1 && e1.id || ""
            }, this.renderConfig.dpr = e1 && e1.dpr || 1, this.animationItem.wrapper && (this.renderConfig.dpr = e1 && e1.dpr || window.devicePixelRatio || 1), this.renderedFrame = -1, this.globalData = {
                frameNum: -1,
                _mdf: !1,
                renderConfig: this.renderConfig,
                currentGlobalAlpha: -1
            }, this.contextData = new CVContextData, this.elements = [], this.pendingElements = [], this.transformMat = new Matrix, this.completeLayers = !1, this.rendererType = "canvas";
        }
        function CVCompElement(t1, e1, r1) {
            this.completeLayers = !1, this.layers = t1.layers, this.pendingElements = [], this.elements = createSizedArray(this.layers.length), this.initElement(t1, e1, r1), this.tm = t1.tm ? PropertyFactory.getProp(this, t1.tm, 0, e1.frameRate, this) : {
                _placeholder: !0
            };
        }
        function CanvasRenderer(t1, e1) {
            this.animationItem = t1, this.renderConfig = {
                clearCanvas: !e1 || void 0 === e1.clearCanvas || e1.clearCanvas,
                context: e1 && e1.context || null,
                progressiveLoad: e1 && e1.progressiveLoad || !1,
                preserveAspectRatio: e1 && e1.preserveAspectRatio || "xMidYMid meet",
                imagePreserveAspectRatio: e1 && e1.imagePreserveAspectRatio || "xMidYMid slice",
                contentVisibility: e1 && e1.contentVisibility || "visible",
                className: e1 && e1.className || "",
                id: e1 && e1.id || "",
                runExpressions: !e1 || void 0 === e1.runExpressions || e1.runExpressions
            }, this.renderConfig.dpr = e1 && e1.dpr || 1, this.animationItem.wrapper && (this.renderConfig.dpr = e1 && e1.dpr || window.devicePixelRatio || 1), this.renderedFrame = -1, this.globalData = {
                frameNum: -1,
                _mdf: !1,
                renderConfig: this.renderConfig,
                currentGlobalAlpha: -1
            }, this.contextData = new CVContextData, this.elements = [], this.pendingElements = [], this.transformMat = new Matrix, this.completeLayers = !1, this.rendererType = "canvas";
        }
        function HBaseElement() {}
        function HSolidElement(t1, e1, r1) {
            this.initElement(t1, e1, r1);
        }
        function HShapeElement(t1, e1, r1) {
            this.shapes = [], this.shapesData = t1.shapes, this.stylesList = [], this.shapeModifiers = [], this.itemsData = [], this.processedElements = [], this.animatedContents = [], this.shapesContainer = createNS("g"), this.initElement(t1, e1, r1), this.prevViewData = [], this.currentBBox = {
                x: 999999,
                y: -999999,
                h: 0,
                w: 0
            };
        }
        function HTextElement(t1, e1, r1) {
            this.textSpans = [], this.textPaths = [], this.currentBBox = {
                x: 999999,
                y: -999999,
                h: 0,
                w: 0
            }, this.renderType = "svg", this.isMasked = !1, this.initElement(t1, e1, r1);
        }
        function HCameraElement(t1, e1, r1) {
            this.initFrame(), this.initBaseData(t1, e1, r1), this.initHierarchy();
            var i1 = PropertyFactory.getProp;
            if (this.pe = i1(this, t1.pe, 0, 0, this), t1.ks.p.s ? (this.px = i1(this, t1.ks.p.x, 1, 0, this), this.py = i1(this, t1.ks.p.y, 1, 0, this), this.pz = i1(this, t1.ks.p.z, 1, 0, this)) : this.p = i1(this, t1.ks.p, 1, 0, this), t1.ks.a && (this.a = i1(this, t1.ks.a, 1, 0, this)), t1.ks.or.k.length && t1.ks.or.k[0].to) {
                var s1, a1 = t1.ks.or.k.length;
                for(s1 = 0; s1 < a1; s1 += 1)t1.ks.or.k[s1].to = null, t1.ks.or.k[s1].ti = null;
            }
            this.or = i1(this, t1.ks.or, 1, degToRads, this), this.or.sh = !0, this.rx = i1(this, t1.ks.rx, 0, degToRads, this), this.ry = i1(this, t1.ks.ry, 0, degToRads, this), this.rz = i1(this, t1.ks.rz, 0, degToRads, this), this.mat = new Matrix, this._prevMat = new Matrix, this._isFirstFrame = !0, this.finalTransform = {
                mProp: this
            };
        }
        function HImageElement(t1, e1, r1) {
            this.assetData = e1.getAssetData(t1.refId), this.initElement(t1, e1, r1);
        }
        function HybridRendererBase(t1, e1) {
            this.animationItem = t1, this.layers = null, this.renderedFrame = -1, this.renderConfig = {
                className: e1 && e1.className || "",
                imagePreserveAspectRatio: e1 && e1.imagePreserveAspectRatio || "xMidYMid slice",
                hideOnTransparent: !(e1 && !1 === e1.hideOnTransparent),
                filterSize: {
                    width: e1 && e1.filterSize && e1.filterSize.width || "400%",
                    height: e1 && e1.filterSize && e1.filterSize.height || "400%",
                    x: e1 && e1.filterSize && e1.filterSize.x || "-100%",
                    y: e1 && e1.filterSize && e1.filterSize.y || "-100%"
                }
            }, this.globalData = {
                _mdf: !1,
                frameNum: -1,
                renderConfig: this.renderConfig
            }, this.pendingElements = [], this.elements = [], this.threeDElements = [], this.destroyed = !1, this.camera = null, this.supports3d = !0, this.rendererType = "html";
        }
        function HCompElement(t1, e1, r1) {
            this.layers = t1.layers, this.supports3d = !t1.hasMask, this.completeLayers = !1, this.pendingElements = [], this.elements = this.layers ? createSizedArray(this.layers.length) : [], this.initElement(t1, e1, r1), this.tm = t1.tm ? PropertyFactory.getProp(this, t1.tm, 0, e1.frameRate, this) : {
                _placeholder: !0
            };
        }
        function HybridRenderer(t1, e1) {
            this.animationItem = t1, this.layers = null, this.renderedFrame = -1, this.renderConfig = {
                className: e1 && e1.className || "",
                imagePreserveAspectRatio: e1 && e1.imagePreserveAspectRatio || "xMidYMid slice",
                hideOnTransparent: !(e1 && !1 === e1.hideOnTransparent),
                filterSize: {
                    width: e1 && e1.filterSize && e1.filterSize.width || "400%",
                    height: e1 && e1.filterSize && e1.filterSize.height || "400%",
                    x: e1 && e1.filterSize && e1.filterSize.x || "-100%",
                    y: e1 && e1.filterSize && e1.filterSize.y || "-100%"
                },
                runExpressions: !e1 || void 0 === e1.runExpressions || e1.runExpressions
            }, this.globalData = {
                _mdf: !1,
                frameNum: -1,
                renderConfig: this.renderConfig
            }, this.pendingElements = [], this.elements = [], this.threeDElements = [], this.destroyed = !1, this.camera = null, this.supports3d = !0, this.rendererType = "html";
        }
        extendPrototype([
            BaseElement,
            TransformElement,
            SVGBaseElement,
            HierarchyElement,
            FrameElement,
            RenderableDOMElement,
            ITextElement
        ], SVGTextLottieElement), SVGTextLottieElement.prototype.createContent = function() {
            this.data.singleShape && !this.globalData.fontManager.chars && (this.textContainer = createNS("text"));
        }, SVGTextLottieElement.prototype.buildTextContents = function(t1) {
            for(var e1 = 0, r1 = t1.length, i1 = [], s1 = ""; e1 < r1;)t1[e1] === String.fromCharCode(13) || t1[e1] === String.fromCharCode(3) ? (i1.push(s1), s1 = "") : s1 += t1[e1], e1 += 1;
            return i1.push(s1), i1;
        }, SVGTextLottieElement.prototype.buildShapeData = function(t1, e1) {
            if (t1.shapes && t1.shapes.length) {
                var r1 = t1.shapes[0];
                if (r1.it) {
                    var i1 = r1.it[r1.it.length - 1];
                    i1.s && (i1.s.k[0] = e1, i1.s.k[1] = e1);
                }
            }
            return t1;
        }, SVGTextLottieElement.prototype.buildNewText = function() {
            var t1, e1;
            this.addDynamicProperty(this);
            var r1 = this.textProperty.currentData;
            this.renderedLetters = createSizedArray(r1 ? r1.l.length : 0), r1.fc ? this.layerElement.setAttribute("fill", this.buildColor(r1.fc)) : this.layerElement.setAttribute("fill", "rgba(0,0,0,0)"), r1.sc && (this.layerElement.setAttribute("stroke", this.buildColor(r1.sc)), this.layerElement.setAttribute("stroke-width", r1.sw)), this.layerElement.setAttribute("font-size", r1.finalSize);
            var i1 = this.globalData.fontManager.getFontByName(r1.f);
            if (i1.fClass) this.layerElement.setAttribute("class", i1.fClass);
            else {
                this.layerElement.setAttribute("font-family", i1.fFamily);
                var s1 = r1.fWeight, a1 = r1.fStyle;
                this.layerElement.setAttribute("font-style", a1), this.layerElement.setAttribute("font-weight", s1);
            }
            this.layerElement.setAttribute("aria-label", r1.t);
            var n1, o1 = r1.l || [], h1 = !!this.globalData.fontManager.chars;
            e1 = o1.length;
            var l1 = this.mHelper, p1 = this.data.singleShape, c1 = 0, f1 = 0, d1 = !0, u1 = .001 * r1.tr * r1.finalSize;
            if (!p1 || h1 || r1.sz) {
                var m1, y1 = this.textSpans.length;
                for(t1 = 0; t1 < e1; t1 += 1){
                    if (this.textSpans[t1] || (this.textSpans[t1] = {
                        span: null,
                        childSpan: null,
                        glyph: null
                    }), !h1 || !p1 || 0 === t1) {
                        if (n1 = y1 > t1 ? this.textSpans[t1].span : createNS(h1 ? "g" : "text"), y1 <= t1) {
                            if (n1.setAttribute("stroke-linecap", "butt"), n1.setAttribute("stroke-linejoin", "round"), n1.setAttribute("stroke-miterlimit", "4"), this.textSpans[t1].span = n1, h1) {
                                var g1 = createNS("g");
                                n1.appendChild(g1), this.textSpans[t1].childSpan = g1;
                            }
                            this.textSpans[t1].span = n1, this.layerElement.appendChild(n1);
                        }
                        n1.style.display = "inherit";
                    }
                    if (l1.reset(), p1 && (o1[t1].n && (c1 = -u1, f1 += r1.yOffset, f1 += d1 ? 1 : 0, d1 = !1), this.applyTextPropertiesToMatrix(r1, l1, o1[t1].line, c1, f1), c1 += o1[t1].l || 0, c1 += u1), h1) {
                        var v1;
                        if (1 === (m1 = this.globalData.fontManager.getCharData(r1.finalText[t1], i1.fStyle, this.globalData.fontManager.getFontByName(r1.f).fFamily)).t) v1 = new SVGCompElement(m1.data, this.globalData, this);
                        else {
                            var b1 = emptyShapeData;
                            m1.data && m1.data.shapes && (b1 = this.buildShapeData(m1.data, r1.finalSize)), v1 = new SVGShapeElement(b1, this.globalData, this);
                        }
                        if (this.textSpans[t1].glyph) {
                            var _1 = this.textSpans[t1].glyph;
                            this.textSpans[t1].childSpan.removeChild(_1.layerElement), _1.destroy();
                        }
                        this.textSpans[t1].glyph = v1, v1._debug = !0, v1.prepareFrame(0), v1.renderFrame(), this.textSpans[t1].childSpan.appendChild(v1.layerElement), 1 === m1.t && this.textSpans[t1].childSpan.setAttribute("transform", "scale(" + r1.finalSize / 100 + "," + r1.finalSize / 100 + ")");
                    } else p1 && n1.setAttribute("transform", "translate(" + l1.props[12] + "," + l1.props[13] + ")"), n1.textContent = o1[t1].val, n1.setAttributeNS("http://www.w3.org/XML/1998/namespace", "xml:space", "preserve");
                }
                p1 && n1 && n1.setAttribute("d", "");
            } else {
                var P1 = this.textContainer, E1 = "start";
                switch(r1.j){
                    case 1:
                        E1 = "end";
                        break;
                    case 2:
                        E1 = "middle";
                        break;
                    default:
                        E1 = "start";
                }
                P1.setAttribute("text-anchor", E1), P1.setAttribute("letter-spacing", u1);
                var S1 = this.buildTextContents(r1.finalText);
                for(e1 = S1.length, f1 = r1.ps ? r1.ps[1] + r1.ascent : 0, t1 = 0; t1 < e1; t1 += 1)(n1 = this.textSpans[t1].span || createNS("tspan")).textContent = S1[t1], n1.setAttribute("x", 0), n1.setAttribute("y", f1), n1.style.display = "inherit", P1.appendChild(n1), this.textSpans[t1] || (this.textSpans[t1] = {
                    span: null,
                    glyph: null
                }), this.textSpans[t1].span = n1, f1 += r1.finalLineHeight;
                this.layerElement.appendChild(P1);
            }
            for(; t1 < this.textSpans.length;)this.textSpans[t1].span.style.display = "none", t1 += 1;
            this._sizeChanged = !0;
        }, SVGTextLottieElement.prototype.sourceRectAtTime = function() {
            if (this.prepareFrame(this.comp.renderedFrame - this.data.st), this.renderInnerContent(), this._sizeChanged) {
                this._sizeChanged = !1;
                var t1 = this.layerElement.getBBox();
                this.bbox = {
                    top: t1.y,
                    left: t1.x,
                    width: t1.width,
                    height: t1.height
                };
            }
            return this.bbox;
        }, SVGTextLottieElement.prototype.getValue = function() {
            var t1, e1, r1 = this.textSpans.length;
            for(this.renderedFrame = this.comp.renderedFrame, t1 = 0; t1 < r1; t1 += 1)(e1 = this.textSpans[t1].glyph) && (e1.prepareFrame(this.comp.renderedFrame - this.data.st), e1._mdf && (this._mdf = !0));
        }, SVGTextLottieElement.prototype.renderInnerContent = function() {
            if ((!this.data.singleShape || this._mdf) && (this.textAnimator.getMeasures(this.textProperty.currentData, this.lettersChangedFlag), this.lettersChangedFlag || this.textAnimator.lettersChangedFlag)) {
                var t1, e1;
                this._sizeChanged = !0;
                var r1, i1, s1, a1 = this.textAnimator.renderedLetters, n1 = this.textProperty.currentData.l;
                for(e1 = n1.length, t1 = 0; t1 < e1; t1 += 1)n1[t1].n || (r1 = a1[t1], i1 = this.textSpans[t1].span, (s1 = this.textSpans[t1].glyph) && s1.renderFrame(), r1._mdf.m && i1.setAttribute("transform", r1.m), r1._mdf.o && i1.setAttribute("opacity", r1.o), r1._mdf.sw && i1.setAttribute("stroke-width", r1.sw), r1._mdf.sc && i1.setAttribute("stroke", r1.sc), r1._mdf.fc && i1.setAttribute("fill", r1.fc));
            }
        }, extendPrototype([
            IImageElement
        ], ISolidElement), ISolidElement.prototype.createContent = function() {
            var t1 = createNS("rect");
            t1.setAttribute("width", this.data.sw), t1.setAttribute("height", this.data.sh), t1.setAttribute("fill", this.data.sc), this.layerElement.appendChild(t1);
        }, NullElement.prototype.prepareFrame = function(t1) {
            this.prepareProperties(t1, !0);
        }, NullElement.prototype.renderFrame = function() {}, NullElement.prototype.getBaseElement = function() {
            return null;
        }, NullElement.prototype.destroy = function() {}, NullElement.prototype.sourceRectAtTime = function() {}, NullElement.prototype.hide = function() {}, extendPrototype([
            BaseElement,
            TransformElement,
            HierarchyElement,
            FrameElement
        ], NullElement), extendPrototype([
            BaseRenderer
        ], SVGRendererBase), SVGRendererBase.prototype.createNull = function(t1) {
            return new NullElement(t1, this.globalData, this);
        }, SVGRendererBase.prototype.createShape = function(t1) {
            return new SVGShapeElement(t1, this.globalData, this);
        }, SVGRendererBase.prototype.createText = function(t1) {
            return new SVGTextLottieElement(t1, this.globalData, this);
        }, SVGRendererBase.prototype.createImage = function(t1) {
            return new IImageElement(t1, this.globalData, this);
        }, SVGRendererBase.prototype.createSolid = function(t1) {
            return new ISolidElement(t1, this.globalData, this);
        }, SVGRendererBase.prototype.configAnimation = function(t1) {
            this.svgElement.setAttribute("xmlns", "http://www.w3.org/2000/svg"), this.svgElement.setAttribute("xmlns:xlink", "http://www.w3.org/1999/xlink"), this.renderConfig.viewBoxSize ? this.svgElement.setAttribute("viewBox", this.renderConfig.viewBoxSize) : this.svgElement.setAttribute("viewBox", "0 0 " + t1.w + " " + t1.h), this.renderConfig.viewBoxOnly || (this.svgElement.setAttribute("width", t1.w), this.svgElement.setAttribute("height", t1.h), this.svgElement.style.width = "100%", this.svgElement.style.height = "100%", this.svgElement.style.transform = "translate3d(0,0,0)", this.svgElement.style.contentVisibility = this.renderConfig.contentVisibility), this.renderConfig.width && this.svgElement.setAttribute("width", this.renderConfig.width), this.renderConfig.height && this.svgElement.setAttribute("height", this.renderConfig.height), this.renderConfig.className && this.svgElement.setAttribute("class", this.renderConfig.className), this.renderConfig.id && this.svgElement.setAttribute("id", this.renderConfig.id), void 0 !== this.renderConfig.focusable && this.svgElement.setAttribute("focusable", this.renderConfig.focusable), this.svgElement.setAttribute("preserveAspectRatio", this.renderConfig.preserveAspectRatio), this.animationItem.wrapper.appendChild(this.svgElement);
            var e1 = this.globalData.defs;
            this.setupGlobalData(t1, e1), this.globalData.progressiveLoad = this.renderConfig.progressiveLoad, this.data = t1;
            var r1 = createNS("clipPath"), i1 = createNS("rect");
            i1.setAttribute("width", t1.w), i1.setAttribute("height", t1.h), i1.setAttribute("x", 0), i1.setAttribute("y", 0);
            var s1 = createElementID();
            r1.setAttribute("id", s1), r1.appendChild(i1), this.layerElement.setAttribute("clip-path", "url(" + getLocationHref() + "#" + s1 + ")"), e1.appendChild(r1), this.layers = t1.layers, this.elements = createSizedArray(t1.layers.length);
        }, SVGRendererBase.prototype.destroy = function() {
            var t1;
            this.animationItem.wrapper && (this.animationItem.wrapper.innerText = ""), this.layerElement = null, this.globalData.defs = null;
            var e1 = this.layers ? this.layers.length : 0;
            for(t1 = 0; t1 < e1; t1 += 1)this.elements[t1] && this.elements[t1].destroy();
            this.elements.length = 0, this.destroyed = !0, this.animationItem = null;
        }, SVGRendererBase.prototype.updateContainerSize = function() {}, SVGRendererBase.prototype.findIndexByInd = function(t1) {
            var e1 = 0, r1 = this.layers.length;
            for(e1 = 0; e1 < r1; e1 += 1)if (this.layers[e1].ind === t1) return e1;
            return -1;
        }, SVGRendererBase.prototype.buildItem = function(t1) {
            var e1 = this.elements;
            if (!e1[t1] && 99 !== this.layers[t1].ty) {
                e1[t1] = !0;
                var r1 = this.createItem(this.layers[t1]);
                if (e1[t1] = r1, getExpressionsPlugin() && (0 === this.layers[t1].ty && this.globalData.projectInterface.registerComposition(r1), r1.initExpressions()), this.appendElementInPos(r1, t1), this.layers[t1].tt) {
                    var i1 = "tp" in this.layers[t1] ? this.findIndexByInd(this.layers[t1].tp) : t1 - 1;
                    if (-1 === i1) return;
                    if (this.elements[i1] && !0 !== this.elements[i1]) {
                        var s1 = e1[i1].getMatte(this.layers[t1].tt);
                        r1.setMatte(s1);
                    } else this.buildItem(i1), this.addPendingElement(r1);
                }
            }
        }, SVGRendererBase.prototype.checkPendingElements = function() {
            for(; this.pendingElements.length;){
                var t1 = this.pendingElements.pop();
                if (t1.checkParenting(), t1.data.tt) for(var e1 = 0, r1 = this.elements.length; e1 < r1;){
                    if (this.elements[e1] === t1) {
                        var i1 = "tp" in t1.data ? this.findIndexByInd(t1.data.tp) : e1 - 1, s1 = this.elements[i1].getMatte(this.layers[e1].tt);
                        t1.setMatte(s1);
                        break;
                    }
                    e1 += 1;
                }
            }
        }, SVGRendererBase.prototype.renderFrame = function(t1) {
            if (this.renderedFrame !== t1 && !this.destroyed) {
                var e1;
                null === t1 ? t1 = this.renderedFrame : this.renderedFrame = t1, this.globalData.frameNum = t1, this.globalData.frameId += 1, this.globalData.projectInterface.currentFrame = t1, this.globalData._mdf = !1;
                var r1 = this.layers.length;
                for(this.completeLayers || this.checkLayers(t1), e1 = r1 - 1; e1 >= 0; e1 -= 1)(this.completeLayers || this.elements[e1]) && this.elements[e1].prepareFrame(t1 - this.layers[e1].st);
                if (this.globalData._mdf) for(e1 = 0; e1 < r1; e1 += 1)(this.completeLayers || this.elements[e1]) && this.elements[e1].renderFrame();
            }
        }, SVGRendererBase.prototype.appendElementInPos = function(t1, e1) {
            var r1 = t1.getBaseElement();
            if (r1) {
                for(var i1, s1 = 0; s1 < e1;)this.elements[s1] && !0 !== this.elements[s1] && this.elements[s1].getBaseElement() && (i1 = this.elements[s1].getBaseElement()), s1 += 1;
                i1 ? this.layerElement.insertBefore(r1, i1) : this.layerElement.appendChild(r1);
            }
        }, SVGRendererBase.prototype.hide = function() {
            this.layerElement.style.display = "none";
        }, SVGRendererBase.prototype.show = function() {
            this.layerElement.style.display = "block";
        }, extendPrototype([
            BaseElement,
            TransformElement,
            HierarchyElement,
            FrameElement,
            RenderableDOMElement
        ], ICompElement), ICompElement.prototype.initElement = function(t1, e1, r1) {
            this.initFrame(), this.initBaseData(t1, e1, r1), this.initTransform(t1, e1, r1), this.initRenderable(), this.initHierarchy(), this.initRendererElement(), this.createContainerElements(), this.createRenderableComponents(), !this.data.xt && e1.progressiveLoad || this.buildAllItems(), this.hide();
        }, ICompElement.prototype.prepareFrame = function(t1) {
            if (this._mdf = !1, this.prepareRenderableFrame(t1), this.prepareProperties(t1, this.isInRange), this.isInRange || this.data.xt) {
                if (this.tm._placeholder) this.renderedFrame = t1 / this.data.sr;
                else {
                    var e1 = this.tm.v;
                    e1 === this.data.op && (e1 = this.data.op - 1), this.renderedFrame = e1;
                }
                var r1, i1 = this.elements.length;
                for(this.completeLayers || this.checkLayers(this.renderedFrame), r1 = i1 - 1; r1 >= 0; r1 -= 1)(this.completeLayers || this.elements[r1]) && (this.elements[r1].prepareFrame(this.renderedFrame - this.layers[r1].st), this.elements[r1]._mdf && (this._mdf = !0));
            }
        }, ICompElement.prototype.renderInnerContent = function() {
            var t1, e1 = this.layers.length;
            for(t1 = 0; t1 < e1; t1 += 1)(this.completeLayers || this.elements[t1]) && this.elements[t1].renderFrame();
        }, ICompElement.prototype.setElements = function(t1) {
            this.elements = t1;
        }, ICompElement.prototype.getElements = function() {
            return this.elements;
        }, ICompElement.prototype.destroyElements = function() {
            var t1, e1 = this.layers.length;
            for(t1 = 0; t1 < e1; t1 += 1)this.elements[t1] && this.elements[t1].destroy();
        }, ICompElement.prototype.destroy = function() {
            this.destroyElements(), this.destroyBaseElement();
        }, extendPrototype([
            SVGRendererBase,
            ICompElement,
            SVGBaseElement
        ], SVGCompElement), SVGCompElement.prototype.createComp = function(t1) {
            return new SVGCompElement(t1, this.globalData, this);
        }, extendPrototype([
            SVGRendererBase
        ], SVGRenderer), SVGRenderer.prototype.createComp = function(t1) {
            return new SVGCompElement(t1, this.globalData, this);
        }, CVContextData.prototype.duplicate = function() {
            var t1 = 2 * this._length, e1 = this.savedOp;
            this.savedOp = createTypedArray("float32", t1), this.savedOp.set(e1);
            var r1 = 0;
            for(r1 = this._length; r1 < t1; r1 += 1)this.saved[r1] = createTypedArray("float32", 16);
            this._length = t1;
        }, CVContextData.prototype.reset = function() {
            this.cArrPos = 0, this.cTr.reset(), this.cO = 1;
        }, ShapeTransformManager.prototype = {
            addTransformSequence: function(t1) {
                var e1, r1 = t1.length, i1 = "_";
                for(e1 = 0; e1 < r1; e1 += 1)i1 += t1[e1].transform.key + "_";
                var s1 = this.sequences[i1];
                return s1 || (s1 = {
                    transforms: [].concat(t1),
                    finalTransform: new Matrix,
                    _mdf: !1
                }, this.sequences[i1] = s1, this.sequenceList.push(s1)), s1;
            },
            processSequence: function(t1, e1) {
                for(var r1, i1 = 0, s1 = t1.transforms.length, a1 = e1; i1 < s1 && !e1;){
                    if (t1.transforms[i1].transform.mProps._mdf) {
                        a1 = !0;
                        break;
                    }
                    i1 += 1;
                }
                if (a1) for(t1.finalTransform.reset(), i1 = s1 - 1; i1 >= 0; i1 -= 1)r1 = t1.transforms[i1].transform.mProps.v.props, t1.finalTransform.transform(r1[0], r1[1], r1[2], r1[3], r1[4], r1[5], r1[6], r1[7], r1[8], r1[9], r1[10], r1[11], r1[12], r1[13], r1[14], r1[15]);
                t1._mdf = a1;
            },
            processSequences: function(t1) {
                var e1, r1 = this.sequenceList.length;
                for(e1 = 0; e1 < r1; e1 += 1)this.processSequence(this.sequenceList[e1], t1);
            },
            getNewKey: function() {
                return this.transform_key_count += 1, "_" + this.transform_key_count;
            }
        }, CVEffects.prototype.renderFrame = function() {}, CVMaskElement.prototype.renderFrame = function() {
            if (this.hasMasks) {
                var t1, e1, r1, i1, s1 = this.element.finalTransform.mat, a1 = this.element.canvasContext, n1 = this.masksProperties.length;
                for(a1.beginPath(), t1 = 0; t1 < n1; t1 += 1)if ("n" !== this.masksProperties[t1].mode) {
                    var o1;
                    this.masksProperties[t1].inv && (a1.moveTo(0, 0), a1.lineTo(this.element.globalData.compSize.w, 0), a1.lineTo(this.element.globalData.compSize.w, this.element.globalData.compSize.h), a1.lineTo(0, this.element.globalData.compSize.h), a1.lineTo(0, 0)), i1 = this.viewData[t1].v, e1 = s1.applyToPointArray(i1.v[0][0], i1.v[0][1], 0), a1.moveTo(e1[0], e1[1]);
                    var h1 = i1._length;
                    for(o1 = 1; o1 < h1; o1 += 1)r1 = s1.applyToTriplePoints(i1.o[o1 - 1], i1.i[o1], i1.v[o1]), a1.bezierCurveTo(r1[0], r1[1], r1[2], r1[3], r1[4], r1[5]);
                    r1 = s1.applyToTriplePoints(i1.o[o1 - 1], i1.i[0], i1.v[0]), a1.bezierCurveTo(r1[0], r1[1], r1[2], r1[3], r1[4], r1[5]);
                }
                this.element.globalData.renderer.save(!0), a1.clip();
            }
        }, CVMaskElement.prototype.getMaskProperty = MaskElement.prototype.getMaskProperty, CVMaskElement.prototype.destroy = function() {
            this.element = null;
        }, CVBaseElement.prototype = {
            createElements: function() {},
            initRendererElement: function() {},
            createContainerElements: function() {
                this.canvasContext = this.globalData.canvasContext, this.renderableEffectsManager = new CVEffects(this);
            },
            createContent: function() {},
            setBlendMode: function() {
                var t1 = this.globalData;
                if (t1.blendMode !== this.data.bm) {
                    t1.blendMode = this.data.bm;
                    var e1 = getBlendMode(this.data.bm);
                    t1.canvasContext.globalCompositeOperation = e1;
                }
            },
            createRenderableComponents: function() {
                this.maskManager = new CVMaskElement(this.data, this);
            },
            hideElement: function() {
                this.hidden || this.isInRange && !this.isTransparent || (this.hidden = !0);
            },
            showElement: function() {
                this.isInRange && !this.isTransparent && (this.hidden = !1, this._isFirstFrame = !0, this.maskManager._isFirstFrame = !0);
            },
            renderFrame: function() {
                if (!this.hidden && !this.data.hd) {
                    this.renderTransform(), this.renderRenderable(), this.setBlendMode();
                    var t1 = 0 === this.data.ty;
                    this.globalData.renderer.save(t1), this.globalData.renderer.ctxTransform(this.finalTransform.mat.props), this.globalData.renderer.ctxOpacity(this.finalTransform.mProp.o.v), this.renderInnerContent(), this.globalData.renderer.restore(t1), this.maskManager.hasMasks && this.globalData.renderer.restore(!0), this._isFirstFrame && (this._isFirstFrame = !1);
                }
            },
            destroy: function() {
                this.canvasContext = null, this.data = null, this.globalData = null, this.maskManager.destroy();
            },
            mHelper: new Matrix
        }, CVBaseElement.prototype.hide = CVBaseElement.prototype.hideElement, CVBaseElement.prototype.show = CVBaseElement.prototype.showElement, CVShapeData.prototype.setAsAnimated = SVGShapeData.prototype.setAsAnimated, extendPrototype([
            BaseElement,
            TransformElement,
            CVBaseElement,
            IShapeElement,
            HierarchyElement,
            FrameElement,
            RenderableElement
        ], CVShapeElement), CVShapeElement.prototype.initElement = RenderableDOMElement.prototype.initElement, CVShapeElement.prototype.transformHelper = {
            opacity: 1,
            _opMdf: !1
        }, CVShapeElement.prototype.dashResetter = [], CVShapeElement.prototype.createContent = function() {
            this.searchShapes(this.shapesData, this.itemsData, this.prevViewData, !0, []);
        }, CVShapeElement.prototype.createStyleElement = function(t1, e1) {
            var r1 = {
                data: t1,
                type: t1.ty,
                preTransforms: this.transformsManager.addTransformSequence(e1),
                transforms: [],
                elements: [],
                closed: !0 === t1.hd
            }, i1 = {};
            if ("fl" === t1.ty || "st" === t1.ty ? (i1.c = PropertyFactory.getProp(this, t1.c, 1, 255, this), i1.c.k || (r1.co = "rgb(" + bmFloor(i1.c.v[0]) + "," + bmFloor(i1.c.v[1]) + "," + bmFloor(i1.c.v[2]) + ")")) : "gf" !== t1.ty && "gs" !== t1.ty || (i1.s = PropertyFactory.getProp(this, t1.s, 1, null, this), i1.e = PropertyFactory.getProp(this, t1.e, 1, null, this), i1.h = PropertyFactory.getProp(this, t1.h || {
                k: 0
            }, 0, .01, this), i1.a = PropertyFactory.getProp(this, t1.a || {
                k: 0
            }, 0, degToRads, this), i1.g = new GradientProperty(this, t1.g, this)), i1.o = PropertyFactory.getProp(this, t1.o, 0, .01, this), "st" === t1.ty || "gs" === t1.ty) {
                if (r1.lc = lineCapEnum[t1.lc || 2], r1.lj = lineJoinEnum[t1.lj || 2], 1 == t1.lj && (r1.ml = t1.ml), i1.w = PropertyFactory.getProp(this, t1.w, 0, null, this), i1.w.k || (r1.wi = i1.w.v), t1.d) {
                    var s1 = new DashProperty(this, t1.d, "canvas", this);
                    i1.d = s1, i1.d.k || (r1.da = i1.d.dashArray, r1.do = i1.d.dashoffset[0]);
                }
            } else r1.r = 2 === t1.r ? "evenodd" : "nonzero";
            return this.stylesList.push(r1), i1.style = r1, i1;
        }, CVShapeElement.prototype.createGroupElement = function() {
            return {
                it: [],
                prevViewData: []
            };
        }, CVShapeElement.prototype.createTransformElement = function(t1) {
            return {
                transform: {
                    opacity: 1,
                    _opMdf: !1,
                    key: this.transformsManager.getNewKey(),
                    op: PropertyFactory.getProp(this, t1.o, 0, .01, this),
                    mProps: TransformPropertyFactory.getTransformProperty(this, t1, this)
                }
            };
        }, CVShapeElement.prototype.createShapeElement = function(t1) {
            var e1 = new CVShapeData(this, t1, this.stylesList, this.transformsManager);
            return this.shapes.push(e1), this.addShapeToModifiers(e1), e1;
        }, CVShapeElement.prototype.reloadShapes = function() {
            var t1;
            this._isFirstFrame = !0;
            var e1 = this.itemsData.length;
            for(t1 = 0; t1 < e1; t1 += 1)this.prevViewData[t1] = this.itemsData[t1];
            for(this.searchShapes(this.shapesData, this.itemsData, this.prevViewData, !0, []), e1 = this.dynamicProperties.length, t1 = 0; t1 < e1; t1 += 1)this.dynamicProperties[t1].getValue();
            this.renderModifiers(), this.transformsManager.processSequences(this._isFirstFrame);
        }, CVShapeElement.prototype.addTransformToStyleList = function(t1) {
            var e1, r1 = this.stylesList.length;
            for(e1 = 0; e1 < r1; e1 += 1)this.stylesList[e1].closed || this.stylesList[e1].transforms.push(t1);
        }, CVShapeElement.prototype.removeTransformFromStyleList = function() {
            var t1, e1 = this.stylesList.length;
            for(t1 = 0; t1 < e1; t1 += 1)this.stylesList[t1].closed || this.stylesList[t1].transforms.pop();
        }, CVShapeElement.prototype.closeStyles = function(t1) {
            var e1, r1 = t1.length;
            for(e1 = 0; e1 < r1; e1 += 1)t1[e1].closed = !0;
        }, CVShapeElement.prototype.searchShapes = function(t1, e1, r1, i1, s1) {
            var a1, n1, o1, h1, l1, p1, c1 = t1.length - 1, f1 = [], d1 = [], u1 = [].concat(s1);
            for(a1 = c1; a1 >= 0; a1 -= 1){
                if ((h1 = this.searchProcessedElement(t1[a1])) ? e1[a1] = r1[h1 - 1] : t1[a1]._shouldRender = i1, "fl" === t1[a1].ty || "st" === t1[a1].ty || "gf" === t1[a1].ty || "gs" === t1[a1].ty) h1 ? e1[a1].style.closed = !1 : e1[a1] = this.createStyleElement(t1[a1], u1), f1.push(e1[a1].style);
                else if ("gr" === t1[a1].ty) {
                    if (h1) for(o1 = e1[a1].it.length, n1 = 0; n1 < o1; n1 += 1)e1[a1].prevViewData[n1] = e1[a1].it[n1];
                    else e1[a1] = this.createGroupElement(t1[a1]);
                    this.searchShapes(t1[a1].it, e1[a1].it, e1[a1].prevViewData, i1, u1);
                } else "tr" === t1[a1].ty ? (h1 || (p1 = this.createTransformElement(t1[a1]), e1[a1] = p1), u1.push(e1[a1]), this.addTransformToStyleList(e1[a1])) : "sh" === t1[a1].ty || "rc" === t1[a1].ty || "el" === t1[a1].ty || "sr" === t1[a1].ty ? h1 || (e1[a1] = this.createShapeElement(t1[a1])) : "tm" === t1[a1].ty || "rd" === t1[a1].ty || "pb" === t1[a1].ty || "zz" === t1[a1].ty || "op" === t1[a1].ty ? (h1 ? (l1 = e1[a1]).closed = !1 : ((l1 = ShapeModifiers.getModifier(t1[a1].ty)).init(this, t1[a1]), e1[a1] = l1, this.shapeModifiers.push(l1)), d1.push(l1)) : "rp" === t1[a1].ty && (h1 ? (l1 = e1[a1]).closed = !0 : (l1 = ShapeModifiers.getModifier(t1[a1].ty), e1[a1] = l1, l1.init(this, t1, a1, e1), this.shapeModifiers.push(l1), i1 = !1), d1.push(l1));
                this.addProcessedElement(t1[a1], a1 + 1);
            }
            for(this.removeTransformFromStyleList(), this.closeStyles(f1), c1 = d1.length, a1 = 0; a1 < c1; a1 += 1)d1[a1].closed = !0;
        }, CVShapeElement.prototype.renderInnerContent = function() {
            this.transformHelper.opacity = 1, this.transformHelper._opMdf = !1, this.renderModifiers(), this.transformsManager.processSequences(this._isFirstFrame), this.renderShape(this.transformHelper, this.shapesData, this.itemsData, !0);
        }, CVShapeElement.prototype.renderShapeTransform = function(t1, e1) {
            (t1._opMdf || e1.op._mdf || this._isFirstFrame) && (e1.opacity = t1.opacity, e1.opacity *= e1.op.v, e1._opMdf = !0);
        }, CVShapeElement.prototype.drawLayer = function() {
            var t1, e1, r1, i1, s1, a1, n1, o1, h1, l1 = this.stylesList.length, p1 = this.globalData.renderer, c1 = this.globalData.canvasContext;
            for(t1 = 0; t1 < l1; t1 += 1)if (("st" !== (o1 = (h1 = this.stylesList[t1]).type) && "gs" !== o1 || 0 !== h1.wi) && h1.data._shouldRender && 0 !== h1.coOp && 0 !== this.globalData.currentGlobalAlpha) {
                for(p1.save(), a1 = h1.elements, "st" === o1 || "gs" === o1 ? (c1.strokeStyle = "st" === o1 ? h1.co : h1.grd, c1.lineWidth = h1.wi, c1.lineCap = h1.lc, c1.lineJoin = h1.lj, c1.miterLimit = h1.ml || 0) : c1.fillStyle = "fl" === o1 ? h1.co : h1.grd, p1.ctxOpacity(h1.coOp), "st" !== o1 && "gs" !== o1 && c1.beginPath(), p1.ctxTransform(h1.preTransforms.finalTransform.props), r1 = a1.length, e1 = 0; e1 < r1; e1 += 1){
                    for("st" !== o1 && "gs" !== o1 || (c1.beginPath(), h1.da && (c1.setLineDash(h1.da), c1.lineDashOffset = h1.do)), s1 = (n1 = a1[e1].trNodes).length, i1 = 0; i1 < s1; i1 += 1)"m" === n1[i1].t ? c1.moveTo(n1[i1].p[0], n1[i1].p[1]) : "c" === n1[i1].t ? c1.bezierCurveTo(n1[i1].pts[0], n1[i1].pts[1], n1[i1].pts[2], n1[i1].pts[3], n1[i1].pts[4], n1[i1].pts[5]) : c1.closePath();
                    "st" !== o1 && "gs" !== o1 || (c1.stroke(), h1.da && c1.setLineDash(this.dashResetter));
                }
                "st" !== o1 && "gs" !== o1 && c1.fill(h1.r), p1.restore();
            }
        }, CVShapeElement.prototype.renderShape = function(t1, e1, r1, i1) {
            var s1, a1;
            for(a1 = t1, s1 = e1.length - 1; s1 >= 0; s1 -= 1)"tr" === e1[s1].ty ? (a1 = r1[s1].transform, this.renderShapeTransform(t1, a1)) : "sh" === e1[s1].ty || "el" === e1[s1].ty || "rc" === e1[s1].ty || "sr" === e1[s1].ty ? this.renderPath(e1[s1], r1[s1]) : "fl" === e1[s1].ty ? this.renderFill(e1[s1], r1[s1], a1) : "st" === e1[s1].ty ? this.renderStroke(e1[s1], r1[s1], a1) : "gf" === e1[s1].ty || "gs" === e1[s1].ty ? this.renderGradientFill(e1[s1], r1[s1], a1) : "gr" === e1[s1].ty ? this.renderShape(a1, e1[s1].it, r1[s1].it) : e1[s1].ty;
            i1 && this.drawLayer();
        }, CVShapeElement.prototype.renderStyledShape = function(t1, e1) {
            if (this._isFirstFrame || e1._mdf || t1.transforms._mdf) {
                var r1, i1, s1, a1 = t1.trNodes, n1 = e1.paths, o1 = n1._length;
                a1.length = 0;
                var h1 = t1.transforms.finalTransform;
                for(s1 = 0; s1 < o1; s1 += 1){
                    var l1 = n1.shapes[s1];
                    if (l1 && l1.v) {
                        for(i1 = l1._length, r1 = 1; r1 < i1; r1 += 1)1 === r1 && a1.push({
                            t: "m",
                            p: h1.applyToPointArray(l1.v[0][0], l1.v[0][1], 0)
                        }), a1.push({
                            t: "c",
                            pts: h1.applyToTriplePoints(l1.o[r1 - 1], l1.i[r1], l1.v[r1])
                        });
                        1 === i1 && a1.push({
                            t: "m",
                            p: h1.applyToPointArray(l1.v[0][0], l1.v[0][1], 0)
                        }), l1.c && i1 && (a1.push({
                            t: "c",
                            pts: h1.applyToTriplePoints(l1.o[r1 - 1], l1.i[0], l1.v[0])
                        }), a1.push({
                            t: "z"
                        }));
                    }
                }
                t1.trNodes = a1;
            }
        }, CVShapeElement.prototype.renderPath = function(t1, e1) {
            if (!0 !== t1.hd && t1._shouldRender) {
                var r1, i1 = e1.styledShapes.length;
                for(r1 = 0; r1 < i1; r1 += 1)this.renderStyledShape(e1.styledShapes[r1], e1.sh);
            }
        }, CVShapeElement.prototype.renderFill = function(t1, e1, r1) {
            var i1 = e1.style;
            (e1.c._mdf || this._isFirstFrame) && (i1.co = "rgb(" + bmFloor(e1.c.v[0]) + "," + bmFloor(e1.c.v[1]) + "," + bmFloor(e1.c.v[2]) + ")"), (e1.o._mdf || r1._opMdf || this._isFirstFrame) && (i1.coOp = e1.o.v * r1.opacity);
        }, CVShapeElement.prototype.renderGradientFill = function(t1, e1, r1) {
            var i1, s1 = e1.style;
            if (!s1.grd || e1.g._mdf || e1.s._mdf || e1.e._mdf || 1 !== t1.t && (e1.h._mdf || e1.a._mdf)) {
                var a1, n1 = this.globalData.canvasContext, o1 = e1.s.v, h1 = e1.e.v;
                if (1 === t1.t) i1 = n1.createLinearGradient(o1[0], o1[1], h1[0], h1[1]);
                else {
                    var l1 = Math.sqrt(Math.pow(o1[0] - h1[0], 2) + Math.pow(o1[1] - h1[1], 2)), p1 = Math.atan2(h1[1] - o1[1], h1[0] - o1[0]), c1 = e1.h.v;
                    c1 >= 1 ? c1 = .99 : c1 <= -1 && (c1 = -0.99);
                    var f1 = l1 * c1, d1 = Math.cos(p1 + e1.a.v) * f1 + o1[0], u1 = Math.sin(p1 + e1.a.v) * f1 + o1[1];
                    i1 = n1.createRadialGradient(d1, u1, 0, o1[0], o1[1], l1);
                }
                var m1 = t1.g.p, y1 = e1.g.c, g1 = 1;
                for(a1 = 0; a1 < m1; a1 += 1)e1.g._hasOpacity && e1.g._collapsable && (g1 = e1.g.o[2 * a1 + 1]), i1.addColorStop(y1[4 * a1] / 100, "rgba(" + y1[4 * a1 + 1] + "," + y1[4 * a1 + 2] + "," + y1[4 * a1 + 3] + "," + g1 + ")");
                s1.grd = i1;
            }
            s1.coOp = e1.o.v * r1.opacity;
        }, CVShapeElement.prototype.renderStroke = function(t1, e1, r1) {
            var i1 = e1.style, s1 = e1.d;
            s1 && (s1._mdf || this._isFirstFrame) && (i1.da = s1.dashArray, i1.do = s1.dashoffset[0]), (e1.c._mdf || this._isFirstFrame) && (i1.co = "rgb(" + bmFloor(e1.c.v[0]) + "," + bmFloor(e1.c.v[1]) + "," + bmFloor(e1.c.v[2]) + ")"), (e1.o._mdf || r1._opMdf || this._isFirstFrame) && (i1.coOp = e1.o.v * r1.opacity), (e1.w._mdf || this._isFirstFrame) && (i1.wi = e1.w.v);
        }, CVShapeElement.prototype.destroy = function() {
            this.shapesData = null, this.globalData = null, this.canvasContext = null, this.stylesList.length = 0, this.itemsData.length = 0;
        }, extendPrototype([
            BaseElement,
            TransformElement,
            CVBaseElement,
            HierarchyElement,
            FrameElement,
            RenderableElement,
            ITextElement
        ], CVTextElement), CVTextElement.prototype.tHelper = createTag("canvas").getContext("2d"), CVTextElement.prototype.buildNewText = function() {
            var t1 = this.textProperty.currentData;
            this.renderedLetters = createSizedArray(t1.l ? t1.l.length : 0);
            var e1 = !1;
            t1.fc ? (e1 = !0, this.values.fill = this.buildColor(t1.fc)) : this.values.fill = "rgba(0,0,0,0)", this.fill = e1;
            var r1 = !1;
            t1.sc && (r1 = !0, this.values.stroke = this.buildColor(t1.sc), this.values.sWidth = t1.sw);
            var i1, s1, a1, n1, o1, h1, l1, p1, c1, f1, d1, u1, m1 = this.globalData.fontManager.getFontByName(t1.f), y1 = t1.l, g1 = this.mHelper;
            this.stroke = r1, this.values.fValue = t1.finalSize + "px " + this.globalData.fontManager.getFontByName(t1.f).fFamily, s1 = t1.finalText.length;
            var v1 = this.data.singleShape, b1 = .001 * t1.tr * t1.finalSize, _1 = 0, P1 = 0, E1 = !0, S1 = 0;
            for(i1 = 0; i1 < s1; i1 += 1){
                n1 = (a1 = this.globalData.fontManager.getCharData(t1.finalText[i1], m1.fStyle, this.globalData.fontManager.getFontByName(t1.f).fFamily)) && a1.data || {}, g1.reset(), v1 && y1[i1].n && (_1 = -b1, P1 += t1.yOffset, P1 += E1 ? 1 : 0, E1 = !1), c1 = (l1 = n1.shapes ? n1.shapes[0].it : []).length, g1.scale(t1.finalSize / 100, t1.finalSize / 100), v1 && this.applyTextPropertiesToMatrix(t1, g1, y1[i1].line, _1, P1), d1 = createSizedArray(c1 - 1);
                var x1 = 0;
                for(p1 = 0; p1 < c1; p1 += 1)if ("sh" === l1[p1].ty) {
                    for(h1 = l1[p1].ks.k.i.length, f1 = l1[p1].ks.k, u1 = [], o1 = 1; o1 < h1; o1 += 1)1 === o1 && u1.push(g1.applyToX(f1.v[0][0], f1.v[0][1], 0), g1.applyToY(f1.v[0][0], f1.v[0][1], 0)), u1.push(g1.applyToX(f1.o[o1 - 1][0], f1.o[o1 - 1][1], 0), g1.applyToY(f1.o[o1 - 1][0], f1.o[o1 - 1][1], 0), g1.applyToX(f1.i[o1][0], f1.i[o1][1], 0), g1.applyToY(f1.i[o1][0], f1.i[o1][1], 0), g1.applyToX(f1.v[o1][0], f1.v[o1][1], 0), g1.applyToY(f1.v[o1][0], f1.v[o1][1], 0));
                    u1.push(g1.applyToX(f1.o[o1 - 1][0], f1.o[o1 - 1][1], 0), g1.applyToY(f1.o[o1 - 1][0], f1.o[o1 - 1][1], 0), g1.applyToX(f1.i[0][0], f1.i[0][1], 0), g1.applyToY(f1.i[0][0], f1.i[0][1], 0), g1.applyToX(f1.v[0][0], f1.v[0][1], 0), g1.applyToY(f1.v[0][0], f1.v[0][1], 0)), d1[x1] = u1, x1 += 1;
                }
                v1 && (_1 += y1[i1].l, _1 += b1), this.textSpans[S1] ? this.textSpans[S1].elem = d1 : this.textSpans[S1] = {
                    elem: d1
                }, S1 += 1;
            }
        }, CVTextElement.prototype.renderInnerContent = function() {
            var t1, e1, r1, i1, s1, a1, n1 = this.canvasContext;
            n1.font = this.values.fValue, n1.lineCap = "butt", n1.lineJoin = "miter", n1.miterLimit = 4, this.data.singleShape || this.textAnimator.getMeasures(this.textProperty.currentData, this.lettersChangedFlag);
            var o1, h1 = this.textAnimator.renderedLetters, l1 = this.textProperty.currentData.l;
            e1 = l1.length;
            var p1, c1, f1 = null, d1 = null, u1 = null;
            for(t1 = 0; t1 < e1; t1 += 1)if (!l1[t1].n) {
                if ((o1 = h1[t1]) && (this.globalData.renderer.save(), this.globalData.renderer.ctxTransform(o1.p), this.globalData.renderer.ctxOpacity(o1.o)), this.fill) {
                    for(o1 && o1.fc ? f1 !== o1.fc && (f1 = o1.fc, n1.fillStyle = o1.fc) : f1 !== this.values.fill && (f1 = this.values.fill, n1.fillStyle = this.values.fill), i1 = (p1 = this.textSpans[t1].elem).length, this.globalData.canvasContext.beginPath(), r1 = 0; r1 < i1; r1 += 1)for(a1 = (c1 = p1[r1]).length, this.globalData.canvasContext.moveTo(c1[0], c1[1]), s1 = 2; s1 < a1; s1 += 6)this.globalData.canvasContext.bezierCurveTo(c1[s1], c1[s1 + 1], c1[s1 + 2], c1[s1 + 3], c1[s1 + 4], c1[s1 + 5]);
                    this.globalData.canvasContext.closePath(), this.globalData.canvasContext.fill();
                }
                if (this.stroke) {
                    for(o1 && o1.sw ? u1 !== o1.sw && (u1 = o1.sw, n1.lineWidth = o1.sw) : u1 !== this.values.sWidth && (u1 = this.values.sWidth, n1.lineWidth = this.values.sWidth), o1 && o1.sc ? d1 !== o1.sc && (d1 = o1.sc, n1.strokeStyle = o1.sc) : d1 !== this.values.stroke && (d1 = this.values.stroke, n1.strokeStyle = this.values.stroke), i1 = (p1 = this.textSpans[t1].elem).length, this.globalData.canvasContext.beginPath(), r1 = 0; r1 < i1; r1 += 1)for(a1 = (c1 = p1[r1]).length, this.globalData.canvasContext.moveTo(c1[0], c1[1]), s1 = 2; s1 < a1; s1 += 6)this.globalData.canvasContext.bezierCurveTo(c1[s1], c1[s1 + 1], c1[s1 + 2], c1[s1 + 3], c1[s1 + 4], c1[s1 + 5]);
                    this.globalData.canvasContext.closePath(), this.globalData.canvasContext.stroke();
                }
                o1 && this.globalData.renderer.restore();
            }
        }, extendPrototype([
            BaseElement,
            TransformElement,
            CVBaseElement,
            HierarchyElement,
            FrameElement,
            RenderableElement
        ], CVImageElement), CVImageElement.prototype.initElement = SVGShapeElement.prototype.initElement, CVImageElement.prototype.prepareFrame = IImageElement.prototype.prepareFrame, CVImageElement.prototype.createContent = function() {
            if (this.img.width && (this.assetData.w !== this.img.width || this.assetData.h !== this.img.height)) {
                var t1 = createTag("canvas");
                t1.width = this.assetData.w, t1.height = this.assetData.h;
                var e1, r1, i1 = t1.getContext("2d"), s1 = this.img.width, a1 = this.img.height, n1 = s1 / a1, o1 = this.assetData.w / this.assetData.h, h1 = this.assetData.pr || this.globalData.renderConfig.imagePreserveAspectRatio;
                n1 > o1 && "xMidYMid slice" === h1 || n1 < o1 && "xMidYMid slice" !== h1 ? e1 = (r1 = a1) * o1 : r1 = (e1 = s1) / o1, i1.drawImage(this.img, (s1 - e1) / 2, (a1 - r1) / 2, e1, r1, 0, 0, this.assetData.w, this.assetData.h), this.img = t1;
            }
        }, CVImageElement.prototype.renderInnerContent = function() {
            this.canvasContext.drawImage(this.img, 0, 0);
        }, CVImageElement.prototype.destroy = function() {
            this.img = null;
        }, extendPrototype([
            BaseElement,
            TransformElement,
            CVBaseElement,
            HierarchyElement,
            FrameElement,
            RenderableElement
        ], CVSolidElement), CVSolidElement.prototype.initElement = SVGShapeElement.prototype.initElement, CVSolidElement.prototype.prepareFrame = IImageElement.prototype.prepareFrame, CVSolidElement.prototype.renderInnerContent = function() {
            var t1 = this.canvasContext;
            t1.fillStyle = this.data.sc, t1.fillRect(0, 0, this.data.sw, this.data.sh);
        }, extendPrototype([
            BaseRenderer
        ], CanvasRendererBase), CanvasRendererBase.prototype.createShape = function(t1) {
            return new CVShapeElement(t1, this.globalData, this);
        }, CanvasRendererBase.prototype.createText = function(t1) {
            return new CVTextElement(t1, this.globalData, this);
        }, CanvasRendererBase.prototype.createImage = function(t1) {
            return new CVImageElement(t1, this.globalData, this);
        }, CanvasRendererBase.prototype.createSolid = function(t1) {
            return new CVSolidElement(t1, this.globalData, this);
        }, CanvasRendererBase.prototype.createNull = SVGRenderer.prototype.createNull, CanvasRendererBase.prototype.ctxTransform = function(t1) {
            if (1 !== t1[0] || 0 !== t1[1] || 0 !== t1[4] || 1 !== t1[5] || 0 !== t1[12] || 0 !== t1[13]) {
                if (this.renderConfig.clearCanvas) {
                    this.transformMat.cloneFromProps(t1);
                    var e1 = this.contextData.cTr.props;
                    this.transformMat.transform(e1[0], e1[1], e1[2], e1[3], e1[4], e1[5], e1[6], e1[7], e1[8], e1[9], e1[10], e1[11], e1[12], e1[13], e1[14], e1[15]), this.contextData.cTr.cloneFromProps(this.transformMat.props);
                    var r1 = this.contextData.cTr.props;
                    this.canvasContext.setTransform(r1[0], r1[1], r1[4], r1[5], r1[12], r1[13]);
                } else this.canvasContext.transform(t1[0], t1[1], t1[4], t1[5], t1[12], t1[13]);
            }
        }, CanvasRendererBase.prototype.ctxOpacity = function(t1) {
            if (!this.renderConfig.clearCanvas) return this.canvasContext.globalAlpha *= t1 < 0 ? 0 : t1, void (this.globalData.currentGlobalAlpha = this.contextData.cO);
            this.contextData.cO *= t1 < 0 ? 0 : t1, this.globalData.currentGlobalAlpha !== this.contextData.cO && (this.canvasContext.globalAlpha = this.contextData.cO, this.globalData.currentGlobalAlpha = this.contextData.cO);
        }, CanvasRendererBase.prototype.reset = function() {
            this.renderConfig.clearCanvas ? this.contextData.reset() : this.canvasContext.restore();
        }, CanvasRendererBase.prototype.save = function(t1) {
            if (this.renderConfig.clearCanvas) {
                t1 && this.canvasContext.save();
                var e1, r1 = this.contextData.cTr.props;
                this.contextData._length <= this.contextData.cArrPos && this.contextData.duplicate();
                var i1 = this.contextData.saved[this.contextData.cArrPos];
                for(e1 = 0; e1 < 16; e1 += 1)i1[e1] = r1[e1];
                this.contextData.savedOp[this.contextData.cArrPos] = this.contextData.cO, this.contextData.cArrPos += 1;
            } else this.canvasContext.save();
        }, CanvasRendererBase.prototype.restore = function(t1) {
            if (this.renderConfig.clearCanvas) {
                t1 && (this.canvasContext.restore(), this.globalData.blendMode = "source-over"), this.contextData.cArrPos -= 1;
                var e1, r1 = this.contextData.saved[this.contextData.cArrPos], i1 = this.contextData.cTr.props;
                for(e1 = 0; e1 < 16; e1 += 1)i1[e1] = r1[e1];
                this.canvasContext.setTransform(r1[0], r1[1], r1[4], r1[5], r1[12], r1[13]), r1 = this.contextData.savedOp[this.contextData.cArrPos], this.contextData.cO = r1, this.globalData.currentGlobalAlpha !== r1 && (this.canvasContext.globalAlpha = r1, this.globalData.currentGlobalAlpha = r1);
            } else this.canvasContext.restore();
        }, CanvasRendererBase.prototype.configAnimation = function(t1) {
            if (this.animationItem.wrapper) {
                this.animationItem.container = createTag("canvas");
                var e1 = this.animationItem.container.style;
                e1.width = "100%", e1.height = "100%";
                var r1 = "0px 0px 0px";
                e1.transformOrigin = r1, e1.mozTransformOrigin = r1, e1.webkitTransformOrigin = r1, e1["-webkit-transform"] = r1, e1.contentVisibility = this.renderConfig.contentVisibility, this.animationItem.wrapper.appendChild(this.animationItem.container), this.canvasContext = this.animationItem.container.getContext("2d"), this.renderConfig.className && this.animationItem.container.setAttribute("class", this.renderConfig.className), this.renderConfig.id && this.animationItem.container.setAttribute("id", this.renderConfig.id);
            } else this.canvasContext = this.renderConfig.context;
            this.data = t1, this.layers = t1.layers, this.transformCanvas = {
                w: t1.w,
                h: t1.h,
                sx: 0,
                sy: 0,
                tx: 0,
                ty: 0
            }, this.setupGlobalData(t1, document.body), this.globalData.canvasContext = this.canvasContext, this.globalData.renderer = this, this.globalData.isDashed = !1, this.globalData.progressiveLoad = this.renderConfig.progressiveLoad, this.globalData.transformCanvas = this.transformCanvas, this.elements = createSizedArray(t1.layers.length), this.updateContainerSize();
        }, CanvasRendererBase.prototype.updateContainerSize = function(t1, e1) {
            var r1, i1, s1, a1;
            if (this.reset(), t1 ? (r1 = t1, i1 = e1, this.canvasContext.canvas.width = r1, this.canvasContext.canvas.height = i1) : (this.animationItem.wrapper && this.animationItem.container ? (r1 = this.animationItem.wrapper.offsetWidth, i1 = this.animationItem.wrapper.offsetHeight) : (r1 = this.canvasContext.canvas.width, i1 = this.canvasContext.canvas.height), this.canvasContext.canvas.width = r1 * this.renderConfig.dpr, this.canvasContext.canvas.height = i1 * this.renderConfig.dpr), -1 !== this.renderConfig.preserveAspectRatio.indexOf("meet") || -1 !== this.renderConfig.preserveAspectRatio.indexOf("slice")) {
                var n1 = this.renderConfig.preserveAspectRatio.split(" "), o1 = n1[1] || "meet", h1 = n1[0] || "xMidYMid", l1 = h1.substr(0, 4), p1 = h1.substr(4);
                s1 = r1 / i1, (a1 = this.transformCanvas.w / this.transformCanvas.h) > s1 && "meet" === o1 || a1 < s1 && "slice" === o1 ? (this.transformCanvas.sx = r1 / (this.transformCanvas.w / this.renderConfig.dpr), this.transformCanvas.sy = r1 / (this.transformCanvas.w / this.renderConfig.dpr)) : (this.transformCanvas.sx = i1 / (this.transformCanvas.h / this.renderConfig.dpr), this.transformCanvas.sy = i1 / (this.transformCanvas.h / this.renderConfig.dpr)), this.transformCanvas.tx = "xMid" === l1 && (a1 < s1 && "meet" === o1 || a1 > s1 && "slice" === o1) ? (r1 - this.transformCanvas.w * (i1 / this.transformCanvas.h)) / 2 * this.renderConfig.dpr : "xMax" === l1 && (a1 < s1 && "meet" === o1 || a1 > s1 && "slice" === o1) ? (r1 - this.transformCanvas.w * (i1 / this.transformCanvas.h)) * this.renderConfig.dpr : 0, this.transformCanvas.ty = "YMid" === p1 && (a1 > s1 && "meet" === o1 || a1 < s1 && "slice" === o1) ? (i1 - this.transformCanvas.h * (r1 / this.transformCanvas.w)) / 2 * this.renderConfig.dpr : "YMax" === p1 && (a1 > s1 && "meet" === o1 || a1 < s1 && "slice" === o1) ? (i1 - this.transformCanvas.h * (r1 / this.transformCanvas.w)) * this.renderConfig.dpr : 0;
            } else "none" === this.renderConfig.preserveAspectRatio ? (this.transformCanvas.sx = r1 / (this.transformCanvas.w / this.renderConfig.dpr), this.transformCanvas.sy = i1 / (this.transformCanvas.h / this.renderConfig.dpr), this.transformCanvas.tx = 0, this.transformCanvas.ty = 0) : (this.transformCanvas.sx = this.renderConfig.dpr, this.transformCanvas.sy = this.renderConfig.dpr, this.transformCanvas.tx = 0, this.transformCanvas.ty = 0);
            this.transformCanvas.props = [
                this.transformCanvas.sx,
                0,
                0,
                0,
                0,
                this.transformCanvas.sy,
                0,
                0,
                0,
                0,
                1,
                0,
                this.transformCanvas.tx,
                this.transformCanvas.ty,
                0,
                1
            ], this.ctxTransform(this.transformCanvas.props), this.canvasContext.beginPath(), this.canvasContext.rect(0, 0, this.transformCanvas.w, this.transformCanvas.h), this.canvasContext.closePath(), this.canvasContext.clip(), this.renderFrame(this.renderedFrame, !0);
        }, CanvasRendererBase.prototype.destroy = function() {
            var t1;
            for(this.renderConfig.clearCanvas && this.animationItem.wrapper && (this.animationItem.wrapper.innerText = ""), t1 = (this.layers ? this.layers.length : 0) - 1; t1 >= 0; t1 -= 1)this.elements[t1] && this.elements[t1].destroy();
            this.elements.length = 0, this.globalData.canvasContext = null, this.animationItem.container = null, this.destroyed = !0;
        }, CanvasRendererBase.prototype.renderFrame = function(t1, e1) {
            if ((this.renderedFrame !== t1 || !0 !== this.renderConfig.clearCanvas || e1) && !this.destroyed && -1 !== t1) {
                var r1;
                this.renderedFrame = t1, this.globalData.frameNum = t1 - this.animationItem._isFirstFrame, this.globalData.frameId += 1, this.globalData._mdf = !this.renderConfig.clearCanvas || e1, this.globalData.projectInterface.currentFrame = t1;
                var i1 = this.layers.length;
                for(this.completeLayers || this.checkLayers(t1), r1 = 0; r1 < i1; r1 += 1)(this.completeLayers || this.elements[r1]) && this.elements[r1].prepareFrame(t1 - this.layers[r1].st);
                if (this.globalData._mdf) {
                    for(!0 === this.renderConfig.clearCanvas ? this.canvasContext.clearRect(0, 0, this.transformCanvas.w, this.transformCanvas.h) : this.save(), r1 = i1 - 1; r1 >= 0; r1 -= 1)(this.completeLayers || this.elements[r1]) && this.elements[r1].renderFrame();
                    !0 !== this.renderConfig.clearCanvas && this.restore();
                }
            }
        }, CanvasRendererBase.prototype.buildItem = function(t1) {
            var e1 = this.elements;
            if (!e1[t1] && 99 !== this.layers[t1].ty) {
                var r1 = this.createItem(this.layers[t1], this, this.globalData);
                e1[t1] = r1, r1.initExpressions();
            }
        }, CanvasRendererBase.prototype.checkPendingElements = function() {
            for(; this.pendingElements.length;)this.pendingElements.pop().checkParenting();
        }, CanvasRendererBase.prototype.hide = function() {
            this.animationItem.container.style.display = "none";
        }, CanvasRendererBase.prototype.show = function() {
            this.animationItem.container.style.display = "block";
        }, extendPrototype([
            CanvasRendererBase,
            ICompElement,
            CVBaseElement
        ], CVCompElement), CVCompElement.prototype.renderInnerContent = function() {
            var t1, e1 = this.canvasContext;
            for(e1.beginPath(), e1.moveTo(0, 0), e1.lineTo(this.data.w, 0), e1.lineTo(this.data.w, this.data.h), e1.lineTo(0, this.data.h), e1.lineTo(0, 0), e1.clip(), t1 = this.layers.length - 1; t1 >= 0; t1 -= 1)(this.completeLayers || this.elements[t1]) && this.elements[t1].renderFrame();
        }, CVCompElement.prototype.destroy = function() {
            var t1;
            for(t1 = this.layers.length - 1; t1 >= 0; t1 -= 1)this.elements[t1] && this.elements[t1].destroy();
            this.layers = null, this.elements = null;
        }, CVCompElement.prototype.createComp = function(t1) {
            return new CVCompElement(t1, this.globalData, this);
        }, extendPrototype([
            CanvasRendererBase
        ], CanvasRenderer), CanvasRenderer.prototype.createComp = function(t1) {
            return new CVCompElement(t1, this.globalData, this);
        }, HBaseElement.prototype = {
            checkBlendMode: function() {},
            initRendererElement: function() {
                this.baseElement = createTag(this.data.tg || "div"), this.data.hasMask ? (this.svgElement = createNS("svg"), this.layerElement = createNS("g"), this.maskedElement = this.layerElement, this.svgElement.appendChild(this.layerElement), this.baseElement.appendChild(this.svgElement)) : this.layerElement = this.baseElement, styleDiv(this.baseElement);
            },
            createContainerElements: function() {
                this.renderableEffectsManager = new CVEffects(this), this.transformedElement = this.baseElement, this.maskedElement = this.layerElement, this.data.ln && this.layerElement.setAttribute("id", this.data.ln), this.data.cl && this.layerElement.setAttribute("class", this.data.cl), 0 !== this.data.bm && this.setBlendMode();
            },
            renderElement: function() {
                var t1 = this.transformedElement ? this.transformedElement.style : {};
                if (this.finalTransform._matMdf) {
                    var e1 = this.finalTransform.mat.toCSS();
                    t1.transform = e1, t1.webkitTransform = e1;
                }
                this.finalTransform._opMdf && (t1.opacity = this.finalTransform.mProp.o.v);
            },
            renderFrame: function() {
                this.data.hd || this.hidden || (this.renderTransform(), this.renderRenderable(), this.renderElement(), this.renderInnerContent(), this._isFirstFrame && (this._isFirstFrame = !1));
            },
            destroy: function() {
                this.layerElement = null, this.transformedElement = null, this.matteElement && (this.matteElement = null), this.maskManager && (this.maskManager.destroy(), this.maskManager = null);
            },
            createRenderableComponents: function() {
                this.maskManager = new MaskElement(this.data, this, this.globalData);
            },
            addEffects: function() {},
            setMatte: function() {}
        }, HBaseElement.prototype.getBaseElement = SVGBaseElement.prototype.getBaseElement, HBaseElement.prototype.destroyBaseElement = HBaseElement.prototype.destroy, HBaseElement.prototype.buildElementParenting = BaseRenderer.prototype.buildElementParenting, extendPrototype([
            BaseElement,
            TransformElement,
            HBaseElement,
            HierarchyElement,
            FrameElement,
            RenderableDOMElement
        ], HSolidElement), HSolidElement.prototype.createContent = function() {
            var t1;
            this.data.hasMask ? ((t1 = createNS("rect")).setAttribute("width", this.data.sw), t1.setAttribute("height", this.data.sh), t1.setAttribute("fill", this.data.sc), this.svgElement.setAttribute("width", this.data.sw), this.svgElement.setAttribute("height", this.data.sh)) : ((t1 = createTag("div")).style.width = this.data.sw + "px", t1.style.height = this.data.sh + "px", t1.style.backgroundColor = this.data.sc), this.layerElement.appendChild(t1);
        }, extendPrototype([
            BaseElement,
            TransformElement,
            HSolidElement,
            SVGShapeElement,
            HBaseElement,
            HierarchyElement,
            FrameElement,
            RenderableElement
        ], HShapeElement), HShapeElement.prototype._renderShapeFrame = HShapeElement.prototype.renderInnerContent, HShapeElement.prototype.createContent = function() {
            var t1;
            if (this.baseElement.style.fontSize = 0, this.data.hasMask) this.layerElement.appendChild(this.shapesContainer), t1 = this.svgElement;
            else {
                t1 = createNS("svg");
                var e1 = this.comp.data ? this.comp.data : this.globalData.compSize;
                t1.setAttribute("width", e1.w), t1.setAttribute("height", e1.h), t1.appendChild(this.shapesContainer), this.layerElement.appendChild(t1);
            }
            this.searchShapes(this.shapesData, this.itemsData, this.prevViewData, this.shapesContainer, 0, [], !0), this.filterUniqueShapes(), this.shapeCont = t1;
        }, HShapeElement.prototype.getTransformedPoint = function(t1, e1) {
            var r1, i1 = t1.length;
            for(r1 = 0; r1 < i1; r1 += 1)e1 = t1[r1].mProps.v.applyToPointArray(e1[0], e1[1], 0);
            return e1;
        }, HShapeElement.prototype.calculateShapeBoundingBox = function(t1, e1) {
            var r1, i1, s1, a1, n1, o1 = t1.sh.v, h1 = t1.transformers, l1 = o1._length;
            if (!(l1 <= 1)) {
                for(r1 = 0; r1 < l1 - 1; r1 += 1)i1 = this.getTransformedPoint(h1, o1.v[r1]), s1 = this.getTransformedPoint(h1, o1.o[r1]), a1 = this.getTransformedPoint(h1, o1.i[r1 + 1]), n1 = this.getTransformedPoint(h1, o1.v[r1 + 1]), this.checkBounds(i1, s1, a1, n1, e1);
                o1.c && (i1 = this.getTransformedPoint(h1, o1.v[r1]), s1 = this.getTransformedPoint(h1, o1.o[r1]), a1 = this.getTransformedPoint(h1, o1.i[0]), n1 = this.getTransformedPoint(h1, o1.v[0]), this.checkBounds(i1, s1, a1, n1, e1));
            }
        }, HShapeElement.prototype.checkBounds = function(t1, e1, r1, i1, s1) {
            this.getBoundsOfCurve(t1, e1, r1, i1);
            var a1 = this.shapeBoundingBox;
            s1.x = bmMin(a1.left, s1.x), s1.xMax = bmMax(a1.right, s1.xMax), s1.y = bmMin(a1.top, s1.y), s1.yMax = bmMax(a1.bottom, s1.yMax);
        }, HShapeElement.prototype.shapeBoundingBox = {
            left: 0,
            right: 0,
            top: 0,
            bottom: 0
        }, HShapeElement.prototype.tempBoundingBox = {
            x: 0,
            xMax: 0,
            y: 0,
            yMax: 0,
            width: 0,
            height: 0
        }, HShapeElement.prototype.getBoundsOfCurve = function(t1, e1, r1, i1) {
            for(var s1, a1, n1, o1, h1, l1, p1, c1 = [
                [
                    t1[0],
                    i1[0]
                ],
                [
                    t1[1],
                    i1[1]
                ]
            ], f1 = 0; f1 < 2; ++f1)a1 = 6 * t1[f1] - 12 * e1[f1] + 6 * r1[f1], s1 = -3 * t1[f1] + 9 * e1[f1] - 9 * r1[f1] + 3 * i1[f1], n1 = 3 * e1[f1] - 3 * t1[f1], a1 |= 0, n1 |= 0, 0 == (s1 |= 0) && 0 === a1 || (0 === s1 ? (o1 = -n1 / a1) > 0 && o1 < 1 && c1[f1].push(this.calculateF(o1, t1, e1, r1, i1, f1)) : (h1 = a1 * a1 - 4 * n1 * s1) >= 0 && ((l1 = (-a1 + bmSqrt(h1)) / (2 * s1)) > 0 && l1 < 1 && c1[f1].push(this.calculateF(l1, t1, e1, r1, i1, f1)), (p1 = (-a1 - bmSqrt(h1)) / (2 * s1)) > 0 && p1 < 1 && c1[f1].push(this.calculateF(p1, t1, e1, r1, i1, f1))));
            this.shapeBoundingBox.left = bmMin.apply(null, c1[0]), this.shapeBoundingBox.top = bmMin.apply(null, c1[1]), this.shapeBoundingBox.right = bmMax.apply(null, c1[0]), this.shapeBoundingBox.bottom = bmMax.apply(null, c1[1]);
        }, HShapeElement.prototype.calculateF = function(t1, e1, r1, i1, s1, a1) {
            return bmPow(1 - t1, 3) * e1[a1] + 3 * bmPow(1 - t1, 2) * t1 * r1[a1] + 3 * (1 - t1) * bmPow(t1, 2) * i1[a1] + bmPow(t1, 3) * s1[a1];
        }, HShapeElement.prototype.calculateBoundingBox = function(t1, e1) {
            var r1, i1 = t1.length;
            for(r1 = 0; r1 < i1; r1 += 1)t1[r1] && t1[r1].sh ? this.calculateShapeBoundingBox(t1[r1], e1) : t1[r1] && t1[r1].it ? this.calculateBoundingBox(t1[r1].it, e1) : t1[r1] && t1[r1].style && t1[r1].w && this.expandStrokeBoundingBox(t1[r1].w, e1);
        }, HShapeElement.prototype.expandStrokeBoundingBox = function(t1, e1) {
            var r1 = 0;
            if (t1.keyframes) {
                for(var i1 = 0; i1 < t1.keyframes.length; i1 += 1){
                    var s1 = t1.keyframes[i1].s;
                    s1 > r1 && (r1 = s1);
                }
                r1 *= t1.mult;
            } else r1 = t1.v * t1.mult;
            e1.x -= r1, e1.xMax += r1, e1.y -= r1, e1.yMax += r1;
        }, HShapeElement.prototype.currentBoxContains = function(t1) {
            return this.currentBBox.x <= t1.x && this.currentBBox.y <= t1.y && this.currentBBox.width + this.currentBBox.x >= t1.x + t1.width && this.currentBBox.height + this.currentBBox.y >= t1.y + t1.height;
        }, HShapeElement.prototype.renderInnerContent = function() {
            if (this._renderShapeFrame(), !this.hidden && (this._isFirstFrame || this._mdf)) {
                var t1 = this.tempBoundingBox, e1 = 999999;
                if (t1.x = e1, t1.xMax = -e1, t1.y = e1, t1.yMax = -e1, this.calculateBoundingBox(this.itemsData, t1), t1.width = t1.xMax < t1.x ? 0 : t1.xMax - t1.x, t1.height = t1.yMax < t1.y ? 0 : t1.yMax - t1.y, this.currentBoxContains(t1)) return;
                var r1 = !1;
                if (this.currentBBox.w !== t1.width && (this.currentBBox.w = t1.width, this.shapeCont.setAttribute("width", t1.width), r1 = !0), this.currentBBox.h !== t1.height && (this.currentBBox.h = t1.height, this.shapeCont.setAttribute("height", t1.height), r1 = !0), r1 || this.currentBBox.x !== t1.x || this.currentBBox.y !== t1.y) {
                    this.currentBBox.w = t1.width, this.currentBBox.h = t1.height, this.currentBBox.x = t1.x, this.currentBBox.y = t1.y, this.shapeCont.setAttribute("viewBox", this.currentBBox.x + " " + this.currentBBox.y + " " + this.currentBBox.w + " " + this.currentBBox.h);
                    var i1 = this.shapeCont.style, s1 = "translate(" + this.currentBBox.x + "px," + this.currentBBox.y + "px)";
                    i1.transform = s1, i1.webkitTransform = s1;
                }
            }
        }, extendPrototype([
            BaseElement,
            TransformElement,
            HBaseElement,
            HierarchyElement,
            FrameElement,
            RenderableDOMElement,
            ITextElement
        ], HTextElement), HTextElement.prototype.createContent = function() {
            if (this.isMasked = this.checkMasks(), this.isMasked) {
                this.renderType = "svg", this.compW = this.comp.data.w, this.compH = this.comp.data.h, this.svgElement.setAttribute("width", this.compW), this.svgElement.setAttribute("height", this.compH);
                var t1 = createNS("g");
                this.maskedElement.appendChild(t1), this.innerElem = t1;
            } else this.renderType = "html", this.innerElem = this.layerElement;
            this.checkParenting();
        }, HTextElement.prototype.buildNewText = function() {
            var t1 = this.textProperty.currentData;
            this.renderedLetters = createSizedArray(t1.l ? t1.l.length : 0);
            var e1 = this.innerElem.style, r1 = t1.fc ? this.buildColor(t1.fc) : "rgba(0,0,0,0)";
            e1.fill = r1, e1.color = r1, t1.sc && (e1.stroke = this.buildColor(t1.sc), e1.strokeWidth = t1.sw + "px");
            var i1, s1, a1 = this.globalData.fontManager.getFontByName(t1.f);
            if (!this.globalData.fontManager.chars) {
                if (e1.fontSize = t1.finalSize + "px", e1.lineHeight = t1.finalSize + "px", a1.fClass) this.innerElem.className = a1.fClass;
                else {
                    e1.fontFamily = a1.fFamily;
                    var n1 = t1.fWeight, o1 = t1.fStyle;
                    e1.fontStyle = o1, e1.fontWeight = n1;
                }
            }
            var h1, l1, p1, c1 = t1.l;
            s1 = c1.length;
            var f1, d1 = this.mHelper, u1 = "", m1 = 0;
            for(i1 = 0; i1 < s1; i1 += 1){
                if (this.globalData.fontManager.chars ? (this.textPaths[m1] ? h1 = this.textPaths[m1] : ((h1 = createNS("path")).setAttribute("stroke-linecap", lineCapEnum[1]), h1.setAttribute("stroke-linejoin", lineJoinEnum[2]), h1.setAttribute("stroke-miterlimit", "4")), this.isMasked || (this.textSpans[m1] ? p1 = (l1 = this.textSpans[m1]).children[0] : ((l1 = createTag("div")).style.lineHeight = 0, (p1 = createNS("svg")).appendChild(h1), styleDiv(l1)))) : this.isMasked ? h1 = this.textPaths[m1] ? this.textPaths[m1] : createNS("text") : this.textSpans[m1] ? (l1 = this.textSpans[m1], h1 = this.textPaths[m1]) : (styleDiv(l1 = createTag("span")), styleDiv(h1 = createTag("span")), l1.appendChild(h1)), this.globalData.fontManager.chars) {
                    var y1, g1 = this.globalData.fontManager.getCharData(t1.finalText[i1], a1.fStyle, this.globalData.fontManager.getFontByName(t1.f).fFamily);
                    if (y1 = g1 ? g1.data : null, d1.reset(), y1 && y1.shapes && y1.shapes.length && (f1 = y1.shapes[0].it, d1.scale(t1.finalSize / 100, t1.finalSize / 100), u1 = this.createPathShape(d1, f1), h1.setAttribute("d", u1)), this.isMasked) this.innerElem.appendChild(h1);
                    else {
                        if (this.innerElem.appendChild(l1), y1 && y1.shapes) {
                            document.body.appendChild(p1);
                            var v1 = p1.getBBox();
                            p1.setAttribute("width", v1.width + 2), p1.setAttribute("height", v1.height + 2), p1.setAttribute("viewBox", v1.x - 1 + " " + (v1.y - 1) + " " + (v1.width + 2) + " " + (v1.height + 2));
                            var b1 = p1.style, _1 = "translate(" + (v1.x - 1) + "px," + (v1.y - 1) + "px)";
                            b1.transform = _1, b1.webkitTransform = _1, c1[i1].yOffset = v1.y - 1;
                        } else p1.setAttribute("width", 1), p1.setAttribute("height", 1);
                        l1.appendChild(p1);
                    }
                } else if (h1.textContent = c1[i1].val, h1.setAttributeNS("http://www.w3.org/XML/1998/namespace", "xml:space", "preserve"), this.isMasked) this.innerElem.appendChild(h1);
                else {
                    this.innerElem.appendChild(l1);
                    var P1 = h1.style, E1 = "translate3d(0," + -t1.finalSize / 1.2 + "px,0)";
                    P1.transform = E1, P1.webkitTransform = E1;
                }
                this.isMasked ? this.textSpans[m1] = h1 : this.textSpans[m1] = l1, this.textSpans[m1].style.display = "block", this.textPaths[m1] = h1, m1 += 1;
            }
            for(; m1 < this.textSpans.length;)this.textSpans[m1].style.display = "none", m1 += 1;
        }, HTextElement.prototype.renderInnerContent = function() {
            var t1;
            if (this.data.singleShape) {
                if (!this._isFirstFrame && !this.lettersChangedFlag) return;
                if (this.isMasked && this.finalTransform._matMdf) {
                    this.svgElement.setAttribute("viewBox", -this.finalTransform.mProp.p.v[0] + " " + -this.finalTransform.mProp.p.v[1] + " " + this.compW + " " + this.compH), t1 = this.svgElement.style;
                    var e1 = "translate(" + -this.finalTransform.mProp.p.v[0] + "px," + -this.finalTransform.mProp.p.v[1] + "px)";
                    t1.transform = e1, t1.webkitTransform = e1;
                }
            }
            if (this.textAnimator.getMeasures(this.textProperty.currentData, this.lettersChangedFlag), this.lettersChangedFlag || this.textAnimator.lettersChangedFlag) {
                var r1, i1, s1, a1, n1, o1 = 0, h1 = this.textAnimator.renderedLetters, l1 = this.textProperty.currentData.l;
                for(i1 = l1.length, r1 = 0; r1 < i1; r1 += 1)l1[r1].n ? o1 += 1 : (a1 = this.textSpans[r1], n1 = this.textPaths[r1], s1 = h1[o1], o1 += 1, s1._mdf.m && (this.isMasked ? a1.setAttribute("transform", s1.m) : (a1.style.webkitTransform = s1.m, a1.style.transform = s1.m)), a1.style.opacity = s1.o, s1.sw && s1._mdf.sw && n1.setAttribute("stroke-width", s1.sw), s1.sc && s1._mdf.sc && n1.setAttribute("stroke", s1.sc), s1.fc && s1._mdf.fc && (n1.setAttribute("fill", s1.fc), n1.style.color = s1.fc));
                if (this.innerElem.getBBox && !this.hidden && (this._isFirstFrame || this._mdf)) {
                    var p1 = this.innerElem.getBBox();
                    if (this.currentBBox.w !== p1.width && (this.currentBBox.w = p1.width, this.svgElement.setAttribute("width", p1.width)), this.currentBBox.h !== p1.height && (this.currentBBox.h = p1.height, this.svgElement.setAttribute("height", p1.height)), this.currentBBox.w !== p1.width + 2 || this.currentBBox.h !== p1.height + 2 || this.currentBBox.x !== p1.x - 1 || this.currentBBox.y !== p1.y - 1) {
                        this.currentBBox.w = p1.width + 2, this.currentBBox.h = p1.height + 2, this.currentBBox.x = p1.x - 1, this.currentBBox.y = p1.y - 1, this.svgElement.setAttribute("viewBox", this.currentBBox.x + " " + this.currentBBox.y + " " + this.currentBBox.w + " " + this.currentBBox.h), t1 = this.svgElement.style;
                        var c1 = "translate(" + this.currentBBox.x + "px," + this.currentBBox.y + "px)";
                        t1.transform = c1, t1.webkitTransform = c1;
                    }
                }
            }
        }, extendPrototype([
            BaseElement,
            FrameElement,
            HierarchyElement
        ], HCameraElement), HCameraElement.prototype.setup = function() {
            var t1, e1, r1, i1, s1 = this.comp.threeDElements.length;
            for(t1 = 0; t1 < s1; t1 += 1)if ("3d" === (e1 = this.comp.threeDElements[t1]).type) {
                r1 = e1.perspectiveElem.style, i1 = e1.container.style;
                var a1 = this.pe.v + "px", n1 = "0px 0px 0px", o1 = "matrix3d(1,0,0,0,0,1,0,0,0,0,1,0,0,0,0,1)";
                r1.perspective = a1, r1.webkitPerspective = a1, i1.transformOrigin = n1, i1.mozTransformOrigin = n1, i1.webkitTransformOrigin = n1, r1.transform = o1, r1.webkitTransform = o1;
            }
        }, HCameraElement.prototype.createElements = function() {}, HCameraElement.prototype.hide = function() {}, HCameraElement.prototype.renderFrame = function() {
            var t1, e1, r1 = this._isFirstFrame;
            if (this.hierarchy) for(e1 = this.hierarchy.length, t1 = 0; t1 < e1; t1 += 1)r1 = this.hierarchy[t1].finalTransform.mProp._mdf || r1;
            if (r1 || this.pe._mdf || this.p && this.p._mdf || this.px && (this.px._mdf || this.py._mdf || this.pz._mdf) || this.rx._mdf || this.ry._mdf || this.rz._mdf || this.or._mdf || this.a && this.a._mdf) {
                if (this.mat.reset(), this.hierarchy) for(t1 = e1 = this.hierarchy.length - 1; t1 >= 0; t1 -= 1){
                    var i1 = this.hierarchy[t1].finalTransform.mProp;
                    this.mat.translate(-i1.p.v[0], -i1.p.v[1], i1.p.v[2]), this.mat.rotateX(-i1.or.v[0]).rotateY(-i1.or.v[1]).rotateZ(i1.or.v[2]), this.mat.rotateX(-i1.rx.v).rotateY(-i1.ry.v).rotateZ(i1.rz.v), this.mat.scale(1 / i1.s.v[0], 1 / i1.s.v[1], 1 / i1.s.v[2]), this.mat.translate(i1.a.v[0], i1.a.v[1], i1.a.v[2]);
                }
                if (this.p ? this.mat.translate(-this.p.v[0], -this.p.v[1], this.p.v[2]) : this.mat.translate(-this.px.v, -this.py.v, this.pz.v), this.a) {
                    var s1;
                    s1 = this.p ? [
                        this.p.v[0] - this.a.v[0],
                        this.p.v[1] - this.a.v[1],
                        this.p.v[2] - this.a.v[2]
                    ] : [
                        this.px.v - this.a.v[0],
                        this.py.v - this.a.v[1],
                        this.pz.v - this.a.v[2]
                    ];
                    var a1 = Math.sqrt(Math.pow(s1[0], 2) + Math.pow(s1[1], 2) + Math.pow(s1[2], 2)), n1 = [
                        s1[0] / a1,
                        s1[1] / a1,
                        s1[2] / a1
                    ], o1 = Math.sqrt(n1[2] * n1[2] + n1[0] * n1[0]), h1 = Math.atan2(n1[1], o1), l1 = Math.atan2(n1[0], -n1[2]);
                    this.mat.rotateY(l1).rotateX(-h1);
                }
                this.mat.rotateX(-this.rx.v).rotateY(-this.ry.v).rotateZ(this.rz.v), this.mat.rotateX(-this.or.v[0]).rotateY(-this.or.v[1]).rotateZ(this.or.v[2]), this.mat.translate(this.globalData.compSize.w / 2, this.globalData.compSize.h / 2, 0), this.mat.translate(0, 0, this.pe.v);
                var p1 = !this._prevMat.equals(this.mat);
                if ((p1 || this.pe._mdf) && this.comp.threeDElements) {
                    var c1, f1, d1;
                    for(e1 = this.comp.threeDElements.length, t1 = 0; t1 < e1; t1 += 1)if ("3d" === (c1 = this.comp.threeDElements[t1]).type) {
                        if (p1) {
                            var u1 = this.mat.toCSS();
                            (d1 = c1.container.style).transform = u1, d1.webkitTransform = u1;
                        }
                        this.pe._mdf && ((f1 = c1.perspectiveElem.style).perspective = this.pe.v + "px", f1.webkitPerspective = this.pe.v + "px");
                    }
                    this.mat.clone(this._prevMat);
                }
            }
            this._isFirstFrame = !1;
        }, HCameraElement.prototype.prepareFrame = function(t1) {
            this.prepareProperties(t1, !0);
        }, HCameraElement.prototype.destroy = function() {}, HCameraElement.prototype.getBaseElement = function() {
            return null;
        }, extendPrototype([
            BaseElement,
            TransformElement,
            HBaseElement,
            HSolidElement,
            HierarchyElement,
            FrameElement,
            RenderableElement
        ], HImageElement), HImageElement.prototype.createContent = function() {
            var t1 = this.globalData.getAssetsPath(this.assetData), e1 = new Image;
            this.data.hasMask ? (this.imageElem = createNS("image"), this.imageElem.setAttribute("width", this.assetData.w + "px"), this.imageElem.setAttribute("height", this.assetData.h + "px"), this.imageElem.setAttributeNS("http://www.w3.org/1999/xlink", "href", t1), this.layerElement.appendChild(this.imageElem), this.baseElement.setAttribute("width", this.assetData.w), this.baseElement.setAttribute("height", this.assetData.h)) : this.layerElement.appendChild(e1), e1.crossOrigin = "anonymous", e1.src = t1, this.data.ln && this.baseElement.setAttribute("id", this.data.ln);
        }, extendPrototype([
            BaseRenderer
        ], HybridRendererBase), HybridRendererBase.prototype.buildItem = SVGRenderer.prototype.buildItem, HybridRendererBase.prototype.checkPendingElements = function() {
            for(; this.pendingElements.length;)this.pendingElements.pop().checkParenting();
        }, HybridRendererBase.prototype.appendElementInPos = function(t1, e1) {
            var r1 = t1.getBaseElement();
            if (r1) {
                var i1 = this.layers[e1];
                if (i1.ddd && this.supports3d) this.addTo3dContainer(r1, e1);
                else if (this.threeDElements) this.addTo3dContainer(r1, e1);
                else {
                    for(var s1, a1, n1 = 0; n1 < e1;)this.elements[n1] && !0 !== this.elements[n1] && this.elements[n1].getBaseElement && (a1 = this.elements[n1], s1 = (this.layers[n1].ddd ? this.getThreeDContainerByPos(n1) : a1.getBaseElement()) || s1), n1 += 1;
                    s1 ? i1.ddd && this.supports3d || this.layerElement.insertBefore(r1, s1) : i1.ddd && this.supports3d || this.layerElement.appendChild(r1);
                }
            }
        }, HybridRendererBase.prototype.createShape = function(t1) {
            return this.supports3d ? new HShapeElement(t1, this.globalData, this) : new SVGShapeElement(t1, this.globalData, this);
        }, HybridRendererBase.prototype.createText = function(t1) {
            return this.supports3d ? new HTextElement(t1, this.globalData, this) : new SVGTextLottieElement(t1, this.globalData, this);
        }, HybridRendererBase.prototype.createCamera = function(t1) {
            return this.camera = new HCameraElement(t1, this.globalData, this), this.camera;
        }, HybridRendererBase.prototype.createImage = function(t1) {
            return this.supports3d ? new HImageElement(t1, this.globalData, this) : new IImageElement(t1, this.globalData, this);
        }, HybridRendererBase.prototype.createSolid = function(t1) {
            return this.supports3d ? new HSolidElement(t1, this.globalData, this) : new ISolidElement(t1, this.globalData, this);
        }, HybridRendererBase.prototype.createNull = SVGRenderer.prototype.createNull, HybridRendererBase.prototype.getThreeDContainerByPos = function(t1) {
            for(var e1 = 0, r1 = this.threeDElements.length; e1 < r1;){
                if (this.threeDElements[e1].startPos <= t1 && this.threeDElements[e1].endPos >= t1) return this.threeDElements[e1].perspectiveElem;
                e1 += 1;
            }
            return null;
        }, HybridRendererBase.prototype.createThreeDContainer = function(t1, e1) {
            var r1, i1, s1 = createTag("div");
            styleDiv(s1);
            var a1 = createTag("div");
            if (styleDiv(a1), "3d" === e1) {
                (r1 = s1.style).width = this.globalData.compSize.w + "px", r1.height = this.globalData.compSize.h + "px";
                var n1 = "50% 50%";
                r1.webkitTransformOrigin = n1, r1.mozTransformOrigin = n1, r1.transformOrigin = n1;
                var o1 = "matrix3d(1,0,0,0,0,1,0,0,0,0,1,0,0,0,0,1)";
                (i1 = a1.style).transform = o1, i1.webkitTransform = o1;
            }
            s1.appendChild(a1);
            var h1 = {
                container: a1,
                perspectiveElem: s1,
                startPos: t1,
                endPos: t1,
                type: e1
            };
            return this.threeDElements.push(h1), h1;
        }, HybridRendererBase.prototype.build3dContainers = function() {
            var t1, e1, r1 = this.layers.length, i1 = "";
            for(t1 = 0; t1 < r1; t1 += 1)this.layers[t1].ddd && 3 !== this.layers[t1].ty ? ("3d" !== i1 && (i1 = "3d", e1 = this.createThreeDContainer(t1, "3d")), e1.endPos = Math.max(e1.endPos, t1)) : ("2d" !== i1 && (i1 = "2d", e1 = this.createThreeDContainer(t1, "2d")), e1.endPos = Math.max(e1.endPos, t1));
            for(t1 = (r1 = this.threeDElements.length) - 1; t1 >= 0; t1 -= 1)this.resizerElem.appendChild(this.threeDElements[t1].perspectiveElem);
        }, HybridRendererBase.prototype.addTo3dContainer = function(t1, e1) {
            for(var r1 = 0, i1 = this.threeDElements.length; r1 < i1;){
                if (e1 <= this.threeDElements[r1].endPos) {
                    for(var s1, a1 = this.threeDElements[r1].startPos; a1 < e1;)this.elements[a1] && this.elements[a1].getBaseElement && (s1 = this.elements[a1].getBaseElement()), a1 += 1;
                    s1 ? this.threeDElements[r1].container.insertBefore(t1, s1) : this.threeDElements[r1].container.appendChild(t1);
                    break;
                }
                r1 += 1;
            }
        }, HybridRendererBase.prototype.configAnimation = function(t1) {
            var e1 = createTag("div"), r1 = this.animationItem.wrapper, i1 = e1.style;
            i1.width = t1.w + "px", i1.height = t1.h + "px", this.resizerElem = e1, styleDiv(e1), i1.transformStyle = "flat", i1.mozTransformStyle = "flat", i1.webkitTransformStyle = "flat", this.renderConfig.className && e1.setAttribute("class", this.renderConfig.className), r1.appendChild(e1), i1.overflow = "hidden";
            var s1 = createNS("svg");
            s1.setAttribute("width", "1"), s1.setAttribute("height", "1"), styleDiv(s1), this.resizerElem.appendChild(s1);
            var a1 = createNS("defs");
            s1.appendChild(a1), this.data = t1, this.setupGlobalData(t1, s1), this.globalData.defs = a1, this.layers = t1.layers, this.layerElement = this.resizerElem, this.build3dContainers(), this.updateContainerSize();
        }, HybridRendererBase.prototype.destroy = function() {
            var t1;
            this.animationItem.wrapper && (this.animationItem.wrapper.innerText = ""), this.animationItem.container = null, this.globalData.defs = null;
            var e1 = this.layers ? this.layers.length : 0;
            for(t1 = 0; t1 < e1; t1 += 1)this.elements[t1].destroy();
            this.elements.length = 0, this.destroyed = !0, this.animationItem = null;
        }, HybridRendererBase.prototype.updateContainerSize = function() {
            var t1, e1, r1, i1, s1 = this.animationItem.wrapper.offsetWidth, a1 = this.animationItem.wrapper.offsetHeight, n1 = s1 / a1;
            this.globalData.compSize.w / this.globalData.compSize.h > n1 ? (t1 = s1 / this.globalData.compSize.w, e1 = s1 / this.globalData.compSize.w, r1 = 0, i1 = (a1 - this.globalData.compSize.h * (s1 / this.globalData.compSize.w)) / 2) : (t1 = a1 / this.globalData.compSize.h, e1 = a1 / this.globalData.compSize.h, r1 = (s1 - this.globalData.compSize.w * (a1 / this.globalData.compSize.h)) / 2, i1 = 0);
            var o1 = this.resizerElem.style;
            o1.webkitTransform = "matrix3d(" + t1 + ",0,0,0,0," + e1 + ",0,0,0,0,1,0," + r1 + "," + i1 + ",0,1)", o1.transform = o1.webkitTransform;
        }, HybridRendererBase.prototype.renderFrame = SVGRenderer.prototype.renderFrame, HybridRendererBase.prototype.hide = function() {
            this.resizerElem.style.display = "none";
        }, HybridRendererBase.prototype.show = function() {
            this.resizerElem.style.display = "block";
        }, HybridRendererBase.prototype.initItems = function() {
            if (this.buildAllItems(), this.camera) this.camera.setup();
            else {
                var t1, e1 = this.globalData.compSize.w, r1 = this.globalData.compSize.h, i1 = this.threeDElements.length;
                for(t1 = 0; t1 < i1; t1 += 1){
                    var s1 = this.threeDElements[t1].perspectiveElem.style;
                    s1.webkitPerspective = Math.sqrt(Math.pow(e1, 2) + Math.pow(r1, 2)) + "px", s1.perspective = s1.webkitPerspective;
                }
            }
        }, HybridRendererBase.prototype.searchExtraCompositions = function(t1) {
            var e1, r1 = t1.length, i1 = createTag("div");
            for(e1 = 0; e1 < r1; e1 += 1)if (t1[e1].xt) {
                var s1 = this.createComp(t1[e1], i1, this.globalData.comp, null);
                s1.initExpressions(), this.globalData.projectInterface.registerComposition(s1);
            }
        }, extendPrototype([
            HybridRendererBase,
            ICompElement,
            HBaseElement
        ], HCompElement), HCompElement.prototype._createBaseContainerElements = HCompElement.prototype.createContainerElements, HCompElement.prototype.createContainerElements = function() {
            this._createBaseContainerElements(), this.data.hasMask ? (this.svgElement.setAttribute("width", this.data.w), this.svgElement.setAttribute("height", this.data.h), this.transformedElement = this.baseElement) : this.transformedElement = this.layerElement;
        }, HCompElement.prototype.addTo3dContainer = function(t1, e1) {
            for(var r1, i1 = 0; i1 < e1;)this.elements[i1] && this.elements[i1].getBaseElement && (r1 = this.elements[i1].getBaseElement()), i1 += 1;
            r1 ? this.layerElement.insertBefore(t1, r1) : this.layerElement.appendChild(t1);
        }, HCompElement.prototype.createComp = function(t1) {
            return this.supports3d ? new HCompElement(t1, this.globalData, this) : new SVGCompElement(t1, this.globalData, this);
        }, extendPrototype([
            HybridRendererBase
        ], HybridRenderer), HybridRenderer.prototype.createComp = function(t1) {
            return this.supports3d ? new HCompElement(t1, this.globalData, this) : new SVGCompElement(t1, this.globalData, this);
        };
        var CompExpressionInterface = function(t1) {
            function e1(e1) {
                for(var r1 = 0, i1 = t1.layers.length; r1 < i1;){
                    if (t1.layers[r1].nm === e1 || t1.layers[r1].ind === e1) return t1.elements[r1].layerInterface;
                    r1 += 1;
                }
                return null;
            }
            return Object.defineProperty(e1, "_name", {
                value: t1.data.nm
            }), e1.layer = e1, e1.pixelAspect = 1, e1.height = t1.data.h || t1.globalData.compSize.h, e1.width = t1.data.w || t1.globalData.compSize.w, e1.pixelAspect = 1, e1.frameDuration = 1 / t1.globalData.frameRate, e1.displayStartTime = 0, e1.numLayers = t1.layers.length, e1;
        }, Expressions = function() {
            var t1 = {
                initExpressions: function(t1) {
                    var e1 = 0, r1 = [];
                    t1.renderer.compInterface = CompExpressionInterface(t1.renderer), t1.renderer.globalData.projectInterface.registerComposition(t1.renderer), t1.renderer.globalData.pushExpression = function() {
                        e1 += 1;
                    }, t1.renderer.globalData.popExpression = function() {
                        0 == (e1 -= 1) && function() {
                            var t1, e1 = r1.length;
                            for(t1 = 0; t1 < e1; t1 += 1)r1[t1].release();
                            r1.length = 0;
                        }();
                    }, t1.renderer.globalData.registerExpressionProperty = function(t1) {
                        -1 === r1.indexOf(t1) && r1.push(t1);
                    };
                }
            };
            return t1;
        }(), MaskManagerInterface = function() {
            function t1(t1, e1) {
                this._mask = t1, this._data = e1;
            }
            return Object.defineProperty(t1.prototype, "maskPath", {
                get: function() {
                    return this._mask.prop.k && this._mask.prop.getValue(), this._mask.prop;
                }
            }), Object.defineProperty(t1.prototype, "maskOpacity", {
                get: function() {
                    return this._mask.op.k && this._mask.op.getValue(), 100 * this._mask.op.v;
                }
            }), function(e1) {
                var r1, i1 = createSizedArray(e1.viewData.length), s1 = e1.viewData.length;
                for(r1 = 0; r1 < s1; r1 += 1)i1[r1] = new t1(e1.viewData[r1], e1.masksProperties[r1]);
                return function(t1) {
                    for(r1 = 0; r1 < s1;){
                        if (e1.masksProperties[r1].nm === t1) return i1[r1];
                        r1 += 1;
                    }
                    return null;
                };
            };
        }(), ExpressionPropertyInterface = function() {
            var t1 = {
                pv: 0,
                v: 0,
                mult: 1
            }, e1 = {
                pv: [
                    0,
                    0,
                    0
                ],
                v: [
                    0,
                    0,
                    0
                ],
                mult: 1
            };
            function r1(t1, e1, r1) {
                Object.defineProperty(t1, "velocity", {
                    get: function() {
                        return e1.getVelocityAtTime(e1.comp.currentFrame);
                    }
                }), t1.numKeys = e1.keyframes ? e1.keyframes.length : 0, t1.key = function(i1) {
                    if (!t1.numKeys) return 0;
                    var s1 = "";
                    s1 = "s" in e1.keyframes[i1 - 1] ? e1.keyframes[i1 - 1].s : "e" in e1.keyframes[i1 - 2] ? e1.keyframes[i1 - 2].e : e1.keyframes[i1 - 2].s;
                    var a1 = "unidimensional" === r1 ? new Number(s1) : Object.assign({}, s1);
                    return a1.time = e1.keyframes[i1 - 1].t / e1.elem.comp.globalData.frameRate, a1.value = "unidimensional" === r1 ? s1[0] : s1, a1;
                }, t1.valueAtTime = e1.getValueAtTime, t1.speedAtTime = e1.getSpeedAtTime, t1.velocityAtTime = e1.getVelocityAtTime, t1.propertyGroup = e1.propertyGroup;
            }
            function i1() {
                return t1;
            }
            return function(s1) {
                return s1 ? "unidimensional" === s1.propType ? function(e1) {
                    e1 && "pv" in e1 || (e1 = t1);
                    var i1 = 1 / e1.mult, s1 = e1.pv * i1, a1 = new Number(s1);
                    return a1.value = s1, r1(a1, e1, "unidimensional"), function() {
                        return e1.k && e1.getValue(), s1 = e1.v * i1, a1.value !== s1 && ((a1 = new Number(s1)).value = s1, r1(a1, e1, "unidimensional")), a1;
                    };
                }(s1) : function(t1) {
                    t1 && "pv" in t1 || (t1 = e1);
                    var i1 = 1 / t1.mult, s1 = t1.data && t1.data.l || t1.pv.length, a1 = createTypedArray("float32", s1), n1 = createTypedArray("float32", s1);
                    return a1.value = n1, r1(a1, t1, "multidimensional"), function() {
                        t1.k && t1.getValue();
                        for(var e1 = 0; e1 < s1; e1 += 1)n1[e1] = t1.v[e1] * i1, a1[e1] = n1[e1];
                        return a1;
                    };
                }(s1) : i1;
            };
        }(), TransformExpressionInterface = function(t1) {
            function e1(t1) {
                switch(t1){
                    case "scale":
                    case "Scale":
                    case "ADBE Scale":
                    case 6:
                        return e1.scale;
                    case "rotation":
                    case "Rotation":
                    case "ADBE Rotation":
                    case "ADBE Rotate Z":
                    case 10:
                        return e1.rotation;
                    case "ADBE Rotate X":
                        return e1.xRotation;
                    case "ADBE Rotate Y":
                        return e1.yRotation;
                    case "position":
                    case "Position":
                    case "ADBE Position":
                    case 2:
                        return e1.position;
                    case "ADBE Position_0":
                        return e1.xPosition;
                    case "ADBE Position_1":
                        return e1.yPosition;
                    case "ADBE Position_2":
                        return e1.zPosition;
                    case "anchorPoint":
                    case "AnchorPoint":
                    case "Anchor Point":
                    case "ADBE AnchorPoint":
                    case 1:
                        return e1.anchorPoint;
                    case "opacity":
                    case "Opacity":
                    case 11:
                        return e1.opacity;
                    default:
                        return null;
                }
            }
            var r1, i1, s1, a1;
            return Object.defineProperty(e1, "rotation", {
                get: ExpressionPropertyInterface(t1.r || t1.rz)
            }), Object.defineProperty(e1, "zRotation", {
                get: ExpressionPropertyInterface(t1.rz || t1.r)
            }), Object.defineProperty(e1, "xRotation", {
                get: ExpressionPropertyInterface(t1.rx)
            }), Object.defineProperty(e1, "yRotation", {
                get: ExpressionPropertyInterface(t1.ry)
            }), Object.defineProperty(e1, "scale", {
                get: ExpressionPropertyInterface(t1.s)
            }), t1.p ? a1 = ExpressionPropertyInterface(t1.p) : (r1 = ExpressionPropertyInterface(t1.px), i1 = ExpressionPropertyInterface(t1.py), t1.pz && (s1 = ExpressionPropertyInterface(t1.pz))), Object.defineProperty(e1, "position", {
                get: function() {
                    return t1.p ? a1() : [
                        r1(),
                        i1(),
                        s1 ? s1() : 0
                    ];
                }
            }), Object.defineProperty(e1, "xPosition", {
                get: ExpressionPropertyInterface(t1.px)
            }), Object.defineProperty(e1, "yPosition", {
                get: ExpressionPropertyInterface(t1.py)
            }), Object.defineProperty(e1, "zPosition", {
                get: ExpressionPropertyInterface(t1.pz)
            }), Object.defineProperty(e1, "anchorPoint", {
                get: ExpressionPropertyInterface(t1.a)
            }), Object.defineProperty(e1, "opacity", {
                get: ExpressionPropertyInterface(t1.o)
            }), Object.defineProperty(e1, "skew", {
                get: ExpressionPropertyInterface(t1.sk)
            }), Object.defineProperty(e1, "skewAxis", {
                get: ExpressionPropertyInterface(t1.sa)
            }), Object.defineProperty(e1, "orientation", {
                get: ExpressionPropertyInterface(t1.or)
            }), e1;
        }, LayerExpressionInterface = function() {
            function t1(t1) {
                var e1 = new Matrix;
                return void 0 !== t1 ? this._elem.finalTransform.mProp.getValueAtTime(t1).clone(e1) : this._elem.finalTransform.mProp.applyToMatrix(e1), e1;
            }
            function e1(t1, e1) {
                var r1 = this.getMatrix(e1);
                return r1.props[12] = 0, r1.props[13] = 0, r1.props[14] = 0, this.applyPoint(r1, t1);
            }
            function r1(t1, e1) {
                var r1 = this.getMatrix(e1);
                return this.applyPoint(r1, t1);
            }
            function i1(t1, e1) {
                var r1 = this.getMatrix(e1);
                return r1.props[12] = 0, r1.props[13] = 0, r1.props[14] = 0, this.invertPoint(r1, t1);
            }
            function s1(t1, e1) {
                var r1 = this.getMatrix(e1);
                return this.invertPoint(r1, t1);
            }
            function a1(t1, e1) {
                if (this._elem.hierarchy && this._elem.hierarchy.length) {
                    var r1, i1 = this._elem.hierarchy.length;
                    for(r1 = 0; r1 < i1; r1 += 1)this._elem.hierarchy[r1].finalTransform.mProp.applyToMatrix(t1);
                }
                return t1.applyToPointArray(e1[0], e1[1], e1[2] || 0);
            }
            function n1(t1, e1) {
                if (this._elem.hierarchy && this._elem.hierarchy.length) {
                    var r1, i1 = this._elem.hierarchy.length;
                    for(r1 = 0; r1 < i1; r1 += 1)this._elem.hierarchy[r1].finalTransform.mProp.applyToMatrix(t1);
                }
                return t1.inversePoint(e1);
            }
            function o1(t1) {
                var e1 = new Matrix;
                if (e1.reset(), this._elem.finalTransform.mProp.applyToMatrix(e1), this._elem.hierarchy && this._elem.hierarchy.length) {
                    var r1, i1 = this._elem.hierarchy.length;
                    for(r1 = 0; r1 < i1; r1 += 1)this._elem.hierarchy[r1].finalTransform.mProp.applyToMatrix(e1);
                    return e1.inversePoint(t1);
                }
                return e1.inversePoint(t1);
            }
            function h1() {
                return [
                    1,
                    1,
                    1,
                    1
                ];
            }
            return function(l1) {
                var p1;
                function c1(t1) {
                    switch(t1){
                        case "ADBE Root Vectors Group":
                        case "Contents":
                        case 2:
                            return c1.shapeInterface;
                        case 1:
                        case 6:
                        case "Transform":
                        case "transform":
                        case "ADBE Transform Group":
                            return p1;
                        case 4:
                        case "ADBE Effect Parade":
                        case "effects":
                        case "Effects":
                            return c1.effect;
                        case "ADBE Text Properties":
                            return c1.textInterface;
                        default:
                            return null;
                    }
                }
                c1.getMatrix = t1, c1.invertPoint = n1, c1.applyPoint = a1, c1.toWorld = r1, c1.toWorldVec = e1, c1.fromWorld = s1, c1.fromWorldVec = i1, c1.toComp = r1, c1.fromComp = o1, c1.sampleImage = h1, c1.sourceRectAtTime = l1.sourceRectAtTime.bind(l1), c1._elem = l1;
                var f1 = getDescriptor(p1 = TransformExpressionInterface(l1.finalTransform.mProp), "anchorPoint");
                return Object.defineProperties(c1, {
                    hasParent: {
                        get: function() {
                            return l1.hierarchy.length;
                        }
                    },
                    parent: {
                        get: function() {
                            return l1.hierarchy[0].layerInterface;
                        }
                    },
                    rotation: getDescriptor(p1, "rotation"),
                    scale: getDescriptor(p1, "scale"),
                    position: getDescriptor(p1, "position"),
                    opacity: getDescriptor(p1, "opacity"),
                    anchorPoint: f1,
                    anchor_point: f1,
                    transform: {
                        get: function() {
                            return p1;
                        }
                    },
                    active: {
                        get: function() {
                            return l1.isInRange;
                        }
                    }
                }), c1.startTime = l1.data.st, c1.index = l1.data.ind, c1.source = l1.data.refId, c1.height = 0 === l1.data.ty ? l1.data.h : 100, c1.width = 0 === l1.data.ty ? l1.data.w : 100, c1.inPoint = l1.data.ip / l1.comp.globalData.frameRate, c1.outPoint = l1.data.op / l1.comp.globalData.frameRate, c1._name = l1.data.nm, c1.registerMaskInterface = function(t1) {
                    c1.mask = new MaskManagerInterface(t1, l1);
                }, c1.registerEffectsInterface = function(t1) {
                    c1.effect = t1;
                }, c1;
            };
        }(), propertyGroupFactory = function(t1, e1) {
            return function(r1) {
                return (r1 = void 0 === r1 ? 1 : r1) <= 0 ? t1 : e1(r1 - 1);
            };
        }, PropertyInterface = function(t1, e1) {
            var r1 = {
                _name: t1
            };
            return function(t1) {
                return (t1 = void 0 === t1 ? 1 : t1) <= 0 ? r1 : e1(t1 - 1);
            };
        }, EffectsExpressionInterface = function() {
            var t1 = {
                createEffectsInterface: function(t1, r1) {
                    if (t1.effectsManager) {
                        var i1, s1 = [], a1 = t1.data.ef, n1 = t1.effectsManager.effectElements.length;
                        for(i1 = 0; i1 < n1; i1 += 1)s1.push(e1(a1[i1], t1.effectsManager.effectElements[i1], r1, t1));
                        var o1 = t1.data.ef || [], h1 = function(t1) {
                            for(i1 = 0, n1 = o1.length; i1 < n1;){
                                if (t1 === o1[i1].nm || t1 === o1[i1].mn || t1 === o1[i1].ix) return s1[i1];
                                i1 += 1;
                            }
                            return null;
                        };
                        return Object.defineProperty(h1, "numProperties", {
                            get: function() {
                                return o1.length;
                            }
                        }), h1;
                    }
                    return null;
                }
            };
            function e1(t1, i1, s1, a1) {
                function n1(e1) {
                    for(var r1 = t1.ef, i1 = 0, s1 = r1.length; i1 < s1;){
                        if (e1 === r1[i1].nm || e1 === r1[i1].mn || e1 === r1[i1].ix) return 5 === r1[i1].ty ? l1[i1] : l1[i1]();
                        i1 += 1;
                    }
                    throw new Error;
                }
                var o1, h1 = propertyGroupFactory(n1, s1), l1 = [], p1 = t1.ef.length;
                for(o1 = 0; o1 < p1; o1 += 1)5 === t1.ef[o1].ty ? l1.push(e1(t1.ef[o1], i1.effectElements[o1], i1.effectElements[o1].propertyGroup, a1)) : l1.push(r1(i1.effectElements[o1], t1.ef[o1].ty, a1, h1));
                return "ADBE Color Control" === t1.mn && Object.defineProperty(n1, "color", {
                    get: function() {
                        return l1[0]();
                    }
                }), Object.defineProperties(n1, {
                    numProperties: {
                        get: function() {
                            return t1.np;
                        }
                    },
                    _name: {
                        value: t1.nm
                    },
                    propertyGroup: {
                        value: h1
                    }
                }), n1.enabled = 0 !== t1.en, n1.active = n1.enabled, n1;
            }
            function r1(t1, e1, r1, i1) {
                var s1 = ExpressionPropertyInterface(t1.p);
                return t1.p.setGroupProperty && t1.p.setGroupProperty(PropertyInterface("", i1)), function() {
                    return 10 === e1 ? r1.comp.compInterface(t1.p.v) : s1();
                };
            }
            return t1;
        }(), ShapePathInterface = function(t1, e1, r1) {
            var i1 = e1.sh;
            function s1(t1) {
                return "Shape" === t1 || "shape" === t1 || "Path" === t1 || "path" === t1 || "ADBE Vector Shape" === t1 || 2 === t1 ? s1.path : null;
            }
            var a1 = propertyGroupFactory(s1, r1);
            return i1.setGroupProperty(PropertyInterface("Path", a1)), Object.defineProperties(s1, {
                path: {
                    get: function() {
                        return i1.k && i1.getValue(), i1;
                    }
                },
                shape: {
                    get: function() {
                        return i1.k && i1.getValue(), i1;
                    }
                },
                _name: {
                    value: t1.nm
                },
                ix: {
                    value: t1.ix
                },
                propertyIndex: {
                    value: t1.ix
                },
                mn: {
                    value: t1.mn
                },
                propertyGroup: {
                    value: r1
                }
            }), s1;
        }, ShapeExpressionInterface = function() {
            function t1(t1, n1, f1) {
                var d1, u1 = [], m1 = t1 ? t1.length : 0;
                for(d1 = 0; d1 < m1; d1 += 1)"gr" === t1[d1].ty ? u1.push(e1(t1[d1], n1[d1], f1)) : "fl" === t1[d1].ty ? u1.push(r1(t1[d1], n1[d1], f1)) : "st" === t1[d1].ty ? u1.push(s1(t1[d1], n1[d1], f1)) : "tm" === t1[d1].ty ? u1.push(a1(t1[d1], n1[d1], f1)) : "tr" === t1[d1].ty || ("el" === t1[d1].ty ? u1.push(o1(t1[d1], n1[d1], f1)) : "sr" === t1[d1].ty ? u1.push(h1(t1[d1], n1[d1], f1)) : "sh" === t1[d1].ty ? u1.push(ShapePathInterface(t1[d1], n1[d1], f1)) : "rc" === t1[d1].ty ? u1.push(l1(t1[d1], n1[d1], f1)) : "rd" === t1[d1].ty ? u1.push(p1(t1[d1], n1[d1], f1)) : "rp" === t1[d1].ty ? u1.push(c1(t1[d1], n1[d1], f1)) : "gf" === t1[d1].ty ? u1.push(i1(t1[d1], n1[d1], f1)) : u1.push((t1[d1], n1[d1], function() {
                    return null;
                })));
                return u1;
            }
            function e1(e1, r1, i1) {
                var s1 = function(t1) {
                    switch(t1){
                        case "ADBE Vectors Group":
                        case "Contents":
                        case 2:
                            return s1.content;
                        default:
                            return s1.transform;
                    }
                };
                s1.propertyGroup = propertyGroupFactory(s1, i1);
                var a1 = function(e1, r1, i1) {
                    var s1, a1 = function(t1) {
                        for(var e1 = 0, r1 = s1.length; e1 < r1;){
                            if (s1[e1]._name === t1 || s1[e1].mn === t1 || s1[e1].propertyIndex === t1 || s1[e1].ix === t1 || s1[e1].ind === t1) return s1[e1];
                            e1 += 1;
                        }
                        return "number" == typeof t1 ? s1[t1 - 1] : null;
                    };
                    a1.propertyGroup = propertyGroupFactory(a1, i1), s1 = t1(e1.it, r1.it, a1.propertyGroup), a1.numProperties = s1.length;
                    var o1 = n1(e1.it[e1.it.length - 1], r1.it[r1.it.length - 1], a1.propertyGroup);
                    return a1.transform = o1, a1.propertyIndex = e1.cix, a1._name = e1.nm, a1;
                }(e1, r1, s1.propertyGroup), o1 = n1(e1.it[e1.it.length - 1], r1.it[r1.it.length - 1], s1.propertyGroup);
                return s1.content = a1, s1.transform = o1, Object.defineProperty(s1, "_name", {
                    get: function() {
                        return e1.nm;
                    }
                }), s1.numProperties = e1.np, s1.propertyIndex = e1.ix, s1.nm = e1.nm, s1.mn = e1.mn, s1;
            }
            function r1(t1, e1, r1) {
                function i1(t1) {
                    return "Color" === t1 || "color" === t1 ? i1.color : "Opacity" === t1 || "opacity" === t1 ? i1.opacity : null;
                }
                return Object.defineProperties(i1, {
                    color: {
                        get: ExpressionPropertyInterface(e1.c)
                    },
                    opacity: {
                        get: ExpressionPropertyInterface(e1.o)
                    },
                    _name: {
                        value: t1.nm
                    },
                    mn: {
                        value: t1.mn
                    }
                }), e1.c.setGroupProperty(PropertyInterface("Color", r1)), e1.o.setGroupProperty(PropertyInterface("Opacity", r1)), i1;
            }
            function i1(t1, e1, r1) {
                function i1(t1) {
                    return "Start Point" === t1 || "start point" === t1 ? i1.startPoint : "End Point" === t1 || "end point" === t1 ? i1.endPoint : "Opacity" === t1 || "opacity" === t1 ? i1.opacity : null;
                }
                return Object.defineProperties(i1, {
                    startPoint: {
                        get: ExpressionPropertyInterface(e1.s)
                    },
                    endPoint: {
                        get: ExpressionPropertyInterface(e1.e)
                    },
                    opacity: {
                        get: ExpressionPropertyInterface(e1.o)
                    },
                    type: {
                        get: function() {
                            return "a";
                        }
                    },
                    _name: {
                        value: t1.nm
                    },
                    mn: {
                        value: t1.mn
                    }
                }), e1.s.setGroupProperty(PropertyInterface("Start Point", r1)), e1.e.setGroupProperty(PropertyInterface("End Point", r1)), e1.o.setGroupProperty(PropertyInterface("Opacity", r1)), i1;
            }
            function s1(t1, e1, r1) {
                var i1, s1 = propertyGroupFactory(l1, r1), a1 = propertyGroupFactory(h1, s1);
                function n1(r1) {
                    Object.defineProperty(h1, t1.d[r1].nm, {
                        get: ExpressionPropertyInterface(e1.d.dataProps[r1].p)
                    });
                }
                var o1 = t1.d ? t1.d.length : 0, h1 = {};
                for(i1 = 0; i1 < o1; i1 += 1)n1(i1), e1.d.dataProps[i1].p.setGroupProperty(a1);
                function l1(t1) {
                    return "Color" === t1 || "color" === t1 ? l1.color : "Opacity" === t1 || "opacity" === t1 ? l1.opacity : "Stroke Width" === t1 || "stroke width" === t1 ? l1.strokeWidth : null;
                }
                return Object.defineProperties(l1, {
                    color: {
                        get: ExpressionPropertyInterface(e1.c)
                    },
                    opacity: {
                        get: ExpressionPropertyInterface(e1.o)
                    },
                    strokeWidth: {
                        get: ExpressionPropertyInterface(e1.w)
                    },
                    dash: {
                        get: function() {
                            return h1;
                        }
                    },
                    _name: {
                        value: t1.nm
                    },
                    mn: {
                        value: t1.mn
                    }
                }), e1.c.setGroupProperty(PropertyInterface("Color", s1)), e1.o.setGroupProperty(PropertyInterface("Opacity", s1)), e1.w.setGroupProperty(PropertyInterface("Stroke Width", s1)), l1;
            }
            function a1(t1, e1, r1) {
                function i1(e1) {
                    return e1 === t1.e.ix || "End" === e1 || "end" === e1 ? i1.end : e1 === t1.s.ix ? i1.start : e1 === t1.o.ix ? i1.offset : null;
                }
                var s1 = propertyGroupFactory(i1, r1);
                return i1.propertyIndex = t1.ix, e1.s.setGroupProperty(PropertyInterface("Start", s1)), e1.e.setGroupProperty(PropertyInterface("End", s1)), e1.o.setGroupProperty(PropertyInterface("Offset", s1)), i1.propertyIndex = t1.ix, i1.propertyGroup = r1, Object.defineProperties(i1, {
                    start: {
                        get: ExpressionPropertyInterface(e1.s)
                    },
                    end: {
                        get: ExpressionPropertyInterface(e1.e)
                    },
                    offset: {
                        get: ExpressionPropertyInterface(e1.o)
                    },
                    _name: {
                        value: t1.nm
                    }
                }), i1.mn = t1.mn, i1;
            }
            function n1(t1, e1, r1) {
                function i1(e1) {
                    return t1.a.ix === e1 || "Anchor Point" === e1 ? i1.anchorPoint : t1.o.ix === e1 || "Opacity" === e1 ? i1.opacity : t1.p.ix === e1 || "Position" === e1 ? i1.position : t1.r.ix === e1 || "Rotation" === e1 || "ADBE Vector Rotation" === e1 ? i1.rotation : t1.s.ix === e1 || "Scale" === e1 ? i1.scale : t1.sk && t1.sk.ix === e1 || "Skew" === e1 ? i1.skew : t1.sa && t1.sa.ix === e1 || "Skew Axis" === e1 ? i1.skewAxis : null;
                }
                var s1 = propertyGroupFactory(i1, r1);
                return e1.transform.mProps.o.setGroupProperty(PropertyInterface("Opacity", s1)), e1.transform.mProps.p.setGroupProperty(PropertyInterface("Position", s1)), e1.transform.mProps.a.setGroupProperty(PropertyInterface("Anchor Point", s1)), e1.transform.mProps.s.setGroupProperty(PropertyInterface("Scale", s1)), e1.transform.mProps.r.setGroupProperty(PropertyInterface("Rotation", s1)), e1.transform.mProps.sk && (e1.transform.mProps.sk.setGroupProperty(PropertyInterface("Skew", s1)), e1.transform.mProps.sa.setGroupProperty(PropertyInterface("Skew Angle", s1))), e1.transform.op.setGroupProperty(PropertyInterface("Opacity", s1)), Object.defineProperties(i1, {
                    opacity: {
                        get: ExpressionPropertyInterface(e1.transform.mProps.o)
                    },
                    position: {
                        get: ExpressionPropertyInterface(e1.transform.mProps.p)
                    },
                    anchorPoint: {
                        get: ExpressionPropertyInterface(e1.transform.mProps.a)
                    },
                    scale: {
                        get: ExpressionPropertyInterface(e1.transform.mProps.s)
                    },
                    rotation: {
                        get: ExpressionPropertyInterface(e1.transform.mProps.r)
                    },
                    skew: {
                        get: ExpressionPropertyInterface(e1.transform.mProps.sk)
                    },
                    skewAxis: {
                        get: ExpressionPropertyInterface(e1.transform.mProps.sa)
                    },
                    _name: {
                        value: t1.nm
                    }
                }), i1.ty = "tr", i1.mn = t1.mn, i1.propertyGroup = r1, i1;
            }
            function o1(t1, e1, r1) {
                function i1(e1) {
                    return t1.p.ix === e1 ? i1.position : t1.s.ix === e1 ? i1.size : null;
                }
                var s1 = propertyGroupFactory(i1, r1);
                i1.propertyIndex = t1.ix;
                var a1 = "tm" === e1.sh.ty ? e1.sh.prop : e1.sh;
                return a1.s.setGroupProperty(PropertyInterface("Size", s1)), a1.p.setGroupProperty(PropertyInterface("Position", s1)), Object.defineProperties(i1, {
                    size: {
                        get: ExpressionPropertyInterface(a1.s)
                    },
                    position: {
                        get: ExpressionPropertyInterface(a1.p)
                    },
                    _name: {
                        value: t1.nm
                    }
                }), i1.mn = t1.mn, i1;
            }
            function h1(t1, e1, r1) {
                function i1(e1) {
                    return t1.p.ix === e1 ? i1.position : t1.r.ix === e1 ? i1.rotation : t1.pt.ix === e1 ? i1.points : t1.or.ix === e1 || "ADBE Vector Star Outer Radius" === e1 ? i1.outerRadius : t1.os.ix === e1 ? i1.outerRoundness : !t1.ir || t1.ir.ix !== e1 && "ADBE Vector Star Inner Radius" !== e1 ? t1.is && t1.is.ix === e1 ? i1.innerRoundness : null : i1.innerRadius;
                }
                var s1 = propertyGroupFactory(i1, r1), a1 = "tm" === e1.sh.ty ? e1.sh.prop : e1.sh;
                return i1.propertyIndex = t1.ix, a1.or.setGroupProperty(PropertyInterface("Outer Radius", s1)), a1.os.setGroupProperty(PropertyInterface("Outer Roundness", s1)), a1.pt.setGroupProperty(PropertyInterface("Points", s1)), a1.p.setGroupProperty(PropertyInterface("Position", s1)), a1.r.setGroupProperty(PropertyInterface("Rotation", s1)), t1.ir && (a1.ir.setGroupProperty(PropertyInterface("Inner Radius", s1)), a1.is.setGroupProperty(PropertyInterface("Inner Roundness", s1))), Object.defineProperties(i1, {
                    position: {
                        get: ExpressionPropertyInterface(a1.p)
                    },
                    rotation: {
                        get: ExpressionPropertyInterface(a1.r)
                    },
                    points: {
                        get: ExpressionPropertyInterface(a1.pt)
                    },
                    outerRadius: {
                        get: ExpressionPropertyInterface(a1.or)
                    },
                    outerRoundness: {
                        get: ExpressionPropertyInterface(a1.os)
                    },
                    innerRadius: {
                        get: ExpressionPropertyInterface(a1.ir)
                    },
                    innerRoundness: {
                        get: ExpressionPropertyInterface(a1.is)
                    },
                    _name: {
                        value: t1.nm
                    }
                }), i1.mn = t1.mn, i1;
            }
            function l1(t1, e1, r1) {
                function i1(e1) {
                    return t1.p.ix === e1 ? i1.position : t1.r.ix === e1 ? i1.roundness : t1.s.ix === e1 || "Size" === e1 || "ADBE Vector Rect Size" === e1 ? i1.size : null;
                }
                var s1 = propertyGroupFactory(i1, r1), a1 = "tm" === e1.sh.ty ? e1.sh.prop : e1.sh;
                return i1.propertyIndex = t1.ix, a1.p.setGroupProperty(PropertyInterface("Position", s1)), a1.s.setGroupProperty(PropertyInterface("Size", s1)), a1.r.setGroupProperty(PropertyInterface("Rotation", s1)), Object.defineProperties(i1, {
                    position: {
                        get: ExpressionPropertyInterface(a1.p)
                    },
                    roundness: {
                        get: ExpressionPropertyInterface(a1.r)
                    },
                    size: {
                        get: ExpressionPropertyInterface(a1.s)
                    },
                    _name: {
                        value: t1.nm
                    }
                }), i1.mn = t1.mn, i1;
            }
            function p1(t1, e1, r1) {
                function i1(e1) {
                    return t1.r.ix === e1 || "Round Corners 1" === e1 ? i1.radius : null;
                }
                var s1 = propertyGroupFactory(i1, r1), a1 = e1;
                return i1.propertyIndex = t1.ix, a1.rd.setGroupProperty(PropertyInterface("Radius", s1)), Object.defineProperties(i1, {
                    radius: {
                        get: ExpressionPropertyInterface(a1.rd)
                    },
                    _name: {
                        value: t1.nm
                    }
                }), i1.mn = t1.mn, i1;
            }
            function c1(t1, e1, r1) {
                function i1(e1) {
                    return t1.c.ix === e1 || "Copies" === e1 ? i1.copies : t1.o.ix === e1 || "Offset" === e1 ? i1.offset : null;
                }
                var s1 = propertyGroupFactory(i1, r1), a1 = e1;
                return i1.propertyIndex = t1.ix, a1.c.setGroupProperty(PropertyInterface("Copies", s1)), a1.o.setGroupProperty(PropertyInterface("Offset", s1)), Object.defineProperties(i1, {
                    copies: {
                        get: ExpressionPropertyInterface(a1.c)
                    },
                    offset: {
                        get: ExpressionPropertyInterface(a1.o)
                    },
                    _name: {
                        value: t1.nm
                    }
                }), i1.mn = t1.mn, i1;
            }
            return function(e1, r1, i1) {
                var s1;
                function a1(t1) {
                    if ("number" == typeof t1) return 0 === (t1 = void 0 === t1 ? 1 : t1) ? i1 : s1[t1 - 1];
                    for(var e1 = 0, r1 = s1.length; e1 < r1;){
                        if (s1[e1]._name === t1) return s1[e1];
                        e1 += 1;
                    }
                    return null;
                }
                return a1.propertyGroup = propertyGroupFactory(a1, function() {
                    return i1;
                }), s1 = t1(e1, r1, a1.propertyGroup), a1.numProperties = s1.length, a1._name = "Contents", a1;
            };
        }(), TextExpressionInterface = function(t1) {
            var e1, r1;
            function i1(t1) {
                return "ADBE Text Document" === t1 ? i1.sourceText : null;
            }
            return Object.defineProperty(i1, "sourceText", {
                get: function() {
                    t1.textProperty.getValue();
                    var i1 = t1.textProperty.currentData.t;
                    return i1 !== e1 && (t1.textProperty.currentData.t = e1, (r1 = new String(i1)).value = i1 || new String(i1)), r1;
                }
            }), i1;
        };
        function _typeof$2(t1) {
            return _typeof$2 = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(t1) {
                return typeof t1;
            } : function(t1) {
                return t1 && "function" == typeof Symbol && t1.constructor === Symbol && t1 !== Symbol.prototype ? "symbol" : typeof t1;
            }, _typeof$2(t1);
        }
        var FootageInterface = (dataInterfaceFactory = function(t1) {
            function e1(t1) {
                return "Outline" === t1 ? e1.outlineInterface() : null;
            }
            return e1._name = "Outline", e1.outlineInterface = function(t1) {
                var e1 = "", r1 = t1.getFootageData();
                function i1(t1) {
                    if (r1[t1]) return e1 = t1, "object" === _typeof$2(r1 = r1[t1]) ? i1 : r1;
                    var s1 = t1.indexOf(e1);
                    if (-1 !== s1) {
                        var a1 = parseInt(t1.substr(s1 + e1.length), 10);
                        return "object" === _typeof$2(r1 = r1[a1]) ? i1 : r1;
                    }
                    return "";
                }
                return function() {
                    return e1 = "", r1 = t1.getFootageData(), i1;
                };
            }(t1), e1;
        }, function(t1) {
            function e1(t1) {
                return "Data" === t1 ? e1.dataInterface : null;
            }
            return e1._name = "Data", e1.dataInterface = dataInterfaceFactory(t1), e1;
        }), dataInterfaceFactory, interfaces = {
            layer: LayerExpressionInterface,
            effects: EffectsExpressionInterface,
            comp: CompExpressionInterface,
            shape: ShapeExpressionInterface,
            text: TextExpressionInterface,
            footage: FootageInterface
        };
        function getInterface(t1) {
            return interfaces[t1] || null;
        }
        function _typeof$1(t1) {
            return _typeof$1 = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(t1) {
                return typeof t1;
            } : function(t1) {
                return t1 && "function" == typeof Symbol && t1.constructor === Symbol && t1 !== Symbol.prototype ? "symbol" : typeof t1;
            }, _typeof$1(t1);
        }
        function seedRandom(t1, e1) {
            var r1 = this, i1 = 256, s1 = e1.pow(i1, 6), a1 = e1.pow(2, 52), n1 = 2 * a1, o1 = 255;
            function h1(t1) {
                var e1, r1 = t1.length, s1 = this, a1 = 0, n1 = s1.i = s1.j = 0, h1 = s1.S = [];
                for(r1 || (t1 = [
                    r1++
                ]); a1 < i1;)h1[a1] = a1++;
                for(a1 = 0; a1 < i1; a1++)h1[a1] = h1[n1 = o1 & n1 + t1[a1 % r1] + (e1 = h1[a1])], h1[n1] = e1;
                s1.g = function(t1) {
                    for(var e1, r1 = 0, a1 = s1.i, n1 = s1.j, h1 = s1.S; t1--;)e1 = h1[a1 = o1 & a1 + 1], r1 = r1 * i1 + h1[o1 & (h1[a1] = h1[n1 = o1 & n1 + e1]) + (h1[n1] = e1)];
                    return s1.i = a1, s1.j = n1, r1;
                };
            }
            function l1(t1, e1) {
                return e1.i = t1.i, e1.j = t1.j, e1.S = t1.S.slice(), e1;
            }
            function p1(t1, e1) {
                var r1, i1 = [], s1 = _typeof$1(t1);
                if (e1 && "object" == s1) for(r1 in t1)try {
                    i1.push(p1(t1[r1], e1 - 1));
                } catch (t1) {}
                return i1.length ? i1 : "string" == s1 ? t1 : t1 + "\x00";
            }
            function c1(t1, e1) {
                for(var r1, i1 = t1 + "", s1 = 0; s1 < i1.length;)e1[o1 & s1] = o1 & (r1 ^= 19 * e1[o1 & s1]) + i1.charCodeAt(s1++);
                return f1(e1);
            }
            function f1(t1) {
                return String.fromCharCode.apply(0, t1);
            }
            e1.seedrandom = function(o1, d1, u1) {
                var m1 = [], y1 = c1(p1((d1 = !0 === d1 ? {
                    entropy: !0
                } : d1 || {}).entropy ? [
                    o1,
                    f1(t1)
                ] : null === o1 ? function() {
                    try {
                        var e1 = new Uint8Array(i1);
                        return (r1.crypto || r1.msCrypto).getRandomValues(e1), f1(e1);
                    } catch (e1) {
                        var s1 = r1.navigator, a1 = s1 && s1.plugins;
                        return [
                            +new Date,
                            r1,
                            a1,
                            r1.screen,
                            f1(t1)
                        ];
                    }
                }() : o1, 3), m1), g1 = new h1(m1), v1 = function() {
                    for(var t1 = g1.g(6), e1 = s1, r1 = 0; t1 < a1;)t1 = (t1 + r1) * i1, e1 *= i1, r1 = g1.g(1);
                    for(; t1 >= n1;)t1 /= 2, e1 /= 2, r1 >>>= 1;
                    return (t1 + r1) / e1;
                };
                return v1.int32 = function() {
                    return 0 | g1.g(4);
                }, v1.quick = function() {
                    return g1.g(4) / 4294967296;
                }, v1.double = v1, c1(f1(g1.S), t1), (d1.pass || u1 || function(t1, r1, i1, s1) {
                    return s1 && (s1.S && l1(s1, g1), t1.state = function() {
                        return l1(g1, {});
                    }), i1 ? (e1.random = t1, r1) : t1;
                })(v1, y1, "global" in d1 ? d1.global : this == e1, d1.state);
            }, c1(e1.random(), t1);
        }
        function initialize$2(t1) {
            seedRandom([], t1);
        }
        var propTypes = {
            SHAPE: "shape"
        };
        function _typeof(t1) {
            return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(t1) {
                return typeof t1;
            } : function(t1) {
                return t1 && "function" == typeof Symbol && t1.constructor === Symbol && t1 !== Symbol.prototype ? "symbol" : typeof t1;
            }, _typeof(t1);
        }
        var ExpressionManager = function() {
            var ob = {}, Math = BMMath, window = null, document = null, XMLHttpRequest = null, fetch = null, frames = null;
            function $bm_isInstanceOfArray(t1) {
                return t1.constructor === Array || t1.constructor === Float32Array;
            }
            function isNumerable(t1, e1) {
                return "number" === t1 || "boolean" === t1 || "string" === t1 || e1 instanceof Number;
            }
            function $bm_neg(t1) {
                var e1 = _typeof(t1);
                if ("number" === e1 || "boolean" === e1 || t1 instanceof Number) return -t1;
                if ($bm_isInstanceOfArray(t1)) {
                    var r1, i1 = t1.length, s1 = [];
                    for(r1 = 0; r1 < i1; r1 += 1)s1[r1] = -t1[r1];
                    return s1;
                }
                return t1.propType ? t1.v : -t1;
            }
            initialize$2(BMMath);
            var easeInBez = BezierFactory.getBezierEasing(.333, 0, .833, .833, "easeIn").get, easeOutBez = BezierFactory.getBezierEasing(.167, .167, .667, 1, "easeOut").get, easeInOutBez = BezierFactory.getBezierEasing(.33, 0, .667, 1, "easeInOut").get;
            function sum(t1, e1) {
                var r1 = _typeof(t1), i1 = _typeof(e1);
                if ("string" === r1 || "string" === i1) return t1 + e1;
                if (isNumerable(r1, t1) && isNumerable(i1, e1)) return t1 + e1;
                if ($bm_isInstanceOfArray(t1) && isNumerable(i1, e1)) return (t1 = t1.slice(0))[0] += e1, t1;
                if (isNumerable(r1, t1) && $bm_isInstanceOfArray(e1)) return (e1 = e1.slice(0))[0] = t1 + e1[0], e1;
                if ($bm_isInstanceOfArray(t1) && $bm_isInstanceOfArray(e1)) {
                    for(var s1 = 0, a1 = t1.length, n1 = e1.length, o1 = []; s1 < a1 || s1 < n1;)("number" == typeof t1[s1] || t1[s1] instanceof Number) && ("number" == typeof e1[s1] || e1[s1] instanceof Number) ? o1[s1] = t1[s1] + e1[s1] : o1[s1] = void 0 === e1[s1] ? t1[s1] : t1[s1] || e1[s1], s1 += 1;
                    return o1;
                }
                return 0;
            }
            var add = sum;
            function sub(t1, e1) {
                var r1 = _typeof(t1), i1 = _typeof(e1);
                if (isNumerable(r1, t1) && isNumerable(i1, e1)) return "string" === r1 && (t1 = parseInt(t1, 10)), "string" === i1 && (e1 = parseInt(e1, 10)), t1 - e1;
                if ($bm_isInstanceOfArray(t1) && isNumerable(i1, e1)) return (t1 = t1.slice(0))[0] -= e1, t1;
                if (isNumerable(r1, t1) && $bm_isInstanceOfArray(e1)) return (e1 = e1.slice(0))[0] = t1 - e1[0], e1;
                if ($bm_isInstanceOfArray(t1) && $bm_isInstanceOfArray(e1)) {
                    for(var s1 = 0, a1 = t1.length, n1 = e1.length, o1 = []; s1 < a1 || s1 < n1;)("number" == typeof t1[s1] || t1[s1] instanceof Number) && ("number" == typeof e1[s1] || e1[s1] instanceof Number) ? o1[s1] = t1[s1] - e1[s1] : o1[s1] = void 0 === e1[s1] ? t1[s1] : t1[s1] || e1[s1], s1 += 1;
                    return o1;
                }
                return 0;
            }
            function mul(t1, e1) {
                var r1, i1, s1, a1 = _typeof(t1), n1 = _typeof(e1);
                if (isNumerable(a1, t1) && isNumerable(n1, e1)) return t1 * e1;
                if ($bm_isInstanceOfArray(t1) && isNumerable(n1, e1)) {
                    for(s1 = t1.length, r1 = createTypedArray("float32", s1), i1 = 0; i1 < s1; i1 += 1)r1[i1] = t1[i1] * e1;
                    return r1;
                }
                if (isNumerable(a1, t1) && $bm_isInstanceOfArray(e1)) {
                    for(s1 = e1.length, r1 = createTypedArray("float32", s1), i1 = 0; i1 < s1; i1 += 1)r1[i1] = t1 * e1[i1];
                    return r1;
                }
                return 0;
            }
            function div(t1, e1) {
                var r1, i1, s1, a1 = _typeof(t1), n1 = _typeof(e1);
                if (isNumerable(a1, t1) && isNumerable(n1, e1)) return t1 / e1;
                if ($bm_isInstanceOfArray(t1) && isNumerable(n1, e1)) {
                    for(s1 = t1.length, r1 = createTypedArray("float32", s1), i1 = 0; i1 < s1; i1 += 1)r1[i1] = t1[i1] / e1;
                    return r1;
                }
                if (isNumerable(a1, t1) && $bm_isInstanceOfArray(e1)) {
                    for(s1 = e1.length, r1 = createTypedArray("float32", s1), i1 = 0; i1 < s1; i1 += 1)r1[i1] = t1 / e1[i1];
                    return r1;
                }
                return 0;
            }
            function mod(t1, e1) {
                return "string" == typeof t1 && (t1 = parseInt(t1, 10)), "string" == typeof e1 && (e1 = parseInt(e1, 10)), t1 % e1;
            }
            var $bm_sum = sum, $bm_sub = sub, $bm_mul = mul, $bm_div = div, $bm_mod = mod;
            function clamp(t1, e1, r1) {
                if (e1 > r1) {
                    var i1 = r1;
                    r1 = e1, e1 = i1;
                }
                return Math.min(Math.max(t1, e1), r1);
            }
            function radiansToDegrees(t1) {
                return t1 / degToRads;
            }
            var radians_to_degrees = radiansToDegrees;
            function degreesToRadians(t1) {
                return t1 * degToRads;
            }
            var degrees_to_radians = radiansToDegrees, helperLengthArray = [
                0,
                0,
                0,
                0,
                0,
                0
            ];
            function length(t1, e1) {
                if ("number" == typeof t1 || t1 instanceof Number) return e1 = e1 || 0, Math.abs(t1 - e1);
                var r1;
                e1 || (e1 = helperLengthArray);
                var i1 = Math.min(t1.length, e1.length), s1 = 0;
                for(r1 = 0; r1 < i1; r1 += 1)s1 += Math.pow(e1[r1] - t1[r1], 2);
                return Math.sqrt(s1);
            }
            function normalize(t1) {
                return div(t1, length(t1));
            }
            function rgbToHsl(t1) {
                var e1, r1, i1 = t1[0], s1 = t1[1], a1 = t1[2], n1 = Math.max(i1, s1, a1), o1 = Math.min(i1, s1, a1), h1 = (n1 + o1) / 2;
                if (n1 === o1) e1 = 0, r1 = 0;
                else {
                    var l1 = n1 - o1;
                    switch(r1 = h1 > .5 ? l1 / (2 - n1 - o1) : l1 / (n1 + o1), n1){
                        case i1:
                            e1 = (s1 - a1) / l1 + (s1 < a1 ? 6 : 0);
                            break;
                        case s1:
                            e1 = (a1 - i1) / l1 + 2;
                            break;
                        case a1:
                            e1 = (i1 - s1) / l1 + 4;
                    }
                    e1 /= 6;
                }
                return [
                    e1,
                    r1,
                    h1,
                    t1[3]
                ];
            }
            function hue2rgb(t1, e1, r1) {
                return r1 < 0 && (r1 += 1), r1 > 1 && (r1 -= 1), r1 < 1 / 6 ? t1 + 6 * (e1 - t1) * r1 : r1 < .5 ? e1 : r1 < 2 / 3 ? t1 + (e1 - t1) * (2 / 3 - r1) * 6 : t1;
            }
            function hslToRgb(t1) {
                var e1, r1, i1, s1 = t1[0], a1 = t1[1], n1 = t1[2];
                if (0 === a1) e1 = n1, i1 = n1, r1 = n1;
                else {
                    var o1 = n1 < .5 ? n1 * (1 + a1) : n1 + a1 - n1 * a1, h1 = 2 * n1 - o1;
                    e1 = hue2rgb(h1, o1, s1 + 1 / 3), r1 = hue2rgb(h1, o1, s1), i1 = hue2rgb(h1, o1, s1 - 1 / 3);
                }
                return [
                    e1,
                    r1,
                    i1,
                    t1[3]
                ];
            }
            function linear(t1, e1, r1, i1, s1) {
                if (void 0 !== i1 && void 0 !== s1 || (i1 = e1, s1 = r1, e1 = 0, r1 = 1), r1 < e1) {
                    var a1 = r1;
                    r1 = e1, e1 = a1;
                }
                if (t1 <= e1) return i1;
                if (t1 >= r1) return s1;
                var n1, o1 = r1 === e1 ? 0 : (t1 - e1) / (r1 - e1);
                if (!i1.length) return i1 + (s1 - i1) * o1;
                var h1 = i1.length, l1 = createTypedArray("float32", h1);
                for(n1 = 0; n1 < h1; n1 += 1)l1[n1] = i1[n1] + (s1[n1] - i1[n1]) * o1;
                return l1;
            }
            function random(t1, e1) {
                if (void 0 === e1 && (void 0 === t1 ? (t1 = 0, e1 = 1) : (e1 = t1, t1 = void 0)), e1.length) {
                    var r1, i1 = e1.length;
                    t1 || (t1 = createTypedArray("float32", i1));
                    var s1 = createTypedArray("float32", i1), a1 = BMMath.random();
                    for(r1 = 0; r1 < i1; r1 += 1)s1[r1] = t1[r1] + a1 * (e1[r1] - t1[r1]);
                    return s1;
                }
                return void 0 === t1 && (t1 = 0), t1 + BMMath.random() * (e1 - t1);
            }
            function createPath(t1, e1, r1, i1) {
                var s1, a1 = t1.length, n1 = shapePool.newElement();
                n1.setPathData(!!i1, a1);
                var o1, h1, l1 = [
                    0,
                    0
                ];
                for(s1 = 0; s1 < a1; s1 += 1)o1 = e1 && e1[s1] ? e1[s1] : l1, h1 = r1 && r1[s1] ? r1[s1] : l1, n1.setTripleAt(t1[s1][0], t1[s1][1], h1[0] + t1[s1][0], h1[1] + t1[s1][1], o1[0] + t1[s1][0], o1[1] + t1[s1][1], s1, !0);
                return n1;
            }
            function initiateExpression(elem, data, property) {
                function noOp(t1) {
                    return t1;
                }
                if (!elem.globalData.renderConfig.runExpressions) return noOp;
                var val = data.x, needsVelocity = /velocity(?![\w\d])/.test(val), _needsRandom = -1 !== val.indexOf("random"), elemType = elem.data.ty, transform, $bm_transform, content, effect, thisProperty = property;
                thisProperty.valueAtTime = thisProperty.getValueAtTime, Object.defineProperty(thisProperty, "value", {
                    get: function() {
                        return thisProperty.v;
                    }
                }), elem.comp.frameDuration = 1 / elem.comp.globalData.frameRate, elem.comp.displayStartTime = 0;
                var inPoint = elem.data.ip / elem.comp.globalData.frameRate, outPoint = elem.data.op / elem.comp.globalData.frameRate, width = elem.data.sw ? elem.data.sw : 0, height = elem.data.sh ? elem.data.sh : 0, name = elem.data.nm, loopIn, loop_in, loopOut, loop_out, smooth, toWorld, fromWorld, fromComp, toComp, fromCompToSurface, position, rotation, anchorPoint, scale, thisLayer, thisComp, mask, valueAtTime, velocityAtTime, scoped_bm_rt, expression_function = eval("[function _expression_function(){" + val + ";scoped_bm_rt=$bm_rt}]")[0], numKeys = property.kf ? data.k.length : 0, active = !this.data || !0 !== this.data.hd, wiggle = (function(t1, e1) {
                    var r1, i1, s1 = this.pv.length ? this.pv.length : 1, a1 = createTypedArray("float32", s1), n1 = Math.floor(5 * time);
                    for(r1 = 0, i1 = 0; r1 < n1;){
                        for(i1 = 0; i1 < s1; i1 += 1)a1[i1] += -e1 + 2 * e1 * BMMath.random();
                        r1 += 1;
                    }
                    var o1 = 5 * time, h1 = o1 - Math.floor(o1), l1 = createTypedArray("float32", s1);
                    if (s1 > 1) {
                        for(i1 = 0; i1 < s1; i1 += 1)l1[i1] = this.pv[i1] + a1[i1] + (-e1 + 2 * e1 * BMMath.random()) * h1;
                        return l1;
                    }
                    return this.pv + a1[0] + (-e1 + 2 * e1 * BMMath.random()) * h1;
                }).bind(this);
                function loopInDuration(t1, e1) {
                    return loopIn(t1, e1, !0);
                }
                function loopOutDuration(t1, e1) {
                    return loopOut(t1, e1, !0);
                }
                thisProperty.loopIn && (loopIn = thisProperty.loopIn.bind(thisProperty), loop_in = loopIn), thisProperty.loopOut && (loopOut = thisProperty.loopOut.bind(thisProperty), loop_out = loopOut), thisProperty.smooth && (smooth = thisProperty.smooth.bind(thisProperty)), this.getValueAtTime && (valueAtTime = this.getValueAtTime.bind(this)), this.getVelocityAtTime && (velocityAtTime = this.getVelocityAtTime.bind(this));
                var comp = elem.comp.globalData.projectInterface.bind(elem.comp.globalData.projectInterface), time, velocity, value, text, textIndex, textTotal, selectorValue;
                function lookAt(t1, e1) {
                    var r1 = [
                        e1[0] - t1[0],
                        e1[1] - t1[1],
                        e1[2] - t1[2]
                    ], i1 = Math.atan2(r1[0], Math.sqrt(r1[1] * r1[1] + r1[2] * r1[2])) / degToRads;
                    return [
                        -Math.atan2(r1[1], r1[2]) / degToRads,
                        i1,
                        0
                    ];
                }
                function easeOut(t1, e1, r1, i1, s1) {
                    return applyEase(easeOutBez, t1, e1, r1, i1, s1);
                }
                function easeIn(t1, e1, r1, i1, s1) {
                    return applyEase(easeInBez, t1, e1, r1, i1, s1);
                }
                function ease(t1, e1, r1, i1, s1) {
                    return applyEase(easeInOutBez, t1, e1, r1, i1, s1);
                }
                function applyEase(t1, e1, r1, i1, s1, a1) {
                    void 0 === s1 ? (s1 = r1, a1 = i1) : e1 = (e1 - r1) / (i1 - r1), e1 > 1 ? e1 = 1 : e1 < 0 && (e1 = 0);
                    var n1 = t1(e1);
                    if ($bm_isInstanceOfArray(s1)) {
                        var o1, h1 = s1.length, l1 = createTypedArray("float32", h1);
                        for(o1 = 0; o1 < h1; o1 += 1)l1[o1] = (a1[o1] - s1[o1]) * n1 + s1[o1];
                        return l1;
                    }
                    return (a1 - s1) * n1 + s1;
                }
                function nearestKey(t1) {
                    var e1, r1, i1, s1 = data.k.length;
                    if (data.k.length && "number" != typeof data.k[0]) {
                        if (r1 = -1, (t1 *= elem.comp.globalData.frameRate) < data.k[0].t) r1 = 1, i1 = data.k[0].t;
                        else {
                            for(e1 = 0; e1 < s1 - 1; e1 += 1){
                                if (t1 === data.k[e1].t) {
                                    r1 = e1 + 1, i1 = data.k[e1].t;
                                    break;
                                }
                                if (t1 > data.k[e1].t && t1 < data.k[e1 + 1].t) {
                                    t1 - data.k[e1].t > data.k[e1 + 1].t - t1 ? (r1 = e1 + 2, i1 = data.k[e1 + 1].t) : (r1 = e1 + 1, i1 = data.k[e1].t);
                                    break;
                                }
                            }
                            -1 === r1 && (r1 = e1 + 1, i1 = data.k[e1].t);
                        }
                    } else r1 = 0, i1 = 0;
                    var a1 = {};
                    return a1.index = r1, a1.time = i1 / elem.comp.globalData.frameRate, a1;
                }
                function key(t1) {
                    var e1, r1, i1;
                    if (!data.k.length || "number" == typeof data.k[0]) throw new Error("The property has no keyframe at index " + t1);
                    t1 -= 1, e1 = {
                        time: data.k[t1].t / elem.comp.globalData.frameRate,
                        value: []
                    };
                    var s1 = Object.prototype.hasOwnProperty.call(data.k[t1], "s") ? data.k[t1].s : data.k[t1 - 1].e;
                    for(i1 = s1.length, r1 = 0; r1 < i1; r1 += 1)e1[r1] = s1[r1], e1.value[r1] = s1[r1];
                    return e1;
                }
                function framesToTime(t1, e1) {
                    return e1 || (e1 = elem.comp.globalData.frameRate), t1 / e1;
                }
                function timeToFrames(t1, e1) {
                    return t1 || 0 === t1 || (t1 = time), e1 || (e1 = elem.comp.globalData.frameRate), t1 * e1;
                }
                function seedRandom(t1) {
                    BMMath.seedrandom(randSeed + t1);
                }
                function sourceRectAtTime() {
                    return elem.sourceRectAtTime();
                }
                function substring(t1, e1) {
                    return "string" == typeof value ? void 0 === e1 ? value.substring(t1) : value.substring(t1, e1) : "";
                }
                function substr(t1, e1) {
                    return "string" == typeof value ? void 0 === e1 ? value.substr(t1) : value.substr(t1, e1) : "";
                }
                function posterizeTime(t1) {
                    time = 0 === t1 ? 0 : Math.floor(time * t1) / t1, value = valueAtTime(time);
                }
                var index = elem.data.ind, hasParent = !(!elem.hierarchy || !elem.hierarchy.length), parent, randSeed = Math.floor(1e6 * Math.random()), globalData = elem.globalData;
                function executeExpression(t1) {
                    return value = t1, this.frameExpressionId === elem.globalData.frameId && "textSelector" !== this.propType ? value : ("textSelector" === this.propType && (textIndex = this.textIndex, textTotal = this.textTotal, selectorValue = this.selectorValue), thisLayer || (text = elem.layerInterface.text, thisLayer = elem.layerInterface, thisComp = elem.comp.compInterface, toWorld = thisLayer.toWorld.bind(thisLayer), fromWorld = thisLayer.fromWorld.bind(thisLayer), fromComp = thisLayer.fromComp.bind(thisLayer), toComp = thisLayer.toComp.bind(thisLayer), mask = thisLayer.mask ? thisLayer.mask.bind(thisLayer) : null, fromCompToSurface = fromComp), transform || (transform = elem.layerInterface("ADBE Transform Group"), $bm_transform = transform, transform && (anchorPoint = transform.anchorPoint)), 4 !== elemType || content || (content = thisLayer("ADBE Root Vectors Group")), effect || (effect = thisLayer(4)), (hasParent = !(!elem.hierarchy || !elem.hierarchy.length)) && !parent && (parent = elem.hierarchy[0].layerInterface), time = this.comp.renderedFrame / this.comp.globalData.frameRate, _needsRandom && seedRandom(randSeed + time), needsVelocity && (velocity = velocityAtTime(time)), expression_function(), this.frameExpressionId = elem.globalData.frameId, scoped_bm_rt = scoped_bm_rt.propType === propTypes.SHAPE ? scoped_bm_rt.v : scoped_bm_rt);
                }
                return executeExpression.__preventDeadCodeRemoval = [
                    $bm_transform,
                    anchorPoint,
                    time,
                    velocity,
                    inPoint,
                    outPoint,
                    width,
                    height,
                    name,
                    loop_in,
                    loop_out,
                    smooth,
                    toComp,
                    fromCompToSurface,
                    toWorld,
                    fromWorld,
                    mask,
                    position,
                    rotation,
                    scale,
                    thisComp,
                    numKeys,
                    active,
                    wiggle,
                    loopInDuration,
                    loopOutDuration,
                    comp,
                    lookAt,
                    easeOut,
                    easeIn,
                    ease,
                    nearestKey,
                    key,
                    text,
                    textIndex,
                    textTotal,
                    selectorValue,
                    framesToTime,
                    timeToFrames,
                    sourceRectAtTime,
                    substring,
                    substr,
                    posterizeTime,
                    index,
                    globalData
                ], executeExpression;
            }
            return ob.initiateExpression = initiateExpression, ob.__preventDeadCodeRemoval = [
                window,
                document,
                XMLHttpRequest,
                fetch,
                frames,
                $bm_neg,
                add,
                $bm_sum,
                $bm_sub,
                $bm_mul,
                $bm_div,
                $bm_mod,
                clamp,
                radians_to_degrees,
                degreesToRadians,
                degrees_to_radians,
                normalize,
                rgbToHsl,
                hslToRgb,
                linear,
                random,
                createPath
            ], ob;
        }(), expressionHelpers = {
            searchExpressions: function(t1, e1, r1) {
                e1.x && (r1.k = !0, r1.x = !0, r1.initiateExpression = ExpressionManager.initiateExpression, r1.effectsSequence.push(r1.initiateExpression(t1, e1, r1).bind(r1)));
            },
            getSpeedAtTime: function(t1) {
                var e1 = this.getValueAtTime(t1), r1 = this.getValueAtTime(t1 + -0.01), i1 = 0;
                if (e1.length) {
                    var s1;
                    for(s1 = 0; s1 < e1.length; s1 += 1)i1 += Math.pow(r1[s1] - e1[s1], 2);
                    i1 = 100 * Math.sqrt(i1);
                } else i1 = 0;
                return i1;
            },
            getVelocityAtTime: function(t1) {
                if (void 0 !== this.vel) return this.vel;
                var e1, r1, i1 = -0.001, s1 = this.getValueAtTime(t1), a1 = this.getValueAtTime(t1 + i1);
                if (s1.length) for(e1 = createTypedArray("float32", s1.length), r1 = 0; r1 < s1.length; r1 += 1)e1[r1] = (a1[r1] - s1[r1]) / i1;
                else e1 = (a1 - s1) / i1;
                return e1;
            },
            getValueAtTime: function(t1) {
                return t1 *= this.elem.globalData.frameRate, (t1 -= this.offsetTime) !== this._cachingAtTime.lastFrame && (this._cachingAtTime.lastIndex = this._cachingAtTime.lastFrame < t1 ? this._cachingAtTime.lastIndex : 0, this._cachingAtTime.value = this.interpolateValue(t1, this._cachingAtTime), this._cachingAtTime.lastFrame = t1), this._cachingAtTime.value;
            },
            getStaticValueAtTime: function() {
                return this.pv;
            },
            setGroupProperty: function(t1) {
                this.propertyGroup = t1;
            }
        };
        function addPropertyDecorator() {
            function t1(t1, e1, r1) {
                if (!this.k || !this.keyframes) return this.pv;
                t1 = t1 ? t1.toLowerCase() : "";
                var i1, s1, a1, n1, o1, h1 = this.comp.renderedFrame, l1 = this.keyframes, p1 = l1[l1.length - 1].t;
                if (h1 <= p1) return this.pv;
                if (r1 ? s1 = p1 - (i1 = e1 ? Math.abs(p1 - this.elem.comp.globalData.frameRate * e1) : Math.max(0, p1 - this.elem.data.ip)) : ((!e1 || e1 > l1.length - 1) && (e1 = l1.length - 1), i1 = p1 - (s1 = l1[l1.length - 1 - e1].t)), "pingpong" === t1) {
                    if (Math.floor((h1 - s1) / i1) % 2 != 0) return this.getValueAtTime((i1 - (h1 - s1) % i1 + s1) / this.comp.globalData.frameRate, 0);
                } else {
                    if ("offset" === t1) {
                        var c1 = this.getValueAtTime(s1 / this.comp.globalData.frameRate, 0), f1 = this.getValueAtTime(p1 / this.comp.globalData.frameRate, 0), d1 = this.getValueAtTime(((h1 - s1) % i1 + s1) / this.comp.globalData.frameRate, 0), u1 = Math.floor((h1 - s1) / i1);
                        if (this.pv.length) {
                            for(n1 = (o1 = new Array(c1.length)).length, a1 = 0; a1 < n1; a1 += 1)o1[a1] = (f1[a1] - c1[a1]) * u1 + d1[a1];
                            return o1;
                        }
                        return (f1 - c1) * u1 + d1;
                    }
                    if ("continue" === t1) {
                        var m1 = this.getValueAtTime(p1 / this.comp.globalData.frameRate, 0), y1 = this.getValueAtTime((p1 - .001) / this.comp.globalData.frameRate, 0);
                        if (this.pv.length) {
                            for(n1 = (o1 = new Array(m1.length)).length, a1 = 0; a1 < n1; a1 += 1)o1[a1] = m1[a1] + (m1[a1] - y1[a1]) * ((h1 - p1) / this.comp.globalData.frameRate) / 5e-4;
                            return o1;
                        }
                        return m1 + (h1 - p1) / .001 * (m1 - y1);
                    }
                }
                return this.getValueAtTime(((h1 - s1) % i1 + s1) / this.comp.globalData.frameRate, 0);
            }
            function e1(t1, e1, r1) {
                if (!this.k) return this.pv;
                t1 = t1 ? t1.toLowerCase() : "";
                var i1, s1, a1, n1, o1, h1 = this.comp.renderedFrame, l1 = this.keyframes, p1 = l1[0].t;
                if (h1 >= p1) return this.pv;
                if (r1 ? s1 = p1 + (i1 = e1 ? Math.abs(this.elem.comp.globalData.frameRate * e1) : Math.max(0, this.elem.data.op - p1)) : ((!e1 || e1 > l1.length - 1) && (e1 = l1.length - 1), i1 = (s1 = l1[e1].t) - p1), "pingpong" === t1) {
                    if (Math.floor((p1 - h1) / i1) % 2 == 0) return this.getValueAtTime(((p1 - h1) % i1 + p1) / this.comp.globalData.frameRate, 0);
                } else {
                    if ("offset" === t1) {
                        var c1 = this.getValueAtTime(p1 / this.comp.globalData.frameRate, 0), f1 = this.getValueAtTime(s1 / this.comp.globalData.frameRate, 0), d1 = this.getValueAtTime((i1 - (p1 - h1) % i1 + p1) / this.comp.globalData.frameRate, 0), u1 = Math.floor((p1 - h1) / i1) + 1;
                        if (this.pv.length) {
                            for(n1 = (o1 = new Array(c1.length)).length, a1 = 0; a1 < n1; a1 += 1)o1[a1] = d1[a1] - (f1[a1] - c1[a1]) * u1;
                            return o1;
                        }
                        return d1 - (f1 - c1) * u1;
                    }
                    if ("continue" === t1) {
                        var m1 = this.getValueAtTime(p1 / this.comp.globalData.frameRate, 0), y1 = this.getValueAtTime((p1 + .001) / this.comp.globalData.frameRate, 0);
                        if (this.pv.length) {
                            for(n1 = (o1 = new Array(m1.length)).length, a1 = 0; a1 < n1; a1 += 1)o1[a1] = m1[a1] + (m1[a1] - y1[a1]) * (p1 - h1) / .001;
                            return o1;
                        }
                        return m1 + (m1 - y1) * (p1 - h1) / .001;
                    }
                }
                return this.getValueAtTime((i1 - ((p1 - h1) % i1 + p1)) / this.comp.globalData.frameRate, 0);
            }
            function r1(t1, e1) {
                if (!this.k) return this.pv;
                if (t1 = .5 * (t1 || .4), (e1 = Math.floor(e1 || 5)) <= 1) return this.pv;
                var r1, i1, s1 = this.comp.renderedFrame / this.comp.globalData.frameRate, a1 = s1 - t1, n1 = e1 > 1 ? (s1 + t1 - a1) / (e1 - 1) : 1, o1 = 0, h1 = 0;
                for(r1 = this.pv.length ? createTypedArray("float32", this.pv.length) : 0; o1 < e1;){
                    if (i1 = this.getValueAtTime(a1 + o1 * n1), this.pv.length) for(h1 = 0; h1 < this.pv.length; h1 += 1)r1[h1] += i1[h1];
                    else r1 += i1;
                    o1 += 1;
                }
                if (this.pv.length) for(h1 = 0; h1 < this.pv.length; h1 += 1)r1[h1] /= e1;
                else r1 /= e1;
                return r1;
            }
            function i1(t1) {
                this._transformCachingAtTime || (this._transformCachingAtTime = {
                    v: new Matrix
                });
                var e1 = this._transformCachingAtTime.v;
                if (e1.cloneFromProps(this.pre.props), this.appliedTransformations < 1) {
                    var r1 = this.a.getValueAtTime(t1);
                    e1.translate(-r1[0] * this.a.mult, -r1[1] * this.a.mult, r1[2] * this.a.mult);
                }
                if (this.appliedTransformations < 2) {
                    var i1 = this.s.getValueAtTime(t1);
                    e1.scale(i1[0] * this.s.mult, i1[1] * this.s.mult, i1[2] * this.s.mult);
                }
                if (this.sk && this.appliedTransformations < 3) {
                    var s1 = this.sk.getValueAtTime(t1), a1 = this.sa.getValueAtTime(t1);
                    e1.skewFromAxis(-s1 * this.sk.mult, a1 * this.sa.mult);
                }
                if (this.r && this.appliedTransformations < 4) {
                    var n1 = this.r.getValueAtTime(t1);
                    e1.rotate(-n1 * this.r.mult);
                } else if (!this.r && this.appliedTransformations < 4) {
                    var o1 = this.rz.getValueAtTime(t1), h1 = this.ry.getValueAtTime(t1), l1 = this.rx.getValueAtTime(t1), p1 = this.or.getValueAtTime(t1);
                    e1.rotateZ(-o1 * this.rz.mult).rotateY(h1 * this.ry.mult).rotateX(l1 * this.rx.mult).rotateZ(-p1[2] * this.or.mult).rotateY(p1[1] * this.or.mult).rotateX(p1[0] * this.or.mult);
                }
                if (this.data.p && this.data.p.s) {
                    var c1 = this.px.getValueAtTime(t1), f1 = this.py.getValueAtTime(t1);
                    if (this.data.p.z) {
                        var d1 = this.pz.getValueAtTime(t1);
                        e1.translate(c1 * this.px.mult, f1 * this.py.mult, -d1 * this.pz.mult);
                    } else e1.translate(c1 * this.px.mult, f1 * this.py.mult, 0);
                } else {
                    var u1 = this.p.getValueAtTime(t1);
                    e1.translate(u1[0] * this.p.mult, u1[1] * this.p.mult, -u1[2] * this.p.mult);
                }
                return e1;
            }
            function s1() {
                return this.v.clone(new Matrix);
            }
            var a1 = TransformPropertyFactory.getTransformProperty;
            TransformPropertyFactory.getTransformProperty = function(t1, e1, r1) {
                var n1 = a1(t1, e1, r1);
                return n1.dynamicProperties.length ? n1.getValueAtTime = i1.bind(n1) : n1.getValueAtTime = s1.bind(n1), n1.setGroupProperty = expressionHelpers.setGroupProperty, n1;
            };
            var n1 = PropertyFactory.getProp;
            PropertyFactory.getProp = function(i1, s1, a1, o1, h1) {
                var l1 = n1(i1, s1, a1, o1, h1);
                l1.kf ? l1.getValueAtTime = expressionHelpers.getValueAtTime.bind(l1) : l1.getValueAtTime = expressionHelpers.getStaticValueAtTime.bind(l1), l1.setGroupProperty = expressionHelpers.setGroupProperty, l1.loopOut = t1, l1.loopIn = e1, l1.smooth = r1, l1.getVelocityAtTime = expressionHelpers.getVelocityAtTime.bind(l1), l1.getSpeedAtTime = expressionHelpers.getSpeedAtTime.bind(l1), l1.numKeys = 1 === s1.a ? s1.k.length : 0, l1.propertyIndex = s1.ix;
                var p1 = 0;
                return 0 !== a1 && (p1 = createTypedArray("float32", 1 === s1.a ? s1.k[0].s.length : s1.k.length)), l1._cachingAtTime = {
                    lastFrame: initialDefaultFrame,
                    lastIndex: 0,
                    value: p1
                }, expressionHelpers.searchExpressions(i1, s1, l1), l1.k && h1.addDynamicProperty(l1), l1;
            };
            var o1 = ShapePropertyFactory.getConstructorFunction(), h1 = ShapePropertyFactory.getKeyframedConstructorFunction();
            function l1() {}
            l1.prototype = {
                vertices: function(t1, e1) {
                    this.k && this.getValue();
                    var r1, i1 = this.v;
                    void 0 !== e1 && (i1 = this.getValueAtTime(e1, 0));
                    var s1 = i1._length, a1 = i1[t1], n1 = i1.v, o1 = createSizedArray(s1);
                    for(r1 = 0; r1 < s1; r1 += 1)o1[r1] = "i" === t1 || "o" === t1 ? [
                        a1[r1][0] - n1[r1][0],
                        a1[r1][1] - n1[r1][1]
                    ] : [
                        a1[r1][0],
                        a1[r1][1]
                    ];
                    return o1;
                },
                points: function(t1) {
                    return this.vertices("v", t1);
                },
                inTangents: function(t1) {
                    return this.vertices("i", t1);
                },
                outTangents: function(t1) {
                    return this.vertices("o", t1);
                },
                isClosed: function() {
                    return this.v.c;
                },
                pointOnPath: function(t1, e1) {
                    var r1 = this.v;
                    void 0 !== e1 && (r1 = this.getValueAtTime(e1, 0)), this._segmentsLength || (this._segmentsLength = bez.getSegmentsLength(r1));
                    for(var i1, s1 = this._segmentsLength, a1 = s1.lengths, n1 = s1.totalLength * t1, o1 = 0, h1 = a1.length, l1 = 0; o1 < h1;){
                        if (l1 + a1[o1].addedLength > n1) {
                            var p1 = o1, c1 = r1.c && o1 === h1 - 1 ? 0 : o1 + 1, f1 = (n1 - l1) / a1[o1].addedLength;
                            i1 = bez.getPointInSegment(r1.v[p1], r1.v[c1], r1.o[p1], r1.i[c1], f1, a1[o1]);
                            break;
                        }
                        l1 += a1[o1].addedLength, o1 += 1;
                    }
                    return i1 || (i1 = r1.c ? [
                        r1.v[0][0],
                        r1.v[0][1]
                    ] : [
                        r1.v[r1._length - 1][0],
                        r1.v[r1._length - 1][1]
                    ]), i1;
                },
                vectorOnPath: function(t1, e1, r1) {
                    1 == t1 ? t1 = this.v.c : 0 == t1 && (t1 = .999);
                    var i1 = this.pointOnPath(t1, e1), s1 = this.pointOnPath(t1 + .001, e1), a1 = s1[0] - i1[0], n1 = s1[1] - i1[1], o1 = Math.sqrt(Math.pow(a1, 2) + Math.pow(n1, 2));
                    return 0 === o1 ? [
                        0,
                        0
                    ] : "tangent" === r1 ? [
                        a1 / o1,
                        n1 / o1
                    ] : [
                        -n1 / o1,
                        a1 / o1
                    ];
                },
                tangentOnPath: function(t1, e1) {
                    return this.vectorOnPath(t1, e1, "tangent");
                },
                normalOnPath: function(t1, e1) {
                    return this.vectorOnPath(t1, e1, "normal");
                },
                setGroupProperty: expressionHelpers.setGroupProperty,
                getValueAtTime: expressionHelpers.getStaticValueAtTime
            }, extendPrototype([
                l1
            ], o1), extendPrototype([
                l1
            ], h1), h1.prototype.getValueAtTime = function(t1) {
                return this._cachingAtTime || (this._cachingAtTime = {
                    shapeValue: shapePool.clone(this.pv),
                    lastIndex: 0,
                    lastTime: initialDefaultFrame
                }), t1 *= this.elem.globalData.frameRate, (t1 -= this.offsetTime) !== this._cachingAtTime.lastTime && (this._cachingAtTime.lastIndex = this._cachingAtTime.lastTime < t1 ? this._caching.lastIndex : 0, this._cachingAtTime.lastTime = t1, this.interpolateShape(t1, this._cachingAtTime.shapeValue, this._cachingAtTime)), this._cachingAtTime.shapeValue;
            }, h1.prototype.initiateExpression = ExpressionManager.initiateExpression;
            var p1 = ShapePropertyFactory.getShapeProp;
            ShapePropertyFactory.getShapeProp = function(t1, e1, r1, i1, s1) {
                var a1 = p1(t1, e1, r1, i1, s1);
                return a1.propertyIndex = e1.ix, a1.lock = !1, 3 === r1 ? expressionHelpers.searchExpressions(t1, e1.pt, a1) : 4 === r1 && expressionHelpers.searchExpressions(t1, e1.ks, a1), a1.k && t1.addDynamicProperty(a1), a1;
            };
        }
        function initialize$1() {
            addPropertyDecorator();
        }
        function addDecorator() {
            TextProperty.prototype.getExpressionValue = function(t1, e1) {
                var r1 = this.calculateExpression(e1);
                if (t1.t !== r1) {
                    var i1 = {};
                    return this.copyData(i1, t1), i1.t = r1.toString(), i1.__complete = !1, i1;
                }
                return t1;
            }, TextProperty.prototype.searchProperty = function() {
                var t1 = this.searchKeyframes(), e1 = this.searchExpressions();
                return this.kf = t1 || e1, this.kf;
            }, TextProperty.prototype.searchExpressions = function() {
                return this.data.d.x ? (this.calculateExpression = ExpressionManager.initiateExpression.bind(this)(this.elem, this.data.d, this), this.addEffect(this.getExpressionValue.bind(this)), !0) : null;
            };
        }
        function initialize() {
            addDecorator();
        }
        function SVGComposableEffect() {}
        function SVGTintFilter(t1, e1, r1, i1, s1) {
            this.filterManager = e1;
            var a1 = createNS("feColorMatrix");
            a1.setAttribute("type", "matrix"), a1.setAttribute("color-interpolation-filters", "linearRGB"), a1.setAttribute("values", "0.3333 0.3333 0.3333 0 0 0.3333 0.3333 0.3333 0 0 0.3333 0.3333 0.3333 0 0 0 0 0 1 0"), a1.setAttribute("result", i1 + "_tint_1"), t1.appendChild(a1), (a1 = createNS("feColorMatrix")).setAttribute("type", "matrix"), a1.setAttribute("color-interpolation-filters", "sRGB"), a1.setAttribute("values", "1 0 0 0 0 0 1 0 0 0 0 0 1 0 0 0 0 0 1 0"), a1.setAttribute("result", i1 + "_tint_2"), t1.appendChild(a1), this.matrixFilter = a1;
            var n1 = this.createMergeNode(i1, [
                s1,
                i1 + "_tint_1",
                i1 + "_tint_2"
            ]);
            t1.appendChild(n1);
        }
        function SVGFillFilter(t1, e1, r1, i1) {
            this.filterManager = e1;
            var s1 = createNS("feColorMatrix");
            s1.setAttribute("type", "matrix"), s1.setAttribute("color-interpolation-filters", "sRGB"), s1.setAttribute("values", "1 0 0 0 0 0 1 0 0 0 0 0 1 0 0 0 0 0 1 0"), s1.setAttribute("result", i1), t1.appendChild(s1), this.matrixFilter = s1;
        }
        function SVGStrokeEffect(t1, e1, r1) {
            this.initialized = !1, this.filterManager = e1, this.elem = r1, this.paths = [];
        }
        function SVGTritoneFilter(t1, e1, r1, i1) {
            this.filterManager = e1;
            var s1 = createNS("feColorMatrix");
            s1.setAttribute("type", "matrix"), s1.setAttribute("color-interpolation-filters", "linearRGB"), s1.setAttribute("values", "0.3333 0.3333 0.3333 0 0 0.3333 0.3333 0.3333 0 0 0.3333 0.3333 0.3333 0 0 0 0 0 1 0"), t1.appendChild(s1);
            var a1 = createNS("feComponentTransfer");
            a1.setAttribute("color-interpolation-filters", "sRGB"), a1.setAttribute("result", i1), this.matrixFilter = a1;
            var n1 = createNS("feFuncR");
            n1.setAttribute("type", "table"), a1.appendChild(n1), this.feFuncR = n1;
            var o1 = createNS("feFuncG");
            o1.setAttribute("type", "table"), a1.appendChild(o1), this.feFuncG = o1;
            var h1 = createNS("feFuncB");
            h1.setAttribute("type", "table"), a1.appendChild(h1), this.feFuncB = h1, t1.appendChild(a1);
        }
        function SVGProLevelsFilter(t1, e1, r1, i1) {
            this.filterManager = e1;
            var s1 = this.filterManager.effectElements, a1 = createNS("feComponentTransfer");
            (s1[10].p.k || 0 !== s1[10].p.v || s1[11].p.k || 1 !== s1[11].p.v || s1[12].p.k || 1 !== s1[12].p.v || s1[13].p.k || 0 !== s1[13].p.v || s1[14].p.k || 1 !== s1[14].p.v) && (this.feFuncR = this.createFeFunc("feFuncR", a1)), (s1[17].p.k || 0 !== s1[17].p.v || s1[18].p.k || 1 !== s1[18].p.v || s1[19].p.k || 1 !== s1[19].p.v || s1[20].p.k || 0 !== s1[20].p.v || s1[21].p.k || 1 !== s1[21].p.v) && (this.feFuncG = this.createFeFunc("feFuncG", a1)), (s1[24].p.k || 0 !== s1[24].p.v || s1[25].p.k || 1 !== s1[25].p.v || s1[26].p.k || 1 !== s1[26].p.v || s1[27].p.k || 0 !== s1[27].p.v || s1[28].p.k || 1 !== s1[28].p.v) && (this.feFuncB = this.createFeFunc("feFuncB", a1)), (s1[31].p.k || 0 !== s1[31].p.v || s1[32].p.k || 1 !== s1[32].p.v || s1[33].p.k || 1 !== s1[33].p.v || s1[34].p.k || 0 !== s1[34].p.v || s1[35].p.k || 1 !== s1[35].p.v) && (this.feFuncA = this.createFeFunc("feFuncA", a1)), (this.feFuncR || this.feFuncG || this.feFuncB || this.feFuncA) && (a1.setAttribute("color-interpolation-filters", "sRGB"), t1.appendChild(a1)), (s1[3].p.k || 0 !== s1[3].p.v || s1[4].p.k || 1 !== s1[4].p.v || s1[5].p.k || 1 !== s1[5].p.v || s1[6].p.k || 0 !== s1[6].p.v || s1[7].p.k || 1 !== s1[7].p.v) && ((a1 = createNS("feComponentTransfer")).setAttribute("color-interpolation-filters", "sRGB"), a1.setAttribute("result", i1), t1.appendChild(a1), this.feFuncRComposed = this.createFeFunc("feFuncR", a1), this.feFuncGComposed = this.createFeFunc("feFuncG", a1), this.feFuncBComposed = this.createFeFunc("feFuncB", a1));
        }
        function SVGDropShadowEffect(t1, e1, r1, i1, s1) {
            var a1 = e1.container.globalData.renderConfig.filterSize, n1 = e1.data.fs || a1;
            t1.setAttribute("x", n1.x || a1.x), t1.setAttribute("y", n1.y || a1.y), t1.setAttribute("width", n1.width || a1.width), t1.setAttribute("height", n1.height || a1.height), this.filterManager = e1;
            var o1 = createNS("feGaussianBlur");
            o1.setAttribute("in", "SourceAlpha"), o1.setAttribute("result", i1 + "_drop_shadow_1"), o1.setAttribute("stdDeviation", "0"), this.feGaussianBlur = o1, t1.appendChild(o1);
            var h1 = createNS("feOffset");
            h1.setAttribute("dx", "25"), h1.setAttribute("dy", "0"), h1.setAttribute("in", i1 + "_drop_shadow_1"), h1.setAttribute("result", i1 + "_drop_shadow_2"), this.feOffset = h1, t1.appendChild(h1);
            var l1 = createNS("feFlood");
            l1.setAttribute("flood-color", "#00ff00"), l1.setAttribute("flood-opacity", "1"), l1.setAttribute("result", i1 + "_drop_shadow_3"), this.feFlood = l1, t1.appendChild(l1);
            var p1 = createNS("feComposite");
            p1.setAttribute("in", i1 + "_drop_shadow_3"), p1.setAttribute("in2", i1 + "_drop_shadow_2"), p1.setAttribute("operator", "in"), p1.setAttribute("result", i1 + "_drop_shadow_4"), t1.appendChild(p1);
            var c1 = this.createMergeNode(i1, [
                i1 + "_drop_shadow_4",
                s1
            ]);
            t1.appendChild(c1);
        }
        SVGComposableEffect.prototype = {
            createMergeNode: function(t1, e1) {
                var r1, i1, s1 = createNS("feMerge");
                for(s1.setAttribute("result", t1), i1 = 0; i1 < e1.length; i1 += 1)(r1 = createNS("feMergeNode")).setAttribute("in", e1[i1]), s1.appendChild(r1), s1.appendChild(r1);
                return s1;
            }
        }, extendPrototype([
            SVGComposableEffect
        ], SVGTintFilter), SVGTintFilter.prototype.renderFrame = function(t1) {
            if (t1 || this.filterManager._mdf) {
                var e1 = this.filterManager.effectElements[0].p.v, r1 = this.filterManager.effectElements[1].p.v, i1 = this.filterManager.effectElements[2].p.v / 100;
                this.matrixFilter.setAttribute("values", r1[0] - e1[0] + " 0 0 0 " + e1[0] + " " + (r1[1] - e1[1]) + " 0 0 0 " + e1[1] + " " + (r1[2] - e1[2]) + " 0 0 0 " + e1[2] + " 0 0 0 " + i1 + " 0");
            }
        }, SVGFillFilter.prototype.renderFrame = function(t1) {
            if (t1 || this.filterManager._mdf) {
                var e1 = this.filterManager.effectElements[2].p.v, r1 = this.filterManager.effectElements[6].p.v;
                this.matrixFilter.setAttribute("values", "0 0 0 0 " + e1[0] + " 0 0 0 0 " + e1[1] + " 0 0 0 0 " + e1[2] + " 0 0 0 " + r1 + " 0");
            }
        }, SVGStrokeEffect.prototype.initialize = function() {
            var t1, e1, r1, i1, s1 = this.elem.layerElement.children || this.elem.layerElement.childNodes;
            for(1 === this.filterManager.effectElements[1].p.v ? (i1 = this.elem.maskManager.masksProperties.length, r1 = 0) : i1 = 1 + (r1 = this.filterManager.effectElements[0].p.v - 1), (e1 = createNS("g")).setAttribute("fill", "none"), e1.setAttribute("stroke-linecap", "round"), e1.setAttribute("stroke-dashoffset", 1); r1 < i1; r1 += 1)t1 = createNS("path"), e1.appendChild(t1), this.paths.push({
                p: t1,
                m: r1
            });
            if (3 === this.filterManager.effectElements[10].p.v) {
                var a1 = createNS("mask"), n1 = createElementID();
                a1.setAttribute("id", n1), a1.setAttribute("mask-type", "alpha"), a1.appendChild(e1), this.elem.globalData.defs.appendChild(a1);
                var o1 = createNS("g");
                for(o1.setAttribute("mask", "url(" + getLocationHref() + "#" + n1 + ")"); s1[0];)o1.appendChild(s1[0]);
                this.elem.layerElement.appendChild(o1), this.masker = a1, e1.setAttribute("stroke", "#fff");
            } else if (1 === this.filterManager.effectElements[10].p.v || 2 === this.filterManager.effectElements[10].p.v) {
                if (2 === this.filterManager.effectElements[10].p.v) for(s1 = this.elem.layerElement.children || this.elem.layerElement.childNodes; s1.length;)this.elem.layerElement.removeChild(s1[0]);
                this.elem.layerElement.appendChild(e1), this.elem.layerElement.removeAttribute("mask"), e1.setAttribute("stroke", "#fff");
            }
            this.initialized = !0, this.pathMasker = e1;
        }, SVGStrokeEffect.prototype.renderFrame = function(t1) {
            var e1;
            this.initialized || this.initialize();
            var r1, i1, s1 = this.paths.length;
            for(e1 = 0; e1 < s1; e1 += 1)if (-1 !== this.paths[e1].m && (r1 = this.elem.maskManager.viewData[this.paths[e1].m], i1 = this.paths[e1].p, (t1 || this.filterManager._mdf || r1.prop._mdf) && i1.setAttribute("d", r1.lastPath), t1 || this.filterManager.effectElements[9].p._mdf || this.filterManager.effectElements[4].p._mdf || this.filterManager.effectElements[7].p._mdf || this.filterManager.effectElements[8].p._mdf || r1.prop._mdf)) {
                var a1;
                if (0 !== this.filterManager.effectElements[7].p.v || 100 !== this.filterManager.effectElements[8].p.v) {
                    var n1 = .01 * Math.min(this.filterManager.effectElements[7].p.v, this.filterManager.effectElements[8].p.v), o1 = .01 * Math.max(this.filterManager.effectElements[7].p.v, this.filterManager.effectElements[8].p.v), h1 = i1.getTotalLength();
                    a1 = "0 0 0 " + h1 * n1 + " ";
                    var l1, p1 = h1 * (o1 - n1), c1 = 1 + 2 * this.filterManager.effectElements[4].p.v * this.filterManager.effectElements[9].p.v * .01, f1 = Math.floor(p1 / c1);
                    for(l1 = 0; l1 < f1; l1 += 1)a1 += "1 " + 2 * this.filterManager.effectElements[4].p.v * this.filterManager.effectElements[9].p.v * .01 + " ";
                    a1 += "0 " + 10 * h1 + " 0 0";
                } else a1 = "1 " + 2 * this.filterManager.effectElements[4].p.v * this.filterManager.effectElements[9].p.v * .01;
                i1.setAttribute("stroke-dasharray", a1);
            }
            if ((t1 || this.filterManager.effectElements[4].p._mdf) && this.pathMasker.setAttribute("stroke-width", 2 * this.filterManager.effectElements[4].p.v), (t1 || this.filterManager.effectElements[6].p._mdf) && this.pathMasker.setAttribute("opacity", this.filterManager.effectElements[6].p.v), (1 === this.filterManager.effectElements[10].p.v || 2 === this.filterManager.effectElements[10].p.v) && (t1 || this.filterManager.effectElements[3].p._mdf)) {
                var d1 = this.filterManager.effectElements[3].p.v;
                this.pathMasker.setAttribute("stroke", "rgb(" + bmFloor(255 * d1[0]) + "," + bmFloor(255 * d1[1]) + "," + bmFloor(255 * d1[2]) + ")");
            }
        }, SVGTritoneFilter.prototype.renderFrame = function(t1) {
            if (t1 || this.filterManager._mdf) {
                var e1 = this.filterManager.effectElements[0].p.v, r1 = this.filterManager.effectElements[1].p.v, i1 = this.filterManager.effectElements[2].p.v, s1 = i1[0] + " " + r1[0] + " " + e1[0], a1 = i1[1] + " " + r1[1] + " " + e1[1], n1 = i1[2] + " " + r1[2] + " " + e1[2];
                this.feFuncR.setAttribute("tableValues", s1), this.feFuncG.setAttribute("tableValues", a1), this.feFuncB.setAttribute("tableValues", n1);
            }
        }, SVGProLevelsFilter.prototype.createFeFunc = function(t1, e1) {
            var r1 = createNS(t1);
            return r1.setAttribute("type", "table"), e1.appendChild(r1), r1;
        }, SVGProLevelsFilter.prototype.getTableValue = function(t1, e1, r1, i1, s1) {
            for(var a1, n1, o1 = 0, h1 = Math.min(t1, e1), l1 = Math.max(t1, e1), p1 = Array.call(null, {
                length: 256
            }), c1 = 0, f1 = s1 - i1, d1 = e1 - t1; o1 <= 256;)n1 = (a1 = o1 / 256) <= h1 ? d1 < 0 ? s1 : i1 : a1 >= l1 ? d1 < 0 ? i1 : s1 : i1 + f1 * Math.pow((a1 - t1) / d1, 1 / r1), p1[c1] = n1, c1 += 1, o1 += 256 / 255;
            return p1.join(" ");
        }, SVGProLevelsFilter.prototype.renderFrame = function(t1) {
            if (t1 || this.filterManager._mdf) {
                var e1, r1 = this.filterManager.effectElements;
                this.feFuncRComposed && (t1 || r1[3].p._mdf || r1[4].p._mdf || r1[5].p._mdf || r1[6].p._mdf || r1[7].p._mdf) && (e1 = this.getTableValue(r1[3].p.v, r1[4].p.v, r1[5].p.v, r1[6].p.v, r1[7].p.v), this.feFuncRComposed.setAttribute("tableValues", e1), this.feFuncGComposed.setAttribute("tableValues", e1), this.feFuncBComposed.setAttribute("tableValues", e1)), this.feFuncR && (t1 || r1[10].p._mdf || r1[11].p._mdf || r1[12].p._mdf || r1[13].p._mdf || r1[14].p._mdf) && (e1 = this.getTableValue(r1[10].p.v, r1[11].p.v, r1[12].p.v, r1[13].p.v, r1[14].p.v), this.feFuncR.setAttribute("tableValues", e1)), this.feFuncG && (t1 || r1[17].p._mdf || r1[18].p._mdf || r1[19].p._mdf || r1[20].p._mdf || r1[21].p._mdf) && (e1 = this.getTableValue(r1[17].p.v, r1[18].p.v, r1[19].p.v, r1[20].p.v, r1[21].p.v), this.feFuncG.setAttribute("tableValues", e1)), this.feFuncB && (t1 || r1[24].p._mdf || r1[25].p._mdf || r1[26].p._mdf || r1[27].p._mdf || r1[28].p._mdf) && (e1 = this.getTableValue(r1[24].p.v, r1[25].p.v, r1[26].p.v, r1[27].p.v, r1[28].p.v), this.feFuncB.setAttribute("tableValues", e1)), this.feFuncA && (t1 || r1[31].p._mdf || r1[32].p._mdf || r1[33].p._mdf || r1[34].p._mdf || r1[35].p._mdf) && (e1 = this.getTableValue(r1[31].p.v, r1[32].p.v, r1[33].p.v, r1[34].p.v, r1[35].p.v), this.feFuncA.setAttribute("tableValues", e1));
            }
        }, extendPrototype([
            SVGComposableEffect
        ], SVGDropShadowEffect), SVGDropShadowEffect.prototype.renderFrame = function(t1) {
            if (t1 || this.filterManager._mdf) {
                if ((t1 || this.filterManager.effectElements[4].p._mdf) && this.feGaussianBlur.setAttribute("stdDeviation", this.filterManager.effectElements[4].p.v / 4), t1 || this.filterManager.effectElements[0].p._mdf) {
                    var e1 = this.filterManager.effectElements[0].p.v;
                    this.feFlood.setAttribute("flood-color", rgbToHex(Math.round(255 * e1[0]), Math.round(255 * e1[1]), Math.round(255 * e1[2])));
                }
                if ((t1 || this.filterManager.effectElements[1].p._mdf) && this.feFlood.setAttribute("flood-opacity", this.filterManager.effectElements[1].p.v / 255), t1 || this.filterManager.effectElements[2].p._mdf || this.filterManager.effectElements[3].p._mdf) {
                    var r1 = this.filterManager.effectElements[3].p.v, i1 = (this.filterManager.effectElements[2].p.v - 90) * degToRads, s1 = r1 * Math.cos(i1), a1 = r1 * Math.sin(i1);
                    this.feOffset.setAttribute("dx", s1), this.feOffset.setAttribute("dy", a1);
                }
            }
        };
        var _svgMatteSymbols = [];
        function SVGMatte3Effect(t1, e1, r1) {
            this.initialized = !1, this.filterManager = e1, this.filterElem = t1, this.elem = r1, r1.matteElement = createNS("g"), r1.matteElement.appendChild(r1.layerElement), r1.matteElement.appendChild(r1.transformedElement), r1.baseElement = r1.matteElement;
        }
        function SVGGaussianBlurEffect(t1, e1, r1, i1) {
            t1.setAttribute("x", "-100%"), t1.setAttribute("y", "-100%"), t1.setAttribute("width", "300%"), t1.setAttribute("height", "300%"), this.filterManager = e1;
            var s1 = createNS("feGaussianBlur");
            s1.setAttribute("result", i1), t1.appendChild(s1), this.feGaussianBlur = s1;
        }
        return SVGMatte3Effect.prototype.findSymbol = function(t1) {
            for(var e1 = 0, r1 = _svgMatteSymbols.length; e1 < r1;){
                if (_svgMatteSymbols[e1] === t1) return _svgMatteSymbols[e1];
                e1 += 1;
            }
            return null;
        }, SVGMatte3Effect.prototype.replaceInParent = function(t1, e1) {
            var r1 = t1.layerElement.parentNode;
            if (r1) {
                for(var i1, s1 = r1.children, a1 = 0, n1 = s1.length; a1 < n1 && s1[a1] !== t1.layerElement;)a1 += 1;
                a1 <= n1 - 2 && (i1 = s1[a1 + 1]);
                var o1 = createNS("use");
                o1.setAttribute("href", "#" + e1), i1 ? r1.insertBefore(o1, i1) : r1.appendChild(o1);
            }
        }, SVGMatte3Effect.prototype.setElementAsMask = function(t1, e1) {
            if (!this.findSymbol(e1)) {
                var r1 = createElementID(), i1 = createNS("mask");
                i1.setAttribute("id", e1.layerId), i1.setAttribute("mask-type", "alpha"), _svgMatteSymbols.push(e1);
                var s1 = t1.globalData.defs;
                s1.appendChild(i1);
                var a1 = createNS("symbol");
                a1.setAttribute("id", r1), this.replaceInParent(e1, r1), a1.appendChild(e1.layerElement), s1.appendChild(a1);
                var n1 = createNS("use");
                n1.setAttribute("href", "#" + r1), i1.appendChild(n1), e1.data.hd = !1, e1.show();
            }
            t1.setMatte(e1.layerId);
        }, SVGMatte3Effect.prototype.initialize = function() {
            for(var t1 = this.filterManager.effectElements[0].p.v, e1 = this.elem.comp.elements, r1 = 0, i1 = e1.length; r1 < i1;)e1[r1] && e1[r1].data.ind === t1 && this.setElementAsMask(this.elem, e1[r1]), r1 += 1;
            this.initialized = !0;
        }, SVGMatte3Effect.prototype.renderFrame = function() {
            this.initialized || this.initialize();
        }, SVGGaussianBlurEffect.prototype.renderFrame = function(t1) {
            if (t1 || this.filterManager._mdf) {
                var e1 = .3 * this.filterManager.effectElements[0].p.v, r1 = this.filterManager.effectElements[1].p.v, i1 = 3 == r1 ? 0 : e1, s1 = 2 == r1 ? 0 : e1;
                this.feGaussianBlur.setAttribute("stdDeviation", i1 + " " + s1);
                var a1 = 1 == this.filterManager.effectElements[2].p.v ? "wrap" : "duplicate";
                this.feGaussianBlur.setAttribute("edgeMode", a1);
            }
        }, registerRenderer("canvas", CanvasRenderer), registerRenderer("html", HybridRenderer), registerRenderer("svg", SVGRenderer), ShapeModifiers.registerModifier("tm", TrimModifier), ShapeModifiers.registerModifier("pb", PuckerAndBloatModifier), ShapeModifiers.registerModifier("rp", RepeaterModifier), ShapeModifiers.registerModifier("rd", RoundCornersModifier), ShapeModifiers.registerModifier("zz", ZigZagModifier), ShapeModifiers.registerModifier("op", OffsetPathModifier), setExpressionsPlugin(Expressions), setExpressionInterfaces(getInterface), initialize$1(), initialize(), registerEffect(20, SVGTintFilter, !0), registerEffect(21, SVGFillFilter, !0), registerEffect(22, SVGStrokeEffect, !1), registerEffect(23, SVGTritoneFilter, !0), registerEffect(24, SVGProLevelsFilter, !0), registerEffect(25, SVGDropShadowEffect, !0), registerEffect(28, SVGMatte3Effect, !1), registerEffect(29, SVGGaussianBlurEffect, !0), lottie;
    }, module.exports = factory());
})(lottie$1, lottie$1.exports);
var lottie = lottie$1.exports, _templateObject$1, styles = r$3(_templateObject$1 || (_templateObject$1 = _taggedTemplateLiteral([
    "\n  * {\n    box-sizing: border-box;\n  }\n\n  :host {\n    --lottie-player-toolbar-height: 35px;\n    --lottie-player-toolbar-background-color: transparent;\n    --lottie-player-toolbar-icon-color: #999;\n    --lottie-player-toolbar-icon-hover-color: #222;\n    --lottie-player-toolbar-icon-active-color: #555;\n    --lottie-player-seeker-track-color: #ccc;\n    --lottie-player-seeker-thumb-color: rgba(0, 107, 120, 0.8);\n    --lottie-player-seeker-display: block;\n\n    display: block;\n    width: 100%;\n    height: 100%;\n  }\n\n  .main {\n    display: flex;\n    flex-direction: column;\n    height: 100%;\n    width: 100%;\n  }\n\n  .animation {\n    width: 100%;\n    height: 100%;\n    display: flex;\n  }\n  .animation.controls {\n    height: calc(100% - 35px);\n  }\n\n  .toolbar {\n    display: flex;\n    align-items: center;\n    justify-items: center;\n    background-color: var(--lottie-player-toolbar-background-color);\n    margin: 0 5px;\n    height: 35px;\n  }\n\n  .toolbar button {\n    cursor: pointer;\n    fill: var(--lottie-player-toolbar-icon-color);\n    display: flex;\n    background: none;\n    border: 0;\n    padding: 0;\n    outline: none;\n    height: 100%;\n  }\n\n  .toolbar button:hover {\n    fill: var(--lottie-player-toolbar-icon-hover-color);\n  }\n\n  .toolbar button.active {\n    fill: var(--lottie-player-toolbar-icon-active-color);\n  }\n\n  .toolbar button.active:hover {\n    fill: var(--lottie-player-toolbar-icon-hover-color);\n  }\n\n  .toolbar button:focus {\n    outline: 1px dotted var(--lottie-player-toolbar-icon-active-color);\n  }\n\n  .toolbar button svg {\n  }\n\n  .toolbar button.disabled svg {\n    display: none;\n  }\n\n  .seeker {\n    -webkit-appearance: none;\n    width: 95%;\n    outline: none;\n    background-color: var(--lottie-player-toolbar-background-color);\n    display: var(--lottie-player-seeker-display);\n  }\n\n  .seeker::-webkit-slider-runnable-track {\n    width: 100%;\n    height: 5px;\n    cursor: pointer;\n    background: var(--lottie-player-seeker-track-color);\n    border-radius: 3px;\n  }\n  .seeker::-webkit-slider-thumb {\n    height: 15px;\n    width: 15px;\n    border-radius: 50%;\n    background: var(--lottie-player-seeker-thumb-color);\n    cursor: pointer;\n    -webkit-appearance: none;\n    margin-top: -5px;\n  }\n  .seeker:focus::-webkit-slider-runnable-track {\n    background: #999;\n  }\n  .seeker::-moz-range-track {\n    width: 100%;\n    height: 5px;\n    cursor: pointer;\n    background: var(--lottie-player-seeker-track-color);\n    border-radius: 3px;\n  }\n  .seeker::-moz-range-thumb {\n    height: 15px;\n    width: 15px;\n    border-radius: 50%;\n    background: var(--lottie-player-seeker-thumb-color);\n    cursor: pointer;\n  }\n  .seeker::-ms-track {\n    width: 100%;\n    height: 5px;\n    cursor: pointer;\n    background: transparent;\n    border-color: transparent;\n    color: transparent;\n  }\n  .seeker::-ms-fill-lower {\n    background: var(--lottie-player-seeker-track-color);\n    border-radius: 3px;\n  }\n  .seeker::-ms-fill-upper {\n    background: var(--lottie-player-seeker-track-color);\n    border-radius: 3px;\n  }\n  .seeker::-ms-thumb {\n    border: 0;\n    height: 15px;\n    width: 15px;\n    border-radius: 50%;\n    background: var(--lottie-player-seeker-thumb-color);\n    cursor: pointer;\n  }\n  .seeker:focus::-ms-fill-lower {\n    background: var(--lottie-player-seeker-track-color);\n  }\n  .seeker:focus::-ms-fill-upper {\n    background: var(--lottie-player-seeker-track-color);\n  }\n\n  .error {\n    display: flex;\n    justify-content: center;\n    height: 100%;\n    align-items: center;\n  }\n"
]))), LOTTIE_PLAYER_VERSION = "2.0.2", LOTTIE_WEB_VERSION = "^5.10.0", _templateObject, _templateObject2, _templateObject3, _templateObject4, _templateObject5, PlayerState, PlayMode, PlayerEvents;
function parseSrc(t1) {
    if ("object" == typeof t1) return t1;
    try {
        return JSON.parse(t1);
    } catch (e1) {
        return new URL(t1, window.location.href).toString();
    }
}
function isLottie(t1) {
    return [
        "v",
        "ip",
        "op",
        "layers",
        "fr",
        "w",
        "h"
    ].every((e1)=>Object.prototype.hasOwnProperty.call(t1, e1));
}
function fromURL(t1) {
    return _fromURL.apply(this, arguments);
}
function _fromURL() {
    return (_fromURL = _asyncToGenerator(function*(t1) {
        if ("string" != typeof t1) throw new Error("The url value must be a string");
        var e1;
        try {
            var r1 = new URL(t1), i1 = yield fetch(r1.toString());
            e1 = yield i1.json();
        } catch (t1) {
            throw new Error("An error occurred while trying to load the Lottie file from URL");
        }
        return e1;
    })).apply(this, arguments);
}
!function(t1) {
    t1.Destroyed = "destroyed", t1.Error = "error", t1.Frozen = "frozen", t1.Loading = "loading", t1.Paused = "paused", t1.Playing = "playing", t1.Stopped = "stopped";
}(PlayerState || (PlayerState = {})), function(t1) {
    t1.Bounce = "bounce", t1.Normal = "normal";
}(PlayMode || (PlayMode = {})), function(t1) {
    t1.Complete = "complete", t1.Destroyed = "destroyed", t1.Error = "error", t1.Frame = "frame", t1.Freeze = "freeze", t1.Load = "load", t1.Loop = "loop", t1.Pause = "pause", t1.Play = "play", t1.Ready = "ready", t1.Rendered = "rendered", t1.Stop = "stop";
}(PlayerEvents || (PlayerEvents = {}));
var LottiePlayer = class extends s {
    constructor(){
        super(...arguments), this.autoplay = !1, this.background = "transparent", this.controls = !1, this.currentState = PlayerState.Loading, this.description = "Lottie animation", this.direction = 1, this.disableCheck = !1, this.disableShadowDOM = !1, this.hover = !1, this.intermission = 1, this.loop = !1, this.mode = PlayMode.Normal, this.preserveAspectRatio = "xMidYMid meet", this.renderer = "svg", this.speed = 1, this._io = void 0, this._counter = 1;
    }
    load(t1) {
        var e1 = this;
        return _asyncToGenerator(function*() {
            var r1 = {
                container: e1.container,
                loop: !1,
                autoplay: !1,
                renderer: e1.renderer,
                rendererSettings: Object.assign({
                    preserveAspectRatio: e1.preserveAspectRatio,
                    clearCanvas: !1,
                    progressiveLoad: !0,
                    hideOnTransparent: !0
                }, e1.viewBoxSize && {
                    viewBoxSize: e1.viewBoxSize
                })
            };
            try {
                var i1 = parseSrc(t1), s1 = {}, a1 = "string" == typeof i1 ? "path" : "animationData";
                e1._lottie && e1._lottie.destroy(), e1.webworkers && lottie$1.exports.useWebWorker(!0), e1._lottie = lottie$1.exports.loadAnimation(Object.assign(Object.assign({}, r1), {
                    [a1]: i1
                })), e1._attachEventListeners(), e1.disableCheck || ("path" === a1 ? (s1 = yield fromURL(i1), a1 = "animationData") : s1 = i1, isLottie(s1) || (e1.currentState = PlayerState.Error, e1.dispatchEvent(new CustomEvent(PlayerEvents.Error))));
            } catch (t1) {
                e1.currentState = PlayerState.Error, e1.dispatchEvent(new CustomEvent(PlayerEvents.Error));
            }
        })();
    }
    getLottie() {
        return this._lottie;
    }
    getVersions() {
        return {
            lottieWebVersion: LOTTIE_WEB_VERSION,
            lottiePlayerVersion: LOTTIE_PLAYER_VERSION
        };
    }
    play() {
        this._lottie && (this._lottie.play(), this.currentState = PlayerState.Playing, this.dispatchEvent(new CustomEvent(PlayerEvents.Play)));
    }
    pause() {
        this._lottie && (this._lottie.pause(), this.currentState = PlayerState.Paused, this.dispatchEvent(new CustomEvent(PlayerEvents.Pause)));
    }
    stop() {
        this._lottie && (this._counter = 1, this._lottie.stop(), this.currentState = PlayerState.Stopped, this.dispatchEvent(new CustomEvent(PlayerEvents.Stop)));
    }
    destroy() {
        this._lottie && (this._lottie.destroy(), this._lottie = null, this.currentState = PlayerState.Destroyed, this.dispatchEvent(new CustomEvent(PlayerEvents.Destroyed)), this.remove());
    }
    seek(t1) {
        if (this._lottie) {
            var e1 = /^(\d+)(%?)$/.exec(t1.toString());
            if (e1) {
                var r1 = "%" === e1[2] ? this._lottie.totalFrames * Number(e1[1]) / 100 : Number(e1[1]);
                this.seeker = r1, this.currentState === PlayerState.Playing ? this._lottie.goToAndPlay(r1, !0) : (this._lottie.goToAndStop(r1, !0), this._lottie.pause());
            }
        }
    }
    snapshot() {
        var t1 = !(arguments.length > 0 && void 0 !== arguments[0]) || arguments[0];
        if (this.shadowRoot) {
            var e1 = this.shadowRoot.querySelector(".animation svg"), r1 = (new XMLSerializer).serializeToString(e1);
            if (t1) {
                var i1 = document.createElement("a");
                i1.href = "data:image/svg+xml;charset=utf-8,".concat(encodeURIComponent(r1)), i1.download = "download_".concat(this.seeker, ".svg"), document.body.appendChild(i1), i1.click(), document.body.removeChild(i1);
            }
            return r1;
        }
    }
    setSpeed() {
        var t1 = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : 1;
        this._lottie && this._lottie.setSpeed(t1);
    }
    setDirection(t1) {
        this._lottie && this._lottie.setDirection(t1);
    }
    setLooping(t1) {
        this._lottie && (this.loop = t1, this._lottie.loop = t1);
    }
    togglePlay() {
        return this.currentState === PlayerState.Playing ? this.pause() : this.play();
    }
    toggleLooping() {
        this.setLooping(!this.loop);
    }
    resize() {
        this._lottie && this._lottie.resize();
    }
    static get styles() {
        return styles;
    }
    disconnectedCallback() {
        this.isConnected || (this._io && (this._io.disconnect(), this._io = void 0), document.removeEventListener("visibilitychange", ()=>this._onVisibilityChange()), this.destroy());
    }
    render() {
        var t1 = this.controls ? "main controls" : "main", e1 = this.controls ? "animation controls" : "animation";
        return $(_templateObject || (_templateObject = _taggedTemplateLiteral([
            ' <div\n      id="animation-container"\n      class=',
            '\n      lang="en"\n      aria-label=',
            '\n      role="img"\n    >\n      <div\n        id="animation"\n        class=',
            '\n        style="background:',
            ';"\n      >\n        ',
            "\n      </div>\n      ",
            "\n    </div>"
        ])), t1, this.description, e1, this.background, this.currentState === PlayerState.Error ? $(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral([
            '<div class="error">\u26A0\uFE0F</div>'
        ]))) : void 0, this.controls && !this.disableShadowDOM ? this.renderControls() : void 0);
    }
    createRenderRoot() {
        return this.disableShadowDOM && (this.style.display = "block"), this.disableShadowDOM ? this : super.createRenderRoot();
    }
    firstUpdated() {
        "IntersectionObserver" in window && (this._io = new IntersectionObserver((t1)=>{
            t1[0].isIntersecting ? this.currentState === PlayerState.Frozen && this.play() : this.currentState === PlayerState.Playing && this.freeze();
        }), this._io.observe(this.container)), void 0 !== document.hidden && document.addEventListener("visibilitychange", ()=>this._onVisibilityChange()), this.src && this.load(this.src), this.dispatchEvent(new CustomEvent(PlayerEvents.Rendered));
    }
    renderControls() {
        var t1 = this.currentState === PlayerState.Playing, e1 = this.currentState === PlayerState.Paused, r1 = this.currentState === PlayerState.Stopped;
        return $(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral([
            '\n      <div\n        id="lottie-controls"\n        aria-label="lottie-animation-controls"\n        class="toolbar"\n      >\n        <button\n          id="lottie-play-button"\n          @click=',
            "\n          class=",
            '\n          style="align-items:center;"\n          tabindex="0"\n          aria-label="play-pause"\n        >\n          ',
            '\n        </button>\n        <button\n          id="lottie-stop-button"\n          @click=',
            "\n          class=",
            '\n          style="align-items:center;"\n          tabindex="0"\n          aria-label="stop"\n        >\n          <svg width="24" height="24" aria-hidden="true" focusable="false">\n            <path d="M6 6h12v12H6V6z" />\n          </svg>\n        </button>\n        <input\n          id="lottie-seeker-input"\n          class="seeker"\n          type="range"\n          min="0"\n          step="1"\n          max="100"\n          .value=',
            "\n          @input=",
            "\n          @mousedown=",
            "\n          @mouseup=",
            '\n          aria-valuemin="1"\n          aria-valuemax="100"\n          role="slider"\n          aria-valuenow=',
            '\n          tabindex="0"\n          aria-label="lottie-seek-input"\n        />\n        <button\n          id="lottie-loop-toggle"\n          @click=',
            "\n          class=",
            '\n          style="align-items:center;"\n          tabindex="0"\n          aria-label="loop-toggle"\n        >\n          <svg width="24" height="24" aria-hidden="true" focusable="false">\n            <path\n              d="M17.016 17.016v-4.031h1.969v6h-12v3l-3.984-3.984 3.984-3.984v3h10.031zM6.984 6.984v4.031H5.015v-6h12v-3l3.984 3.984-3.984 3.984v-3H6.984z"\n            />\n          </svg>\n        </button>\n      </div>\n    '
        ])), this.togglePlay, t1 || e1 ? "active" : "", $(t1 ? _templateObject4 || (_templateObject4 = _taggedTemplateLiteral([
            '<svg\n                width="24"\n                height="24"\n                aria-hidden="true"\n                focusable="false"\n              >\n                <path\n                  d="M14.016 5.016H18v13.969h-3.984V5.016zM6 18.984V5.015h3.984v13.969H6z"\n                />\n              </svg>'
        ])) : _templateObject5 || (_templateObject5 = _taggedTemplateLiteral([
            '<svg\n                width="24"\n                height="24"\n                aria-hidden="true"\n                focusable="false"\n              >\n                <path d="M8.016 5.016L18.985 12 8.016 18.984V5.015z" />\n              </svg>'
        ]))), this.stop, r1 ? "active" : "", this.seeker, this._handleSeekChange, ()=>{
            this._prevState = this.currentState, this.freeze();
        }, ()=>{
            this._prevState === PlayerState.Playing && this.play();
        }, this.seeker, this.toggleLooping, this.loop ? "active" : "");
    }
    _onVisibilityChange() {
        !0 === document.hidden && this.currentState === PlayerState.Playing ? this.freeze() : this.currentState === PlayerState.Frozen && this.play();
    }
    _handleSeekChange(t1) {
        if (this._lottie && !isNaN(t1.target.value)) {
            var e1 = t1.target.value / 100 * this._lottie.totalFrames;
            this.seek(e1);
        }
    }
    _attachEventListeners() {
        this._lottie.addEventListener("enterFrame", ()=>{
            this.seeker = this._lottie.currentFrame / this._lottie.totalFrames * 100, this.dispatchEvent(new CustomEvent(PlayerEvents.Frame, {
                detail: {
                    frame: this._lottie.currentFrame,
                    seeker: this.seeker
                }
            }));
        }), this._lottie.addEventListener("complete", ()=>{
            if (this.currentState === PlayerState.Playing) {
                if (!this.loop || this.count && this._counter >= this.count) {
                    if (this.dispatchEvent(new CustomEvent(PlayerEvents.Complete)), this.mode !== PlayMode.Bounce) return;
                    if (0 === this._lottie.currentFrame) return;
                }
                this.mode === PlayMode.Bounce ? (this.count && (this._counter += .5), setTimeout(()=>{
                    this.dispatchEvent(new CustomEvent(PlayerEvents.Loop)), this.currentState === PlayerState.Playing && (this._lottie.setDirection(-1 * this._lottie.playDirection), this._lottie.play());
                }, this.intermission)) : (this.count && (this._counter += 1), window.setTimeout(()=>{
                    this.dispatchEvent(new CustomEvent(PlayerEvents.Loop)), this.currentState === PlayerState.Playing && (-1 === this.direction ? (this.seek("99%"), this.play()) : (this._lottie.stop(), this._lottie.play()));
                }, this.intermission));
            } else this.dispatchEvent(new CustomEvent(PlayerEvents.Complete));
        }), this._lottie.addEventListener("DOMLoaded", ()=>{
            this.setSpeed(this.speed), this.setDirection(this.direction), this.autoplay && (-1 === this.direction && this.seek("100%"), this.play()), this.dispatchEvent(new CustomEvent(PlayerEvents.Ready));
        }), this._lottie.addEventListener("data_ready", ()=>{
            this.dispatchEvent(new CustomEvent(PlayerEvents.Load));
        }), this._lottie.addEventListener("data_failed", ()=>{
            this.currentState = PlayerState.Error, this.dispatchEvent(new CustomEvent(PlayerEvents.Error));
        }), this.container.addEventListener("mouseenter", ()=>{
            this.hover && this.currentState !== PlayerState.Playing && this.play();
        }), this.container.addEventListener("mouseleave", ()=>{
            this.hover && this.currentState === PlayerState.Playing && this.stop();
        });
    }
    freeze() {
        this._lottie && (this._lottie.pause(), this.currentState = PlayerState.Frozen, this.dispatchEvent(new CustomEvent(PlayerEvents.Freeze)));
    }
};
__decorate([
    e$5({
        type: Boolean
    })
], LottiePlayer.prototype, "autoplay", void 0), __decorate([
    e$5({
        type: String,
        reflect: !0
    })
], LottiePlayer.prototype, "background", void 0), __decorate([
    e$5({
        type: Boolean
    })
], LottiePlayer.prototype, "controls", void 0), __decorate([
    e$5({
        type: Number
    })
], LottiePlayer.prototype, "count", void 0), __decorate([
    e$5({
        type: String
    })
], LottiePlayer.prototype, "currentState", void 0), __decorate([
    e$5({
        type: String
    })
], LottiePlayer.prototype, "description", void 0), __decorate([
    e$5({
        type: Number
    })
], LottiePlayer.prototype, "direction", void 0), __decorate([
    e$5({
        type: Boolean
    })
], LottiePlayer.prototype, "disableCheck", void 0), __decorate([
    e$5({
        type: Boolean
    })
], LottiePlayer.prototype, "disableShadowDOM", void 0), __decorate([
    e$5({
        type: Boolean
    })
], LottiePlayer.prototype, "hover", void 0), __decorate([
    e$5()
], LottiePlayer.prototype, "intermission", void 0), __decorate([
    e$5({
        type: Boolean,
        reflect: !0
    })
], LottiePlayer.prototype, "loop", void 0), __decorate([
    e$5()
], LottiePlayer.prototype, "mode", void 0), __decorate([
    e$5({
        type: String
    })
], LottiePlayer.prototype, "preserveAspectRatio", void 0), __decorate([
    e$5({
        type: String
    })
], LottiePlayer.prototype, "renderer", void 0), __decorate([
    e$5({
        type: String
    })
], LottiePlayer.prototype, "viewBoxSize", void 0), __decorate([
    e$5()
], LottiePlayer.prototype, "seeker", void 0), __decorate([
    e$5({
        type: Number
    })
], LottiePlayer.prototype, "speed", void 0), __decorate([
    e$5({
        type: String
    })
], LottiePlayer.prototype, "src", void 0), __decorate([
    e$5({
        type: Boolean
    })
], LottiePlayer.prototype, "webworkers", void 0), __decorate([
    i(".animation")
], LottiePlayer.prototype, "container", void 0), LottiePlayer = __decorate([
    n$1("lottie-player")
], LottiePlayer);

},{"@parcel/transformer-js/src/esmodule-helpers.js":"90RNB"}]},["kzDha","3jnqg"], "3jnqg", "parcelRequireffdf")

